var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/lib/virtual.ts
var GenericSubclassApi = class {
  static {
    __name(this, "GenericSubclassApi");
  }
  constructor() {
    this.initialized = false;
    this.source = void 0;
  }
  initialize(apiInstances, source) {
    this.initialized = true;
    this.axiosMainInstance = apiInstances.mainInstance;
    this.axiosLockInstance = apiInstances.lockInstance;
    this.axiosInsuranceInstance = apiInstances.insuranceInstance;
    this.source = source;
  }
};
var virtual_default = GenericSubclassApi;

// src/slSdkTypes.ts
var InitializationError = class _InitializationError extends Error {
  static {
    __name(this, "InitializationError");
  }
  constructor() {
    super("API NOT INITIALIZED");
    Object.setPrototypeOf(this, _InitializationError.prototype);
  }
};
var initError = new InitializationError();
var formatQueryParams = /* @__PURE__ */ __name((filter, defaultFilter) => {
  if (filter) return `?${filter}`;
  if (defaultFilter) return `?${defaultFilter}`;
  return "";
}, "formatQueryParams");
var formatQueryParamsWithBase = /* @__PURE__ */ __name((baseParams, filter, defaultFilter) => {
  const base = `?${baseParams}`;
  if (filter) return `${base}&${filter}`;
  if (defaultFilter) return `${base}&${defaultFilter}`;
  return base;
}, "formatQueryParamsWithBase");

// src/insurance-api/group-commissions.ts
var CommissionInvoiceStatus = /* @__PURE__ */ ((CommissionInvoiceStatus2) => {
  CommissionInvoiceStatus2["CREATED"] = "CREATED";
  CommissionInvoiceStatus2["SENT"] = "SENT";
  CommissionInvoiceStatus2["PAID"] = "PAID";
  CommissionInvoiceStatus2["CANCEL"] = "CANCEL";
  return CommissionInvoiceStatus2;
})(CommissionInvoiceStatus || {});
var CommissionStatus = /* @__PURE__ */ ((CommissionStatus2) => {
  CommissionStatus2["CREATED"] = "CREATED";
  CommissionStatus2["SENT"] = "SENT";
  CommissionStatus2["PAID"] = "PAID";
  CommissionStatus2["COMMISSIONABLE"] = "COMMISSIONABLE";
  CommissionStatus2["NOT_COMMISSIONABLE"] = "NOT_COMMISSIONABLE";
  CommissionStatus2["CANCELLED"] = "CANCELLED";
  return CommissionStatus2;
})(CommissionStatus || {});
var CommissionInvoiceFrequency = /* @__PURE__ */ ((CommissionInvoiceFrequency2) => {
  CommissionInvoiceFrequency2["MONTHLY"] = "MONTHLY";
  CommissionInvoiceFrequency2["QUARTERLY"] = "QUARTERLY";
  CommissionInvoiceFrequency2["YEARLY"] = "YEARLY";
  return CommissionInvoiceFrequency2;
})(CommissionInvoiceFrequency || {});
var GroupCommissionApi = class extends virtual_default {
  static {
    __name(this, "GroupCommissionApi");
  }
  /**
   * Commission rules
   */
  getAllCommissionsRules(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commission-rules${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllCommissionsRulesCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commission-rules/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createGroupCommissionRule(id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/commission-rules/byGroup/${id}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateManyCommissionsRules(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/commission-rules/update-many`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateOneCommissionsRule(id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/commission-rules/${id}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  deleteManyCommissionsRules(ids) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/commission-rules`, { data: { ids } }).then((response) => response.data) : Promise.reject(initError);
  }
  /**
   * Commissions Invoices
   *
   */
  findCommissionsInvoices(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commissions-invoices?${filter || ""}`).then((response) => response.data) : Promise.reject(initError);
  }
  findCommissionsInvoicesCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commissions-invoices/count?${filter || ""}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCommissionInvoiceById(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commissions-invoices/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updatePartnerCommissions(id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/commissions-invoices/${id}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  generateCommissionInvoice(groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/commissions-invoices/group/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
  generateMassiveExtract(commissionInvoiceId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/commissions-invoices/${commissionInvoiceId}/generate-massive-export`).then((response) => response.data) : Promise.reject(initError);
  }
  getMassiveExportFile(commissionInvoiceId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/commissions-invoices/${commissionInvoiceId}/get-massive-export-file`).then((response) => response.data) : Promise.reject(initError);
  }
};
var group_commissions_default = new GroupCommissionApi();

// src/insurance-api/partner-invoices.ts
var B2b2cPartnerInvoiceStripeMode = /* @__PURE__ */ ((B2b2cPartnerInvoiceStripeMode2) => {
  B2b2cPartnerInvoiceStripeMode2["NONE"] = "NONE";
  B2b2cPartnerInvoiceStripeMode2["STRIPE_COLLECT"] = "STRIPE_COLLECT";
  B2b2cPartnerInvoiceStripeMode2["STRIPE_RECORD"] = "STRIPE_RECORD";
  return B2b2cPartnerInvoiceStripeMode2;
})(B2b2cPartnerInvoiceStripeMode || {});
var PartnerInvoicesApi = class extends virtual_default {
  static {
    __name(this, "PartnerInvoicesApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/partner-invoices${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(partnerInvoicesId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/partner-invoices/${partnerInvoicesId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/partner-invoices/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  totals(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/partner-invoices/totals${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  generateInvoices(partnerId, month) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/partner-invoices", { partnerId, month }).then((response) => response.data) : Promise.reject(initError);
  }
  updateStatus(partnerInvoicesId, status, sending_date, payment_date, paid_amount, keep_receipts) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/partner-invoices/${partnerInvoicesId}/status`, {
      status,
      payment_date,
      sending_date,
      paid_amount,
      keep_receipts
    }).then((response) => response.data) : Promise.reject(initError);
  }
  addReceiptsToInvoice(partnerInvoicesId, month) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/partner-invoices/${partnerInvoicesId}/receipts`, { month }).then((response) => response.data) : Promise.reject(initError);
  }
  send(partnerInvoicesId, options) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/partner-invoices/${partnerInvoicesId}/send`, {
      send_email: options?.send_email ?? true
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getInvoiceDocument(partnerInvoicesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/partner-invoices/${partnerInvoicesId}/invoice-document`).then((response) => response.data) : Promise.reject(initError);
  }
};
var partner_invoices_default = new PartnerInvoicesApi();

// src/main-api/search.ts
var SearchOptionKindEnum = /* @__PURE__ */ ((SearchOptionKindEnum2) => {
  SearchOptionKindEnum2["B2B_CLAIM"] = "B2B_CLAIM";
  SearchOptionKindEnum2["VEHICLE"] = "VEHICLE";
  SearchOptionKindEnum2["B2B_POLICY"] = "B2B_POLICY";
  SearchOptionKindEnum2["B2B2B_POLICY"] = "B2B2B_POLICY";
  SearchOptionKindEnum2["B2B2C_POLICY"] = "B2B2C_POLICY";
  SearchOptionKindEnum2["B2B_QUOTE"] = "B2B_QUOTE";
  SearchOptionKindEnum2["B2B2B_QUOTE"] = "B2B2B_QUOTE";
  SearchOptionKindEnum2["MANAGED_COMPANY"] = "MANAGED_CLIENT";
  SearchOptionKindEnum2["FLEETS"] = "FLEETS";
  return SearchOptionKindEnum2;
})(SearchOptionKindEnum || {});
var SearchGenericApi = class extends virtual_default {
  static {
    __name(this, "SearchGenericApi");
  }
  searchInB2bGroup(input) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/search/b2b", { input }).then((response) => response.data) : Promise.reject(initError);
  }
};
var search_default = new SearchGenericApi();

// src/lib/trads.ts
import i18n from "i18next";

// src/locales/en/translation.json
var translation_default = {
  "notification.error.DEFAULT_ERROR_MESSAGE": 'An error occured. Please contact support with information "{code}"',
  "notification.error.ERROR_ID_REQUIRED": "No id provided",
  "notification.error.ERROR_ID_INVALID_FORMAT": "Invalid format for provided id",
  "notification.error.ERROR_IDS_REQUIRED": "No ids provided",
  "notification.error.ERROR_IDS_INVALID_FORMAT": "Invalid format for provided ids",
  "notification.error.ERROR_IDS_EMPTY": "No ids provided",
  "notification.error.ERROR_IDS_DUPLICATES": "There is some duplicates in provided ids",
  "notification.error.ERROR_NAME_REQUIRED": "No name provided",
  "notification.error.ERROR_DATE_REQUIRED": "No date provided",
  "notification.error.ERROR_DATE_INVALID_FORMAT": "Invalid format for provided date",
  "notification.error.ERROR_PRICE_REQUIRED": "No price provided",
  "notification.error.ERROR_PRICE_INVALID_FORMAT": "Invalid format for provided price",
  "notification.error.ERROR_PRICE_TOO_LOW": "Provided price is too low",
  "notification.error.ERROR_PRICE_TOO_HIGH": "Provided price is too high",
  "notification.error.ERROR_IS_B2B_INVALID_FORMAT": "Invalid format for provided is b2b",
  "notification.error.ERROR_ZIPCODE_INVALID_FORMAT": "Invalid format for provided zipcode",
  "notification.error.ERROR_BODY_REQUIRED": "No body provided",
  "notification.error.ERROR_PASSWORD_REQUIRED": "No password provided",
  "notification.error.ERROR_INVALID_PASSWORD_FORMAT": "Invalid format for provided password",
  "notification.error.ERROR_PASSWORD_CONFIRMATION_REQUIRED": "No password confirmation provided",
  "notification.error.ERROR_PASSWORD_CONFIRMATION_INVALID_FORMAT": "Invalid format for provided password confirmation",
  "notification.error.ERROR_PREVIOUS_PASSWORD_REQUIRED": "No previous password provided",
  "notification.error.ERROR_PREVIOUS_PASSWORD_INVALID_FORMAT": "Invalid format for provided previous password",
  "notification.error.ERROR_RESET_PASSWORD_CODE_INVALID": "Provided reset-password code is invalid",
  "notification.error.ERROR_PASSWORDS_DO_NOT_MATCH": "Provided password and password confirmation do not match",
  "notification.error.ERROR_EMAIL_REQUIRED": "No email provided",
  "notification.error.ERROR_EMAIL_INVALID_FORMAT": "Invalid format for provided email",
  "notification.error.ERROR_EMAIL_ALREADY_USED": "Email already used",
  "notification.error.ERROR_DEVICE_DOES_NOT_EXIST": "Device does not exist",
  "notification.error.ERROR_USERNAME_REQUIRED": "No username provided",
  "notification.error.ERROR_DEVICE_CONFIRMATION_CODE_INVALID": "Provided device confirmation code is invalid",
  "notification.error.ERROR_PHONE_REQUIRED": "No phone number provided",
  "notification.error.ERROR_PHONE_INVALID_FORMAT": "Invalid format for provided phone number",
  "notification.error.ERROR_ZIPCODE_REQUIRED": "No zipcode provided",
  "notification.error.ERROR_ADDRESS_REQUIRED": "No address provided",
  "notification.error.ERROR_FIRSTNAME_REQUIRED": "No firstname provided",
  "notification.error.ERROR_LASTNAME_REQUIRED": "No lastname provided",
  "notification.error.ERROR_BIRTHDAY_REQUIRED": "No birthday provided",
  "notification.error.ERROR_BIRTHDAY_INVALID_FORMAT": "Invalid format for provided birthday",
  "notification.error.ERROR_LATITUDE_REQUIRED": "No latitude provided",
  "notification.error.ERROR_LATITUDE_INVALID_FORMAT": "Invalid format for provided latidude",
  "notification.error.ERROR_LONGITUDE_REQUIRED": "No longitude provided",
  "notification.error.ERROR_LONGITUDE_INVALID_FORMAT": "Invalid format for provided longitude",
  "notification.error.ERROR_LATITUDE_DELTA_REQUIRED": "No latitude delta provided",
  "notification.error.ERROR_LATITUDE_DELTA_INVALID_FORMAT": "Invalid format for provided latidude delta",
  "notification.error.ERROR_LATITUDE_DELTA_TOO_HIGH": "Provided latitude delta is too high",
  "notification.error.ERROR_LONGITUDE_DELTA_REQUIRED": "No longitude delta provided",
  "notification.error.ERROR_LONGITUDE_DELTA_INVALID_FORMAT": "Invalid format for provided longitude delta",
  "notification.error.ERROR_LONGITUDE_DELTA_TOO_HIGH": "Provided longitude delta is too high",
  "notification.error.ERROR_INVALID_AUTH_FORM": "Invalid username or password",
  "notification.error.ERROR_MFA_TOKEN_INVALID": "Provided mfa token is invalid",
  "notification.error.ERROR_MAIL_OPT_IN_REQUIRED": "No mail opt-in provided",
  "notification.error.ERROR_MAIL_OPT_IN_INVALID_FORMAT": "Invalid format for provided mail opt-in",
  "notification.error.ERROR_ROLE_REQUIRED": "No role provided",
  "notification.error.ERROR_ROLE_INVALID_TYPE": "Invalid type for provided role",
  "notification.error.ERROR_BANK_DOES_NOT_EXIST": "Bank does not exist",
  "notification.error.ERROR_BIC_REQUIRED": "No BIC provided",
  "notification.error.ERROR_BIC_TOO_SHORT": "BIC length must be higher or equal to 6",
  "notification.error.ERROR_BANK_CODE_REQUIRED": "No bank code provided",
  "notification.error.ERROR_BANK_CODE_TOO_LOW": "Provided bank code too low",
  "notification.error.ERROR_BANK_CODE_TOO_HIGH": "Provided bank code too high",
  "notification.error.ERROR_BANK_CODE_INVALID_FORMAT": "Invalid format for provided bank code",
  "notification.error.ERROR_DANGER_LEVEL_REQUIRED": "No danger level provided",
  "notification.error.ERROR_DANGER_LEVEL_INVALID_FORMAT": "Invalid format for provided danger level",
  "notification.error.ERROR_DANGER_LEVEL_TOO_LOW": "Danger level must be higher or equal to 1",
  "notification.error.ERROR_DANGER_LEVEL_TOO_HIGH": "Danger level must be lower or equal to 3",
  "notification.error.ERROR_BIKE_MODEL_DOES_NOT_EXIST": "Bike model does not exist",
  "notification.error.ERROR_BRAND_REQUIRED": "No brand provided",
  "notification.error.ERROR_BRAND_INVALID_FORMAT": "Invalid format for provided brand",
  "notification.error.ERROR_BRAND_INVALID_LENGTH": "Invalid length for provided brand",
  "notification.error.ERROR_MODEL_REQUIRED": "No model provided",
  "notification.error.ERROR_MODEL_INVALID_LENGTH": "Invalid length for provided model",
  "notification.error.ERROR_APPROVED_INVALID_FORMAT": "Invalid format for provided approved",
  "notification.error.ERROR_BRAND_CODE_INVALID_LENGTH": "Invalid length for provided brand code",
  "notification.error.ERROR_CATEGORY_INVALID_LENGTH": "Invalid length for provided category",
  "notification.error.ERROR_CATEGORY_CODE_INVALID_LENGTH": "Invalid length for provided category code",
  "notification.error.ERROR_ELECTRIC_INVALID_FORMAT": "Invalid format for provided electric",
  "notification.error.ERROR_IMAGE_URL_INVALID_LENGTH": "Invalid length for provided image url",
  "notification.error.ERROR_MODEL_CODE_INVALID_LENGTH": "Invalid length for provided model code",
  "notification.error.ERROR_SHARELOCK_COMPATIBILITY_PERCENTAGE_INVALID_FORMAT": "Invalid format for provided sharelock compatibility percentage",
  "notification.error.ERROR_SHARELOCK_COMPATIBLE_INVALID_FORMAT": "Invalid format for provided sharelock compatible",
  "notification.error.ERROR_YEAR_INVALID_FORMAT": "Invalid format for provided year",
  "notification.error.ERROR_PREVBRAND_REQUIRED": "No previous brand provided",
  "notification.error.ERROR_SUGGESTION_ID_REQUIRED": "No suggested id provided",
  "notification.error.ERROR_BIKE_ID_REQUIRED": "No bike id provided",
  "notification.error.ERROR_SUGGESTION_ID_AND_BIKE_ID_MUST_BE_DIFFERENT": "Suggested id and current id must differe",
  "notification.error.ERROR_CITY_DOES_NOT_EXIST": "City does not exist",
  "notification.error.ERROR_CURRENT_CITY_INVALID_FORMAT": "Invalid format for provided current city",
  "notification.error.ERROR_IS_ARCHIVED_REQUIRED": "No is archived provided",
  "notification.error.ERROR_IS_ARCHIVED_INVALID_FORMAT": "Invalid format for provided is archived",
  "notification.error.ERROR_USER_DOES_NOT_EXIST": "User does not exist",
  "notification.error.ERROR_USER_ID_REQUIRED": "No user id provided",
  "notification.error.ERROR_USER_ID_INVALID_FORMAT": "Invalid format for provided user id",
  "notification.error.ERROR_USERS_REQUIRED": "No users provided",
  "notification.error.ERROR_USERS_INVALID_FORMAT": "Invalid format for provided users",
  "notification.error.ERROR_TAG_REQUIRED": "No tag provided",
  "notification.error.ERROR_REASON_REQUIRED": "No reason provided",
  "notification.error.ERROR_TAG_DATE_INVALID_FORMAT": "Invalid format for provided tag date",
  "notification.error.ERROR_BLOCKED_INVALID_FORMAT": "Invalid format for provided blocked",
  "notification.error.ERROR_CONFIRMED_INVALID_FORMAT": "Invalid format for provided confirmed",
  "notification.error.ERROR_BANK_INVALID_FORMAT": "Invalid format for provided bank",
  "notification.error.ERROR_PHOTO_REQUIRED": "No photo provided",
  "notification.error.ERROR_VIGIMAP_INVALID_FORMAT": "Invalid format for provided vigimap",
  "notification.error.ERROR_VIGIMAP_POPUP_INVALID_FORMAT": "Invalid format for provided vigimap popup",
  "notification.error.ERROR_BATTERY_POPUP_INVALID_FORMAT": "Invalid format for provided battery popup",
  "notification.error.ERROR_ALWAYS_GEOLOCATION_TRACKING_INVALID_FORMAT": "Invalid format for provided always geolocation tracking",
  "notification.error.ERROR_REDIRECT_AFTER_LOGIN_INVALID_TYPE": "Invalid format for provided redirect after login",
  "notification.error.ERROR_ROLES_TO_ADD_INVALID_TYPE": "Invalid type for provided roles to add",
  "notification.error.ERROR_ROLES_TO_REMOVE_INVALID_TYPE": "Invalid type for provided roles to remove",
  "notification.error.ERROR_ROLES_REQUIRED": "No roles provided",
  "notification.error.ERROR_GROUP_DOES_NOT_EXIST": "Group does not exist",
  "notification.error.ERROR_GROUP_ID_REQUIRED": "No group id provided",
  "notification.error.ERROR_GROUP_ID_INVALID_FORMAT": "Invalid format for provided group id",
  "notification.error.ERROR_PARTNER_DOES_NOT_EXIST": "Partner does not exist",
  "notification.error.ERROR_PARTNER_ID_REQUIRED": "No partner id provided",
  "notification.error.ERROR_PARTNER_ID_INVALID_FORMAT": "Invalid format for provided partner id",
  "notification.error.ERROR_SIRET_REQUIRED": "No siret provided",
  "notification.error.ERROR_SIRET_ALREADY_EXISTS": "Provided siret already exist",
  "notification.error.ERROR_CITY_REQUIRED": "No city provided",
  "notification.error.ERROR_TYPOLOGY_INVALID_TYPE": "Invalid type for provided typology",
  "notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_TYPE": "Invalid type for provided expected policy type",
  "notification.error.ERROR_ORIAS_TOO_LONG": "Provided orias is too long",
  "notification.error.ERROR_EXPECTED_TARGETS_INVALID_FORMAT": "Invalid format for provided expected targets",
  "notification.error.ERROR_USE_PROMOTION_CODE_FOR_ATTRIBUTION_INVALID_FORMAT": "Invalid format for provided use promotion code for attribution",
  "notification.error.ERROR_PROMOTION_CODES_INVALID_FORMAT": "Invalid format for provided promotion codes",
  "notification.error.ERROR_PROMOTION_CODES_DUCPLICATE": "There is some duplicates in provided promotion codes",
  "notification.error.ERROR_OPS_ID_INVALID_FORMAT": "Invalid format for provided ops id",
  "notification.error.ERROR_USER_ALREADY_IN_GROUP": "Provided user is already member of provided group",
  "notification.error.ERROR_USER_ALREADY_INVITED": "Provided user has already been invited to provided group",
  "notification.error.ERROR_NO_VEHICLE_GIVEN": "No vehicle given",
  "notification.error.ERROR_DOCUMENT_DOES_NOT_EXIST": "Document does not exist",
  "notification.error.ERROR_FILENAME_REQUIRED": "No filename provided",
  "notification.error.ERROR_VERSO_FILENAME_REQUIRED": "No verso filename provided",
  "notification.error.ERROR_UUID_REQUIRED": "No uuid provided",
  "notification.error.ERROR_VERSO_UUID_REQUIRED": "No verso uuid provided",
  "notification.error.ERROR_MIME_TYPE_REQUIRED": "No mime type provided",
  "notification.error.ERROR_MIME_TYPE_INVALID_TYPE": "Invalid type for provided mime type",
  "notification.error.ERROR_VERSO_MIME_TYPE_REQUIRED": "No verso mime type provided",
  "notification.error.ERROR_VERSO_MIME_TYPE_INVALID_TYPE": "Invalid type for provided verso mime type",
  "notification.error.ERROR_SIZE_INVALID_FORMAT": "Invalid format for provided size",
  "notification.error.ERROR_VERSO_SIZE_INVALID_FORMAT": "Invalid format for provided verso size",
  "notification.error.ERROR_OWNER_INVALID_FORMAT": "Invalid format for provided owner",
  "notification.error.ERROR_TYPE_REQUIRED": "No type provided",
  "notification.error.ERROR_TYPE_INVALID_TYPE": "Invalid type for provided type",
  "notification.error.ERROR_OBJECT_ID_REQUIRED": "No object id provided",
  "notification.error.ERROR_OBJECT_ID_INVALID_FORMAT": "Invalid format for provided object id",
  "notification.error.ERROR_IS_EXPIRED_REQUIRED": "No is expired provided",
  "notification.error.ERROR_IS_EXPIRED_INVALID_FORMAT": "Invalid format for provided is expired",
  "notification.error.ERROR_EXPIRATION_DATE_INVALID_FORMAT": "Invalid format for provided expiration date",
  "notification.error.ERROR_INFORM_REASON_REQUIRED": "No inform reason provided",
  "notification.error.ERROR_REJECT_REASON_REQUIRED": "No reject reason provided",
  "notification.error.ERROR_ROTATE_FACTOR_REQUIRED": "No rotate factor provided",
  "notification.error.ERROR_ROTATE_FACTOR_INVALID_FORMAT": "Invalid format for provided rotate factor",
  "notification.error.ERROR_WITHOUT_EXPIRED_INVALID_FORMAT": "Invalid format for provided without expired",
  "notification.error.ERROR_DOCUMENT_ALREADY_VALIDATED": "Provided document is already validated",
  "notification.error.ERROR_DOCUMENT_ALREADY_REJECTED": "Provided document is already rejected",
  "notification.error.ERROR_USER_ALREADY_INFORMED": "User is already informed",
  "notification.error.ERROR_DOCUMENT_NOT_RESETTABLE": "Provided document is not resettable",
  "notification.error.ERROR_NOTES_REQUIRED": "No notes provided",
  "notification.error.ERROR_SEND_TO_USER_REQUIRED": "No sent to user provided",
  "notification.error.ERROR_SEND_TO_USER_INVALID_FORMAT": "Invalid format for provided send to user",
  "notification.error.ERROR_COMMENT_REQUIRED": "No comment provided",
  "notification.error.ERROR_IS_OBJECT_INVALID_FORMAT": "Invalid format for provided is object",
  "notification.error.ERROR_REJECTED_INVALID_FORMAT": "Invalid format for provided rejected",
  "notification.error.ERROR_NEW_TYPE_REQUIRED": "No new type provided",
  "notification.error.ERROR_NEW_TYPE_INVALID_TYPE": "Invalid type for provided new type",
  "notification.error.ERROR_NEW_LINK_REQUIRED": "No new link provided",
  "notification.error.ERROR_NEW_LINK_INVALID_FORMAT": "Invalid format for provided new link",
  "notification.error.ERROR_CONTRACT_DOES_NOT_EXIST": "Contract does not exist",
  "notification.error.ERROR_CONTRACT_ID_REQUIRED": "No contract id provided",
  "notification.error.ERROR_CONTRACT_ID_INVALID_FORMAT": "Invalid format for provided contract id",
  "notification.error.ERROR_PACKAGE_DOES_NOT_EXIST": "Package does not exist",
  "notification.error.ERROR_PACKAGE_ID_REQUIRED": "No package id provided",
  "notification.error.ERROR_PACKAGE_ID_INVALID_FORMAT": "Invalid format for provided package id",
  "notification.error.ERROR_PAYMENT_METHOD_REQUIRED": "No payment method provided",
  "notification.error.ERROR_PAYMENT_METHOD_TOO_SHORT": "Provided payment method is too short",
  "notification.error.ERROR_PAYMENT_METHOD_NOT_FOUND": "No payment method found",
  "notification.error.ERROR_PAYMENT_METHOD_ID_REQUIRED": "No payment method id provided",
  "notification.error.ERROR_PAYMENT_METHOD_ID_TOO_SHORT": "Provided payment method id is too short",
  "notification.error.ERROR_PAYMENT_METHOD_TYPE_REQUIRED": "No payment method type provided",
  "notification.error.ERROR_PAYMENT_METHOD_TYPE_INVALID_TYPE": "Invalid type for provided payment method type",
  "notification.error.ERROR_PAYMENT_INTENT_ID_REQUIRED": "No payment intent id provided",
  "notification.error.ERROR_PAYMENT_INTENT_ID_TOO_SHORT": "Provided payment intent id is too short",
  "notification.error.ERROR_INVOICE_ID_REQUIRED": "No invocie id provided",
  "notification.error.ERROR_VEHICLE_ID_REQUIRED": "No vehicle id provided",
  "notification.error.ERROR_VEHICLE_ID_INVALID_FORMAT": "Invalid format for provided vehicle id",
  "notification.error.ERROR_PURCHASE_PROOF_REQUIRED": "No purchase proof provided",
  "notification.error.ERROR_PURCHASE_PROOF_INVALID_FORMAT": "Invalid format for provided purchase proof",
  "notification.error.ERROR_PURCHASE_DATE_REQUIRED": "No purchase date provided",
  "notification.error.ERROR_PURCHASE_DATE_INVALID_FORMAT": "Invalid format for provided purchase date",
  "notification.error.ERROR_PURCHASE_DATE_TOO_OLD": "Provided purchase date is too old (5 years old max)",
  "notification.error.ERROR_BICYCODE_REQUIRED": "No marking code provided",
  "notification.error.ERROR_BICYCODE_INVALID_LENGTH": "Invalid length for provided marking code",
  "notification.error.ERROR_COMMENT_INVALID_LENGTH": "Invalid length for provided comment",
  "notification.error.ERROR_DATAS_REQUIRED": "No datas provided",
  "notification.error.ERROR_DATAS_EMPTY": "No datas provided",
  "notification.error.ERROR_FLEET_DOES_NOT_EXIST": "Provided fleet does not exist",
  "notification.error.ERROR_FLEET_INVALID_FORMAT": "Invalid format for provided fleet",
  "notification.error.ERROR_FILE_REQUIRED": "No file provided",
  "notification.error.ERROR_URL_REQUIRED": "No url provided",
  "notification.error.ERROR_DEMAND_DATE_REQUIRED": "No demand date provided",
  "notification.error.ERROR_DEMAND_DATE_INVALID_FORMAT": "Invalid format for provided demand date",
  "notification.error.ERROR_INTERVENTION_TYPE_REQUIRED": "No intervention type provided",
  "notification.error.ERROR_INTERVENTION_TYPE_INVALID_TYPE": "Invalid type for provided interventation type",
  "notification.error.ERROR_WARRANTY_REQUIRED": "No warranty provided",
  "notification.error.ERROR_WARRANTY_INVALID_TYPE": "Invalid type for provided warranty",
  "notification.error.ERROR_WARRANTY_CONDITION_REQUIRED": "No warranty condition provided",
  "notification.error.ERROR_WARRANTY_CONDITION_INVALID_FORMAT": "Invalid format for provided warranty condition",
  "notification.error.ERROR_OPERATIONS_REQUIRED": "No operations provided",
  "notification.error.ERROR_OPERATIONS_EMPTY": "No operations provided",
  "notification.error.ERROR_OPERATIONS_INVALID_TYPE": "Invalid type for provided operations",
  "notification.error.ERROR_PROBLEM_DESCRIPTION_REQUIRED": "No problem description provided",
  "notification.error.ERROR_WHISHES_REQUIRED": "No wishes provided",
  "notification.error.ERROR_WHISHES_EMPTY": "No wishes provided",
  "notification.error.ERROR_WISHES_INVALID_TYPE": "Invalid type for provided wishes",
  "notification.error.ERROR_INTERVENTION_ADDRESS_REQUIRED": "No intervention address provided",
  "notification.error.ERROR_AVAILABILITIES_REQUIRED": "No availabilities provided",
  "notification.error.ERROR_BIKE_PICS_REQUIRED": "No bike pictures provided",
  "notification.error.ERROR_BIKE_PICS_INVALID_FORMAT": "No bike pictures provided",
  "notification.error.ERROR_BIKE_PICS_EMPTY": "No bike pictures provided",
  "notification.error.ERROR_BIKE_PICS_INVALID_TYPE": "Invalid type for provided bike pictures",
  "notification.error.ERROR_DOCUMENTS_REQUIRED": "No documents provided",
  "notification.error.ERROR_DOCUMENTS_INVALID_FORMAT": "Invalid format for provided documents",
  "notification.error.ERROR_DOCUMENTS_CANNOT_EMPTY": "No documents provided",
  "notification.error.ERROR_DOCUMENTS_INVALID_TYPE": "Invalid type for provided documents",
  "notification.error.ERROR_FOLDER_KEY_REQUIRED": "No folder key provided",
  "notification.error.ERROR_LEAD_DOES_NOT_EXIST": "Lead does not exist",
  "notification.error.ERROR_INSURED_VALUE_INVALID_FORMAT": "Invalid format for provided insured value",
  "notification.error.ERROR_FROM_SOURCE_INVALID_TYPE": "Invalid type for provided from source",
  "notification.error.ERROR_STATUS_INVALID_TYPE": "Invalid type for provided status",
  "notification.error.ERROR_NEWS_LETTER_OPT_IN_INVALID_FORMAT": "Invalid format for provided newsletter opt-in",
  "notification.error.ERROR_PHONE_OPT_IN_INVALID_FORMAT": "Invalid format for provided phone opt-in",
  "notification.error.ERROR_ADDITIONAL_INFORMATION_INVALID_FORMAT": "Invalid format for provided additional information",
  "notification.error.ERROR_TOKEN_REQUIRED": "No token provided",
  "notification.error.ERROR_QUOTE_DOES_NOT_EXIST": "Quote does not exist",
  "notification.error.ERROR_LOCK_MODEL_DOES_NOT_EXIST": "Lock model does not exist",
  "notification.error.ERROR_LOCKS_IDS_REQUIRED": "No locks ids provided",
  "notification.error.ERROR_LOCKS_IDS_INVALID_FORMAT": "Invalid format for provided locks ids",
  "notification.error.ERROR_IS_APPROVED_REQUIRED": "No is approved provided",
  "notification.error.ERROR_IS_APPROVED_INVALID_FORMAT": "Invalid format for provided is approved",
  "notification.error.ERROR_TYPE_INVALID_LENGTH": "Invalid length for provided type",
  "notification.error.ERROR_SECURITY_CERTIFICATE_REQUIRED": "No security certificate provided",
  "notification.error.ERROR_SECURITY_CERTIFICATE_INVALID_LENGTH": "Invalid length provided security certificate",
  "notification.error.ERROR_LEVEL_INVALID_LENGTH": "Invalid length for provided level",
  "notification.error.ERROR_FRAUD_PARTNER_ID_REQUIRED": "No fraud partner id provided",
  "notification.error.ERROR_FRAUD_PARTNER_ID_INVALID_FORMAT": "Invalid format for provided fraud partner id",
  "notification.error.ERROR_ALREADY_FRAUD_PARTNER": "Provided fraud partner id is already a fraud partner",
  "notification.error.ERROR_FRAUD_PARTNER_DOES_NOT_EXIST": "Fraud partner does not exist",
  "notification.error.ERROR_CLAIM_DATE_INVALID_FORMAT": "Invalid format for provided claim date",
  "notification.error.ERROR_CODE_REQUIRED": "No code provided",
  "notification.error.ERROR_CODE_INVALID_LENGTH": "Invalid length for provided code",
  "notification.error.ERROR_CODE_ID_REQUIRED": "No code id provided",
  "notification.error.ERROR_CODE_ID_INVALID_FORMAT": "Invalid format for provided code id",
  "notification.error.ERROR_YEAR_REQUIRED": "No year provided",
  "notification.error.ERROR_NOTIF_IDS_REQUIRED": "No notif ids provided",
  "notification.error.ERROR_NOTIF_IDS_EMPTY": "No notif ids provided",
  "notification.error.ERROR_NOTIF_IDS_INVALID_FORMAT": "Invalid format for provided notif ids",
  "notification.error.ERROR_USERS_IDS_REQUIRED": "No users ids provided",
  "notification.error.ERROR_USERS_IDS_INVALID_FORMAT": "Invalid format for provided users ids",
  "notification.error.ERROR_USERS_IDS_EMPTY": "No users ids provided",
  "notification.error.ERROR_MESSAGE_REQUIRED": "No message provided",
  "notification.error.ERROR_TITLE_REQUIRED": "No title provided",
  "notification.error.ERROR_START_DATE_IN_THE_PAST": "Provided start date should not be in the past",
  "notification.error.ERROR_START_DATE_INVALID_FORMAT": "Invalid format provided for start date",
  "notification.error.ERROR_EXPIRATION_BEFORE_START": "Expiration date must be after start date",
  "notification.error.ERROR_MISSING_EXPIRATION_DATE": "No expiration date provided",
  "notification.error.ERROR_EXPIRATION_DATE_NOT_IN_FUTUR": "Provided expiration date should be in the futur",
  "notification.error.ERROR_PRIORITY_LEVEL_REQUIRED": "No priority level provided",
  "notification.error.ERROR_PRIORITY_LEVEL_INVALID_TYPE": "Invalid type for provided priority level",
  "notification.error.ERROR_SEND_VIA_FIREBASE_REQUIRED": "No send via firebase provided",
  "notification.error.ERROR_SEND_VIA_FIREBASE_INVALID_FORMAT": "Invalid format for provided send via firebase",
  "notification.error.ERROR_AUTH_TOKEN_ID_REQUIRED": "No auth token id provided",
  "notification.error.ERROR_AUTH_TOKEN_ID_INVALID_FORMAT": "Invalid format for provided auth token id",
  "notification.error.ERROR_PHONE_OPERATOR_DOES_NOT_EXIST": "Phone operator does not exist",
  "notification.error.ERROR_NAME_TOO_SHORT": "Provided name is too short",
  "notification.error.ERROR_OPERATOR_CODE_REQUIRED": "No operator code provided",
  "notification.error.ERROR_OPERATOR_CODE_TOO_LOW": "Provided operator code is too low",
  "notification.error.ERROR_OPERATOR_CODE_TOO_HIGH": "Provided operator code is too high",
  "notification.error.ERROR_OPERATOR_CODE_INVALID_FORMAT": "Invalid format for provided operator code",
  "notification.error.ERROR_PROMOTION_CODE_DOES_NOT_EXIST": "Promotion code does not exist",
  "notification.error.ERROR_PROMOTION_CODE_ALREADY_EXISTS": "Promotion code already exist",
  "notification.error.ERROR_ACTIVE_INVALID_FORMAT": "Invalid format for provided active",
  "notification.error.ERROR_PRODUCT_REQUIRED": "No product provided",
  "notification.error.ERROR_PRODUCT_INVALID_TYPE": "Invalid type for provided product",
  "notification.error.ERROR_MONTHLY_REQUIRED": "No monthly code provided",
  "notification.error.ERROR_MONTHLY_INVALID_LENGTH": "Invalid length for provided monthly code",
  "notification.error.ERROR_ANNUAL_REQUIRED": "No annual code provided",
  "notification.error.ERROR_ANNUAL_INVALID_LENGTH": "Invalid length for provided annual code",
  "notification.error.ERROR_MAX_REDEEM_TOTAL_INVALID_FORMAT": "Invalid format for provided max redeem total",
  "notification.error.ERROR_MAX_REDEEM_PER_USER_INVALID_FORMAT": "Invalid format for provided max redeem per user",
  "notification.error.ERROR_LOCK_REQUIRED": "No lock provided",
  "notification.error.ERROR_LOCK_INVALID_LENGTH": "Invalid length for provided lock",
  "notification.error.ERROR_PROMOTION_CODE_EXPIRED": "Provided promotion-code is expired",
  "notification.error.ERROR_INPUT_REQUIRED": "No input provided",
  "notification.error.ERROR_COVERAGE_CODE_REQUIRED": "No coverage code provided",
  "notification.error.ERROR_COVERAGE_CODE_INVALID_TYPE": "Invalid type for provided coverage code",
  "notification.error.ERROR_LOCKING_SESSION_DOES_NOT_EXIST": "Locking-session does not exist",
  "notification.error.ERROR_LOCKING_SESSION_ID_INVALID_FORMAT": "Invalid format for provided locking-session id",
  "notification.error.ERROR_LOCK_DOES_NOT_EXIST": "Lock does not exist",
  "notification.error.ERROR_LOCK_ID_REQUIRED": "No lock id provided",
  "notification.error.ERROR_LOCK_ID_INVALID_FORMAT": "Invalid format for provided lock id",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_DOES_NOT_EXIST": "Personal-locking-session does not exist",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_FORMAT": "Invalid format for provided personal-locking-session id",
  "notification.error.ERROR_DESCRIPTION_REQUIRED": "No description provided",
  "notification.error.ERROR_SOURCE_REQUIRED": "No source provided",
  "notification.error.ERROR_SOURCE_INVALID_TYPE": "Invalid type for provided source",
  "notification.error.ERROR_MILEAGE_REQUIRED": "No mileage provided",
  "notification.error.ERROR_MILEAGE_INVALID_FORMAT": "Invalid format for provided mileage",
  "notification.error.ERROR_BUYING_YEAR_REQUIRED": "No buying year provided",
  "notification.error.ERROR_BUYING_YEAR_TOO_LOW": "Provided buying year is too low",
  "notification.error.ERROR_BUYING_YEAR_IN_THE_FUTURE": "Provided buying year should not be in the futur",
  "notification.error.ERROR_BUYING_YEAR_INVALID_FORMAT": "Invalid format for provided buying year",
  "notification.error.ERROR_BUYING_PRICE_REQUIRED": "No buying price provided",
  "notification.error.ERROR_BUYING_PRICE_INVALID_FORMAT": "Invalid format for provided buying price",
  "notification.error.ERROR_CATEGORY_REQUIRED": "No category provided",
  "notification.error.ERROR_CATEGORY_INVALID_TYPE": "Invalid type for provided category",
  "notification.error.ERROR_COLOR_REQUIRED": "No color provided",
  "notification.error.ERROR_COLOR_INVALID_TYPE": "Invalid type for provided color",
  "notification.error.ERROR_SIZE_REQUIRED": "No size provided",
  "notification.error.ERROR_BATTERY_CAPACITY_REQUIRED": "No battery capacity provided",
  "notification.error.ERROR_BATTERY_CAPACITY_INVALID_FORMAT": "Invalid format for provided battery capacity",
  "notification.error.ERROR_ORIGIN_REQUIRED": "No origin provided",
  "notification.error.ERROR_ORIGIN_INVALID_TYPE": "Invalid type for provided origin",
  "notification.error.ERROR_PROPOSED_PRICE_INVALID_FORMAT": "Invalid format for provided proposed price",
  "notification.error.ERROR_CREATING_TRADE_IN_REQUEST": "Could not create trad-in request",
  "notification.error.ERROR_ANDROID_INVALID_FORMAT": "Invalid format for provided android",
  "notification.error.ERROR_IOS_INVALID_FORMAT": "Invalid format for provided ios",
  "notification.error.ERROR_MIN_ANDROID_INVALID_FORMAT": "Invalid format for provided minimum android",
  "notification.error.ERROR_MIN_IOS_INVALID_FORMAT": "Invalid format for provided minimum ios",
  "notification.error.ERROR_CHALLENGE_TOKEN_REQUIRED": "No token provided",
  "notification.error.ERROR_CAN_NOT_CHANGE_CLIENT_ROLE": "Changing client roles is not allowed",
  "notification.error.ERROR_UNAUTHORIZED_ROLE_MODIFICATION": "Operation not allowed",
  "notification.error.ERROR_USER_HAS_ACTIVE_POLICY": "User has an active policy",
  "notification.error.ERROR_USER_HAS_POLICY_IN_RETENTION_PERIOD": "User has a policy terminated less than five years ago",
  "notification.error.ERROR_USER_HAS_CLAIM_IN_RETENTION_PERIOD": "User has a claim closed less than five years ago",
  "notification.error.ERROR_USER_HAS_LOCK_SUBSCRIPTION": "User has an active lock subscription",
  "notification.error.ERROR_USER_IS_IN_A_GROUP": "User is in a group",
  "notification.error.ERROR_BODY_CANNOT_BE_EMPTY": "The body can not be empty",
  "notification.error.ERROR_GROUP_ALREADY_PARTNER": "The group is already a partner",
  "notification.error.ERROR_GROUP_IS_NOT_PARTNER": "The group is not a partner",
  "notification.error.ERROR_IS_PARTNER_INVALID_FORMAT": "is_partner field is not in a correct format",
  "notification.error.ERROR_IS_PARTNER_REQUIRED": "is_partner field is mandatory",
  "notification.error.ERROR_GROUP_ALREADY_FRAUD_PARTNER": "The group is already a fraud partner",
  "notification.error.ERROR_GROUP_IS_NOT_FRAUD_PARTNER": "The group is not a fraud partner",
  "notification.error.ERROR_DATAS_INVALID_ARRAY": "Provided datas not an array",
  "notification.error.ERROR_LAT_INVALID_FORMAT": "Invalid format for provided lat",
  "notification.error.ERROR_LONG_INVALID_FORMAT": "Invalid format for provided long",
  "notification.error.ERROR_MONTH_REQUIRED": "No month provided",
  "notification.error.ERROR_MONTH_INVALID_FORMAT": "Invalid format for provided month",
  "notification.error.ERROR_MONTH_TOO_HIGH": "Provided month is too high",
  "notification.error.ERROR_MONTH_TOO_LOW": "Provided month is too low",
  "notification.error.ERROR_SUGGESTION_ID_INVALID_FORMAT": "Invalid format for provided suggestion id",
  "notification.error.ERROR_FM_TOKENS_INVALID_ARRAY": "Provided fm tokens not an array",
  "notification.error.ERROR_ROLES_TO_ADD_INVALID_ARRAY": "Provided roles to add not an array",
  "notification.error.ERROR_ROLES_TO_REMOVE_INVALID_ARRAY": "Provided roles to remove not an array",
  "notification.error.ERROR_BIKE_ID_INVALID_FORMAT": "Invalid format for provided bike id",
  "notification.error.ERROR_OPERATIONS_INVALID_ARRAY": "Provided operations not an array",
  "notification.error.ERROR_WHISHES_INVALID_ARRAY": "Provided wishes not an array",
  "notification.error.ERROR_YEAR_FORMAT": "Year must be a 4-digit number",
  "notification.error.ERROR_MONTH_MIN_1": "Month must be at least 1",
  "notification.error.ERROR_MONTH_MAX_12": "Month cannot be greater than 12",
  "notification.error.ERROR_NOTIFICATION_LINK_INVALID_URL": "Invalid format for provided notification link",
  "notification.error.ERROR_NOTIFICATION_TEXT_REQUIRED": "No notification text provided",
  "notification.error.ERROR_NOTIFICATION_TITLE_REQUIRED": "No notification title provided",
  "notification.error.ERROR_COMMENT_MIN": "Comment is too short",
  "notification.error.ERROR_COMMENT_MAX": "Comment is too long",
  "notification.error.ERROR_MISSING_REQUIRED_PAYMENT_DATE": "Payment date was required when new status is INVOICE_PAID",
  "notification.error.ERROR_MISSING_REQUIRED_SENDING_DATE": "Sending date was required when new status is INVOICE_SENT",
  "notification.error.ERROR_PARTNER_INVOICES_STATUS": "Missing partner invoice status",
  "notification.error.WRONG_PARTNER_INVOICES_STATUS": "Wrong status type",
  "notification.error.WRONG_PAYMENT_DATE_TYPE": "Wrong date format for payment date",
  "notification.error.WRONG_SENDING_DATE_TYPE": "Wrong date format for sending date",
  "notification.error.ERROR_PAID_AMOUNT_MINIMUM": "Error paid amount minimum",
  "notification.error.ERROR_PAID_AMOUNT_TYPE": "Error paid amount type",
  "notification.error.ERROR_DOCUMENT_ID_FORMAT": "document_id is not in a correct format",
  "notification.error.ERROR_DOCUMENT_ID_REQUIRED": "document_id is required",
  "notification.error.ERROR_NAME_INVALID_FORMAT": "name is not in a correct format",
  "notification.error.ERROR_NAME_TOO_LONG": "name is too long",
  "notification.error.ERROR_PU_TTC_FORMAT": "pu_ttc is not in a correct format",
  "notification.error.ERROR_PU_TTC_REQUIRED": "pu_ttc is required",
  "notification.error.ERROR_QUANTITY_FORMAT": "quantity is not in a correct format",
  "notification.error.ERROR_QUANTITY_REQUIRED": "quantity is required",
  "notification.error.ERROR_ARTICLES_REQUIRED": "articles are required",
  "notification.error.ERROR_DISCOUNT_NEGATIVE": "discount must be positive",
  "notification.error.ERROR_PU_HT_NEGATIVE": "ht price must be positive",
  "notification.error.ERROR_PU_TTC_NEGATIVE": "ttc price must be positive",
  "notification.error.ERROR_QUANTITY_NEGATIVE": "quantity must be positive",
  "notification.error.ERROR_TVA_AMOUNT_NEGATIVE": "tva_amount must be positive",
  "notification.error.ERROR_TVA_NEGATIVE": "tva must be positive",
  "notification.error.ERROR_DISCOUNT_FORMAT": "discount wrong format",
  "notification.error.ERROR_DOCUMENT_ID_INVALID_FORMAT": "document_id wrong format",
  "notification.error.ERROR_PU_HT_FORMAT": "price without taxes wrong format",
  "notification.error.ERROR_TVA_FORMAT": "tva wrong format",
  "notification.error.ERROR_ID_INVALID": "id invalid",
  "notification.error.ERROR_TVA_AMOUNT_FORMAT": "tva_amount wrong format",
  "notification.error.ERROR_QUOTE_ID_REQUIRED": "Error quote id required",
  "notification.error.ERROR_VEHICLES_ID_INVALID_FORMAT": "Error vehicles id invalid format",
  "notification.error.ERROR_CANCEL_REASON_INVALID_TYPE": "Error cancel reason id invalid type",
  "notification.error.ERROR_CANCEL_REASON_REQUIRED": "Error cancel reason required",
  "notification.error.ERROR_VEHICLES_NOT_AN_ARRAY": "Error vehicles not an array",
  "notification.error.ERROR_ARTICLES_INVALID_ARRAY": "Provided articles not an array",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_BOOLEAN": "Auto renewal must be a boolean value.",
  "notification.error.ERROR_OPS_SUSPEND_ALLOWED_INVALID_FORMAT": "Ops suspend allowed must be a boolean value.",
  "notification.error.ERROR_POLICY_INFORMATION_INVALID_FORMAT": "Invalid format for provided policy information",
  "notification.error.ERROR_POLICY_PRICE_INVALID_FORMAT": "Invalid format for provided policy price",
  "notification.error.ERROR_BIKE_INFORMATION_INVALID_FORMAT": "Invalid format for provided bike information",
  "notification.error.ERROR_DISPLAY_CONTRACT_INVALID_FORMAT": "Invalid format for provided display contract",
  "notification.error.ERROR_CANCEL_ALLOWED_INVALID_FORMAT": "Invalid format for provided cancel allowed",
  "notification.error.ERROR_INSURED_VALUE_LIMIT_INVALID_FORMAT": "Invalid format for provided insured value limit",
  "notification.error.ERROR_OPS_SUSPEND_ALLOWED_REQUIRED": "Ops suspend allowed is required",
  "notification.error.ERROR_NB_EMPLOYEES_INVALID_FORMAT": "Invalid format for provided number of employees",
  "notification.error.ERROR_IS_ARCHIVE_INVALID_FORMAT": "is_archive must be a boolean value.",
  "notification.error.ERROR_USER_IS_A_SPONSOR": "User is a Sponsor",
  "notification.error.ERROR_USER_HAS_PAYMENTS": "User has payments in Stripe",
  "notification.error.ERROR_FLEET_ASSOCIATION_ERROR": "Fleet association error",
  "notification.error.ERROR_VEHICLE_IDS_INVALID_ARRAY": "Invalid array for provided vehicle ids",
  "notification.error.ERROR_VEHICLE_IDS_EMPTY": "No vehicle ids provided",
  "notification.error.ERROR_VEHICLE_IDS_INVALID_FORMAT": "Invalid format for provided vehicle ids",
  "notification.error.ERROR_FLEETS_EMPTY": "No fleets provided",
  "notification.error.ERROR_FLEETS_INVALID_ARRAY": "Invalid array for provided fleets",
  "notification.error.ERROR_VEHICLE_IDS_REQUIRED": "No vehicle ids provided",
  "notification.error.ERROR_EVENTS_INVALID_ARRAY": "Events must be an array.",
  "notification.error.ERROR_EVENTS_INVALID_TYPE": "Invalid type for event(s).",
  "notification.error.ERROR_WEBHOOK_DESCRIPTION_INVALID_FORMAT": "Invalid format for webhook description.",
  "notification.error.ERROR_WEBHOOK_GROUP_INVALID_FORMAT": "Invalid format for webhook group.",
  "notification.error.ERROR_WEBHOOK_GROUP_REQUIRED": "Webhook group is required.",
  "notification.error.ERROR_WEBHOOK_EVENTS_REQUIRED": "Please provide at least one event for the webhook.",
  "notification.error.ERROR_WEBHOOK_URL_INVALID_FORMAT": "Webhook URL must be a string.",
  "notification.error.ERROR_WEBHOOK_URL_INVALID_URL": "Webhook URL must be a valid URL (https://example.com).",
  "notification.error.ERROR_WEBHOOK_URL_REQUIRED": "Please provide a webhook URL.",
  "notification.error.ERROR_RESET_PASSWORD_CODE_EXPIRED": "Provided reset-password code has expired",
  "notification.error.ERROR_DEVICE_CONFIRMATION_CODE_EXPIRED": "Provided device confirmation code is expired",
  "notification.error.ERROR_PAYMENT_METHOD_DOES_NOT_BELONG_TO_GROUP": "Provided payment intent id does not belong to your group",
  "notification.error.ERROR_COMMUNICATION_TYPE_REQUIRED": "please provide at least one communication type",
  "notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ARRAY": "Communication type must be an array.",
  "notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ENUM": "Invalid communication type.",
  "notification.error.TOO_MANY_REQUESTS": "Too many requests, please wait and try again",
  "notification.error.ERROR_COMMUNICATION_TYPES_MUST_BE_ARRAY": "Communication types must be an array.",
  "notification.error.ERROR_COMMUNICATION_TYPES_REQUIRED": "Communication types are required.",
  "notification.error.ERROR_SEND_QUOTE_TO_CLIENT": "Failed to send quote to client",
  "notification.error.ERROR_SEND_QUOTE_TO_CLIENT_INVALID_FORMAT": "Invalid format for provided send quote to client",
  "notification.error.ERROR_INVITATION_NOT_FOUND": "Invitation not found",
  "notification.error.ERROR_INVITATION_ID_REQUIRED": "Invitation id is required",
  "notification.error.ERROR_INVITATION_ID_INVALID": "Invitation id is invalid",
  "notification.error.ERROR_INVITATION_ID_INVALID_FORMAT": "Invitation id is not in a correct format",
  "notification.error.ERROR_IDS_INVALID_ARRAY": "Provided ids not an array",
  "notification.error.ERROR_INVALID_ACCESSORIES_VALUE": "Invalid accessories value",
  "notification.error.ERROR_INVALID_PRICE": "Invalid price",
  "notification.error.ERROR_DATE_NOT_IN_FUTUR": "Provided date is not in futur",
  "notification.error.ERROR_DANGER_LEVEL_INVALID_TYPE": "Invalid type for provided danger level",
  "notification.error.ERROR_BIKE_MODEL_INVALID_FORMAT": "Invalid format for provided bike model",
  "notification.error.ERROR_DATE_NOT_IN_PAST": "Provided date should not be in the past",
  "notification.error.ERROR_CLAIM_ID_INVALID_FORMAT": "Claim id is not in a correct format",
  "notification.error.ERROR_CLAIM_ID_REQUIRED": "Claim id is required",
  "notification.error.ERROR_DOCUMENT_UUID_REQUIRED": "Document uuid is required",
  "notification.error.ERROR_DOCUMENT_UUID_INVALID_FORMAT": "Document uuid is not in a correct format",
  "notification.error.ERROR_B2B_CLAIM_DOES_NOT_EXIST": "B2B claim does not exist",
  "notification.error.ERROR_NO_CLAIM_LINKED_TO_POLICY_OR_GROUP": "No claim linked to policy or group",
  "notification.error.ERROR_STATUS_REQUIRED": "Status is required",
  "notification.error.ERROR_BIKE_ELEMENTS_IS_REQUIRED_WHEN_THEFT_PARTIAL_OR_DAMAGE_PARTIAL": "Bike elements are required when theft partial or damage partial",
  "notification.error.ERROR_IS_FRAUD_INVALID_FORMAT": "Invalid format for provided is fraud",
  "notification.error.ERROR_INVALID_PACKAGE": "Invalid package",
  "notification.error.ERROR_GROUP_REQUIRED": "Group is required",
  "notification.error.ERROR_GROUP_INVALID_FORMAT": "Invalid format for provided group",
  "notification.error.ERROR_DURATION_REQUIRED": "No usage provided",
  "notification.error.ERROR_DURATION_MUST_BE_GREATER_THAN_ONE": "Duration must be greater than 1",
  "notification.error.ERROR_TIME_PERIOD_REQUIRED": "Time period is required",
  "notification.error.ERROR_TIME_PERIOD_INVALID_TYPE": "Invalid type for provided time period",
  "notification.error.ERROR_END_DATE_INVALID_FORMAT": "Invalid format for provided end date",
  "notification.error.ERROR_PARTNER_INVALID_FORMAT": "Invalid format for provided partner",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_REQUIRED": "Pricing rules per coverage is required",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_EMPTY": "Pricing rules per coverage cannot be empty",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_FORMAT": "Invalid format for provided pricing rules per coverage",
  "notification.error.ERROR_FILE_TYPE_INVALID_FORMAT": "Invalid format for provided file type",
  "notification.error.ERROR_FILE_TYPE_INVALID_EXTENSION": "Invalid file extension",
  "notification.error.ERROR_TEMPLATE_INVALID_FORMAT": "Invalid format for provided template",
  "notification.error.ERROR_EMPTY_BODY_REQUIRED": "Empty body check is required",
  "notification.error.ERROR_VALID_END_DATE_REQUIRED": "A valid end date is required",
  "notification.error.ERROR_VALID_END_DATE_INVALID_FORMAT": "Invalid format for provided valid end date",
  "notification.error.ERROR_CONTRACT_REQUIRED": "No contract provided",
  "notification.error.ERROR_CONTRACT_INVALID_FORMAT": "Invalid format for provided contract",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_REQUIRED": "Claim occurence period start is required",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_REQUIRED": "Claim occurence period end is required",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSIONS_ID_INVALID_FORMAT": "Invalid format for provided personal locking sessions id",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_TYPE": "Invalid type for provided premium support type",
  "notification.error.ERROR_LOCKING_SESSIONS_ID_INVALID_FORMAT": "Invalid format for provided locking sessions id",
  "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_REQUIRED": "Remain to pay not recovered is required",
  "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_INVALID_FORMAT": "Invalid format for provided remain to pay not recovered",
  "notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_NUMBER": "Invalid format for provided to be reimbursed group",
  "notification.error.ERROR_CLAIM_PAID_GROUP_NOT_POSITIVE": "Claim paid group must be positive",
  "notification.error.ERROR_CLAIM_PAID_GROUP_NOT_NUMBER": "Invalid format for provided claim paid group",
  "notification.error.ERROR_SUPPORT_AMOUNT_NOT_POSITIVE": "Support amount must be positive",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_POSITIVE": "Bike claim amount must be positive",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_NUMBER": "Invalid format for provided bike claim amount",
  "notification.error.ERROR_GROSS_AMOUNT_NOT_POSITIVE": "Gross amount must be positive",
  "notification.error.ERROR_GROSS_AMOUNT_NOT_NUMBER": "Invalid format for provided gross amount",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE": "To be recovered amount group must be positive",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_GROUP_NOT_NUMBER": "Invalid format for provided to be recovered amount group",
  "notification.error.ERROR_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE": "Recovered amount group must be positive",
  "notification.error.ERROR_RECOVERED_AMOUNT_GROUP_NOT_NUMBER": "Invalid format for provided recovered amount group",
  "notification.error.ERROR_FRANCHISE_AMOUNT_NOT_POSITIVE": "Franchise amount must be positive",
  "notification.error.ERROR_FRANCHISE_AMOUNT_NOT_NUMBER": "Invalid format for provided franchise amount",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_POSITIVE": "Franchise percentage must be positive",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_NUMBER": "Invalid format for provided franchise percentage",
  "notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_POSITIVE": "To be reimbursed group must be positive",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_INVALID_FORMAT": "Invalid format for provided claim occurence period start",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_INVALID_FORMAT": "Invalid format for provided claim occurence period end",
  "notification.error.ERROR_PACKAGE_NOT_ACTIVE": "Package is not active",
  "notification.error.ERROR_PACKAGE_INVALID_FORMAT": "Invalid format for provided package",
  "notification.error.ERROR_CHOOSEN_PACKAGES_REQUIRED": "No choosen package provided",
  "notification.error.ERROR_AFFECTED_USERS_INVALID_ARRAY": "Invalid array for provided affected users",
  "notification.error.ERROR_ACCESSORY_STEP_INVALID_FORMAT": "Invalid format for provided accessory step",
  "notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_FORMAT": "Invalid format for provided optional coverages",
  "notification.error.ERROR_EFFECTIVE_DATE_INVALID_FORMAT": "Invalid format for provided effective date",
  "notification.error.ERROR_EFFECTIVE_DATE_IN_THE_FUTURE": "Provided effective date is in the futur",
  "notification.error.ERROR_DURATION_TOO_LOW": "Provided value for duration is too low",
  "notification.error.ERROR_DURATION_INVALID_FORMAT": "Invalid format for provided duration",
  "notification.error.ERROR_USAGE_INVALID_TYPE": "Invalid value for provided usage",
  "notification.error.ERROR_PAYMENT_METHODS_INVALID_TYPE": "Invalid value for provided payment methods",
  "notification.error.ERROR_SPLITTING_REQUIRED": "No splitting provided",
  "notification.error.ERROR_SPLITTING_INVALID_TYPE": "Invalid value for provided splitting",
  "notification.error.ERROR_PARTNER_PAY_INVALID_FORMAT": "Invalid format for provided partner pay",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_FORMAT": "Invalid format for provided auto renewal",
  "notification.error.ERROR_MODEL_BRAND_OR_BIKE_MODEL_REQUIRED": "A brand and model or a bike model must be provided",
  "notification.error.ERROR_ACCESSORIES_VALUE_TOO_LOW": "Provided value for accessories value is too low",
  "notification.error.ERROR_ACCESSORIES_VALUE_INVALID_FORMAT": "Invalid format for provided accessories value",
  "notification.error.ERROR_COUNT_INVALID_FORMAT": "Invalid format for provided count",
  "notification.error.ERROR_FULL_REQUIRED": "No full provided",
  "notification.error.ERROR_OPT_IN_INVALID_FORMAT": "Invalid format for provided opt-in",
  "notification.error.ERROR_CLIENT_IS_UNDERAGE": "Provided birthday is too high",
  "notification.error.ERROR_MONTH_MUST_BE_GREATER_THAN_ONE": "Month must be greater than 1",
  "notification.error.ERROR_MONTH_MUST_BE_LESS_THAN_TWELVE": "Month must be less than 12",
  "notification.error.ERROR_COVERAGE_REQUIRED": "No coverage provided",
  "notification.error.ERROR_COVERAGE_INVALID_FORMAT": "Invalid format for provided coverage",
  "notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_ARRAY": "Invalid array for provided coverage",
  "notification.error.ERROR_PERCENTAGE_REQUIRED": "Percentage is required",
  "notification.error.ERROR_PERCENTAGE_INVALID_FORMAT": "Invalid format for provided percentage",
  "notification.error.ERROR_FIXED_AMOUNT_WITH_PERCENTAGE": "Cannot set fixed amount when percentage is set",
  "notification.error.ERROR_PERCENTAGE_WITH_FIXED_AMOUNT": "Cannot set percentage when fixed amount is set",
  "notification.error.ERROR_FIXED_AMOUNT_REQUIRED": "Fixed amount is required",
  "notification.error.ERROR_FIXED_AMOUNT_INVALID_FORMAT": "Invalid format for provided fixed amount",
  "notification.error.ERROR_AMOUNT_TYPE_REQUIRED": "Amount type is required",
  "notification.error.ERROR_AMOUNT_TYPE_INVALID_TYPE": "Invalid type for provided amount type",
  "notification.error.ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_ONE": "Policy year must be greater than 1",
  "notification.error.ERROR_POLICY_YEAR_REQUIRED": "Policy year is required",
  "notification.error.ERROR_POLICY_YEAR_INVALID_FORMAT": "Invalid format for provided policy year",
  "notification.error.ERROR_COMMISSIONS_INVALID_ARRAY": "Commissions must be an array.",
  "notification.error.ERROR_COMMISSIONS_INVALID_FORMAT": "Invalid format for provided commissions",
  "notification.error.ERROR_POLICY_ID_REQUIRED": "Policy id is required",
  "notification.error.ERROR_POLICY_ID_INVALID_FORMAT": "Policy id is not in a correct format",
  "notification.error.ERROR_POLICY_NOT_FOUND": "Policy not found",
  "notification.error.ERROR_VEHICLES_ID_INVALID_ARRAY": "Vehicles ids is not in a correct format",
  "notification.error.ERROR_VEHICLES_ID_REQUIRED": "Vehicles id is required",
  "notification.error.ERROR_VEHICLES_IDS": "Vehicles ids does not exist",
  "notification.error.ERROR_COMMENT_LENGHT_1_255": "Comment must be between 1 and 255 characters",
  "notification.error.ERROR_B2B_POLICY_STATUS": "Wrong Policy status",
  "notification.error.ERROR_TOO_OLD_POLICIES_TO_RETRACT": "Policy is too old to retract",
  "notification.error.ERROR_WRONG_POLICY_DURATION": "Policy duration is wrong",
  "notification.error.ERROR_B2B_CONTRACT_NOT_VALID": "Contract is not valid",
  "notification.error.CREATE_AMEND_ERROR": "Error creating amendment",
  "notification.error.ERROR_NAME_INVALID_LENGTH": "Name must be between 2 and 50 characters",
  "notification.error.ERROR_CONTRACTUAL_DOCUMENT_DOES_NOT_EXIST": "Contractual document does not exist",
  "notification.error.ERROR_EXPIRED_INVALID_FORMAT": "Expired must be in a correct format",
  "notification.error.ERROR_COVERAGES_INVALID_FORMAT": "Coverages must be in a correct format",
  "notification.error.ERROR_COVERAGES_INVALID_ARRAY": "Coverages must be an array",
  "notification.error.INVALID_TRAD_CODE": "Invalid trad code",
  "notification.error.ERROR_INVALID_COVERAGE_CODE": "Invalid coverage code",
  "notification.error.ERROR_MISS_FLEET_NAME": "Fleet name is required",
  "notification.error.ERROR_MISS_FLEET_ID": "Fleet id is required",
  "notification.error.ERROR_FLEET_ID_INVALID_FORMAT": "Fleet id is not in a correct format",
  "notification.error.ERROR_FLEET_ID_INVALID": "Fleet id is invalid",
  "notification.error.ERROR_VEHICLES_IDADDED_INVALID_FORMAT": "Vehicles id added is not in a correct format",
  "notification.error.ERROR_VEHICLES_IDADDED_INVALID_ARRAY": "Vehicles id added is not an array",
  "notification.error.ERROR_VEHICLES_IDDELETED_INVALID_FORMAT": "Vehicles id deleted is not in a correct format",
  "notification.error.ERROR_VEHICLES_IDDELETED_INVALID_ARRAY": "Vehicles id deleted is not an array",
  "notification.error.ERROR_AT_LEAST_ONE_FIELD_REQUIRED": "At least one field is required",
  "notification.error.ERROR_VEHICLES_NOT_GROUP": "Vehicles are not in the group",
  "notification.error.ERROR_LOW_MISSING": "Low value not found",
  "notification.error.ERROR_LOW_LOWER_THAN_ZERO": "Low value has to be between 0 and 1",
  "notification.error.ERROR_LOW_GREATER_THAN_ONE": "Low value has to be between 0 and 1",
  "notification.error.ERROR_LOW_INVALID_NUMBER": "Low value has to be a valid number",
  "notification.error.ERROR_MEDIUM_MISSING": "Medium value not found",
  "notification.error.ERROR_MEDIUM_LOWER_THAN_ZERO": "Medium value has to be between 0 and 1",
  "notification.error.ERROR_MEDIUM_GREATER_THAN_ONE": "Medium value has to be between 0 and 1",
  "notification.error.ERROR_MEDIUM_INVALID_NUMBER": "Medium value has to be a valid number",
  "notification.error.ERROR_MEDIUM_LOWER_THAN_LOW": "Medium value has to be a greater than low value",
  "notification.error.ERROR_HIGH_MISSING": "High value not found",
  "notification.error.ERROR_HIGH_LOWER_THAN_ZERO": "High value has to be between 0 and 1",
  "notification.error.ERROR_HIGH_GREATER_THAN_ONE": "High value has to be between 0 and 1",
  "notification.error.ERROR_HIGH_INVALID_NUMBER": "High value has to be a valid number",
  "notification.error.ERROR_HIGH_LOWER_THAN_MEDIUM": "High value has to be a greater than medium value",
  "notification.error.NO_FRAUD_WEIGHT_FOUND": "Fraud weight not found",
  "notification.error.ERROR_LAT_REQUIRED": "Latitude is required",
  "notification.error.ERROR_LONG_REQUIRED": "Longitude is required",
  "notification.error.ERROR_DANGEROSITY_INVALID_TYPE": "Dangerosity must be in a correct format",
  "notification.error.ERROR_LAT_DELTA_REQUIRED": "Latitude delta is required",
  "notification.error.ERROR_LAT_DELTA_INVALID_FORMAT": "Latitude delta must be in a correct format",
  "notification.error.ERROR_LONG_DELTA_REQUIRED": "Longitude delta is required",
  "notification.error.ERROR_LONG_DELTA_INVALID_FORMAT": "Longitude delta must be in a correct format",
  "notification.error.ERROR_LAT_DELTA_TOO_HIGH": "Latitude delta must be less than 0.2",
  "notification.error.ERROR_LONG_DELTA_TOO_HIGH": "Longitude delta must be less than 0.2",
  "notification.error.ERROR_ZONES_REQUIRED": "Zones are required",
  "notification.error.ERROR_ZONES_INVALID_ARRAY": "Zones must be an array",
  "notification.error.ERROR_LAT_LONG_INVALID_FORMAT": "Latitude and longitude must be in a correct format",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_REQUIRED": "To be recovered amount for user is required",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_INVALID_FORMAT": "To be recovered amount for user must be in a correct format",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_TOO_LOW": "To be recovered amount for user must be greater than 0",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_REQUIRED": "To be recovered amount for partner is required",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT": "To be recovered amount for partner must be in a correct format",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_TOO_LOW": "To be recovered amount for partner must be greater than 0",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_REQUIRED": "Occurrence period start is required",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_FORMAT": "Occurrence period start must be in a correct format",
  "notification.error.ERROR_OCCURENCE_PERIOD_END_INVALID_DATE": "Occurrence period end must be in a correct format",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_DATE": "Occurrence period start must be in a correct format",
  "notification.error.ERROR_PERIOD_START_GREATER_THAN_PERIOD_END": "Occurrence period start must be before the end",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_REQUIRED": "Occurrence period end is required",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_FORMAT": "Occurrence period end must be in a correct format",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_NUMBER": "Personal locking session id must be in a correct format",
  "notification.error.ERROR_PREMIUM_SUPPORT_INVALID": "Premium support type is invalid",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_REQUIRED": "Premium support type is required",
  "notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_FORMAT": "Is culprit known must be in a correct format",
  "notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_NUMBER": "Personal lock id must be in a correct format",
  "notification.error.ERROR_AT_HOME_INVALID_FORMAT": "At home value must be in a correct format",
  "notification.error.ERROR_IS_BIKE_VAE_REQUIRED": "Is bike vae value is required",
  "notification.error.ERROR_IS_BIKE_VAE_INVALID_FORMAT": "Is bike vae value must be in a correct format",
  "notification.error.ERROR_IS_BATTERY_SAFE_INVALID_FORMAT": "Is battery safe value must be in a correct format",
  "notification.error.ERROR_TO_BE_REIMBURSED_USER_INVALID_FORMAT": "To be recovered amount for user must be in a correct format",
  "notification.error.ERROR_TO_BE_REIMBURSED_USER_TOO_LOW": "To be recovered amount for user must be greater than 0",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_INVALID_FORMAT": "To be recovered amount for partner must be in a correct format",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_TOO_LOW": "To be recovered amount for partner must be greater than 0",
  "notification.error.ERROR_FRANCHISE_AMOUNT_INVALID_FORMAT": "Franchise amount must be in a correct format",
  "notification.error.ERROR_FRANCHISE_AMOUNT_TOO_LOW": "Franchise amount must be greater than 0",
  "notification.error.ERROR_CLAIM_PAID_USER_INVALID_FORMAT": "Claim paid user must be in a correct format",
  "notification.error.ERROR_CLAIM_PAID_USER_TOO_LOW": "Claim paid user must be greater than 0",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_INVALID_FORMAT": "Claim paid partner must be in a correct format",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_TOO_LOW": "Claim paid partner must be greater than 0",
  "notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_INVALID_FORMAT": "Support claim amount must be in a correct format",
  "notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_TOO_LOW": "Support claim amount must be greater than 0",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_INVALID_FORMAT": "Bike claim amount must be in a correct format",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_TOO_LOW": "Bike claim amount must be greater than 0",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_INVALID_FORMAT": "Franchise percentage must be in a correct format",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_TOO_LOW": "Franchise percentage must be greater than 0",
  "notification.error.ERROR_PRICE_BEFORE_DEDUCTION_INVALID_FORMAT": "Price before deduction must be in a correct format",
  "notification.error.ERROR_PRICE_BEFORE_DEDUCTION_TOO_LOW": "Price before deduction must be greater than 0",
  "notification.error.ERROR_RECOVERED_AMOUNT_USER_INVALID_FORMAT": "Recovered amount for user must be in a correct format",
  "notification.error.ERROR_RECOVERED_AMOUNT_USER_TOO_LOW": "Recovered amount for user must be greater than 0",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT": "Recovered amount for partner must be in a correct format",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_TOO_LOW": "Recovered amount for partner must be greater than 0",
  "notification.error.ERROR_REAL_VALUE_INVALID_FORMAT": "Real value must be in a correct format",
  "notification.error.ERROR_REAL_VALUE_NEGATIVE": "Real value must be at least 0",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_INVALID_FORMAT": "Additional user amount must be in a correct format for user",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_NEGATIVE": "Additional user amount must be at least 0",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_REASON_REQUIRED": "Additional user amount reason is required",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_INVALID_FORMAT": "Additional partner amount must be in a correct format for partner",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_NEGATIVE": "Additional partner amount must be at least 0",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_REASON_REQUIRED": "Additional partner amount reason is required",
  "notification.error.ERROR_FIELD_TOUPDATE_REQUIRED": "Field to update is required",
  "notification.error.ERROR_FIXED_PARKING_LOCATION_CHECKED_INVALID_FORMAT": "Fixed parking location checked value must be in a correct format",
  "notification.error.ERROR_HAS_USER_BEEN_CALLED_INVALID_FORMAT": "Has user been called value must be in a correct format",
  "notification.error.ERROR_DECLARATION_CONSISTENT_INVALID_FORMAT": "Declaration consistent value must be in a correct format",
  "notification.error.ERROR_HAS_SHOP_BEEN_CALLED_INVALID_FORMAT": "Has shop been called value must be in a correct format",
  "notification.error.ERROR_IS_PLS_VALIDATED_INVALID_FORMAT": "Is pls validated value must be in a correct format",
  "notification.error.ERROR_CLAIM_DOES_NOT_EXIST": "Claim does not exist",
  "notification.error.ERROR_UNIQ_ID_REQUIRED": "Uniq id is required",
  "notification.error.ERROR_UNKNOWN_UNIQ_ID": "Unknown unique id",
  "notification.error.ERROR_FRANCHISE_INVALID_FORMAT": "Franchise value must be in a correct format",
  "notification.error.ERROR_CLAIMS_IDS_REQUIRED": "Claims ids are required",
  "notification.error.ERROR_CLAIM_ID_INVALID_TYPE": "Claim id must be in a correct format",
  "notification.error.ERROR_INVALID_CLAIM": "Invalid claim",
  "notification.error.ERROR_PARTNER_CLAIMS_NOT_AN_ARRAY": "Partner claims ids must be an array",
  "notification.error.ERROR_AMOUNT_REQUIRED": "Amount is required",
  "notification.error.ERROR_AMOUNT_INVALID_FORMAT": "Amount must be in a correct format",
  "notification.error.ERROR_LONG_INVALID_VALUE": "Long value must be in a correct format",
  "notification.error.ERROR_LAT_INVALID_VALUE": "Lat value must be in a correct format",
  "notification.error.ERROR_ADDRESS_INVALID_STRING": "Address must be in a correct format",
  "notification.error.ERROR_COVERAGE_CODE_INVALID_VALUE": "Coverage code must be in a correct format",
  "notification.error.ERROR_DESCRIPTION_INVALID_STRING": "Description must be in a correct format",
  "notification.error.ERROR_PARK_LOCATION_INVALID_STRING": "Park location must be in a correct format",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_VALUE": "Premium support type must be in a correct format",
  "notification.error.ERROR_BIKE_ELEMENTS_INVALID_STRING": "Bike elements must be in a correct format",
  "notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_BOOLEAN": "Is culprit known must be a boolean value",
  "notification.error.ERROR_OCCURED_AT_HOME_INVALID_BOOLEAN": "Occured at home must be a boolean value",
  "notification.error.ERROR_IS_BIKE_VAE_INVALID_BOOLEAN": "Is bike vae must be a boolean value",
  "notification.error.ERROR_IS_BATTERY_SAFE_INVALID_BOOLEAN": "Is battery safe must be a boolean value",
  "notification.error.IS_CULPRIT_KNOWN_NOT_GIVEN": "Is culprit known must be provided for vandalism claim",
  "notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_EXPECTED": "Premium support type must be provided for premium support claim",
  "notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_UNEXPECTED": "Premium support type must not be provided for non premium support claim",
  "notification.error.ERROR_PHOTO_INVALID_TYPE": "Photo must be in a correct format",
  "notification.error.ERROR_CLAIM_TYPE_REQUIRED": "Claim type is required",
  "notification.error.ERROR_CLAIM_TYPE_INVALID": "Invalid claim type",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_REQUIRED": "Required documents are required",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_INVALID": "Invalid required documents",
  "notification.error.ERROR_REQUIRED_AND_OPTIONAL_DOCUMENTS_OVERLAP": "Required and optional documents overlap",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_MUST_BE_ARRAY": "Required documents must be an array",
  "notification.error.ERROR_REQUIRED_DOCUMENT_TYPE_INVALID": "Invalid required document type",
  "notification.error.ERROR_OPTIONAL_DOCUMENTS_REQUIRED": "Optional documents are required",
  "notification.error.ERROR_OPTIONAL_DOCUMENTS_MUST_BE_ARRAY": "Optional documents must be an array",
  "notification.error.ERROR_OPTIONAL_DOCUMENT_TYPE_INVALID": "Invalid optional document type",
  "notification.error.ERROR_PARTNER_ID_MUST_BE_A_NUMBER": "Invalid format for provided partner id",
  "notification.error.ERROR_PERSONAL_LOCK_REQUIRED": "Personal lock is required",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_REQUIRED": "Insured value threshold is required",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_POSITIVE": "Insured value threshold must be positive",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_A_NUMBER": "Insured value threshold must be a number",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_REQUIRED": "Gross refundable amount threshold is required",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_POSITIVE": "Gross refundable amount threshold must be positive",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_A_NUMBER": "Gross refundable amount threshold must be a number",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_REQUIRED": "Mandatory ops checks are required",
  "notification.error.ERROR_MANDATORY_OPS_CHECK_TYPE_INVALID": "Invalid mandatory ops check type",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_MUST_BE_ARRAY": "Mandatory ops checks must be an array",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_REQUIRED": "Insured value ops checks are required",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECK_TYPE_INVALID": "Invalid insured value ops check type",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_MUST_BE_ARRAY": "Insured value ops checks must be an array",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_REQUIRED": "Gross refundable amount ops checks are required",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECK_TYPE_INVALID": "Invalid gross refundable amount ops check type",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_MUST_BE_ARRAY": "Gross refundable amount ops checks must be an array",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_REQUIRED": "Fraud ops checks are required",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_TYPE_INVALID": "Invalid fraud ops checks type",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_MUST_BE_ARRAY": "Fraud ops checks must be an array",
  "notification.error.ERROR_PLS_DURATION_REQUIRED": "PLS duration is required",
  "notification.error.ERROR_PLS_DURATION_INVALID_FORMAT": "Invalid PLS duration format",
  "notification.error.ERROR_DEPRIVATION_DURATION_REQUIRED": "Deprivation duration is required",
  "notification.error.ERROR_DEPRIVATION_DURATION_INVALID_FORMAT": "Invalid deprivation duration format",
  "notification.error.ERROR_CONTRACT_TEMPLATE_REQUIRED": "Contract template is required",
  "notification.error.ERROR_MAIL_AT_CREATION_ID_REQUIRED": "Mail at creation ID is required",
  "notification.error.ERROR_MAIL_AT_CREATION_ID_INVALID_FORMAT": "Invalid mail at creation ID format",
  "notification.error.ERROR_MAIL_AT_END_ID_INVALID_FORMAT": "Invalid mail at end ID format",
  "notification.error.ERROR_MAIL_AT_END_UNPAID_ID_INVALID_FORMAT": "Invalid mail at end unpaid ID format",
  "notification.error.ERROR_DISPLAY_POLICY_INFORMATIONS_REQUIRED": "Display policy informations is required",
  "notification.error.ERROR_PLS_WITH_TOTAL_CLAIM_ALLOWED_REQUIRED": "PLS with total claim allowed is required",
  "notification.error.ERROR_PLS_ALLOWED_INVALID_FORMAT": "Invalid PLS allowed format",
  "notification.error.ERROR_PLS_DURATION_MUST_A_NUMBER": "PLS duration must be a number",
  "notification.error.ERROR_PLS_DURATION_MUST_0_AT_LEAST": "PLS duration must be at least 0",
  "notification.error.ERROR_DEPRIVATION_DURATION_MUST_A_NUMBER": "Deprivation duration must be a number",
  "notification.error.ERROR_DEPRIVATION_DURATION_MUST_0_AT_LEAST": "Deprivation duration must be at least 0",
  "notification.error.ERROR_MAIL_ID_INVALID_FORMAT": "Invalid mail ID format",
  "notification.error.ERROR_EMPTY_BODY": "Empty body",
  "notification.error.ERROR_PACKAGE_ID_MUST_A_BE_NUMBER": "Package ID must be a number",
  "notification.error.ERROR_OPTIONAL_CHECKS_REQUIRED": "Optional checks are required",
  "notification.error.ERROR_NOT_OPTIONNAL_CHECK": "Not optional check",
  "notification.error.ERROR_OPTIONAL_CHECKS_INVALID_ARRAY": "Invalid optional checks array",
  "notification.error.ERROR_VEHICLE_OWNER_REQUIRED": "Vehicle owner is required",
  "notification.error.ERROR_VEHICLE_OWNER_NOT_BOOL": "Vehicle owner must be a boolean",
  "notification.error.ERROR_MAIL_ID_MUST_A_BE_NUMBER": "Mail ID must be a number",
  "notification.error.ERROR_THRESHOLD_MUST_A_BE_NUMBER": "Threshold must be a number",
  "notification.error.ERROR_MAIL_ID_MUST_A_NUMBER": "Mail ID must be a number",
  "notification.error.ERROR_IDS_INVALID_TYPE": "Invalid IDs type",
  "notification.error.ERROR_PARTNER_ESTIMATION_UNDEFINED": "Partner estimation is undefined",
  "notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID_ARRAY": "Invalid partner estimations rule array",
  "notification.error.ERROR_PARTNER_ESTIMATION_VALUES_EMPTY": "Partner estimation values are empty",
  "notification.error.ERROR_PARTNER_ESTIMATION_INVALID_TYPE": "Invalid partner estimation type",
  "notification.error.ERROR_USER_ESTIMATION_UNDEFINED": "User estimation is undefined",
  "notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID_ARRAY": "Invalid user estimations rule array",
  "notification.error.ERROR_USER_ESTIMATION_VALUES_EMPTY": "User estimation values are empty",
  "notification.error.ERROR_USER_ESTIMATION_INVALID_TYPE": "Invalid user estimation type",
  "notification.error.ERROR_FRANCHISE_RULE_UNDEFINED": "Franchise rule is undefined",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID_ARRAY": "Invalid franchise rule array",
  "notification.error.ERROR_FRANCHISE_RULE_VALUES_EMPTY": "Franchise rule values are empty",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID_TYPE": "Invalid franchise rule type",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_UNDEFINED": "Partner reimbursement is undefined",
  "notification.error.ERROR_PARTNER_REIMBURSMENT_RULE_INVALID_ARRAY": "Invalid partner reimbursement rule array",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_VALUES_EMPTY": "Partner reimbursement values are empty",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_INVALID_TYPE": "Invalid partner reimbursement type",
  "notification.error.ERROR_USER_REIMBURSEMENT_UNDEFINED": "User reimbursement is undefined",
  "notification.error.ERROR_CLIENT_REIMBURSMENT_RULE_INVALID_ARRAY": "Invalid client reimbursement rule array",
  "notification.error.ERROR_USER_REIMBURSEMENT_VALUES_EMPTY": "User reimbursement values are empty",
  "notification.error.ERROR_USER_REIMBURSEMENT_INVALID_TYPE": "Invalid user reimbursement type",
  "notification.error.ERROR_CLAIM_TYPE_UNDEFINED": "Claim type is undefined",
  "notification.error.ERROR_CLAIM_TYPE_INVALID_TYPE": "Invalid claim type",
  "notification.error.ERROR_WITH_PLS_UNDEFINED": "With PLS is undefined",
  "notification.error.ERROR_WITH_PLS_INVALID_TYPE": "Invalid with PLS type",
  "notification.error.ERROR_HAS_BATTERY_UNDEFINED": "Has battery is undefined",
  "notification.error.ERROR_HAS_BATTERY_INVALID_TYPE": "Invalid has battery type",
  "notification.error.ERROR_BIKE_MODEL_MUST_BE_A_NUMBER": "Bike model must be a number",
  "notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID": "Invalid partner estimations rule",
  "notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID": "Invalid user estimations rule",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID": "Invalid franchise rule",
  "notification.error.ERROR_PARTNER_REIMBURSMENT_RULE_INVALID": "Invalid partner reimbursement rule",
  "notification.error.ERROR_CLIENT_REIMBURSMENT_RULE_INVALID": "Invalid client reimbursement rule",
  "notification.error.ERROR_MANDATORY_CHECKS_UNDEFINED": "Mandatory checks are undefined",
  "notification.error.ERROR_MANDATORY_CHECKS_INVALID_TYPE": "Invalid mandatory checks type",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_INVALID_ARRAY": "Invalid mandatory ops checks array",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_UNDEFINED": "Insured value checks are undefined",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_INVALID_TYPE": "Invalid insured value checks type",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_INVALID_ARRAY": "Invalid insured value ops checks array",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_UNDEFINED": "Fraud ops checks are undefined",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_TYPE": "Invalid fraud ops checks type",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_ARRAY": "Invalid fraud ops checks array",
  "notification.error.ERROR_VALUE_THESHOLD_UNDEFINED": "Value threshold is undefined",
  "notification.error.ERROR_VALUE_THRESHOLD_INVALID_TYPE": "Invalid value threshold type",
  "notification.error.ERROR_VALUE_THRESHOLD_INVALID": "Invalid value threshold",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_UNDEFINED": "Gross refundable amount threshold is undefined",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID_TYPE": "Invalid gross refundable amount threshold type",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID": "Invalid gross refundable amount threshold",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_UNDEFINED": "Gross refundable amount ops checks are undefined",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_TYPE": "Invalid gross refundable amount ops checks type",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_ARRAY": "Invalid gross refundable amount ops checks array",
  "notification.error.ERROR_REQUIRED_DOCS_UNDEFINED": "Required docs are undefined",
  "notification.error.ERROR_REQUIRED_DOCS_INVALID_TYPE": "Invalid required docs type",
  "notification.error.ERROR_REQUIRED_DOCS_INVALID_ARRAY": "Invalid required docs array",
  "notification.error.ERROR_OPTIONAL_DOCS_UNDEFINED": "Optional docs are undefined",
  "notification.error.ERROR_OPTIONAL_DOCS_INVALID_TYPE": "Invalid optional docs type",
  "notification.error.ERROR_OPTIONAL_DOCS_INVALID_ARRAY": "Invalid optional docs array",
  "notification.error.ERROR_LOCK_REQUIRED_INVALID_FORMAT": "Invalid lock required format",
  "notification.error.ERROR_MARKING_CODE_REQUIRED_INVALID_FORMAT": "Invalid marking code required format",
  "notification.error.ERROR_APIC_CHECK_INVALID_FORMAT": "Invalid APIC check format",
  "notification.error.ERROR_REPAID_QUOTE_INVALID_FORMAT": "Invalid repaid quote format",
  "notification.error.ERROR_REIMBURSEMENT_LIMIT_INVALID_FORMAT": "Invalid reimbursement limit format",
  "notification.error.ERROR_ALREADY_REIMURSEMENT_CHECK_INVALID_FORMAT": "Invalid already reimbursement check format",
  "notification.error.ERROR_NOTIFY_PARTNER_INVALID_FORMAT": "Invalid notify partner format",
  "notification.error.ERROR_APPLY_FRAUD_TAG_INVALID_FORMAT": "Invalid apply fraud tag format",
  "notification.error.ERROR_TOTAL_TERMINATE_POLICY_INVALID_FORMAT": "Invalid total terminate policy format",
  "notification.error.ERROR_USER_NOTIFY_PARTNER_INVALID_FORMAT": "Invalid user notify partner format",
  "notification.error.ERROR_BIKE_OBSO_INVALID_FORMAT": "Invalid bike obsolescence format",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_0_AT_LEAST": "Bike obsolescence must be at least 0",
  "notification.error.ERROR_BIKE_OBSO_PERCENTAGE_INVALID_FORMAT": "Invalid bike obsolescence percentage format",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_0_AT_LEAST": "Bike obsolescence percentage must be at least 0",
  "notification.error.ERROR_BIKE_OBSO_LIMIT_INVALID_FORMAT": "Invalid bike obsolescence limit format",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_LIMIT_0_AT_LEAST": "Bike obsolescence limit must be at least 0",
  "notification.error.ERROR_ALLOWED_PARTIAL_INVALID_FORMAT": "Invalid allowed partial format",
  "notification.error.ERROR_BIKE_ALLOWED_PARTIAL_MIN_ONE_AT_LEAST": "Bike allowed partial must be at least -1",
  "notification.error.ERROR_CREATION_MAIL_ID_INVALID_FORMAT": "Invalid creation mail ID format",
  "notification.error.ERROR_REJECTED_MAIL_ID_INVALID_FORMAT": "Invalid rejected mail ID format",
  "notification.error.ERROR_ABANDON_MAIL_ID_INVALID_FORMAT": "Invalid abandon mail ID format",
  "notification.error.ERROR_TO_PAY_MAIL_ID_INVALID_FORMAT": "Invalid to pay mail ID format",
  "notification.error.ERROR_VALIDATED_MAIL_ID_INVALID_FORMAT": "Invalid validated mail ID format",
  "notification.error.ERROR_PAID_MAIL_ID_INVALID_FORMAT": "Invalid paid mail ID format",
  "notification.error.ERROR_PERSONAL_LOCK_INVALID_FORMAT": "Invalid format for provided personal lock",
  "notification.error.ERROR_MARKING_CODE_CHECK_REQUIRED": "Marking code check is required",
  "notification.error.ERROR_MARKING_CODE_CHECK_INVALID_FORMAT": "Invalid format for provided marking code check",
  "notification.error.ERROR_APIC_CHECK_REQUIRED": "Apic check is required",
  "notification.error.ERROR_REPAIR_QUOTE_REQUIRED": "Repair quote is required",
  "notification.error.ERROR_REPAIR_QUOTE_INVALID_FORMAT": "Invalid format for provided repair quote",
  "notification.error.ERROR_ALL_OBSOLESCENCE_SETTINGS_REQUIRED": "All obsolescence settings are required",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_MUST_BE_POSITIVE": "Bike obsolescence start must be positive",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_INVALID_FORMAT": "Invalid format for provided bike obsolescence start",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_POSITIVE": "Bike obsolescence percentage per month must be positive",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_THAN_100": "Bike obsolescence percentage per month must be less than 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_INVALID_FORMAT": "Invalid format for provided bike obsolescence percentage per month",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_POSITIVE": "Bike obsolescence percentage limit must be positive",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_THAN_100": "Bike obsolescence percentage limit must be less than 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_INVALID_FORMAT": "Invalid format for provided bike obsolescence percentage limit",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_REQUIRED": "Partial claim allowed count is required",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_INVALID_FORMAT": "Invalid format for provided partial claim allowed count",
  "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_REQUIRED": "Should limit reimbursement to insured value is required",
  "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_INVALID_FORMAT": "Invalid format for provided should limit reimbursement to insured value",
  "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_REQUIRED": "Should check already reimbursed amounts is required",
  "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_INVALID_FORMAT": "Invalid format for provided should check already reimbursed amounts",
  "notification.error.ERROR_SHOULD_NOTIFY_PARTNER_REQUIRED": "Should notify partner is required",
  "notification.error.ERROR_SHOULD_NOTIFY_PARTNER_INVALID_FORMAT": "Invalid format for provided should notify partner",
  "notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_REQUIRED": "Should apply fraud tag is required",
  "notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_INVALID_FORMAT": "Invalid format for provided should apply fraud tag",
  "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_REQUIRED": "Should total paid terminate policy is required",
  "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_INVALID_FORMAT": "Invalid format for provided should total paid terminate policy",
  "notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_REQUIRED": "Should user notify partner is required",
  "notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_INVALID_FORMAT": "Invalid format for provided should user notify partner",
  "notification.error.ERROR_CLAIM_CREATION_MAIL_ID_INVALID_FORMAT": "Invalid format for provided claim creation mail id",
  "notification.error.ERROR_VALIDATED_ON_QUOTE_MAIL_ID_INVALID_FORMAT": "Invalid format for provided validated on quote mail id",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_ARRAY": "Invalid array for provided document parameters",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_OBJECT": "Invalid object for provided document parameters",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_OBJECT": "Invalid object for provided ops checks parameters",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_ARRAY": "Invalid array for provided reimbursement parameters",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_OBJECT": "Invalid object for provided reimbursement parameters",
  "notification.error.ERROR_DOCS_ID_REQUIRED": "No docs id provided",
  "notification.error.ERROR_DOCS_ID_INVALID_FORMAT": "Invalid format for provided docs id",
  "notification.error.ERROR_CHECKS_ID_REQUIRED": "No checks id provided",
  "notification.error.ERROR_CHECKS_ID_INVALID_FORMAT": "Invalid format for provided checks id",
  "notification.error.ERROR_REIMBURSEMENT_ID_REQUIRED": "No reimbursement id provided",
  "notification.error.ERROR_REIMBURSEMENT_ID_INVALID_FORMAT": "Invalid format for provided reimbursement id",
  "notification.error.ERROR_PACKAGE_REQUIRED": "No package provided",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_UNDEFINED": "No insured value threshold provided",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID_TYPE": "Invalid type for provided insured value threshold",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID": "Invalid insured value threshold",
  "notification.error.ERROR_PARTNER_INVOICES_ID_REQUIRED": "Partner invoice id is required",
  "notification.error.ERROR_PARTNER_INVOICES_ID_INVALID_FORMAT": "Partner invoice id has to be a valid number",
  "notification.error.ERROR_PARTNER_INVOICES_STATUS_REQUIRED": "Partner invoice status is required",
  "notification.error.ERROR_NO_RECEIPTS_CREATED": "No receipts found with status INVOICE_CREATED",
  "notification.error.ERROR_INVALID_STATUS": "Invalid partner invoice status",
  "notification.error.ERROR_URI_REQUIRED": "No uri provided",
  "notification.error.ERROR_URI_INVALID_FORMAT": "Invalid format for provided uri",
  "notification.error.ERROR_PATH_REQUIRED": "No path provided",
  "notification.error.ERROR_PATH_INVALID_FORMAT": "Invalid format for provided path",
  "notification.error.ERROR_BUFFER_REQUIRED": "No buffer provided",
  "notification.error.ERROR_MIMETYPE_REQUIRED": "No mimetype provided",
  "notification.error.ERROR_MIMETYPE_INVALID_FORMAT": "Invalid format for provided mimetype",
  "notification.error.ERROR_MIMETYPE_INVALID_EXTENSION": "Invalid mimetype extension",
  "notification.error.ERROR_START_PICTURE_REQUIRED": "Start picture is required",
  "notification.error.ERROR_FEEDBACK_REQUIRED": "Feedback is required",
  "notification.error.ERROR_FEEDBACK_INVALID_FORMAT": "Invalid format for provided feedback",
  "notification.error.ERROR_PERSONAL_LOCK_DOES_NOT_EXIST": "Provided personal lock does not exist",
  "notification.error.ERROR_POLICY_REQUIRED": "No policy provided",
  "notification.error.ERROR_POLICY_DOES_NOT_EXIST": "Provided policy does not exist",
  "notification.error.ERROR_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST": "Provided policy cancel request does not exist",
  "notification.error.ERROR_PRICE_WITHOUT_TAXES_REQUIRED": "No price without taxes provided",
  "notification.error.ERROR_PRICE_WITHOUT_TAXES_INVALID_FORMAT": "Invalid format for provided price without taxes",
  "notification.error.ERROR_PRICE_WITH_TAXES_REQUIRED": "No price with taxes provided",
  "notification.error.ERROR_PRICE_WITH_TAXES_INVALID_FORMAT": "Invalid format for provided price with taxes",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_REQUIRED": "No discounted price without taxes provided",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_INVALID_FORMAT": "Invalid format for provided dicounted price without taxes",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_REQUIRED": "No discounted price with taxes provided",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_INVALID_FORMAT": "Invalid format for provided discounted price with taxes",
  "notification.error.ERROR_TECHNICAL_PREMIUM_REQUIRED": "No technical premium provided",
  "notification.error.ERROR_TECHNICAL_PREMIUM_INVALID_FORMAT": "Invalid format for provided technical premium",
  "notification.error.ERROR_COMMISSION_REQUIRED": "No commission provided",
  "notification.error.ERROR_COMMISSION_INVALID_FORMAT": "Invalid format for provided commission",
  "notification.error.ERROR_SPLITTING_FEES_REQUIRED": "No splitting fees provided",
  "notification.error.ERROR_SPLITTING_FEES_INVALID_FORMAT": "Invalid format for provided splitting fees",
  "notification.error.ERROR_MANAGEMENT_FEES_REQUIRED": "No management fees provided",
  "notification.error.ERROR_MANAGEMENT_FEES_INVALID_FORMAT": "Invalid format for provided management fees",
  "notification.error.ERROR_TAXES_REQUIRED": "No taxes provided",
  "notification.error.ERROR_TAXES_INVALID_FORMAT": "Invalid format for provided taxes",
  "notification.error.ERROR_BROKER_FEES_REQUIRED": "No broker fees provided",
  "notification.error.ERROR_BROKER_FEES_INVALID_FORMAT": "Invalid format for provided broker fees",
  "notification.error.ERROR_INSURED_VALUE_REQUIRED": "Invalid format for provided coverage pricings",
  "notification.error.ERROR_INVOICE_ID_MUST_NOT_BE_EMPTY": "Invoice id must not be empty",
  "notification.error.ERROR_AMOUNT_TOO_LOW": "Amount must be greater than 0",
  "notification.error.ERROR_AMOUNT_MUST_BE_INTEGER": "Amount must be an integer",
  "notification.error.ERROR_IS_CANCEL_REQUIRED": "Is cancel is required",
  "notification.error.ERROR_INVALID_TERMINATION_DATE": "Termination date must be in a correct format",
  "notification.error.REASON_NOT_COMPATIBLE_WITH_TERMINATION_DATE": "Reason is not compatible with termination date",
  "notification.error.ERROR_USER_BIRTHDAY_REQUIRED": "User birthday is required",
  "notification.error.ERROR_USER_BIRTHDAYMILLIS_INVALID_FORMAT": "User birthday millis must be in a correct format",
  "notification.error.ERROR_WRONG_DOCUMENT_TYPE": "Wrong document type",
  "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_REQUIRED": "Policy effective start date is required",
  "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_INVALID_FORMAT": "Policy effective start date must be in a correct format",
  "notification.error.ERROR_PAST_EFFECTIVE_START_DATE": "Policy effective start date must be in the future",
  "notification.error.ERROR_SERIAL_REQUIRED": "Serial is required",
  "notification.error.ERROR_POLICY_TERMINATION_DATE_INVALID_FORMAT": "Policy termination date must be in a correct format",
  "notification.error.ERROR_DATE_IN_THE_PAST": "Date must be in today or in the future",
  "notification.error.TERMINATION_DATE_NOT_BETWEEN_POLICY_DATES": "Termination date must be between policy dates",
  "notification.error.TERMINATION_DATE_NOT_ALLOWED_FOR_MONTHLY_SPLITTING": "Termination date is not allowed for monthly splitting",
  "notification.error.ERROR_UNABLE_TO_ABORT_ACTIVE_POLICY": "Unable to abort active policy",
  "notification.error.ERROR_CANCEL_POLICY": "Cannot cancel policy",
  "notification.error.ERROR_B2B_USAGE_TYPE": "B2b Usage must be in a correct type",
  "notification.error.WRONG_TIME_PERIOD_TYPE": "Time period must be in a correct type",
  "notification.error.ERROR_PROMOTION_CODE_REQUIRED": "Promotion code is required",
  "notification.error.ERROR_BIKE_PRICE_REQUIRED": "Bike price is required",
  "notification.error.ERROR_CHOOSEN_PACKAGE_INVALID_FORMAT": "Choosen package must be in a correct format",
  "notification.error.NO_PACKAGE_CHOOSEN_YET": "No package choosen yet",
  "notification.error.ERROR_COVERAGE_PRICINGS_REQUIRED": "No coverage pricing provided",
  "notification.error.ERROR_APPLY_ZONING_REQUIRED": "No apply zoning provided",
  "notification.error.ERROR_APPLY_ZONING_INVALID_FORMAT": "Invalid format for provided apply zoning",
  "notification.error.ERROR_MIN_X_REQUIRED": "No min x provided",
  "notification.error.ERROR_MIN_X_TOO_LOW": "Min x must be greater than or equal to 0",
  "notification.error.ERROR_MIN_X_INVALID_FORMAT": "Invalid value for provided min x",
  "notification.error.ERROR_MAX_X_TOO_LOW": "Max x must be greater than or equal to 0 and greater than min x",
  "notification.error.ERROR_MAX_X_INVALID_FORMAT": "Invalid value for provided max x",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_REQUIRED": "No technical premium coefficients provided",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_EMPTY": "Technical premium coefficients cannot be empty",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_INVALID_FORMAT": "Invalid format for provided technical premium coefficients",
  "notification.error.ERROR_COMMISSION_COEFFS_REQUIRED": "No commission coefficients provided",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_REQUIRED": "No splitting fees coefficients provided",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_EMPTY": "Splitting fees coefficients cannot be empty",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_FORMAT": "Invalid format for provided splitting fees coefficients",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_ARRAY": "Splitting fees coefficients must be an array",
  "notification.error.ERROR_COMMISSION_COEFFS_EMPTY": "Commission coefficients cannot be empty",
  "notification.error.ERROR_COMMISSION_COEFFS_INVALID_FORMAT": "Invalid format for provided commission coefficients",
  "notification.error.ERROR_COMMISSION_COEFFS_INVALID_ARRAY": "Commission coefficients must be an array",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_REQUIRED": "No management fees coefficients provided",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_EMPTY": "Management fees coefficients cannot be empty",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_FORMAT": "Invalid format for provided management fees coefficients",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_ARRAY": "Management fees coefficients must be an array",
  "notification.error.ERROR_TAXE_RATE_REQUIRED": "No taxe rate provided",
  "notification.error.ERROR_TAXE_RATE_TOO_LOW": "Taxe rate must be greater than or equal to 0",
  "notification.error.ERROR_TAXE_RATE_INVALID_FORMAT": "Taxe rate must be in a correct format",
  "notification.error.ERROR_BROKER_FEES_COEFFS_REQUIRED": "No broker fees coefficients provided",
  "notification.error.ERROR_BROKER_FEES_COEFFS_EMPTY": "Broker fees coefficients cannot be empty",
  "notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_FORMAT": "Invalid format for provided broker fees coefficients",
  "notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_ARRAY": "Broker fees coefficients must be an array",
  "notification.error.ERROR_COVERAGE_ID_REQUIRED": "Coverage id is required",
  "notification.error.ERROR_COVERAGE_ID_INVALID_FORMAT": "Coverage id is not in a correct format",
  "notification.error.ERROR_PRICING_RULES_REQUIRED": "No pricing rules provided",
  "notification.error.ERROR_PRICING_RULES_EMPTY": "Pricing rules cannot be empty",
  "notification.error.ERROR_PRICING_RULES_INVALID_ARRAY": "Pricing rules must be an array",
  "notification.error.ERROR_PRICING_RULES_INVALID_FORMAT": "Invalid format for provided pricing rules",
  "notification.error.ERROR_CLIENT_REQUIRED": "No provided client",
  "notification.error.ERROR_PREMIUM_SPLITTING_INVALID_TYPE": "Invalid type for provided premium splitting",
  "notification.error.ERROR_DURATION_NOT_VALID": "Provided duration is invalid",
  "notification.error.ERROR_DURATION_INVALID_FOR_ANNUAL": "Invalid duration for annual splitting",
  "notification.error.ERROR_CALLBACK_INVALID_FORMAT": "Invalid format for provided callback",
  "notification.error.ERROR_VALUES_REQUIRED": "No values provided",
  "notification.error.ERROR_VALUES_INVALID_ARRAY": "Values must be an array",
  "notification.error.ERROR_VALUES_EMPTY": "Values cannot be empty",
  "notification.error.ERROR_VALUES_INVALID_FORMAT": "Invalid format for provided values",
  "notification.error.ERROR_PACKAGES_REQUIRED": "No packages provided",
  "notification.error.ERROR_PACKAGES_INVALID_ARRAY": "Packages must be an array",
  "notification.error.ERROR_PACKAGES_EMPTY": "Packages cannot be empty",
  "notification.error.ERROR_PACKAGES_INVALID_FORMAT": "Invalid format for provided packages",
  "notification.error.ERROR_ACTIVE_REQUIRED": "No active provided",
  "notification.error.ERROR_VEHICLE_DOES_NOT_EXIST": "Provided vehicle does not exist",
  "notification.error.ERROR_VEHICLES_REQUIRED": "No vehicles provided",
  "notification.error.ERROR_VEHICLES_INVALID_ARRAY": "Invalid array for provided vehicles",
  "notification.error.ERROR_BICYCODE_IDS_REQUIRED": "Bicycode ids are required",
  "notification.error.ERROR_BICYCODE_IDS_EMPTY": "Bicycode ids must not be empty",
  "notification.error.ERROR_BICYCODE_IDS_INVALID_ARRAY": "Invalid array for provided bicycode ids",
  "notification.error.ERROR_PURCHASE_PROOF_INVALID_TYPE": "Purchase proof must be in a correct type",
  "notification.error.ERROR_SERIAL_LENGTH_TOO_LONG": "Serial length must be less than 30 characters",
  "notification.error.ERROR_IS_ASSURED_INVALID_FORMAT": "Is assured must be in a correct format",
  "notification.error.ERROR_DOCUMENT_OBJECT_REQUIRED": "Document object is required",
  "notification.error.ERROR_DOCUMENT_OBJECT_INVALID_FORMAT": "Document object must be in a correct format",
  "notification.error.ERROR_INCLUDE_REQUIRED": "Include is required",
  "notification.error.ERROR_B2B_POLICY_OBJECT_REQUIRED": "B2b policy object is required",
  "notification.error.ERROR_B2B_POLICY_OBJECT_INVALID_FORMAT": "B2b policy object must be in a correct format",
  "notification.error.ERROR_INSURANCE_CLAIMS_REQUIRED": "Insurance claims is required",
  "notification.error.ERROR_INSURANCE_CLAIMS_OBJECT_INVALID_FORMAT": "Insurance claims object must be in a correct format",
  "notification.error.ERROR_PERSONAL_LOCK_OBJECT_INVALID_FORMAT": "Personal lock object must be in a correct format",
  "notification.error.ERROR_FLEET_OBJECT_INVALID_FORMAT": "Fleet object must be in a correct format",
  "notification.error.ERROR_GROUP_OBJECT_INVALID_FORMAT": "Group object must be in a correct format",
  "notification.error.ERROR_B2B_CLAIMS_OBJECT_INVALID_FORMAT": "B2b claims object must be in a correct format",
  "notification.error.ERROR_VEHICLE_MUST_HAVE_BICYCODE": "Vehicle must have a bicycode",
  "notification.error.ERROR_VEHICLE_REQUIRED": "No vehicle provided",
  "notification.error.ERROR_TYPE_INVALID_FORMAT": "Type must be in a correct format",
  "notification.error.ERROR_COMMISSION_ID_REQUIRED": "Commission id is required",
  "notification.error.ERROR_COMMISSION_ID_INVALID_FORMAT": "Commission id is not in a correct format",
  "notification.error.ERROR_COMMISSION_DOES_NOT_EXIST": "Commission does not exist",
  "notification.error.ERROR_AND_INVALID_FORMAT": "Invalid format for provided and",
  "notification.error.ERROR_OR_INVALID_FORMAT": "Invalid format for provided or",
  "notification.error.COULD_NOT_FIND_USER_OR_GROUP": "No user nor group found for stripe event",
  "notification.error.ERROR_CURRENT_CITY_OBJECT_INVALID_FORMAT": "Invalid format for provided current city object",
  "notification.error.ERROR_DEVICES_OBJECT_INVALID_FORMAT": "Invalid format for provided device object",
  "notification.error.ERROR_FIRST_CITY_OBJECT_INVALID_FORMAT": "Invalid format for provided first city object",
  "notification.error.ERROR_NOTES_OBJECT_INVALID_FORMAT": "Invalid format for provided notes object",
  "notification.error.ERROR_POLICIES_INVALID_FORMAT": "Invalid format for provided policies",
  "notification.error.ERROR_POLICY_STATUS_REQUIRED": "No policy status provided",
  "notification.error.ERROR_USERS_GROUPS_RELATIONS_OBJECT_INVALID_FORMAT": "Invalid format for provided users-groups relations object",
  "notification.error.ERROR_USER_SETTINGS_INVALID_FORMAT": "Invalid format for provided user-settings",
  "notification.error.ERROR_STATUS_INVALID_VALUE": "Invalid value for provided status",
  "notification.error.ERROR_PROMOTION_CODE_OBJECT_INVALID_FORMAT": "Invalid format for provided promotion-code object",
  "notification.error.ERROR_USER_OBJECT_INVALID_FORMAT": "Invalid format for provided user object",
  "notification.error.AMOUNT_BIGGER_THAN_INSURED_VALUE": "Claim amount is bigger than insured value",
  "notification.error.AMOUNT_TO_PAY_NOT_EQUAL_TO_SUM_OF_CLAIMS_TO_PAY": "Amount to pay is not equal to the sum of the claims to pay",
  "notification.error.CLAIM_NOT_FOUND_OR_NOT_IN_TO_PAY_STATUS": "No claim in TO_PAY status found",
  "notification.error.DOC_COMPLETION_NOT_100": "Document completion is not 100%",
  "notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_VALUE": "Invalid value for provided claim coverage status",
  "notification.error.ERROR_FILE_TYPE_INVALID_TYPE": "Invalid file extension",
  "notification.error.ERROR_CONTRACT_HAS_NO_END_DATE": "Contract does not have an end date",
  "notification.error.ERROR_CONTRACT_HAS_NO_START_DATE": "Contract does not have an start date",
  "notification.error.ERROR_CONTRACT_IS_NOT_ACTIVE": "Contract is inactive",
  "notification.error.ERROR_MISSING_COVERAGE_PRICING_RULE_DEFINITION": "No coverage pricing rule definition provided",
  "notification.error.ERROR_DURATION_INVALID_VALUE": "Invalid value for provided duration",
  "notification.error.ERROR_CANCEL_REQUEST_ID_REQUIRED": "No cancel request id provided",
  "notification.error.ERROR_AFFECTED_USERS_REQUIRED": "No affetced users provided",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_TYPE": "Invalid type for provided auto renewal",
  "notification.error.ERROR_BIRTHDAY_TOO_HIGH": "Provided birthday is too high",
  "notification.error.ERROR_MISSING_INFORMATION": "Some informations are missing",
  "notification.error.ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ONE": "Policy year must be greater than 1",
  "notification.error.ERROR_FIXED_AMOUNT_PROHIBITED_FOR_PERCENTAGE_TYPE": "Fixed amounts are not allowed for percentage type",
  "notification.error.ERROR_COMMENT_LENGTH_1_255": "Comment must be between 1 and 255 characters",
  "notification.error.ERROR_END_DATE_MUST_BE_AFTER_START_DATE": "End date must be after start date",
  "notification.error.ERROR_FLEET_ID_REQUIRED": "Fleet id is required",
  "notification.error.ERROR_AMOUNTS_INCONSISTENCIES": "There is inconsistencies amongs amounts",
  "notification.error.ERROR_CLAIM_NOT_FOUND": "Claim could not be found",
  "notification.error.ERROR_ABANDONED_MAIL_ID_INVALID_FORMAT": "Invalid format for provided",
  "notification.error.ERROR_CLAIM_MANAGEMENT_PARAMETERS_ALREADY_EXISTS": "Claim management parameters already exist",
  "notification.error.ERROR_DISPLAY_BIKE_INFORMATIONS_REQUIRED": "No information about displaying bike informations provided",
  "notification.error.ERROR_DISPLAY_CONTRACT_REQUIRED": "No information about displaying contract provided",
  "notification.error.ERROR_DISPLAY_POLICY_PRICE_REQUIRED": "No information about displaying policy price provided",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_ALREADY_EXISTS": "Document parameters already exist",
  "notification.error.ERROR_PARTNER_ESTIMATION_REQUIRED": "Partner estimation is undefined",
  "notification.error.ERROR_USER_ESTIMATION_REQUIRED": "User estimation is undefined",
  "notification.error.ERROR_FRANCHISE_RULE_REQUIRED": "Franchise rule is undefined",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_REQUIRED": "Partner reimbursement is undefined",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID_ARRAY": "Invalid partner reimbursement rule array",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_REQUIRED": "User reimbursement is undefined",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID_ARRAY": "Invalid client reimbursement rule array",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_INVALID_TYPE": "Invalid user reimbursement type",
  "notification.error.ERROR_CLAIM_USER_NOT_FOUND": "Could not find given user",
  "notification.error.ERROR_WITH_PLS_REQUIRED": "With PLS is undefined",
  "notification.error.ERROR_HAS_BATTERY_REQUIRED": "Has battery is undefined",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID": "Invalid partner reimbursement rule",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID": "Invalid client reimbursement rule",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_VALUES_EMPTY": "Provided client reimbursement rule is empty",
  "notification.error.ERROR_MANDATORY_CHECKS_REQUIRED": "Mandatory checks are undefined",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_REQUIRED": "Insured value checks are undefined",
  "notification.error.ERROR_VALUE_THRESHOLD_REQUIRED": "Value threshold is undefined",
  "notification.error.ERROR_REQUIRED_DOCS_REQUIRED": "Required docs are undefined",
  "notification.error.ERROR_OPTIONAL_DOCS_REQUIRED": "Optional docs are undefined",
  "notification.error.ERROR_IS_REPAIR_QUOTE_PARTIAL_CLAIM_REQUIRED_INVALID_FORMAT": "Invalid repaid quote format",
  "notification.error.ERROR_ALREADY_REIMBURSEMENT_CHECK_INVALID_FORMAT": "Invalid already reimbursement check format",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_INVALID_FORMAT": "Invalid bike obsolescence start date in days format",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_0_AT_LEAST": "Bike obsolescence start date in days must be at least 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PER_MONTH_0_AT_LEAST": "Bike obsolescence per month must be at least 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_0_AT_LEAST": "Bike obsolescence percentage must be at least 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_OR_EQUAL_TO_100": "Bike obsolescence percentage per month must be less than 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_OR_EQUAL_TO_100": "Bike obsolescence percentage limit must be less than 100",
  "notification.error.ERROR_ACCESSORY_STEPS_REQUIRED": "No acessory steps provided",
  "notification.error.ERROR_ACCESSORY_STEPS_INVALID_ARRAY": "Invalid array for provided accessory steps",
  "notification.error.ERROR_ACCESSORY_STEPS_INVALID_FORMAT": "Invalid format for provided accessory steps",
  "notification.error.ERROR_COVERAGES_EMPTY": "Provided coverages array is empty",
  "notification.error.ERROR_COVERAGES_REQUIRED": "No coverages provided",
  "notification.error.ERROR_COVERAGE_PRICING_RULE_DEFINITION_REQUIRED": "No coverage pricing rule definition provided",
  "notification.error.ERROR_FAVORITE_INVALID_FORMAT": "Invalid format for provided favorite",
  "notification.error.ERROR_FILE_INVALID_FORMAT": "Invalid format for provided file",
  "notification.error.ERROR_FILE_TYPE_REQUIRED": "No file type provided",
  "notification.error.ERROR_MISSING_BATTERY_FEEDBACK": "No battery feedback provided",
  "notification.error.CANNOT_CANCEL_ACTIVE_POLICY": "Policy is not cancellable",
  "notification.error.ERROR_BIKE_PRICE_INVALID_FORMAT": "Invalid format for provided bike price",
  "notification.error.ERROR_BIKE_REQUIRED": "No bike provided",
  "notification.error.ERROR_MISSING_FIRSTNAME": "No firstname provided",
  "notification.error.ERROR_MISSING_LASTNAME": "No lastname provided",
  "notification.error.AMOUNT_GREATER_THAN_RECEIPTS_AMOUNT": "Refund amount is greater than receipt amount",
  "notification.error.AMOUNT_GREATER_THAN_TOTAL_RECEIPTS_AMOUNT": "Refund amount is greater than total receipt amount",
  "notification.error.ERROR_VEHICLES_ID_EMPTY": "Bicycode ids list is empty",
  "notification.error.ERROR_INSURANCE_CLAIMS_INVALID_FORMAT": "Invalid format for provided insurance claims",
  "notification.error.ERROR_INVALID_RENEW_TOKEN": "Provided renew token is invalid",
  "notification.error.ERROR_B2B_POLICY_NOT_AUTO_RENEWABLE": "Policy is not renewable",
  "notification.error.ERROR_INSURANCE_DATE_INVALID_FORMAT": "Invalid format for provided insurance date",
  "notification.error.ERROR_INSURANCE_DATE_REQUIRED": "Insurance date is required",
  "notification.error.ERROR_MISS_CHOOSEN_PACKAGES": "No chosen packages provided",
  "notification.error.ERROR_MISS_CHOOSEN_PACKAGE_WITH_DURATION": "No chosen package with duration provided",
  "notification.error.ERROR_MISS_CLIENT_INFO": "No client info provided",
  "notification.error.ERROR_MISS_PACKAGES_INFO": "No packages info provided",
  "notification.error.ERROR_MISS_PACKAGE_ID": "No package id provided",
  "notification.error.ERROR_MISS_POLICY": "No policy provided",
  "notification.error.ERROR_MISS_POLICY_INFO": "No policy info provided",
  "notification.error.ERROR_MISS_PRICE_INFO": "No price info provided",
  "notification.error.ERROR_MISS_PRICING": "No pricing provided",
  "notification.error.ERROR_MISS_VEHICLE": "No vehicle provided",
  "notification.error.ERROR_MISS_VEHICLE_INFO": "No vehicle info provided",
  "notification.error.ERROR_NEXT_PACKAGE_INVALID_FORMAT": "Invalid format for provided next package",
  "notification.error.ERROR_NOTHING_TO_UPDATE": "Nothing to update",
  "notification.error.ERROR_NO_INVOICES": "No invoices provided",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_DATE": "Invalid date for provided occurrence period end",
  "notification.error.ERROR_OPEN_CLAIM": "Open claim",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_ALREADY_EXISTS": "Ops checks parameters already exists",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_ARRAY": "Invalid array for provided ops checks parameters",
  "notification.error.ERROR_OPTIONAL_COVERAGES_EMPTY": "Optional coverages cannot be empty",
  "notification.error.ERROR_PACKAGE_SOURCE_INVALID_TYPE": "Invalid type for provided package source",
  "notification.error.ERROR_PACKAGE_SOURCE_REQUIRED": "Package source is required",
  "notification.error.ERROR_PARTNERS_INVALID_ARRAY": "Partners must be an array",
  "notification.error.ERROR_PARTNERS_INVALID_FORMAT": "Invalid format for provided partners",
  "notification.error.ERROR_PAYMENT_METHODS_VALUE": "Invalid value for provided payment methods",
  "notification.error.ERROR_PERCENTAGE_PROHIBITED_FOR_FIXED_TYPE": "Percentage prohibited for fixed type",
  "notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_FORMAT": "Invalid format for provided personal lock id",
  "notification.error.ERROR_PMP_ALREADY_EXISTS": "Pmp already exists",
  "notification.error.ERROR_POLICY_ALREADY_EXIST": "Policy already exists",
  "notification.error.ERROR_POLICY_EXPIRED_OVER_ONE_YEAR": "Policy expired over one year",
  "notification.error.ERROR_POLICY_INVALID_STATUS": "Invalid policy status",
  "notification.error.ERROR_POLICY_MISSING_INFORMATION": "Missing information",
  "notification.error.ERROR_POLICY_NOT_FOUND_OR_INCOMPLETE": "Policy not found or incomplete",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_EXPECTED": "Premium support type expected",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_UNEXPECTED": "Premium support type unexpected",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_ARRAY": "Invalid array for provided pricing rules per coverage",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_NOT_ALLOWED_FOR_B2B": "Pricing rules per coverage not allowed for B2B",
  "notification.error.ERROR_PRIORITY_INVALID_FORMAT": "Invalid format for provided priority",
  "notification.error.ERROR_PRIORITY_REQUIRED": "Priority is required",
  "notification.error.ERROR_QMP_ALREADY_EXISTS": "Qmp already exists",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_ALREADY_EXISTS": "Reimbursement parameters already exists",
  "notification.error.ERROR_SPLITTING_VALUE": "Invalid value for provided splitting",
  "notification.error.ERROR_STRIPE_SIGNATURE_REQUIRED": "Stripe signature is required",
  "notification.error.ERROR_SUPPORT_AMOUNT_NOT_NUMBER": "Support amount must be a number",
  "notification.error.ERROR_TIME_PERIOD_TYPE": "Invalid time period type",
  "notification.error.ERROR_TIME_PERIOD_VALUE": "Invalid time period value",
  "notification.error.ERROR_TOO_LATE_TO_CANCEL_CANCELLATION": "Too late to cancel cancellation",
  "notification.error.ERROR_TOO_MANY_OPENED_REQUESTS": "Too many opened requests",
  "notification.error.ERROR_TRAD_CODE_MUST_BE_ONE_OF_THE_VALID_VALUES": "Trad code must be one of the valid values",
  "notification.error.ERROR_TRAD_CODE_REQUIRED": "Trad code is required",
  "notification.error.ERROR_USER_CANCEL_ALLOWED_REQUIRED": "User cancel allowed is required",
  "notification.error.ERROR_VEHICLE_ID_INVALID_TYPE": "Invalid type for provided vehicle id",
  "notification.error.INACTIVE_POLICY_OR_ALREADY_STARTED": "Policy is inactive or already started",
  "notification.error.INCORRECT_AMOUNT": "Incorrect amount",
  "notification.error.INSURANCE_NO_SUBSCRIPTION_GIVEN": "No subscription given",
  "notification.error.INVALID_CODE": "Invalid code",
  "notification.error.INVALID_COVERAGE_CODE": "Invalid coverage code",
  "notification.error.INVALID_PACKAGE_STEP": "Invalid package step",
  "notification.error.INVALID_POLICY": "Invalid policy",
  "notification.error.INVALID_PREMIUM_SUPPORT_TYPE": "Invalid premium support type",
  "notification.error.INVALID_PROMOTION_CODE": "Invalid promotion code",
  "notification.error.INVALID_QUOTE_GIVEN": "Invalid quote given",
  "notification.error.INVALID_STATUS": "Invalid status",
  "notification.error.LAST_CHECK_NOT_ALLOWED": "Last check not allowed",
  "notification.error.MISSING_CLAIM_DATA": "Missing claim data",
  "notification.error.MISS_POLICY_PACKAGE": "Missing policy package",
  "notification.error.MISS_VEHICLES_AFFECTED_USER": "Missing vehicles affected user",
  "notification.error.NEW_STATUS_NOT_ALLOWED": "New status not allowed",
  "notification.error.NOT_A_TOTAL_COVERAGE_CODE": "Claim is not total",
  "notification.error.NO_BIKE_FUND": "No bike fund",
  "notification.error.NO_LINES": "No lines",
  "notification.error.NO_PACKAGES": "No packages",
  "notification.error.NO_PACKAGES_OR_CONTRACT": "No packages or contract",
  "notification.error.NO_PLAN_GIVEN": "No plan given",
  "notification.error.NO_UPDATE": "No update",
  "notification.error.NO_VEHICLE_PHOTO": "No vehicle photo",
  "notification.error.PAST_EFFECTIVE_START_DATE": "Effective start date must be in the future",
  "notification.error.PENDING_POLICY_NOT_FOUND": "Pending policy not found",
  "notification.error.PERSONAL_LOCK_REQUIRED": "Personal lock is required",
  "notification.error.PLS_VALIDATION_NOT_CONSISTENT": "Pls validation not consistent",
  "notification.error.POLICY_ALREADY_ENDED": "Policy already ended",
  "notification.error.POLICY_ALREADY_RENEWED": "Policy already renewed",
  "notification.error.POLICY_IS_NOT_ACTIVE_ANYMORE": "Policy is not active anymore",
  "notification.error.POLICY_NOT_CANCELABLE": "Policy not cancelable",
  "notification.error.POLICY_NOT_FOUND": "Policy not found",
  "notification.error.POLICY_STILL_IN_DEPRIVATION": "Policy still in deprivation",
  "notification.error.QUOTE_NOT_FOUND_OR_INCOMPLETE": "Quote not found or incomplete",
  "notification.error.RECEIPT_NOT_FOUND": "Receipt not found",
  "notification.error.RECONDUCTED_POLICY": "Policy is reconducted",
  "notification.error.REQUEST_ALREADY_HANDLED": "Request already handled",
  "notification.error.STRIPE_NOT_EDITABLE": "Stripe not editable",
  "notification.error.TOO_LATE_TO_UPDATE_SCHEDULE": "Too late to update schedule",
  "notification.error.UNABLE_TO_DELETE": "Unable to delete",
  "notification.error.UNKNOWN_PRODUCT": "Unknown product",
  "notification.error.USER_CHECK_COMMENT_REQUIRED": "User check comment is required",
  "notification.error.USER_ID_REQUIRED": "User id is required",
  "notification.error.USER_PERSONAL_LOCK_NOT_FOUND": "User personal lock not found",
  "notification.error.VEHICLE_NOT_APIC_APPROVED": "Vehicle has not been checked with the APIC",
  "notification.error.VEHICLE_NOT_EXIST_OR_ERROR_CREATION": "Vehicle not exist or error creation",
  "notification.error.ERROR_TOTAL_TTC_NEGATIVE": "The total price (tax included) must be positive",
  "notification.error.ERROR_TOTAL_TTC_FORMAT": "The total price (tax included) has an invalid format",
  "notification.error.ERROR_DISCOUNT_AMOUNT_NEGATIVE": "Discount amount must be positive",
  "notification.error.ERROR_DISCOUNT_AMOUNT_FORMAT": "Discount amount is not in a correct format",
  "notification.error.ERROR_TVA_PERCENTAGE_NEGATIVE": "TVA percentage must be positive",
  "notification.error.ERROR_TVA_PERCENTAGE_FORMAT": "TVA percentage is not in a correct format",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_TOO_HIGH": "Discount percentage must be less than 100",
  "notification.error.ERROR_TVA_PERCENTAGE_TOO_HIGH": "TVA percentage must be less than 100",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_NEGATIVE": "Discount percentage must be positive",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_FORMAT": "Discount percentage has an invalid format",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_INVALID_TYPE": "The cancel condition of the claim reject must be in the correct format",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_NOT_ALLOWED": "The cancel condition of the claim reject is not allowed",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_REQUIRED": "The cancel condition of the claim reject is required",
  "notification.error.ERROR_INVALID_PROMO_CODE": "The promo code is invalid",
  "notification.error.ERROR_NO_POLICY_FOR_RENEWAL": "No policy found for renewal",
  "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT": "The total rejected terminate policy must be a boolean",
  "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_REQUIRED": "The total rejected terminate policy is required",
  "notification.error.ERROR_TERMINATE_POLICY_RETRACTION": "Policy is in retraction, cannot be terminated",
  "notification.error.ERROR_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT": "The total rejected terminate policy must be a boolean",
  "notification.error.VEHICLE_NOT_APIC_APPROVED_OR_INVALID_STATUS": "Vehicle has not been checked with the APIC or has an invalid status",
  "notification.error.ERROR_MAIL_ID_MUST_BE_A_NUMBER": "Mail ID must be a number",
  "notification.error.ERROR_EXCLUDE_IDS_INVALID_ARRAY": "Exclude ids must be an array",
  "notification.error.ERROR_EXCLUDE_IDS_INVALID_FORMAT": "Invalid format for provided exclude ids",
  "notification.error.ERROR_MAX_LAT_INVALID_FORMAT": "Invalid value for provided max lat",
  "notification.error.ERROR_MAX_LAT_REQUIRED": "No max lat provided",
  "notification.error.ERROR_MAX_LON_INVALID_FORMAT": "Invalid value for provided max lon",
  "notification.error.ERROR_MAX_LON_REQUIRED": "No max lon provided",
  "notification.error.ERROR_MIN_LAT_INVALID_FORMAT": "Invalid value for provided min lat",
  "notification.error.ERROR_MIN_LAT_REQUIRED": "No min lat provided",
  "notification.error.ERROR_MIN_LON_INVALID_FORMAT": "Invalid value for provided min lon",
  "notification.error.ERROR_MIN_LON_REQUIRED": "No min lon provided",
  "notification.error.ERROR_B2B_POLICIES_INVALID_FORMAT": "Invalid format for provided b2b-policies",
  "notification.error.ERROR_QUOTES_AS_INSURED_INVALID_FORMAT": "Invalid format for provided quotes-as-insured",
  "notification.error.ERROR_VEHICLES_INVALID_FORMAT": "Invalid format for provided vehicles",
  "notification.error.ERROR_NAME_MIN_1": "Name must be at least 1 character",
  "notification.error.ERROR_APIC_STATUS_HISTORY_INVALID_FORMAT": "Invalid format for provided apic status",
  "notification.error.ERROR_GROUPS_IN_CONFLICT_INVALID_FORMAT": "Invalid format for provided groups in conflict",
  "notification.error.WRONG_B2B_USAGE_TYPE": "Invalid usage type",
  "notification.error.ERROR_KEY_REQUIRED": "No key provided",
  "notification.error.ERROR_CAN_NOT_DISABLE_COVERAGE": "Coverage could not be disabled",
  "notification.error.ERROR_ONE_TIME_BILLING_INVALID_FORMAT": "Invalid format for provided one-time billing",
  "notification.error.ERROR_ONE_TIME_BILLING_REQUIRED": "Billing is required",
  "notification.error.ERROR_PRICE_NOT_DEFINED_FOR_INSURED_VALUE": "No pricing available for the specified package/insured amount",
  "notification.error.ERROR_BICYCODE_INVALID_FORMAT": "Invalid format for provided bicycode",
  "notification.error.ERROR_COLOR_INVALID_FORMAT": "Invalid format for provided color",
  "notification.error.ERROR_FLEET_NAME_INVALID_FORMAT": "Invalid format for provided fleet name",
  "notification.error.ERROR_MODEL_INVALID_FORMAT": "Invalid format for provided model name",
  "notification.error.ERROR_CANT_DISABLE_PACKAGE_WITH_CONTRACTS": "Cannot disable package with contracts",
  "notification.error.ERROR_SHOP_PRODUCT_OBJECT_INVALID_FORMAT": "Invalid format for provided shop product object",
  "notification.error.ERROR_GROUP_STATS_VIEW_INVALID_FORMAT": "Invalid format for provided group stats view",
  "notification.error.ERROR_ORDER_DOES_NOT_EXIST": "Order does not exist",
  "notification.error.ERROR_PRODUCT_ID_INVALID_FORMAT": "Invalid format for provided product id",
  "notification.error.ERROR_ORDER_ID_INVALID_FORMAT": "Invalid format for provided order id",
  "notification.error.ERROR_PRODUCT_DOES_NOT_EXIST": "Product does not exist",
  "notification.error.ERROR_PRODUCT_OUT_OF_STOCK": "Product is out of stock",
  "notification.error.ERROR_SPONSOR_NAME_REQUIRED": "No sponsor name provided",
  "notification.error.ERROR_PICTURE_REQUIRED": "No picture provided",
  "notification.error.ERROR_PRODUCT_COST_REQUIRED": "No product cost provided",
  "notification.error.ERROR_PRODUCT_COST_INVALID_FORMAT": "Invalid format for provided product cost",
  "notification.error.ERROR_STOCK_INVALID_FORMAT": "Invalid format for provided stock",
  "notification.error.ERROR_XSS_DETECTED": "XSS detected",
  "notification.error.ERROR_PRODUCT_EXPIRED": "Product has expired",
  "notification.error.ERROR_MISSING_PRODUCT_INFORMATIONS": "Missing product informations",
  "notification.error.ERROR_GENERATE_ON_ORDER_REQUIRED": "No generate on order provided",
  "notification.error.ERROR_GENERATE_ON_ORDER_INVALID_FORMAT": "Invalid format for provided generate on order",
  "notification.error.ERROR_PROMO_CODES_INVALID_ARRAY": "Invalid array for provided promotions codes",
  "notification.error.ERROR_PROMO_CODES_NOT_EMPTY": "No promotions codes provided",
  "notification.error.ERROR_PROMO_CODES_INVALID_FORMAT": "Invalid format for provided promotions codes",
  "notification.error.ERROR_API_GENERATION_URL_INVALID_FORMAT": "Invalid format for provided api generation url",
  "notification.error.ERROR_DESCRIPTION_INVALID_FORMAT": "Invalid format for provided description",
  "notification.error.ERROR_PARTNER_WEBSITE_URL_INVALID_FORMAT": "Invalid format for provided partner website url",
  "notification.error.ERROR_PICTURE_INVALID_FORMAT": "Invalid format for provided picture",
  "notification.error.ERROR_SPONSOR_NAME_INVALID_FORMAT": "Invalid format for provided sponsor name",
  "notification.error.ERROR_IS_ACTIVE_INVALID_FORMAT": "Invalid format for provided is active",
  "notification.error.ERROR_REWARD_TYPE_INVALID_TYPE": "Invalid type for provided reward type",
  "notification.error.ERROR_REWARD_TYPE_REQUIRED": "No reward type provided",
  "notification.error.ERROR_INSUFFICIENT_POINTS": "Insufficient points",
  "notification.error.ERROR_PRODUCT_NOT_ACTIVE": "Product is not active",
  "notification.error.ERROR_S3_KEY_REQUIRED": "No s3 key provided",
  "notification.error.ERROR_S3_KEY_INVALID_FORMAT": "Invalid format for provided s3 key",
  "notification.error.ERROR_IS_FRAUD_PARTNER_INVALID_FORMAT": "Invalid format for provided is fraud partner",
  "notification.error.ERROR_MANAGING_PARTNER_INVALID_FORMAT": "Invalid format for provided managing partner",
  "notification.error.ERROR_MANAGING_PARTNER_OBJECT_INVALID_FORMAT": "Invalid format for provided is managing partner object",
  "notification.error.ERROR_OPS_OBJECT_INVALID_FORMAT": "Invalid format for provided Ops object",
  "notification.error.ERROR_B2B_CLAIM_ID_INVALID_FORMAT": "Invalid format for provided b2b claim id",
  "notification.error.ERROR_DOCUMENT_NOTES_INVALID_FORMAT": "Invalid format for provided document notes",
  "notification.error.ERROR_INSURANCE_CLAIM_ID_INVALID_FORMAT": "Invalid format for provided claim id",
  "notification.error.ERROR_INSURANCE_CLAIM_OBJECT_INVALID_FORMAT": "Invalid format for provided claim object",
  "notification.error.ERROR_OWNER_OBJECT_INVALID_FORMAT": "Invalid format for provided owner object",
  "notification.error.ERROR_OWNING_GROUP_INVALID_FORMAT": "Invalid format for provided owning group",
  "notification.error.ERROR_OWNING_GROUP_OBJECT_INVALID_FORMAT": "Invalid format for provided owning group object",
  "notification.error.ERROR_PERSONAL_LOCKS_INVALID_FORMAT": "Invalid format for provided personal-locks",
  "notification.error.ERROR_VALIDATED_BY_OBJECT_INVALID_FORMAT": "Invalid format for provided validated by object",
  "notification.error.ERROR_VALID_END_DATE_TOO_OLD": "Provided valid end date is too old",
  "notification.error.ERROR_VALID_START_DATE_INVALID_FORMAT": "Invalid format for provided valid start date",
  "notification.error.ERROR_VALID_START_DATE_TOO_OLD": "Provided valid start date is too old",
  "notification.error.ERROR_PACKAGE_OBJECT_INVALID_FORMAT": "Invalid format for provided package_object filter",
  "notification.error.ERROR_PARTNER_OBJECT_INVALID_FORMAT": "Invalid format for provided partner_object filter",
  "notification.error.ERROR_VEHICLE_OBJECT_INVALID_FORMAT": "Invalid format for provided vehicle object",
  "notification.error.ERROR_COMMISSIONS_RULES_INVALID_FORMAT": "Invalid format for provided commission rules",
  "notification.error.ERROR_POLICY_OBJECT_INVALID_FORMAT": "Invalid format for provided policy object",
  "notification.error.ERROR_AFFECTED_USERS_OBJECT_INVALID_FORMAT": "Invalid format for provided affected users",
  "notification.error.ERROR_CONTRACTUAL_DOCUMENTS_INVALID_FORMAT": "Invalid format for provided contractual documents",
  "notification.error.ERROR_CONTRACT_OBJECT_INVALID_FORMAT": "Invalid format for provided contract object",
  "notification.error.GROUP_BUT_B2B_PRODUCT_NOT_IDENTIFIED": "Group but b2b product not identified",
  "notification.error.ERROR_DISPLAY_POLICY_INFORMATION_INVALID_FORMAT": "Display policy information must be a boolean",
  "notification.error.ERROR_DISPLAY_BIKE_INFORMATION_INVALID_FORMAT": "Display bike information must be a boolean",
  "notification.error.ERROR_DISPLAY_AFFECTED_USER_DETAILS_INVALID_FORMAT": "Display affected user details must be a boolean",
  "notification.error.ERROR_CLIENT_BIKE_UPDATE_ALLOWED_INVALID_FORMAT": "Client bike update allowed must be a boolean",
  "notification.error.ERROR_CLIENT_ALLOWED_UPDATE_INVALID_FORMAT": "Client allowed update must be a boolean",
  "notification.error.ERROR_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT": "Client cancel allowed must be a boolean",
  "notification.error.ERROR_CREATE_CLAIM_CLIENT_INVALID_FORMAT": "Create claim client must be a boolean",
  "notification.error.ERROR_CREATE_CLAIM_PARTNER_INVALID_FORMAT": "Create claim partner must be a boolean",
  "notification.error.ERROR_B2B_POLICY_UNAUTHORIZED_ACTION": "Unauthorized action for B2B policy",
  "notification.error.ERROR_PRICING_RULES_INVALID_LENGTH": "Invalid length for provided pricing rules",
  "notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_REQUIRED": "No average price percentage provided",
  "notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_INVALID_FORMAT": "Average price percentage is not in a correct format",
  "notification.error.ERROR_B2B_RECEIPTS_INVALID_FORMAT": "Invalid format for provided B2B receipts",
  "notification.error.ERROR_PAYMENT_STATUS_INVALID_TYPE": "Invalid type for provided payment status",
  "notification.error.ERROR_NEXT_CONTRACT_ID_REQUIRED": "nextContractId is required",
  "notification.error.ERROR_NEXT_CONTRACT_IS_NOT_ACTIVE": "Next contract is not active",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_USAGE": "Next contract has different usage",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_PACKAGE": "Next contract has different package",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_DURATION": "Next contract has different duration",
  "notification.error.ERROR_NEXT_CONTRACT_ID_INVALID_FORMAT": "Invalid format for provided next contract id",
  "notification.error.ERROR_CLAIM_NOT_LINKED_TO_GROUP": "Claim is not linked to group",
  "notification.error.ERROR_CLAIM_NOT_ALLOWED_TO_UPDATE": "Claim is not allowed to update",
  "notification.error.ERROR_CARD_PICTURE_INVALID_FORMAT": "Invalid format for provided card picture",
  "notification.error.ERROR_CARD_PICTURE_REQUIRED": "No card picture provided",
  "notification.error.ERROR_DETAIL_PICTURE_INVALID_FORMAT": "Invalid format for provided detail picture",
  "notification.error.ERROR_DETAIL_PICTURE_REQUIRED": "No detail picture provided",
  "notification.error.ERROR_B2B_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Invalid format for provided b2b policy management parameters",
  "notification.error.ERROR_B2C_CONTRACT_ID_INVALID_FORMAT": "Invalid format for provided b2c contract id",
  "notification.error.ERROR_CANCELLATION_REQUEST_OBJECT_INVALID_FORMAT": "Invalid format for provided cancellation request object",
  "notification.error.ERROR_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Invalid format for provided policy management parameters",
  "notification.error.ERROR_POLICY_STATUS_INVALID_FORMAT": "Invalid format for provided policy status",
  "notification.error.ERROR_POLICY_TYPE_INVALID_TYPE": "Invalid type for provided policy type",
  "notification.error.ERROR_PROMO_CODES_REQUIRED": "Invalid format for provided promo codes",
  "notification.error.ERROR_RENEWABLE_INVALID_FORMAT": "Invalid format for provided renewable",
  "notification.error.ERROR_RISK_SCORE_INVALID_FORMAT": "Invalid format for provided risk score",
  "notification.error.ERROR_USER_INVALID_FORMAT": "Invalid format for provided user",
  "notification.error.ERROR_B2B_CONTRACT_ID_INVALID_FORMAT": "Invalid format for provided b2b contract id",
  "notification.error.ERROR_COVERAGE_OBJECT_INVALID_FORMAT": "Invalid format for provided coverage object",
  "notification.error.ERROR_SPLITTING_TYPE_INVALID_TYPE": "Invalid type for provided splitting type",
  "notification.error.ERROR_ATTRIB_INVALID_FORMAT": "invalid format for provided attrib",
  "notification.error.ERROR_DISPLAY_CLAIMS_CLIENT_INVALID_FORMAT": "Invalid format for provided display claims client",
  "notification.error.ERROR_DISPLAY_CLAIMS_PARTNER_INVALID_FORMAT": "Invalid format for provided display claims partner",
  "notification.error.ERROR_IS_CLIENT_EDIT_ALLOWED_INVALID_FORMAT": "Invalid format for provided is client edit allowed",
  "notification.error.ERROR_IS_PARTNER_EDIT_ALLOWED_INVALID_FORMAT": "Invalid format for provided is partner edit allowed",
  "notification.error.ERROR_IS_CLIENT_DOC_VIEW_ALLOWED_INVALID_FORMAT": "Invalid format for provided is client doc view allowed",
  "notification.error.ERROR_IS_PARTNER_DOC_VIEW_ALLOWED_INVALID_FORMAT": "Invalid format for provided is partner doc view allowed",
  "notification.error.ERROR_IS_CLIENT_DOC_UPLOAD_ALLOWED_INVALID_FORMAT": "Invalid format for provided is client doc upload allowed",
  "notification.error.ERROR_IS_PARTNER_DOC_UPLOAD_ALLOWED_INVALID_FORMAT": "Invalid format for provided is partner doc upload allowed",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_INVALID_FORMAT": "Invalid format for provided bike obsolescence start in days",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_0_AT_LEAST": "Bike obsolescence start in days must be at least 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_100_AT_MOST": "Bike obsolescence percentage limit must be at most 100",
  "notification.error.ERROR_B2B_CLAIM_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Invalid format for provided b2b claim management parameters",
  "notification.error.ERROR_IS_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT": "Invalid format for provided is client cancel allowed",
  "notification.error.ERROR_IS_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT": "Invalid format for provided is partner cancel allowed",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_0_AT_LEAST": "Partial claim allowed count must be at least 0",
  "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_NOT_BOOL": "Duration greater than contract duration allowed must be a boolean",
  "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_REQUIRED": "Duration greater than contract duration allowed is required",
  "notification.error.ERROR_AMEND_ALLOWED_NOT_BOOL": "Amend allowed must be a boolean",
  "notification.error.ERROR_AMEND_ALLOWED_REQUIRED": "Amend allowed is required",
  "notification.error.ERROR_REQUEST_STATUS_INVALID_TYPE": "Request status must be an enum",
  "notification.error.ERROR_REQUEST_REASON_INVALID_TYPE": "Request reason must be an enum",
  "notification.error.ERROR_ARTICLE_ID_INVALID_FORMAT": "Invalid format for provided article_id",
  "notification.error.ERROR_RECEIPTS_INVALID_FORMAT": "Invalid format for provided receipts",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_EXCEEDED": "Partial claim allowed count exceeded",
  "notification.error.CLIENT_MANAGED_BY_ANOTHER_PARTNER": "Quote can not be confirmed as client is managed by another partner",
  "notification.error.ERROR_DATE_INVALID_TYPE": "Invalid value for provided date",
  "notification.error.ERROR_IBAN_INVALID": "Invalid format for provided IBAN",
  "notification.error.ERROR_SOURCE_ID_REQUIRED": "Source bike model ID is required",
  "notification.error.ERROR_SOURCE_ID_INVALID_FORMAT": "Invalid format for source bike model ID",
  "notification.error.ERROR_TARGET_ID_REQUIRED": "Target bike model ID is required",
  "notification.error.ERROR_TARGET_ID_INVALID_FORMAT": "Invalid format for target bike model ID",
  "notification.error.ERROR_SOURCE_AND_TARGET_MUST_BE_DIFFERENT": "Source and target bike models must be different",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_REQUIRED": "No reimbursement type provided",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_TYPE": "Invalid type for provided reimbursement type",
  "notification.error.ERROR_USER_AND_PARTNER_NOT_LINKED_BY_POLICY": "User and partner are not linked by policy",
  "notification.error.ERROR_TYPOLOGIES_INVALID_FORMAT": "Invalid format for provided typologies",
  "notification.error.ERROR_UUID_INVALID_FORMAT": "Invalid format for provided uuid",
  "notification.error.ERROR_EVENT_USER_OBJECT_INVALID_FORMAT": "Invalid format for provided event user object",
  "notification.error.ERROR_IS_AMEND_ALLOWED_INVALID_FORMAT": "Invalid format for provided is_amend_allowed",
  "notification.error.ERROR_IS_DURATION_GT_CONTRACT_DURATION_ALLOWED_INVALID_FORMAT": "Invalid format for provided is_duration_gt_contract_duration_allowed",
  "notification.error.already_sponsored": "You have already been sponsored. You can be sponsored only once.",
  "notification.error.ERROR_COMMISSION_INVOICE_DOES_NOT_EXIST": "Commission invoice does not exist",
  "notification.error.ERROR_COMMISSION_INVOICE_ALREADY_PAID": "Commission invoice is already paid",
  "notification.error.ERROR_COMMISSION_INVOICE_ID_REQUIRED": "Commission invoice ID is required",
  "notification.error.ERROR_COMMISSION_INVOICE_ID_INVALID_FORMAT": "Invalid format for provided commission invoice ID",
  "notification.error.ERROR_INVALID_COMMISSION_INVOICE_STATUS_TRANSITION": "Invalid commission invoice status transition",
  "notification.error.ERROR_COMMISSION_INVOICE_ZERO_AMOUNT_ALREADY_EXISTS": "A commission invoice with zero amount already exists for this period",
  "notification.error.ERROR_NO_RECEIPTS": "No receipts found",
  "notification.error.ERROR_PROMO_CODE_NOT_FOUND": "Promo code not found",
  "notification.error.PROMO_CODE_NOT_FOUND": "Promo code not found",
  "notification.error.ERROR_PROMOTION_CODE_ID_INVALID_FORMAT": "Invalid format for provided promotion code id",
  "notification.error.ERROR_SHOP_PRODUCT_PROMO_CODE_INVALID_FORMAT": "Invalid format for provided shop product promotion code",
  "notification.error.ERROR_UNAUTHORIZED": "Unauthorized",
  "notification.error.ERROR_B2B_ONBOARDING_OBJECT_INVALID_FORMAT": "Invalid format for provided b2b onboarding object",
  "notification.error.ERROR_ONBOARDING_TYPE_REQUIRED": "Onboarding type is required",
  "notification.error.ERROR_ONBOARDING_TYPE_INVALID_TYPE": "Invalid type for provided onboarding type",
  "notification.error.ERROR_POLICY_DURATION_INVALID_FORMAT": "Invalid format for provided policy duration",
  "notification.error.ERROR_POLICY_DURATION_TOO_LOW": "Policy duration is too low",
  "notification.error.ERROR_POLICY_DURATION_TOO_HIGH": "Policy duration is too high",
  "notification.error.ERROR_COVERAGE_NEEDS_INVALID_ARRAY": "Invalid array for provided coverage needs",
  "notification.error.ERROR_COVERAGE_NEEDS_DUPLICATE": "Coverage needs must be unique",
  "notification.error.ERROR_COVERAGE_NEEDS_INVALID_ENUM": "Invalid enum for provided coverage needs",
  "notification.error.ERROR_ESTIMATED_VEHICLE_COUNT_INVALID_TYPE": "Invalid type for provided estimated vehicle count",
  "notification.error.ERROR_ESTIMATED_POLICY_COUNT_INVALID_TYPE": "Invalid type for provided estimated policy count",
  "notification.error.ERROR_RESELL_TYPE_INVALID_TYPE": "Invalid type for provided resell type",
  "notification.error.ERROR_B2B_ONBOARDING_VALIDATION_FAILED": "B2b onboarding validation failed",
  "notification.error.ERROR_HAS_OPTIONAL_BATTERY_INVALID_TYPE": "Invalid type for provided has optional battery",
  "notification.error.ERROR_HAS_OPTIONAL_BATTERY_REQUIRED": "Has optional battery is required",
  "notification.error.ERROR_HAS_TRAILER_INVALID_TYPE": "Invalid type for provided has trailer",
  "notification.error.ERROR_HAS_TRAILER_REQUIRED": "Has trailer is required",
  "notification.error.ERROR_IS_OPTIONAL_BATTERY_SAFE_INVALID_FORMAT": "Invalid format for provided is optional battery safe",
  "notification.error.ERROR_IS_TRAILER_SAFE_INVALID_FORMAT": "Invalid format for provided is trailer safe",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER": "Invalid format for provided recovered amount partner",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE": "Recovered amount partner must be positive",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER": "Invalid format for provided to be recovered amount partner",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE": "To be recovered amount partner must be positive",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_NUMBER": "Invalid format for provided to be reimbursed partner",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_POSITIVE": "To be reimbursed partner must be positive",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_NUMBER": "Invalid format for provided claim paid partner",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_POSITIVE": "Claim paid partner must be positive",
  "notification.error.ERROR_PRICING_DURATION_REQUIRED": "Pricing duration is required",
  "notification.error.ERROR_PRICING_DURATION_MUST_BE_GREATER_THAN_ONE": "Pricing duration must be greater than 1",
  "notification.error.ERROR_PRICING_DURATION_INVALID_FORMAT": "Invalid format for provided pricing duration",
  "notification.error.ERROR_PRICING_TIME_PERIOD_REQUIRED": "Pricing time period is required",
  "notification.error.ERROR_PRICING_TIME_PERIOD_INVALID_TYPE": "Invalid type for provided pricing time period",
  "notification.error.ERROR_CANCEL_REQUEST_UNIQUE_ID_REQUIRED": "No cancel request unique id provided",
  "notification.error.ERROR_AT_GD_VALUE_INVALID_FORMAT": "Invalid format for provided at gd value",
  "notification.error.ERROR_EMPLOYEE_OF_INVALID_FORMAT": "Invalid format for provided employee of",
  "notification.error.ERROR_FIRSTNAME_INVALID_FORMAT": "Invalid format for provided firstname",
  "notification.error.ERROR_GCLID_FIELD_INVALID_FORMAT": "Invalid format for provided gclid field",
  "notification.error.ERROR_LASTNAME_INVALID_FORMAT": "Invalid format for provided lastname",
  "notification.error.ERROR_OPT_IN_NL_INVALID_FORMAT": "Invalid format for provided opt in nl",
  "notification.error.ERROR_OPT_IN_NL_MOBILE_INVALID_FORMAT": "Invalid format for provided opt in nl mobile",
  "notification.error.ERROR_PAGE_URL_INVALID_FORMAT": "Invalid format for provided page url",
  "notification.error.ERROR_PARTNERSHIP_SOURCE_INVALID_FORMAT": "Invalid format for provided partnership source",
  "notification.error.ERROR_PARTNER_UTM_CONTENT_INVALID_FORMAT": "Invalid format for provided partner utm content",
  "notification.error.ERROR_PARTNER_UTM_SOURCE_INVALID_FORMAT": "Invalid format for provided partner utm source",
  "notification.error.ERROR_QUOTEFORM_ID_INVALID_FORMAT": "Invalid format for provided quoteform id",
  "notification.error.ERROR_UTM_CAMPAIGN_INVALID_FORMAT": "Invalid format for provided utm campaign",
  "notification.error.ERROR_UTM_CONTENT_INVALID_FORMAT": "Invalid format for provided utm content",
  "notification.error.ERROR_UTM_MEDIUM_INVALID_FORMAT": "Invalid format for provided utm medium",
  "notification.error.ERROR_UTM_SOURCE_INVALID_FORMAT": "Invalid format for provided utm source",
  "notification.error.ERROR_UTM_TERM_INVALID_FORMAT": "Invalid format for provided utm term",
  "notification.error.ERROR_PROMOTION_CODE_ID_REQUIRED_FOR_INSURANCE_CODE": "Promotion code ID is required for insurance code products",
  "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_REQUIRED": "Termination reimbursement mode is required",
  "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_INVALID_TYPE": "Invalid type for provided termination reimbursement mode",
  "notification.error.ERROR_HAS_PAST_CLAIMS_WITH_BATTERY_CHECKED_INVALID_FORMAT": "Has past claims with battery checked value must be in a correct format",
  "notification.error.ERROR_HAS_PLS_BEEN_VALIDATED_INVALID_FORMAT": "Has PLS been validated value must be in a correct format",
  "notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_INVALID_FORMAT": "Invalid format for provided is direct reimbursement",
  "notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_INVALID_FORMAT": "Invalid format for provided need PLS been validated",
  "notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_REQUIRED": "Need PLS been validated is required",
  "notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_TYPE": "Invalid type for claim coverage status",
  "notification.error.ERROR_DEPRIVATION_DURATION_IN_DAYS_INVALID_FORMAT": "Invalid format for provided deprivation duration in days",
  "notification.error.ERROR_IS_OPS_SUSPEND_ALLOWED_INVALID_FORMAT": "Invalid format for provided is ops suspend allowed",
  "notification.error.ERROR_IS_PLS_WITH_TOTAL_CLAIM_ALLOWED_INVALID_FORMAT": "Invalid format for provided is pls with total claim allowed",
  "notification.error.ERROR_IS_USER_CANCEL_ALLOWED_INVALID_FORMAT": "Invalid format for provided is user cancel allowed",
  "notification.error.ERROR_PLS_DURATION_LIMIT_IN_DAYS_INVALID_FORMAT": "Invalid format for provided pls duration limit in days",
  "notification.error.ERROR_SHOULD_DISPLAY_BIKE_INFORMATIONS_INVALID_FORMAT": "Invalid format for provided should display bike informations",
  "notification.error.ERROR_SHOULD_DISPLAY_CONTRACT_INVALID_FORMAT": "Invalid format for provided should display contract",
  "notification.error.ERROR_SHOULD_DISPLAY_POLICY_INFORMATIONS_INVALID_FORMAT": "Invalid format for provided should display policy informations",
  "notification.error.ERROR_SHOULD_DISPLAY_POLICY_PRICE_INVALID_FORMAT": "Invalid format for provided should display policy price",
  "notification.error.ERROR_IS_USER_VEHICLE_OWNER_INVALID_FORMAT": "Invalid format for provided is user vehicle owner",
  "notification.error.ERROR_CLAIM_REIMBURSMENT_PARAMETERS_OBJECT_INVALID_FORMAT": "Invalid format for provided reimbursment parameters object",
  "notification.error.ERROR_IS_APIC_CHECK_REQUIRED_INVALID_FORMAT": "Invalid format for provided is APIC check required",
  "notification.error.ERROR_IS_MARKING_CODE_CHECK_REQUIRED_INVALID_FORMAT": "Invalid format for provided is marking code check required",
  "notification.error.ERROR_IS_PERSONAL_LOCK_REQUIRED_INVALID_FORMAT": "Invalid format for provided is personal lock required",
  "notification.error.ERROR_OPS_CHECK_PARAMETERS_INVALID_FORMAT": "Invalid format for provided ops check parameters",
  "notification.error.ERROR_CAN_USER_CREATE_CLAIM_INVALID_FORMAT": "Invalid can_user_create_claim format",
  "notification.error.ERROR_CAN_USER_CREATE_CLAIM_REQUIRED": "can_user_create_claim is required",
  "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_REQUIRED": "should_ask_for_reimbursement_type is required",
  "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_INVALID_FORMAT": "Invalid format for provided should ask for reimbursement type",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_FORMAT": "Invalid format for provided reimbursement type",
  "notification.error.REIMBURSEMENT_TYPE_REQUIRED": "Reimbursement type is required",
  "notification.error.ERROR_PARTNER_INVOICE_ID_REQUIRED": "Partner invoice id is required",
  "notification.error.ERROR_PARTNER_INVOICE_ID_INVALID_FORMAT": "Partner invoice id has to be a valid number",
  "notification.error.ERROR_PARTNER_INVOICE_RECEIPTS_NOT_ALLOWED": "Receipts cannot be added while the partner invoice is paid, sent, cancelled, or void; only draft (created) invoices can be updated.",
  "notification.error.ERROR_EXTERNAL_ID_INVALID_FORMAT": "Invalid format for provided external id",
  "notification.error.ERROR_PARTNER_INVOICES_INVALID_FORMAT": "Invalid format for provided partner invoices",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_OBJECTS_INVALID_FORMAT": "Invalid format for provided document parameters objects",
  "notification.error.ERROR_REIMBURSMENT_PARAMETERS_OBJECTS_INVALID_FORMAT": "Invalid format for provided reimbursement parameters objects",
  "notification.error.ERROR_OPS_CHECK_PARAMETERS_OBJECTS_INVALID_FORMAT": "Invalid format for provided ops check parameters objects",
  "notification.error.ERROR_BIKE_VALUE_CHECKS_INVALID_TYPE": "Invalid type for provided bike value checks",
  "notification.error.ERROR_BIKE_VALUE_CHECKS_REQUIRED": "No bike value checks provided",
  "notification.error.ERROR_BIKE_VALUE_OPS_CHECKS_INVALID_ARRAY": "Invalid array for provided bike value ops checks",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID": "Invalid value for provided bike value threshold",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID_TYPE": "Invalid type for provided bike value threshold",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_REQUIRED": "No bike value threshold provided",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID": "Invalid value for provided min franchise amount",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID_TYPE": "Invalid type for provided min franchise amount",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_REQUIRED": "No min franchise amount provided",
  "notification.error.ERROR_STATUS_CODE_INVALID_FORMAT": "Invalid format for provided status_code",
  "notification.error.ERROR_ORDER_NOT_VALID": "Order is not valid",
  "notification.error.ORDER_NOT_VALID": "Order is not valid",
  "notification.error.ERROR_ORDER_OBJECT_INVALID_FORMAT": "Invalid format for provided order object",
  "notification.error.ERROR_LINK_URL_REQUIRED": "No link url provided",
  "notification.error.ERROR_LINK_URL_INVALID_FORMAT": "Invalid format for provided link url",
  "notification.error.ERROR_POINTS_INVALID_FORMAT": "invalid format for points",
  "notification.error.ERROR_EARNED_TYPE_INVALID_TYPE": "invalid type for earned-type",
  "notification.error.ERROR_SPENT_TYPE_INVALID_TYPE": "invalid type for spent-type",
  "notification.error.ERROR_IS_CLIENT_ABANDON_ALLOWED_INVALID_FORMAT": "Invalid format for provided is client abandon allowed",
  "notification.error.ERROR_IS_PARTNER_ABANDON_ALLOWED_INVALID_FORMAT": "Invalid format for provided is partner abandon allowed",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_TOO_LOW": "Partial claim allowed count must be higher than or equal to -1",
  "notification.error.ERROR_IS_CONFIRMED_INVALID_FORMAT": "Invalid format for provided is_confirmed",
  "notification.error.ERROR_CITY_INVALID_FORMAT": "Invalid format for provided city",
  "notification.error.ERROR_VEHICLE_INVALID_FORMAT": "Invalid format for provided vehicle",
  "notification.error.ERROR_ENUM_SCORING_TYPE_INVALID_TYPE": "Invalid format for provided scoring",
  "notification.error.ERROR_TRAD_CODE_INVALID_TYPE": "Invalid format for provided trad code",
  "notification.error.ERROR_NEXT_PACKAGE_OBJECT_INVALID_FORMAT": "Invalid format for provided next_package_object",
  "notification.error.ERROR_PREVIOUS_PACKAGES_OBJECT_INVALID_FORMAT": "Invalid format for provided previous_packages_object",
  "notification.error.ERROR_SOME_REQUIRED": "Some are required",
  "notification.error.ERROR_FRAUD_SCORE_INVALID_FORMAT": "Invalid format for provided fraud score",
  "notification.error.ERROR_CLAIM_INVALID_FORMAT": "Invalid format for provided claim",
  "notification.error.ERROR_COMMENT_INVALID_FORMAT": "Invalid format for provided comment",
  "notification.error.ERROR_POLICY_INVALID_FORMAT": "Invalid format for provided policy",
  "notification.error.ERROR_IS_DELETED_INVALID_FORMAT": "Invalid format for provided is_deleted",
  "notification.error.ERROR_COMMISSIONS_LINES_INVALID_FORMAT": "Invalid format for provided commissions_lines",
  "notification.error.ERROR_INSURER_INVALID_TYPE": "Invalid format for provided insurer",
  "notification.error.ERROR_QUOTEID_INVALID_FORMAT": "Invalid format for provided quoteId",
  "notification.error.ERROR_SERIAL_NUMBER_INVALID_FORMAT": "Invalid format for provided serial_number",
  "notification.error.ERROR_SPLITTING_TYPE_INVALID_FORMAT": "Invalid format for provided splitting_type",
  "notification.error.ERROR_DOCUMENTS_OBJECT_INVALID_FORMAT": "Invalid format for provided documents_object",
  "notification.error.ERROR_TOTAL_COST_INVALID_FORMAT": "Invalid format for provided total_cost",
  "notification.error.ERROR_IS_SPONSORSHIP_CODE_USED_INVALID_FORMAT": "Invalid format for provided is_sponsorship_code_used",
  "notification.error.ERROR_COMMISSION_INVOICE_FREQUENCY_INVALID_TYPE": "Invalid type for commission invoice frequency",
  "notification.error.ERROR_GROUP_TOO_RECENT": "Group is too recent to generate commissions",
  "notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_REQUIRED": "is_direct_reimbursement is required",
  "notification.error.ERROR_START_DATE_MORE_THAN_10_MINUTES_AGO": "Start date must be less than 10 minutes ago",
  "notification.error.ERROR_END_DATE_BEFORE_START_DATE": "End date must be after start date",
  "notification.error.ERROR_COMMISSION_STATUS_INVALID_TYPE": "Invalid type for provided commission status",
  "notification.error.ERROR_NOT_INVALID_FORMAT": "Invalid format for provided not",
  "notification.error.ERROR_COUNTRY_CODE_INVALID_FORMAT": "Country code must be a 2-letter ISO code",
  "notification.error.ERROR_DOCUMENT_ALREADY_EXISTS": "Document already exists",
  "notification.error.ERROR_FILE_NOT_FOUND": "File not found",
  "notification.error.ERROR_PAYMENT_METHOD_NOT_SEPA": "Payment method is not a SEPA direct debit",
  "notification.error.ERROR_COUNTRY_CODE_TOO_SHORT": "Provided country code is too short",
  "notification.error.ERROR_COUNTRY_CODE_TOO_LONG": "Provided country code is too long",
  "notification.error.ERROR_POLICY_QUOTE_ID_REQUIRED": "Error policy quote id required",
  "notification.error.ERROR_DOCUMENT_TYPE_NOT_SUPPORTED": "Document type not supported",
  "notification.error.ERROR_POLICY_ALREADY_HAS_AN_ONGOING_CLAIM": "Policy already has an ongoing claim",
  "notification.error.ERROR_RESET_PASSWORD_CODE_EXPIRED_NEW_CODE_SENT": "The code you entered has expired. A new code has been sent to you by email.",
  "notification.error.ERROR_EMAIL_IS_SAME": "New email must be different from current email",
  "notification.error.ERROR_EMAIL_CHANGE_CODE_EXPIRED": "Verification code has expired",
  "notification.error.ERROR_EMAIL_CHANGE_CODE_INVALID": "Verification code is invalid",
  "notification.error.ERROR_TOO_MANY_ATTEMPTS": "Too many attempts. Please try again later",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_ALLOWED": "Profile change request is not allowed",
  "notification.error.ERROR_NAME_IS_SAME": "Name is same as current name",
  "notification.error.ERROR_BIRTHDAY_IS_SAME": "Birthday is same as current birthday",
  "notification.error.ERROR_BIRTHPLACE_IS_SAME": "Birthplace is same as current birthplace",
  "notification.error.ERROR_BIRTHPLACE_TOO_SHORT": "Birthplace is too short",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_OPEN": "Profile change request is not open",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_TYPE_INVALID": "Invalid profile change request type",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_INVALID_PAYLOAD": "Invalid profile change request payload",
  "notification.error.ERROR_SIDE_REQUIRED": "No side provided",
  "notification.error.ERROR_SIDE_INVALID_FORMAT": "Invalid format for provided side",
  "notification.error.ERROR_OLD_CODE_REQUIRED": "No old code provided",
  "notification.error.ERROR_NEW_CODE_REQUIRED": "No new code provided",
  "notification.error.ERROR_BIRTHDAY_INVALID_YEARS_RANGE": "Invalid years range for provided birthday",
  "notification.error.ERROR_ROLES_INVALID_ARRAY": "Invalid array for provided roles",
  "notification.error.ERROR_ROLES_EMPTY_ARRAY": "Provided roles array is empty",
  "notification.error.ERROR_ROLES_INVALID_TYPE": "Invalid type for provided roles",
  "notification.error.ERROR_BADGE_TYPE_REQUIRED": "Badge type is required",
  "notification.error.ERROR_LEVEL_INVALID_FORMAT": "Invalid format for provided level",
  "notification.error.ERROR_LEVEL_REQUIRED": "Level is required",
  "notification.error.ERROR_LEVEL_TOO_HIGH": "Level must be lower or equal to 4",
  "notification.error.ERROR_LEVEL_TOO_LOW": "Level must be higher or equal to 1",
  "notification.error.ERROR_BADGE_CODE_REQUIRED": "Badge code is required",
  "notification.error.ERROR_BADGE_CODE_INVALID_FORMAT": "Invalid format for provided badge code",
  "notification.error.ERROR_BADGE_CODE_TOO_LONG": "Badge code must be at most 100 characters",
  "notification.error.ERROR_BADGE_DEFINITION_DOES_NOT_EXIST": "Badge definition does not exist",
  "notification.error.ERROR_BADGE_DEFINITION_NOT_ACTIVE": "Badge definition is not active",
  "notification.error.ERROR_BADGE_DEFINITION_INVALID_FORMAT": "Invalid format for provided badge definition",
  "notification.error.ERROR_BADGES_INVALID_FORMAT": "Invalid format for provided badges",
  "notification.error.ERROR_BADGE_LEVEL_REQUIRED": "Badge level is required",
  "notification.error.ERROR_BADGE_LEVEL_INVALID_FORMAT": "Invalid format for provided badge level",
  "notification.error.ERROR_BADGE_LEVEL_TOO_LOW": "Badge level must be at least 1",
  "notification.error.ERROR_BADGE_LEVEL_TOO_HIGH": "Badge level must be at most 4",
  "notification.error.ERROR_BADGE_LEVEL_ALREADY_ASSIGNED": "Cannot remove a badge level already assigned to users",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_FR_REQUIRED": "Badge level target (French) is required",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_FR_INVALID_FORMAT": "Invalid format for provided badge level target (French)",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_EN_REQUIRED": "Badge level target (English) is required",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_EN_INVALID_FORMAT": "Invalid format for provided badge level target (English)",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_REQUIRED": "Badge level description (French) is required",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_INVALID_FORMAT": "Invalid format for provided badge level description (French)",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_REQUIRED": "Badge level description (English) is required",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_INVALID_FORMAT": "Invalid format for provided badge level description (English)",
  "notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_INVALID_FORMAT": "Invalid format for provided badge level image URL",
  "notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_TOO_LONG": "Badge level image URL must be at most 500 characters",
  "notification.error.ERROR_DISPLAY_ORDER_REQUIRED": "Display order is required",
  "notification.error.ERROR_DISPLAY_ORDER_INVALID_FORMAT": "Invalid format for provided display order",
  "notification.error.ERROR_MAX_LEVEL_REQUIRED": "Max level is required",
  "notification.error.ERROR_MAX_LEVEL_INVALID_FORMAT": "Invalid format for provided max level",
  "notification.error.ERROR_MAX_LEVEL_TOO_LOW": "Max level must be at least 1",
  "notification.error.ERROR_MAX_LEVEL_TOO_HIGH": "Max level must be at most 4",
  "notification.error.ERROR_IS_ONE_OFF_REQUIRED": "Is one off is required",
  "notification.error.ERROR_TITLE_FR_REQUIRED": "Title (French) is required",
  "notification.error.ERROR_TITLE_FR_INVALID_FORMAT": "Invalid format for provided title (French)",
  "notification.error.ERROR_TITLE_FR_TOO_LONG": "Title (French) must be at most 255 characters",
  "notification.error.ERROR_TITLE_EN_REQUIRED": "Title (English) is required",
  "notification.error.ERROR_TITLE_EN_INVALID_FORMAT": "Invalid format for provided title (English)",
  "notification.error.ERROR_TITLE_EN_TOO_LONG": "Title (English) must be at most 255 characters",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_REQUIRED": "Not acquired description (French) is required",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT": "Invalid format for provided not acquired description (French)",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_TOO_LONG": "Not acquired description (French) must be at most 255 characters",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_REQUIRED": "Not acquired description (English) is required",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT": "Invalid format for provided not acquired description (English)",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_TOO_LONG": "Not acquired description (English) must be at most 255 characters",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_REQUIRED": "Acquired description (French) is required",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT": "Invalid format for provided acquired description (French)",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_TOO_LONG": "Acquired description (French) must be at most 255 characters",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_REQUIRED": "Acquired description (English) is required",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT": "Invalid format for provided acquired description (English)",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_TOO_LONG": "Acquired description (English) must be at most 255 characters",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_REQUIRED": "Default image URL is required",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_INVALID_FORMAT": "Invalid format for provided default image URL",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_TOO_LONG": "Default image URL must be at most 500 characters",
  "notification.error.ERROR_LEVELS_REQUIRED": "At least one badge level is required",
  "notification.error.ERROR_LEVELS_INVALID_FORMAT": "Invalid format for provided badge levels",
  "notification.error.ERROR_LEVELS_COUNT_MISMATCH": "Badge levels count must match max level",
  "notification.error.ERROR_IS_ACTIVE_REQUIRED": "Is active is required",
  "notification.error.CLAIM_NOT_IN_TO_PAY_STATUS": 'The claim must be in "to pay" status to be paid',
  "notification.error.NOTHING_TO_REIMBURSE_USER": "There is no amount to reimburse to the user",
  "notification.error.MISSING_USER_IBAN": "The user has no IBAN registered",
  "notification.error.MISSING_GROUP_IBAN": "The group has no IBAN registered",
  "notification.error.TO_BE_REIMBURSED_GROUP_IS_0": "There is nothing to reimburse to the group",
  "notification.error.QONTO_TRANSFER_AMOUNT_MISMATCH": "A transfer was already sent for this claim with a different amount. Check Qonto before retrying",
  "notification.error.CLAIM_PAYMENT_ALREADY_IN_PROGRESS": "This claim was just modified or paid by someone else. Reload it before retrying",
  "notification.error.INSUFFICIENT_ACCOUNT_BALANCE": "The account balance is insufficient to pay this reimbursement",
  "notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_FORMAT": "Invalid format for provided expected policy type",
  "notification.error.ERROR_MANAGING_PARTNER_REQUIRED": "Managing partner is required",
  "notification.error.ERROR_DOCUMENT_NOT_IBAN": "Provided document is not an IBAN document",
  "notification.error.ERROR_DOCUMENT_STATUS_NOT_RECEIVED": "Provided document status is not received",
  "notification.error.ERROR_UNCOVERED_ELEMENTS_INVALID_FORMAT": "Invalid format for provided uncovered elements",
  "notification.error.ERROR_UNCOVERED_ELEMENTS_REQUIRED": "No uncovered elements provided",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_INVALID_FORMAT": "Invalid format for provided uncovered element amount",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_REQUIRED": "No uncovered element amount provided",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_INVALID_FORMAT": "Invalid format for provided uncovered element label",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_REQUIRED": "No uncovered element label provided",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_LONG": "Provided uncovered element label is too long",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_SHORT": "Provided uncovered element label is too short",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_TOO_LOW": "Provided uncovered element amount is too low",
  "notification.error.ERROR_NO_COMMISSION_RULES_CONFIGURED": "No commission rules are configured for this group",
  "notification.error.NO_RECEIPT_COVERING_TERMINATION_DATE": "No receipt covering termination date provided",
  "notification.error.ERROR_QUOTE_NOT_EDITABLE": "Quote not editable",
  "notification.error.ERROR_CODE_INVALID_FORMAT": "Invalid format for provided code",
  "notification.error.ERROR_OTP_CODE_REQUIRED": "No OTP code provided",
  "notification.error.ERROR_OTP_INVALID_FORMAT": "OTP code must be a 6-digit number",
  "notification.error.ERROR_MANEUVERS_REQUIRED": "No maneuvers provided",
  "notification.error.ERROR_MANEUVERS_INVALID_ARRAY": "Maneuvers must be an array",
  "notification.error.ERROR_MANEUVER_TYPE_REQUIRED": "No maneuver type provided",
  "notification.error.ERROR_MANEUVER_TYPE_INVALID_FORMAT": "Invalid maneuver type",
  "notification.error.ERROR_MANEUVER_INSTRUCTION_REQUIRED": "No maneuver instruction provided",
  "notification.error.ERROR_MANEUVER_INSTRUCTION_INVALID_FORMAT": "Invalid maneuver instruction format",
  "notification.error.ERROR_MANEUVER_DISTANCE_REQUIRED": "No maneuver distance provided",
  "notification.error.ERROR_MANEUVER_DISTANCE_INVALID_FORMAT": "Invalid maneuver distance format",
  "notification.error.ERROR_MANEUVER_DURATION_REQUIRED": "No maneuver duration provided",
  "notification.error.ERROR_MANEUVER_DURATION_INVALID_FORMAT": "Invalid maneuver duration format",
  "notification.error.ERROR_MANEUVER_BEARING_REQUIRED": "No maneuver bearing provided",
  "notification.error.ERROR_MANEUVER_BEARING_INVALID_FORMAT": "Invalid maneuver bearing format",
  "notification.error.ERROR_MANEUVER_STREET_NAME_INVALID_FORMAT": "Invalid maneuver street name format",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_CLIENT_POLICY": "Group has an active client policy",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_PARTNER_POLICY": "Group has an active partner policy",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_ATTRIB_POLICY": "Group has an active attributed policy",
  "notification.error.ERROR_GROUP_HAS_POLICY_IN_RETENTION_PERIOD": "Group has a policy terminated less than five years ago",
  "notification.error.ERROR_GROUP_HAS_CLAIM_IN_RETENTION_PERIOD": "Group has a claim closed less than five years ago",
  "notification.error.ERROR_GROUP_MANAGES_OTHER_GROUPS": "Group manages other groups",
  "notification.error.ERROR_GROUP_HAS_PENDING_PARTNER_INVOICE": "Group has a partner invoice pending payment",
  "notification.error.ERROR_GROUP_HAS_PAYMENTS": "Group has payments in Stripe",
  "notification.error.ERROR_CANNOT_SET_SELF_AS_MANAGING_PARTNER": "A group cannot be set as its own managing partner",
  "notification.error.ERROR_KEEP_RECEIPTS_TYPE": "Invalid type for provided keep_receipts",
  "notification.error.ERROR_CANCEL_REASON_INFO_REQUIRED": "Error cancel reason info required",
  "notification.error.ERROR_SIMULATE_TERMINATION_PENDING_POLICY": "Error simulate termination pending policy",
  "notification.error.ERROR_SIMULATE_TERMINATION_POLICY_EFFECTIVE_START_DATE_TOO_OLD": "Error simulate termination policy effective start date too old",
  "notification.error.ERROR_EVENT_DATE_INVALID_FORMAT": "Invalid format for provided event date.",
  "notification.error.ERROR_EVENT_DATE_REQUIRED": "Event date is required.",
  "notification.error.ERROR_EVENT_INVALID_TYPE": "Invalid type for provided event.",
  "notification.error.ERROR_EVENT_REQUIRED": "Event is required.",
  "notification.error.ERROR_RAW_BODY_REQUIRED": "Raw body is required.",
  "notification.error.ERROR_SUBSCRIPTION_REQUIRED": "Subscription is required.",
  "notification.error.ERROR_SUBSCRIPTION_ID_REQUIRED": "Subscription id is required.",
  "notification.error.ERROR_INVOICE_DATE_REQUIRED": "Invoice date is required.",
  "notification.error.ERROR_INVOICE_DATE_INVALID_FORMAT": "Invalid format for provided invoice date.",
  "notification.error.ERROR_PAYLOAD_REQUIRED": "Payload is required.",
  "notification.error.ERROR_PAYMENT_STATUS_REQUIRED": "Payment status is required.",
  "notification.error.ERROR_UPDATE_INVITATION_DATA_REQUIRED": "At least one invitation update field is required",
  "notification.error.ERROR_UPDATE_MEMBER_DATA_REQUIRED": "At least one member update field is required",
  "notification.error.ERROR_IS_BATTERY_SAFE_REQUIRED": "Is battery safe is required",
  "notification.error.ERROR_KEY_INVALID_TYPE": "Key is invalid type",
  "notification.error.ERROR_KEY_INVALID_FORMAT": "Key has an invalid format",
  "notification.error.ERROR_UPDATE_CLAIM_NOT_ALLOWED": "Update claim not allowed",
  "notification.error.ERROR_VEHICLE_MARKING_CODE_INVALID_FORMAT": "Vehicle marking code is invalid format",
  "notification.error.ERROR_VEHICLE_MARKING_CODE_REQUIRED": "Vehicle marking code is required",
  "notification.error.ERROR_BIKE_ELEMENTS_ONLY_ALLOWED_FOR_PARTIAL_COVERAGE_TYPES": "Bike elements are required when theft partial or damage partial",
  "notification.error.ERROR_FIXED_AMOUNT_TYPE_NOT_ALLOWED": "Creating commission rules with fixed amount type is not allowed",
  "notification.error.ERROR_B2C_CONTRACT_DOES_NOT_EXIST": "No B2C contract found for this package and partner",
  "notification.error.ERROR_OPENING_DATE_BEFORE_OCCURRENCE_END": "Opening date must be after occurrence end",
  "notification.error.ERROR_PARTNER_CANCEL_ALLOWED_REQUIRED": "Partner cancel allowed is required",
  "notification.error.ERROR_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT": "Invalid format for provided partner cancel allowed",
  "notification.error.ERROR_B2B_POLICY_DOES_NOT_EXIST": "B2B policy does not exist",
  "notification.error.ERROR_B2B_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST": "B2B policy cancel request does not exist",
  "notification.error.ERROR_B2B_QUOTE_NOT_FOUND": "B2B quote not found",
  "notification.error.ERROR_B2B_QUOTE_NOT_EDITABLE": "B2B quote not editable",
  "notification.error.ERROR_PARTNER_INVOICE_DOES_NOT_EXIST": "Partner invoice does not exist",
  "notification.error.ERROR_INVALID_PARTNER_INVOICE_STATUS": "Partner invoice status does not allow this action",
  "notification.error.ERROR_PARTNER_INVOICE_DOCUMENT_NOT_FOUND": "Partner invoice document was not found",
  "notification.error.ERROR_PARTNER_INVOICE_EXPORT_NOT_FOUND": "Partner invoice export was not found",
  "notification.error.ERROR_B2B2C_PARTNER_INVOICE_STRIPE_MODE_INVALID_TYPE": "Invalid B2B2C partner invoice Stripe mode",
  "notification.error.ERROR_SEND_EMAIL_INVALID_TYPE": "Invalid format for provided send_email",
  "notification.error.ERROR_EXTERNAL_ID_TOO_LONG": "Provided external id is too long",
  "notification.error.ERROR_COMMENT_TOO_LONG": "Provided comment is too long",
  "notification.error.NO_REFUNDABLE_AMOUNT_MATCHING_REQUESTED_AMOUNT": "No refundable amount close to the requested amount matches the receipts",
  "notification.error.ERROR_LOW_REQUIRED": "Low threshold is required",
  "notification.error.ERROR_LOW_GREATER_THAN_MAX": "Low threshold has to be between 0 and 10000",
  "notification.error.ERROR_HIGH_REQUIRED": "High threshold is required",
  "notification.error.ERROR_HIGH_GREATER_THAN_MAX": "High threshold has to be between 0 and 10000",
  "notification.error.ERROR_HIGH_LOWER_THAN_LOW": "High threshold has to be greater than or equal to low threshold",
  "notification.error.ERROR_ENUM_SCORED_ENTITY_INVALID_TYPE": "Invalid format for provided scored entity",
  "notification.error.ERROR_GREEN_PCT_MISSING": "Green percentage is required",
  "notification.error.ERROR_GREEN_PCT_INVALID_NUMBER": "Green percentage has to be a valid integer",
  "notification.error.ERROR_GREEN_PCT_LOWER_THAN_ZERO": "Green percentage has to be between 0 and 100",
  "notification.error.ERROR_GREEN_PCT_GREATER_THAN_HUNDRED": "Green percentage has to be between 0 and 100",
  "notification.error.ERROR_RED_PCT_MISSING": "Red percentage is required",
  "notification.error.ERROR_RED_PCT_INVALID_NUMBER": "Red percentage has to be a valid integer",
  "notification.error.ERROR_RED_PCT_LOWER_THAN_ZERO": "Red percentage has to be between 0 and 100",
  "notification.error.ERROR_RED_PCT_GREATER_THAN_HUNDRED": "Red percentage has to be between 0 and 100",
  "notification.error.ERROR_GREEN_PLUS_RED_OVER_HUNDRED": "Green and red percentages together cannot exceed 100",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_MISSING": "Referral max redeem is required",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_INVALID_NUMBER": "Referral max redeem must be a valid number",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_LOWER_THAN_ZERO": "Referral max redeem must be greater than or equal to 0",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_MISSING": "Referral percentage redeem is required",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_INVALID_NUMBER": "Referral percentage redeem must be a valid number",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_LOWER_THAN_ZERO": "Referral percentage redeem must be greater than or equal to 0",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_GREATER_THAN_ONE": "Referral percentage redeem must be less than or equal to 1",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_MISSING": "Sponsor max redeem is required",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_INVALID_NUMBER": "Sponsor max redeem must be a valid number",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_LOWER_THAN_ZERO": "Sponsor max redeem must be greater than or equal to 0",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_MISSING": "Amount annual coupon id is required",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_INVALID": "Amount annual coupon id must be a string",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_TOO_LONG": "Amount annual coupon id must be less than 255 characters",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_MISSING": "Percentage annual coupon id is required",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_INVALID": "Percentage annual coupon id must be a string",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_TOO_LONG": "Percentage annual coupon id must be less than 255 characters",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_MISSING": "Amount monthly coupon id is required",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_INVALID": "Amount monthly coupon id must be a string",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_TOO_LONG": "Amount monthly coupon id must be less than 255 characters",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_MISSING": "Percentage monthly coupon id is required",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_INVALID": "Percentage monthly coupon id must be a string",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_TOO_LONG": "Percentage monthly coupon id must be less than 255 characters",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_DUPLICATE": "Vehicle marking codes must be unique",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_EMPTY": "Vehicle marking codes list is empty",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_INVALID_ARRAY": "Invalid array for provided vehicle marking codes",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_NOT_ACTIVE": "Vehicle marking code is not active on the policy",
  "notification.error.ERROR_IS_ONE_OFF_INVALID_FORMAT": "Is one off must be in a correct format",
  "notification.error.ERROR_STRIPE_SIGNATURE_INVALID": "Stripe signature is invalid",
  "notification.error.INVALID_OAUTH_STATE": "Invalid OAuth state",
  "notification.error.ERROR_SEND_MAIL_INVALID_FORMAT": "Send mail must be a boolean",
  "notification.error.POLICY_ALREADY_HAS_AMENDMENT": "Policy already has an amendment",
  "notification.error.ERROR_TERMINATE_POLICY_DUE_DATE_NOT_SIMULABLE": "Termination at due date cannot be simulated",
  "notification.error.ERROR_RJ_UUID_REQUIRED": "RJ UUID is required",
  "notification.error.ERROR_CLAIM_PHOTO_ALREADY_USED": "Claim photo already used",
  "notification.error.ERROR_CLAIM_PHOTO_NOT_FOUND": "Claim photo not found",
  "notification.error.ERROR_CLAIM_PHOTO_NOT_IN_BUCKET": "Claim photo not in bucket",
  "notification.error.ERROR_TRAJECT_TYPE_REQUIRED": "Trajectory type is required",
  "notification.error.ERROR_DISTANCE_REQUIRED": "Distance is required",
  "notification.error.ERROR_CYCLEWAY_PERCENTAGE_REQUIRED": "Cycleway percentage is required",
  "notification.error.ERROR_CYCLEWAY_PERCENTAGE_INVALID_FORMAT": "Cycleway percentage must be in a correct format",
  "notification.error.ERROR_COORDINATES_REQUIRED": "Coordinates are required",
  "notification.error.ERROR_COORDINATES_INVALID_ARRAY": "Coordinates must be an array",
  "notification.error.ERROR_DESTINATION_REQUIRED": "Destination is required",
  "notification.error.ERROR_ELEVATION_INVALID_FORMAT": "Elevation must be in a correct format",
  "notification.error.ERROR_ERROR_DESCRIPTION_INVALID_FORMAT": "Invalid format for provided error description",
  "notification.error.ERROR_OAUTH_ERROR_INVALID_FORMAT": "Invalid format for provided oauth error",
  "notification.error.ERROR_RETURN_TO_INVALID_FORMAT": "Invalid format for provided return to",
  "notification.error.ERROR_SCOPE_INVALID_FORMAT": "Invalid format for provided scope",
  "notification.error.ERROR_STATE_INVALID_FORMAT": "Invalid format for provided state",
  "notification.error.ERROR_ASSIGNED_OPS_USER_OBJECT_INVALID_FORMAT": "Invalid format for provided assigned_ops_user_object",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ALREADY_ASSIGNED": "Assigned ops user already assigned",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ID_INVALID_FORMAT": "Invalid format for provided assigned_ops_user_id",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ID_REQUIRED": "Assigned ops user id is required",
  "notification.error.ERROR_OPS_USER_DOES_NOT_EXIST": "Ops user does not exist",
  "notification.error.QONTO_TRANSFER_MISSING_ID": "Qonto transfer missing id",
  "notification.inapp.title.APP": "New app version !",
  "notification.inapp.title.DOC": "There is news about your documents.",
  "notification.inapp.title.CLAIM": "There is news about your claim.",
  "notification.inapp.title.POLICY": "There is news about your policy.",
  "notification.inapp.title.PLS": 'There is news about your "Park Here" session.',
  "notification.inapp.title.BIKE": "There is news about your bike.",
  "notification.inapp.title.INVOICE": "There is a problem with your payments.",
  "notification.inapp.title.CARD": "There is a problem about your card.",
  "notification.inapp.title.DEFAULT": "There is news",
  "notification.inapp.DOC_REJECTED": 'Your document "{{docType}}" has been rejected.',
  "notification.inapp.DOC_INFORMED": 'We need more information about the document "{{docType}}".',
  "notification.inapp.CLAIM_CLOSED": "Your claim {{claimUniqId}} has been closed.",
  "notification.inapp.CLAIM_CREATED": "Your claim {{claimUniqId}} has been created.",
  "notification.inapp.CLAIM_QUOTE_VALIDATED": "The repair quote for the claim {{claimUniqId}} has been validated.",
  "notification.inapp.CLAIM_VALIDATED": "The claim {{claimUniqId}} has been validated.",
  "notification.inapp.CLAIM_USER_CHECK": "We need you to call the support about your claim {{claimUniqId}}.",
  "notification.inapp.CLAIM_PAID": "The claim {{claimUniqId}} has been paid.",
  "notification.inapp.CARD_EXPIRED": "Your credit card has expired.",
  "notification.inapp.CARD_SOON_EXPIRED": "Your credit card will expire soon. Click here to update it.",
  "notification.inapp.CARD_NO_DEFAULT": "You do not have a default card. Click here to set one.",
  "notification.inapp.INVOICE_UNPAID": "You have an unpaid invoice. Click here to pay it.",
  "notification.inapp.POLICY_SUSPENDED": "Your policy for your {{bikeBrand}} - {{bikeModel}} has been suspended.",
  "notification.inapp.POLICY_TERMINATED": "Your policy for your {{bikeBrand}} - {{bikeModel}} has been terminated.",
  "notification.inapp.POLICY_RENEWED": "Your policy for your {{bikeBrand}} - {{bikeModel}} has been renewed.",
  "notification.inapp.POLICY_CANCEL_PERIOD_END": "Your policy for your {{bikeBrand}} - {{bikeModel}} is set to be cancelled at the end of the contract period.",
  "notification.inapp.POLICY_CANCEL_MONTH_END": "Your policy for your {{bikeBrand}} - {{bikeModel}} is set to be cancelled at the end of the ongoing payment.",
  "notification.inapp.PLS_AUTO_TERMINATED": 'Your "Park Here" session of your {{bikeBrand}} - {{bikeModel}} has been auto-terminated.',
  "notification.inapp.PLS_BATTERY_NOT_REMOVED": "The battery was not removed from your {{bikeBrand}} - {{bikeModel}}",
  "notification.inapp.PLS_WHEEL_ONLY": "It seems your {{bikeBrand}} - {{bikeModel}} was only parked with the wheel. Please check in the app and tell us if it is the case.",
  "notification.inapp.PLS_INCORRECTLY_PARKED": "It seems your {{bikeBrand}} - {{bikeModel}} was incorrectly parked. Please check in the app and tell us if it is the case.",
  "notification.inapp.BIKE_INVALID_CODE": "Your {{bikeBrand}} - {{bikeModel}} has an invalid code.",
  "notification.inapp.BIKE_INVALID_APIC_STATUS": "Your {{bikeBrand}} - {{bikeModel}} has an invalid APIC status. In case of a claim, you must declare the state of the bike to your marking operator.",
  "notification.inapp.APP_UPDATE": "Discover the new features of the app.",
  "notification.inapp.DEFAULT": "There is news",
  "notification.error.ERROR_B2B_POLICY_INVALID_FORMAT": "Invalid format for provided B2B policy",
  "notification.error.ERROR_QUOTES_INVALID_ARRAY": "Provided quotes not an array",
  "notification.error.ERROR_QUOTES_REQUIRED": "No quotes provided",
  "notification.error.ERROR_QUOTES_TOO_MANY": "A maximum of 50 quotes can be created at once",
  "notification.error.ERROR_CLAIM_VEHICLE_IDENTIFIER_REQUIRED": "Bike marking code or serial number is required",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_REQUIRED": "Bike marking code or serial number is required",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_EXCLUSIVE": "Provide only one of bike marking code or serial number",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_NOT_UNIQUE": "Several bikes match this identifier",
  "notification.error.ERROR_PARTNER_TERMINATE_PRIOR_TO_TWELVE_MONTH_INVALID_FORMAT": "Partner terminate prior to twelve month must be a boolean",
  "notification.error.ERROR_ACKNOWLEDGE_DATE_BEFORE_RECEIVED_DATE": "Acknowledge date must be after received date",
  "notification.error.ERROR_ACKNOWLEDGE_DATE_INVALID_FORMAT": "Invalid format for provided acknowledge date",
  "notification.error.ERROR_B2B_CLAIM_OBJECT_INVALID_FORMAT": "Invalid format for provided b2b claim object",
  "notification.error.ERROR_B2C_CLAIM_OBJECT_INVALID_FORMAT": "Invalid format for provided b2c claim object",
  "notification.error.ERROR_CLAIM_COMPLAINT_ALREADY_EXISTS": "Claim complaint already exists",
  "notification.error.ERROR_CLAIM_COMPLAINT_CLAIM_REQUIRED": "No claim provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_INVALID_FORMAT": "Invalid format for provided level 2 comment",
  "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_REQUIRED": "No level 2 comment provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_FEEDBACK_INVALID_FORMAT": "Invalid format for provided feedback",
  "notification.error.ERROR_CLAIM_COMPLAINT_INSURER_NOT_FOUND": "Could not resolve insurer for claim complaint",
  "notification.error.ERROR_CLAIM_COMPLAINT_IS_LEVEL_2_INVALID_FORMAT": "Invalid format for provided is_level_2",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_2_FIELDS_REQUIRE_LEVEL_2": "Level 2 fields require complaint level 2 or higher",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_DECREASE": "Claim complaint level can only increase",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_SKIP": "Claim complaint level can only increase by one",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_INVALID_FORMAT": "Invalid format for provided level",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_REQUIRES_REJECTED_RESPONSE": "Claim complaint level can only increase after the current level is rejected",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_HIGH": "Provided level is too high",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_LOW": "Provided level is too low",
  "notification.error.ERROR_CLAIM_COMPLAINT_OBJECT_INVALID_FORMAT": "Invalid format for provided claim complaint object",
  "notification.error.ERROR_CLAIM_COMPLAINT_POLICY_HOLDER_INFO_MISSING": "Policy holder information is missing",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_ALREADY_SET": "Claim complaint response is already set",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DATE_LEVEL_2_INVALID_FORMAT": "Invalid format for provided level 2 response date",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_ALREADY_SET": "Claim complaint response document is already set",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_MISSING": "Claim complaint response document is missing",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_REQUIRED": "No claim complaint response document provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_INVALID_FORMAT": "Invalid format for provided response",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_ALREADY_SET": "Claim complaint level 2 response is already set",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_DOCUMENT_REQUIRED": "No level 2 response document provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_INVALID_FORMAT": "Invalid format for provided level 2 response",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_REQUIRED": "No level 2 response provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_REQUIRED": "No response provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID": "Invalid claim complaint response template",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID_FORMAT": "Invalid format for provided response template",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_REQUIRED": "No response template provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_INVALID_TYPE": "Invalid type for provided claim complaint subject",
  "notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_REQUIRED": "No claim complaint subject provided",
  "notification.error.ERROR_CLAIM_COMPLAINT_TYPE_INVALID_TYPE": "Invalid type for provided claim complaint type",
  "notification.error.ERROR_CLAIM_COMPLAINT_TYPE_REQUIRED": "No claim complaint type provided",
  "notification.error.ERROR_COMPLAINER_ADDRESS_INVALID_FORMAT": "Invalid format for provided complainer address",
  "notification.error.ERROR_COMPLAINER_ADDRESS_REQUIRED": "No complainer address provided",
  "notification.error.ERROR_COMPLAINER_CITY_INVALID_FORMAT": "Invalid format for provided complainer city",
  "notification.error.ERROR_COMPLAINER_CITY_REQUIRED": "No complainer city provided",
  "notification.error.ERROR_COMPLAINER_FIRSTNAME_INVALID_FORMAT": "Invalid format for provided complainer firstname",
  "notification.error.ERROR_COMPLAINER_FIRSTNAME_REQUIRED": "No complainer firstname provided",
  "notification.error.ERROR_COMPLAINER_LASTNAME_INVALID_FORMAT": "Invalid format for provided complainer lastname",
  "notification.error.ERROR_COMPLAINER_LASTNAME_REQUIRED": "No complainer lastname provided",
  "notification.error.ERROR_COMPLAINER_TYPE_INVALID_TYPE": "Invalid type for provided complainer type",
  "notification.error.ERROR_COMPLAINER_TYPE_REQUIRED": "No complainer type provided",
  "notification.error.ERROR_COMPLAINER_ZIPCODE_REQUIRED": "No complainer zipcode provided",
  "notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_INVALID_FORMAT": "Invalid format for provided financial dispute amount",
  "notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_TOO_LOW": "Provided financial dispute amount is too low",
  "notification.error.ERROR_INSURER_REQUIRED": "No insurer provided",
  "notification.error.ERROR_RECEIVED_DATE_BEFORE_SENDING_DATE": "Received date must be after sending date",
  "notification.error.ERROR_RECEIVED_DATE_INVALID_FORMAT": "Invalid format for provided received date",
  "notification.error.ERROR_RECEIVED_DATE_REQUIRED": "No received date provided",
  "notification.error.ERROR_RECEPTION_MEDIUM_EMPTY": "No reception medium provided",
  "notification.error.ERROR_RECEPTION_MEDIUM_INVALID_ARRAY": "Provided reception medium not an array",
  "notification.error.ERROR_RECEPTION_MEDIUM_INVALID_TYPE": "Invalid type for provided reception medium",
  "notification.error.ERROR_RECEPTION_MEDIUM_REQUIRED": "No reception medium provided",
  "notification.error.ERROR_RESPONSE_DATE_BEFORE_ACKNOWLEDGE_DATE": "Response date must be after acknowledge date",
  "notification.error.ERROR_RESPONSE_DATE_INVALID_FORMAT": "Invalid format for provided response date",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_ACKNOWLEDGE_DATE": "Level 2 response date must be after acknowledge date",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_RESPONSE_DATE": "Level 2 response date must be after response date",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_REQUIRED": "No level 2 response date provided",
  "notification.error.ERROR_RESPONSE_DATE_REQUIRED": "No response date provided",
  "notification.error.ERROR_SENDING_DATE_INVALID_FORMAT": "Invalid format for provided sending date",
  "notification.error.ERROR_SENDING_DATE_REQUIRED": "No sending date provided",
  "notification.error.ERROR_WITH_MEDIATION_INVALID_FORMAT": "Invalid format for provided with mediation",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_FORMAT": "Invalid format for provided customer support ref link",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_URL": "Invalid URL for provided customer support ref link",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_REQUIRED": "No customer support ref link provided",
  "notification.error.ERROR_MISS_FLEET_ADDRESS": "Fleet address is required",
  "notification.error.ERROR_MISS_FLEET_ZIPCODE": "Fleet zip code is required",
  "notification.error.ERROR_MISS_FLEET_CITY": "Fleet city is required",
  "notification.error.ERROR_MISS_FLEET_EMAIL": "Fleet email is required",
  "notification.error.ERROR_MISS_FLEET_PHONE": "Fleet phone number is required",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_INVALID_FORMAT": "Invalid format for provided amendment renew allowed days after end",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_REQUIRED": "Amendment renew allowed days after end is required",
  "notification.error.ERROR_AMENDMENT_RENEW_NOT_ALLOWED": "Amendment or renew is not allowed for this policy",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_MUST_0_AT_LEAST": "Amendment renew allowed days after end must be at least 0",
  "notification.error.ERROR_MISS_CLIENT_OWNER_INFOS": "No client owner infos provided"
};

// src/locales/fr/translation.json
var translation_default2 = {
  "notification.error.DEFAULT_ERROR_MESSAGE": `Une erreur est survenue. Veuillez contacter le support avec l'information "{code}"`,
  "notification.error.ERROR_ID_REQUIRED": "Aucun id fourni",
  "notification.error.ERROR_ID_INVALID_FORMAT": "Format invalide pour l'id fourni",
  "notification.error.ERROR_IDS_REQUIRED": "Aucun ids fourni",
  "notification.error.ERROR_IDS_INVALID_FORMAT": "Format invalide pour les ids fournis",
  "notification.error.ERROR_IDS_EMPTY": "Aucun ids fourni",
  "notification.error.ERROR_IDS_DUPLICATES": "Il y a doublons dans les ids fournis",
  "notification.error.ERROR_NAME_REQUIRED": "Aucun nom fourni",
  "notification.error.ERROR_DATE_REQUIRED": "Aucune date fournie",
  "notification.error.ERROR_DATE_INVALID_FORMAT": "Format invalide pour la date fournie",
  "notification.error.ERROR_PRICE_REQUIRED": "Aucun prix fourni",
  "notification.error.ERROR_PRICE_INVALID_FORMAT": "Format invalide pour le prix fourni",
  "notification.error.ERROR_PRICE_TOO_LOW": "Le prix fourni est trop bas",
  "notification.error.ERROR_PRICE_TOO_HIGH": "Le prix fourni est trop haut",
  "notification.error.ERROR_IS_B2B_INVALID_FORMAT": 'Format invalide pour le "is b2b" fourni',
  "notification.error.ERROR_ZIPCODE_INVALID_FORMAT": "Format invalide pour le code postal fourni",
  "notification.error.ERROR_BODY_REQUIRED": "Aucun payload fourni",
  "notification.error.ERROR_PASSWORD_REQUIRED": "Aucun mot-de-passe fourni",
  "notification.error.ERROR_INVALID_PASSWORD_FORMAT": "Format invalide pour le mot-de-passe fourni",
  "notification.error.ERROR_PASSWORD_CONFIRMATION_REQUIRED": "Aucun mot-de-passe de confirmation fourni",
  "notification.error.ERROR_PASSWORD_CONFIRMATION_INVALID_FORMAT": "Format invalide pour le mot-de-passe de confirmation fourni",
  "notification.error.ERROR_PREVIOUS_PASSWORD_REQUIRED": "Aucun pr\xE9c\xE9dent mot de passe fourni",
  "notification.error.ERROR_PREVIOUS_PASSWORD_INVALID_FORMAT": "Format invalide pour le pr\xE9c\xE9dant mot de passe fourni",
  "notification.error.ERROR_RESET_PASSWORD_CODE_INVALID": "Le code de r\xE9siliation de mot de passe fourni est invalide",
  "notification.error.ERROR_PASSWORDS_DO_NOT_MATCH": "Le mot de passe et le mot de passe de confirmation ne sont pas identiques",
  "notification.error.ERROR_EMAIL_REQUIRED": "Aucun email fourni",
  "notification.error.ERROR_EMAIL_INVALID_FORMAT": "Format invalide pour l'email fourni",
  "notification.error.ERROR_EMAIL_ALREADY_USED": "Email d\xE9j\xE0 utilis\xE9",
  "notification.error.ERROR_DEVICE_DOES_NOT_EXIST": "L'appareil n'existe pas",
  "notification.error.ERROR_USERNAME_REQUIRED": "Aucun nom d'utilisateur fourni",
  "notification.error.ERROR_DEVICE_CONFIRMATION_CODE_INVALID": "Le code de confirmation d'appareil est invalide",
  "notification.error.ERROR_PHONE_REQUIRED": "Aucun num\xE9ro de t\xE9l\xE9phone fourni",
  "notification.error.ERROR_PHONE_INVALID_FORMAT": "Format invalide pour le num\xE9ro de t\xE9l\xE9phone fourni",
  "notification.error.ERROR_ZIPCODE_REQUIRED": "Aucun code postale fourni",
  "notification.error.ERROR_ADDRESS_REQUIRED": "Aucune adresse fournie",
  "notification.error.ERROR_FIRSTNAME_REQUIRED": "Aucun pr\xE9nom fourni",
  "notification.error.ERROR_LASTNAME_REQUIRED": "Aucun nom de famille fourni",
  "notification.error.ERROR_BIRTHDAY_REQUIRED": "Aucune date de naissance fournie",
  "notification.error.ERROR_BIRTHDAY_INVALID_FORMAT": "Format invalide pour la date de naissance fournie",
  "notification.error.ERROR_LATITUDE_REQUIRED": "Aucune latitude fournie",
  "notification.error.ERROR_LATITUDE_INVALID_FORMAT": "Format invalide pour la latitude fournie",
  "notification.error.ERROR_LONGITUDE_REQUIRED": "Aucune longitude fournie",
  "notification.error.ERROR_LONGITUDE_INVALID_FORMAT": "Format invalide pour la longitude fournie",
  "notification.error.ERROR_LATITUDE_DELTA_REQUIRED": "Aucun delta de latitude fourni",
  "notification.error.ERROR_LATITUDE_DELTA_INVALID_FORMAT": "Format invalide pour le delta de latitude fourni",
  "notification.error.ERROR_LATITUDE_DELTA_TOO_HIGH": "Le delta de latitude fourni est trop \xE9lev\xE9",
  "notification.error.ERROR_LONGITUDE_DELTA_REQUIRED": "Pas de delta de longitude fourni",
  "notification.error.ERROR_LONGITUDE_DELTA_INVALID_FORMAT": "Format non valide pour le delta de longitude fourni",
  "notification.error.ERROR_LONGITUDE_DELTA_TOO_HIGH": "Le delta de longitude est trop grand",
  "notification.error.ERROR_INVALID_AUTH_FORM": "Mot de passe ou nom d'utilisateur invalide",
  "notification.error.ERROR_MFA_TOKEN_INVALID": "Le token MFA fourni est invalide",
  "notification.error.ERROR_MAIL_OPT_IN_REQUIRED": "Aucune information d'opt-in de mail fournie",
  "notification.error.ERROR_MAIL_OPT_IN_INVALID_FORMAT": "Format invalide pour l'information d'opt-in de mail fournie",
  "notification.error.ERROR_ROLE_REQUIRED": "Aucun r\xF4le fourni",
  "notification.error.ERROR_ROLE_INVALID_TYPE": "Type invalide pour le r\xF4le fourni",
  "notification.error.ERROR_BANK_DOES_NOT_EXIST": "Banque inexistante",
  "notification.error.ERROR_BIC_REQUIRED": "Aucun BIC fourni",
  "notification.error.ERROR_BIC_TOO_SHORT": "Le BIC doit \xEAtre long d'au moins 6 caract\xE8res",
  "notification.error.ERROR_BANK_CODE_REQUIRED": "Aucun code de banque fourni",
  "notification.error.ERROR_BANK_CODE_TOO_LOW": "Le code de banque fourni est trop bas",
  "notification.error.ERROR_BANK_CODE_TOO_HIGH": "Le code de banque fourni est trop haut",
  "notification.error.ERROR_BANK_CODE_INVALID_FORMAT": "Format invalide pour le code de banque fourni",
  "notification.error.ERROR_DANGER_LEVEL_REQUIRED": "Aucun niveau de danger n'est indiqu\xE9",
  "notification.error.ERROR_DANGER_LEVEL_INVALID_FORMAT": "Format invalide pour le niveau de danger fourni",
  "notification.error.ERROR_DANGER_LEVEL_TOO_LOW": "Le niveau de danger doit \xEAtre inf\xE9rieur ou \xE9gal \xE0 1",
  "notification.error.ERROR_DANGER_LEVEL_TOO_HIGH": "Le niveau de danger doit \xEAtre inf\xE9rieur ou \xE9gal \xE0 3",
  "notification.error.ERROR_BIKE_MODEL_DOES_NOT_EXIST": "Le mod\xE8le de v\xE9lo n'existe pas",
  "notification.error.ERROR_BRAND_REQUIRED": "Aucune marque n'est indiqu\xE9e",
  "notification.error.ERROR_BRAND_INVALID_FORMAT": "Format non valide pour la marque fournie",
  "notification.error.ERROR_BRAND_INVALID_LENGTH": "Longueur incorrecte pour la marque fournie",
  "notification.error.ERROR_MODEL_REQUIRED": "Aucun model fourni",
  "notification.error.ERROR_MODEL_INVALID_LENGTH": "Taille invalide pour le mod\xE8le fourni",
  "notification.error.ERROR_APPROVED_INVALID_FORMAT": "Format invalide pour l'information d'approbation fournie",
  "notification.error.ERROR_BRAND_CODE_INVALID_LENGTH": "Taille invalide pour la marque fournie",
  "notification.error.ERROR_CATEGORY_INVALID_LENGTH": "Taille invalide pour la cat\xE9gorie fournie",
  "notification.error.ERROR_CATEGORY_CODE_INVALID_LENGTH": "Taille invalide pour le code de cat\xE9gorie fourni",
  "notification.error.ERROR_ELECTRIC_INVALID_FORMAT": `Format invalide pour l'information "\xE9lectrique" fournie`,
  "notification.error.ERROR_IMAGE_URL_INVALID_LENGTH": "Taille invalide pour l'URL de l'image fournie",
  "notification.error.ERROR_MODEL_CODE_INVALID_LENGTH": "Taille invalide pour le mod\xE8le fourni",
  "notification.error.ERROR_SHARELOCK_COMPATIBILITY_PERCENTAGE_INVALID_FORMAT": "Format invalide pour le pourcentage de compatibilit\xE9 au Sharelock fourni",
  "notification.error.ERROR_SHARELOCK_COMPATIBLE_INVALID_FORMAT": "Format invalide pour l'information de compatibilit\xE9 au Sharelock",
  "notification.error.ERROR_YEAR_INVALID_FORMAT": "Format invalide pour l'ann\xE9e fournie",
  "notification.error.ERROR_PREVBRAND_REQUIRED": "Aucune pr\xE9c\xE9dente marque forunie",
  "notification.error.ERROR_SUGGESTION_ID_REQUIRED": "Aucun id sugg\xE9r\xE9 fourni",
  "notification.error.ERROR_BIKE_ID_REQUIRED": "Aucun id de v\xE9lo fourni",
  "notification.error.ERROR_SUGGESTION_ID_AND_BIKE_ID_MUST_BE_DIFFERENT": "L'id sugg\xE9r\xE9 et l'id renseign\xE9 doivent \xEAtre diff\xE9rent",
  "notification.error.ERROR_CITY_DOES_NOT_EXIST": "La ville n'existe pas",
  "notification.error.ERROR_CURRENT_CITY_INVALID_FORMAT": "Format invalide pour la ville actuelle fournie",
  "notification.error.ERROR_IS_ARCHIVED_REQUIRED": 'Aucune information sur "is archived" fournie',
  "notification.error.ERROR_IS_ARCHIVED_INVALID_FORMAT": `Format invalide pour l'information "is archived" fournie`,
  "notification.error.ERROR_USER_DOES_NOT_EXIST": "L'utilisateur n'existe pas",
  "notification.error.ERROR_USER_ID_REQUIRED": "Aucun id utilisateur fourni",
  "notification.error.ERROR_USER_ID_INVALID_FORMAT": "Format invalide pour l'id utilisateur fourni",
  "notification.error.ERROR_USERS_REQUIRED": "Aucun utilisateur fourni",
  "notification.error.ERROR_USERS_INVALID_FORMAT": "Format invalide pour les utilisateurs fournis",
  "notification.error.ERROR_TAG_REQUIRED": "Aucun tag fourni",
  "notification.error.ERROR_REASON_REQUIRED": "Aucune raison fournie",
  "notification.error.ERROR_TAG_DATE_INVALID_FORMAT": "Format invalide pour la date du tag fournie",
  "notification.error.ERROR_BLOCKED_INVALID_FORMAT": "Format invalide pour l'information de blocage fournie",
  "notification.error.ERROR_CONFIRMED_INVALID_FORMAT": "Format invalide pour l'infirmation de confirmation de compte fourni",
  "notification.error.ERROR_BANK_INVALID_FORMAT": "Format invalide pour la banque fournie",
  "notification.error.ERROR_PHOTO_REQUIRED": "Aucune photo fournie",
  "notification.error.ERROR_VIGIMAP_INVALID_FORMAT": "Format invalide pour l'information vigimap fournie",
  "notification.error.ERROR_VIGIMAP_POPUP_INVALID_FORMAT": "Format invalide pour l'information popup vigimap fournie",
  "notification.error.ERROR_BATTERY_POPUP_INVALID_FORMAT": "Format invalide pour la popup batterie fournie",
  "notification.error.ERROR_ALWAYS_GEOLOCATION_TRACKING_INVALID_FORMAT": "Format invalide pour le tracking de la g\xE9olocalisation fournie",
  "notification.error.ERROR_REDIRECT_AFTER_LOGIN_INVALID_TYPE": "Format invalide pour la redirection apr\xE8s authentification fournie",
  "notification.error.ERROR_ROLES_TO_ADD_INVALID_TYPE": "Type invalide pour les r\xF4les \xE0 ajouter fournis",
  "notification.error.ERROR_ROLES_TO_REMOVE_INVALID_TYPE": "Type invalide pour les r\xF4les \xE0 enlever fournis",
  "notification.error.ERROR_ROLES_REQUIRED": "Aucun r\xF4le fourni",
  "notification.error.ERROR_GROUP_DOES_NOT_EXIST": "Le groupe n'existe pas",
  "notification.error.ERROR_GROUP_ID_REQUIRED": "Aucun id de groupe fourni",
  "notification.error.ERROR_GROUP_ID_INVALID_FORMAT": "Format invalide pour l'id de groupe",
  "notification.error.ERROR_PARTNER_DOES_NOT_EXIST": "Partenaire inexistant",
  "notification.error.ERROR_PARTNER_ID_REQUIRED": "Aucun id de partenaire fourni",
  "notification.error.ERROR_PARTNER_ID_INVALID_FORMAT": "Format invalide pour l'id de partenaire",
  "notification.error.ERROR_SIRET_REQUIRED": "Aucun siret fourni",
  "notification.error.ERROR_SIRET_ALREADY_EXISTS": "Le siret fourni existe d\xE9j\xE0",
  "notification.error.ERROR_CITY_REQUIRED": "Aucune ville fournie",
  "notification.error.ERROR_TYPOLOGY_INVALID_TYPE": "Type invalide pour la typologie fournie",
  "notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_TYPE": "Type invalide pour le type de police fournie",
  "notification.error.ERROR_ORIAS_TOO_LONG": "L'orias fourni est trop long",
  "notification.error.ERROR_EXPECTED_TARGETS_INVALID_FORMAT": "Format non valide pour les cibles attendues",
  "notification.error.ERROR_USE_PROMOTION_CODE_FOR_ATTRIBUTION_INVALID_FORMAT": "Format invalide pour l'information d'utilisation du code promotionnel pour attribution fournie",
  "notification.error.ERROR_PROMOTION_CODES_INVALID_FORMAT": "Format invalide pour le code promotionnel fourni",
  "notification.error.ERROR_PROMOTION_CODES_DUCPLICATE": "Il y a des doublons dans les codes promotionnels fournis",
  "notification.error.ERROR_OPS_ID_INVALID_FORMAT": "Format invalide pour l'id d'Ops fourni",
  "notification.error.ERROR_USER_ALREADY_IN_GROUP": "L'utilisateur est d\xE9j\xE0 membre du groupe fourni",
  "notification.error.ERROR_USER_ALREADY_INVITED": "L'utilisateur fourni a d\xE9j\xE0 \xE9t\xE9 invit\xE9 au groupe fourni",
  "notification.error.ERROR_NO_VEHICLE_GIVEN": "Aucun v\xE9hicule fourni",
  "notification.error.ERROR_DOCUMENT_DOES_NOT_EXIST": "Le document n'existe pas",
  "notification.error.ERROR_FILENAME_REQUIRED": "Aucun nom de fichier fourni",
  "notification.error.ERROR_VERSO_FILENAME_REQUIRED": "Aucun nom de fichier pour le verso fourni",
  "notification.error.ERROR_UUID_REQUIRED": "Aucun uuid fourni",
  "notification.error.ERROR_VERSO_UUID_REQUIRED": "Aucun uuid poiur le verso fourni",
  "notification.error.ERROR_MIME_TYPE_REQUIRED": "Aucun mime type fourni",
  "notification.error.ERROR_MIME_TYPE_INVALID_TYPE": "Type invalide pour le mime type fourni",
  "notification.error.ERROR_VERSO_MIME_TYPE_REQUIRED": "Aucun mime type pour le verso fourni",
  "notification.error.ERROR_VERSO_MIME_TYPE_INVALID_TYPE": "Type invalide pour le mime type fourni pour le verso",
  "notification.error.ERROR_SIZE_INVALID_FORMAT": "Format invalide",
  "notification.error.ERROR_VERSO_SIZE_INVALID_FORMAT": "Format invalide pour la taille fourni pour le verso",
  "notification.error.ERROR_OWNER_INVALID_FORMAT": "Format invalide pour le propri\xE9taire fourni",
  "notification.error.ERROR_TYPE_REQUIRED": "Aucun type fourni",
  "notification.error.ERROR_TYPE_INVALID_TYPE": "Type invalide pour le type fourni",
  "notification.error.ERROR_OBJECT_ID_REQUIRED": "Aucun id d'objet fourni",
  "notification.error.ERROR_OBJECT_ID_INVALID_FORMAT": "Format invalide pour l'id d'objet fourni",
  "notification.error.ERROR_IS_EXPIRED_REQUIRED": "Aucune information sur l'expiration fournie",
  "notification.error.ERROR_IS_EXPIRED_INVALID_FORMAT": "Format invalide pour l'information sur l'expiration fournie",
  "notification.error.ERROR_EXPIRATION_DATE_INVALID_FORMAT": "Format invalide pour la date d'expiration fournie",
  "notification.error.ERROR_INFORM_REASON_REQUIRED": "Aucune raison de notification fournie",
  "notification.error.ERROR_REJECT_REASON_REQUIRED": "Aucune raison de rejet fournie",
  "notification.error.ERROR_ROTATE_FACTOR_REQUIRED": "Aucun facteur de rotation fourni",
  "notification.error.ERROR_ROTATE_FACTOR_INVALID_FORMAT": "Format invalide pour le facteur de rotation fourni",
  "notification.error.ERROR_WITHOUT_EXPIRED_INVALID_FORMAT": `Format invalid pour l'information "without expired"`,
  "notification.error.ERROR_DOCUMENT_ALREADY_VALIDATED": "Le document fourni est d\xE9j\xE0 valid\xE9",
  "notification.error.ERROR_DOCUMENT_ALREADY_REJECTED": "Le document fourni est d\xE9j\xE0 rejet\xE9",
  "notification.error.ERROR_USER_ALREADY_INFORMED": "L'utilisateur a d\xE9j\xE0 \xE9t\xE9 inform\xE9",
  "notification.error.ERROR_DOCUMENT_NOT_RESETTABLE": "Le document fourni n'est pas r\xE9initialisable",
  "notification.error.ERROR_NOTES_REQUIRED": "Aucune note fournie",
  "notification.error.ERROR_SEND_TO_USER_REQUIRED": "Aucune information sur l'envoi \xE0 l'utilisateur ou non fournie",
  "notification.error.ERROR_SEND_TO_USER_INVALID_FORMAT": "Format invalide pour l'information sur l'envoi \xE0 l'utilisateur ou non fournie",
  "notification.error.ERROR_COMMENT_REQUIRED": "Aucun commentaire fourni",
  "notification.error.ERROR_IS_OBJECT_INVALID_FORMAT": `Format invalide pour l'information "is object" fournie`,
  "notification.error.ERROR_REJECTED_INVALID_FORMAT": "Format invalide pour l'information de rejet fournie",
  "notification.error.ERROR_NEW_TYPE_REQUIRED": "Aucun nouveau type fourni",
  "notification.error.ERROR_NEW_TYPE_INVALID_TYPE": "Type invalide pour le nouveau type fourni",
  "notification.error.ERROR_NEW_LINK_REQUIRED": "Aucun nouveau lien fourni",
  "notification.error.ERROR_NEW_LINK_INVALID_FORMAT": "Format invalide pour le nouveau lien fourni",
  "notification.error.ERROR_CONTRACT_DOES_NOT_EXIST": "Le contrat n'existe pas",
  "notification.error.ERROR_CONTRACT_ID_REQUIRED": "Aucun id de contrat fourni",
  "notification.error.ERROR_CONTRACT_ID_INVALID_FORMAT": "Format invalide pour l'id de contrat fourni",
  "notification.error.ERROR_PACKAGE_DOES_NOT_EXIST": "La formule n'existe pas",
  "notification.error.ERROR_PACKAGE_ID_REQUIRED": "Aucun id de package fourni",
  "notification.error.ERROR_PACKAGE_ID_INVALID_FORMAT": "Format invalide pour l'id de la formule fournie",
  "notification.error.ERROR_PAYMENT_METHOD_REQUIRED": "Aucune m\xE9thode de paiement fournie",
  "notification.error.ERROR_PAYMENT_METHOD_TOO_SHORT": "Le moyen de paiement indiqu\xE9 est trop court",
  "notification.error.ERROR_PAYMENT_METHOD_NOT_FOUND": "Aucune m\xE9thode de paiement n'a \xE9t\xE9 d\xE9finie",
  "notification.error.ERROR_PAYMENT_METHOD_ID_REQUIRED": "Aucun id de m\xE9thode de paiement fourni",
  "notification.error.ERROR_PAYMENT_METHOD_ID_TOO_SHORT": "La m\xE9thode de paiement fournie est trop courte",
  "notification.error.ERROR_PAYMENT_METHOD_TYPE_REQUIRED": "Aucun type de m\xE9thode de paiement fourni",
  "notification.error.ERROR_PAYMENT_METHOD_TYPE_INVALID_TYPE": "Type invalide pour le type de m\xE9thode de paiement fourni",
  "notification.error.ERROR_PAYMENT_INTENT_ID_REQUIRED": "Aucun id de tentative de paiement fourni",
  "notification.error.ERROR_PAYMENT_INTENT_ID_TOO_SHORT": "L'id de tentative de paiement fourni est trop court",
  "notification.error.ERROR_INVOICE_ID_REQUIRED": "Aucun identifiant de facture fourni",
  "notification.error.ERROR_VEHICLE_ID_REQUIRED": "Aucun id de v\xE9hicule fourni",
  "notification.error.ERROR_VEHICLE_ID_INVALID_FORMAT": "Format invalide pour l'id de v\xE9hicule fourni",
  "notification.error.ERROR_PURCHASE_PROOF_REQUIRED": "Aucune preuve d'achat fournie",
  "notification.error.ERROR_PURCHASE_PROOF_INVALID_FORMAT": "Format non valide pour la preuve d'achat fournie",
  "notification.error.ERROR_PURCHASE_DATE_REQUIRED": "Aucune date d'achat fournie",
  "notification.error.ERROR_PURCHASE_DATE_INVALID_FORMAT": "Format invalide pour la date d'achat fournie",
  "notification.error.ERROR_PURCHASE_DATE_TOO_OLD": "La date d'achat indiqu\xE9e est trop ancienne (5 ans au maximum)",
  "notification.error.ERROR_BICYCODE_REQUIRED": "Aucun code de marquage n'est indiqu\xE9",
  "notification.error.ERROR_BICYCODE_INVALID_LENGTH": "Taille invalide pour le code de marquage fourni",
  "notification.error.ERROR_COMMENT_INVALID_LENGTH": "Taille invalide pour le commentaire fourni",
  "notification.error.ERROR_DATAS_REQUIRED": "Aucune data fournie",
  "notification.error.ERROR_DATAS_EMPTY": "Aucune data fournie",
  "notification.error.ERROR_FLEET_DOES_NOT_EXIST": "La flotte fournie n'existe pas",
  "notification.error.ERROR_FLEET_INVALID_FORMAT": "Format invalide pour la flotte fournie",
  "notification.error.ERROR_FILE_REQUIRED": "Aucun fichier fourni",
  "notification.error.ERROR_URL_REQUIRED": "Aucune url fournie",
  "notification.error.ERROR_DEMAND_DATE_REQUIRED": "Aucune date de demande fournie",
  "notification.error.ERROR_DEMAND_DATE_INVALID_FORMAT": "Format non valide pour la date de demande fournie",
  "notification.error.ERROR_INTERVENTION_TYPE_REQUIRED": "Aucun type d'intervention fourni",
  "notification.error.ERROR_INTERVENTION_TYPE_INVALID_TYPE": "Type invalide pour le type d'intervention fourni",
  "notification.error.ERROR_WARRANTY_REQUIRED": "Aucune garantie fournie",
  "notification.error.ERROR_WARRANTY_INVALID_TYPE": "Type invalide pour la garantie fournie",
  "notification.error.ERROR_WARRANTY_CONDITION_REQUIRED": "Aucune condition de garantie fournie",
  "notification.error.ERROR_WARRANTY_CONDITION_INVALID_FORMAT": "Format invalide pour la condition de garantie fournie",
  "notification.error.ERROR_OPERATIONS_REQUIRED": "Aucune op\xE9ration fournie",
  "notification.error.ERROR_OPERATIONS_EMPTY": "Aucune op\xE9ration fournie",
  "notification.error.ERROR_OPERATIONS_INVALID_TYPE": "Type invalide pour les op\xE9rations fournies",
  "notification.error.ERROR_PROBLEM_DESCRIPTION_REQUIRED": "Aucune description du probl\xE8me fournie",
  "notification.error.ERROR_WHISHES_REQUIRED": "Aucun souhait fourni",
  "notification.error.ERROR_WHISHES_EMPTY": "Aucun souhait fourni",
  "notification.error.ERROR_WISHES_INVALID_TYPE": "Type invalide pour les souhaits fournis",
  "notification.error.ERROR_INTERVENTION_ADDRESS_REQUIRED": "Aucune adresse d'intervention fournie",
  "notification.error.ERROR_AVAILABILITIES_REQUIRED": "Aucune disponibilit\xE9 fournie",
  "notification.error.ERROR_BIKE_PICS_REQUIRED": "Aucune photo du v\xE9hicule fournie",
  "notification.error.ERROR_BIKE_PICS_INVALID_FORMAT": "Aucune photo du v\xE9lo fournie",
  "notification.error.ERROR_BIKE_PICS_EMPTY": "Aucune photo du v\xE9lo fournie",
  "notification.error.ERROR_BIKE_PICS_INVALID_TYPE": "Type invalide pour les photos du v\xE9lo fournies",
  "notification.error.ERROR_DOCUMENTS_REQUIRED": "Aucun document fourni",
  "notification.error.ERROR_DOCUMENTS_INVALID_FORMAT": "Format invalide pour les documents fournis",
  "notification.error.ERROR_DOCUMENTS_CANNOT_EMPTY": "Aucun document fourni",
  "notification.error.ERROR_DOCUMENTS_INVALID_TYPE": "Type invalide pour les documents fournis",
  "notification.error.ERROR_FOLDER_KEY_REQUIRED": "Aucune cl\xE9 de dossier fourni",
  "notification.error.ERROR_LEAD_DOES_NOT_EXIST": "Le prospect n'existe pas",
  "notification.error.ERROR_INSURED_VALUE_INVALID_FORMAT": "Format invalide pour la valeur assur\xE9e fournie",
  "notification.error.ERROR_FROM_SOURCE_INVALID_TYPE": "Type invalide pour la source fournie",
  "notification.error.ERROR_STATUS_INVALID_TYPE": "Type invalide pour le status fourni",
  "notification.error.ERROR_NEWS_LETTER_OPT_IN_INVALID_FORMAT": "Format invalide pour l'information d'opt-in pour la newsletter fournie",
  "notification.error.ERROR_PHONE_OPT_IN_INVALID_FORMAT": "Format invalide pour l'information d'opt-in pour les appels",
  "notification.error.ERROR_ADDITIONAL_INFORMATION_INVALID_FORMAT": "Format invalide pour les informations additionnelles fournies",
  "notification.error.ERROR_TOKEN_REQUIRED": "Aucun token fourni",
  "notification.error.ERROR_QUOTE_DOES_NOT_EXIST": "Le devis n'existe pas",
  "notification.error.ERROR_LOCK_MODEL_DOES_NOT_EXIST": "Le mod\xE8le de cadenas n'existe pas",
  "notification.error.ERROR_LOCKS_IDS_REQUIRED": "Aucun id de cadenas fourni",
  "notification.error.ERROR_LOCKS_IDS_INVALID_FORMAT": "Format invalide pour les ids de cadenas fournis",
  "notification.error.ERROR_IS_APPROVED_REQUIRED": "Aucune information sur l'approbation fournie",
  "notification.error.ERROR_IS_APPROVED_INVALID_FORMAT": "Format invalide pour l'information d'approbation fournie",
  "notification.error.ERROR_TYPE_INVALID_LENGTH": "Taille invalide pour le type fourni",
  "notification.error.ERROR_SECURITY_CERTIFICATE_REQUIRED": "Aucun certificat de s\xE9curit\xE9 fourni",
  "notification.error.ERROR_SECURITY_CERTIFICATE_INVALID_LENGTH": "Taille invalide pour le certificat de s\xE9curit\xE9 fourni",
  "notification.error.ERROR_LEVEL_INVALID_LENGTH": "Taille invalide pour le niveau fourni",
  "notification.error.ERROR_FRAUD_PARTNER_ID_REQUIRED": "Aucun id de partenaire contre la fraude fourni",
  "notification.error.ERROR_FRAUD_PARTNER_ID_INVALID_FORMAT": "Format invalide pour l'id de partenaire contre la fraude",
  "notification.error.ERROR_ALREADY_FRAUD_PARTNER": "L'id de partenaire contre la fraude est d\xE9j\xE0 un partenaire contre la fraude",
  "notification.error.ERROR_FRAUD_PARTNER_DOES_NOT_EXIST": "Le partenaire contre la fraude n'existe pas",
  "notification.error.ERROR_CLAIM_DATE_INVALID_FORMAT": "Format invalide pour la date du sinistre",
  "notification.error.ERROR_CODE_REQUIRED": "Aucun code fourni",
  "notification.error.ERROR_CODE_INVALID_LENGTH": "Taille invalide pour le code fourni",
  "notification.error.ERROR_CODE_ID_REQUIRED": "Aucun id de code fourni",
  "notification.error.ERROR_CODE_ID_INVALID_FORMAT": "Format invalide pour l'id de code fourni",
  "notification.error.ERROR_YEAR_REQUIRED": "Aucune ann\xE9e fournie",
  "notification.error.ERROR_NOTIF_IDS_REQUIRED": "Aucun id de notification fourni",
  "notification.error.ERROR_NOTIF_IDS_EMPTY": "Aucun id de notification fourni",
  "notification.error.ERROR_NOTIF_IDS_INVALID_FORMAT": "Format invalide pour les ids de notification fournis",
  "notification.error.ERROR_USERS_IDS_REQUIRED": "Aucun id d'utilisateur fourni",
  "notification.error.ERROR_USERS_IDS_INVALID_FORMAT": "Format invalide pour les ids d'utilisateur fournis",
  "notification.error.ERROR_USERS_IDS_EMPTY": "Aucun id d'utilisateur fourni",
  "notification.error.ERROR_MESSAGE_REQUIRED": "Aucun message fourni",
  "notification.error.ERROR_TITLE_REQUIRED": "Aucun titre fourni",
  "notification.error.ERROR_START_DATE_IN_THE_PAST": "La date de d\xE9but fournie ne doit pas \xEAtre dans le pass\xE9",
  "notification.error.ERROR_START_DATE_INVALID_FORMAT": "Format invalide pour la date de d\xE9but fournie",
  "notification.error.ERROR_EXPIRATION_BEFORE_START": "La date d'expiration doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but",
  "notification.error.ERROR_MISSING_EXPIRATION_DATE": "Aucune date d'expiration n'est indiqu\xE9e",
  "notification.error.ERROR_EXPIRATION_DATE_NOT_IN_FUTUR": "La date d'expiration communiqu\xE9e doit se situer dans le futur",
  "notification.error.ERROR_PRIORITY_LEVEL_REQUIRED": "Aucun niveau de priorit\xE9 fourni",
  "notification.error.ERROR_PRIORITY_LEVEL_INVALID_TYPE": "Type invalide pour le niveau de priorit\xE9 fourni",
  "notification.error.ERROR_SEND_VIA_FIREBASE_REQUIRED": "Aucune information sur l'envoi via Firebase fournie",
  "notification.error.ERROR_SEND_VIA_FIREBASE_INVALID_FORMAT": "Format invalide pour l'information sur l'envoi via Firebase fournie",
  "notification.error.ERROR_AUTH_TOKEN_ID_REQUIRED": "Aucun id de token d'authentification fourni",
  "notification.error.ERROR_AUTH_TOKEN_ID_INVALID_FORMAT": "Format invalide pour l'id de token d'authentification fourni",
  "notification.error.ERROR_PHONE_OPERATOR_DOES_NOT_EXIST": "L'op\xE9rateur t\xE9l\xE9phonique n'existe pas",
  "notification.error.ERROR_NAME_TOO_SHORT": "Nom fourni trop court",
  "notification.error.ERROR_OPERATOR_CODE_REQUIRED": "Aucun code d'op\xE9rateur fourni",
  "notification.error.ERROR_OPERATOR_CODE_TOO_LOW": "Le code d'op\xE9rateur fourni est trop bas",
  "notification.error.ERROR_OPERATOR_CODE_TOO_HIGH": "Le code d'op\xE9rateur fourni est trop haut",
  "notification.error.ERROR_OPERATOR_CODE_INVALID_FORMAT": "Format invalide pour le code d'op\xE9rateur fourni",
  "notification.error.ERROR_PROMOTION_CODE_DOES_NOT_EXIST": "Le code de promotion n'existe pas",
  "notification.error.ERROR_PROMOTION_CODE_ALREADY_EXISTS": "Code promotionnel d\xE9j\xE0 existant",
  "notification.error.ERROR_ACTIVE_INVALID_FORMAT": "Format invalide pour l'information d'activation fournie",
  "notification.error.ERROR_PRODUCT_REQUIRED": "Aucun produit fourni",
  "notification.error.ERROR_PRODUCT_INVALID_TYPE": "Type invalide pour le produit fourni",
  "notification.error.ERROR_MONTHLY_REQUIRED": "Aucun code mensuel fourni",
  "notification.error.ERROR_MONTHLY_INVALID_LENGTH": "Taille invalide pour le code mensuel fourni",
  "notification.error.ERROR_ANNUAL_REQUIRED": "Aucun code annuel fourni",
  "notification.error.ERROR_ANNUAL_INVALID_LENGTH": "Taille invalide pour le code annuel fourni",
  "notification.error.ERROR_MAX_REDEEM_TOTAL_INVALID_FORMAT": "Format invalide pour le nombre maximal d'utilisations fourni",
  "notification.error.ERROR_MAX_REDEEM_PER_USER_INVALID_FORMAT": "Format invalide pour le nombre maximal d'utilisations par utilisateur fourni",
  "notification.error.ERROR_LOCK_REQUIRED": "Aucun cadenas fourni",
  "notification.error.ERROR_LOCK_INVALID_LENGTH": "Taille invalide pour le cadenas fourni",
  "notification.error.ERROR_PROMOTION_CODE_EXPIRED": "Le code de promotion fourni est expir\xE9",
  "notification.error.ERROR_INPUT_REQUIRED": "Aucune entr\xE9e fournie",
  "notification.error.ERROR_COVERAGE_CODE_REQUIRED": "Aucun code de couverture fourni",
  "notification.error.ERROR_COVERAGE_CODE_INVALID_TYPE": "Type invalide pour le code de couverture fourni",
  "notification.error.ERROR_LOCKING_SESSION_DOES_NOT_EXIST": "La session cadenas n'existe pas",
  "notification.error.ERROR_LOCKING_SESSION_ID_INVALID_FORMAT": "Format invalide pour l'id de session cadenas fourni",
  "notification.error.ERROR_LOCK_DOES_NOT_EXIST": "Le cadenas n'existe pas",
  "notification.error.ERROR_LOCK_ID_REQUIRED": "Aucun id de cadenas fourni",
  "notification.error.ERROR_LOCK_ID_INVALID_FORMAT": "Format invalide pour l'id de cadenas fourni",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_DOES_NOT_EXIST": "La session assurance n'existe pas",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_FORMAT": "Format invalide pour l'id de session assurance fournie",
  "notification.error.ERROR_DESCRIPTION_REQUIRED": "Aucune description fournie",
  "notification.error.ERROR_SOURCE_REQUIRED": "Aucune source fournie",
  "notification.error.ERROR_SOURCE_INVALID_TYPE": "Type invalide pour la source fournie",
  "notification.error.ERROR_MILEAGE_REQUIRED": "Aucun kilom\xE9trage fourni",
  "notification.error.ERROR_MILEAGE_INVALID_FORMAT": "Format invalide pour le kilom\xE9trage fourni",
  "notification.error.ERROR_BUYING_YEAR_REQUIRED": "Aucune ann\xE9e d'achat fournie",
  "notification.error.ERROR_BUYING_YEAR_TOO_LOW": "L'ann\xE9e d'achat fournie est trop basse",
  "notification.error.ERROR_BUYING_YEAR_IN_THE_FUTURE": "L'ann\xE9e d'achat fournie ne doit pas \xEAtre dans le futur",
  "notification.error.ERROR_BUYING_YEAR_INVALID_FORMAT": "Format invalide pour l'ann\xE9e d'achat fournie",
  "notification.error.ERROR_BUYING_PRICE_REQUIRED": "Aucun prix d'achat fourni",
  "notification.error.ERROR_BUYING_PRICE_INVALID_FORMAT": "Format invalide pour le prix d'achat fourni",
  "notification.error.ERROR_CATEGORY_REQUIRED": "Aucune cat\xE9gorie fournie",
  "notification.error.ERROR_CATEGORY_INVALID_TYPE": "Type invalide pour la cat\xE9gorie fournie",
  "notification.error.ERROR_COLOR_REQUIRED": "Aucune couleur fournie",
  "notification.error.ERROR_COLOR_INVALID_TYPE": "Type invalide pour la couleur fournie",
  "notification.error.ERROR_SIZE_REQUIRED": "Aucune taille fournie",
  "notification.error.ERROR_BATTERY_CAPACITY_REQUIRED": "Aucune capacit\xE9 de batterie fournie",
  "notification.error.ERROR_BATTERY_CAPACITY_INVALID_FORMAT": "Format invalide pour la capacit\xE9 de batterie fournie",
  "notification.error.ERROR_ORIGIN_REQUIRED": "Aucune origine fournie",
  "notification.error.ERROR_ORIGIN_INVALID_TYPE": "Type invalide pour l'origine fournie",
  "notification.error.ERROR_PROPOSED_PRICE_INVALID_FORMAT": "Format invalide pour le prix propos\xE9",
  "notification.error.ERROR_CREATING_TRADE_IN_REQUEST": "Impossible de cr\xE9er demande de reprise",
  "notification.error.ERROR_ANDROID_INVALID_FORMAT": "Format invalide pour la version Android fournie",
  "notification.error.ERROR_IOS_INVALID_FORMAT": "Format invalide pour la version iOS fournie",
  "notification.error.ERROR_MIN_ANDROID_INVALID_FORMAT": "Format invalide pour la version Android minimale requise",
  "notification.error.ERROR_MIN_IOS_INVALID_FORMAT": "Format invalide pour la version iOS minimale requise",
  "notification.error.ERROR_CHALLENGE_TOKEN_REQUIRED": "Aucun token fourni",
  "notification.error.ERROR_CAN_NOT_CHANGE_CLIENT_ROLE": "Changer le r\xF4le d'un client n'est pas autoris\xE9",
  "notification.error.ERROR_UNAUTHORIZED_ROLE_MODIFICATION": "Cette op\xE9ration n'est pas autoris\xE9e",
  "notification.error.ERROR_USER_HAS_ACTIVE_POLICY": "L'utilisateur a une police active",
  "notification.error.ERROR_USER_HAS_POLICY_IN_RETENTION_PERIOD": "L'utilisateur a une police termin\xE9e il y a moins de 5 ans",
  "notification.error.ERROR_USER_HAS_CLAIM_IN_RETENTION_PERIOD": "L'utilisateur a eu un sinistre clos il y a moins de 5 ans",
  "notification.error.ERROR_USER_HAS_LOCK_SUBSCRIPTION": "L'utilisateur a un abonnement actif aux cadenas",
  "notification.error.ERROR_USER_IS_IN_A_GROUP": "L'utilisateur est dans une entreprise",
  "notification.error.ERROR_BODY_CANNOT_BE_EMPTY": "Aucun payload fourni",
  "notification.error.ERROR_GROUP_ALREADY_PARTNER": "L'entreprise est d\xE9j\xE0 partenaire",
  "notification.error.ERROR_GROUP_IS_NOT_PARTNER": "L'entreprise n'est pas partenaire",
  "notification.error.ERROR_IS_PARTNER_INVALID_FORMAT": "Format incorrect pour le is_partner fourni",
  "notification.error.ERROR_IS_PARTNER_REQUIRED": "Le champ is_partner est requis",
  "notification.error.ERROR_GROUP_ALREADY_FRAUD_PARTNER": "L'entreprise est d\xE9j\xE0 un partenaire de fraude",
  "notification.error.ERROR_GROUP_IS_NOT_FRAUD_PARTNER": "L'entreprise n'est pas un partenaire de fraude",
  "notification.error.ERROR_DATAS_INVALID_ARRAY": "La donn\xE9e fournie n'est pas un tableau",
  "notification.error.ERROR_LAT_INVALID_FORMAT": "Format invalide pour la latitude fournie",
  "notification.error.ERROR_LONG_INVALID_FORMAT": "Format invalide pour la longitude fournie",
  "notification.error.ERROR_MONTH_REQUIRED": "Aucun mois fourni",
  "notification.error.ERROR_MONTH_INVALID_FORMAT": "Format invalide pour le mois fourni",
  "notification.error.ERROR_MONTH_TOO_HIGH": "La valeur pour le mois fournis est trop grande",
  "notification.error.ERROR_MONTH_TOO_LOW": "La valeur pour le mois fournis est trop basse",
  "notification.error.ERROR_SUGGESTION_ID_INVALID_FORMAT": "Format invalide pour l'id de suggestion fournie",
  "notification.error.ERROR_FM_TOKENS_INVALID_ARRAY": "Les fm tokens fournis ne sont pas un tableau",
  "notification.error.ERROR_ROLES_TO_ADD_INVALID_ARRAY": "Les r\xF4les fournis ne sont pas un tableau",
  "notification.error.ERROR_ROLES_TO_REMOVE_INVALID_ARRAY": "Les r\xF4les \xE0 enlever ne sont pas un tableau",
  "notification.error.ERROR_BIKE_ID_INVALID_FORMAT": "Format invalide pour l'id de v\xE9lo fourni",
  "notification.error.ERROR_OPERATIONS_INVALID_ARRAY": "Les op\xE9rations fournies ne sont pas un tableau",
  "notification.error.ERROR_WHISHES_INVALID_ARRAY": "Les souhaits fournis ne sont pas un tableau",
  "notification.error.ERROR_YEAR_FORMAT": "L'ann\xE9e doit \xEAtre un nombre \xE0 4 chiffres",
  "notification.error.ERROR_MONTH_MIN_1": "Le mois doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 1",
  "notification.error.ERROR_MONTH_MAX_12": "Le mois doit \xEAtre inf\xE9rieur ou \xE9gal \xE0 12",
  "notification.error.ERROR_NOTIFICATION_LINK_INVALID_URL": "Format invalide pour le lien de notification fourni",
  "notification.error.ERROR_NOTIFICATION_TEXT_REQUIRED": "Aucun texte fourni pour la notification",
  "notification.error.ERROR_NOTIFICATION_TITLE_REQUIRED": "Aucun titre fourni pour la notification",
  "notification.error.ERROR_COMMENT_MIN": "Le commentaire est trop court",
  "notification.error.ERROR_COMMENT_MAX": "Le commentaire est trop long",
  "notification.error.ERROR_MISSING_REQUIRED_PAYMENT_DATE": "La date de paiement est requise quand le nouveau statut est INVOICE_PAID",
  "notification.error.ERROR_MISSING_REQUIRED_SENDING_DATE": "La date d'envoi est requise quand le nouveau statut est INVOICE_SENT",
  "notification.error.ERROR_PARTNER_INVOICES_STATUS": "Le statut de la facture du partenaire est manquant",
  "notification.error.WRONG_PARTNER_INVOICES_STATUS": "Mauvais type de statut",
  "notification.error.WRONG_PAYMENT_DATE_TYPE": "Mauvais format pour la date de paiement",
  "notification.error.WRONG_SENDING_DATE_TYPE": "Mauvais format pour la date d'envoi",
  "notification.error.ERROR_PAID_AMOUNT_MINIMUM": "Le montant pay\xE9 minimum est faux",
  "notification.error.ERROR_PAID_AMOUNT_TYPE": "Le type du montant pay\xE9 n'est pas bon",
  "notification.error.ERROR_DOCUMENT_ID_FORMAT": "Format invalide pour l'ID de document fourni",
  "notification.error.ERROR_DOCUMENT_ID_REQUIRED": "Le document_id est requis",
  "notification.error.ERROR_NAME_INVALID_FORMAT": "Le nom n'est pas dans le bon format",
  "notification.error.ERROR_NAME_TOO_LONG": "Le nom est trop long",
  "notification.error.ERROR_PU_TTC_FORMAT": "Le pu_ttc n'est pas dans le bon format",
  "notification.error.ERROR_PU_TTC_REQUIRED": "Le pu_ttc est requis",
  "notification.error.ERROR_QUANTITY_FORMAT": "La quantit\xE9 n'est pas dans le bon format",
  "notification.error.ERROR_QUANTITY_REQUIRED": "La quantit\xE9 est requise",
  "notification.error.ERROR_ARTICLES_REQUIRED": "Les articles sont requis",
  "notification.error.ERROR_DISCOUNT_NEGATIVE": "La remise doit \xEAtre positive",
  "notification.error.ERROR_PU_HT_NEGATIVE": "Le prix HT doit \xEAtre positif",
  "notification.error.ERROR_PU_TTC_NEGATIVE": "Le prix TTC doit \xEAtre positif",
  "notification.error.ERROR_QUANTITY_NEGATIVE": "La quantit\xE9 doit \xEAtre positive",
  "notification.error.ERROR_TVA_AMOUNT_NEGATIVE": "Le montant des taxes doit \xEAtre positif",
  "notification.error.ERROR_TVA_NEGATIVE": "Les taxes doivent \xEAtre positives",
  "notification.error.ERROR_DISCOUNT_FORMAT": "Format invalide pour le discount",
  "notification.error.ERROR_DOCUMENT_ID_INVALID_FORMAT": "Format invalide pour l'id du document",
  "notification.error.ERROR_PU_HT_FORMAT": "Format invalide pour le prix HT",
  "notification.error.ERROR_TVA_FORMAT": "Format invalide pour les taxes",
  "notification.error.ERROR_ID_INVALID": "ID invalide",
  "notification.error.ERROR_TVA_AMOUNT_FORMAT": "Format invalide pour le montant des taxes",
  "notification.error.ERROR_QUOTE_ID_REQUIRED": "Un ID de quote est requis",
  "notification.error.ERROR_VEHICLES_ID_INVALID_FORMAT": "Format invalide pour l'ID du v\xE9hicule",
  "notification.error.ERROR_CANCEL_REASON_INVALID_TYPE": "Type invalide pour le motif d'annulation",
  "notification.error.ERROR_CANCEL_REASON_REQUIRED": "Un motif d'annulation est requis",
  "notification.error.ERROR_VEHICLES_NOT_AN_ARRAY": "Les v\xE9hicules fournis ne sont pas un tableau",
  "notification.error.ERROR_ARTICLES_INVALID_ARRAY": "Les articles fournis ne sont pas un tableau",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_BOOLEAN": "L'information de renouvellement automatique doit \xEAtre une valeur bool\xE9enne.",
  "notification.error.ERROR_OPS_SUSPEND_ALLOWED_INVALID_FORMAT": "L'information d'autorisation de l'action de suspension par un Ops doit \xEAtre une valeur bool\xE9enne.",
  "notification.error.ERROR_POLICY_INFORMATION_INVALID_FORMAT": "Format invalide pour l'information de la police fournie",
  "notification.error.ERROR_POLICY_PRICE_INVALID_FORMAT": "Le format fournit pour le prix de la police est invalide",
  "notification.error.ERROR_BIKE_INFORMATION_INVALID_FORMAT": "Le format des informations du v\xE9lo fournit est invalide",
  "notification.error.ERROR_DISPLAY_CONTRACT_INVALID_FORMAT": "Format invalide pour l'information d'affichage du contrat fournie",
  "notification.error.ERROR_CANCEL_ALLOWED_INVALID_FORMAT": "Format invalide pour l'information d'autorisation d'annulation par un Ops fournie",
  "notification.error.ERROR_INSURED_VALUE_LIMIT_INVALID_FORMAT": "Format invalide pour la valeur limite assurable fournie",
  "notification.error.ERROR_OPS_SUSPEND_ALLOWED_REQUIRED": "L'information d'autorisation d'annulation par un Ops est requise",
  "notification.error.ERROR_NB_EMPLOYEES_INVALID_FORMAT": "Format invalide pour le nombre d'employ\xE9 fourni",
  "notification.error.ERROR_IS_ARCHIVE_INVALID_FORMAT": "L'information pour is_archive doit \xEAtre une valeur bool\xE9enne.",
  "notification.error.ERROR_USER_IS_A_SPONSOR": "L'utilisateur est un sponsor",
  "notification.error.ERROR_USER_HAS_PAYMENTS": "L'utilisateur a des paiements dans Stripe",
  "notification.error.ERROR_FLEET_ASSOCIATION_ERROR": "Erreur d'association \xE0 une flotte",
  "notification.error.ERROR_VEHICLE_IDS_INVALID_ARRAY": "Array invalide pour les IDs de v\xE9los fournis",
  "notification.error.ERROR_VEHICLE_IDS_EMPTY": "Aucun ID v\xE9lo fourni",
  "notification.error.ERROR_VEHICLE_IDS_INVALID_FORMAT": "Format invalide pour les IDs de v\xE9los",
  "notification.error.ERROR_FLEETS_EMPTY": "Aucune flotte fournie",
  "notification.error.ERROR_FLEETS_INVALID_ARRAY": "Array invalide pour les flottes fournies",
  "notification.error.ERROR_VEHICLE_IDS_REQUIRED": "Aucun ID v\xE9lo fourni",
  "notification.error.ERROR_EVENTS_INVALID_ARRAY": "Les \xE9v\xE8nements doivent \xEAtre un array.",
  "notification.error.ERROR_EVENTS_INVALID_TYPE": "Type invalide pour les \xE9v\xE8nements.",
  "notification.error.ERROR_WEBHOOK_DESCRIPTION_INVALID_FORMAT": "Format invalide pour la description du webhook.",
  "notification.error.ERROR_WEBHOOK_GROUP_INVALID_FORMAT": "Format invalide pour le groupe li\xE9 au webhook.",
  "notification.error.ERROR_WEBHOOK_GROUP_REQUIRED": "Le groupe li\xE9 au webhook est requis.",
  "notification.error.ERROR_WEBHOOK_EVENTS_REQUIRED": "Veuillez renseigner au minimum un \xE9v\xE8nement.",
  "notification.error.ERROR_WEBHOOK_URL_INVALID_FORMAT": "L'URL du webhook doit \xEAtre une cha\xEEne de caract\xE8re.",
  "notification.error.ERROR_WEBHOOK_URL_INVALID_URL": "L'URL du webhook doit \xEAtre valide (https://example.com).",
  "notification.error.ERROR_WEBHOOK_URL_REQUIRED": "Veuillez fournir une URL pour le webhook.",
  "notification.error.ERROR_RESET_PASSWORD_CODE_EXPIRED": "Le code de r\xE9initialisation de mot de passe a expir\xE9",
  "notification.error.ERROR_DEVICE_CONFIRMATION_CODE_EXPIRED": "Le code de confirmation de l'appareil a expir\xE9",
  "notification.error.ERROR_PAYMENT_METHOD_DOES_NOT_BELONG_TO_GROUP": "L'id de la m\xE9thode de paiement n'appartient pas \xE0 votre groupe",
  "notification.error.ERROR_COMMUNICATION_TYPE_REQUIRED": "Veuillez fournir au moins un type de communication",
  "notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ARRAY": "Le type de communication doit \xEAtre un tableau.",
  "notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ENUM": "Type de communication invalide.",
  "notification.error.TOO_MANY_REQUESTS": "Trop de requ\xEAtes, veuillez patienter et r\xE9essayer",
  "notification.error.ERROR_COMMUNICATION_TYPES_MUST_BE_ARRAY": "Les types de communication doivent \xEAtre une liste.",
  "notification.error.ERROR_COMMUNICATION_TYPES_REQUIRED": "Les types de communication sont requises.",
  "notification.error.ERROR_SEND_QUOTE_TO_CLIENT": "\xC9chec de l\u2019envoi du devis au client",
  "notification.error.ERROR_SEND_QUOTE_TO_CLIENT_INVALID_FORMAT": "Format invalide pour l\u2019envoi du devis au client",
  "notification.error.ERROR_INVITATION_NOT_FOUND": "L'invitation n'a pas \xE9t\xE9 trouv\xE9e",
  "notification.error.ERROR_INVITATION_ID_REQUIRED": "L'ID de l'invitation est requis",
  "notification.error.ERROR_INVITATION_ID_INVALID": "Identifiant d\u2019invitation invalide",
  "notification.error.ERROR_INVITATION_ID_INVALID_FORMAT": "Le format de l\u2019identifiant d\u2019invitation est incorrect",
  "notification.error.ERROR_IDS_INVALID_ARRAY": "Les ids fournis ne sont pas un tableau",
  "notification.error.ERROR_INVALID_ACCESSORIES_VALUE": "Valeur d'accessoires invalide",
  "notification.error.ERROR_INVALID_PRICE": "Prix invalide",
  "notification.error.ERROR_DATE_NOT_IN_FUTUR": "Veuillez renseigner une date dans le futur",
  "notification.error.ERROR_DANGER_LEVEL_INVALID_TYPE": "Le type du niveau de danger est invalide",
  "notification.error.ERROR_BIKE_MODEL_INVALID_FORMAT": "Format non valide pour le mod\xE8le de v\xE9lo fourni",
  "notification.error.ERROR_DATE_NOT_IN_PAST": "La date fournie doit \xEAtre dans le futur",
  "notification.error.ERROR_CLAIM_ID_INVALID_FORMAT": "Le format de l'id du sinistre n'est pas valide",
  "notification.error.ERROR_CLAIM_ID_REQUIRED": "L'id du sinistre est requis",
  "notification.error.ERROR_DOCUMENT_UUID_REQUIRED": "L'uuid du document est requis",
  "notification.error.ERROR_DOCUMENT_UUID_INVALID_FORMAT": "L'uuid du document n'est pas dans le correct format",
  "notification.error.ERROR_B2B_CLAIM_DOES_NOT_EXIST": "Le sinistre B2B n'existe pas",
  "notification.error.ERROR_NO_CLAIM_LINKED_TO_POLICY_OR_GROUP": "Aucun sinistre li\xE9 \xE0 la police ou \xE0 l'entreprise",
  "notification.error.ERROR_STATUS_REQUIRED": "Le statut est requis",
  "notification.error.ERROR_BIKE_ELEMENTS_IS_REQUIRED_WHEN_THEFT_PARTIAL_OR_DAMAGE_PARTIAL": "Les \xE9l\xE9ments du v\xE9lo sont requis en cas de vol partiel ou de dommage partiel",
  "notification.error.ERROR_IS_FRAUD_INVALID_FORMAT": "Is Fraud n'est pas dans le correct format",
  "notification.error.ERROR_INVALID_PACKAGE": "Package invalide",
  "notification.error.ERROR_GROUP_REQUIRED": "Le groupe est requis",
  "notification.error.ERROR_GROUP_INVALID_FORMAT": "Le format du groupe n'est pas valide",
  "notification.error.ERROR_DURATION_REQUIRED": "L'utilisation est requise",
  "notification.error.ERROR_DURATION_MUST_BE_GREATER_THAN_ONE": "La dur\xE9e doit \xEAtre sup\xE9rieure \xE0 1",
  "notification.error.ERROR_TIME_PERIOD_REQUIRED": "La dur\xE9e de d\xE9finition est requise",
  "notification.error.ERROR_TIME_PERIOD_INVALID_TYPE": "Le type de la p\xE9riode n'est pas valide",
  "notification.error.ERROR_END_DATE_INVALID_FORMAT": "Le format de la date de fin n'est pas valide",
  "notification.error.ERROR_PARTNER_INVALID_FORMAT": "Le format du partenaire n'est pas valide",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_REQUIRED": "Les r\xE8gles de prix par couverture sont requises",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_EMPTY": "Les r\xE8gles de prix par couverture ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_FORMAT": "Format invalide pour les r\xE8gles de pricing par couverture",
  "notification.error.ERROR_FILE_TYPE_INVALID_FORMAT": "Format invalide pour le format du fichier",
  "notification.error.ERROR_FILE_TYPE_INVALID_EXTENSION": "L'extension du fichier n'est pas valide",
  "notification.error.ERROR_TEMPLATE_INVALID_FORMAT": "Le format du template n'est pas valide",
  "notification.error.ERROR_EMPTY_BODY_REQUIRED": 'Le check "corps vide" est requis',
  "notification.error.ERROR_VALID_END_DATE_REQUIRED": "Une date de fin valide est requise",
  "notification.error.ERROR_VALID_END_DATE_INVALID_FORMAT": "Le format de la date de fin n'est pas valide",
  "notification.error.ERROR_CONTRACT_REQUIRED": "Un contrat est requis",
  "notification.error.ERROR_CONTRACT_INVALID_FORMAT": "Le format du contrat n'est pas valide",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_REQUIRED": "La date de d\xE9but de la p\xE9riode d'occurrence du sinistre est requise",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_REQUIRED": "La date de fin de la p\xE9riode d'occurrence du sinistre est requise",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSIONS_ID_INVALID_FORMAT": "Format invalide pour l'id de la session assurance fourni",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_TYPE": "Le type du support premium est invalide",
  "notification.error.ERROR_LOCKING_SESSIONS_ID_INVALID_FORMAT": "L\u2019identifiant de sessions de verrouillage fourni est invalide",
  "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_REQUIRED": "Le reste \xE0 payer non couvert est requis",
  "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_INVALID_FORMAT": "Le format du reste \xE0 payer non couvert est invalide",
  "notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_NUMBER": "Le format du montant \xE0 rembourser au groupe est invalide",
  "notification.error.ERROR_CLAIM_PAID_GROUP_NOT_POSITIVE": "Le montant rembours\xE9 au groupe doit \xEAtre positif",
  "notification.error.ERROR_CLAIM_PAID_GROUP_NOT_NUMBER": "Format invalide pour le montant rembours\xE9 au groupe fourni",
  "notification.error.ERROR_SUPPORT_AMOUNT_NOT_POSITIVE": "Le montant li\xE9 \xE0 l'assistance doit \xEAtre positif",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_POSITIVE": "Le montant du v\xE9lo sinistr\xE9 doit \xEAtre positif",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_NUMBER": "Format invalide pour le montant du v\xE9lo sinistr\xE9 fourni",
  "notification.error.ERROR_GROSS_AMOUNT_NOT_POSITIVE": "Le montant brut doit \xEAtre positif",
  "notification.error.ERROR_GROSS_AMOUNT_NOT_NUMBER": "Format invalide pour le montant brut fourni",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE": "Le montant \xE0 recouvrir aupr\xE8s du groupe doit \xEAtre positif",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_GROUP_NOT_NUMBER": "Format invalide pour le montant \xE0 recouvrir aupr\xE8s du groupe fourni",
  "notification.error.ERROR_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE": "Le montant recouvert aupr\xE8s du groupe doit \xEAtre positif",
  "notification.error.ERROR_RECOVERED_AMOUNT_GROUP_NOT_NUMBER": "Format invalide pour le montant recouvert aupr\xE8s du groupe fourni",
  "notification.error.ERROR_FRANCHISE_AMOUNT_NOT_POSITIVE": "Le montant de la franchise doit \xEAtre positif",
  "notification.error.ERROR_FRANCHISE_AMOUNT_NOT_NUMBER": "Le format de la franchise n'est pas valide",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_POSITIVE": "Le pourcentage de la franchise doit \xEAtre positif",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_NUMBER": "Le format du pourcentage de franchise est invalide",
  "notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_POSITIVE": "Le montant \xE0 rembourser au groupe doit \xEAtre positif",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_INVALID_FORMAT": "Format invalide pour la date de d\xE9but de la p\xE9riode d'occurrence du sinistre",
  "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_INVALID_FORMAT": "Format invalide pour la date de fin d'occurrence du sinistre fourni",
  "notification.error.ERROR_PACKAGE_NOT_ACTIVE": "Le package n'est pas actif",
  "notification.error.ERROR_PACKAGE_INVALID_FORMAT": "Format invalide pour le package fourni",
  "notification.error.ERROR_CHOOSEN_PACKAGES_REQUIRED": "Aucune formule s\xE9lectionn\xE9e",
  "notification.error.ERROR_AFFECTED_USERS_INVALID_ARRAY": "Liste invalide pour les utilisateurs affect\xE9s fournis",
  "notification.error.ERROR_ACCESSORY_STEP_INVALID_FORMAT": "Format invalide pour les montants d'accessoires r\xE9f\xE9rence fournis",
  "notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_FORMAT": "Format invalide pour les couvertures optionnelles fournies",
  "notification.error.ERROR_EFFECTIVE_DATE_INVALID_FORMAT": "Le format de la date d\u2019effet est invalide",
  "notification.error.ERROR_EFFECTIVE_DATE_IN_THE_FUTURE": "La date effective est dans le futur",
  "notification.error.ERROR_DURATION_TOO_LOW": "La dur\xE9e est trop courte",
  "notification.error.ERROR_DURATION_INVALID_FORMAT": "Le format de la dur\xE9e est invalide",
  "notification.error.ERROR_USAGE_INVALID_TYPE": "Valeur invalide pour l\u2019usage fourni",
  "notification.error.ERROR_PAYMENT_METHODS_INVALID_TYPE": "Valeur invalide pour les m\xE9thodes de paiement fournies",
  "notification.error.ERROR_SPLITTING_REQUIRED": "Un fractionnement est requis",
  "notification.error.ERROR_SPLITTING_INVALID_TYPE": "Valeur incorrecte pour le fractionnement fourni",
  "notification.error.ERROR_PARTNER_PAY_INVALID_FORMAT": "Format invalide pour l'information indiquant si le partenaire paye fournie",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_FORMAT": "Format invalide pour l'information de renouvellement automatique fournie",
  "notification.error.ERROR_MODEL_BRAND_OR_BIKE_MODEL_REQUIRED": "Une marque et un mod\xE8le ou un bike model sont requis",
  "notification.error.ERROR_ACCESSORIES_VALUE_TOO_LOW": "La valeur des accessoires fournis est trop basse",
  "notification.error.ERROR_ACCESSORIES_VALUE_INVALID_FORMAT": "Le format de la valeur des accessoires fournis n'est pas valide",
  "notification.error.ERROR_COUNT_INVALID_FORMAT": "Format invalide pour le d\xE9compte fourni",
  "notification.error.ERROR_FULL_REQUIRED": "Les informations pour le fractionnement en Totalit\xE9 sont requises",
  "notification.error.ERROR_OPT_IN_INVALID_FORMAT": "Format invalide pour l'information d'opt-in fournie",
  "notification.error.ERROR_CLIENT_IS_UNDERAGE": "La date d'anniversaire fournie est trop r\xE9cente",
  "notification.error.ERROR_MONTH_MUST_BE_GREATER_THAN_ONE": "L'information li\xE9e au mois doit-\xEAtre sup\xE9rieure \xE0 1",
  "notification.error.ERROR_MONTH_MUST_BE_LESS_THAN_TWELVE": "L'information li\xE9e au mois doit-\xEAtre sup\xE9rieure \xE0 12",
  "notification.error.ERROR_COVERAGE_REQUIRED": "Une couverture est requise",
  "notification.error.ERROR_COVERAGE_INVALID_FORMAT": "Format invalide pour la couverture fournie",
  "notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_ARRAY": "Liste invalide pour les couvertures forunis",
  "notification.error.ERROR_PERCENTAGE_REQUIRED": "Un pourcentage est requis",
  "notification.error.ERROR_PERCENTAGE_INVALID_FORMAT": "Format invalide pour le pourcentage fourni",
  "notification.error.ERROR_FIXED_AMOUNT_WITH_PERCENTAGE": "Il n'est pas possible de renseigner un montant fix lorsqu'un pourcentage l'est d\xE9j\xE0",
  "notification.error.ERROR_PERCENTAGE_WITH_FIXED_AMOUNT": "Il n'est pas possible de renseigner un pourcentage lorsqu'un montant fix l'est d\xE9j\xE0",
  "notification.error.ERROR_FIXED_AMOUNT_REQUIRED": "Un montant fix est requis",
  "notification.error.ERROR_FIXED_AMOUNT_INVALID_FORMAT": "Format invalide pour le montant fix fourni",
  "notification.error.ERROR_AMOUNT_TYPE_REQUIRED": "Le type de montant est requis",
  "notification.error.ERROR_AMOUNT_TYPE_INVALID_TYPE": "Type invalide pour le type de montant fourni",
  "notification.error.ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_ONE": "L'ann\xE9e de la police doit \xEAtre sup\xE9rieur \xE0 1",
  "notification.error.ERROR_POLICY_YEAR_REQUIRED": "L'ann\xE9e de la police est requise",
  "notification.error.ERROR_POLICY_YEAR_INVALID_FORMAT": "Format invalide pour l'ann\xE9e de la police renseign\xE9e",
  "notification.error.ERROR_COMMISSIONS_INVALID_ARRAY": "Les commissions doivent-\xEAtre une liste.",
  "notification.error.ERROR_COMMISSIONS_INVALID_FORMAT": "Format invalide pour les commissions fournies",
  "notification.error.ERROR_POLICY_ID_REQUIRED": "L'id de la police est requise",
  "notification.error.ERROR_POLICY_ID_INVALID_FORMAT": "Format invalide pour l'id de la police fourni",
  "notification.error.ERROR_POLICY_NOT_FOUND": "Aucune police trouv\xE9e",
  "notification.error.ERROR_VEHICLES_ID_INVALID_ARRAY": "Format invalide pour les ids de v\xE9hicules frounis",
  "notification.error.ERROR_VEHICLES_ID_REQUIRED": "Les ids de v\xE9hicules sont requis",
  "notification.error.ERROR_VEHICLES_IDS": "Certains ids de v\xE9hicules n'ont pas \xE9t\xE9 trouv\xE9e",
  "notification.error.ERROR_COMMENT_LENGHT_1_255": "Le commentaire doit faire entre 1 et 255 caract\xE8res",
  "notification.error.ERROR_B2B_POLICY_STATUS": "Mauvais statut de police",
  "notification.error.ERROR_TOO_OLD_POLICIES_TO_RETRACT": "La police est trop vieille pour \xEAtre r\xE9tract\xE9e",
  "notification.error.ERROR_WRONG_POLICY_DURATION": "La dur\xE9e de la police est incorrecte",
  "notification.error.ERROR_B2B_CONTRACT_NOT_VALID": "Le contrat n'est pas valide",
  "notification.error.CREATE_AMEND_ERROR": "Erreur pendant la cr\xE9ation d'un amendement",
  "notification.error.ERROR_NAME_INVALID_LENGTH": "Le nom doit faire entre 2 et 50 caract\xE8res",
  "notification.error.ERROR_CONTRACTUAL_DOCUMENT_DOES_NOT_EXIST": "Le document contractuel n'existe pas",
  "notification.error.ERROR_EXPIRED_INVALID_FORMAT": "Format incorrecte pour l'information d'expiration fournie",
  "notification.error.ERROR_COVERAGES_INVALID_FORMAT": "Les couvertures ne sont pas dans le bon format",
  "notification.error.ERROR_COVERAGES_INVALID_ARRAY": "Les couvertures doivent \xEAtre une liste",
  "notification.error.INVALID_TRAD_CODE": "Le code de traduction n'est pas valide",
  "notification.error.ERROR_INVALID_COVERAGE_CODE": "Le code de couverture n'est pas valide",
  "notification.error.ERROR_MISS_FLEET_NAME": "Le nom de flotte est requis",
  "notification.error.ERROR_MISS_FLEET_ID": "L'identifiant de la flotte est requis",
  "notification.error.ERROR_FLEET_ID_INVALID_FORMAT": "L'identifiant de la flotte n'est pas dans le bon format",
  "notification.error.ERROR_FLEET_ID_INVALID": "L'identifiant de la flotte n'est pas valide",
  "notification.error.ERROR_VEHICLES_IDADDED_INVALID_FORMAT": "Les identifiants des v\xE9hicules ajout\xE9s ne sont pas dans le bon format",
  "notification.error.ERROR_VEHICLES_IDADDED_INVALID_ARRAY": "Les identifiants des v\xE9hicules doivent \xEAtre une liste",
  "notification.error.ERROR_VEHICLES_IDDELETED_INVALID_FORMAT": "Les identifiants des v\xE9hicules supprim\xE9s ne sont pas dans le bon format",
  "notification.error.ERROR_VEHICLES_IDDELETED_INVALID_ARRAY": "Liste invalide pour les v\xE9los \xE0 retirer",
  "notification.error.ERROR_AT_LEAST_ONE_FIELD_REQUIRED": "Au moins un champs est requis",
  "notification.error.ERROR_VEHICLES_NOT_GROUP": "Certains v\xE9hicules ne sont pas dans le groupe",
  "notification.error.ERROR_LOW_MISSING": "La valeur basse est requise",
  "notification.error.ERROR_LOW_LOWER_THAN_ZERO": "La valeur basse doit se situer entre 0 et 1",
  "notification.error.ERROR_LOW_GREATER_THAN_ONE": "La valeur basse doit se situer entre 0 et 1",
  "notification.error.ERROR_LOW_INVALID_NUMBER": "La valeur basse doit \xEAtre un nombre valide",
  "notification.error.ERROR_MEDIUM_MISSING": "La valeur moyenne est requise",
  "notification.error.ERROR_MEDIUM_LOWER_THAN_ZERO": "La valeur moyenne doit se situer entre 0 et 1",
  "notification.error.ERROR_MEDIUM_GREATER_THAN_ONE": "La valeur moyenne doit se situer entre 0 et 1",
  "notification.error.ERROR_MEDIUM_INVALID_NUMBER": "La valeur moyenne doit \xEAtre un nombre valide",
  "notification.error.ERROR_MEDIUM_LOWER_THAN_LOW": "La valeur moyenne doit \xEAtre sup\xE9rieur \xE0 la valeur basse",
  "notification.error.ERROR_HIGH_MISSING": "La valeur haute est requise",
  "notification.error.ERROR_HIGH_LOWER_THAN_ZERO": "La valeur haute doit \xEAtre entre 0 et 1",
  "notification.error.ERROR_HIGH_GREATER_THAN_ONE": "La valeur haute doit \xEAtre entre 0 et 1",
  "notification.error.ERROR_HIGH_INVALID_NUMBER": "La valeur haute doit \xEAtre un nombre valide",
  "notification.error.ERROR_HIGH_LOWER_THAN_MEDIUM": "La valeur haute doit \xEAtre sup\xE9rieur \xE0 la valeur moyenne",
  "notification.error.NO_FRAUD_WEIGHT_FOUND": "Les poids du calcul de fraude n'ont pas \xE9t\xE9 trouv\xE9s",
  "notification.error.ERROR_LAT_REQUIRED": "La latitude est requise",
  "notification.error.ERROR_LONG_REQUIRED": "La longitude est requise",
  "notification.error.ERROR_DANGEROSITY_INVALID_TYPE": "Le niveau de danger n'est pas un format valide",
  "notification.error.ERROR_LAT_DELTA_REQUIRED": "Le delta de la latitude est requis",
  "notification.error.ERROR_LAT_DELTA_INVALID_FORMAT": "Le delta de la latitude n'est pas dans le format correct",
  "notification.error.ERROR_LONG_DELTA_REQUIRED": "Le delta de la longitude est requis",
  "notification.error.ERROR_LONG_DELTA_INVALID_FORMAT": "Le delta de la longitude n'est pas dans le format correct",
  "notification.error.ERROR_LAT_DELTA_TOO_HIGH": "Le delta de la latitude doit \xEAtre inf\xE9rieur \xE0 0.2",
  "notification.error.ERROR_LONG_DELTA_TOO_HIGH": "Le delta de la longitude doit \xEAtre inf\xE9rieur \xE0 0.2",
  "notification.error.ERROR_ZONES_REQUIRED": "Les zones sont requises",
  "notification.error.ERROR_ZONES_INVALID_ARRAY": "Les zones doivent \xEAtre une liste",
  "notification.error.ERROR_LAT_LONG_INVALID_FORMAT": "La latitude et la longitude ne sont pas dans un format valide",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_REQUIRED": "Le montant \xE0 r\xE9cup\xE9rer pour l\u2019utilisateur est requis",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_INVALID_FORMAT": "Le montant \xE0 r\xE9cup\xE9rer pour l\u2019utilisateur n'est pas dans un format valide",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_TOO_LOW": "Le montant \xE0 r\xE9cup\xE9rer pour l\u2019utilisateur doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_REQUIRED": "Le montant \xE0 r\xE9cup\xE9rer pour le partenaire est requis",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT": "Le montant \xE0 r\xE9cup\xE9rer pour le partenaire n'est pas un format valide",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_TOO_LOW": "Le montant \xE0 r\xE9cup\xE9rer pour le partenaire doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_REQUIRED": "La date de d\xE9but d'occurrence du sinistre est requise",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_FORMAT": "Format incorrecte pour la date de d\xE9but d'occurrence du sinistre",
  "notification.error.ERROR_OCCURENCE_PERIOD_END_INVALID_DATE": "Format incorrecte pour la date de fin d'occurrence du sinistre",
  "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_DATE": "La date de d\xE9but d'occurrence du sinistre n'est pas une date valide",
  "notification.error.ERROR_PERIOD_START_GREATER_THAN_PERIOD_END": "La date de d\xE9but d'occurrence du sinistre doit \xEAtre ant\xE9rieur \xE0 la date de fin d'occurrence du sinistre",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_REQUIRED": "La date de fin d'occurrence du sinistre est requise",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_FORMAT": "Format incorrecte pour la date de fin d'occurrence du sinistre",
  "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_NUMBER": "Format invalide pour l'id de la session assurance fourni",
  "notification.error.ERROR_PREMIUM_SUPPORT_INVALID": "Le type de l'assistance premium est invalide",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_REQUIRED": "Le type de l'assistance premium est requis",
  "notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_FORMAT": "Format invalide pour l'information sur la connaissance du coupable",
  "notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_NUMBER": "Format invaldie pour l'id de la session assurance",
  "notification.error.ERROR_AT_HOME_INVALID_FORMAT": "Format invalide pour l'information dis si le sinistre \xE0 eu lieu au domicile fournie",
  "notification.error.ERROR_IS_BIKE_VAE_REQUIRED": "L'information de si le v\xE9lo est un VAE est requise",
  "notification.error.ERROR_IS_BIKE_VAE_INVALID_FORMAT": "Format invalide pour l'information de si le v\xE9lo est un VAE fournie",
  "notification.error.ERROR_IS_BATTERY_SAFE_INVALID_FORMAT": "Format invalide pour l'information de l'\xE9tat de la batterie fournie",
  "notification.error.ERROR_TO_BE_REIMBURSED_USER_INVALID_FORMAT": "Format invalide pour le montant \xE0 recouvrir aupr\xE8s de l'utilisateur",
  "notification.error.ERROR_TO_BE_REIMBURSED_USER_TOO_LOW": "Le montant \xE0 recouvrir aupr\xE8s de l'utilisateur doit \xEAtre sup\xE9rieur \xE0 9",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_INVALID_FORMAT": "Format invalide pour le montant \xE0 recouvrir aupr\xE8s du partenaire",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_TOO_LOW": "Le montant \xE0 recouvrir aupr\xE8s du partenaire doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_FRANCHISE_AMOUNT_INVALID_FORMAT": "Le montant de la franchise n'est pas un format valide",
  "notification.error.ERROR_FRANCHISE_AMOUNT_TOO_LOW": "Le montant de la franchise doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_CLAIM_PAID_USER_INVALID_FORMAT": "Format invalide pour le montant pay\xE9 \xE0 l'utilisateur",
  "notification.error.ERROR_CLAIM_PAID_USER_TOO_LOW": "Le montant pay\xE9 \xE0 l'utilisateur doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_INVALID_FORMAT": "Format invalide pour le montant pay\xE9 au partenaire",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_TOO_LOW": "Le montant pay\xE9 au partenaire doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_INVALID_FORMAT": "Format invalide pour le montant de l'assistance",
  "notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_TOO_LOW": "Le montant de l'assistance doit \xEAtre sup\xE9rieur 0",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_INVALID_FORMAT": "Format invalide pour le montant du v\xE9lo sinistr\xE9",
  "notification.error.ERROR_BIKE_CLAIM_AMOUNT_TOO_LOW": "Le montant du v\xE9lo sinistr\xE9 doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_INVALID_FORMAT": "Format invalide pour le pourcentage de franchise",
  "notification.error.ERROR_FRANCHISE_PERCENTAGE_TOO_LOW": "Le pourcentage de franchise doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_PRICE_BEFORE_DEDUCTION_INVALID_FORMAT": "Format invalide pour le prix avant d\xE9duction",
  "notification.error.ERROR_PRICE_BEFORE_DEDUCTION_TOO_LOW": "Le prix avant d\xE9duction doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_RECOVERED_AMOUNT_USER_INVALID_FORMAT": "Format invalide pour le montant \xE0 recouvrir aupr\xE8s de l'utilisateur",
  "notification.error.ERROR_RECOVERED_AMOUNT_USER_TOO_LOW": "Le montant \xE0 recouvrir aupr\xE8s de l'utilisateur doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT": "Format invalide pour le montant \xE0 recouvrir aupr\xE8s du partenaire",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_TOO_LOW": "Le montant \xE0 recouvrir aupr\xE8s du partenaire doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_REAL_VALUE_INVALID_FORMAT": "Format invalide pour la valeur r\xE9elle fournie",
  "notification.error.ERROR_REAL_VALUE_NEGATIVE": "La valeur r\xE9elle doit \xEAtre sup\xE9rieure \xE0 0",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_INVALID_FORMAT": "Format invalide pour le montant additionnel li\xE9 \xE0 l'utilisateur",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_NEGATIVE": "Le montant additionnel li\xE9 \xE0 l'utilisateur doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_REASON_REQUIRED": "La raison li\xE9e au montant additionnel li\xE9 \xE0 l'utilisateur est requise",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_INVALID_FORMAT": "Format invalide pour le montant additionnel li\xE9 au partenaire",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_NEGATIVE": "Le montant additionnel li\xE9 au partenaire doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_REASON_REQUIRED": "La raison li\xE9e au montant additionnel li\xE9 au partenaire est requise",
  "notification.error.ERROR_FIELD_TOUPDATE_REQUIRED": "Au moins une modification de champs est requise",
  "notification.error.ERROR_FIXED_PARKING_LOCATION_CHECKED_INVALID_FORMAT": "Format invalide pour l'information li\xE9e \xE0 la v\xE9rification du point fixe de stationnement",
  "notification.error.ERROR_HAS_USER_BEEN_CALLED_INVALID_FORMAT": "Format invalide pour l'information li\xE9e \xE0 la validation de l'appel de l'utilisateur",
  "notification.error.ERROR_DECLARATION_CONSISTENT_INVALID_FORMAT": "Format invalide pour l'information de validation de la consistance de la d\xE9claration",
  "notification.error.ERROR_HAS_SHOP_BEEN_CALLED_INVALID_FORMAT": "Format invalide pour l'information li\xE9e \xE0 la validation de l'appel du magasin",
  "notification.error.ERROR_IS_PLS_VALIDATED_INVALID_FORMAT": "Format invalide pour l'information de validation de la session assurance",
  "notification.error.ERROR_CLAIM_DOES_NOT_EXIST": "Le sinistre n'existe pas",
  "notification.error.ERROR_UNIQ_ID_REQUIRED": "L'identifiant unique est requis",
  "notification.error.ERROR_UNKNOWN_UNIQ_ID": "L'identifiant unique est inconnu",
  "notification.error.ERROR_FRANCHISE_INVALID_FORMAT": "La valeur de la franchise n'est pas dans le bon format",
  "notification.error.ERROR_CLAIMS_IDS_REQUIRED": "Les ids de dossiers de sinistres sont requis",
  "notification.error.ERROR_CLAIM_ID_INVALID_TYPE": "Format invalide pour l'id du dossier de sinistre",
  "notification.error.ERROR_INVALID_CLAIM": "Dossier de sinistre invalide",
  "notification.error.ERROR_PARTNER_CLAIMS_NOT_AN_ARRAY": "Liste invalide pour les ids de dossiers de sinistres",
  "notification.error.ERROR_AMOUNT_REQUIRED": "Le montant est requis",
  "notification.error.ERROR_AMOUNT_INVALID_FORMAT": "Le format du montant n'est pas valide",
  "notification.error.ERROR_LONG_INVALID_VALUE": "Format invalide pour la longitude",
  "notification.error.ERROR_LAT_INVALID_VALUE": "Format invalide pour la latitude",
  "notification.error.ERROR_ADDRESS_INVALID_STRING": "Format invalide pour l'adresse",
  "notification.error.ERROR_COVERAGE_CODE_INVALID_VALUE": "Format invalide pour le code de couverture",
  "notification.error.ERROR_DESCRIPTION_INVALID_STRING": "Format invalide pour la description",
  "notification.error.ERROR_PARK_LOCATION_INVALID_STRING": "Format invalide pour le lieu de stationnement",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_VALUE": "Format invalide pour le type de l'assistance premium",
  "notification.error.ERROR_BIKE_ELEMENTS_INVALID_STRING": "Format invalide pour les \xE9l\xE9ments du v\xE9lo",
  "notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_BOOLEAN": "L'information de si le coupable est connu doit \xEAtre une valeur bool\xE9enne",
  "notification.error.ERROR_OCCURED_AT_HOME_INVALID_BOOLEAN": "L'information de si le sinistre est survenu sur le lieu d'habitation doit \xEAtre une valeur bool\xE9enne",
  "notification.error.ERROR_IS_BIKE_VAE_INVALID_BOOLEAN": "L'information de si le v\xE9hicule est un VAE doit \xEAtre une valeur bool\xE9enne",
  "notification.error.ERROR_IS_BATTERY_SAFE_INVALID_BOOLEAN": "L'information de si la batterie est sinistr\xE9e doit \xEAtre une valeur bool\xE9enne",
  "notification.error.IS_CULPRIT_KNOWN_NOT_GIVEN": "L'information de si le coupable est connu doit \xEAtre fourni dans le cas d'un sinistre de vandalisme",
  "notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_EXPECTED": "Le type de l'assistance premium doit \xEAtre fourni dans le cadre d'un sinistre d'assistance premium",
  "notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_UNEXPECTED": "Le type de l'assistance premium ne doit pas \xEAtre fourni dans le cadre d'un sinistre autre qu'assistance premium",
  "notification.error.ERROR_PHOTO_INVALID_TYPE": "Format invalide pour la photo",
  "notification.error.ERROR_CLAIM_TYPE_REQUIRED": "Le type du claim est requis",
  "notification.error.ERROR_CLAIM_TYPE_INVALID": "Le type du claim n'est pas valide",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_REQUIRED": "Il manque des documents requis",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_INVALID": "Les documents requis sont invalides",
  "notification.error.ERROR_REQUIRED_AND_OPTIONAL_DOCUMENTS_OVERLAP": "Les documents requis et facultatifs se chevauchent",
  "notification.error.ERROR_REQUIRED_DOCUMENTS_MUST_BE_ARRAY": "Les documents requis doivent \xEAtre une liste",
  "notification.error.ERROR_REQUIRED_DOCUMENT_TYPE_INVALID": "Le type du document requis est invalide",
  "notification.error.ERROR_OPTIONAL_DOCUMENTS_REQUIRED": "Les documents facultatifs sont requis",
  "notification.error.ERROR_OPTIONAL_DOCUMENTS_MUST_BE_ARRAY": "Les documents facultatifs doivent \xEAtre une liste",
  "notification.error.ERROR_OPTIONAL_DOCUMENT_TYPE_INVALID": "Type invalide pour le document optionnel",
  "notification.error.ERROR_PARTNER_ID_MUST_BE_A_NUMBER": "Format invalide pour l'id du partenaire",
  "notification.error.ERROR_PERSONAL_LOCK_REQUIRED": "Le cadenas personnel est requis",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_REQUIRED": "Le seuil de la valeur assurable doit \xEAtre fourni",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_POSITIVE": "Le seuil de la valeur assurable doit \xEAtre positif",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_A_NUMBER": "Le seuil de la valeur assurable doit \xEAtre un nombre",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_REQUIRED": "Le seuil du montant brut remboursable doit \xEAtre fourni",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_POSITIVE": "Le seuil du montant brut remboursable doit \xEAtre positif",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_A_NUMBER": "Le seuil du montant brut remboursable doit \xEAtre un nombre",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_REQUIRED": "La liste des v\xE9rifications Ops obligatoires est requise",
  "notification.error.ERROR_MANDATORY_OPS_CHECK_TYPE_INVALID": "Le type des v\xE9rifications ops n'est pas valide",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_MUST_BE_ARRAY": "Liste invalide pour les v\xE9rifications Ops obligatoires",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_REQUIRED": "La liste des v\xE9rifications Ops d\xE9clench\xE9es par le franchissement d'une valeur assur\xE9e est requise",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECK_TYPE_INVALID": "Type invalide pout la v\xE9rification Ops d\xE9clench\xE9e par le franchissement d'une valeur assur\xE9e",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_MUST_BE_ARRAY": "Liste invalide pour les v\xE9rifications Ops d\xE9clench\xE9es par le franchissement d'une valeur assur\xE9e",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_REQUIRED": "La liste v\xE9rifications Ops d\xE9clench\xE9es par le franchissement d'un montant brut \xE0 rembourser est requise",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECK_TYPE_INVALID": "Type invalide pour la v\xE9rification Ops d\xE9clench\xE9e par le franchissement d'un montant brut \xE0 rembourser",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_MUST_BE_ARRAY": "Liste invalide pour les v\xE9rifications Ops d\xE9clench\xE9es par le franchissement d'un montant brut \xE0 rembourser",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_REQUIRED": "La liste des v\xE9rifications Ops en cas de soup\xE7on de fraude est requise",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_TYPE_INVALID": "Type invalide pour les v\xE9rifications Ops en cas de soup\xE7on de fraude",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_MUST_BE_ARRAY": "Liste invalide pour les v\xE9rifications Ops en cas de soup\xE7on de fraude",
  "notification.error.ERROR_PLS_DURATION_REQUIRED": "La dur\xE9e d'une session assurance est requise",
  "notification.error.ERROR_PLS_DURATION_INVALID_FORMAT": "Format invalide pour la dur\xE9e d'une session assurance",
  "notification.error.ERROR_DEPRIVATION_DURATION_REQUIRED": "La dur\xE9e de la carence est requise",
  "notification.error.ERROR_DEPRIVATION_DURATION_INVALID_FORMAT": "Format invalide pour la dur\xE9e de la carence",
  "notification.error.ERROR_CONTRACT_TEMPLATE_REQUIRED": "La template du contrat est requise",
  "notification.error.ERROR_MAIL_AT_CREATION_ID_REQUIRED": "L'id du mail \xE0 la cr\xE9ation est requis",
  "notification.error.ERROR_MAIL_AT_CREATION_ID_INVALID_FORMAT": "Format invalide pour l'id de mail \xE0 la cr\xE9ation",
  "notification.error.ERROR_MAIL_AT_END_ID_INVALID_FORMAT": "Format invalide pour l'id de mail \xE0 la fin d'un contrat",
  "notification.error.ERROR_MAIL_AT_END_UNPAID_ID_INVALID_FORMAT": "Format invalide pour le mail \xE0 la fin d'un contrat non pay\xE9",
  "notification.error.ERROR_DISPLAY_POLICY_INFORMATIONS_REQUIRED": "L'information sur l'affichage des informations de la police est requise",
  "notification.error.ERROR_PLS_WITH_TOTAL_CLAIM_ALLOWED_REQUIRED": "L'information si un sinistre total emp\xEAche la cr\xE9ation de session assurance est requise",
  "notification.error.ERROR_PLS_ALLOWED_INVALID_FORMAT": "Format invalide pour l'information si un sinistre total emp\xEAche la cr\xE9ation de session assurance",
  "notification.error.ERROR_PLS_DURATION_MUST_A_NUMBER": "La dur\xE9e d'une session assurance doit \xEAtre un nombre",
  "notification.error.ERROR_PLS_DURATION_MUST_0_AT_LEAST": "La dur\xE9e d'une session assurance doit \xEAtre sup\xE9rieur ou \xE9gale \xE0 0",
  "notification.error.ERROR_DEPRIVATION_DURATION_MUST_A_NUMBER": "La dur\xE9e de carence doit \xEAtre un nombre",
  "notification.error.ERROR_DEPRIVATION_DURATION_MUST_0_AT_LEAST": "La dur\xE9e de carence doit \xEAtre sup\xE9rieur \xE0 0",
  "notification.error.ERROR_MAIL_ID_INVALID_FORMAT": "Format invalide pour l'id du mail",
  "notification.error.ERROR_EMPTY_BODY": "Aucune information transmise",
  "notification.error.ERROR_PACKAGE_ID_MUST_A_BE_NUMBER": "L'id du package doit \xEAtre un nombre",
  "notification.error.ERROR_OPTIONAL_CHECKS_REQUIRED": "Les v\xE9rifications optionnelles sont requises",
  "notification.error.ERROR_NOT_OPTIONNAL_CHECK": "Type invalide pour la v\xE9rification optionnelle",
  "notification.error.ERROR_OPTIONAL_CHECKS_INVALID_ARRAY": "Liste invalide pour les v\xE9rifications optionnelles",
  "notification.error.ERROR_VEHICLE_OWNER_REQUIRED": "L'information sur le propri\xE9taire du v\xE9hicule est requise",
  "notification.error.ERROR_VEHICLE_OWNER_NOT_BOOL": "L'information de si l'utilisateur est propri\xE9taire du v\xE9hicule doit \xEAtre une valeur bool\xE9enne",
  "notification.error.ERROR_MAIL_ID_MUST_A_BE_NUMBER": "L'id du mail doit \xEAtre un nombre",
  "notification.error.ERROR_THRESHOLD_MUST_A_BE_NUMBER": "Le seuil doit \xEAtre un nombre",
  "notification.error.ERROR_MAIL_ID_MUST_A_NUMBER": "L'id du mail doit \xEAtre un nombre",
  "notification.error.ERROR_IDS_INVALID_TYPE": "Format invalide pour la liste d'ids",
  "notification.error.ERROR_PARTNER_ESTIMATION_UNDEFINED": "Les r\xE8gles d'estimation de remboursement au partenaire sont requises",
  "notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID_ARRAY": "Liste invalide pour les r\xE8gles d'estimation de remboursement au partenaire",
  "notification.error.ERROR_PARTNER_ESTIMATION_VALUES_EMPTY": "Les valeurs d'estimation des partenaires sont vides",
  "notification.error.ERROR_PARTNER_ESTIMATION_INVALID_TYPE": "Type d'estimation du partenaire non valide",
  "notification.error.ERROR_USER_ESTIMATION_UNDEFINED": "Erreur, la provision pour le user est undefined",
  "notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID_ARRAY": "Tableau invalide pour la provision",
  "notification.error.ERROR_USER_ESTIMATION_VALUES_EMPTY": "User estimation values are empty",
  "notification.error.ERROR_USER_ESTIMATION_INVALID_TYPE": "Tableau vide pour la provision",
  "notification.error.ERROR_FRANCHISE_RULE_UNDEFINED": "La r\xE8gle de franchise est undefined",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID_ARRAY": "La r\xE8gle de franchise est invalide",
  "notification.error.ERROR_FRANCHISE_RULE_VALUES_EMPTY": "Le tableau des r\xE8gle de franchise est vide",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID_TYPE": "Les r\xE8gle de franchise n'ont pas le bon type",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_UNDEFINED": "les r\xE8gles de remboursement partenaire sont undefined",
  "notification.error.ERROR_PARTNER_REIMBURSMENT_RULE_INVALID_ARRAY": "Le tableau de r\xE8gle de remboursement partenaire est invalide",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_VALUES_EMPTY": "Le tableau de r\xE8gle de remboursement partenaire est vide",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_INVALID_TYPE": "La r\xE8gle de remboursement partenaire est invalide",
  "notification.error.ERROR_USER_REIMBURSEMENT_UNDEFINED": "Le tableau de r\xE8gle de remboursement partenaire est undefined",
  "notification.error.ERROR_CLIENT_REIMBURSMENT_RULE_INVALID_ARRAY": "Le tableau de r\xE8gle de remboursement client est invalide",
  "notification.error.ERROR_USER_REIMBURSEMENT_VALUES_EMPTY": "Le tableau de r\xE8gle de remboursement est vide",
  "notification.error.ERROR_USER_REIMBURSEMENT_INVALID_TYPE": "Les r\xE8gle de remboursement client sont invalides",
  "notification.error.ERROR_CLAIM_TYPE_UNDEFINED": "Le type de sinistre n'est pas defini",
  "notification.error.ERROR_CLAIM_TYPE_INVALID_TYPE": "Le type de sinistre est invalide",
  "notification.error.ERROR_WITH_PLS_UNDEFINED": "Le champ 'With pls' est undefined",
  "notification.error.ERROR_WITH_PLS_INVALID_TYPE": "Le champ 'With pls' est invalide",
  "notification.error.ERROR_HAS_BATTERY_UNDEFINED": "Le champ 'Has Battery' est undefined",
  "notification.error.ERROR_HAS_BATTERY_INVALID_TYPE": "Le champ 'Has Battery' est invalide",
  "notification.error.ERROR_BIKE_MODEL_MUST_BE_A_NUMBER": "Le bike model doit \xEAtre un nombre",
  "notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID": "Les r\xE8gles de provision partenaire sont invalide",
  "notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID": "Les r\xE8gles de provision user sont invalide",
  "notification.error.ERROR_FRANCHISE_RULE_INVALID": "Les r\xE8gles de franchise sont invalide",
  "notification.error.ERROR_PARTNER_REIMBURSMENT_RULE_INVALID": "Les r\xE8gles de remboursement partenaire sont invalide",
  "notification.error.ERROR_CLIENT_REIMBURSMENT_RULE_INVALID": "Les r\xE8gles de remboursement user sont invalide",
  "notification.error.ERROR_MANDATORY_CHECKS_UNDEFINED": "Les checks obligatoires sont undefined",
  "notification.error.ERROR_MANDATORY_CHECKS_INVALID_TYPE": "Les r\xE8gles de provision partenaire sont invalide",
  "notification.error.ERROR_MANDATORY_OPS_CHECKS_INVALID_ARRAY": "Le tableau des r\xE8gles de provision partenaire est invalide",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_UNDEFINED": "Les checks li\xE9s \xE0 la valeur assur\xE9e sont undefined",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_INVALID_TYPE": "Les checks li\xE9s \xE0 la valeur assur\xE9e sont invalides",
  "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_INVALID_ARRAY": "Le tableau des checks li\xE9s \xE0 la valeur assur\xE9e est invalide",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_UNDEFINED": "Les checks li\xE9s au fraud score sont undefined",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_TYPE": "Les checks li\xE9s au fraud score sont invalides",
  "notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_ARRAY": "Le tableau des checks li\xE9s au fraud score est invalide",
  "notification.error.ERROR_VALUE_THESHOLD_UNDEFINED": "Le seuil de valeur n'est pas d\xE9fini",
  "notification.error.ERROR_VALUE_THRESHOLD_INVALID_TYPE": "Type de seuil de valeur invalide",
  "notification.error.ERROR_VALUE_THRESHOLD_INVALID": "Seuil de valeur invalide",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_UNDEFINED": "Le seuil du montant brut remboursable n'est pas d\xE9fini",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID_TYPE": "Montant de remboursement brut non valide.",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID": "Montant de remboursement brut non valide",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_UNDEFINED": "Les contr\xF4les op\xE9rationels pour le montant de remboursement brut ne sont pas d\xE9finis",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_TYPE": "Type de contr\xF4les ops du montant remboursable brut invalide",
  "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_ARRAY": "Tableau de contr\xF4les ops du montant remboursable brut invalide",
  "notification.error.ERROR_REQUIRED_DOCS_UNDEFINED": "Les documents requis ne sont pas d\xE9finis",
  "notification.error.ERROR_REQUIRED_DOCS_INVALID_TYPE": "Type de documents requis invalide",
  "notification.error.ERROR_REQUIRED_DOCS_INVALID_ARRAY": "Liste de documents requis invalide",
  "notification.error.ERROR_OPTIONAL_DOCS_UNDEFINED": "Les documents optionnels sont ind\xE9finis",
  "notification.error.ERROR_OPTIONAL_DOCS_INVALID_TYPE": "Type de documents optionnels invalide",
  "notification.error.ERROR_OPTIONAL_DOCS_INVALID_ARRAY": "Tableau de documents optionnels invalide",
  "notification.error.ERROR_LOCK_REQUIRED_INVALID_FORMAT": "Format invalide pour l'obligation d'antivol",
  "notification.error.ERROR_MARKING_CODE_REQUIRED_INVALID_FORMAT": "Format requis du code de marquage invalide",
  "notification.error.ERROR_APIC_CHECK_INVALID_FORMAT": "Format  de l'APIC  invalide",
  "notification.error.ERROR_REPAID_QUOTE_INVALID_FORMAT": "Format de devis de r\xE9paration invalide",
  "notification.error.ERROR_REIMBURSEMENT_LIMIT_INVALID_FORMAT": "Format de limite de remboursement invalide",
  "notification.error.ERROR_ALREADY_REIMURSEMENT_CHECK_INVALID_FORMAT": "Format invalide pour le contr\xF4le de remboursement d\xE9j\xE0 effectu\xE9",
  "notification.error.ERROR_NOTIFY_PARTNER_INVALID_FORMAT": "Format invalide pour la notification partenaire",
  "notification.error.ERROR_APPLY_FRAUD_TAG_INVALID_FORMAT": "Format invalide pour l'application du tag fraude",
  "notification.error.ERROR_TOTAL_TERMINATE_POLICY_INVALID_FORMAT": "Format invalide pour la r\xE9siliation totale de police",
  "notification.error.ERROR_USER_NOTIFY_PARTNER_INVALID_FORMAT": "Format invalide pour la notification partenaire utilisateur",
  "notification.error.ERROR_BIKE_OBSO_INVALID_FORMAT": "Format invalide pour la v\xE9tust\xE9 du v\xE9lo",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_0_AT_LEAST": "La v\xE9tust\xE9 du v\xE9lo doit \xEAtre au minimum de 0",
  "notification.error.ERROR_BIKE_OBSO_PERCENTAGE_INVALID_FORMAT": "Format invalide pour le pourcentage de v\xE9tust\xE9 du v\xE9lo",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_0_AT_LEAST": "Le pourcentage de v\xE9tust\xE9 doit \xEAtre au minimum de 0.",
  "notification.error.ERROR_BIKE_OBSO_LIMIT_INVALID_FORMAT": "Format de vetust\xE9 invalide",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_LIMIT_0_AT_LEAST": "La limite de vetust\xE9 doit \xEAtre au moins de 0",
  "notification.error.ERROR_ALLOWED_PARTIAL_INVALID_FORMAT": "Format invalide pour le nombre de sinistres partiels autoris\xE9s",
  "notification.error.ERROR_BIKE_ALLOWED_PARTIAL_MIN_ONE_AT_LEAST": "Le nombre de sinistres partiels autoris\xE9s pour le v\xE9lo doit \xEAtre au minimum de -1",
  "notification.error.ERROR_CREATION_MAIL_ID_INVALID_FORMAT": "format invalide pour l'ID du mail \xE0 la cr\xE9ation",
  "notification.error.ERROR_REJECTED_MAIL_ID_INVALID_FORMAT": "Format d'ID de mail de rejet invalide",
  "notification.error.ERROR_ABANDON_MAIL_ID_INVALID_FORMAT": "Format d'ID de mail d'abandon invalide",
  "notification.error.ERROR_TO_PAY_MAIL_ID_INVALID_FORMAT": "Format d'ID de mail \xAB \xE0 payer \xBB invalide",
  "notification.error.ERROR_VALIDATED_MAIL_ID_INVALID_FORMAT": "Format d'ID de mail de validation invalide",
  "notification.error.ERROR_PAID_MAIL_ID_INVALID_FORMAT": "Format d'ID de mail de paiement invalide",
  "notification.error.ERROR_PERSONAL_LOCK_INVALID_FORMAT": "Format invalide pour l'antivol personnel fourni",
  "notification.error.ERROR_MARKING_CODE_CHECK_REQUIRED": "le champ is_marking_code_check_required est manquant",
  "notification.error.ERROR_MARKING_CODE_CHECK_INVALID_FORMAT": "le champ is_marking_code_check_required est invalide",
  "notification.error.ERROR_APIC_CHECK_REQUIRED": "le champ is_apic_check_required est manquant",
  "notification.error.ERROR_REPAIR_QUOTE_REQUIRED": "Le champ is_repair_quote_partial_claim_required est manquant",
  "notification.error.ERROR_REPAIR_QUOTE_INVALID_FORMAT": "Format invalide pour le devis de r\xE9paration",
  "notification.error.ERROR_ALL_OBSOLESCENCE_SETTINGS_REQUIRED": "Tous les champs concernant la v\xE9tust\xE9 sont obligatoires",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_MUST_BE_POSITIVE": "Le nombre de jour pour calcul de la v\xE9tust\xE9 doit \xEAtre positif",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_INVALID_FORMAT": "Le nombre de jour pour le d\xE9but de la v\xE9tust\xE9 est invalide",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_POSITIVE": "Le % de v\xE9tust\xE9 par mois doit \xEAtre positif",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_THAN_100": "Le % de v\xE9tust\xE9 par mois doit \xEAtre moins que 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_INVALID_FORMAT": "Le % de v\xE9tust\xE9 par mois est invalide",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_POSITIVE": "Le % de v\xE9tust\xE9 doit \xEAtre positif",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_THAN_100": "Le % de v\xE9tust\xE9 doit \xEAtremoins que 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_INVALID_FORMAT": "Format invalide pour le pourcentage limite de v\xE9tust\xE9",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_REQUIRED": "Le nombre de claim partiel autoris\xE9 est requis",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_INVALID_FORMAT": "Format invalide pour le nombre de claim partiel autoris\xE9",
  "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_REQUIRED": "La limitation du remboursement \xE0 la valeur assur\xE9e est requise",
  "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_INVALID_FORMAT": "Format invalide pour la limitation du remboursement \xE0 la valeur assur\xE9e fournie",
  "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_REQUIRED": "Le Should check already reimbursed amounts est requis",
  "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_INVALID_FORMAT": "Format invalide pour le should check already reimbursed amounts fourni",
  "notification.error.ERROR_SHOULD_NOTIFY_PARTNER_REQUIRED": "La notification du partenaire est requise",
  "notification.error.ERROR_SHOULD_NOTIFY_PARTNER_INVALID_FORMAT": "Format invalide pour la notification du partenaire fournie",
  "notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_REQUIRED": "L'application du tag fraude est requis",
  "notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_INVALID_FORMAT": "Format invalide pour l'application du tag fraude fourni",
  "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_REQUIRED": "Le Should total paid terminate policy est requis",
  "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_INVALID_FORMAT": "Format invalide pour le should total paid terminate policy fourni",
  "notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_REQUIRED": "La notification partenaire par l'utilisateur est requise",
  "notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_INVALID_FORMAT": "Format invalide pour la notification partenaire par l'utilisateur fournie",
  "notification.error.ERROR_CLAIM_CREATION_MAIL_ID_INVALID_FORMAT": "Format invalide pour l'id de mail de cr\xE9ation de sinistre fourni",
  "notification.error.ERROR_VALIDATED_ON_QUOTE_MAIL_ID_INVALID_FORMAT": "Format invalide pour l'id de mail de validation sur devis fourni",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_ARRAY": "Tableau invalide pour les param\xE8tres de document fournis",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_OBJECT": "Objet invalide pour les param\xE8tres de document fournis",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_OBJECT": "Objet invalide pour les param\xE8tres de contr\xF4les ops fournis",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_ARRAY": "Tableau invalide pour les param\xE8tres de remboursement fournis",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_OBJECT": "Objet invalide pour les param\xE8tres de remboursement fournis",
  "notification.error.ERROR_DOCS_ID_REQUIRED": "Aucun docs id fourni",
  "notification.error.ERROR_DOCS_ID_INVALID_FORMAT": "Format invalide pour le docs id fourni",
  "notification.error.ERROR_CHECKS_ID_REQUIRED": "Aucun checks id fourni",
  "notification.error.ERROR_CHECKS_ID_INVALID_FORMAT": "Format invalide pour le checks id fourni",
  "notification.error.ERROR_REIMBURSEMENT_ID_REQUIRED": "Aucun reimbursement id fourni",
  "notification.error.ERROR_REIMBURSEMENT_ID_INVALID_FORMAT": "Format invalide pour le reimbursement id fourni",
  "notification.error.ERROR_PACKAGE_REQUIRED": "Aucune formule fournie",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_UNDEFINED": "Aucun seuil de valeur assur\xE9e fourni",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID_TYPE": "Type invalide pour le seuil de valeur assur\xE9e fourni",
  "notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID": "Seuil de valeur assur\xE9e invalide",
  "notification.error.ERROR_PARTNER_INVOICES_ID_REQUIRED": "L'id de facture partenaire est requis",
  "notification.error.ERROR_PARTNER_INVOICES_ID_INVALID_FORMAT": "L'id de facture partenaire doit \xEAtre un nombre valide",
  "notification.error.ERROR_PARTNER_INVOICES_STATUS_REQUIRED": "Le Partner invoice status est requis",
  "notification.error.ERROR_NO_RECEIPTS_CREATED": "Aucun re\xE7u trouv\xE9 avec le statut INVOICE_CREATED",
  "notification.error.ERROR_INVALID_STATUS": "Statut de facture partenaire invalide",
  "notification.error.ERROR_URI_REQUIRED": "Aucun uri fourni",
  "notification.error.ERROR_URI_INVALID_FORMAT": "Format invalide pour l'uri fourni",
  "notification.error.ERROR_PATH_REQUIRED": "Aucun path fourni",
  "notification.error.ERROR_PATH_INVALID_FORMAT": "Format invalide pour le path fourni",
  "notification.error.ERROR_BUFFER_REQUIRED": "Aucun buffer fourni",
  "notification.error.ERROR_MIMETYPE_REQUIRED": "Aucun mimetype fourni",
  "notification.error.ERROR_MIMETYPE_INVALID_FORMAT": "Format invalide pour le mimetype fourni",
  "notification.error.ERROR_MIMETYPE_INVALID_EXTENSION": "Extension de mimetype invalide",
  "notification.error.ERROR_START_PICTURE_REQUIRED": "Le Start picture est requis",
  "notification.error.ERROR_FEEDBACK_REQUIRED": "Le Feedback est requis",
  "notification.error.ERROR_FEEDBACK_INVALID_FORMAT": "Format invalide pour le feedback fourni",
  "notification.error.ERROR_PERSONAL_LOCK_DOES_NOT_EXIST": "L'antivol personnel fourni n'existe pas",
  "notification.error.ERROR_POLICY_REQUIRED": "Aucune police fournie",
  "notification.error.ERROR_POLICY_DOES_NOT_EXIST": "La police fournie n'existe pas",
  "notification.error.ERROR_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST": "La demande d'annulation de police fournie n'existe pas",
  "notification.error.ERROR_PRICE_WITHOUT_TAXES_REQUIRED": "Aucun price without taxes fourni",
  "notification.error.ERROR_PRICE_WITHOUT_TAXES_INVALID_FORMAT": "Format invalide pour le price without taxes fourni",
  "notification.error.ERROR_PRICE_WITH_TAXES_REQUIRED": "Aucun price with taxes fourni",
  "notification.error.ERROR_PRICE_WITH_TAXES_INVALID_FORMAT": "Format invalide pour le price with taxes fourni",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_REQUIRED": "Aucun discounted price without taxes fourni",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_INVALID_FORMAT": "Format invalide pour le dicounted price without taxes fourni",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_REQUIRED": "Aucun discounted price with taxes fourni",
  "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_INVALID_FORMAT": "Format invalide pour le discounted price with taxes fourni",
  "notification.error.ERROR_TECHNICAL_PREMIUM_REQUIRED": "Aucun technical premium fourni",
  "notification.error.ERROR_TECHNICAL_PREMIUM_INVALID_FORMAT": "Format invalide pour le technical premium fourni",
  "notification.error.ERROR_COMMISSION_REQUIRED": "Aucun commission fourni",
  "notification.error.ERROR_COMMISSION_INVALID_FORMAT": "Format invalide pour le commission fourni",
  "notification.error.ERROR_SPLITTING_FEES_REQUIRED": "Aucun frais de fractionnement fournis",
  "notification.error.ERROR_SPLITTING_FEES_INVALID_FORMAT": "Format invalide pour les frais de fractionnement fournis",
  "notification.error.ERROR_MANAGEMENT_FEES_REQUIRED": "Aucun frais de gestion fournis",
  "notification.error.ERROR_MANAGEMENT_FEES_INVALID_FORMAT": "Format invalide pour les frais de gestion fournis",
  "notification.error.ERROR_TAXES_REQUIRED": "Aucune taxe fournie",
  "notification.error.ERROR_TAXES_INVALID_FORMAT": "Format invalide pour le taxes fourni",
  "notification.error.ERROR_BROKER_FEES_REQUIRED": "Aucun frais de courtier fourni",
  "notification.error.ERROR_BROKER_FEES_INVALID_FORMAT": "Le format des frais de courtier n'est pas valide",
  "notification.error.ERROR_INSURED_VALUE_REQUIRED": "Format invalide pour le coverage pricings fourni",
  "notification.error.ERROR_INVOICE_ID_MUST_NOT_BE_EMPTY": "L'id de facture ne doit pas \xEAtre vide",
  "notification.error.ERROR_AMOUNT_TOO_LOW": "Le montant doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_AMOUNT_MUST_BE_INTEGER": "Le montant doit \xEAtre un entier",
  "notification.error.ERROR_IS_CANCEL_REQUIRED": "L'Is cancel est requis",
  "notification.error.ERROR_INVALID_TERMINATION_DATE": "La date de r\xE9siliation doit \xEAtre dans un format correct",
  "notification.error.REASON_NOT_COMPATIBLE_WITH_TERMINATION_DATE": "Le motif n'est pas compatible avec la date de r\xE9siliation",
  "notification.error.ERROR_USER_BIRTHDAY_REQUIRED": "La date de naissance de l'utilisateur est requise",
  "notification.error.ERROR_USER_BIRTHDAYMILLIS_INVALID_FORMAT": "La date de naissance utilisateur (millis) doit \xEAtre dans un format correct",
  "notification.error.ERROR_WRONG_DOCUMENT_TYPE": "Type de document incorrect",
  "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_REQUIRED": "La date d'effet de la police est requise",
  "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_INVALID_FORMAT": "La date d'effet de la police doit \xEAtre dans un format correct",
  "notification.error.ERROR_PAST_EFFECTIVE_START_DATE": "La date d'effet de la police doit \xEAtre dans le futur",
  "notification.error.ERROR_SERIAL_REQUIRED": "Le Serial est requis",
  "notification.error.ERROR_POLICY_TERMINATION_DATE_INVALID_FORMAT": "La date de r\xE9siliation de la police doit \xEAtre dans un format correct",
  "notification.error.ERROR_DATE_IN_THE_PAST": "La date doit \xEAtre aujourd'hui ou dans le futur",
  "notification.error.TERMINATION_DATE_NOT_BETWEEN_POLICY_DATES": "La date de r\xE9siliation doit \xEAtre comprise entre les dates de la police",
  "notification.error.TERMINATION_DATE_NOT_ALLOWED_FOR_MONTHLY_SPLITTING": "La date de r\xE9siliation n'est pas autoris\xE9e pour le d\xE9coupage mensuel",
  "notification.error.ERROR_UNABLE_TO_ABORT_ACTIVE_POLICY": "Impossible de terminer la police active",
  "notification.error.ERROR_CANCEL_POLICY": "Impossible d'annuler la police",
  "notification.error.ERROR_B2B_USAGE_TYPE": "L'usage b2b doit \xEAtre d'un type correct",
  "notification.error.WRONG_TIME_PERIOD_TYPE": "Le type de p\xE9riode doit \xEAtre correct",
  "notification.error.ERROR_PROMOTION_CODE_REQUIRED": "Le code de promotion est requis",
  "notification.error.ERROR_BIKE_PRICE_REQUIRED": "Le prix du v\xE9lo est requis",
  "notification.error.ERROR_CHOOSEN_PACKAGE_INVALID_FORMAT": "La formule choisie doit \xEAtre dans un format correct",
  "notification.error.NO_PACKAGE_CHOOSEN_YET": "Aucun forfait choisi pour le moment",
  "notification.error.ERROR_COVERAGE_PRICINGS_REQUIRED": "Aucun prix de couverture fourni",
  "notification.error.ERROR_APPLY_ZONING_REQUIRED": "Aucun apply zoning fourni",
  "notification.error.ERROR_APPLY_ZONING_INVALID_FORMAT": "Format invalide pour l'apply zoning fourni",
  "notification.error.ERROR_MIN_X_REQUIRED": "La valeur minimale est requise",
  "notification.error.ERROR_MIN_X_TOO_LOW": "La valeur minimale doit \xEAtre sup\xE9rieure ou \xE9gale \xE0 0",
  "notification.error.ERROR_MIN_X_INVALID_FORMAT": "La valeur minimale fournie est invalide",
  "notification.error.ERROR_MAX_X_TOO_LOW": "La valeur maximale doit \xEAtre positive et sup\xE9rieure \xE0 la valeur minimale",
  "notification.error.ERROR_MAX_X_INVALID_FORMAT": "La valeur maximale fournie est invalide",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_REQUIRED": "Aucun coefficient de prime technique fourni",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_EMPTY": "Les coefficients de prime technique ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_INVALID_FORMAT": "Format invalide pour le technical premium coefficients fourni",
  "notification.error.ERROR_COMMISSION_COEFFS_REQUIRED": "Aucun coefficients de commission fournis",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_REQUIRED": "Aucun coefficients de frais de fractionnement fournis",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_EMPTY": "Les coefficients de frais de fractionnement ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_FORMAT": "Format invalide pour les coefficients de frais de fractionnement fournis",
  "notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_ARRAY": "Les coefficients de frais de fractionnement doivent \xEAtre un tableau",
  "notification.error.ERROR_COMMISSION_COEFFS_EMPTY": "Les coefficients de commission ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_COMMISSION_COEFFS_INVALID_FORMAT": "Format invalide pour les coefficients de commission fournis",
  "notification.error.ERROR_COMMISSION_COEFFS_INVALID_ARRAY": "Les coefficients de commission doivent \xEAtre une liste",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_REQUIRED": "Aucun coefficient de frais de gestion fourni",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_EMPTY": "Les coefficients de frais de gestion ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_FORMAT": "Format invalide pour les coefficients de frais de gestion fournis",
  "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_ARRAY": "Les coefficients de frais de gestion doivent \xEAtre un tableau",
  "notification.error.ERROR_TAXE_RATE_REQUIRED": "Aucun taux de taxe fourni",
  "notification.error.ERROR_TAXE_RATE_TOO_LOW": "Le taux de taxe doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_TAXE_RATE_INVALID_FORMAT": "Le taux de taxe n'est pas dans le bon format",
  "notification.error.ERROR_BROKER_FEES_COEFFS_REQUIRED": "Aucun coefficient de frais de courtier fourni",
  "notification.error.ERROR_BROKER_FEES_COEFFS_EMPTY": "Les coefficients de frais de courtier ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_FORMAT": "Les coefficients de frais de courtier ne sont pas dans le bon format",
  "notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_ARRAY": "Les coefficients de frais de courtier doivent \xEAtre une liste",
  "notification.error.ERROR_COVERAGE_ID_REQUIRED": "L'identifiant de la couverture est requis",
  "notification.error.ERROR_COVERAGE_ID_INVALID_FORMAT": "L'identifiant de la couverture n'est pas dans le bon format",
  "notification.error.ERROR_PRICING_RULES_REQUIRED": "Aucun r\xE8gles de tarification fournis",
  "notification.error.ERROR_PRICING_RULES_EMPTY": "Les r\xE8gles de prix ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_PRICING_RULES_INVALID_ARRAY": "Les r\xE8gles de tarification doivent \xEAtre un tableau",
  "notification.error.ERROR_PRICING_RULES_INVALID_FORMAT": "Format invalide pour les r\xE8gles de tarification fournis",
  "notification.error.ERROR_CLIENT_REQUIRED": "Veuillez pr\xE9ciser un client",
  "notification.error.ERROR_PREMIUM_SPLITTING_INVALID_TYPE": "Type invalide pour le premium splitting fourni",
  "notification.error.ERROR_DURATION_NOT_VALID": "La dur\xE9e choisie n'est pas valide",
  "notification.error.ERROR_DURATION_INVALID_FOR_ANNUAL": "Dur\xE9e invalide pour le d\xE9coupage annuel",
  "notification.error.ERROR_CALLBACK_INVALID_FORMAT": "Format invalide pour le callback fourni",
  "notification.error.ERROR_VALUES_REQUIRED": "Aucun values fourni",
  "notification.error.ERROR_VALUES_INVALID_ARRAY": "Les valeurs doivent \xEAtre un tableau",
  "notification.error.ERROR_VALUES_EMPTY": "Les valeurs ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_VALUES_INVALID_FORMAT": "Format invalide pour le values fourni",
  "notification.error.ERROR_PACKAGES_REQUIRED": "Pas de formule renseign\xE9e",
  "notification.error.ERROR_PACKAGES_INVALID_ARRAY": "Les formules doivent \xEAtre un tableau",
  "notification.error.ERROR_PACKAGES_EMPTY": "Les formules ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_PACKAGES_INVALID_FORMAT": "Format invalide pour le packages fourni",
  "notification.error.ERROR_ACTIVE_REQUIRED": "Aucun active fourni",
  "notification.error.ERROR_VEHICLE_DOES_NOT_EXIST": "Le v\xE9hicule n'existe pas",
  "notification.error.ERROR_VEHICLES_REQUIRED": "Veuillez pr\xE9ciser les v\xE9los",
  "notification.error.ERROR_VEHICLES_INVALID_ARRAY": "Tableau invalide pour les v\xE9hicules fournis",
  "notification.error.ERROR_BICYCODE_IDS_REQUIRED": "Les identifiants des codes de marquage sont requis",
  "notification.error.ERROR_BICYCODE_IDS_EMPTY": "Les ids bicycode ne doivent pas \xEAtre vides",
  "notification.error.ERROR_BICYCODE_IDS_INVALID_ARRAY": "Tableau invalide pour les ids bicycode fournis",
  "notification.error.ERROR_PURCHASE_PROOF_INVALID_TYPE": "La preuve d'achat n'est pas du bon type",
  "notification.error.ERROR_SERIAL_LENGTH_TOO_LONG": "La longueur du num\xE9ro de s\xE9rie doit \xEAtre inf\xE9rieure \xE0 30 caract\xE8res",
  "notification.error.ERROR_IS_ASSURED_INVALID_FORMAT": "Le statut assur\xE9 doit \xEAtre dans un format correct",
  "notification.error.ERROR_DOCUMENT_OBJECT_REQUIRED": "Veuillez pr\xE9ciser un document",
  "notification.error.ERROR_DOCUMENT_OBJECT_INVALID_FORMAT": "L'objet document doit \xEAtre dans un format correct",
  "notification.error.ERROR_INCLUDE_REQUIRED": "L'Include est requis",
  "notification.error.ERROR_B2B_POLICY_OBJECT_REQUIRED": "L'objet police b2b est requis",
  "notification.error.ERROR_B2B_POLICY_OBJECT_INVALID_FORMAT": "L'objet police b2b doit \xEAtre dans un format correct",
  "notification.error.ERROR_INSURANCE_CLAIMS_REQUIRED": "L'Insurance claims est requis",
  "notification.error.ERROR_INSURANCE_CLAIMS_OBJECT_INVALID_FORMAT": "L'objet sinistres assurance doit \xEAtre dans un format correct",
  "notification.error.ERROR_PERSONAL_LOCK_OBJECT_INVALID_FORMAT": "L'objet antivol personnel doit \xEAtre dans un format correct",
  "notification.error.ERROR_FLEET_OBJECT_INVALID_FORMAT": "L'objet flotte doit \xEAtre dans un format correct",
  "notification.error.ERROR_GROUP_OBJECT_INVALID_FORMAT": "L'objet groupe doit \xEAtre dans un format correct",
  "notification.error.ERROR_B2B_CLAIMS_OBJECT_INVALID_FORMAT": "L'objet sinistres b2b doit \xEAtre dans un format correct",
  "notification.error.ERROR_VEHICLE_MUST_HAVE_BICYCODE": "Veuillez fournir un code de marquage pour le v\xE9lo",
  "notification.error.ERROR_VEHICLE_REQUIRED": "Veuillez pr\xE9ciser un v\xE9lo",
  "notification.error.ERROR_TYPE_INVALID_FORMAT": "Le type doit \xEAtre dans un format correct",
  "notification.error.ERROR_COMMISSION_ID_REQUIRED": "Le Commission id est requis",
  "notification.error.ERROR_COMMISSION_ID_INVALID_FORMAT": "L'id de commission n'est pas dans un format correct",
  "notification.error.ERROR_COMMISSION_DOES_NOT_EXIST": "La commission n'existe pas",
  "notification.error.ERROR_AND_INVALID_FORMAT": "Format invalide pour l'and fourni",
  "notification.error.ERROR_OR_INVALID_FORMAT": "Format invalide pour l'or fourni",
  "notification.error.COULD_NOT_FIND_USER_OR_GROUP": "Aucun utilisateur ni groupe trouv\xE9 pour l'\xE9v\xE9nement Stripe",
  "notification.error.ERROR_CURRENT_CITY_OBJECT_INVALID_FORMAT": "Format invalide pour le current city object fourni",
  "notification.error.ERROR_DEVICES_OBJECT_INVALID_FORMAT": "Format invalide pour le device object fourni",
  "notification.error.ERROR_FIRST_CITY_OBJECT_INVALID_FORMAT": "Format invalide pour le first city object fourni",
  "notification.error.ERROR_NOTES_OBJECT_INVALID_FORMAT": "Format invalide pour les notes object fournis",
  "notification.error.ERROR_POLICIES_INVALID_FORMAT": "Format invalide pour le policies fourni",
  "notification.error.ERROR_POLICY_STATUS_REQUIRED": "Aucun statut de police fourni",
  "notification.error.ERROR_USERS_GROUPS_RELATIONS_OBJECT_INVALID_FORMAT": "Format invalide pour l'users-groups relations object fourni",
  "notification.error.ERROR_USER_SETTINGS_INVALID_FORMAT": "Format invalide pour l'user-settings fourni",
  "notification.error.ERROR_STATUS_INVALID_VALUE": "Valeur invalide pour le statut fourni",
  "notification.error.ERROR_PROMOTION_CODE_OBJECT_INVALID_FORMAT": "Format invalide pour le promotion-code object fourni",
  "notification.error.ERROR_USER_OBJECT_INVALID_FORMAT": "Format invalide pour l'user object fourni",
  "notification.error.AMOUNT_BIGGER_THAN_INSURED_VALUE": "Le montant du sinistre est sup\xE9rieur \xE0 la valeur assur\xE9e",
  "notification.error.AMOUNT_TO_PAY_NOT_EQUAL_TO_SUM_OF_CLAIMS_TO_PAY": "Le montant \xE0 payer n'est pas \xE9gal \xE0 la somme des sinistres \xE0 payer",
  "notification.error.CLAIM_NOT_FOUND_OR_NOT_IN_TO_PAY_STATUS": "Aucun sinistre au statut TO_PAY trouv\xE9",
  "notification.error.DOC_COMPLETION_NOT_100": "La compl\xE9tion des documents n'est pas \xE0 100 %",
  "notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_VALUE": "Valeur invalide pour le statut de couverture du sinistre fourni",
  "notification.error.ERROR_FILE_TYPE_INVALID_TYPE": "Extension de fichier invalide",
  "notification.error.ERROR_CONTRACT_HAS_NO_END_DATE": "Le contrat n'a pas de date de fin",
  "notification.error.ERROR_CONTRACT_HAS_NO_START_DATE": "Le contrat n'a pas de date de d\xE9but",
  "notification.error.ERROR_CONTRACT_IS_NOT_ACTIVE": "Le contrat est inactif",
  "notification.error.ERROR_MISSING_COVERAGE_PRICING_RULE_DEFINITION": "Aucun coverage pricing rule definition fourni",
  "notification.error.ERROR_DURATION_INVALID_VALUE": "Valeur invalide pour la dur\xE9e fournie",
  "notification.error.ERROR_CANCEL_REQUEST_ID_REQUIRED": "Aucun cancel request id fourni",
  "notification.error.ERROR_AFFECTED_USERS_REQUIRED": "Aucun affetced users fourni",
  "notification.error.ERROR_AUTO_RENEWAL_INVALID_TYPE": "Type invalide pour l'auto renewal fourni",
  "notification.error.ERROR_BIRTHDAY_TOO_HIGH": "La date de naissance fournie est trop \xE9lev\xE9e",
  "notification.error.ERROR_MISSING_INFORMATION": "Certaines informations sont manquantes",
  "notification.error.ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ONE": "L'ann\xE9e de police doit \xEAtre sup\xE9rieure \xE0 1",
  "notification.error.ERROR_FIXED_AMOUNT_PROHIBITED_FOR_PERCENTAGE_TYPE": "Les montants fixes ne sont pas autoris\xE9s pour le type pourcentage",
  "notification.error.ERROR_COMMENT_LENGTH_1_255": "Le commentaire doit contenir entre 1 et 255 caract\xE8res",
  "notification.error.ERROR_END_DATE_MUST_BE_AFTER_START_DATE": "La date de fin doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but",
  "notification.error.ERROR_FLEET_ID_REQUIRED": "L'id de flotte est requis",
  "notification.error.ERROR_AMOUNTS_INCONSISTENCIES": "Il y a des incoh\xE9rences entre les montants",
  "notification.error.ERROR_CLAIM_NOT_FOUND": "Le sinistre est introuvable",
  "notification.error.ERROR_ABANDONED_MAIL_ID_INVALID_FORMAT": "Format invalide pour l'ID de mail d'abandon fourni",
  "notification.error.ERROR_CLAIM_MANAGEMENT_PARAMETERS_ALREADY_EXISTS": "Les param\xE8tres de gestion de sinistre existent d\xE9j\xE0",
  "notification.error.ERROR_DISPLAY_BIKE_INFORMATIONS_REQUIRED": "Aucun information about displaying bike informations fourni",
  "notification.error.ERROR_DISPLAY_CONTRACT_REQUIRED": "Aucun information about displaying contract fourni",
  "notification.error.ERROR_DISPLAY_POLICY_PRICE_REQUIRED": "Aucun information about displaying policy price fourni",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_ALREADY_EXISTS": "Les param\xE8tres de document existent d\xE9j\xE0",
  "notification.error.ERROR_PARTNER_ESTIMATION_REQUIRED": "L'estimation partenaire n'est pas d\xE9finie",
  "notification.error.ERROR_USER_ESTIMATION_REQUIRED": "L'estimation utilisateur n'est pas d\xE9finie",
  "notification.error.ERROR_FRANCHISE_RULE_REQUIRED": "La r\xE8gle de franchise n'est pas d\xE9finie",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_REQUIRED": "Le remboursement partenaire n'est pas d\xE9fini",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID_ARRAY": "Tableau de r\xE8gles de remboursement partenaire invalide",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_REQUIRED": "Le remboursement utilisateur n'est pas d\xE9fini",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID_ARRAY": "Tableau de r\xE8gles de remboursement client invalide",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_INVALID_TYPE": "Type de remboursement utilisateur invalide",
  "notification.error.ERROR_CLAIM_USER_NOT_FOUND": "Impossible de trouver l'utilisateur donn\xE9",
  "notification.error.ERROR_WITH_PLS_REQUIRED": "La pr\xE9sence de PLS n'est pas d\xE9finie",
  "notification.error.ERROR_HAS_BATTERY_REQUIRED": "La pr\xE9sence de batterie n'est pas d\xE9finie",
  "notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID": "R\xE8gle de remboursement partenaire invalide",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID": "R\xE8gle de remboursement client invalide",
  "notification.error.ERROR_CLIENT_REIMBURSEMENT_VALUES_EMPTY": "La r\xE8gle de remboursement client fournie est vide",
  "notification.error.ERROR_MANDATORY_CHECKS_REQUIRED": "Les contr\xF4les obligatoires ne sont pas d\xE9finis",
  "notification.error.ERROR_INSURED_VALUE_CHECKS_REQUIRED": "Les contr\xF4les de valeur assur\xE9e ne sont pas d\xE9finis",
  "notification.error.ERROR_VALUE_THRESHOLD_REQUIRED": "Le seuil de valeur n'est pas d\xE9fini",
  "notification.error.ERROR_REQUIRED_DOCS_REQUIRED": "Les documents requis ne sont pas d\xE9finis",
  "notification.error.ERROR_OPTIONAL_DOCS_REQUIRED": "Les documents optionnels ne sont pas d\xE9finis",
  "notification.error.ERROR_IS_REPAIR_QUOTE_PARTIAL_CLAIM_REQUIRED_INVALID_FORMAT": "Format de devis de r\xE9paration invalide",
  "notification.error.ERROR_ALREADY_REIMBURSEMENT_CHECK_INVALID_FORMAT": "Format invalide pour le contr\xF4le de remboursement d\xE9j\xE0 effectu\xE9",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_INVALID_FORMAT": "Format invalide pour la date de d\xE9but de v\xE9tust\xE9 du v\xE9lo en jours",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_0_AT_LEAST": "La date de d\xE9but de v\xE9tust\xE9 du v\xE9lo en jours doit \xEAtre au minimum de 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PER_MONTH_0_AT_LEAST": "La v\xE9tust\xE9 du v\xE9lo par mois doit \xEAtre au minimum de 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_0_AT_LEAST": "Le pourcentage de v\xE9tust\xE9 du v\xE9lo doit \xEAtre au minimum de 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_OR_EQUAL_TO_100": "Le pourcentage de v\xE9tust\xE9 du v\xE9lo par mois doit \xEAtre inf\xE9rieur \xE0 100",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_OR_EQUAL_TO_100": "La limite de pourcentage de v\xE9tust\xE9 du v\xE9lo doit \xEAtre inf\xE9rieure \xE0 100",
  "notification.error.ERROR_ACCESSORY_STEPS_REQUIRED": "Aucun acessory steps fourni",
  "notification.error.ERROR_ACCESSORY_STEPS_INVALID_ARRAY": "Tableau invalide pour les \xE9tapes d'accessoires fournis",
  "notification.error.ERROR_ACCESSORY_STEPS_INVALID_FORMAT": "Format invalide pour les \xE9tapes d'accessoires fournis",
  "notification.error.ERROR_COVERAGES_EMPTY": "Le tableau de couvertures fourni est vide",
  "notification.error.ERROR_COVERAGES_REQUIRED": "Aucun coverages fourni",
  "notification.error.ERROR_COVERAGE_PRICING_RULE_DEFINITION_REQUIRED": "Aucun coverage pricing rule definition fourni",
  "notification.error.ERROR_FAVORITE_INVALID_FORMAT": "Format invalide pour le favorite fourni",
  "notification.error.ERROR_FILE_INVALID_FORMAT": "Format invalide pour le file fourni",
  "notification.error.ERROR_FILE_TYPE_REQUIRED": "Aucun file type fourni",
  "notification.error.ERROR_MISSING_BATTERY_FEEDBACK": "Aucun battery feedback fourni",
  "notification.error.CANNOT_CANCEL_ACTIVE_POLICY": "La police n'est pas annulable",
  "notification.error.ERROR_BIKE_PRICE_INVALID_FORMAT": "Format invalide pour le bike price fourni",
  "notification.error.ERROR_BIKE_REQUIRED": "Aucun bike fourni",
  "notification.error.ERROR_MISSING_FIRSTNAME": "Aucun pr\xE9nom fourni",
  "notification.error.ERROR_MISSING_LASTNAME": "Aucun nom de famille fourni",
  "notification.error.AMOUNT_GREATER_THAN_RECEIPTS_AMOUNT": "Le montant du remboursement est sup\xE9rieur au montant du re\xE7u",
  "notification.error.AMOUNT_GREATER_THAN_TOTAL_RECEIPTS_AMOUNT": "Le montant du remboursement est sup\xE9rieur au montant total des re\xE7us",
  "notification.error.ERROR_VEHICLES_ID_EMPTY": "La liste des ids bicycode est vide",
  "notification.error.ERROR_INSURANCE_CLAIMS_INVALID_FORMAT": "Format invalide pour l'insurance claims fourni",
  "notification.error.ERROR_INVALID_RENEW_TOKEN": "Le jeton de renouvellement fourni est invalide",
  "notification.error.ERROR_B2B_POLICY_NOT_AUTO_RENEWABLE": "La police n'est pas renouvelable",
  "notification.error.ERROR_INSURANCE_DATE_INVALID_FORMAT": "Format invalide pour l'insurance date fourni",
  "notification.error.ERROR_INSURANCE_DATE_REQUIRED": "L'Insurance date est requis",
  "notification.error.ERROR_MISS_CHOOSEN_PACKAGES": "Aucun chosen packages fourni",
  "notification.error.ERROR_MISS_CHOOSEN_PACKAGE_WITH_DURATION": "Aucun chosen package with duration fourni",
  "notification.error.ERROR_MISS_CLIENT_INFO": "Aucun client info fourni",
  "notification.error.ERROR_MISS_PACKAGES_INFO": "Aucun packages info fourni",
  "notification.error.ERROR_MISS_PACKAGE_ID": "Aucun id de formule fourni",
  "notification.error.ERROR_MISS_POLICY": "Aucune police fournie",
  "notification.error.ERROR_MISS_POLICY_INFO": "Aucun policy info fourni",
  "notification.error.ERROR_MISS_PRICE_INFO": "Aucun price info fourni",
  "notification.error.ERROR_MISS_PRICING": "Aucun pricing fourni",
  "notification.error.ERROR_MISS_VEHICLE": "Aucun v\xE9hicule fourni",
  "notification.error.ERROR_MISS_VEHICLE_INFO": "Aucun vehicle info fourni",
  "notification.error.ERROR_NEXT_PACKAGE_INVALID_FORMAT": "Format invalide pour le next package fourni",
  "notification.error.ERROR_NOTHING_TO_UPDATE": "Rien \xE0 mettre \xE0 jour",
  "notification.error.ERROR_NO_INVOICES": "Aucun invoices fourni",
  "notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_DATE": "Date invalide pour la fin de p\xE9riode d'occurrence fournie",
  "notification.error.ERROR_OPEN_CLAIM": "Sinistre ouvert",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_ALREADY_EXISTS": "Les param\xE8tres de contr\xF4les ops existent d\xE9j\xE0",
  "notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_ARRAY": "Tableau invalide pour les param\xE8tres de contr\xF4les ops fournis",
  "notification.error.ERROR_OPTIONAL_COVERAGES_EMPTY": "Les couvertures optionnelles ne peuvent pas \xEAtre vides",
  "notification.error.ERROR_PACKAGE_SOURCE_INVALID_TYPE": "Type invalide pour le package source fourni",
  "notification.error.ERROR_PACKAGE_SOURCE_REQUIRED": "Le Package source est requis",
  "notification.error.ERROR_PARTNERS_INVALID_ARRAY": "Les partenaires doivent \xEAtre un tableau",
  "notification.error.ERROR_PARTNERS_INVALID_FORMAT": "Format invalide pour le partners fourni",
  "notification.error.ERROR_PAYMENT_METHODS_VALUE": "Valeur invalide pour les moyens de paiement fournis",
  "notification.error.ERROR_PERCENTAGE_PROHIBITED_FOR_FIXED_TYPE": "Pourcentage interdit pour le type fixe",
  "notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_FORMAT": "Format invalide pour l'id d'antivol personnel fourni",
  "notification.error.ERROR_PMP_ALREADY_EXISTS": "Le PMP existe d\xE9j\xE0",
  "notification.error.ERROR_POLICY_ALREADY_EXIST": "La police existe d\xE9j\xE0",
  "notification.error.ERROR_POLICY_EXPIRED_OVER_ONE_YEAR": "La police a expir\xE9 depuis plus d'un an",
  "notification.error.ERROR_POLICY_INVALID_STATUS": "Statut de police invalide",
  "notification.error.ERROR_POLICY_MISSING_INFORMATION": "Informations manquantes",
  "notification.error.ERROR_POLICY_NOT_FOUND_OR_INCOMPLETE": "Police introuvable ou incompl\xE8te",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_EXPECTED": "Type de prise en charge de prime attendu",
  "notification.error.ERROR_PREMIUM_SUPPORT_TYPE_UNEXPECTED": "Type de prise en charge de prime inattendu",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_ARRAY": "Tableau invalide pour les r\xE8gles de tarification par couverture fournis",
  "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_NOT_ALLOWED_FOR_B2B": "Les r\xE8gles de tarification par couverture ne sont pas autoris\xE9es pour le B2B",
  "notification.error.ERROR_PRIORITY_INVALID_FORMAT": "Format invalide pour le priority fourni",
  "notification.error.ERROR_PRIORITY_REQUIRED": "Le Priority est requis",
  "notification.error.ERROR_QMP_ALREADY_EXISTS": "Le QMP existe d\xE9j\xE0",
  "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_ALREADY_EXISTS": "Les param\xE8tres de remboursement existent d\xE9j\xE0",
  "notification.error.ERROR_SPLITTING_VALUE": "Valeur invalide pour le fractionnement fourni",
  "notification.error.ERROR_STRIPE_SIGNATURE_REQUIRED": "Le Stripe signature est requis",
  "notification.error.ERROR_SUPPORT_AMOUNT_NOT_NUMBER": "Le montant de prise en charge doit \xEAtre un nombre",
  "notification.error.ERROR_TIME_PERIOD_TYPE": "Type de p\xE9riode invalide",
  "notification.error.ERROR_TIME_PERIOD_VALUE": "Valeur de p\xE9riode invalide",
  "notification.error.ERROR_TOO_LATE_TO_CANCEL_CANCELLATION": "Trop tard pour annuler l'annulation",
  "notification.error.ERROR_TOO_MANY_OPENED_REQUESTS": "Trop de demandes ouvertes",
  "notification.error.ERROR_TRAD_CODE_MUST_BE_ONE_OF_THE_VALID_VALUES": "Le code de traduction doit \xEAtre l'une des valeurs valides",
  "notification.error.ERROR_TRAD_CODE_REQUIRED": "Le code de traduction est requis",
  "notification.error.ERROR_USER_CANCEL_ALLOWED_REQUIRED": "L'User cancel allowed est requis",
  "notification.error.ERROR_VEHICLE_ID_INVALID_TYPE": "Type invalide pour l'id de v\xE9hicule fourni",
  "notification.error.INACTIVE_POLICY_OR_ALREADY_STARTED": "La police est inactive ou a d\xE9j\xE0 commenc\xE9",
  "notification.error.INCORRECT_AMOUNT": "Montant incorrect",
  "notification.error.INSURANCE_NO_SUBSCRIPTION_GIVEN": "Aucun abonnement fourni",
  "notification.error.INVALID_CODE": "Code invalide",
  "notification.error.INVALID_COVERAGE_CODE": "Code de couverture invalide",
  "notification.error.INVALID_PACKAGE_STEP": "\xC9tape de formule invalide",
  "notification.error.INVALID_POLICY": "Police invalide",
  "notification.error.INVALID_PREMIUM_SUPPORT_TYPE": "Type de prise en charge de prime invalide",
  "notification.error.INVALID_PROMOTION_CODE": "Code promotionnel invalide",
  "notification.error.INVALID_QUOTE_GIVEN": "Devis fourni invalide",
  "notification.error.INVALID_STATUS": "Statut invalide",
  "notification.error.LAST_CHECK_NOT_ALLOWED": "Dernier contr\xF4le non autoris\xE9",
  "notification.error.MISSING_CLAIM_DATA": "Donn\xE9es de sinistre manquantes",
  "notification.error.MISS_POLICY_PACKAGE": "Formule de police manquante",
  "notification.error.MISS_VEHICLES_AFFECTED_USER": "Utilisateur affect\xE9 aux v\xE9hicules manquant",
  "notification.error.NEW_STATUS_NOT_ALLOWED": "Nouveau statut non autoris\xE9",
  "notification.error.NOT_A_TOTAL_COVERAGE_CODE": "Le sinistre n'est pas total",
  "notification.error.NO_BIKE_FUND": "Aucun fonds v\xE9lo",
  "notification.error.NO_LINES": "Aucune ligne",
  "notification.error.NO_PACKAGES": "Aucune formule",
  "notification.error.NO_PACKAGES_OR_CONTRACT": "Aucune formule ni contrat",
  "notification.error.NO_PLAN_GIVEN": "Aucun plan fourni",
  "notification.error.NO_UPDATE": "Aucune mise \xE0 jour",
  "notification.error.NO_VEHICLE_PHOTO": "Aucune photo de v\xE9hicule",
  "notification.error.PAST_EFFECTIVE_START_DATE": "La date d'effet doit \xEAtre dans le futur",
  "notification.error.PENDING_POLICY_NOT_FOUND": "Police en attente introuvable",
  "notification.error.PERSONAL_LOCK_REQUIRED": "L'antivol est requis",
  "notification.error.PLS_VALIDATION_NOT_CONSISTENT": "Validation PLS incoh\xE9rente",
  "notification.error.POLICY_ALREADY_ENDED": "La police est d\xE9j\xE0 termin\xE9e",
  "notification.error.POLICY_ALREADY_RENEWED": "La police est d\xE9j\xE0 renouvel\xE9e",
  "notification.error.POLICY_IS_NOT_ACTIVE_ANYMORE": "La police n'est plus active",
  "notification.error.POLICY_NOT_CANCELABLE": "Police non annulable",
  "notification.error.POLICY_NOT_FOUND": "Police introuvable",
  "notification.error.POLICY_STILL_IN_DEPRIVATION": "La police est encore en privation",
  "notification.error.QUOTE_NOT_FOUND_OR_INCOMPLETE": "Devis introuvable ou incomplet",
  "notification.error.RECEIPT_NOT_FOUND": "Re\xE7u introuvable",
  "notification.error.RECONDUCTED_POLICY": "La police est reconduite",
  "notification.error.REQUEST_ALREADY_HANDLED": "Demande d\xE9j\xE0 trait\xE9e",
  "notification.error.STRIPE_NOT_EDITABLE": "Stripe non modifiable",
  "notification.error.TOO_LATE_TO_UPDATE_SCHEDULE": "Trop tard pour mettre \xE0 jour le planning",
  "notification.error.UNABLE_TO_DELETE": "Impossible de supprimer",
  "notification.error.UNKNOWN_PRODUCT": "Produit inconnu",
  "notification.error.USER_CHECK_COMMENT_REQUIRED": "L'User check comment est requis",
  "notification.error.USER_ID_REQUIRED": "L'id utilisateur est requis",
  "notification.error.USER_PERSONAL_LOCK_NOT_FOUND": "L'antivol de l'utilisateur est introuvable",
  "notification.error.VEHICLE_NOT_APIC_APPROVED": "Le v\xE9hicule n'a pas \xE9t\xE9 v\xE9rifi\xE9 aupr\xE8s de l'APIC",
  "notification.error.VEHICLE_NOT_EXIST_OR_ERROR_CREATION": "Le v\xE9hicule n'existe pas ou erreur de cr\xE9ation",
  "notification.error.ERROR_TOTAL_TTC_NEGATIVE": "Le prix total (TTC) doit \xEAtre positif",
  "notification.error.ERROR_TOTAL_TTC_FORMAT": "Le prix total (TTC) a un format invalide",
  "notification.error.ERROR_DISCOUNT_AMOUNT_NEGATIVE": "Le montant de la r\xE9duction doit \xEAtre positif",
  "notification.error.ERROR_DISCOUNT_AMOUNT_FORMAT": "Le montant de la r\xE9duction n'est pas dans un format correct",
  "notification.error.ERROR_TVA_PERCENTAGE_NEGATIVE": "Le pourcentage de TVA doit \xEAtre positif",
  "notification.error.ERROR_TVA_PERCENTAGE_FORMAT": "Le pourcentage de TVA n'est pas dans un format correct",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_TOO_HIGH": "Le pourcentage de r\xE9duction doit \xEAtre inf\xE9rieur \xE0 100",
  "notification.error.ERROR_TVA_PERCENTAGE_TOO_HIGH": "Le pourcentage de TVA doit \xEAtre inf\xE9rieur \xE0 100",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_NEGATIVE": "Le pourcentage de r\xE9duction doit \xEAtre positif",
  "notification.error.ERROR_DISCOUNT_PERCENTAGE_FORMAT": "Le pourcentage de r\xE9duction a un format invalide",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_INVALID_TYPE": "La condition d'annulation du rejet de sinistre doit \xEAtre dans le format correct",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_NOT_ALLOWED": "La condition d'annulation du rejet de sinistre n'est pas autoris\xE9e",
  "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_REQUIRED": "Le The cancel condition of the claim reject est requis",
  "notification.error.ERROR_INVALID_PROMO_CODE": "Le code promo est invalide",
  "notification.error.ERROR_NO_POLICY_FOR_RENEWAL": "Aucune police trouv\xE9e pour le renouvellement",
  "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT": "La r\xE9siliation de police en cas de rejet total doit \xEAtre un bool\xE9en",
  "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_REQUIRED": "La r\xE9siliation de police en cas de rejet total est requise",
  "notification.error.ERROR_TERMINATE_POLICY_RETRACTION": "La police est en r\xE9tractation, elle ne peut pas \xEAtre r\xE9sili\xE9e",
  "notification.error.ERROR_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT": "La r\xE9siliation de police en cas de rejet total doit \xEAtre un bool\xE9en",
  "notification.error.VEHICLE_NOT_APIC_APPROVED_OR_INVALID_STATUS": "Le v\xE9hicule n'a pas \xE9t\xE9 v\xE9rifi\xE9 aupr\xE8s de l'APIC ou a un statut invalide",
  "notification.error.ERROR_MAIL_ID_MUST_BE_A_NUMBER": "L'ID de mail doit \xEAtre un nombre",
  "notification.error.ERROR_EXCLUDE_IDS_INVALID_ARRAY": "Les ids \xE0 exclure doivent \xEAtre un tableau",
  "notification.error.ERROR_EXCLUDE_IDS_INVALID_FORMAT": "Format invalide pour les ids \xE0 exclure fourni",
  "notification.error.ERROR_MAX_LAT_INVALID_FORMAT": "Valeur invalide pour la latitude max fournie",
  "notification.error.ERROR_MAX_LAT_REQUIRED": "Aucune latitude max fournie",
  "notification.error.ERROR_MAX_LON_INVALID_FORMAT": "Valeur invalide pour la longitude max fournie",
  "notification.error.ERROR_MAX_LON_REQUIRED": "Aucune longitude max fournie",
  "notification.error.ERROR_MIN_LAT_INVALID_FORMAT": "Valeur invalide pour la latitude min fournie",
  "notification.error.ERROR_MIN_LAT_REQUIRED": "Aucune latitude min fournie",
  "notification.error.ERROR_MIN_LON_INVALID_FORMAT": "Valeur invalide pour la longitude min fournie",
  "notification.error.ERROR_MIN_LON_REQUIRED": "Aucune longitude min fournie",
  "notification.error.ERROR_DETAIL_PICTURE_REQUIRED": "La photo d\xE9tail est manquante",
  "notification.error.ERROR_DETAIL_PICTURE_INVALID_FORMAT": "La photo d\xE9tail est invalide",
  "notification.error.ERROR_CARD_PICTURE_REQUIRED": "La photo card est manquante",
  "notification.error.ERROR_CARD_PICTURE_INVALID_FORMAT": "La photo card est invalide",
  "notification.error.ERROR_CLAIM_NOT_LINKED_TO_GROUP": "Le sinistre n'est pas li\xE9 au groupe",
  "notification.error.ERROR_NEXT_CONTRACT_ID_INVALID_FORMAT": "Le next contract id est invalide",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_DURATION": "La dur\xE9e du prochain contrat est diff\xE9rente",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_PACKAGE": "Le prochain contrat a un package diff\xE9rent",
  "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_USAGE": "Le prochain contrat a un usage diff\xE9rent",
  "notification.error.ERROR_NEXT_CONTRACT_IS_NOT_ACTIVE": "Le prochain contrat n'est pas 'active'",
  "notification.error.ERROR_NEXT_CONTRACT_ID_REQUIRED": "nextContractId est manquant",
  "notification.error.ERROR_PAYMENT_STATUS_INVALID_TYPE": "Le type de statut de paiement est invalide",
  "notification.error.ERROR_B2B_RECEIPTS_INVALID_FORMAT": "Les re\xE7us B2B sont invalide",
  "notification.error.ERROR_B2B_POLICY_UNAUTHORIZED_ACTION": "Action interdit pour la police",
  "notification.error.ERROR_CREATE_CLAIM_PARTNER_INVALID_FORMAT": "Le champ 'should_create_claim_partner' doit \xEAtre un boolean",
  "notification.error.ERROR_CREATE_CLAIM_CLIENT_INVALID_FORMAT": "Le champ 'should_create_claim_client' doit \xEAtre un boolean",
  "notification.error.ERROR_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT": "Le champ 'is_client_cancel_allowed' doit \xEAtre un boolean",
  "notification.error.ERROR_CLIENT_ALLOWED_UPDATE_INVALID_FORMAT": "Le champ 'is_client_allowed_update' doit \xEAtre un boolean",
  "notification.error.ERROR_CLIENT_BIKE_UPDATE_ALLOWED_INVALID_FORMAT": "Le champ 'is_client_bike_update_allowed' doit \xEAtre un boolean",
  "notification.error.ERROR_DISPLAY_AFFECTED_USER_DETAILS_INVALID_FORMAT": "Le champ 'should_display_affected_user_details_client' doit \xEAtre un boolean",
  "notification.error.ERROR_DISPLAY_BIKE_INFORMATION_INVALID_FORMAT": "Le champ 'should_display_bike_informations' doit \xEAtre un boolean",
  "notification.error.ERROR_DISPLAY_POLICY_INFORMATION_INVALID_FORMAT": "Le champ 'should_display_policy_informations' doit \xEAtre un boolean",
  "notification.error.GROUP_BUT_B2B_PRODUCT_NOT_IDENTIFIED": "Le groupe existe mais le produit b2b est inconnu",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_EXCEEDED": "Vous avez d\xE9j\xE0 fait trop de r\xE9clamations partielles pour ce v\xE9lo.",
  "notification.error.ERROR_B2B_POLICIES_INVALID_FORMAT": "Format invalide pour les polices b2b fournis",
  "notification.error.ERROR_QUOTES_AS_INSURED_INVALID_FORMAT": "Format invalide pour le devis en tant qu'assur\xE9 fourni",
  "notification.error.ERROR_VEHICLES_INVALID_FORMAT": "Format invalide pour les v\xE9hicules fournis",
  "notification.error.ERROR_NAME_MIN_1": "Le nom doit comporter au moins 1 caract\xE8re",
  "notification.error.ERROR_APIC_STATUS_HISTORY_INVALID_FORMAT": "Format invalide pour le statut apic fourni",
  "notification.error.ERROR_GROUPS_IN_CONFLICT_INVALID_FORMAT": "Format invalide pour les groupes en conflit fournis",
  "notification.error.WRONG_B2B_USAGE_TYPE": "Type d'usage invalide",
  "notification.error.ERROR_KEY_REQUIRED": "Aucune cl\xE9 fournie",
  "notification.error.ERROR_CAN_NOT_DISABLE_COVERAGE": "La couverture n'a pas pu \xEAtre d\xE9sactiv\xE9e",
  "notification.error.ERROR_ONE_TIME_BILLING_INVALID_FORMAT": "Format invalide pour le facturation unique fourni",
  "notification.error.ERROR_ONE_TIME_BILLING_REQUIRED": "Le Billing est requis",
  "notification.error.ERROR_PRICE_NOT_DEFINED_FOR_INSURED_VALUE": "Aucun tarif disponible pour la formule/montant assur\xE9 sp\xE9cifi\xE9",
  "notification.error.ERROR_BICYCODE_INVALID_FORMAT": "Format invalide pour le bicycode fourni",
  "notification.error.ERROR_COLOR_INVALID_FORMAT": "Format invalide pour la couleur fournie",
  "notification.error.ERROR_FLEET_NAME_INVALID_FORMAT": "Format invalide pour le nom de flotte fourni",
  "notification.error.ERROR_MODEL_INVALID_FORMAT": "Format invalide pour le nom du mod\xE8le fourni",
  "notification.error.ERROR_CANT_DISABLE_PACKAGE_WITH_CONTRACTS": "Impossible de d\xE9sactiver une formule avec des contrats",
  "notification.error.ERROR_SHOP_PRODUCT_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet produit boutique fourni",
  "notification.error.ERROR_GROUP_STATS_VIEW_INVALID_FORMAT": "Format invalide pour la vue de statistiques de groupe fournie",
  "notification.error.ERROR_ORDER_DOES_NOT_EXIST": "La commande n'existe pas",
  "notification.error.ERROR_PRODUCT_ID_INVALID_FORMAT": "Format invalide pour l'id produit fourni",
  "notification.error.ERROR_ORDER_ID_INVALID_FORMAT": "Format invalide pour l'id de commande fourni",
  "notification.error.ERROR_PRODUCT_DOES_NOT_EXIST": "Le produit n'existe pas",
  "notification.error.ERROR_PRODUCT_OUT_OF_STOCK": "Le produit est en rupture de stock",
  "notification.error.ERROR_SPONSOR_NAME_REQUIRED": "Aucun nom de sponsor fourni",
  "notification.error.ERROR_PICTURE_REQUIRED": "Aucun image fourni",
  "notification.error.ERROR_PRODUCT_COST_REQUIRED": "Aucun co\xFBt produit fourni",
  "notification.error.ERROR_PRODUCT_COST_INVALID_FORMAT": "Format invalide pour le co\xFBt produit fourni",
  "notification.error.ERROR_STOCK_INVALID_FORMAT": "Format invalide pour le stock fourni",
  "notification.error.ERROR_XSS_DETECTED": "XSS d\xE9tect\xE9",
  "notification.error.ERROR_PRODUCT_EXPIRED": "Le produit a expir\xE9",
  "notification.error.ERROR_MISSING_PRODUCT_INFORMATIONS": "Informations produit manquantes",
  "notification.error.ERROR_GENERATE_ON_ORDER_REQUIRED": "Aucune g\xE9n\xE9ration \xE0 la commande fournie",
  "notification.error.ERROR_GENERATE_ON_ORDER_INVALID_FORMAT": "Format invalide pour la g\xE9n\xE9ration \xE0 la commande fournie",
  "notification.error.ERROR_PROMO_CODES_INVALID_ARRAY": "Tableau invalide pour les codes promotionnels fournis",
  "notification.error.ERROR_PROMO_CODES_NOT_EMPTY": "Aucun codes promotionnels fournis",
  "notification.error.ERROR_PROMO_CODES_INVALID_FORMAT": "Format invalide pour les codes promotionnels fournis",
  "notification.error.ERROR_API_GENERATION_URL_INVALID_FORMAT": "Format invalide pour l'url de g\xE9n\xE9ration d'api fournie",
  "notification.error.ERROR_DESCRIPTION_INVALID_FORMAT": "Format invalide pour la description fournie",
  "notification.error.ERROR_PARTNER_WEBSITE_URL_INVALID_FORMAT": "Format invalide pour l'url du site partenaire fournie",
  "notification.error.ERROR_PICTURE_INVALID_FORMAT": "Format invalide pour l'image fourni",
  "notification.error.ERROR_SPONSOR_NAME_INVALID_FORMAT": "Format invalide pour le nom de sponsor fourni",
  "notification.error.ERROR_IS_ACTIVE_INVALID_FORMAT": "Format invalide pour l'activation fournie",
  "notification.error.ERROR_REWARD_TYPE_INVALID_TYPE": "Type invalide pour le type de r\xE9compense fourni",
  "notification.error.ERROR_REWARD_TYPE_REQUIRED": "Aucun type de r\xE9compense fourni",
  "notification.error.ERROR_INSUFFICIENT_POINTS": "Points insuffisants",
  "notification.error.ERROR_PRODUCT_NOT_ACTIVE": "Le produit n'est pas actif",
  "notification.error.ERROR_S3_KEY_REQUIRED": "Aucune cl\xE9 s3 fournie",
  "notification.error.ERROR_S3_KEY_INVALID_FORMAT": "Format invalide pour la cl\xE9 s3 fournie",
  "notification.error.ERROR_IS_FRAUD_PARTNER_INVALID_FORMAT": "Format invalide pour le partenaire fraude fourni",
  "notification.error.ERROR_MANAGING_PARTNER_INVALID_FORMAT": "Format invalide pour le partenaire gestionnaire fourni",
  "notification.error.ERROR_MANAGING_PARTNER_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet partenaire gestionnaire fourni",
  "notification.error.ERROR_OPS_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet Ops fourni",
  "notification.error.ERROR_B2B_CLAIM_ID_INVALID_FORMAT": "Format invalide pour l'id de sinistre b2b fourni",
  "notification.error.ERROR_DOCUMENT_NOTES_INVALID_FORMAT": "Format invalide pour les notes de document fournis",
  "notification.error.ERROR_INSURANCE_CLAIM_ID_INVALID_FORMAT": "Format invalide pour l'id de sinistre fourni",
  "notification.error.ERROR_INSURANCE_CLAIM_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet sinistre fourni",
  "notification.error.ERROR_OWNER_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet propri\xE9taire fourni",
  "notification.error.ERROR_OWNING_GROUP_INVALID_FORMAT": "Format invalide pour le groupe propri\xE9taire fourni",
  "notification.error.ERROR_OWNING_GROUP_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet groupe propri\xE9taire fourni",
  "notification.error.ERROR_PERSONAL_LOCKS_INVALID_FORMAT": "Format invalide pour les antivols personnels fournis",
  "notification.error.ERROR_VALIDATED_BY_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet de validation fourni",
  "notification.error.ERROR_VALID_END_DATE_TOO_OLD": "La date de fin de validit\xE9 fournie est trop ancienne",
  "notification.error.ERROR_VALID_START_DATE_INVALID_FORMAT": "Format invalide pour la date de d\xE9but de validit\xE9 fournie",
  "notification.error.ERROR_VALID_START_DATE_TOO_OLD": "La date de d\xE9but de validit\xE9 fournie est trop ancienne",
  "notification.error.ERROR_PACKAGE_OBJECT_INVALID_FORMAT": "Format invalide pour le package_object filter fourni",
  "notification.error.ERROR_PARTNER_OBJECT_INVALID_FORMAT": "Format invalide pour le partner_object filter fourni",
  "notification.error.ERROR_VEHICLE_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet v\xE9hicule fourni",
  "notification.error.ERROR_COMMISSIONS_RULES_INVALID_FORMAT": "Format invalide pour les r\xE8gles de commission fournis",
  "notification.error.ERROR_POLICY_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet police fourni",
  "notification.error.ERROR_AFFECTED_USERS_OBJECT_INVALID_FORMAT": "Format invalide pour les utilisateurs affect\xE9s fournis",
  "notification.error.ERROR_CONTRACTUAL_DOCUMENTS_INVALID_FORMAT": "Format invalide pour les documents contractuels fournis",
  "notification.error.ERROR_CONTRACT_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet contrat fourni",
  "notification.error.ERROR_PRICING_RULES_INVALID_LENGTH": "Longueur invalide pour les r\xE8gles de tarification fournis",
  "notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_REQUIRED": "Aucun pourcentage de prix moyen fourni",
  "notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_INVALID_FORMAT": "Le pourcentage de prix moyen n'est pas dans un format correct",
  "notification.error.ERROR_CLAIM_NOT_ALLOWED_TO_UPDATE": "La mise \xE0 jour du sinistre n'est pas autoris\xE9e",
  "notification.error.ERROR_B2B_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Format invalide pour les param\xE8tres de gestion de police b2b fournis",
  "notification.error.ERROR_B2C_CONTRACT_ID_INVALID_FORMAT": "Format invalide pour l'id de contrat b2c fourni",
  "notification.error.ERROR_CANCELLATION_REQUEST_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet de demande d'annulation fourni",
  "notification.error.ERROR_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Format invalide pour les param\xE8tres de gestion de police fournis",
  "notification.error.ERROR_POLICY_STATUS_INVALID_FORMAT": "Format invalide pour le statut de police fourni",
  "notification.error.ERROR_POLICY_TYPE_INVALID_TYPE": "Type invalide pour le type de police fourni",
  "notification.error.ERROR_PROMO_CODES_REQUIRED": "Format invalide pour les codes promo fournis",
  "notification.error.ERROR_RENEWABLE_INVALID_FORMAT": "Format invalide pour le renouvelable fourni",
  "notification.error.ERROR_RISK_SCORE_INVALID_FORMAT": "Format invalide pour le score de risque fourni",
  "notification.error.ERROR_USER_INVALID_FORMAT": "Format invalide pour l'utilisateur fourni",
  "notification.error.ERROR_B2B_CONTRACT_ID_INVALID_FORMAT": "Format invalide pour l'id de contrat b2b fourni",
  "notification.error.ERROR_COVERAGE_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet couverture fourni",
  "notification.error.ERROR_SPLITTING_TYPE_INVALID_TYPE": "Type invalide pour le type de fractionnement fourni",
  "notification.error.ERROR_ATTRIB_INVALID_FORMAT": "Format invalide pour l'attribut fourni",
  "notification.error.ERROR_DISPLAY_CLAIMS_CLIENT_INVALID_FORMAT": "Format invalide pour l'affichage des sinistres c\xF4t\xE9 client fourni",
  "notification.error.ERROR_DISPLAY_CLAIMS_PARTNER_INVALID_FORMAT": "Format invalide pour l'affichage des sinistres c\xF4t\xE9 partenaire fourni",
  "notification.error.ERROR_IS_CLIENT_EDIT_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'\xE9dition client fournie",
  "notification.error.ERROR_IS_PARTNER_EDIT_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'\xE9dition partenaire fournie",
  "notification.error.ERROR_IS_CLIENT_DOC_VIEW_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation de consultation de documents client fournie",
  "notification.error.ERROR_IS_PARTNER_DOC_VIEW_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation de consultation de documents partenaire fournie",
  "notification.error.ERROR_IS_CLIENT_DOC_UPLOAD_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'upload de documents client fournie",
  "notification.error.ERROR_IS_PARTNER_DOC_UPLOAD_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'upload de documents partenaire fournie",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_INVALID_FORMAT": "Format invalide pour le d\xE9but de v\xE9tust\xE9 du v\xE9lo en jours fourni",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_0_AT_LEAST": "Le d\xE9but de v\xE9tust\xE9 du v\xE9lo en jours doit \xEAtre au minimum de 0",
  "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_100_AT_MOST": "La limite de pourcentage de v\xE9tust\xE9 du v\xE9lo doit \xEAtre au maximum de 100",
  "notification.error.ERROR_B2B_CLAIM_MANAGEMENT_PARAMETERS_INVALID_FORMAT": "Format invalide pour les param\xE8tres de gestion de sinistre b2b fournis",
  "notification.error.ERROR_IS_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'annulation client fournie",
  "notification.error.ERROR_IS_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'annulation partenaire fournie",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_0_AT_LEAST": "Le nombre de sinistres partiels autoris\xE9s doit \xEAtre au minimum de 0",
  "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_NOT_BOOL": "L'autorisation de dur\xE9e sup\xE9rieure au contrat doit \xEAtre un bool\xE9en",
  "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_REQUIRED": "L'autorisation de dur\xE9e sup\xE9rieure au contrat est requise",
  "notification.error.ERROR_AMEND_ALLOWED_NOT_BOOL": "L'autorisation d'avenant doit \xEAtre un bool\xE9en",
  "notification.error.ERROR_AMEND_ALLOWED_REQUIRED": "L'autorisation d'avenant est requise",
  "notification.error.ERROR_REQUEST_STATUS_INVALID_TYPE": "Le statut de la demande doit \xEAtre une valeur d'\xE9num\xE9ration valide",
  "notification.error.ERROR_REQUEST_REASON_INVALID_TYPE": "La raison de la demande doit \xEAtre une valeur d'\xE9num\xE9ration valide",
  "notification.error.ERROR_ARTICLE_ID_INVALID_FORMAT": "Format invalide pour l'id d'article fourni",
  "notification.error.ERROR_RECEIPTS_INVALID_FORMAT": "Format invalide pour les re\xE7us fournis",
  "notification.error.CLIENT_MANAGED_BY_ANOTHER_PARTNER": "Le devis ne peut pas \xEAtre confirm\xE9 car le client est g\xE9r\xE9 par un autre partenaire",
  "notification.error.ERROR_DATE_INVALID_TYPE": "Valeur invalide pour la date fournie",
  "notification.error.ERROR_IBAN_INVALID": "Format invalide pour l'IBAN fourni",
  "notification.error.ERROR_SOURCE_ID_REQUIRED": "L'ID du mod\xE8le de v\xE9lo source est requis",
  "notification.error.ERROR_SOURCE_ID_INVALID_FORMAT": "Format invalide pour l'ID du mod\xE8le de v\xE9lo source",
  "notification.error.ERROR_TARGET_ID_REQUIRED": "L'ID du mod\xE8le de v\xE9lo cible est requis",
  "notification.error.ERROR_TARGET_ID_INVALID_FORMAT": "Format invalide pour l'ID du mod\xE8le de v\xE9lo cible",
  "notification.error.ERROR_SOURCE_AND_TARGET_MUST_BE_DIFFERENT": "Les mod\xE8les de v\xE9lo source et cible doivent \xEAtre diff\xE9rents",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_REQUIRED": "Aucun type de remboursement fourni",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_TYPE": "Type invalide pour le type de remboursement fourni",
  "notification.error.ERROR_USER_AND_PARTNER_NOT_LINKED_BY_POLICY": "L'utilisateur et le partenaire ne sont pas li\xE9s par une police",
  "notification.error.ERROR_TYPOLOGIES_INVALID_FORMAT": "Format invalide pour les typologies fournis",
  "notification.error.ERROR_UUID_INVALID_FORMAT": "Format invalide pour l'uuid fourni",
  "notification.error.ERROR_EVENT_USER_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet utilisateur d'\xE9v\xE9nement fourni",
  "notification.error.ERROR_IS_AMEND_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'avenant fournie",
  "notification.error.ERROR_IS_DURATION_GT_CONTRACT_DURATION_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation de dur\xE9e sup\xE9rieure au contrat fournie",
  "notification.error.already_sponsored": "Vous avez d\xE9j\xE0 \xE9t\xE9 parrain\xE9. Vous ne pouvez \xEAtre parrain\xE9 qu'une seule fois.",
  "notification.error.ERROR_COMMISSION_INVOICE_DOES_NOT_EXIST": "La facture de commission n'existe pas",
  "notification.error.ERROR_COMMISSION_INVOICE_ALREADY_PAID": "La facture de commission est d\xE9j\xE0 pay\xE9e",
  "notification.error.ERROR_COMMISSION_INVOICE_ID_REQUIRED": "L'ID de facture de commission est requis",
  "notification.error.ERROR_COMMISSION_INVOICE_ID_INVALID_FORMAT": "Format invalide pour l'ID de facture de commission fourni",
  "notification.error.ERROR_INVALID_COMMISSION_INVOICE_STATUS_TRANSITION": "Transition de statut de facture de commission invalide",
  "notification.error.ERROR_COMMISSION_INVOICE_ZERO_AMOUNT_ALREADY_EXISTS": "Une facture de commission avec un montant nul existe d\xE9j\xE0 pour cette p\xE9riode",
  "notification.error.ERROR_NO_RECEIPTS": "Aucun re\xE7u trouv\xE9",
  "notification.error.ERROR_PROMO_CODE_NOT_FOUND": "Code promo non trouv\xE9",
  "notification.error.PROMO_CODE_NOT_FOUND": "Code promo non trouv\xE9",
  "notification.error.ERROR_PROMOTION_CODE_ID_INVALID_FORMAT": "Format invalide pour l'id de code promotionnel fourni",
  "notification.error.ERROR_SHOP_PRODUCT_PROMO_CODE_INVALID_FORMAT": "Format invalide pour le code promotionnel du produit boutique fourni",
  "notification.error.ERROR_UNAUTHORIZED": "Non autoris\xE9",
  "notification.error.ERROR_B2B_ONBOARDING_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet d'onboarding b2b fourni",
  "notification.error.ERROR_ONBOARDING_TYPE_REQUIRED": "Le type d'onboarding est requis",
  "notification.error.ERROR_ONBOARDING_TYPE_INVALID_TYPE": "Type invalide pour le type d'onboarding fourni",
  "notification.error.ERROR_POLICY_DURATION_INVALID_FORMAT": "Format invalide pour la dur\xE9e de police fournie",
  "notification.error.ERROR_POLICY_DURATION_TOO_LOW": "La dur\xE9e de police est trop faible",
  "notification.error.ERROR_POLICY_DURATION_TOO_HIGH": "La dur\xE9e de police est trop \xE9lev\xE9e",
  "notification.error.ERROR_COVERAGE_NEEDS_INVALID_ARRAY": "Tableau invalide pour les besoins de couverture fournis",
  "notification.error.ERROR_COVERAGE_NEEDS_DUPLICATE": "Les besoins de couverture doivent \xEAtre uniques",
  "notification.error.ERROR_COVERAGE_NEEDS_INVALID_ENUM": "Enum invalide pour les besoins de couverture fournis",
  "notification.error.ERROR_ESTIMATED_VEHICLE_COUNT_INVALID_TYPE": "Type invalide pour le nombre estim\xE9 de v\xE9hicules fourni",
  "notification.error.ERROR_ESTIMATED_POLICY_COUNT_INVALID_TYPE": "Type invalide pour le nombre estim\xE9 de polices fourni",
  "notification.error.ERROR_RESELL_TYPE_INVALID_TYPE": "Type invalide pour le type de revente fourni",
  "notification.error.ERROR_B2B_ONBOARDING_VALIDATION_FAILED": "La validation de l'onboarding b2b a \xE9chou\xE9",
  "notification.error.ERROR_HAS_OPTIONAL_BATTERY_INVALID_TYPE": "Type invalide pour la pr\xE9sence de batterie optionnelle fournie",
  "notification.error.ERROR_HAS_OPTIONAL_BATTERY_REQUIRED": "La pr\xE9sence de batterie optionnelle est requise",
  "notification.error.ERROR_HAS_TRAILER_INVALID_TYPE": "Type invalide pour la pr\xE9sence de remorque fournie",
  "notification.error.ERROR_HAS_TRAILER_REQUIRED": "La pr\xE9sence de remorque est requise",
  "notification.error.ERROR_IS_OPTIONAL_BATTERY_SAFE_INVALID_FORMAT": "Format invalide pour la s\xE9curit\xE9 de la batterie optionnelle fournie",
  "notification.error.ERROR_IS_TRAILER_SAFE_INVALID_FORMAT": "Format invalide pour la s\xE9curit\xE9 de la remorque fournie",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER": "Format invalide pour le montant r\xE9cup\xE9r\xE9 partenaire fourni",
  "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE": "Le montant r\xE9cup\xE9r\xE9 partenaire doit \xEAtre positif",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER": "Format invalide pour le montant \xE0 r\xE9cup\xE9rer partenaire fourni",
  "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE": "Le montant \xE0 r\xE9cup\xE9rer partenaire doit \xEAtre positif",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_NUMBER": "Format invalide pour le montant \xE0 rembourser partenaire fourni",
  "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_POSITIVE": "Le montant \xE0 rembourser partenaire doit \xEAtre positif",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_NUMBER": "Format invalide pour le montant pay\xE9 partenaire du sinistre fourni",
  "notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_POSITIVE": "Le montant pay\xE9 partenaire du sinistre doit \xEAtre positif",
  "notification.error.ERROR_PRICING_DURATION_REQUIRED": "La dur\xE9e de tarification est requise",
  "notification.error.ERROR_PRICING_DURATION_MUST_BE_GREATER_THAN_ONE": "La dur\xE9e de tarification doit \xEAtre sup\xE9rieure \xE0 1",
  "notification.error.ERROR_PRICING_DURATION_INVALID_FORMAT": "Format invalide pour la dur\xE9e de tarification fournie",
  "notification.error.ERROR_PRICING_TIME_PERIOD_REQUIRED": "La p\xE9riode de tarification est requise",
  "notification.error.ERROR_PRICING_TIME_PERIOD_INVALID_TYPE": "Type invalide pour la p\xE9riode de tarification fournie",
  "notification.error.ERROR_CANCEL_REQUEST_UNIQUE_ID_REQUIRED": "Aucun cancel request unique id fourni",
  "notification.error.ERROR_AT_GD_VALUE_INVALID_FORMAT": "Format invalide pour la valeur at gd fournie",
  "notification.error.ERROR_EMPLOYEE_OF_INVALID_FORMAT": "Format invalide pour l'employeur fourni",
  "notification.error.ERROR_FIRSTNAME_INVALID_FORMAT": "Format invalide pour le pr\xE9nom fourni",
  "notification.error.ERROR_GCLID_FIELD_INVALID_FORMAT": "Format invalide pour le champ gclid fourni",
  "notification.error.ERROR_LASTNAME_INVALID_FORMAT": "Format invalide pour le nom de famille fourni",
  "notification.error.ERROR_OPT_IN_NL_INVALID_FORMAT": "Format invalide pour l'opt-in newsletter fourni",
  "notification.error.ERROR_OPT_IN_NL_MOBILE_INVALID_FORMAT": "Format invalide pour l'opt-in newsletter mobile fourni",
  "notification.error.ERROR_PAGE_URL_INVALID_FORMAT": "Format invalide pour l'url de page fournie",
  "notification.error.ERROR_PARTNERSHIP_SOURCE_INVALID_FORMAT": "Format invalide pour la source de partenariat fournie",
  "notification.error.ERROR_PARTNER_UTM_CONTENT_INVALID_FORMAT": "Format invalide pour le contenu utm partenaire fourni",
  "notification.error.ERROR_PARTNER_UTM_SOURCE_INVALID_FORMAT": "Format invalide pour la source utm partenaire fournie",
  "notification.error.ERROR_QUOTEFORM_ID_INVALID_FORMAT": "Format invalide pour l'id de formulaire de devis fourni",
  "notification.error.ERROR_UTM_CAMPAIGN_INVALID_FORMAT": "Format invalide pour la campagne utm fournie",
  "notification.error.ERROR_UTM_CONTENT_INVALID_FORMAT": "Format invalide pour le contenu utm fourni",
  "notification.error.ERROR_UTM_MEDIUM_INVALID_FORMAT": "Format invalide pour le medium utm fourni",
  "notification.error.ERROR_UTM_SOURCE_INVALID_FORMAT": "Format invalide pour la source utm fournie",
  "notification.error.ERROR_UTM_TERM_INVALID_FORMAT": "Format invalide pour le terme utm fourni",
  "notification.error.ERROR_PROMOTION_CODE_ID_REQUIRED_FOR_INSURANCE_CODE": "L'ID de code promotionnel est requis pour les produits code assurance",
  "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_REQUIRED": "Le mode de remboursement de r\xE9siliation est requis",
  "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_INVALID_TYPE": "Type invalide pour le mode de remboursement de r\xE9siliation fourni",
  "notification.error.ERROR_HAS_PAST_CLAIMS_WITH_BATTERY_CHECKED_INVALID_FORMAT": "L'Has past claims with battery checked value doit \xEAtre dans un format correct",
  "notification.error.ERROR_HAS_PLS_BEEN_VALIDATED_INVALID_FORMAT": "L'Has PLS been validated value doit \xEAtre dans un format correct",
  "notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_INVALID_FORMAT": "Format invalide pour le remboursement direct fourni",
  "notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_INVALID_FORMAT": "Format invalide pour le n\xE9cessit\xE9 de validation PLS fourni",
  "notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_REQUIRED": "Le n\xE9cessit\xE9 de validation PLS est requis",
  "notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_TYPE": "Type invalide pour le statut de couverture du sinistre",
  "notification.error.ERROR_DEPRIVATION_DURATION_IN_DAYS_INVALID_FORMAT": "Format invalide pour la dur\xE9e de privation en jours fournie",
  "notification.error.ERROR_IS_OPS_SUSPEND_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation de suspension ops fournie",
  "notification.error.ERROR_IS_PLS_WITH_TOTAL_CLAIM_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation de PLS avec sinistre total fournie",
  "notification.error.ERROR_IS_USER_CANCEL_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'annulation utilisateur fournie",
  "notification.error.ERROR_PLS_DURATION_LIMIT_IN_DAYS_INVALID_FORMAT": "Format invalide pour la limite de dur\xE9e PLS en jours fournie",
  "notification.error.ERROR_SHOULD_DISPLAY_BIKE_INFORMATIONS_INVALID_FORMAT": "Format invalide pour l'affichage des informations v\xE9lo fourni",
  "notification.error.ERROR_SHOULD_DISPLAY_CONTRACT_INVALID_FORMAT": "Format invalide pour l'affichage du contrat fourni",
  "notification.error.ERROR_SHOULD_DISPLAY_POLICY_INFORMATIONS_INVALID_FORMAT": "Format invalide pour l'affichage des informations de police fourni",
  "notification.error.ERROR_SHOULD_DISPLAY_POLICY_PRICE_INVALID_FORMAT": "Format invalide pour l'affichage du prix de police fourni",
  "notification.error.ERROR_IS_USER_VEHICLE_OWNER_INVALID_FORMAT": "Format invalide pour la propri\xE9t\xE9 du v\xE9hicule par l'utilisateur fournie",
  "notification.error.ERROR_CLAIM_REIMBURSMENT_PARAMETERS_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet de param\xE8tres de remboursement fourni",
  "notification.error.ERROR_IS_APIC_CHECK_REQUIRED_INVALID_FORMAT": "Format invalide pour l'obligation de contr\xF4le APIC fournie",
  "notification.error.ERROR_IS_MARKING_CODE_CHECK_REQUIRED_INVALID_FORMAT": "Format invalide pour l'obligation de contr\xF4le du code de marquage fournie",
  "notification.error.ERROR_IS_PERSONAL_LOCK_REQUIRED_INVALID_FORMAT": "Format invalide pour l'obligation d'antivol personnel fournie",
  "notification.error.ERROR_OPS_CHECK_PARAMETERS_INVALID_FORMAT": "Format invalide pour les param\xE8tres de contr\xF4le ops fournis",
  "notification.error.ERROR_CAN_USER_CREATE_CLAIM_INVALID_FORMAT": "Format invalide pour le possibilit\xE9 pour l'utilisateur de cr\xE9er un sinistre",
  "notification.error.ERROR_CAN_USER_CREATE_CLAIM_REQUIRED": "Le possibilit\xE9 pour l'utilisateur de cr\xE9er un sinistre est requis",
  "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_REQUIRED": "Le demande du type de remboursement est requis",
  "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_INVALID_FORMAT": "Format invalide pour le demande du type de remboursement fourni",
  "notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_FORMAT": "Format invalide pour le type de remboursement fourni",
  "notification.error.REIMBURSEMENT_TYPE_REQUIRED": "Le type de remboursement est requis",
  "notification.error.ERROR_PARTNER_INVOICE_ID_REQUIRED": "L'id de facture partenaire est requis",
  "notification.error.ERROR_PARTNER_INVOICE_ID_INVALID_FORMAT": "L'id de facture partenaire doit \xEAtre un nombre valide",
  "notification.error.ERROR_PARTNER_INVOICE_RECEIPTS_NOT_ALLOWED": "Les re\xE7us ne peuvent pas \xEAtre ajout\xE9s tant que la facture partenaire est pay\xE9e, envoy\xE9e, annul\xE9e ou annul\xE9e (void) ; seules les factures en brouillon (cr\xE9\xE9es) peuvent \xEAtre mises \xE0 jour.",
  "notification.error.ERROR_EXTERNAL_ID_INVALID_FORMAT": "Format invalide pour l'id externe fourni",
  "notification.error.ERROR_PARTNER_INVOICES_INVALID_FORMAT": "Format invalide pour les factures partenaire fournis",
  "notification.error.ERROR_DOCUMENT_PARAMETERS_OBJECTS_INVALID_FORMAT": "Format invalide pour les objets de param\xE8tres de document fournis",
  "notification.error.ERROR_REIMBURSMENT_PARAMETERS_OBJECTS_INVALID_FORMAT": "Format invalide pour les objets de param\xE8tres de remboursement fournis",
  "notification.error.ERROR_OPS_CHECK_PARAMETERS_OBJECTS_INVALID_FORMAT": "Format invalide pour les objets de param\xE8tres de contr\xF4le ops fournis",
  "notification.error.ERROR_BIKE_VALUE_CHECKS_INVALID_TYPE": "Type invalide pour les contr\xF4les de valeur du v\xE9lo fournis",
  "notification.error.ERROR_BIKE_VALUE_CHECKS_REQUIRED": "Aucun contr\xF4les de valeur du v\xE9lo fournis",
  "notification.error.ERROR_BIKE_VALUE_OPS_CHECKS_INVALID_ARRAY": "Tableau invalide pour les contr\xF4les ops de valeur du v\xE9lo fournis",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID": "Valeur invalide pour le seuil de valeur du v\xE9lo fourni",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID_TYPE": "Type invalide pour le seuil de valeur du v\xE9lo fourni",
  "notification.error.ERROR_BIKE_VALUE_THRESHOLD_REQUIRED": "Aucun seuil de valeur du v\xE9lo fourni",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID": "Valeur invalide pour le montant de franchise minimum fourni",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID_TYPE": "Type invalide pour le montant de franchise minimum fourni",
  "notification.error.ERROR_MIN_FRANCHISE_AMOUNT_REQUIRED": "Aucun montant de franchise minimum fourni",
  "notification.error.ERROR_STATUS_CODE_INVALID_FORMAT": "Format invalide pour le code de statut fourni",
  "notification.error.ERROR_ORDER_NOT_VALID": "La commande n'est pas valide",
  "notification.error.ORDER_NOT_VALID": "La commande n'est pas valide",
  "notification.error.ERROR_ORDER_OBJECT_INVALID_FORMAT": "Format invalide pour l'order object fourni",
  "notification.error.ERROR_LINK_URL_REQUIRED": "Aucune url de lien fournie",
  "notification.error.ERROR_LINK_URL_INVALID_FORMAT": "Format invalide pour l'url de lien fournie",
  "notification.error.ERROR_POINTS_INVALID_FORMAT": "Format invalide pour le points fourni",
  "notification.error.ERROR_EARNED_TYPE_INVALID_TYPE": "Type invalide pour le type gagn\xE9",
  "notification.error.ERROR_SPENT_TYPE_INVALID_TYPE": "Type invalide pour le type d\xE9pens\xE9",
  "notification.error.ERROR_IS_CLIENT_ABANDON_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'abandon client fournie",
  "notification.error.ERROR_IS_PARTNER_ABANDON_ALLOWED_INVALID_FORMAT": "Format invalide pour l'autorisation d'abandon partenaire fournie",
  "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_TOO_LOW": "Le nombre de sinistres partiels autoris\xE9s doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 -1",
  "notification.error.ERROR_IS_CONFIRMED_INVALID_FORMAT": "Format invalide pour la confirmation fournie",
  "notification.error.ERROR_CITY_INVALID_FORMAT": "Format invalide pour la ville fournie",
  "notification.error.ERROR_VEHICLE_INVALID_FORMAT": "Format invalide pour le v\xE9hicule fourni",
  "notification.error.ERROR_ENUM_SCORING_TYPE_INVALID_TYPE": "Format invalide pour le scoring fourni",
  "notification.error.ERROR_TRAD_CODE_INVALID_TYPE": "Format invalide pour le code de traduction fourni",
  "notification.error.ERROR_NEXT_PACKAGE_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet package suivant fourni",
  "notification.error.ERROR_PREVIOUS_PACKAGES_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet packages pr\xE9c\xE9dents fourni",
  "notification.error.ERROR_SOME_REQUIRED": "Certains champs sont requis",
  "notification.error.ERROR_FRAUD_SCORE_INVALID_FORMAT": "Format invalide pour le score de fraude fourni",
  "notification.error.ERROR_CLAIM_INVALID_FORMAT": "Format invalide pour le sinistre fourni",
  "notification.error.ERROR_COMMENT_INVALID_FORMAT": "Format invalide pour le commentaire fourni",
  "notification.error.ERROR_POLICY_INVALID_FORMAT": "Format invalide pour la police fournie",
  "notification.error.ERROR_IS_DELETED_INVALID_FORMAT": "Format invalide pour la suppression fournie",
  "notification.error.ERROR_COMMISSIONS_LINES_INVALID_FORMAT": "Format invalide pour les lignes de commissions fournis",
  "notification.error.ERROR_INSURER_INVALID_TYPE": "Format invalide pour l'assureur fourni",
  "notification.error.ERROR_QUOTEID_INVALID_FORMAT": "Format invalide pour l'id de devis fourni",
  "notification.error.ERROR_SERIAL_NUMBER_INVALID_FORMAT": "Format invalide pour le num\xE9ro de s\xE9rie fourni",
  "notification.error.ERROR_SPLITTING_TYPE_INVALID_FORMAT": "Format invalide pour le type de fractionnement fourni",
  "notification.error.ERROR_DOCUMENTS_OBJECT_INVALID_FORMAT": "Format invalide pour l'objet documents fourni",
  "notification.error.ERROR_TOTAL_COST_INVALID_FORMAT": "Format invalide pour le co\xFBt total fourni",
  "notification.error.ERROR_IS_SPONSORSHIP_CODE_USED_INVALID_FORMAT": "Format invalide pour l'utilisation du code de parrainage fournie",
  "notification.error.ERROR_COMMISSION_INVOICE_FREQUENCY_INVALID_TYPE": "Type invalide pour la fr\xE9quence de facture de commission",
  "notification.error.ERROR_GROUP_TOO_RECENT": "Le groupe est trop r\xE9cent pour g\xE9n\xE9rer des commissions",
  "notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_REQUIRED": "Le remboursement direct est requis",
  "notification.error.ERROR_START_DATE_MORE_THAN_10_MINUTES_AGO": "La date de d\xE9but doit dater de moins de 10 minutes",
  "notification.error.ERROR_END_DATE_BEFORE_START_DATE": "La date de fin doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but",
  "notification.error.ERROR_COMMISSION_STATUS_INVALID_TYPE": "Type invalide pour le statut de commission fourni",
  "notification.error.ERROR_NOT_INVALID_FORMAT": "Format invalide pour le not fourni",
  "notification.error.ERROR_COUNTRY_CODE_INVALID_FORMAT": "Le code pays doit \xEAtre un code ISO \xE0 2 lettres",
  "notification.error.ERROR_DOCUMENT_ALREADY_EXISTS": "Le document existe d\xE9j\xE0",
  "notification.error.ERROR_FILE_NOT_FOUND": "Fichier non trouv\xE9",
  "notification.error.ERROR_PAYMENT_METHOD_NOT_SEPA": "Le moyen de paiement n'est pas un pr\xE9l\xE8vement SEPA",
  "notification.error.ERROR_COUNTRY_CODE_TOO_SHORT": "Le code pays fourni est trop court",
  "notification.error.ERROR_COUNTRY_CODE_TOO_LONG": "Le code pays fourni est trop long",
  "notification.error.ERROR_POLICY_QUOTE_ID_REQUIRED": "Un ID de devis de police est requis",
  "notification.error.ERROR_DOCUMENT_TYPE_NOT_SUPPORTED": "Type de document non support\xE9",
  "notification.error.ERROR_POLICY_ALREADY_HAS_AN_ONGOING_CLAIM": "La police a d\xE9j\xE0 un sinistre en cours",
  "notification.inapp.title.APP": "Nouvelle version de l'application !",
  "notification.inapp.title.DOC": "Il y a du nouveau concernant un document.",
  "notification.inapp.title.CLAIM": "Il y a des nouvelles concernant votre demande.",
  "notification.inapp.title.POLICY": "Il y a du nouveau au sujet de votre assurance.",
  "notification.inapp.title.PLS": '"Il y a du nouveau \xE0 propos de votre session "Vigipark".',
  "notification.inapp.title.BIKE": "Il y a du nouveau \xE0 propos de votre v\xE9lo.",
  "notification.inapp.title.INVOICE": "Il y a un probl\xE8me avec vos paiements.",
  "notification.inapp.title.CARD": "Il y a un probl\xE8me avec votre moyen de paiement.",
  "notification.inapp.title.DEFAULT": "Il y a du nouveau",
  "notification.inapp.DOC_REJECTED": 'Votre document "{{docType}}" a \xE9t\xE9 rejet\xE9.',
  "notification.inapp.DOC_INFORMED": `Nous avons besoin d'un compl\xE9ment d'information au sujet de votre "{{docType}}".`,
  "notification.inapp.CLAIM_CLOSED": 'Votre dossier de sinistre "{{claimUniqId}}" est clos.',
  "notification.inapp.CLAIM_CREATED": 'Votre dossier de sinistre "{{claimUniqId}}" a \xE9t\xE9 cr\xE9e.',
  "notification.inapp.CLAIM_QUOTE_VALIDATED": 'Le devis de r\xE9paration, concernant le dossier "{{claimUniqId}}" a \xE9t\xE9 valid\xE9.',
  "notification.inapp.CLAIM_VALIDATED": 'Le dossier de sinistre "{{claimUniqId}}" est valide.',
  "notification.inapp.CLAIM_USER_CHECK": "Merci de contacter le support au sujet de votre dossier de sinistre {{claimUniqId}}.",
  "notification.inapp.CLAIM_PAID": 'Le dossier de sinistre "{{claimUniqId}}" a \xE9t\xE9 pay\xE9.',
  "notification.inapp.CARD_EXPIRED": "Votre carte a expir\xE9. Cliquez ici pour la mettre \xE0 jour.",
  "notification.inapp.CARD_SOON_EXPIRED": "Votre carte va expirer prochainement. Cliquez ici pour la mettre \xE0 jour.",
  "notification.inapp.CARD_NO_DEFAULT": "Vous n'avez pas de carte par d\xE9faut pour les prochains paiements. Cliquez ici pour en choisir une.",
  "notification.inapp.INVOICE_UNPAID": "Vous avez une facture impay\xE9e. Cliquez ici pour r\xE9gulariser.",
  "notification.inapp.POLICY_SUSPENDED": 'Votre police pour le v\xE9lo "{{bikeBrand}} - {{bikeModel}}" a \xE9t\xE9 suspendue.',
  "notification.inapp.POLICY_TERMINATED": 'Votre police pour le v\xE9lo "{{bikeBrand}} - {{bikeModel}}" a \xE9t\xE9 r\xE9sili\xE9e.',
  "notification.inapp.POLICY_RENEWED": 'Votre police pour le v\xE9lo "{{bikeBrand}} - {{bikeModel}}" a \xE9t\xE9 renouvel\xE9e.',
  "notification.inapp.POLICY_CANCEL_PERIOD_END": 'Votre contrat pour le v\xE9lo "{{bikeBrand}} - {{bikeModel}}" ne sera pas renouvel\xE9e \xE0 la fin de votre contrat.',
  "notification.inapp.POLICY_CANCEL_MONTH_END": 'Votre contrat pour le v\xE9lo "{{bikeBrand}} - {{bikeModel}}" sera r\xE9sili\xE9 \xE0 la fin de la mensualit\xE9 en cours.',
  "notification.inapp.PLS_AUTO_TERMINATED": "Votre session Vigipark avec votre {{bikeBrand}} - {{bikeModel}} a \xE9t\xE9 termin\xE9e automatiquement.",
  "notification.inapp.PLS_BATTERY_NOT_REMOVED": "Votre batterie n'a pas \xE9t\xE9 enlev\xE9e de votre {{bikeBrand}} - {{bikeModel}}",
  "notification.inapp.PLS_WHEEL_ONLY": "Il semblerait que votre {{bikeBrand}} - {{bikeModel}} ait \xE9t\xE9 gar\xE9 uniquement avec la roue. Veuillez v\xE9rifier et nous indiquer si c'est bien le cas.",
  "notification.inapp.PLS_INCORRECTLY_PARKED": "Il semblerait que votre {{bikeBrand}} - {{bikeModel}} soit mal gar\xE9. Veuillez v\xE9rifier et nous indiquer si c'est le cas.",
  "notification.inapp.BIKE_INVALID_CODE": 'Votre v\xE9lo "{{bikeBrand}} - {{bikeModel}}" a un code de marquage invalide.',
  "notification.inapp.BIKE_INVALID_APIC_STATUS": `Votre v\xE9lo "{{bikeBrand}} - {{bikeModel}}" n'a pas le bon status aupr\xE8s du FNCUI. En cas de sinistre, vous devez d\xE9clarer l'\xE9tat de votre v\xE9lo aupr\xE8s de votre op\xE9rateur de marquage.`,
  "notification.inapp.APP_UPDATE": "D\xE9couvrez les nouvelles fonctionalit\xE9s de l'application.",
  "notification.inapp.DEFAULT": "Il y a du nouveau.",
  "notification.error.ERROR_RESET_PASSWORD_CODE_EXPIRED_NEW_CODE_SENT": "Le code qui vous avez utilis\xE9 est expir\xE9. Un nouveau code vous a \xE9t\xE9 envoy\xE9 par email.",
  "notification.error.ERROR_EMAIL_IS_SAME": "Le nouvel email doit \xEAtre diff\xE9rent du mail actuel",
  "notification.error.ERROR_EMAIL_CHANGE_CODE_EXPIRED": "Le code de v\xE9rification a expir\xE9",
  "notification.error.ERROR_EMAIL_CHANGE_CODE_INVALID": "Le code de v\xE9rification est invalide",
  "notification.error.ERROR_TOO_MANY_ATTEMPTS": "Nombre de tentatives d\xE9pass\xE9. Veuillez r\xE9essayer plus tard",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_ALLOWED": "La demande de modification de profil n'est pas autoris\xE9e",
  "notification.error.ERROR_NAME_IS_SAME": "Le nom est identique au nom actuel",
  "notification.error.ERROR_BIRTHDAY_IS_SAME": "La date d'anniversaire correspond \xE0 la date d'anniversaire actuelle",
  "notification.error.ERROR_BIRTHPLACE_IS_SAME": "Le lieu de naissance correspond au lieu de naissance actuel",
  "notification.error.ERROR_BIRTHPLACE_TOO_SHORT": "Le lieu de naissance est trop court",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_OPEN": "La demande de changement de profil n'est pas ouverte",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_TYPE_INVALID": "Type de demande de modification de profil non valide",
  "notification.error.ERROR_PROFILE_CHANGE_REQUEST_INVALID_PAYLOAD": "Donn\xE9es de la demande de modification de profil non valides",
  "notification.error.ERROR_OLD_CODE_REQUIRED": "Aucun ancien code n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_NEW_CODE_REQUIRED": "Aucun nouveau code n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_BIRTHDAY_INVALID_YEARS_RANGE": "Plage d'ann\xE9es non valide pour la date de naissance indiqu\xE9e",
  "notification.error.ERROR_ROLES_INVALID_ARRAY": "Tableau non valide pour les r\xF4les fournis",
  "notification.error.ERROR_ROLES_EMPTY_ARRAY": "Le tableau des r\xF4les est vide",
  "notification.error.ERROR_ROLES_INVALID_TYPE": "Type non valide pour les r\xF4les fournis",
  "notification.error.ERROR_SIDE_REQUIRED": "Aucun c\xF4t\xE9 indiqu\xE9",
  "notification.error.ERROR_SIDE_INVALID_FORMAT": "Format non valide pour la valeur fournie",
  "notification.error.ERROR_BADGE_TYPE_REQUIRED": "Le type de badge est obligatoire",
  "notification.error.ERROR_LEVEL_INVALID_FORMAT": "Format non valide pour le niveau indiqu\xE9",
  "notification.error.ERROR_LEVEL_REQUIRED": "Le niveau est obligatoire",
  "notification.error.ERROR_LEVEL_TOO_HIGH": "Le niveau doit \xEAtre inf\xE9rieur ou \xE9gal \xE0 4",
  "notification.error.ERROR_LEVEL_TOO_LOW": "La valeur doit \xEAtre sup\xE9rieure ou \xE9gale \xE0 1",
  "notification.error.ERROR_BADGE_CODE_REQUIRED": "Le code du badge est obligatoire",
  "notification.error.ERROR_BADGE_CODE_INVALID_FORMAT": "Format non valide pour le code de badge fourni",
  "notification.error.ERROR_BADGE_CODE_TOO_LONG": "Le code du badge ne doit pas d\xE9passer 100 caract\xE8res.",
  "notification.error.ERROR_BADGE_DEFINITION_DOES_NOT_EXIST": "La d\xE9finition du badge n'existe pas",
  "notification.error.ERROR_BADGE_DEFINITION_NOT_ACTIVE": "La d\xE9finition du badge n'est pas active",
  "notification.error.ERROR_BADGE_DEFINITION_INVALID_FORMAT": "Format non valide pour la d\xE9finition de badge fournie",
  "notification.error.ERROR_BADGES_INVALID_FORMAT": "Format non valide pour les badges fournis",
  "notification.error.ERROR_BADGE_LEVEL_REQUIRED": "Un niveau de badge est requis",
  "notification.error.ERROR_BADGE_LEVEL_INVALID_FORMAT": "Format non valide pour le niveau de badge indiqu\xE9",
  "notification.error.ERROR_BADGE_LEVEL_TOO_LOW": "Le niveau du badge doit \xEAtre au moins \xE9gal \xE0 1",
  "notification.error.ERROR_BADGE_LEVEL_TOO_HIGH": "Le niveau du badge ne doit pas d\xE9passer 4",
  "notification.error.ERROR_BADGE_LEVEL_ALREADY_ASSIGNED": "Impossible de supprimer un niveau de badge d\xE9j\xE0 attribu\xE9 aux utilisateurs",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_FR_REQUIRED": "Le niveau de badge requis (fran\xE7ais) est obligatoire",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_FR_INVALID_FORMAT": "Format non valide pour la cible de niveau de badge fournie (fran\xE7ais)",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_EN_REQUIRED": "Le niveau de badge requis (en anglais) est obligatoire",
  "notification.error.ERROR_BADGE_LEVEL_TARGET_EN_INVALID_FORMAT": "Format non valide pour la cible de niveau de badge fournie (anglais)",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_REQUIRED": "La description du niveau du badge (en fran\xE7ais) est obligatoire",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_INVALID_FORMAT": "Format non valide pour la description du niveau de badge fournie (fran\xE7ais)",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_REQUIRED": "La description du niveau du badge (en anglais) est obligatoire",
  "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_INVALID_FORMAT": "Format non valide pour la description du niveau de badge fournie (anglais)",
  "notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_INVALID_FORMAT": "Format non valide pour l'URL de l'image du niveau de badge fournie",
  "notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_TOO_LONG": "L'URL de l'image du niveau de badge ne doit pas d\xE9passer 500 caract\xE8res",
  "notification.error.ERROR_DISPLAY_ORDER_REQUIRED": "L'ordre d'affichage est obligatoire",
  "notification.error.ERROR_DISPLAY_ORDER_INVALID_FORMAT": "Format non valide pour l'ordre d'affichage indiqu\xE9",
  "notification.error.ERROR_MAX_LEVEL_REQUIRED": "Le niveau maximum est requis",
  "notification.error.ERROR_MAX_LEVEL_INVALID_FORMAT": "Format non valide pour le niveau maximal indiqu\xE9",
  "notification.error.ERROR_MAX_LEVEL_TOO_LOW": "Le niveau maximum doit \xEAtre d'au moins 1",
  "notification.error.ERROR_MAX_LEVEL_TOO_HIGH": "Le niveau maximal ne doit pas d\xE9passer 4.",
  "notification.error.ERROR_IS_ONE_OFF_REQUIRED": "Faut-il en commander un seul exemplaire ?",
  "notification.error.ERROR_TITLE_FR_REQUIRED": "Le titre (en fran\xE7ais) est obligatoire",
  "notification.error.ERROR_TITLE_FR_INVALID_FORMAT": "Format non valide pour le titre fourni (fran\xE7ais)",
  "notification.error.ERROR_TITLE_FR_TOO_LONG": "Le titre (en fran\xE7ais) ne doit pas d\xE9passer 255 caract\xE8res",
  "notification.error.ERROR_TITLE_EN_REQUIRED": "Le titre (en anglais) est obligatoire",
  "notification.error.ERROR_TITLE_EN_INVALID_FORMAT": "Format non valide pour le titre fourni (anglais)",
  "notification.error.ERROR_TITLE_EN_TOO_LONG": "Le titre (en anglais) ne doit pas d\xE9passer 255 caract\xE8res",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_REQUIRED": "La description \xAB Non acquis \xBB (en fran\xE7ais) est obligatoire",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT": "Format non valide pour la description fournie \xAB non acquise \xBB (fran\xE7ais)",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_TOO_LONG": "La description \xAB non acquise \xBB (en fran\xE7ais) ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_REQUIRED": "La description \xAB Non acquis \xBB (en anglais) est obligatoire",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT": "Format non valide pour la description fournie \xAB not acquired \xBB (anglais)",
  "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_TOO_LONG": "La description non renseign\xE9e (en anglais) ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_REQUIRED": "La description de l'acquisition (en fran\xE7ais) est obligatoire",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT": "Format non valide pour la description fournie (fran\xE7ais)",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_TOO_LONG": "La description de l'acquisition (en fran\xE7ais) ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_REQUIRED": "La description de l'acquisition (en anglais) est obligatoire",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT": "Format non valide pour la description fournie (anglais)",
  "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_TOO_LONG": "La description de l'acquisition (en anglais) ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_REQUIRED": "L'URL de l'image par d\xE9faut est obligatoire",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_INVALID_FORMAT": "Format non valide pour l'URL de l'image par d\xE9faut fournie",
  "notification.error.ERROR_IMAGE_DEFAULT_URL_TOO_LONG": "L'URL de l'image par d\xE9faut ne doit pas d\xE9passer 500 caract\xE8res.",
  "notification.error.ERROR_LEVELS_REQUIRED": "Au moins un niveau de badge est requis",
  "notification.error.ERROR_LEVELS_INVALID_FORMAT": "Format non valide pour les niveaux de badge indiqu\xE9s",
  "notification.error.ERROR_LEVELS_COUNT_MISMATCH": "Le nombre de niveaux de badge doit correspondre au niveau maximal",
  "notification.error.ERROR_IS_ACTIVE_REQUIRED": "Le champ \xAB Actif \xBB est obligatoire",
  "notification.error.CLAIM_NOT_IN_TO_PAY_STATUS": "Pour que la demande d'indemnisation soit prise en charge, elle doit avoir le statut \xAB \xE0 payer \xBB.",
  "notification.error.MISSING_USER_IBAN": "L'utilisateur n'a pas d'IBAN enregistr\xE9",
  "notification.error.MISSING_GROUP_IBAN": "Le groupe ne dispose d'aucun num\xE9ro IBAN enregistr\xE9.",
  "notification.error.TO_BE_REIMBURSED_GROUP_IS_0": "Il n'y a rien \xE0 rembourser au groupe",
  "notification.error.QONTO_TRANSFER_AMOUNT_MISMATCH": "Un virement a d\xE9j\xE0 \xE9t\xE9 effectu\xE9 pour cette demande, mais le montant \xE9tait diff\xE9rent. V\xE9rifiez votre compte Qonto avant de r\xE9essayer.",
  "notification.error.CLAIM_PAYMENT_ALREADY_IN_PROGRESS": "Cette demande vient d'\xEAtre modifi\xE9e ou prise en charge par quelqu'un d'autre. Veuillez actualiser la page avant de r\xE9essayer.",
  "notification.error.INSUFFICIENT_ACCOUNT_BALANCE": "Le solde du compte est insuffisant pour effectuer ce remboursement.",
  "notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_FORMAT": "Format non valide pour le type de politique attendu fourni",
  "notification.error.ERROR_MANAGING_PARTNER_REQUIRED": "On recherche un associ\xE9 g\xE9rant",
  "notification.error.ERROR_DOCUMENT_NOT_IBAN": "Le document fourni n'est pas un document IBAN.",
  "notification.error.ERROR_DOCUMENT_STATUS_NOT_RECEIVED": "\xC0 condition que le statut du document ne soit pas \xAB re\xE7u \xBB",
  "notification.error.ERROR_UNCOVERED_ELEMENTS_INVALID_FORMAT": "Format non valide pour les \xE9l\xE9ments non masqu\xE9s fournis",
  "notification.error.ERROR_UNCOVERED_ELEMENTS_REQUIRED": "Aucun \xE9l\xE9ment non couvert n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_INVALID_FORMAT": "Format non valide pour le montant de l'\xE9l\xE9ment non couvert fourni",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_REQUIRED": "Aucun montant correspondant aux \xE9l\xE9ments non couverts n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_INVALID_FORMAT": "Format non valide pour l'\xE9tiquette de l'\xE9l\xE9ment non couvert fournie",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_REQUIRED": "Aucune \xE9tiquette d'\xE9l\xE9ment non recouvert n'est fournie",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_LONG": "Si le nom de l'\xE9l\xE9ment non masqu\xE9 est trop long",
  "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_SHORT": "Si le libell\xE9 de l'\xE9l\xE9ment non masqu\xE9 est trop court",
  "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_TOO_LOW": "Si la quantit\xE9 d'\xE9l\xE9ments non couverts est trop faible",
  "notification.error.ERROR_NO_COMMISSION_RULES_CONFIGURED": "Aucune r\xE8gle de commission n'est configur\xE9e pour ce groupe",
  "notification.error.NO_RECEIPT_COVERING_TERMINATION_DATE": "Aucun justificatif indiquant la date de r\xE9siliation n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_QUOTE_NOT_EDITABLE": "Citation non modifiable",
  "notification.error.ERROR_CODE_INVALID_FORMAT": "Format non valide pour le code fourni",
  "notification.error.ERROR_OTP_CODE_REQUIRED": "Aucun code OTP n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_OTP_INVALID_FORMAT": "Le code OTP doit \xEAtre un nombre \xE0 6 chiffres",
  "notification.error.ERROR_MANEUVERS_REQUIRED": "Aucune man\u0153uvre pr\xE9vue",
  "notification.error.ERROR_MANEUVERS_INVALID_ARRAY": "Les man\u0153uvres doivent \xEAtre un tableau",
  "notification.error.ERROR_MANEUVER_TYPE_REQUIRED": "Aucun type de man\u0153uvre n'a \xE9t\xE9 indiqu\xE9",
  "notification.error.ERROR_MANEUVER_TYPE_INVALID_FORMAT": "Type de man\u0153uvre non valide",
  "notification.error.ERROR_MANEUVER_INSTRUCTION_REQUIRED": "Aucune instruction de man\u0153uvre n'a \xE9t\xE9 donn\xE9e",
  "notification.error.ERROR_MANEUVER_INSTRUCTION_INVALID_FORMAT": "Format d'instruction de man\u0153uvre non valide",
  "notification.error.ERROR_MANEUVER_DISTANCE_REQUIRED": "Aucune distance de man\u0153uvre n'est indiqu\xE9e",
  "notification.error.ERROR_MANEUVER_DISTANCE_INVALID_FORMAT": "Format de distance de man\u0153uvre non valide",
  "notification.error.ERROR_MANEUVER_DURATION_REQUIRED": "Aucune dur\xE9e de man\u0153uvre n'est indiqu\xE9e",
  "notification.error.ERROR_MANEUVER_DURATION_INVALID_FORMAT": "Format de dur\xE9e de man\u0153uvre non valide",
  "notification.error.ERROR_MANEUVER_BEARING_REQUIRED": "Aucun cap de man\u0153uvre n'est indiqu\xE9",
  "notification.error.ERROR_MANEUVER_BEARING_INVALID_FORMAT": "Format de cap de man\u0153uvre non valide",
  "notification.error.ERROR_MANEUVER_STREET_NAME_INVALID_FORMAT": "Format de nom de rue non valide pour cette man\u0153uvre",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_CLIENT_POLICY": "Le groupe m\xE8ne une politique active en mati\xE8re de client\xE8le",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_PARTNER_POLICY": "Le groupe m\xE8ne une politique active en mati\xE8re de partenariats",
  "notification.error.ERROR_GROUP_HAS_ACTIVE_ATTRIB_POLICY": "Le groupe dispose d'une politique d'attribution active",
  "notification.error.ERROR_GROUP_HAS_POLICY_IN_RETENTION_PERIOD": "Le contrat d'assurance du groupe a pris fin il y a moins de cinq ans",
  "notification.error.ERROR_GROUP_HAS_CLAIM_IN_RETENTION_PERIOD": "Le groupe a un sinistre cl\xF4tur\xE9 il y a moins de cinq ans",
  "notification.error.ERROR_GROUP_MANAGES_OTHER_GROUPS": "Le groupe g\xE8re d'autres groupes",
  "notification.error.ERROR_GROUP_HAS_PAYMENTS": "Le groupe effectue ses paiements via Stripe",
  "notification.error.ERROR_CANNOT_SET_SELF_AS_MANAGING_PARTNER": "Un groupe ne peut pas \xEAtre d\xE9sign\xE9 comme son propre associ\xE9 g\xE9rant.",
  "notification.error.ERROR_KEEP_RECEIPTS_TYPE": "Type non valide pour le param\xE8tre \xAB keep_receipts \xBB fourni",
  "notification.error.ERROR_CANCEL_REASON_INFO_REQUIRED": "Informations obligatoires concernant le motif d'annulation de l'erreur",
  "notification.error.ERROR_SIMULATE_TERMINATION_PENDING_POLICY": "Erreur : simulation d'une r\xE9siliation en attente conform\xE9ment \xE0 la politique en vigueur",
  "notification.error.ERROR_SIMULATE_TERMINATION_POLICY_EFFECTIVE_START_DATE_TOO_OLD": "Erreur : la date de d\xE9but de la politique de simulation de r\xE9siliation est trop ancienne",
  "notification.error.ERROR_EVENT_DATE_INVALID_FORMAT": "Format non valide pour la date de l'\xE9v\xE9nement indiqu\xE9e.",
  "notification.error.ERROR_EVENT_DATE_REQUIRED": "La date de l'\xE9v\xE9nement est obligatoire.",
  "notification.error.ERROR_EVENT_INVALID_TYPE": "Type non valide pour l'\xE9v\xE9nement fourni.",
  "notification.error.ERROR_EVENT_REQUIRED": "Le champ \xAB \xC9v\xE9nement \xBB est obligatoire.",
  "notification.error.ERROR_RAW_BODY_REQUIRED": "Le corps brut est obligatoire.",
  "notification.error.ERROR_SUBSCRIPTION_REQUIRED": "Un abonnement est n\xE9cessaire.",
  "notification.error.ERROR_SUBSCRIPTION_ID_REQUIRED": "Un identifiant d'abonnement est requis.",
  "notification.error.ERROR_INVOICE_DATE_REQUIRED": "La date de facturation est obligatoire.",
  "notification.error.ERROR_INVOICE_DATE_INVALID_FORMAT": "Format non valide pour la date de facture indiqu\xE9e.",
  "notification.error.ERROR_PAYLOAD_REQUIRED": "Une charge utile est requise.",
  "notification.error.ERROR_PAYMENT_STATUS_REQUIRED": "Le statut de paiement est obligatoire.",
  "notification.error.ERROR_UPDATE_INVITATION_DATA_REQUIRED": "Au moins un champ de mise \xE0 jour de l'invitation doit \xEAtre renseign\xE9",
  "notification.error.ERROR_UPDATE_MEMBER_DATA_REQUIRED": "Au moins un champ de mise \xE0 jour des membres est obligatoire",
  "notification.error.ERROR_IS_BATTERY_SAFE_REQUIRED": "Il est n\xE9cessaire de v\xE9rifier la s\xE9curit\xE9 de la batterie",
  "notification.error.ERROR_KEY_INVALID_TYPE": "Le type de la cl\xE9 n'est pas valide",
  "notification.error.ERROR_KEY_INVALID_FORMAT": "Le format de la cl\xE9 n'est pas valide",
  "notification.error.ERROR_UPDATE_CLAIM_NOT_ALLOWED": "Mise \xE0 jour non autoris\xE9e",
  "notification.error.ERROR_VEHICLE_MARKING_CODE_INVALID_FORMAT": "Le format du code d'identification du v\xE9hicule n'est pas valide",
  "notification.error.ERROR_VEHICLE_MARKING_CODE_REQUIRED": "Le code d'immatriculation du v\xE9hicule est obligatoire",
  "notification.error.ERROR_BIKE_ELEMENTS_ONLY_ALLOWED_FOR_PARTIAL_COVERAGE_TYPES": "Les pi\xE8ces du v\xE9lo doivent \xEAtre fournies en cas de vol partiel ou de dommages partiels.",
  "notification.error.ERROR_FIXED_AMOUNT_TYPE_NOT_ALLOWED": "La cr\xE9ation de r\xE8gles de commission de type \xAB montant fixe \xBB n'est pas autoris\xE9e.",
  "notification.error.ERROR_B2C_CONTRACT_DOES_NOT_EXIST": "Aucun contrat B2C n'a \xE9t\xE9 trouv\xE9 pour cette offre et ce partenaire",
  "notification.error.ERROR_OPENING_DATE_BEFORE_OCCURRENCE_END": "La date d'ouverture doit \xEAtre post\xE9rieure \xE0 la date de fin de l'\xE9v\xE9nement",
  "notification.error.ERROR_PARTNER_CANCEL_ALLOWED_REQUIRED": "Le champ \xAB Annulation par le partenaire autoris\xE9e \xBB est obligatoire",
  "notification.error.ERROR_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT": "Format non valide pour le partenaire fourni ; annulation autoris\xE9e",
  "notification.error.ERROR_B2B_POLICY_DOES_NOT_EXIST": "Il n'existe pas de politique B2B",
  "notification.error.ERROR_B2B_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST": "La demande d'annulation de la police B2B n'existe pas",
  "notification.error.ERROR_B2B_QUOTE_NOT_FOUND": "Devis B2B introuvable",
  "notification.error.ERROR_B2B_QUOTE_NOT_EDITABLE": "Devis B2B non modifiable",
  "notification.error.ERROR_PARTNER_INVOICE_DOES_NOT_EXIST": "La facture du partenaire n'existe pas",
  "notification.error.ERROR_INVALID_PARTNER_INVOICE_STATUS": "Le statut de la facture du partenaire ne permet pas cette action",
  "notification.error.ERROR_PARTNER_INVOICE_DOCUMENT_NOT_FOUND": "Le document de facturation du partenaire est introuvable",
  "notification.error.ERROR_PARTNER_INVOICE_EXPORT_NOT_FOUND": "L'exportation des factures des partenaires est introuvable",
  "notification.error.ERROR_B2B2C_PARTNER_INVOICE_STRIPE_MODE_INVALID_TYPE": "Facture partenaire B2B2C non valide en mode Stripe",
  "notification.error.ERROR_SEND_EMAIL_INVALID_TYPE": "Format non valide pour la fonction send_email fournie",
  "notification.error.ERROR_EXTERNAL_ID_TOO_LONG": "L'identifiant externe fourni est trop long",
  "notification.error.ERROR_COMMENT_TOO_LONG": "Le commentaire fourni est trop long",
  "notification.error.NO_REFUNDABLE_AMOUNT_MATCHING_REQUESTED_AMOUNT": "Aucun montant remboursable proche du montant demand\xE9 ne correspond aux justificatifs",
  "notification.error.ERROR_LOW_REQUIRED": "Un seuil bas est requis",
  "notification.error.ERROR_LOW_GREATER_THAN_MAX": "Le seuil bas doit \xEAtre compris entre 0 et 10 000.",
  "notification.error.ERROR_HIGH_REQUIRED": "Un seuil \xE9lev\xE9 est requis",
  "notification.error.ERROR_HIGH_GREATER_THAN_MAX": "La valeur seuil haute doit \xEAtre comprise entre 0 et 10 000.",
  "notification.error.ERROR_HIGH_LOWER_THAN_LOW": "Le seuil haut doit \xEAtre sup\xE9rieur ou \xE9gal au seuil bas",
  "notification.error.ERROR_ENUM_SCORED_ENTITY_INVALID_TYPE": "Format non valide pour l'entit\xE9 not\xE9e fournie",
  "notification.error.ERROR_GREEN_PCT_MISSING": "Le pourcentage vert est obligatoire",
  "notification.error.ERROR_GREEN_PCT_INVALID_NUMBER": "Le pourcentage de vert doit \xEAtre un nombre entier valide",
  "notification.error.ERROR_GREEN_PCT_LOWER_THAN_ZERO": "Le pourcentage de vert doit \xEAtre compris entre 0 et 100",
  "notification.error.ERROR_GREEN_PCT_GREATER_THAN_HUNDRED": "Le pourcentage de vert doit \xEAtre compris entre 0 et 100",
  "notification.error.ERROR_RED_PCT_MISSING": "Le pourcentage en rouge est obligatoire",
  "notification.error.ERROR_RED_PCT_INVALID_NUMBER": "Le pourcentage en rouge doit \xEAtre un nombre entier valide",
  "notification.error.ERROR_RED_PCT_LOWER_THAN_ZERO": "Le pourcentage en rouge doit \xEAtre compris entre 0 et 100",
  "notification.error.ERROR_RED_PCT_GREATER_THAN_HUNDRED": "Le pourcentage en rouge doit \xEAtre compris entre 0 et 100",
  "notification.error.ERROR_GREEN_PLUS_RED_OVER_HUNDRED": "La somme des pourcentages verts et rouges ne peut pas d\xE9passer 100",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_MISSING": "Il est n\xE9cessaire d'avoir atteint le plafond de conversion des parrainages",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_INVALID_NUMBER": "Le code de parrainage \xE0 utiliser doit \xEAtre un num\xE9ro valide.",
  "notification.error.ERROR_REFERRAL_MAX_REDEEM_LOWER_THAN_ZERO": "Le montant maximal des r\xE9compenses de parrainage doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_MISSING": "Le pourcentage de parrainage doit \xEAtre utilis\xE9",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_INVALID_NUMBER": "Le pourcentage de parrainage \xE0 \xE9changer doit \xEAtre un nombre valide",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_LOWER_THAN_ZERO": "Le pourcentage de r\xE9compense pour les parrainages doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0",
  "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_GREATER_THAN_ONE": "Le pourcentage de conversion des parrainages doit \xEAtre inf\xE9rieur ou \xE9gal \xE0 1",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_MISSING": "Un montant maximal de remboursement par parrain est requis",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_INVALID_NUMBER": "Le code de parrainage \xE0 utiliser doit \xEAtre un nombre valide.",
  "notification.error.ERROR_SPONSOR_MAX_REDEEM_LOWER_THAN_ZERO": "Le nombre maximal de points \xE0 \xE9changer par parrain doit \xEAtre sup\xE9rieur ou \xE9gal \xE0 0.",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_MISSING": "Le num\xE9ro d'identification du coupon annuel est obligatoire",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_INVALID": "L'identifiant du coupon annuel doit \xEAtre une cha\xEEne de caract\xE8res",
  "notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_TOO_LONG": "Le nombre de caract\xE8res de l'identifiant du coupon annuel doit \xEAtre inf\xE9rieur \xE0 255.",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_MISSING": "Le code d'identification du coupon annuel en pourcentage est obligatoire",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_INVALID": "L'identifiant du coupon annuel en pourcentage doit \xEAtre une cha\xEEne de caract\xE8res",
  "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_TOO_LONG": "Le code du coupon annuel exprim\xE9 en pourcentage ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_MISSING": "Le num\xE9ro de coupon mensuel est obligatoire",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_INVALID": "L'identifiant du coupon mensuel \xAB Amount \xBB doit \xEAtre une cha\xEEne de caract\xE8res",
  "notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_TOO_LONG": "Le num\xE9ro de coupon mensuel ne doit pas d\xE9passer 255 caract\xE8res.",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_MISSING": "Le code d'identification du coupon mensuel en pourcentage est obligatoire",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_INVALID": "L'identifiant du coupon mensuel en pourcentage doit \xEAtre une cha\xEEne de caract\xE8res",
  "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_TOO_LONG": "Le num\xE9ro de coupon mensuel exprim\xE9 en pourcentage doit comporter moins de 255 caract\xE8res.",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_DUPLICATE": "Les codes d'identification des v\xE9hicules doivent \xEAtre uniques",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_EMPTY": "La liste des codes d'identification des v\xE9hicules est vide",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_INVALID_ARRAY": "Tableau non valide pour les codes d'identification des v\xE9hicules fournis",
  "notification.error.ERROR_VEHICLES_MARKING_CODE_NOT_ACTIVE": "Le code d'identification du v\xE9hicule n'est pas actif sur la police d'assurance",
  "notification.error.ERROR_IS_ONE_OFF_INVALID_FORMAT": "Le format de \xAB one off \xBB doit \xEAtre correct.",
  "notification.error.ERROR_STRIPE_SIGNATURE_INVALID": "La signature Stripe n'est pas valide",
  "notification.error.INVALID_OAUTH_STATE": "\xC9tat OAuth non valide",
  "notification.error.ERROR_SEND_MAIL_INVALID_FORMAT": "La valeur de \xAB Send mail \xBB doit \xEAtre un bool\xE9en",
  "notification.error.POLICY_ALREADY_HAS_AMENDMENT": "Un amendement a d\xE9j\xE0 \xE9t\xE9 apport\xE9 \xE0 cette politique",
  "notification.error.ERROR_TERMINATE_POLICY_DUE_DATE_NOT_SIMULABLE": "La r\xE9siliation \xE0 la date d'\xE9ch\xE9ance ne peut pas \xEAtre simul\xE9e",
  "notification.error.ERROR_RJ_UUID_REQUIRED": "L'UUID RJ est obligatoire",
  "notification.error.ERROR_CLAIM_PHOTO_ALREADY_USED": "Signaler une photo d\xE9j\xE0 utilis\xE9e",
  "notification.error.ERROR_CLAIM_PHOTO_NOT_FOUND": "La photo de la r\xE9clamation est introuvable",
  "notification.error.ERROR_CLAIM_PHOTO_NOT_IN_BUCKET": "Signaler qu'une photo ne figure pas dans le panier",
  "notification.error.ERROR_TRAJECT_TYPE_REQUIRED": "Le type de trajectoire est obligatoire",
  "notification.error.ERROR_DISTANCE_REQUIRED": "Il faut respecter une certaine distance",
  "notification.error.ERROR_CYCLEWAY_PERCENTAGE_REQUIRED": "Le pourcentage de pistes cyclables est obligatoire",
  "notification.error.ERROR_CYCLEWAY_PERCENTAGE_INVALID_FORMAT": "Le pourcentage de pistes cyclables doit \xEAtre exprim\xE9 dans un format correct",
  "notification.error.ERROR_COORDINATES_REQUIRED": "Les coordonn\xE9es sont obligatoires",
  "notification.error.ERROR_COORDINATES_INVALID_ARRAY": "Les coordonn\xE9es doivent \xEAtre un tableau",
  "notification.error.ERROR_DESTINATION_REQUIRED": "Le champ \xAB Destination \xBB est obligatoire",
  "notification.error.ERROR_ELEVATION_INVALID_FORMAT": "L'altitude doit \xEAtre indiqu\xE9e dans un format correct",
  "notification.error.ERROR_ERROR_DESCRIPTION_INVALID_FORMAT": "Format non valide pour la description de l'erreur fournie",
  "notification.error.ERROR_OAUTH_ERROR_INVALID_FORMAT": "Format non valide pour l'erreur OAuth fournie",
  "notification.error.ERROR_RETURN_TO_INVALID_FORMAT": "Format non valide pour l'adresse de retour fournie",
  "notification.error.ERROR_SCOPE_INVALID_FORMAT": "Format non valide pour la port\xE9e indiqu\xE9e",
  "notification.error.ERROR_STATE_INVALID_FORMAT": "Format non valide pour l'\xE9tat indiqu\xE9",
  "notification.error.ERROR_ASSIGNED_OPS_USER_OBJECT_INVALID_FORMAT": "Format non valide pour l'objet `assigned_ops_user_object` fourni",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ALREADY_ASSIGNED": "Utilisateur \xAB ops \xBB d\xE9j\xE0 attribu\xE9",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ID_INVALID_FORMAT": "Format non valide pour la valeur fournie \xAB assigned_ops_user_id \xBB",
  "notification.error.ERROR_ASSIGNED_OPS_USER_ID_REQUIRED": "Un identifiant utilisateur \xAB ops \xBB attribu\xE9 est obligatoire",
  "notification.error.ERROR_OPS_USER_DOES_NOT_EXIST": "L'utilisateur \xAB Ops \xBB n'existe pas",
  "notification.error.QONTO_TRANSFER_MISSING_ID": "Virement Qonto : identifiant manquant",
  "notification.error.ERROR_B2B_POLICY_INVALID_FORMAT": "Format non valide pour la politique B2B fournie",
  "notification.error.ERROR_QUOTES_INVALID_ARRAY": "Les citations fournies ne constituent pas un tableau",
  "notification.error.ERROR_QUOTES_REQUIRED": "Aucun devis fourni",
  "notification.error.ERROR_QUOTES_TOO_MANY": "Il est possible de cr\xE9er jusqu'\xE0 50 devis \xE0 la fois",
  "notification.error.ERROR_CLAIM_VEHICLE_IDENTIFIER_REQUIRED": "Le code d'identification du v\xE9lo ou son num\xE9ro de s\xE9rie est obligatoire",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_REQUIRED": "Le code d'identification du v\xE9lo ou son num\xE9ro de s\xE9rie est obligatoire",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_EXCLUSIVE": "Indiquez uniquement soit le code d'identification du v\xE9lo, soit son num\xE9ro de s\xE9rie.",
  "notification.error.ERROR_VEHICLE_IDENTIFIER_NOT_UNIQUE": "Plusieurs v\xE9los correspondent \xE0 cet identifiant",
  "notification.error.ERROR_PARTNER_TERMINATE_PRIOR_TO_TWELVE_MONTH_INVALID_FORMAT": "La r\xE9siliation du contrat de partenariat avant douze mois doit \xEAtre une valeur bool\xE9enne",
  "notification.error.ERROR_ACKNOWLEDGE_DATE_BEFORE_RECEIVED_DATE": "La date d'accus\xE9 de r\xE9ception doit \xEAtre post\xE9rieure \xE0 la date de r\xE9ception",
  "notification.error.ERROR_ACKNOWLEDGE_DATE_INVALID_FORMAT": "Format non valide pour la date de confirmation indiqu\xE9e",
  "notification.error.ERROR_B2B_CLAIM_OBJECT_INVALID_FORMAT": "Format non valide pour l'objet de demande B2B fourni",
  "notification.error.ERROR_B2C_CLAIM_OBJECT_INVALID_FORMAT": "Format non valide pour l'objet de r\xE9clamation b2c fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_ALREADY_EXISTS": "La r\xE9clamation existe d\xE9j\xE0",
  "notification.error.ERROR_CLAIM_COMPLAINT_CLAIM_REQUIRED": "Aucune d\xE9claration n'a \xE9t\xE9 fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_INVALID_FORMAT": "Format non valide pour le commentaire de niveau 2 fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_REQUIRED": "Aucun commentaire de niveau 2 n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_FEEDBACK_INVALID_FORMAT": "Format non valide pour les commentaires fournis",
  "notification.error.ERROR_CLAIM_COMPLAINT_INSURER_NOT_FOUND": "Impossible d'identifier l'assureur concern\xE9 par la r\xE9clamation",
  "notification.error.ERROR_CLAIM_COMPLAINT_IS_LEVEL_2_INVALID_FORMAT": "Format non valide pour la valeur fournie \xAB is_level_2 \xBB",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_2_FIELDS_REQUIRE_LEVEL_2": "Les champs de niveau 2 n\xE9cessitent un niveau de plainte 2 ou sup\xE9rieur",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_DECREASE": "Le nombre de r\xE9clamations ne peut que s'accro\xEEtre",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_SKIP": "Le niveau de r\xE9clamation ne peut augmenter que d'une unit\xE9.",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_INVALID_FORMAT": "Format non valide pour le niveau indiqu\xE9",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_REQUIRES_REJECTED_RESPONSE": "Le niveau de r\xE9clamation ne peut augmenter qu\u2019apr\xE8s le rejet du niveau actuel.",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_HIGH": "Le niveau indiqu\xE9 est trop \xE9lev\xE9",
  "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_LOW": "Le niveau indiqu\xE9 est trop bas",
  "notification.error.ERROR_CLAIM_COMPLAINT_OBJECT_INVALID_FORMAT": "Format non valide pour l'objet \xAB r\xE9clamation \xBB fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_POLICY_HOLDER_INFO_MISSING": "Les informations relatives au souscripteur sont manquantes",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_ALREADY_SET": "La r\xE9ponse \xE0 la r\xE9clamation est d\xE9j\xE0 d\xE9finie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DATE_LEVEL_2_INVALID_FORMAT": "Format non valide pour la date de r\xE9ponse de niveau 2 fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_ALREADY_SET": "Le document de r\xE9ponse \xE0 la r\xE9clamation est d\xE9j\xE0 pr\xEAt",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_MISSING": "Le document de r\xE9ponse \xE0 la r\xE9clamation est manquant",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_REQUIRED": "Aucun document de r\xE9ponse \xE0 la r\xE9clamation n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_INVALID_FORMAT": "Format non valide pour la r\xE9ponse fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_ALREADY_SET": "La r\xE9ponse de niveau 2 \xE0 la r\xE9clamation est d\xE9j\xE0 configur\xE9e",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_DOCUMENT_REQUIRED": "Aucun document de r\xE9ponse de niveau 2 n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_INVALID_FORMAT": "Format non valide pour la r\xE9ponse de niveau 2 fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_REQUIRED": "Aucune r\xE9ponse de niveau 2 n'a \xE9t\xE9 fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_REQUIRED": "Aucune r\xE9ponse n'a \xE9t\xE9 fournie",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID": "Mod\xE8le de r\xE9ponse \xE0 une r\xE9clamation concernant une demande non valable",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID_FORMAT": "Format non valide pour le mod\xE8le de r\xE9ponse fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_REQUIRED": "Aucun mod\xE8le de r\xE9ponse n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_INVALID_TYPE": "Type non valide pour l'objet de la r\xE9clamation fourni",
  "notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_REQUIRED": "Aucun objet de r\xE9clamation n'a \xE9t\xE9 indiqu\xE9",
  "notification.error.ERROR_CLAIM_COMPLAINT_TYPE_INVALID_TYPE": "Type non valide pour le type de r\xE9clamation indiqu\xE9",
  "notification.error.ERROR_CLAIM_COMPLAINT_TYPE_REQUIRED": "Aucun type de r\xE9clamation n'a \xE9t\xE9 indiqu\xE9",
  "notification.error.ERROR_COMPLAINER_ADDRESS_INVALID_FORMAT": "Format non valide pour l'adresse du plaignant fournie",
  "notification.error.ERROR_COMPLAINER_ADDRESS_REQUIRED": "Aucune adresse du plaignant n'a \xE9t\xE9 fournie",
  "notification.error.ERROR_COMPLAINER_CITY_INVALID_FORMAT": "Format non valide pour la ville indiqu\xE9e par le plaignant",
  "notification.error.ERROR_COMPLAINER_CITY_REQUIRED": "Aucune ville \xAB sans r\xE2leurs \xBB n'a \xE9t\xE9 indiqu\xE9e",
  "notification.error.ERROR_COMPLAINER_FIRSTNAME_INVALID_FORMAT": "Format non valide pour le pr\xE9nom du plaignant fourni",
  "notification.error.ERROR_COMPLAINER_FIRSTNAME_REQUIRED": "Aucun pr\xE9nom de plaignant n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_COMPLAINER_LASTNAME_INVALID_FORMAT": "Format non valide pour le nom de famille du plaignant fourni",
  "notification.error.ERROR_COMPLAINER_LASTNAME_REQUIRED": "Aucun nom de famille n'a \xE9t\xE9 fourni par le plaignant",
  "notification.error.ERROR_COMPLAINER_TYPE_INVALID_TYPE": "Type non valide pour le type de plaignant fourni",
  "notification.error.ERROR_COMPLAINER_TYPE_REQUIRED": "Aucun type de \xAB r\xE2leur \xBB n'est pr\xE9vu",
  "notification.error.ERROR_COMPLAINER_ZIPCODE_REQUIRED": "Aucun code postal n'a \xE9t\xE9 fourni par le plaignant",
  "notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_INVALID_FORMAT": "Format non valide pour le montant indiqu\xE9 dans le litige financier",
  "notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_TOO_LOW": "Le montant du litige financier en cause est trop faible",
  "notification.error.ERROR_INSURER_REQUIRED": "Aucun assureur n'a \xE9t\xE9 indiqu\xE9",
  "notification.error.ERROR_RECEIVED_DATE_BEFORE_SENDING_DATE": "La date de r\xE9ception doit \xEAtre post\xE9rieure \xE0 la date d'envoi",
  "notification.error.ERROR_RECEIVED_DATE_INVALID_FORMAT": "Format non valide pour la date de r\xE9ception indiqu\xE9e",
  "notification.error.ERROR_RECEIVED_DATE_REQUIRED": "Aucune date de r\xE9ception n'a \xE9t\xE9 indiqu\xE9e",
  "notification.error.ERROR_RECEPTION_MEDIUM_EMPTY": "Aucun support de r\xE9ception n'est fourni",
  "notification.error.ERROR_RECEPTION_MEDIUM_INVALID_ARRAY": "Le support de r\xE9ception fourni n'est pas un r\xE9seau",
  "notification.error.ERROR_RECEPTION_MEDIUM_INVALID_TYPE": "Type non valide pour le support de r\xE9ception fourni",
  "notification.error.ERROR_RECEPTION_MEDIUM_REQUIRED": "Aucun support de r\xE9ception n'est fourni",
  "notification.error.ERROR_RESPONSE_DATE_BEFORE_ACKNOWLEDGE_DATE": "La date de r\xE9ponse doit \xEAtre post\xE9rieure \xE0 la date d'accus\xE9 de r\xE9ception",
  "notification.error.ERROR_RESPONSE_DATE_INVALID_FORMAT": "Format non valide pour la date de r\xE9ponse fournie",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_ACKNOWLEDGE_DATE": "La date de r\xE9ponse de niveau 2 doit \xEAtre post\xE9rieure \xE0 la date d'accus\xE9 de r\xE9ception",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_RESPONSE_DATE": "La date de r\xE9ponse de niveau 2 doit \xEAtre post\xE9rieure \xE0 la date de r\xE9ponse",
  "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_REQUIRED": "Aucune date d'intervention de niveau 2 n'a \xE9t\xE9 communiqu\xE9e",
  "notification.error.ERROR_RESPONSE_DATE_REQUIRED": "Aucune date de r\xE9ponse n'a \xE9t\xE9 indiqu\xE9e",
  "notification.error.ERROR_SENDING_DATE_INVALID_FORMAT": "Format non valide pour la date d'envoi indiqu\xE9e",
  "notification.error.ERROR_SENDING_DATE_REQUIRED": "Aucune date d'envoi n'est indiqu\xE9e",
  "notification.error.ERROR_WITH_MEDIATION_INVALID_FORMAT": "Format non valide pour la m\xE9diation fournie",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_FORMAT": "Format non valide pour le lien de r\xE9f\xE9rence du service client fourni",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_URL": "URL non valide pour le lien de r\xE9f\xE9rence du service client fourni",
  "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_REQUIRED": "Aucun lien de r\xE9f\xE9rence du service client n'a \xE9t\xE9 fourni",
  "notification.error.ERROR_MISS_FLEET_ADDRESS": "L'adresse de la flotte est obligatoire",
  "notification.error.ERROR_MISS_FLEET_ZIPCODE": "Le code postal de la flotte est obligatoire",
  "notification.error.ERROR_MISS_FLEET_CITY": "Une ville dot\xE9e d'un parc automobile est requise",
  "notification.error.ERROR_MISS_FLEET_EMAIL": "Une adresse e-mail professionnelle est obligatoire",
  "notification.error.ERROR_MISS_FLEET_PHONE": "Le num\xE9ro de t\xE9l\xE9phone de la flotte est obligatoire",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_INVALID_FORMAT": "Format non valide pour la modification fournie : le nombre de jours autoris\xE9s pour le renouvellement apr\xE8s la date de fin",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_REQUIRED": "Il est n\xE9cessaire de pr\xE9ciser le nombre de jours autoris\xE9s pour renouveler la modification apr\xE8s la fin de la p\xE9riode.",
  "notification.error.ERROR_AMENDMENT_RENEW_NOT_ALLOWED": "Il n'est pas possible de modifier ou de renouveler cette police.",
  "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_MUST_0_AT_LEAST": "La valeur de l'amendement \xAB nombre de jours autoris\xE9s apr\xE8s la fin \xBB doit \xEAtre au moins \xE9gale \xE0 0",
  "notification.error.ERROR_MISS_CLIENT_OWNER_INFOS": "Aucune information sur le propri\xE9taire du client n'a \xE9t\xE9 fournie",
  "notification.error.NOTHING_TO_REIMBURSE_USER": "Il n'y a aucun montant \xE0 rembourser \xE0 l'utilisateur",
  "notification.error.ERROR_GROUP_HAS_PENDING_PARTNER_INVOICE": "Le groupe a une facture partenaire en attente de paiement"
};

// src/lib/trads.ts
i18n.init({
  compatibilityJSON: "v4",
  resources: {
    en: { translation: translation_default },
    fr: { translation: translation_default2 }
  },
  lng: "en",
  contextSeparator: "_"
});
async function changeLanguage(lang) {
  await i18n.changeLanguage(lang);
}
__name(changeLanguage, "changeLanguage");
var trads_default = i18n;

// src/errorMessages.ts
var getGeneratedDefaultErrorMessage = /* @__PURE__ */ __name((code) => trads_default.t("notification.error.DEFAULT_ERROR_MESSAGE", {
  defaultValue: 'An error occured. Please contact support with information "{code}"',
  code
}), "getGeneratedDefaultErrorMessage");
var getTranslations = /* @__PURE__ */ __name((key) => {
  return {
    // Generics
    CLIENT_MANAGED_BY_ANOTHER_PARTNER: trads_default.t("notification.error.CLIENT_MANAGED_BY_ANOTHER_PARTNER", {
      defaultValue: "Quote can not be confirmed as client is managed by another partner"
    }),
    ERROR_AND_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AND_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided and"
    }),
    ERROR_OR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided or"
    }),
    ERROR_NOT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NOT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided not"
    }),
    ERROR_ID_REQUIRED: trads_default.t("notification.error.ERROR_ID_REQUIRED", {
      defaultValue: "No id provided"
    }),
    ERROR_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided id"
    }),
    ERROR_IDS_REQUIRED: trads_default.t("notification.error.ERROR_IDS_REQUIRED", {
      defaultValue: "No ids provided"
    }),
    ERROR_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided ids"
    }),
    ERROR_IDS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_IDS_INVALID_ARRAY", {
      defaultValue: "Provided ids not an array"
    }),
    ERROR_IDS_EMPTY: trads_default.t("notification.error.ERROR_IDS_EMPTY", {
      defaultValue: "No ids provided"
    }),
    ERROR_IDS_DUPLICATES: trads_default.t("notification.error.ERROR_IDS_DUPLICATES", {
      defaultValue: "There is some duplicates in provided ids"
    }),
    ERROR_NAME_REQUIRED: trads_default.t("notification.error.ERROR_NAME_REQUIRED", {
      defaultValue: "No name provided"
    }),
    ERROR_DATE_REQUIRED: trads_default.t("notification.error.ERROR_DATE_REQUIRED", {
      defaultValue: "No date provided"
    }),
    ERROR_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided date"
    }),
    ERROR_DATE_INVALID_TYPE: trads_default.t("notification.error.ERROR_DATE_INVALID_TYPE", {
      defaultValue: "Invalid value for provided date"
    }),
    ERROR_INVALID_ACCESSORIES_VALUE: trads_default.t("notification.error.ERROR_INVALID_ACCESSORIES_VALUE", {
      defaultValue: "Invalid accessories value"
    }),
    ERROR_PRICE_REQUIRED: trads_default.t("notification.error.ERROR_PRICE_REQUIRED", {
      defaultValue: "No price provided"
    }),
    ERROR_PRICE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRICE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided price"
    }),
    ERROR_INVALID_PRICE: trads_default.t("notification.error.ERROR_INVALID_PRICE", {
      defaultValue: "Invalid price"
    }),
    ERROR_PRICE_TOO_LOW: trads_default.t("notification.error.ERROR_PRICE_TOO_LOW", {
      defaultValue: "Provided price is too low"
    }),
    ERROR_PRICE_TOO_HIGH: trads_default.t("notification.error.ERROR_PRICE_TOO_HIGH", {
      defaultValue: "Provided price is too high"
    }),
    ERROR_IS_B2B_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_B2B_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is b2b"
    }),
    ERROR_ZIPCODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ZIPCODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided zipcode"
    }),
    ERROR_BODY_REQUIRED: trads_default.t("notification.error.ERROR_BODY_REQUIRED", {
      defaultValue: "No body provided"
    }),
    ERROR_DATAS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_DATAS_INVALID_ARRAY", {
      defaultValue: "Provided datas not an array"
    }),
    ERROR_DATE_NOT_IN_FUTUR: trads_default.t("notification.error.ERROR_DATE_NOT_IN_FUTUR", {
      defaultValue: "Provided date is not in futur"
    }),
    COULD_NOT_FIND_USER_OR_GROUP: trads_default.t("notification.error.COULD_NOT_FIND_USER_OR_GROUP", {
      defaultValue: "No user nor group found for stripe event"
    }),
    ERROR_AT_LEAST_ONE_FIELD_REQUIRED: trads_default.t("notification.error.ERROR_AT_LEAST_ONE_FIELD_REQUIRED", {
      defaultValue: "Nothing to update"
    }),
    // Password related
    ERROR_PASSWORD_REQUIRED: trads_default.t("notification.error.ERROR_PASSWORD_REQUIRED", {
      defaultValue: "No password provided"
    }),
    ERROR_INVALID_PASSWORD_FORMAT: trads_default.t("notification.error.ERROR_INVALID_PASSWORD_FORMAT", {
      defaultValue: "Invalid format for provided password"
    }),
    ERROR_PASSWORD_CONFIRMATION_REQUIRED: trads_default.t("notification.error.ERROR_PASSWORD_CONFIRMATION_REQUIRED", {
      defaultValue: "No password confirmation provided"
    }),
    ERROR_PASSWORD_CONFIRMATION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PASSWORD_CONFIRMATION_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided password confirmation"
      }
    ),
    ERROR_PREVIOUS_PASSWORD_REQUIRED: trads_default.t("notification.error.ERROR_PREVIOUS_PASSWORD_REQUIRED", {
      defaultValue: "No previous password provided"
    }),
    ERROR_PREVIOUS_PASSWORD_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PREVIOUS_PASSWORD_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided previous password"
    }),
    ERROR_RESET_PASSWORD_CODE_INVALID: trads_default.t("notification.error.ERROR_RESET_PASSWORD_CODE_INVALID", {
      defaultValue: "Provided reset-password code is invalid"
    }),
    ERROR_RESET_PASSWORD_CODE_EXPIRED: trads_default.t("notification.error.ERROR_RESET_PASSWORD_CODE_EXPIRED_NEW_CODE_SENT", {
      defaultValue: "The code you entered has expired. A new code has been sent to you by email."
    }),
    ERROR_PASSWORDS_DO_NOT_MATCH: trads_default.t("notification.error.ERROR_PASSWORDS_DO_NOT_MATCH", {
      defaultValue: "Provided password and password confirmation do not match"
    }),
    // Email related
    ERROR_EMAIL_REQUIRED: trads_default.t("notification.error.ERROR_EMAIL_REQUIRED", {
      defaultValue: "No email provided"
    }),
    ERROR_EMAIL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EMAIL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided email"
    }),
    ERROR_EMAIL_ALREADY_USED: trads_default.t("notification.error.ERROR_EMAIL_ALREADY_USED", {
      defaultValue: "Email already used"
    }),
    ERROR_EMAIL_IS_SAME: trads_default.t("notification.error.ERROR_EMAIL_IS_SAME", {
      defaultValue: "New email must be different from current email"
    }),
    ERROR_EMAIL_CHANGE_CODE_EXPIRED: trads_default.t("notification.error.ERROR_EMAIL_CHANGE_CODE_EXPIRED", {
      defaultValue: "Verification code has expired"
    }),
    ERROR_EMAIL_CHANGE_CODE_INVALID: trads_default.t("notification.error.ERROR_EMAIL_CHANGE_CODE_INVALID", {
      defaultValue: "Verification code is invalid"
    }),
    ERROR_TOO_MANY_ATTEMPTS: trads_default.t("notification.error.ERROR_TOO_MANY_ATTEMPTS", {
      defaultValue: "Too many attempts. Please try again later"
    }),
    ERROR_PROFILE_CHANGE_REQUEST_NOT_ALLOWED: trads_default.t("notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_ALLOWED", {
      defaultValue: "Profile change request is not allowed"
    }),
    ERROR_NAME_IS_SAME: trads_default.t("notification.error.ERROR_NAME_IS_SAME", {
      defaultValue: "Name is same as current name"
    }),
    ERROR_BIRTHDAY_IS_SAME: trads_default.t("notification.error.ERROR_BIRTHDAY_IS_SAME", {
      defaultValue: "Birthday is same as current birthday"
    }),
    ERROR_BIRTHPLACE_IS_SAME: trads_default.t("notification.error.ERROR_BIRTHPLACE_IS_SAME", {
      defaultValue: "Birthplace is same as current birthplace"
    }),
    ERROR_BIRTHPLACE_TOO_SHORT: trads_default.t("notification.error.ERROR_BIRTHPLACE_TOO_SHORT", {
      defaultValue: "Birthplace is too short"
    }),
    ERROR_PROFILE_CHANGE_REQUEST_NOT_OPEN: trads_default.t("notification.error.ERROR_PROFILE_CHANGE_REQUEST_NOT_OPEN", {
      defaultValue: "Profile change request is not open"
    }),
    ERROR_PROFILE_CHANGE_REQUEST_TYPE_INVALID: trads_default.t("notification.error.ERROR_PROFILE_CHANGE_REQUEST_TYPE_INVALID", {
      defaultValue: "Invalid profile change request type"
    }),
    ERROR_PROFILE_CHANGE_REQUEST_INVALID_PAYLOAD: trads_default.t(
      "notification.error.ERROR_PROFILE_CHANGE_REQUEST_INVALID_PAYLOAD",
      {
        defaultValue: "Invalid profile change request payload"
      }
    ),
    ERROR_SIDE_REQUIRED: trads_default.t("notification.error.ERROR_SIDE_REQUIRED", {
      defaultValue: "No side provided"
    }),
    ERROR_SIDE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SIDE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided side"
    }),
    ERROR_OLD_CODE_REQUIRED: trads_default.t("notification.error.ERROR_OLD_CODE_REQUIRED", {
      defaultValue: "No old code provided"
    }),
    ERROR_NEW_CODE_REQUIRED: trads_default.t("notification.error.ERROR_NEW_CODE_REQUIRED", {
      defaultValue: "No new code provided"
    }),
    // Device related
    ERROR_DEVICE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_DEVICE_DOES_NOT_EXIST", {
      defaultValue: "Device does not exist"
    }),
    ERROR_UNIQUE_ID_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_UNIQUE_ID_REQUIRED"),
    ERROR_DEVICE_NAME_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_DEVICE_NAME_REQUIRED"),
    ERROR_USERNAME_REQUIRED: trads_default.t("notification.error.ERROR_USERNAME_REQUIRED", {
      defaultValue: "No username provided"
    }),
    ERROR_APP_VERSION_ANDROID_INVALID_FORMAT: getGeneratedDefaultErrorMessage(
      "ERROR_APP_VERSION_ANDROID_INVALID_FORMAT"
    ),
    ERROR_APP_VERSION_IOS_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_APP_VERSION_IOS_INVALID_FORMAT"),
    ERROR_DEVICE_CONFIRMATION_CODE_INVALID: trads_default.t("notification.error.ERROR_DEVICE_CONFIRMATION_CODE_INVALID", {
      defaultValue: "Provided device confirmation code is invalid"
    }),
    ERROR_DEVICE_CONFIRMATION_CODE_EXPIRED: trads_default.t("notification.error.ERROR_DEVICE_CONFIRMATION_CODE_EXPIRED", {
      defaultValue: "Provided device confirmation code is expired"
    }),
    // Phone related
    ERROR_PHONE_REQUIRED: trads_default.t("notification.error.ERROR_PHONE_REQUIRED", {
      defaultValue: "No phone number provided"
    }),
    ERROR_PHONE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PHONE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided phone number"
    }),
    // Address related
    ERROR_ZIPCODE_REQUIRED: trads_default.t("notification.error.ERROR_ZIPCODE_REQUIRED", {
      defaultValue: "No zipcode provided"
    }),
    ERROR_ADDRESS_REQUIRED: trads_default.t("notification.error.ERROR_ADDRESS_REQUIRED", {
      defaultValue: "No address provided"
    }),
    // Identity related
    ERROR_FIRSTNAME_REQUIRED: trads_default.t("notification.error.ERROR_FIRSTNAME_REQUIRED", {
      defaultValue: "No firstname provided"
    }),
    ERROR_LASTNAME_REQUIRED: trads_default.t("notification.error.ERROR_LASTNAME_REQUIRED", {
      defaultValue: "No lastname provided"
    }),
    ERROR_BIRTHDAY_REQUIRED: trads_default.t("notification.error.ERROR_BIRTHDAY_REQUIRED", {
      defaultValue: "No birthday provided"
    }),
    ERROR_BIRTHDAY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIRTHDAY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided birthday"
    }),
    ERROR_BIRTHDAY_INVALID_YEARS_RANGE: trads_default.t("notification.error.ERROR_BIRTHDAY_INVALID_YEARS_RANGE", {
      defaultValue: "Invalid years range for provided birthday"
    }),
    // Location related
    ERROR_LATITUDE_REQUIRED: trads_default.t("notification.error.ERROR_LATITUDE_REQUIRED", {
      defaultValue: "No latitude provided"
    }),
    ERROR_LATITUDE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LATITUDE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided latidude"
    }),
    ERROR_LAT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LAT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided lat"
    }),
    ERROR_LONGITUDE_REQUIRED: trads_default.t("notification.error.ERROR_LONGITUDE_REQUIRED", {
      defaultValue: "No longitude provided"
    }),
    ERROR_LONGITUDE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LONGITUDE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided longitude"
    }),
    ERROR_LONG_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LONG_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided long"
    }),
    ERROR_LATITUDE_DELTA_REQUIRED: trads_default.t("notification.error.ERROR_LATITUDE_DELTA_REQUIRED", {
      defaultValue: "No latitude delta provided"
    }),
    ERROR_LATITUDE_DELTA_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LATITUDE_DELTA_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided latidude delta"
    }),
    ERROR_LATITUDE_DELTA_TOO_HIGH: trads_default.t("notification.error.ERROR_LATITUDE_DELTA_TOO_HIGH", {
      defaultValue: "Provided latitude delta is too high"
    }),
    ERROR_LONGITUDE_DELTA_REQUIRED: trads_default.t("notification.error.ERROR_LONGITUDE_DELTA_REQUIRED", {
      defaultValue: "No longitude delta provided"
    }),
    ERROR_LONGITUDE_DELTA_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LONGITUDE_DELTA_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided longitude delta"
    }),
    ERROR_LONGITUDE_DELTA_TOO_HIGH: trads_default.t("notification.error.ERROR_LONGITUDE_DELTA_TOO_HIGH", {
      defaultValue: "Provided longitude delta is too high"
    }),
    // Auth related
    ERROR_INVALID_AUTH_FORM: trads_default.t("notification.error.ERROR_INVALID_AUTH_FORM", {
      defaultValue: "Invalid username or password"
    }),
    ERROR_MFA_TOKEN_INVALID: trads_default.t("notification.error.ERROR_MFA_TOKEN_INVALID", {
      defaultValue: "Provided mfa token is invalid"
    }),
    // Mail opt-in related
    ERROR_MAIL_OPT_IN_REQUIRED: trads_default.t("notification.error.ERROR_MAIL_OPT_IN_REQUIRED", {
      defaultValue: "No mail opt-in provided"
    }),
    ERROR_MAIL_OPT_IN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAIL_OPT_IN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided mail opt-in"
    }),
    // Background geolocation related
    ERROR_BACKGROUND_LOCATIONS_IS_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_BACKGROUND_LOCATIONS_IS_REQUIRED"),
    ERROR_BACKGROUND_LOCATIONS_INVALID_ARRAY: getGeneratedDefaultErrorMessage(
      "ERROR_BACKGROUND_LOCATIONS_INVALID_ARRAY"
    ),
    ERROR_START_DATE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_START_DATE_REQUIRED"),
    ERROR_START_DATE_INVALID_TYPE: getGeneratedDefaultErrorMessage("ERROR_START_DATE_INVALID_TYPE"),
    ERROR_END_DATE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_END_DATE_REQUIRED"),
    ERROR_END_DATE_INVALID_TYPE: getGeneratedDefaultErrorMessage("ERROR_END_DATE_INVALID_TYPE"),
    ERROR_ACCURACY_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ACCURACY_REQUIRED"),
    ERROR_ACCURACY_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_ACCURACY_INVALID_FORMAT"),
    ERROR_SPEED_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_SPEED_REQUIRED"),
    ERROR_SPEED_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_SPEED_INVALID_FORMAT"),
    ERROR_HEADING_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_HEADING_REQUIRED"),
    ERROR_HEADING_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_HEADING_INVALID_FORMAT"),
    ERROR_ALTITUDE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ALTITUDE_REQUIRED"),
    ERROR_ALTITUDE_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_ALTITUDE_INVALID_FORMAT"),
    ERROR_ELLIPSOIDAL_ALTITUDE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ELLIPSOIDAL_ALTITUDE_REQUIRED"),
    ERROR_ELLIPSOIDAL_ALTITUDE_INVALID_FORMAT: getGeneratedDefaultErrorMessage(
      "ERROR_ELLIPSOIDAL_ALTITUDE_INVALID_FORMAT"
    ),
    ERROR_ACTIVITY_TYPE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ACTIVITY_TYPE_REQUIRED"),
    ERROR_ACTIVITY_TYPE_INVALID_TYPE: getGeneratedDefaultErrorMessage("ERROR_ACTIVITY_TYPE_INVALID_TYPE"),
    ERROR_ACTIVITY_CONFIDENCE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ACTIVITY_CONFIDENCE_REQUIRED"),
    ERROR_ACTIVITY_CONFIDENCE_INVALID_FORMAT: getGeneratedDefaultErrorMessage(
      "ERROR_ACTIVITY_CONFIDENCE_INVALID_FORMAT"
    ),
    ERROR_TIMESTAMP_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_TIMESTAMP_REQUIRED"),
    ERROR_TIMESTAMP_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_TIMESTAMP_INVALID_FORMAT"),
    ERROR_IS_MOVING_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_IS_MOVING_REQUIRED"),
    ERROR_ODOMETER_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ODOMETER_REQUIRED"),
    ERROR_ODOMETER_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_ODOMETER_INVALID_FORMAT"),
    // Route related
    ERROR_ROUTE_ID_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_ROUTE_ID_REQUIRED"),
    ERROR_ROUTE_ID_INVALID_TYPE: getGeneratedDefaultErrorMessage("ERROR_ROUTE_ID_INVALID_TYPE"),
    ERROR_IS_ON_BICYCLE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_IS_ON_BICYCLE_REQUIRED"),
    ERROR_IS_ON_BICYCLE_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_IS_ON_BICYCLE_INVALID_FORMAT"),
    // Route statistic related
    ERROR_RANGE_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_RANGE_REQUIRED"),
    ERROR_RANGE_INVALID_TYPE: getGeneratedDefaultErrorMessage("ERROR_RANGE_INVALID_TYPE"),
    ERROR_OFFSET_REQUIRED: getGeneratedDefaultErrorMessage("ERROR_OFFSET_REQUIRED"),
    ERROR_OFFSET_INVALID_FORMAT: getGeneratedDefaultErrorMessage("ERROR_OFFSET_INVALID_FORMAT"),
    // Role related
    ERROR_ROLE_REQUIRED: trads_default.t("notification.error.ERROR_ROLE_REQUIRED", {
      defaultValue: "No role provided"
    }),
    ERROR_ROLE_INVALID_TYPE: trads_default.t("notification.error.ERROR_ROLE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided role"
    }),
    ERROR_ROLES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ROLES_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided roles"
    }),
    ERROR_ROLES_EMPTY_ARRAY: trads_default.t("notification.error.ERROR_ROLES_EMPTY_ARRAY", {
      defaultValue: "Provided roles array is empty"
    }),
    ERROR_ROLES_INVALID_TYPE: trads_default.t("notification.error.ERROR_ROLES_INVALID_TYPE", {
      defaultValue: "Invalid type for provided roles"
    }),
    // Bank related
    ERROR_BANK_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_BANK_DOES_NOT_EXIST", {
      defaultValue: "Bank does not exist"
    }),
    ERROR_BIC_REQUIRED: trads_default.t("notification.error.ERROR_BIC_REQUIRED", {
      defaultValue: "No BIC provided"
    }),
    ERROR_BIC_TOO_SHORT: trads_default.t("notification.error.ERROR_BIC_TOO_SHORT", {
      defaultValue: "BIC length must be higher or equal to 6"
    }),
    ERROR_BANK_CODE_REQUIRED: trads_default.t("notification.error.ERROR_BANK_CODE_REQUIRED", {
      defaultValue: "No bank code provided"
    }),
    ERROR_BANK_CODE_TOO_LOW: trads_default.t("notification.error.ERROR_BANK_CODE_TOO_LOW", {
      defaultValue: "Provided bank code too low"
    }),
    ERROR_BANK_CODE_TOO_HIGH: trads_default.t("notification.error.ERROR_BANK_CODE_TOO_HIGH", {
      defaultValue: "Provided bank code too high"
    }),
    ERROR_BANK_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BANK_CODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bank code"
    }),
    ERROR_COUNTRY_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COUNTRY_CODE_INVALID_FORMAT", {
      defaultValue: "Country code must be a 2-letter ISO code"
    }),
    ERROR_IBAN_INVALID: trads_default.t("notification.error.ERROR_IBAN_INVALID", {
      defaultValue: "Invalid format for provided IBAN"
    }),
    ERROR_DANGER_LEVEL_REQUIRED: trads_default.t("notification.error.ERROR_DANGER_LEVEL_REQUIRED", {
      defaultValue: "No danger level provided"
    }),
    ERROR_DANGER_LEVEL_INVALID_TYPE: trads_default.t("notification.error.ERROR_DANGER_LEVEL_INVALID_TYPE", {
      defaultValue: "Invalid type for provided danger level"
    }),
    ERROR_DANGER_LEVEL_TOO_LOW: trads_default.t("notification.error.ERROR_DANGER_LEVEL_TOO_LOW", {
      defaultValue: "Danger level must be higher or equal to 1"
    }),
    ERROR_DANGER_LEVEL_TOO_HIGH: trads_default.t("notification.error.ERROR_DANGER_LEVEL_TOO_HIGH", {
      defaultValue: "Danger level must be lower or equal to 3"
    }),
    // Bike model related
    ERROR_BIKE_MODEL_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_BIKE_MODEL_DOES_NOT_EXIST", {
      defaultValue: "Bike model does not exist"
    }),
    // BADGES
    ERROR_BADGE_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_TYPE_REQUIRED", {
      defaultValue: "Badge type is required"
    }),
    ERROR_LEVEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LEVEL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided level"
    }),
    ERROR_LEVEL_REQUIRED: trads_default.t("notification.error.ERROR_LEVEL_REQUIRED", {
      defaultValue: "Level is required"
    }),
    ERROR_LEVEL_TOO_HIGH: trads_default.t("notification.error.ERROR_LEVEL_TOO_HIGH", {
      defaultValue: "Level must be lower or equal to 4"
    }),
    ERROR_LEVEL_TOO_LOW: trads_default.t("notification.error.ERROR_LEVEL_TOO_LOW", {
      defaultValue: "Level must be higher or equal to 1"
    }),
    ERROR_BADGE_CODE_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_CODE_REQUIRED", {
      defaultValue: "Badge code is required"
    }),
    ERROR_BADGE_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BADGE_CODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided badge code"
    }),
    ERROR_BADGE_CODE_TOO_LONG: trads_default.t("notification.error.ERROR_BADGE_CODE_TOO_LONG", {
      defaultValue: "Badge code must be at most 100 characters"
    }),
    ERROR_BADGE_DEFINITION_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_BADGE_DEFINITION_DOES_NOT_EXIST", {
      defaultValue: "Badge definition does not exist"
    }),
    ERROR_BADGE_DEFINITION_NOT_ACTIVE: trads_default.t("notification.error.ERROR_BADGE_DEFINITION_NOT_ACTIVE", {
      defaultValue: "Badge definition is not active"
    }),
    ERROR_BADGE_DEFINITION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BADGE_DEFINITION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided badge definition"
    }),
    ERROR_BADGES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BADGES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided badges"
    }),
    ERROR_BADGE_LEVEL_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_REQUIRED", {
      defaultValue: "Badge level is required"
    }),
    ERROR_BADGE_LEVEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BADGE_LEVEL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided badge level"
    }),
    ERROR_BADGE_LEVEL_TOO_LOW: trads_default.t("notification.error.ERROR_BADGE_LEVEL_TOO_LOW", {
      defaultValue: "Badge level must be at least 1"
    }),
    ERROR_BADGE_LEVEL_TOO_HIGH: trads_default.t("notification.error.ERROR_BADGE_LEVEL_TOO_HIGH", {
      defaultValue: "Badge level must be at most 4"
    }),
    ERROR_BADGE_LEVEL_ALREADY_ASSIGNED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_ALREADY_ASSIGNED", {
      defaultValue: "Cannot remove a badge level already assigned to users"
    }),
    ERROR_BADGE_LEVEL_TARGET_FR_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_TARGET_FR_REQUIRED", {
      defaultValue: "Badge level target (French) is required"
    }),
    ERROR_BADGE_LEVEL_TARGET_FR_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BADGE_LEVEL_TARGET_FR_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided badge level target (French)"
      }
    ),
    ERROR_BADGE_LEVEL_TARGET_EN_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_TARGET_EN_REQUIRED", {
      defaultValue: "Badge level target (English) is required"
    }),
    ERROR_BADGE_LEVEL_TARGET_EN_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BADGE_LEVEL_TARGET_EN_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided badge level target (English)"
      }
    ),
    ERROR_BADGE_LEVEL_DESCRIPTION_FR_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_REQUIRED", {
      defaultValue: "Badge level description (French) is required"
    }),
    ERROR_BADGE_LEVEL_DESCRIPTION_FR_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_FR_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided badge level description (French)"
      }
    ),
    ERROR_BADGE_LEVEL_DESCRIPTION_EN_REQUIRED: trads_default.t("notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_REQUIRED", {
      defaultValue: "Badge level description (English) is required"
    }),
    ERROR_BADGE_LEVEL_DESCRIPTION_EN_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BADGE_LEVEL_DESCRIPTION_EN_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided badge level description (English)"
      }
    ),
    ERROR_BADGE_LEVEL_IMAGE_URL_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided badge level image URL"
      }
    ),
    ERROR_BADGE_LEVEL_IMAGE_URL_TOO_LONG: trads_default.t("notification.error.ERROR_BADGE_LEVEL_IMAGE_URL_TOO_LONG", {
      defaultValue: "Badge level image URL must be at most 500 characters"
    }),
    ERROR_DISPLAY_ORDER_REQUIRED: trads_default.t("notification.error.ERROR_DISPLAY_ORDER_REQUIRED", {
      defaultValue: "Display order is required"
    }),
    ERROR_DISPLAY_ORDER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DISPLAY_ORDER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided display order"
    }),
    ERROR_MAX_LEVEL_REQUIRED: trads_default.t("notification.error.ERROR_MAX_LEVEL_REQUIRED", {
      defaultValue: "Max level is required"
    }),
    ERROR_MAX_LEVEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_LEVEL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided max level"
    }),
    ERROR_MAX_LEVEL_TOO_LOW: trads_default.t("notification.error.ERROR_MAX_LEVEL_TOO_LOW", {
      defaultValue: "Max level must be at least 1"
    }),
    ERROR_MAX_LEVEL_TOO_HIGH: trads_default.t("notification.error.ERROR_MAX_LEVEL_TOO_HIGH", {
      defaultValue: "Max level must be at most 4"
    }),
    ERROR_IS_ONE_OFF_REQUIRED: trads_default.t("notification.error.ERROR_IS_ONE_OFF_REQUIRED", {
      defaultValue: "Is one off is required"
    }),
    ERROR_TITLE_FR_REQUIRED: trads_default.t("notification.error.ERROR_TITLE_FR_REQUIRED", {
      defaultValue: "Title (French) is required"
    }),
    ERROR_TITLE_FR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TITLE_FR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided title (French)"
    }),
    ERROR_TITLE_FR_TOO_LONG: trads_default.t("notification.error.ERROR_TITLE_FR_TOO_LONG", {
      defaultValue: "Title (French) must be at most 255 characters"
    }),
    ERROR_TITLE_EN_REQUIRED: trads_default.t("notification.error.ERROR_TITLE_EN_REQUIRED", {
      defaultValue: "Title (English) is required"
    }),
    ERROR_TITLE_EN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TITLE_EN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided title (English)"
    }),
    ERROR_TITLE_EN_TOO_LONG: trads_default.t("notification.error.ERROR_TITLE_EN_TOO_LONG", {
      defaultValue: "Title (English) must be at most 255 characters"
    }),
    ERROR_NOT_ACQUIRED_DESCRIPTION_FR_REQUIRED: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_REQUIRED",
      {
        defaultValue: "Not acquired description (French) is required"
      }
    ),
    ERROR_NOT_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided not acquired description (French)"
      }
    ),
    ERROR_NOT_ACQUIRED_DESCRIPTION_FR_TOO_LONG: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_FR_TOO_LONG",
      {
        defaultValue: "Not acquired description (French) must be at most 255 characters"
      }
    ),
    ERROR_NOT_ACQUIRED_DESCRIPTION_EN_REQUIRED: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_REQUIRED",
      {
        defaultValue: "Not acquired description (English) is required"
      }
    ),
    ERROR_NOT_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided not acquired description (English)"
      }
    ),
    ERROR_NOT_ACQUIRED_DESCRIPTION_EN_TOO_LONG: trads_default.t(
      "notification.error.ERROR_NOT_ACQUIRED_DESCRIPTION_EN_TOO_LONG",
      {
        defaultValue: "Not acquired description (English) must be at most 255 characters"
      }
    ),
    ERROR_ACQUIRED_DESCRIPTION_FR_REQUIRED: trads_default.t("notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_REQUIRED", {
      defaultValue: "Acquired description (French) is required"
    }),
    ERROR_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided acquired description (French)"
      }
    ),
    ERROR_ACQUIRED_DESCRIPTION_FR_TOO_LONG: trads_default.t("notification.error.ERROR_ACQUIRED_DESCRIPTION_FR_TOO_LONG", {
      defaultValue: "Acquired description (French) must be at most 255 characters"
    }),
    ERROR_ACQUIRED_DESCRIPTION_EN_REQUIRED: trads_default.t("notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_REQUIRED", {
      defaultValue: "Acquired description (English) is required"
    }),
    ERROR_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided acquired description (English)"
      }
    ),
    ERROR_ACQUIRED_DESCRIPTION_EN_TOO_LONG: trads_default.t("notification.error.ERROR_ACQUIRED_DESCRIPTION_EN_TOO_LONG", {
      defaultValue: "Acquired description (English) must be at most 255 characters"
    }),
    ERROR_IMAGE_DEFAULT_URL_REQUIRED: trads_default.t("notification.error.ERROR_IMAGE_DEFAULT_URL_REQUIRED", {
      defaultValue: "Default image URL is required"
    }),
    ERROR_IMAGE_DEFAULT_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IMAGE_DEFAULT_URL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided default image URL"
    }),
    ERROR_IMAGE_DEFAULT_URL_TOO_LONG: trads_default.t("notification.error.ERROR_IMAGE_DEFAULT_URL_TOO_LONG", {
      defaultValue: "Default image URL must be at most 500 characters"
    }),
    ERROR_LEVELS_REQUIRED: trads_default.t("notification.error.ERROR_LEVELS_REQUIRED", {
      defaultValue: "At least one badge level is required"
    }),
    ERROR_LEVELS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LEVELS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided badge levels"
    }),
    ERROR_LEVELS_COUNT_MISMATCH: trads_default.t("notification.error.ERROR_LEVELS_COUNT_MISMATCH", {
      defaultValue: "Badge levels count must match max level"
    }),
    ERROR_IS_ACTIVE_REQUIRED: trads_default.t("notification.error.ERROR_IS_ACTIVE_REQUIRED", {
      defaultValue: "Is active is required"
    }),
    ERROR_SOURCE_ID_REQUIRED: trads_default.t("notification.error.ERROR_SOURCE_ID_REQUIRED", {
      defaultValue: "Source bike model ID is required"
    }),
    ERROR_SOURCE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SOURCE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for source bike model ID"
    }),
    ERROR_TARGET_ID_REQUIRED: trads_default.t("notification.error.ERROR_TARGET_ID_REQUIRED", {
      defaultValue: "Target bike model ID is required"
    }),
    ERROR_TARGET_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TARGET_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for target bike model ID"
    }),
    ERROR_SOURCE_AND_TARGET_MUST_BE_DIFFERENT: trads_default.t("notification.error.ERROR_SOURCE_AND_TARGET_MUST_BE_DIFFERENT", {
      defaultValue: "Source and target bike models must be different"
    }),
    ERROR_BRAND_REQUIRED: trads_default.t("notification.error.ERROR_BRAND_REQUIRED", {
      defaultValue: "No brand provided"
    }),
    ERROR_BRAND_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BRAND_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided brand"
    }),
    ERROR_BRAND_INVALID_LENGTH: trads_default.t("notification.error.ERROR_BRAND_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided brand"
    }),
    ERROR_MODEL_REQUIRED: trads_default.t("notification.error.ERROR_MODEL_REQUIRED", {
      defaultValue: "No model provided"
    }),
    ERROR_MODEL_INVALID_LENGTH: trads_default.t("notification.error.ERROR_MODEL_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided model"
    }),
    ERROR_APPROVED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_APPROVED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided approved"
    }),
    ERROR_BRAND_CODE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_BRAND_CODE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided brand code"
    }),
    ERROR_CATEGORY_INVALID_LENGTH: trads_default.t("notification.error.ERROR_CATEGORY_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided category"
    }),
    ERROR_CATEGORY_CODE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_CATEGORY_CODE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided category code"
    }),
    ERROR_ELECTRIC_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ELECTRIC_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided electric"
    }),
    ERROR_IMAGE_URL_INVALID_LENGTH: trads_default.t("notification.error.ERROR_IMAGE_URL_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided image url"
    }),
    ERROR_MODEL_CODE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_MODEL_CODE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided model code"
    }),
    ERROR_SHARELOCK_COMPATIBILITY_PERCENTAGE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHARELOCK_COMPATIBILITY_PERCENTAGE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided sharelock compatibility percentage"
      }
    ),
    ERROR_SHARELOCK_COMPATIBLE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SHARELOCK_COMPATIBLE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided sharelock compatible"
    }),
    ERROR_YEAR_REQUIRED: trads_default.t("notification.error.ERROR_YEAR_REQUIRED", {
      defaultValue: "No year provided"
    }),
    ERROR_MONTH_REQUIRED: trads_default.t("notification.error.ERROR_MONTH_REQUIRED", {
      defaultValue: "No month provided"
    }),
    ERROR_YEAR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_YEAR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided year"
    }),
    ERROR_MONTH_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MONTH_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided month"
    }),
    ERROR_MONTH_TOO_HIGH: trads_default.t("notification.error.ERROR_MONTH_TOO_HIGH", {
      defaultValue: "Provided month is too high"
    }),
    ERROR_MONTH_TOO_LOW: trads_default.t("notification.error.ERROR_MONTH_TOO_LOW", {
      defaultValue: "Provided month is too low"
    }),
    ERROR_PREVBRAND_REQUIRED: trads_default.t("notification.error.ERROR_PREVBRAND_REQUIRED", {
      defaultValue: "No previous brand provided"
    }),
    ERROR_SUGGESTION_ID_REQUIRED: trads_default.t("notification.error.ERROR_SUGGESTION_ID_REQUIRED", {
      defaultValue: "No suggested id provided"
    }),
    ERROR_BIKE_ID_REQUIRED: trads_default.t("notification.error.ERROR_BIKE_ID_REQUIRED", {
      defaultValue: "No bike id provided"
    }),
    ERROR_SUGGESTION_ID_AND_BIKE_ID_MUST_BE_DIFFERENT: trads_default.t(
      "notification.error.ERROR_SUGGESTION_ID_AND_BIKE_ID_MUST_BE_DIFFERENT",
      {
        defaultValue: "Suggested id and current id must differe"
      }
    ),
    ERROR_SUGGESTION_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SUGGESTION_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided suggestion id"
    }),
    ERROR_BIKE_MODEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_MODEL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bike model"
    }),
    // City related
    ERROR_CITY_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_CITY_DOES_NOT_EXIST", {
      defaultValue: "City does not exist"
    }),
    ERROR_CURRENT_CITY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CURRENT_CITY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided current city"
    }),
    ERROR_IS_ARCHIVED_REQUIRED: trads_default.t("notification.error.ERROR_IS_ARCHIVED_REQUIRED", {
      defaultValue: "No is archived provided"
    }),
    ERROR_IS_ARCHIVED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_ARCHIVED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is archived"
    }),
    // User related
    ERROR_USER_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_USER_DOES_NOT_EXIST", {
      defaultValue: "User does not exist"
    }),
    ERROR_USER_ID_REQUIRED: trads_default.t("notification.error.ERROR_USER_ID_REQUIRED", {
      defaultValue: "No user id provided"
    }),
    ERROR_USER_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided user id"
    }),
    ERROR_USERS_REQUIRED: trads_default.t("notification.error.ERROR_USERS_REQUIRED", {
      defaultValue: "No users provided"
    }),
    ERROR_USERS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USERS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided users"
    }),
    ERROR_TAG_REQUIRED: trads_default.t("notification.error.ERROR_TAG_REQUIRED", {
      defaultValue: "No tag provided"
    }),
    ERROR_REASON_REQUIRED: trads_default.t("notification.error.ERROR_REASON_REQUIRED", {
      defaultValue: "No reason provided"
    }),
    ERROR_TAG_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TAG_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided tag date"
    }),
    ERROR_BLOCKED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BLOCKED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided blocked"
    }),
    ERROR_CONFIRMED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CONFIRMED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided confirmed"
    }),
    ERROR_BANK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BANK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bank"
    }),
    ERROR_PHOTO_REQUIRED: trads_default.t("notification.error.ERROR_PHOTO_REQUIRED", {
      defaultValue: "No photo provided"
    }),
    ERROR_FM_TOKENS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_FM_TOKENS_INVALID_ARRAY", {
      defaultValue: "Provided fm tokens not an array"
    }),
    ERROR_USER_IS_A_SPONSOR: trads_default.t("notification.error.ERROR_USER_IS_A_SPONSOR", {
      defaultValue: "User is a Sponsor"
    }),
    ERROR_USER_HAS_PAYMENTS: trads_default.t("notification.error.ERROR_USER_HAS_PAYMENTS", {
      defaultValue: "User has payments in Stripe"
    }),
    ERROR_CURRENT_CITY_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CURRENT_CITY_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided current city object"
    }),
    ERROR_DEVICES_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DEVICES_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided device object"
    }),
    ERROR_FIRST_CITY_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FIRST_CITY_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided first city object"
    }),
    ERROR_NOTES_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NOTES_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided notes object"
    }),
    ERROR_POLICIES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICIES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policies"
    }),
    ERROR_POLICY_STATUS_REQUIRED: trads_default.t("notification.error.ERROR_POLICY_STATUS_REQUIRED", {
      defaultValue: "No policy status provided"
    }),
    ERROR_USERS_GROUPS_RELATIONS_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_USERS_GROUPS_RELATIONS_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided users-groups relations object"
      }
    ),
    ERROR_USER_SETTINGS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_SETTINGS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided user-settings"
    }),
    // B2C Claim related
    ERROR_REIMBURSEMENT_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_REIMBURSEMENT_TYPE_REQUIRED", {
      defaultValue: "No reimbursement type provided"
    }),
    ERROR_REIMBURSEMENT_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided reimbursement type"
    }),
    CLAIM_NOT_IN_TO_PAY_STATUS: trads_default.t("notification.error.CLAIM_NOT_IN_TO_PAY_STATUS", {
      defaultValue: 'The claim must be in "to pay" status to be paid'
    }),
    NOTHING_TO_REIMBURSE_USER: trads_default.t("notification.error.NOTHING_TO_REIMBURSE_USER", {
      defaultValue: "There is no amount to reimburse to the user"
    }),
    MISSING_USER_IBAN: trads_default.t("notification.error.MISSING_USER_IBAN", {
      defaultValue: "The user has no IBAN registered"
    }),
    MISSING_GROUP_IBAN: trads_default.t("notification.error.MISSING_GROUP_IBAN", {
      defaultValue: "The group has no IBAN registered"
    }),
    TO_BE_REIMBURSED_GROUP_IS_0: trads_default.t("notification.error.TO_BE_REIMBURSED_GROUP_IS_0", {
      defaultValue: "There is nothing to reimburse to the group"
    }),
    QONTO_TRANSFER_AMOUNT_MISMATCH: trads_default.t("notification.error.QONTO_TRANSFER_AMOUNT_MISMATCH", {
      defaultValue: "A transfer was already sent for this claim with a different amount. Check Qonto before retrying"
    }),
    CLAIM_PAYMENT_ALREADY_IN_PROGRESS: trads_default.t("notification.error.CLAIM_PAYMENT_ALREADY_IN_PROGRESS", {
      defaultValue: "This claim was just modified or paid by someone else. Reload it before retrying"
    }),
    INSUFFICIENT_ACCOUNT_BALANCE: trads_default.t("notification.error.INSUFFICIENT_ACCOUNT_BALANCE", {
      defaultValue: "The account balance is insufficient to pay this reimbursement"
    }),
    // User-settings related
    ERROR_VIGIMAP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VIGIMAP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vigimap"
    }),
    ERROR_VIGIMAP_POPUP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VIGIMAP_POPUP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vigimap popup"
    }),
    ERROR_BATTERY_POPUP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BATTERY_POPUP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided battery popup"
    }),
    ERROR_ALWAYS_GEOLOCATION_TRACKING_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ALWAYS_GEOLOCATION_TRACKING_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided always geolocation tracking"
      }
    ),
    ERROR_REDIRECT_AFTER_LOGIN_INVALID_TYPE: trads_default.t("notification.error.ERROR_REDIRECT_AFTER_LOGIN_INVALID_TYPE", {
      defaultValue: "Invalid format for provided redirect after login"
    }),
    // Role related
    ERROR_ROLES_TO_ADD_INVALID_TYPE: trads_default.t("notification.error.ERROR_ROLES_TO_ADD_INVALID_TYPE", {
      defaultValue: "Invalid type for provided roles to add"
    }),
    ERROR_ROLES_TO_REMOVE_INVALID_TYPE: trads_default.t("notification.error.ERROR_ROLES_TO_REMOVE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided roles to remove"
    }),
    ERROR_ROLES_TO_ADD_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ROLES_TO_ADD_INVALID_ARRAY", {
      defaultValue: "Provided roles to add not an array"
    }),
    ERROR_ROLES_TO_REMOVE_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ROLES_TO_REMOVE_INVALID_ARRAY", {
      defaultValue: "Provided roles to remove not an array"
    }),
    ERROR_ROLES_REQUIRED: trads_default.t("notification.error.ERROR_ROLES_REQUIRED", {
      defaultValue: "No roles provided"
    }),
    // Group related
    ERROR_GROUP_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_GROUP_DOES_NOT_EXIST", {
      defaultValue: "Group does not exist"
    }),
    ERROR_GROUP_ID_REQUIRED: trads_default.t("notification.error.ERROR_GROUP_ID_REQUIRED", {
      defaultValue: "No group id provided"
    }),
    ERROR_GROUP_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GROUP_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided group id"
    }),
    ERROR_PARTNER_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PARTNER_DOES_NOT_EXIST", {
      defaultValue: "Partner does not exist"
    }),
    ERROR_PARTNER_ID_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_ID_REQUIRED", {
      defaultValue: "No partner id provided"
    }),
    ERROR_PARTNER_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner id"
    }),
    ERROR_USER_AND_PARTNER_NOT_LINKED_BY_POLICY: trads_default.t(
      "notification.error.ERROR_USER_AND_PARTNER_NOT_LINKED_BY_POLICY",
      {
        defaultValue: "User and partner are not linked by policy"
      }
    ),
    ERROR_SIRET_REQUIRED: trads_default.t("notification.error.ERROR_SIRET_REQUIRED", {
      defaultValue: "No siret provided"
    }),
    ERROR_SIRET_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_SIRET_ALREADY_EXISTS", {
      defaultValue: "Provided siret already exist"
    }),
    ERROR_CITY_REQUIRED: trads_default.t("notification.error.ERROR_CITY_REQUIRED", {
      defaultValue: "No city provided"
    }),
    ERROR_TYPOLOGY_INVALID_TYPE: trads_default.t("notification.error.ERROR_TYPOLOGY_INVALID_TYPE", {
      defaultValue: "Invalid type for provided typology"
    }),
    ERROR_TYPOLOGIES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TYPOLOGIES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided typologies"
    }),
    ERROR_EXPECTED_POLICY_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided expected policy type"
    }),
    ERROR_EXPECTED_POLICY_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXPECTED_POLICY_TYPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided expected policy type"
    }),
    ERROR_ORIAS_TOO_LONG: trads_default.t("notification.error.ERROR_ORIAS_TOO_LONG", {
      defaultValue: "Provided orias is too long"
    }),
    ERROR_EXPECTED_TARGETS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXPECTED_TARGETS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided expected targets"
    }),
    ERROR_USE_PROMOTION_CODE_FOR_ATTRIBUTION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_USE_PROMOTION_CODE_FOR_ATTRIBUTION_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided use promotion code for attribution"
      }
    ),
    ERROR_PROMOTION_CODES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PROMOTION_CODES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided prmotion codes"
    }),
    ERROR_PROMOTION_CODES_DUCPLICATE: trads_default.t("notification.error.ERROR_PROMOTION_CODES_DUCPLICATE", {
      defaultValue: "There is some duplicates in provided promotion codes"
    }),
    ERROR_OPS_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPS_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided ops id"
    }),
    ERROR_USER_ALREADY_IN_GROUP: trads_default.t("notification.error.ERROR_USER_ALREADY_IN_GROUP", {
      defaultValue: "Provided user is already memeber of provided group"
    }),
    ERROR_USER_ALREADY_INVITED: trads_default.t("notification.error.ERROR_USER_ALREADY_INVITED", {
      defaultValue: "Provided user has already been invited to provided group"
    }),
    ERROR_NO_VEHICLE_GIVEN: trads_default.t("notification.error.ERROR_NO_VEHICLE_GIVEN", {
      defaultValue: "No vehicle given"
    }),
    ERROR_IS_FRAUD_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_FRAUD_PARTNER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is fraud partner"
    }),
    ERROR_MANAGING_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANAGING_PARTNER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided managing partner"
    }),
    ERROR_MANAGING_PARTNER_REQUIRED: trads_default.t("notification.error.ERROR_MANAGING_PARTNER_REQUIRED", {
      defaultValue: "Managing partner is required"
    }),
    ERROR_MANAGING_PARTNER_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_MANAGING_PARTNER_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is managing partner object"
      }
    ),
    ERROR_OPS_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPS_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided Ops object"
    }),
    // Partner related
    ERROR_B2B_POLICIES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_POLICIES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2b-policies"
    }),
    ERROR_QUOTES_AS_INSURED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_QUOTES_AS_INSURED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided quotes-as-insured"
    }),
    ERROR_VEHICLES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vehicles"
    }),
    ERROR_QUOTES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_QUOTES_INVALID_ARRAY", {
      defaultValue: "Provided quotes not an array"
    }),
    ERROR_QUOTES_REQUIRED: trads_default.t("notification.error.ERROR_QUOTES_REQUIRED", {
      defaultValue: "No quotes provided"
    }),
    ERROR_QUOTES_TOO_MANY: trads_default.t("notification.error.ERROR_QUOTES_TOO_MANY", {
      defaultValue: "A maximum of 50 quotes can be created at once"
    }),
    // Doc related
    ERROR_DOCUMENT_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_DOCUMENT_DOES_NOT_EXIST", {
      defaultValue: "Document does not exist"
    }),
    ERROR_DOCUMENT_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_DOCUMENT_ALREADY_EXISTS", {
      defaultValue: "Document already exists"
    }),
    ERROR_FILENAME_REQUIRED: trads_default.t("notification.error.ERROR_FILENAME_REQUIRED", {
      defaultValue: "No filename provided"
    }),
    ERROR_FILE_NOT_FOUND: trads_default.t("notification.error.ERROR_FILE_NOT_FOUND", {
      defaultValue: "File not found"
    }),
    ERROR_VERSO_FILENAME_REQUIRED: trads_default.t("notification.error.ERROR_VERSO_FILENAME_REQUIRED", {
      defaultValue: "No verso filename provided"
    }),
    ERROR_UUID_REQUIRED: trads_default.t("notification.error.ERROR_UUID_REQUIRED", {
      defaultValue: "No uuid provided"
    }),
    ERROR_VERSO_UUID_REQUIRED: trads_default.t("notification.error.ERROR_VERSO_UUID_REQUIRED", {
      defaultValue: "No verso uuid provided"
    }),
    ERROR_UUID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UUID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided uuid"
    }),
    ERROR_MIME_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_MIME_TYPE_REQUIRED", {
      defaultValue: "No mime type provided"
    }),
    ERROR_MIME_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_MIME_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided mime type"
    }),
    ERROR_VERSO_MIME_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_VERSO_MIME_TYPE_REQUIRED", {
      defaultValue: "No verso mime type provided"
    }),
    ERROR_VERSO_MIME_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_VERSO_MIME_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided verso mime type"
    }),
    ERROR_SIZE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SIZE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided size"
    }),
    ERROR_VERSO_SIZE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VERSO_SIZE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided verso size"
    }),
    ERROR_OWNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OWNER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided owner"
    }),
    ERROR_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_TYPE_REQUIRED", {
      defaultValue: "No type provided"
    }),
    ERROR_OBJECT_ID_REQUIRED: trads_default.t("notification.error.ERROR_OBJECT_ID_REQUIRED", {
      defaultValue: "No object id provided"
    }),
    ERROR_OBJECT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OBJECT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided object id"
    }),
    ERROR_IS_EXPIRED_REQUIRED: trads_default.t("notification.error.ERROR_IS_EXPIRED_REQUIRED", {
      defaultValue: "No is expired provided"
    }),
    ERROR_IS_EXPIRED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_EXPIRED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is expired"
    }),
    ERROR_EXPIRATION_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXPIRATION_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided expiration date"
    }),
    ERROR_INFORM_REASON_REQUIRED: trads_default.t("notification.error.ERROR_INFORM_REASON_REQUIRED", {
      defaultValue: "No inform reason provided"
    }),
    ERROR_REJECT_REASON_REQUIRED: trads_default.t("notification.error.ERROR_REJECT_REASON_REQUIRED", {
      defaultValue: "No reject reason provided"
    }),
    ERROR_ROTATE_FACTOR_REQUIRED: trads_default.t("notification.error.ERROR_ROTATE_FACTOR_REQUIRED", {
      defaultValue: "No rotate factor provided"
    }),
    ERROR_ROTATE_FACTOR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ROTATE_FACTOR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided rotate factor"
    }),
    ERROR_WITHOUT_EXPIRED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_WITHOUT_EXPIRED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided without expired"
    }),
    ERROR_DOCUMENT_ALREADY_VALIDATED: trads_default.t("notification.error.ERROR_DOCUMENT_ALREADY_VALIDATED", {
      defaultValue: "Provided document is already validated"
    }),
    ERROR_DOCUMENT_ALREADY_REJECTED: trads_default.t("notification.error.ERROR_DOCUMENT_ALREADY_REJECTED", {
      defaultValue: "Provided document is already rejected"
    }),
    ERROR_DOCUMENT_NOT_IBAN: trads_default.t("notification.error.ERROR_DOCUMENT_NOT_IBAN", {
      defaultValue: "Provided document is not an IBAN document"
    }),
    ERROR_DOCUMENT_STATUS_NOT_RECEIVED: trads_default.t("notification.error.ERROR_DOCUMENT_STATUS_NOT_RECEIVED", {
      defaultValue: "Provided document status is not received"
    }),
    ERROR_USER_ALREADY_INFORMED: trads_default.t("notification.error.ERROR_USER_ALREADY_INFORMED", {
      defaultValue: "User is already informed"
    }),
    ERROR_DOCUMENT_NOT_RESETTABLE: trads_default.t("notification.error.ERROR_DOCUMENT_NOT_RESETTABLE", {
      defaultValue: "Provided document is not resettable"
    }),
    ERROR_B2B_CLAIM_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_CLAIM_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2b claim id"
    }),
    ERROR_DOCUMENT_NOTES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENT_NOTES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided document notes"
    }),
    ERROR_UNCOVERED_ELEMENTS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENTS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided uncovered elements"
    }),
    ERROR_UNCOVERED_ELEMENTS_REQUIRED: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENTS_REQUIRED", {
      defaultValue: "No uncovered elements provided"
    }),
    ERROR_UNCOVERED_ELEMENT_AMOUNT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided uncovered element amount"
      }
    ),
    ERROR_UNCOVERED_ELEMENT_AMOUNT_REQUIRED: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_REQUIRED", {
      defaultValue: "No uncovered element amount provided"
    }),
    ERROR_UNCOVERED_ELEMENT_LABEL_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided uncovered element label"
      }
    ),
    ERROR_UNCOVERED_ELEMENT_LABEL_REQUIRED: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_REQUIRED", {
      defaultValue: "No uncovered element label provided"
    }),
    ERROR_UNCOVERED_ELEMENT_LABEL_TOO_LONG: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_LONG", {
      defaultValue: "Provided uncovered element label is too long"
    }),
    ERROR_UNCOVERED_ELEMENT_LABEL_TOO_SHORT: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENT_LABEL_TOO_SHORT", {
      defaultValue: "Provided uncovered element label is too short"
    }),
    ERROR_UNCOVERED_ELEMENT_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_UNCOVERED_ELEMENT_AMOUNT_TOO_LOW", {
      defaultValue: "Provided uncovered element amount is too low"
    }),
    ERROR_INSURANCE_CLAIM_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INSURANCE_CLAIM_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided claim id"
    }),
    ERROR_INSURANCE_CLAIM_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_INSURANCE_CLAIM_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided claim object"
      }
    ),
    ERROR_OWNER_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OWNER_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided owner object"
    }),
    ERROR_OWNING_GROUP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OWNING_GROUP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided owning group"
    }),
    ERROR_OWNING_GROUP_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OWNING_GROUP_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided owning group object"
    }),
    ERROR_PERSONAL_LOCKS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PERSONAL_LOCKS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided personal-locks"
    }),
    ERROR_VALIDATED_BY_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VALIDATED_BY_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided validated by object"
    }),
    // Note related
    ERROR_NOTES_REQUIRED: trads_default.t("notification.error.ERROR_NOTES_REQUIRED", {
      defaultValue: "No notes provided"
    }),
    ERROR_SEND_TO_USER_REQUIRED: trads_default.t("notification.error.ERROR_SEND_TO_USER_REQUIRED", {
      defaultValue: "No sent to user provided"
    }),
    ERROR_SEND_TO_USER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SEND_TO_USER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided send to user"
    }),
    ERROR_COMMENT_REQUIRED: trads_default.t("notification.error.ERROR_COMMENT_REQUIRED", {
      defaultValue: "No comment provided"
    }),
    ERROR_IS_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is object"
    }),
    ERROR_REJECTED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REJECTED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided rejected"
    }),
    ERROR_NEW_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_NEW_TYPE_REQUIRED", {
      defaultValue: "No new type provided"
    }),
    ERROR_NEW_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_NEW_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided new type"
    }),
    ERROR_NEW_LINK_REQUIRED: trads_default.t("notification.error.ERROR_NEW_LINK_REQUIRED", {
      defaultValue: "No new link provided"
    }),
    ERROR_NEW_LINK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NEW_LINK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided new link"
    }),
    ERROR_EVENT_USER_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EVENT_USER_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided event user object"
    }),
    // B2b contract related
    ERROR_CONTRACT_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_CONTRACT_DOES_NOT_EXIST", {
      defaultValue: "Contract does not exist"
    }),
    ERROR_CONTRACT_ID_REQUIRED: trads_default.t("notification.error.ERROR_CONTRACT_ID_REQUIRED", {
      defaultValue: "No contract id provided"
    }),
    ERROR_CONTRACT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CONTRACT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided contract id"
    }),
    ERROR_IS_AMEND_ALLOWED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_AMEND_ALLOWED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is_amend_allowed"
    }),
    ERROR_IS_DURATION_GT_CONTRACT_DURATION_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_DURATION_GT_CONTRACT_DURATION_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is_duration_gt_contract_duration_allowed"
      }
    ),
    // B2c contract related
    ERROR_VALID_END_DATE_TOO_OLD: trads_default.t("notification.error.ERROR_VALID_END_DATE_TOO_OLD", {
      defaultValue: "Provided valid end date is too old"
    }),
    ERROR_VALID_START_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VALID_START_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided valid start date"
    }),
    ERROR_VALID_START_DATE_TOO_OLD: trads_default.t("notification.error.ERROR_VALID_START_DATE_TOO_OLD", {
      defaultValue: "Provided valid start date is too old"
    }),
    ERROR_PACKAGE_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PACKAGE_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided package_object filter"
    }),
    ERROR_PARTNER_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner_object filter"
    }),
    // Package related
    ERROR_PACKAGE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PACKAGE_DOES_NOT_EXIST", {
      defaultValue: "Package does not exist"
    }),
    ERROR_PACKAGE_ID_REQUIRED: trads_default.t("notification.error.ERROR_PACKAGE_ID_REQUIRED", {
      defaultValue: "No package id provided"
    }),
    ERROR_PACKAGE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PACKAGE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided package id"
    }),
    // Payment related
    ERROR_PAYMENT_METHOD_REQUIRED: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_REQUIRED", {
      defaultValue: "No payment method provided"
    }),
    ERROR_PAYMENT_METHOD_TOO_SHORT: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_TOO_SHORT", {
      defaultValue: "Provided payment method is too short"
    }),
    ERROR_PAYMENT_METHOD_NOT_FOUND: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_NOT_FOUND", {
      defaultValue: "No payment method found"
    }),
    ERROR_PAYMENT_METHOD_ID_REQUIRED: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_ID_REQUIRED", {
      defaultValue: "No payment method id provided"
    }),
    ERROR_PAYMENT_METHOD_ID_TOO_SHORT: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_ID_TOO_SHORT", {
      defaultValue: "Provided payment method id is too short"
    }),
    ERROR_PAYMENT_METHOD_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_TYPE_REQUIRED", {
      defaultValue: "No payment method type provided"
    }),
    ERROR_PAYMENT_METHOD_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided payment method type"
    }),
    ERROR_PAYMENT_INTENT_ID_REQUIRED: trads_default.t("notification.error.ERROR_PAYMENT_INTENT_ID_REQUIRED", {
      defaultValue: "No payment intent id provided"
    }),
    ERROR_PAYMENT_INTENT_ID_TOO_SHORT: trads_default.t("notification.error.ERROR_PAYMENT_INTENT_ID_TOO_SHORT", {
      defaultValue: "Provided payment intent id is too short"
    }),
    ERROR_PAYMENT_METHOD_DOES_NOT_BELONG_TO_GROUP: trads_default.t(
      "notification.error.ERROR_PAYMENT_METHOD_DOES_NOT_BELONG_TO_GROUP",
      {
        defaultValue: "Provided payment intent id does not belong to your group"
      }
    ),
    ERROR_PAYMENT_METHOD_NOT_SEPA: trads_default.t("notification.error.ERROR_PAYMENT_METHOD_NOT_SEPA", {
      defaultValue: "Payment method is not a SEPA direct debit"
    }),
    ERROR_INVOICE_ID_REQUIRED: trads_default.t("notification.error.ERROR_INVOICE_ID_REQUIRED", {
      defaultValue: "No invocie id method provided"
    }),
    already_sponsored: trads_default.t("notification.error.already_sponsored", {
      defaultValue: "You have already been sponsored. You can be sponsored only once."
    }),
    // Vehicle related
    ERROR_BIKE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bike id"
    }),
    ERROR_VEHICLE_ID_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_ID_REQUIRED", {
      defaultValue: "No vehicle id provided"
    }),
    ERROR_VEHICLE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vehicle id"
    }),
    ERROR_PURCHASE_PROOF_REQUIRED: trads_default.t("notification.error.ERROR_PURCHASE_PROOF_REQUIRED", {
      defaultValue: "No purchase proof provided"
    }),
    ERROR_PURCHASE_PROOF_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PURCHASE_PROOF_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided purchase proof"
    }),
    ERROR_PURCHASE_DATE_REQUIRED: trads_default.t("notification.error.ERROR_PURCHASE_DATE_REQUIRED", {
      defaultValue: "No purchase date provided"
    }),
    ERROR_PURCHASE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PURCHASE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided purchase date"
    }),
    ERROR_PURCHASE_DATE_TOO_OLD: trads_default.t("notification.error.ERROR_PURCHASE_DATE_TOO_OLD", {
      defaultValue: "Provided purchase date is too old (5 years old max)"
    }),
    ERROR_BICYCODE_REQUIRED: trads_default.t("notification.error.ERROR_BICYCODE_REQUIRED", {
      defaultValue: "No marking code provided"
    }),
    ERROR_BICYCODE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_BICYCODE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided marking code"
    }),
    ERROR_COMMENT_INVALID_LENGTH: trads_default.t("notification.error.ERROR_COMMENT_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided comment"
    }),
    ERROR_DATAS_REQUIRED: trads_default.t("notification.error.ERROR_DATAS_REQUIRED", {
      defaultValue: "No datas provided"
    }),
    ERROR_DATAS_EMPTY: trads_default.t("notification.error.ERROR_DATAS_EMPTY", {
      defaultValue: "No datas provided"
    }),
    ERROR_VEHICLE_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLE_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vehicle object"
    }),
    // Fleet related
    ERROR_FLEET_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_FLEET_DOES_NOT_EXIST", {
      defaultValue: "Provided fleer does not exist"
    }),
    ERROR_FLEET_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FLEET_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided fleet"
    }),
    // Multipart related
    ERROR_FILE_REQUIRED: trads_default.t("notification.error.ERROR_FILE_REQUIRED", {
      defaultValue: "No file provided"
    }),
    ERROR_DOCUMENTS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENTS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided documents"
    }),
    ERROR_FLEET_ASSOCIATION_ERROR: trads_default.t("notification.error.ERROR_FLEET_ASSOCIATION_ERROR", {
      defaultValue: "Fleet association error"
    }),
    ERROR_VEHICLE_IDS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLE_IDS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided vehicle ids"
    }),
    ERROR_VEHICLE_IDS_EMPTY: trads_default.t("notification.error.ERROR_VEHICLE_IDS_EMPTY", {
      defaultValue: "No vehicle ids provided"
    }),
    ERROR_VEHICLE_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLE_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vehicle ids"
    }),
    ERROR_FLEETS_EMPTY: trads_default.t("notification.error.ERROR_FLEETS_EMPTY", {
      defaultValue: "No fleets provided"
    }),
    ERROR_FLEETS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_FLEETS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided fleets"
    }),
    ERROR_VEHICLE_IDS_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_IDS_REQUIRED", {
      defaultValue: "No vehicle ids provided"
    }),
    // Lead related
    ERROR_LEAD_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_LEAD_DOES_NOT_EXIST", {
      defaultValue: "Lead does not exist"
    }),
    ERROR_FROM_SOURCE_INVALID_TYPE: trads_default.t("notification.error.ERROR_FROM_SOURCE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided from source"
    }),
    ERROR_STATUS_INVALID_TYPE: trads_default.t("notification.error.ERROR_STATUS_INVALID_TYPE", {
      defaultValue: "Invalid type for provided status"
    }),
    ERROR_STATUS_INVALID_VALUE: trads_default.t("notification.error.ERROR_STATUS_INVALID_VALUE", {
      defaultValue: "Invalid value for provided status"
    }),
    ERROR_COMMISSION_INVOICE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_COMMISSION_INVOICE_DOES_NOT_EXIST", {
      defaultValue: "Commission invoice does not exist"
    }),
    ERROR_COMMISSION_INVOICE_ALREADY_PAID: trads_default.t("notification.error.ERROR_COMMISSION_INVOICE_ALREADY_PAID", {
      defaultValue: "Commission invoice is already paid"
    }),
    ERROR_COMMISSION_INVOICE_ID_REQUIRED: trads_default.t("notification.error.ERROR_COMMISSION_INVOICE_ID_REQUIRED", {
      defaultValue: "Commission invoice ID is required"
    }),
    ERROR_COMMISSION_INVOICE_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_COMMISSION_INVOICE_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided commission invoice ID"
      }
    ),
    ERROR_INVALID_COMMISSION_INVOICE_STATUS_TRANSITION: trads_default.t(
      "notification.error.ERROR_INVALID_COMMISSION_INVOICE_STATUS_TRANSITION",
      {
        defaultValue: "Invalid commission invoice status transition"
      }
    ),
    ERROR_COMMISSION_INVOICE_ZERO_AMOUNT_ALREADY_EXISTS: trads_default.t(
      "notification.error.ERROR_COMMISSION_INVOICE_ZERO_AMOUNT_ALREADY_EXISTS",
      {
        defaultValue: "A commission invoice with zero amount already exists for this period"
      }
    ),
    ERROR_NO_COMMISSION_RULES_CONFIGURED: trads_default.t("notification.error.ERROR_NO_COMMISSION_RULES_CONFIGURED", {
      defaultValue: "No commission rules are configured for this group"
    }),
    ERROR_NO_RECEIPTS: trads_default.t("notification.error.ERROR_NO_RECEIPTS", {
      defaultValue: "No receipts found"
    }),
    ERROR_NEWS_LETTER_OPT_IN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NEWS_LETTER_OPT_IN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided new letter opt-in"
    }),
    ERROR_PHONE_OPT_IN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PHONE_OPT_IN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided phone opt-in"
    }),
    ERROR_ADDITIONAL_INFORMATION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ADDITIONAL_INFORMATION_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided additional information"
      }
    ),
    NO_RECEIPT_COVERING_TERMINATION_DATE: trads_default.t("notification.error.NO_RECEIPT_COVERING_TERMINATION_DATE", {
      defaultValue: "No receipt covering termination date provided"
    }),
    // Make related
    ERROR_TOKEN_REQUIRED: trads_default.t("notification.error.ERROR_TOKEN_REQUIRED", {
      defaultValue: "No token provided"
    }),
    // Quote related
    ERROR_QUOTE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_QUOTE_DOES_NOT_EXIST", {
      defaultValue: "Quote does not exist"
    }),
    ERROR_QUOTE_NOT_EDITABLE: trads_default.t("notification.error.ERROR_QUOTE_NOT_EDITABLE", {
      defaultValue: "Quote not editable"
    }),
    // Lock model related
    ERROR_LOCK_MODEL_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_LOCK_MODEL_DOES_NOT_EXIST", {
      defaultValue: "Lock model does not exist"
    }),
    ERROR_LOCKS_IDS_REQUIRED: trads_default.t("notification.error.ERROR_LOCKS_IDS_REQUIRED", {
      defaultValue: "No locks ids provided"
    }),
    ERROR_LOCKS_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LOCKS_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided locks ids"
    }),
    ERROR_IS_APPROVED_REQUIRED: trads_default.t("notification.error.ERROR_IS_APPROVED_REQUIRED", {
      defaultValue: "No is approved provided"
    }),
    ERROR_IS_APPROVED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_APPROVED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is approved"
    }),
    ERROR_TYPE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_TYPE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided type"
    }),
    ERROR_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided type"
    }),
    ERROR_SECURITY_CERTIFICATE_REQUIRED: trads_default.t("notification.error.ERROR_SECURITY_CERTIFICATE_REQUIRED", {
      defaultValue: "No security certificate provided"
    }),
    ERROR_SECURITY_CERTIFICATE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_SECURITY_CERTIFICATE_INVALID_LENGTH", {
      defaultValue: "Invalid length provided security certificate"
    }),
    ERROR_LEVEL_INVALID_LENGTH: trads_default.t("notification.error.ERROR_LEVEL_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided level"
    }),
    // Fraud partner related
    ERROR_FRAUD_PARTNER_ID_REQUIRED: trads_default.t("notification.error.ERROR_FRAUD_PARTNER_ID_REQUIRED", {
      defaultValue: "No fraud partner id provided"
    }),
    ERROR_FRAUD_PARTNER_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FRAUD_PARTNER_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided fraud partner id"
    }),
    ERROR_ALREADY_FRAUD_PARTNER: trads_default.t("notification.error.ERROR_ALREADY_FRAUD_PARTNER", {
      defaultValue: "Provided fraud partner id is already a fraud partner"
    }),
    ERROR_FRAUD_PARTNER_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_FRAUD_PARTNER_DOES_NOT_EXIST", {
      defaultValue: "Fraud partner does not exist"
    }),
    // Marking code related
    ERROR_CLAIM_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CLAIM_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided claim date"
    }),
    ERROR_CODE_REQUIRED: trads_default.t("notification.error.ERROR_CODE_REQUIRED", {
      defaultValue: "No code provided"
    }),
    ERROR_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided code"
    }),
    ERROR_CODE_INVALID_LENGTH: trads_default.t("notification.error.ERROR_CODE_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided code"
    }),
    ERROR_CODE_ID_REQUIRED: trads_default.t("notification.error.ERROR_CODE_ID_REQUIRED", {
      defaultValue: "No code id provided"
    }),
    ERROR_CODE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CODE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided code id"
    }),
    ERROR_YEAR_FORMAT: trads_default.t("notification.error.ERROR_YEAR_FORMAT", {
      defaultValue: "Year must be a 4-digit number"
    }),
    ERROR_NAME_MIN_1: trads_default.t("notification.error.ERROR_NAME_MIN_1", {
      defaultValue: "Name must be at least 1 character"
    }),
    ERROR_MONTH_MIN_1: trads_default.t("notification.error.ERROR_MONTH_MIN_1", {
      defaultValue: "Month must be at least 1"
    }),
    ERROR_MONTH_MAX_12: trads_default.t("notification.error.ERROR_MONTH_MAX_12", {
      defaultValue: "Month cannot be greater than 12"
    }),
    ERROR_APIC_STATUS_HISTORY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_APIC_STATUS_HISTORY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided apic status"
    }),
    // Conflict related
    ERROR_GROUPS_IN_CONFLICT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GROUPS_IN_CONFLICT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided groups in conflict"
    }),
    // Notification related
    ERROR_NOTIF_IDS_REQUIRED: trads_default.t("notification.error.ERROR_NOTIF_IDS_REQUIRED", {
      defaultValue: "No notif ids provided"
    }),
    ERROR_NOTIF_IDS_EMPTY: trads_default.t("notification.error.ERROR_NOTIF_IDS_EMPTY", {
      defaultValue: "No notif ids provided"
    }),
    ERROR_NOTIF_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NOTIF_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided notif ids"
    }),
    ERROR_USERS_IDS_REQUIRED: trads_default.t("notification.error.ERROR_USERS_IDS_REQUIRED", {
      defaultValue: "No users ids provided"
    }),
    ERROR_USERS_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USERS_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided users ids"
    }),
    ERROR_USERS_IDS_EMPTY: trads_default.t("notification.error.ERROR_USERS_IDS_EMPTY", {
      defaultValue: "No users ids provided"
    }),
    ERROR_MESSAGE_REQUIRED: trads_default.t("notification.error.ERROR_MESSAGE_REQUIRED", {
      defaultValue: "No message provided"
    }),
    ERROR_TITLE_REQUIRED: trads_default.t("notification.error.ERROR_TITLE_REQUIRED", {
      defaultValue: "No title provided"
    }),
    ERROR_START_DATE_IN_THE_PAST: trads_default.t("notification.error.ERROR_START_DATE_IN_THE_PAST", {
      defaultValue: "Provided start date should not be in the past"
    }),
    ERROR_DATE_NOT_IN_PAST: trads_default.t("notification.error.ERROR_DATE_NOT_IN_PAST", {
      defaultValue: "Provided date should not be in the past"
    }),
    ERROR_START_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_START_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format provided for start date"
    }),
    ERROR_EXPIRATION_BEFORE_START: trads_default.t("notification.error.ERROR_EXPIRATION_BEFORE_START", {
      defaultValue: "Expiration date must be after start date"
    }),
    ERROR_MISSING_EXPIRATION_DATE: trads_default.t("notification.error.ERROR_MISSING_EXPIRATION_DATE", {
      defaultValue: "No expiration date provided"
    }),
    ERROR_EXPIRATION_DATE_NOT_IN_FUTUR: trads_default.t("notification.error.ERROR_EXPIRATION_DATE_NOT_IN_FUTUR", {
      defaultValue: "Provided expiration date should be in the futur"
    }),
    ERROR_PRIORITY_LEVEL_REQUIRED: trads_default.t("notification.error.ERROR_PRIORITY_LEVEL_REQUIRED", {
      defaultValue: "No priority level provided"
    }),
    ERROR_PRIORITY_LEVEL_INVALID_TYPE: trads_default.t("notification.error.ERROR_PRIORITY_LEVEL_INVALID_TYPE", {
      defaultValue: "Invalid type for provided priority level"
    }),
    ERROR_SEND_VIA_FIREBASE_REQUIRED: trads_default.t("notification.error.ERROR_SEND_VIA_FIREBASE_REQUIRED", {
      defaultValue: "No send via firebase provided"
    }),
    ERROR_SEND_VIA_FIREBASE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SEND_VIA_FIREBASE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided send via firebase"
    }),
    ERROR_NOTIFICATION_LINK_INVALID_URL: trads_default.t("notification.error.ERROR_NOTIFICATION_LINK_INVALID_URL", {
      defaultValue: "Invalid format for provided notification link"
    }),
    ERROR_NOTIFICATION_TEXT_REQUIRED: trads_default.t("notification.error.ERROR_NOTIFICATION_TEXT_REQUIRED", {
      defaultValue: "No notification text provided"
    }),
    ERROR_NOTIFICATION_TITLE_REQUIRED: trads_default.t("notification.error.ERROR_NOTIFICATION_TITLE_REQUIRED", {
      defaultValue: "No notification title provided"
    }),
    // Auth token required
    ERROR_AUTH_TOKEN_ID_REQUIRED: trads_default.t("notification.error.ERROR_AUTH_TOKEN_ID_REQUIRED", {
      defaultValue: "No auth token id provided"
    }),
    ERROR_AUTH_TOKEN_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AUTH_TOKEN_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided auth token id"
    }),
    ERROR_OTP_CODE_REQUIRED: trads_default.t("notification.error.ERROR_OTP_CODE_REQUIRED", {
      defaultValue: "No OTP code provided"
    }),
    ERROR_OTP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OTP_INVALID_FORMAT", {
      defaultValue: "OTP code must be a 6-digit number"
    }),
    // Phone operator related
    ERROR_PHONE_OPERATOR_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PHONE_OPERATOR_DOES_NOT_EXIST", {
      defaultValue: "Phone operator does not exist"
    }),
    ERROR_NAME_TOO_SHORT: trads_default.t("notification.error.ERROR_NAME_TOO_SHORT", {
      defaultValue: "Provided name is too short"
    }),
    ERROR_OPERATOR_CODE_REQUIRED: trads_default.t("notification.error.ERROR_OPERATOR_CODE_REQUIRED", {
      defaultValue: "No operator code provided"
    }),
    ERROR_OPERATOR_CODE_TOO_LOW: trads_default.t("notification.error.ERROR_OPERATOR_CODE_TOO_LOW", {
      defaultValue: "Provided operator code is too low"
    }),
    ERROR_OPERATOR_CODE_TOO_HIGH: trads_default.t("notification.error.ERROR_OPERATOR_CODE_TOO_HIGH", {
      defaultValue: "Provided operator code is too high"
    }),
    ERROR_OPERATOR_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPERATOR_CODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided operator code"
    }),
    ERROR_COUNTRY_CODE_TOO_SHORT: trads_default.t("notification.error.ERROR_COUNTRY_CODE_TOO_SHORT", {
      defaultValue: "Provided country code is too short"
    }),
    ERROR_COUNTRY_CODE_TOO_LONG: trads_default.t("notification.error.ERROR_COUNTRY_CODE_TOO_LONG", {
      defaultValue: "Provided country code is too long"
    }),
    // Promotion-code related
    ERROR_PROMOTION_CODE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PROMOTION_CODE_DOES_NOT_EXIST", {
      defaultValue: "Promotion code does not exist"
    }),
    ERROR_PROMO_CODE_NOT_FOUND: trads_default.t("notification.error.ERROR_PROMO_CODE_NOT_FOUND", {
      defaultValue: "Promo code not found"
    }),
    PROMO_CODE_NOT_FOUND: trads_default.t("notification.error.PROMO_CODE_NOT_FOUND", {
      defaultValue: "Promo code not found"
    }),
    ERROR_PROMOTION_CODE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PROMOTION_CODE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided promotion code id"
    }),
    ERROR_PROMOTION_CODE_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_PROMOTION_CODE_ALREADY_EXISTS", {
      defaultValue: "Promotion code already exist"
    }),
    ERROR_ACTIVE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ACTIVE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided active"
    }),
    ERROR_PRODUCT_REQUIRED: trads_default.t("notification.error.ERROR_PRODUCT_REQUIRED", {
      defaultValue: "No product provided"
    }),
    ERROR_PRODUCT_INVALID_TYPE: trads_default.t("notification.error.ERROR_PRODUCT_INVALID_TYPE", {
      defaultValue: "Invalid type for provided product"
    }),
    ERROR_MONTHLY_INVALID_LENGTH: trads_default.t("notification.error.ERROR_MONTHLY_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided monthly code"
    }),
    ERROR_ANNUAL_INVALID_LENGTH: trads_default.t("notification.error.ERROR_ANNUAL_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided annual code"
    }),
    ERROR_MAX_REDEEM_TOTAL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_REDEEM_TOTAL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided max redeem total"
    }),
    ERROR_MAX_REDEEM_PER_USER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_REDEEM_PER_USER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided max redeem per user"
    }),
    ERROR_LOCK_REQUIRED: trads_default.t("notification.error.ERROR_LOCK_REQUIRED", {
      defaultValue: "No lock provided"
    }),
    ERROR_LOCK_INVALID_LENGTH: trads_default.t("notification.error.ERROR_LOCK_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided lock"
    }),
    ERROR_PROMOTION_CODE_EXPIRED: trads_default.t("notification.error.ERROR_PROMOTION_CODE_EXPIRED", {
      defaultValue: "Provided promotion-code is expired"
    }),
    FIELD_VALIDATION_ERRORS: getGeneratedDefaultErrorMessage("FIELD_VALIDATION_ERRORS"),
    ERROR_PROMOTION_CODE_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PROMOTION_CODE_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided promotion-code object"
      }
    ),
    ERROR_USER_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided user object"
    }),
    ERROR_SHOP_PRODUCT_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SHOP_PRODUCT_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided shop product object"
    }),
    ERROR_SHOP_PRODUCT_PROMO_CODE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOP_PRODUCT_PROMO_CODE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided shop product promotion code"
      }
    ),
    // Search related
    ERROR_INPUT_REQUIRED: trads_default.t("notification.error.ERROR_INPUT_REQUIRED", {
      defaultValue: "No input provided"
    }),
    // Coverage related
    ERROR_COVERAGE_CODE_REQUIRED: trads_default.t("notification.error.ERROR_COVERAGE_CODE_REQUIRED", {
      defaultValue: "No coverage code provided"
    }),
    ERROR_COVERAGE_CODE_INVALID_TYPE: trads_default.t("notification.error.ERROR_COVERAGE_CODE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided coverage code"
    }),
    // Locking-session related
    ERROR_LOCKING_SESSION_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_LOCKING_SESSION_DOES_NOT_EXIST", {
      defaultValue: "Locking-session does not exist"
    }),
    ERROR_LOCKING_SESSION_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LOCKING_SESSION_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided locking-session id"
    }),
    // Lock related
    ERROR_LOCK_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_LOCK_DOES_NOT_EXIST", {
      defaultValue: "Lock does not exist"
    }),
    ERROR_LOCK_ID_REQUIRED: trads_default.t("notification.error.ERROR_LOCK_ID_REQUIRED", {
      defaultValue: "No lock id provided"
    }),
    ERROR_LOCK_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LOCK_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided lock id"
    }),
    // Personal-locking-session related
    ERROR_PERSONAL_LOCKING_SESSION_DOES_NOT_EXIST: trads_default.t(
      "notification.error.ERROR_PERSONAL_LOCKING_SESSION_DOES_NOT_EXIST",
      {
        defaultValue: "Personal-locking-session does not exist"
      }
    ),
    ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided personal-locking-session id"
      }
    ),
    // Sinister related
    ERROR_DESCRIPTION_REQUIRED: trads_default.t("notification.error.ERROR_DESCRIPTION_REQUIRED", {
      defaultValue: "No description provided"
    }),
    ERROR_SOURCE_REQUIRED: trads_default.t("notification.error.ERROR_SOURCE_REQUIRED", {
      defaultValue: "No source provided"
    }),
    ERROR_SOURCE_INVALID_TYPE: trads_default.t("notification.error.ERROR_SOURCE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided source"
    }),
    ERROR_SIZE_REQUIRED: trads_default.t("notification.error.ERROR_SIZE_REQUIRED", {
      defaultValue: "No size provided"
    }),
    ERROR_ORIGIN_REQUIRED: trads_default.t("notification.error.ERROR_ORIGIN_REQUIRED", {
      defaultValue: "No origin provided"
    }),
    ERROR_MANEUVERS_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVERS_REQUIRED", {
      defaultValue: "No maneuvers provided"
    }),
    ERROR_MANEUVERS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_MANEUVERS_INVALID_ARRAY", {
      defaultValue: "Maneuvers must be an array"
    }),
    ERROR_MANEUVER_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVER_TYPE_REQUIRED", {
      defaultValue: "No maneuver type provided"
    }),
    ERROR_MANEUVER_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_TYPE_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver type"
    }),
    ERROR_MANEUVER_INSTRUCTION_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVER_INSTRUCTION_REQUIRED", {
      defaultValue: "No maneuver instruction provided"
    }),
    ERROR_MANEUVER_INSTRUCTION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_INSTRUCTION_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver instruction format"
    }),
    ERROR_MANEUVER_DISTANCE_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVER_DISTANCE_REQUIRED", {
      defaultValue: "No maneuver distance provided"
    }),
    ERROR_MANEUVER_DISTANCE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_DISTANCE_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver distance format"
    }),
    ERROR_MANEUVER_DURATION_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVER_DURATION_REQUIRED", {
      defaultValue: "No maneuver duration provided"
    }),
    ERROR_MANEUVER_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver duration format"
    }),
    ERROR_MANEUVER_BEARING_REQUIRED: trads_default.t("notification.error.ERROR_MANEUVER_BEARING_REQUIRED", {
      defaultValue: "No maneuver bearing provided"
    }),
    ERROR_MANEUVER_BEARING_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_BEARING_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver bearing format"
    }),
    ERROR_MANEUVER_STREET_NAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANEUVER_STREET_NAME_INVALID_FORMAT", {
      defaultValue: "Invalid maneuver street name format"
    }),
    ERROR_CATEGORY_REQUIRED: trads_default.t("notification.error.ERROR_CATEGORY_REQUIRED", {
      defaultValue: "No category provided"
    }),
    ERROR_CATEGORY_INVALID_TYPE: trads_default.t("notification.error.ERROR_CATEGORY_INVALID_TYPE", {
      defaultValue: "Invalid type for provided category"
    }),
    // Version related
    ERROR_ANDROID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ANDROID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided android"
    }),
    ERROR_IOS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IOS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided ios"
    }),
    ERROR_MIN_ANDROID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIN_ANDROID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided minimum android"
    }),
    ERROR_MIN_IOS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIN_IOS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided minimum ios"
    }),
    // Others
    ERROR_CHALLENGE_TOKEN_REQUIRED: trads_default.t("notification.error.ERROR_CHALLENGE_TOKEN_REQUIRED", {
      defaultValue: "No token provided"
    }),
    ERROR_CAN_NOT_CHANGE_CLIENT_ROLE: trads_default.t("notification.error.ERROR_CAN_NOT_CHANGE_CLIENT_ROLE", {
      defaultValue: "Changing client roles is not allowed"
    }),
    ERROR_UNAUTHORIZED: trads_default.t("notification.error.ERROR_UNAUTHORIZED", {
      defaultValue: "Unauthorized"
    }),
    ERROR_UNAUTHORIZED_ROLE_MODIFICATION: trads_default.t("notification.error.ERROR_UNAUTHORIZED_ROLE_MODIFICATION", {
      defaultValue: "Operation not allowed"
    }),
    ERROR_USER_HAS_ACTIVE_POLICY: trads_default.t("notification.error.ERROR_USER_HAS_ACTIVE_POLICY", {
      defaultValue: "User has an active policy"
    }),
    ERROR_USER_HAS_POLICY_IN_RETENTION_PERIOD: trads_default.t("notification.error.ERROR_USER_HAS_POLICY_IN_RETENTION_PERIOD", {
      defaultValue: "User has a policy terminated less than five years ago"
    }),
    ERROR_USER_HAS_CLAIM_IN_RETENTION_PERIOD: trads_default.t("notification.error.ERROR_USER_HAS_CLAIM_IN_RETENTION_PERIOD", {
      defaultValue: "User has a claim closed less than five years ago"
    }),
    ERROR_USER_HAS_LOCK_SUBSCRIPTION: trads_default.t("notification.error.ERROR_USER_HAS_LOCK_SUBSCRIPTION", {
      defaultValue: "User has an active lock subscription"
    }),
    ERROR_USER_IS_IN_A_GROUP: trads_default.t("notification.error.ERROR_USER_IS_IN_A_GROUP", {
      defaultValue: "User is in a group"
    }),
    ERROR_GROUP_HAS_ACTIVE_CLIENT_POLICY: trads_default.t("notification.error.ERROR_GROUP_HAS_ACTIVE_CLIENT_POLICY", {
      defaultValue: "Group has an active client policy"
    }),
    ERROR_GROUP_HAS_ACTIVE_PARTNER_POLICY: trads_default.t("notification.error.ERROR_GROUP_HAS_ACTIVE_PARTNER_POLICY", {
      defaultValue: "Group has an active partner policy"
    }),
    ERROR_GROUP_HAS_ACTIVE_ATTRIB_POLICY: trads_default.t("notification.error.ERROR_GROUP_HAS_ACTIVE_ATTRIB_POLICY", {
      defaultValue: "Group has an active attributed policy"
    }),
    ERROR_GROUP_HAS_POLICY_IN_RETENTION_PERIOD: trads_default.t(
      "notification.error.ERROR_GROUP_HAS_POLICY_IN_RETENTION_PERIOD",
      {
        defaultValue: "Group has a policy terminated less than five years ago"
      }
    ),
    ERROR_GROUP_HAS_CLAIM_IN_RETENTION_PERIOD: trads_default.t("notification.error.ERROR_GROUP_HAS_CLAIM_IN_RETENTION_PERIOD", {
      defaultValue: "Group has a claim closed less than five years ago"
    }),
    ERROR_GROUP_MANAGES_OTHER_GROUPS: trads_default.t("notification.error.ERROR_GROUP_MANAGES_OTHER_GROUPS", {
      defaultValue: "Group manages other groups"
    }),
    ERROR_GROUP_HAS_PENDING_PARTNER_INVOICE: trads_default.t("notification.error.ERROR_GROUP_HAS_PENDING_PARTNER_INVOICE", {
      defaultValue: "Group has a partner invoice pending payment"
    }),
    ERROR_GROUP_HAS_PAYMENTS: trads_default.t("notification.error.ERROR_GROUP_HAS_PAYMENTS", {
      defaultValue: "Group has payments in Stripe"
    }),
    ERROR_BODY_CANNOT_BE_EMPTY: trads_default.t("notification.error.ERROR_BODY_CANNOT_BE_EMPTY", {
      defaultValue: "The body can not be empty"
    }),
    ERROR_CANNOT_SET_SELF_AS_MANAGING_PARTNER: trads_default.t("notification.error.ERROR_CANNOT_SET_SELF_AS_MANAGING_PARTNER", {
      defaultValue: "A group cannot be set as its own managing partner"
    }),
    ERROR_GROUP_ALREADY_PARTNER: trads_default.t("notification.error.ERROR_GROUP_ALREADY_PARTNER", {
      defaultValue: "The group is already a partner"
    }),
    ERROR_GROUP_IS_NOT_PARTNER: trads_default.t("notification.error.ERROR_GROUP_IS_NOT_PARTNER", {
      defaultValue: "The group is not a partner"
    }),
    ERROR_IS_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_PARTNER_INVALID_FORMAT", {
      defaultValue: "is_partner field is not in a correct format"
    }),
    ERROR_IS_PARTNER_REQUIRED: trads_default.t("notification.error.ERROR_IS_PARTNER_REQUIRED", {
      defaultValue: "is_partner field is mandatory"
    }),
    ERROR_GROUP_ALREADY_FRAUD_PARTNER: trads_default.t("notification.error.ERROR_GROUP_ALREADY_FRAUD_PARTNER", {
      defaultValue: "The group is already a fraud partner"
    }),
    ERROR_GROUP_IS_NOT_FRAUD_PARTNER: trads_default.t("notification.error.ERROR_GROUP_IS_NOT_FRAUD_PARTNER", {
      defaultValue: "The group is not a fraud partner"
    }),
    ERROR_COMMENT_MIN: trads_default.t("notification.error.ERROR_COMMENT_MIN", {
      defaultValue: "Comment is too short"
    }),
    ERROR_COMMENT_MAX: trads_default.t("notification.error.ERROR_COMMENT_MAX", {
      defaultValue: "Comment is too long"
    }),
    ERROR_MISSING_REQUIRED_PAYMENT_DATE: trads_default.t("notification.error.ERROR_MISSING_REQUIRED_PAYMENT_DATE", {
      defaultValue: "Payment date was required when new status is INVOICE_PAID"
    }),
    ERROR_MISSING_REQUIRED_SENDING_DATE: trads_default.t("notification.error.ERROR_MISSING_REQUIRED_SENDING_DATE", {
      defaultValue: "Sending date was required when new status is INVOICE_SENT"
    }),
    ERROR_PARTNER_INVOICES_STATUS: trads_default.t("notification.error.ERROR_PARTNER_INVOICES_STATUS", {
      defaultValue: "Missing partner invoice status"
    }),
    WRONG_PARTNER_INVOICES_STATUS: trads_default.t("notification.error.WRONG_PARTNER_INVOICES_STATUS", {
      defaultValue: "Wrong status type"
    }),
    WRONG_PAYMENT_DATE_TYPE: trads_default.t("notification.error.WRONG_PAYMENT_DATE_TYPE", {
      defaultValue: "Wrong date format for payment date"
    }),
    WRONG_SENDING_DATE_TYPE: trads_default.t("notification.error.WRONG_SENDING_DATE_TYPE", {
      defaultValue: "Wrong date format for sending date"
    }),
    ERROR_PAID_AMOUNT_MINIMUM: trads_default.t("notification.error.ERROR_PAID_AMOUNT_MINIMUM", {
      defaultValue: "Error paid amount minimum"
    }),
    ERROR_PAID_AMOUNT_TYPE: trads_default.t("notification.error.ERROR_PAID_AMOUNT_TYPE", {
      defaultValue: "Error paid amount type"
    }),
    ERROR_KEEP_RECEIPTS_TYPE: trads_default.t("notification.error.ERROR_KEEP_RECEIPTS_TYPE", {
      defaultValue: "Invalid type for provided keep_receipts"
    }),
    // Articles
    ERROR_DOCUMENT_ID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENT_ID_FORMAT", {
      defaultValue: "document_id is not in a correct format"
    }),
    ERROR_DOCUMENT_ID_REQUIRED: trads_default.t("notification.error.ERROR_DOCUMENT_ID_REQUIRED", {
      defaultValue: "document_id is required"
    }),
    ERROR_NAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NAME_INVALID_FORMAT", {
      defaultValue: "name is not in a correct format"
    }),
    ERROR_NAME_TOO_LONG: trads_default.t("notification.error.ERROR_NAME_TOO_LONG", {
      defaultValue: "name is too long"
    }),
    ERROR_PU_TTC_FORMAT: trads_default.t("notification.error.ERROR_PU_TTC_FORMAT", {
      defaultValue: "pu_ttc is not in a correct format"
    }),
    ERROR_PU_TTC_REQUIRED: trads_default.t("notification.error.ERROR_PU_TTC_REQUIRED", {
      defaultValue: "pu_ttc is required"
    }),
    ERROR_TOTAL_TTC_NEGATIVE: trads_default.t("notification.error.ERROR_TOTAL_TTC_NEGATIVE", {
      defaultValue: "The total price (tax included) must be positive"
    }),
    ERROR_TOTAL_TTC_FORMAT: trads_default.t("notification.error.ERROR_TOTAL_TTC_FORMAT", {
      defaultValue: "The total price (tax included) has an invalid format"
    }),
    ERROR_QUANTITY_FORMAT: trads_default.t("notification.error.ERROR_QUANTITY_FORMAT", {
      defaultValue: "quantity is not in a correct format"
    }),
    ERROR_QUANTITY_REQUIRED: trads_default.t("notification.error.ERROR_QUANTITY_REQUIRED", {
      defaultValue: "Quantity is required"
    }),
    ERROR_ARTICLES_REQUIRED: trads_default.t("notification.error.ERROR_ARTICLES_REQUIRED", {
      defaultValue: "Articles are required"
    }),
    ERROR_DISCOUNT_AMOUNT_NEGATIVE: trads_default.t("notification.error.ERROR_DISCOUNT_AMOUNT_NEGATIVE", {
      defaultValue: "Discount amount must be positive"
    }),
    ERROR_DISCOUNT_AMOUNT_FORMAT: trads_default.t("notification.error.ERROR_DISCOUNT_AMOUNT_FORMAT", {
      defaultValue: "Discount amount is not in a correct format"
    }),
    ERROR_PU_HT_NEGATIVE: trads_default.t("notification.error.ERROR_PU_HT_NEGATIVE", {
      defaultValue: "ht price must be positive"
    }),
    ERROR_PU_TTC_NEGATIVE: trads_default.t("notification.error.ERROR_PU_TTC_NEGATIVE", {
      defaultValue: "ttc price must be positive"
    }),
    ERROR_QUANTITY_NEGATIVE: trads_default.t("notification.error.ERROR_QUANTITY_NEGATIVE", {
      defaultValue: "Quantity must be positive"
    }),
    ERROR_TVA_AMOUNT_NEGATIVE: trads_default.t("notification.error.ERROR_TVA_AMOUNT_NEGATIVE", {
      defaultValue: "TVA amount must be positive"
    }),
    ERROR_TVA_PERCENTAGE_NEGATIVE: trads_default.t("notification.error.ERROR_TVA_PERCENTAGE_NEGATIVE", {
      defaultValue: "TVA percentage must be positive"
    }),
    ERROR_TVA_PERCENTAGE_FORMAT: trads_default.t("notification.error.ERROR_TVA_PERCENTAGE_FORMAT", {
      defaultValue: "TVA percentage is not in a correct format"
    }),
    ERROR_DISCOUNT_PERCENTAGE_TOO_HIGH: trads_default.t("notification.error.ERROR_DISCOUNT_PERCENTAGE_TOO_HIGH", {
      defaultValue: "Discount percentage must be less than 100"
    }),
    ERROR_TVA_PERCENTAGE_TOO_HIGH: trads_default.t("notification.error.ERROR_TVA_PERCENTAGE_TOO_HIGH", {
      defaultValue: "TVA percentage must be less than 100"
    }),
    ERROR_DISCOUNT_PERCENTAGE_NEGATIVE: trads_default.t("notification.error.ERROR_DISCOUNT_PERCENTAGE_NEGATIVE", {
      defaultValue: "Discount percentage must be positive"
    }),
    ERROR_DISCOUNT_PERCENTAGE_FORMAT: trads_default.t("notification.error.ERROR_DISCOUNT_PERCENTAGE_FORMAT", {
      defaultValue: "Discount percentage has an invalid format"
    }),
    ERROR_DOCUMENT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENT_ID_INVALID_FORMAT", {
      defaultValue: "Document ID has an invalid format"
    }),
    ERROR_PU_HT_FORMAT: trads_default.t("notification.error.ERROR_PU_HT_FORMAT", {
      defaultValue: "Price without taxes is not in a correct format"
    }),
    ERROR_TVA_FORMAT: trads_default.t("notification.error.ERROR_TVA_FORMAT", {
      defaultValue: "TVA is not in a correct format"
    }),
    ERROR_ID_INVALID: trads_default.t("notification.error.ERROR_ID_INVALID", {
      defaultValue: "id invalid"
    }),
    ERROR_TVA_AMOUNT_FORMAT: trads_default.t("notification.error.ERROR_TVA_AMOUNT_FORMAT", {
      defaultValue: "TVA amount is not in a correct format"
    }),
    ERROR_QUOTE_ID_REQUIRED: trads_default.t("notification.error.ERROR_QUOTE_ID_REQUIRED", {
      defaultValue: "Error quote id required"
    }),
    ERROR_POLICY_QUOTE_ID_REQUIRED: trads_default.t("notification.error.ERROR_POLICY_QUOTE_ID_REQUIRED", {
      defaultValue: "Error policy quote id required"
    }),
    ERROR_VEHICLES_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLES_ID_INVALID_FORMAT", {
      defaultValue: "Error vehicles id invalid format"
    }),
    ERROR_CANCEL_REASON_INVALID_TYPE: trads_default.t("notification.error.ERROR_CANCEL_REASON_INVALID_TYPE", {
      defaultValue: "Error cancel reason id invalid type"
    }),
    ERROR_CANCEL_REASON_REQUIRED: trads_default.t("notification.error.ERROR_CANCEL_REASON_REQUIRED", {
      defaultValue: "Error cancel reason required"
    }),
    ERROR_CANCEL_REASON_INFO_REQUIRED: trads_default.t("notification.error.ERROR_CANCEL_REASON_INFO_REQUIRED", {
      defaultValue: "Error cancel reason info required"
    }),
    ERROR_SIMULATE_TERMINATION_PENDING_POLICY: trads_default.t("notification.error.ERROR_SIMULATE_TERMINATION_PENDING_POLICY", {
      defaultValue: "Error simulate termination pending policy"
    }),
    ERROR_SIMULATE_TERMINATION_POLICY_EFFECTIVE_START_DATE_TOO_OLD: trads_default.t(
      "notification.error.ERROR_SIMULATE_TERMINATION_POLICY_EFFECTIVE_START_DATE_TOO_OLD",
      {
        defaultValue: "Error simulate termination policy effective start date too old"
      }
    ),
    ERROR_VEHICLES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLES_INVALID_ARRAY", {
      defaultValue: "Error vehicles not an array"
    }),
    ERROR_ARTICLES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ARTICLES_INVALID_ARRAY", {
      defaultValue: "Provided articles not an array"
    }),
    ERROR_AUTO_RENEWAL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AUTO_RENEWAL_INVALID_FORMAT", {
      defaultValue: "Auto renewal must be a boolean value."
    }),
    ERROR_OPS_SUSPEND_ALLOWED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPS_SUSPEND_ALLOWED_INVALID_FORMAT", {
      defaultValue: "Ops suspend allowed must be a boolean value."
    }),
    ERROR_POLICY_INFORMATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_INFORMATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy information"
    }),
    ERROR_POLICY_PRICE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_PRICE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy price"
    }),
    ERROR_BIKE_INFORMATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_INFORMATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bike information"
    }),
    ERROR_DISPLAY_CONTRACT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DISPLAY_CONTRACT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided display contract"
    }),
    ERROR_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CANCEL_ALLOWED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided cancel allowed"
    }),
    ERROR_INSURED_VALUE_LIMIT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INSURED_VALUE_LIMIT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided insured value limit"
    }),
    ERROR_OPS_SUSPEND_ALLOWED_REQUIRED: trads_default.t("notification.error.ERROR_OPS_SUSPEND_ALLOWED_REQUIRED", {
      defaultValue: "Ops suspend allowed is required"
    }),
    ERROR_NB_EMPLOYEES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NB_EMPLOYEES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided number of employees"
    }),
    ERROR_IS_ARCHIVE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_ARCHIVE_INVALID_FORMAT", {
      defaultValue: "is_archive must be a boolean value."
    }),
    ERROR_EVENTS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_EVENTS_INVALID_ARRAY", {
      defaultValue: "Events must be an array."
    }),
    ERROR_EVENTS_INVALID_TYPE: trads_default.t("notification.error.ERROR_EVENTS_INVALID_TYPE", {
      defaultValue: "Invalid type for event(s)."
    }),
    ERROR_EVENT_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EVENT_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided event date."
    }),
    ERROR_EVENT_DATE_REQUIRED: trads_default.t("notification.error.ERROR_EVENT_DATE_REQUIRED", {
      defaultValue: "Event date is required."
    }),
    ERROR_EVENT_INVALID_TYPE: trads_default.t("notification.error.ERROR_EVENT_INVALID_TYPE", {
      defaultValue: "Invalid type for provided event."
    }),
    ERROR_EVENT_REQUIRED: trads_default.t("notification.error.ERROR_EVENT_REQUIRED", {
      defaultValue: "Event is required."
    }),
    ERROR_RAW_BODY_REQUIRED: trads_default.t("notification.error.ERROR_RAW_BODY_REQUIRED", {
      defaultValue: "Raw body is required."
    }),
    ERROR_SUBSCRIPTION_REQUIRED: trads_default.t("notification.error.ERROR_SUBSCRIPTION_REQUIRED", {
      defaultValue: "Subscription is required."
    }),
    ERROR_SUBSCRIPTION_ID_REQUIRED: trads_default.t("notification.error.ERROR_SUBSCRIPTION_ID_REQUIRED", {
      defaultValue: "Subscription id is required."
    }),
    ERROR_INVOICE_DATE_REQUIRED: trads_default.t("notification.error.ERROR_INVOICE_DATE_REQUIRED", {
      defaultValue: "Invoice date is required."
    }),
    ERROR_INVOICE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INVOICE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided invoice date."
    }),
    ERROR_PAYLOAD_REQUIRED: trads_default.t("notification.error.ERROR_PAYLOAD_REQUIRED", {
      defaultValue: "Payload is required."
    }),
    ERROR_PAYMENT_STATUS_REQUIRED: trads_default.t("notification.error.ERROR_PAYMENT_STATUS_REQUIRED", {
      defaultValue: "Payment status is required."
    }),
    ERROR_WEBHOOK_DESCRIPTION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_WEBHOOK_DESCRIPTION_INVALID_FORMAT", {
      defaultValue: "Invalid format for webhook description."
    }),
    ERROR_WEBHOOK_GROUP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_WEBHOOK_GROUP_INVALID_FORMAT", {
      defaultValue: "Invalid format for webhook group."
    }),
    ERROR_WEBHOOK_GROUP_REQUIRED: trads_default.t("notification.error.ERROR_WEBHOOK_GROUP_REQUIRED", {
      defaultValue: "Webhook group is required."
    }),
    ERROR_WEBHOOK_EVENTS_REQUIRED: trads_default.t("notification.error.ERROR_WEBHOOK_EVENTS_REQUIRED", {
      defaultValue: "Please provide at least one event for the webhook."
    }),
    ERROR_WEBHOOK_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_WEBHOOK_URL_INVALID_FORMAT", {
      defaultValue: "Webhook URL must be a string."
    }),
    ERROR_WEBHOOK_URL_INVALID_URL: trads_default.t("notification.error.ERROR_WEBHOOK_URL_INVALID_URL", {
      defaultValue: "Webhook URL must be a valid URL (https://example.com)."
    }),
    ERROR_WEBHOOK_URL_REQUIRED: trads_default.t("notification.error.ERROR_WEBHOOK_URL_REQUIRED", {
      defaultValue: "Please provide a webhook URL."
    }),
    ERROR_COMMUNICATION_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_COMMUNICATION_TYPE_REQUIRED", {
      defaultValue: "please provide at least one communication type"
    }),
    ERROR_COMMUNICATION_TYPE_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ARRAY", {
      defaultValue: "Communication type must be an array."
    }),
    ERROR_COMMUNICATION_TYPE_INVALID_ENUM: trads_default.t("notification.error.ERROR_COMMUNICATION_TYPE_INVALID_ENUM", {
      defaultValue: "Invalid communication type."
    }),
    // RATE LIMIT
    TOO_MANY_REQUESTS: trads_default.t("notification.error.TOO_MANY_REQUESTS", {
      defaultValue: "Too many requests, please wait and try again"
    }),
    ERROR_COMMUNICATION_TYPES_MUST_BE_ARRAY: trads_default.t("notification.error.ERROR_COMMUNICATION_TYPES_MUST_BE_ARRAY", {
      defaultValue: "Communication types must be an array."
    }),
    ERROR_COMMUNICATION_TYPES_REQUIRED: trads_default.t("notification.error.ERROR_COMMUNICATION_TYPES_REQUIRED", {
      defaultValue: "Communication types are required."
    }),
    ERROR_SEND_QUOTE_TO_CLIENT: trads_default.t("notification.error.ERROR_SEND_QUOTE_TO_CLIENT", {
      defaultValue: "Failed to send quote to client"
    }),
    ERROR_SEND_QUOTE_TO_CLIENT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SEND_QUOTE_TO_CLIENT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided send quote to client"
    }),
    ERROR_INVITATION_NOT_FOUND: trads_default.t("notification.error.ERROR_INVITATION_NOT_FOUND", {
      defaultValue: "Invitation not found"
    }),
    ERROR_INVITATION_ID_REQUIRED: trads_default.t("notification.error.ERROR_INVITATION_ID_REQUIRED", {
      defaultValue: "Invitation id is required"
    }),
    ERROR_INVITATION_ID_INVALID: trads_default.t("notification.error.ERROR_INVITATION_ID_INVALID", {
      defaultValue: "Invitation id is invalid"
    }),
    ERROR_INVITATION_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INVITATION_ID_INVALID_FORMAT", {
      defaultValue: "Invitation id is not in a correct format"
    }),
    ERROR_UPDATE_INVITATION_DATA_REQUIRED: trads_default.t("notification.error.ERROR_UPDATE_INVITATION_DATA_REQUIRED", {
      defaultValue: "At least one invitation update field is required"
    }),
    ERROR_UPDATE_MEMBER_DATA_REQUIRED: trads_default.t("notification.error.ERROR_UPDATE_MEMBER_DATA_REQUIRED", {
      defaultValue: "At least one member update field is required"
    }),
    ERROR_CLAIM_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CLAIM_ID_INVALID_FORMAT", {
      defaultValue: "Claim id is not in a correct format"
    }),
    ERROR_CLAIM_ID_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_ID_REQUIRED", {
      defaultValue: "Claim id is required"
    }),
    ERROR_DOCUMENT_UUID_REQUIRED: trads_default.t("notification.error.ERROR_DOCUMENT_UUID_REQUIRED", {
      defaultValue: "Document uuid is required"
    }),
    ERROR_DOCUMENT_UUID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENT_UUID_INVALID_FORMAT", {
      defaultValue: "Document uuid is not in a correct format"
    }),
    //commissions
    ERROR_STATUS_REQUIRED: trads_default.t("notification.error.ERROR_STATUS_REQUIRED", {
      defaultValue: "Status is required"
    }),
    ERROR_COMMISSION_ID_REQUIRED: trads_default.t("notification.error.ERROR_COMMISSION_ID_REQUIRED", {
      defaultValue: "Commission id is required"
    }),
    ERROR_COMMISSION_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSION_ID_INVALID_FORMAT", {
      defaultValue: "Commission id is not in a correct format"
    }),
    ERROR_COMMISSION_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_COMMISSION_DOES_NOT_EXIST", {
      defaultValue: "Commission does not exist"
    }),
    ERROR_COMMISSIONS_RULES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSIONS_RULES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided commission rules"
    }),
    // B2B ONBOARDING
    ERROR_B2B_ONBOARDING_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_B2B_ONBOARDING_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided b2b onboarding object"
      }
    ),
    ERROR_ONBOARDING_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_ONBOARDING_TYPE_REQUIRED", {
      defaultValue: "Onboarding type is required"
    }),
    ERROR_ONBOARDING_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_ONBOARDING_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided onboarding type"
    }),
    ERROR_POLICY_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy duration"
    }),
    ERROR_POLICY_DURATION_TOO_LOW: trads_default.t("notification.error.ERROR_POLICY_DURATION_TOO_LOW", {
      defaultValue: "Policy duration is too low"
    }),
    ERROR_POLICY_DURATION_TOO_HIGH: trads_default.t("notification.error.ERROR_POLICY_DURATION_TOO_HIGH", {
      defaultValue: "Policy duration is too high"
    }),
    ERROR_COVERAGE_NEEDS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COVERAGE_NEEDS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided coverage needs"
    }),
    ERROR_COVERAGE_NEEDS_DUPLICATE: trads_default.t("notification.error.ERROR_COVERAGE_NEEDS_DUPLICATE", {
      defaultValue: "Coverage needs must be unique"
    }),
    ERROR_COVERAGE_NEEDS_INVALID_ENUM: trads_default.t("notification.error.ERROR_COVERAGE_NEEDS_INVALID_ENUM", {
      defaultValue: "Invalid enum for provided coverage needs"
    }),
    ERROR_ESTIMATED_VEHICLE_COUNT_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_ESTIMATED_VEHICLE_COUNT_INVALID_TYPE",
      {
        defaultValue: "Invalid type for provided estimated vehicle count"
      }
    ),
    ERROR_ESTIMATED_POLICY_COUNT_INVALID_TYPE: trads_default.t("notification.error.ERROR_ESTIMATED_POLICY_COUNT_INVALID_TYPE", {
      defaultValue: "Invalid type for provided estimated policy count"
    }),
    ERROR_RESELL_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_RESELL_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided resell type"
    }),
    ERROR_B2B_ONBOARDING_VALIDATION_FAILED: trads_default.t("notification.error.ERROR_B2B_ONBOARDING_VALIDATION_FAILED", {
      defaultValue: "B2b onboarding validation failed"
    }),
    // B2B CLAIMS
    ERROR_IS_BATTERY_SAFE_REQUIRED: trads_default.t("notification.error.ERROR_IS_BATTERY_SAFE_REQUIRED", {
      defaultValue: "Is battery safe is required"
    }),
    ERROR_KEY_INVALID_TYPE: trads_default.t("notification.error.ERROR_KEY_INVALID_TYPE", {
      defaultValue: "Key is invalid type"
    }),
    ERROR_KEY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_KEY_INVALID_FORMAT", {
      defaultValue: "Key has an invalid format"
    }),
    ERROR_UPDATE_CLAIM_NOT_ALLOWED: trads_default.t("notification.error.ERROR_UPDATE_CLAIM_NOT_ALLOWED", {
      defaultValue: "Update claim not allowed"
    }),
    ERROR_VEHICLE_MARKING_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLE_MARKING_CODE_INVALID_FORMAT", {
      defaultValue: "Vehicle marking code is invalid format"
    }),
    ERROR_VEHICLE_MARKING_CODE_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_MARKING_CODE_REQUIRED", {
      defaultValue: "Vehicle marking code is required"
    }),
    ERROR_CLAIM_VEHICLE_IDENTIFIER_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_VEHICLE_IDENTIFIER_REQUIRED", {
      defaultValue: "Bike marking code or serial number is required"
    }),
    ERROR_VEHICLE_IDENTIFIER_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_IDENTIFIER_REQUIRED", {
      defaultValue: "Bike marking code or serial number is required"
    }),
    ERROR_VEHICLE_IDENTIFIER_EXCLUSIVE: trads_default.t("notification.error.ERROR_VEHICLE_IDENTIFIER_EXCLUSIVE", {
      defaultValue: "Provide only one of bike marking code or serial number"
    }),
    ERROR_VEHICLE_IDENTIFIER_NOT_UNIQUE: trads_default.t("notification.error.ERROR_VEHICLE_IDENTIFIER_NOT_UNIQUE", {
      defaultValue: "Several bikes match this identifier"
    }),
    ERROR_B2B_CLAIM_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_B2B_CLAIM_DOES_NOT_EXIST", {
      defaultValue: "B2B claim does not exist"
    }),
    ERROR_NO_CLAIM_LINKED_TO_POLICY_OR_GROUP: trads_default.t("notification.error.ERROR_NO_CLAIM_LINKED_TO_POLICY_OR_GROUP", {
      defaultValue: "No claim linked to policy or group"
    }),
    ERROR_BIKE_ELEMENTS_ONLY_ALLOWED_FOR_PARTIAL_COVERAGE_TYPES: trads_default.t(
      "notification.error.ERROR_BIKE_ELEMENTS_ONLY_ALLOWED_FOR_PARTIAL_COVERAGE_TYPES",
      {
        defaultValue: "Bike elements are required when theft partial or damage partial"
      }
    ),
    ERROR_IS_FRAUD_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_FRAUD_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is fraud"
    }),
    AMOUNT_BIGGER_THAN_INSURED_VALUE: trads_default.t("notification.error.AMOUNT_BIGGER_THAN_INSURED_VALUE", {
      defaultValue: "Claim amount is bigger than insured value"
    }),
    AMOUNT_TO_PAY_NOT_EQUAL_TO_SUM_OF_CLAIMS_TO_PAY: trads_default.t(
      "notification.error.AMOUNT_TO_PAY_NOT_EQUAL_TO_SUM_OF_CLAIMS_TO_PAY",
      {
        defaultValue: "Amount to pay is not equal to the sum of the claims to pay"
      }
    ),
    CLAIM_NOT_FOUND_OR_NOT_IN_TO_PAY_STATUS: trads_default.t("notification.error.CLAIM_NOT_FOUND_OR_NOT_IN_TO_PAY_STATUS", {
      defaultValue: "No claim in TO_PAY status found"
    }),
    DOC_COMPLETION_NOT_100: trads_default.t("notification.error.DOC_COMPLETION_NOT_100", {
      defaultValue: "Document completion is not 100%"
    }),
    ERROR_CLAIM_COVERAGE_STATUS_INVALID_VALUE: trads_default.t("notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_VALUE", {
      defaultValue: "Invalid value for provided claim coverage status"
    }),
    ERROR_HAS_OPTIONAL_BATTERY_INVALID_TYPE: trads_default.t("notification.error.ERROR_HAS_OPTIONAL_BATTERY_INVALID_TYPE", {
      defaultValue: "Invalid type for provided has optional battery"
    }),
    ERROR_HAS_OPTIONAL_BATTERY_REQUIRED: trads_default.t("notification.error.ERROR_HAS_OPTIONAL_BATTERY_REQUIRED", {
      defaultValue: "Has optional battery is required"
    }),
    ERROR_HAS_TRAILER_INVALID_TYPE: trads_default.t("notification.error.ERROR_HAS_TRAILER_INVALID_TYPE", {
      defaultValue: "Invalid type for provided has trailer"
    }),
    ERROR_HAS_TRAILER_REQUIRED: trads_default.t("notification.error.ERROR_HAS_TRAILER_REQUIRED", {
      defaultValue: "Has trailer is required"
    }),
    ERROR_IS_OPTIONAL_BATTERY_SAFE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_OPTIONAL_BATTERY_SAFE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is optional battery safe"
      }
    ),
    ERROR_IS_TRAILER_SAFE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_TRAILER_SAFE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is trailer safe"
    }),
    ERROR_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER: trads_default.t("notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER", {
      defaultValue: "Invalid format for provided recovered amount partner"
    }),
    ERROR_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE: trads_default.t(
      "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE",
      {
        defaultValue: "Recovered amount partner must be positive"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_NUMBER",
      {
        defaultValue: "Invalid format for provided to be recovered amount partner"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_NOT_POSITIVE",
      {
        defaultValue: "To be recovered amount partner must be positive"
      }
    ),
    ERROR_TO_BE_REIMBURSED_PARTNER_NOT_NUMBER: trads_default.t("notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_NUMBER", {
      defaultValue: "Invalid format for provided to be reimbursed partner"
    }),
    ERROR_TO_BE_REIMBURSED_PARTNER_NOT_POSITIVE: trads_default.t(
      "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_NOT_POSITIVE",
      {
        defaultValue: "To be reimbursed partner must be positive"
      }
    ),
    ERROR_CLAIM_PAID_PARTNER_NOT_NUMBER: trads_default.t("notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_NUMBER", {
      defaultValue: "Invalid format for provided claim paid partner"
    }),
    ERROR_CLAIM_PAID_PARTNER_NOT_POSITIVE: trads_default.t("notification.error.ERROR_CLAIM_PAID_PARTNER_NOT_POSITIVE", {
      defaultValue: "Claim paid partner must be positive"
    }),
    // B2B CONTRACTS
    ERROR_GROUP_REQUIRED: trads_default.t("notification.error.ERROR_GROUP_REQUIRED", {
      defaultValue: "Group is required"
    }),
    ERROR_GROUP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GROUP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided group"
    }),
    ERROR_DURATION_REQUIRED: trads_default.t("notification.error.ERROR_DURATION_REQUIRED", {
      defaultValue: "Duration is required"
    }),
    ERROR_DURATION_MUST_BE_GREATER_THAN_ONE: trads_default.t("notification.error.ERROR_DURATION_MUST_BE_GREATER_THAN_ONE", {
      defaultValue: "Duration must be greater than 1"
    }),
    ERROR_TIME_PERIOD_REQUIRED: trads_default.t("notification.error.ERROR_TIME_PERIOD_REQUIRED", {
      defaultValue: "Time period is required"
    }),
    ERROR_TIME_PERIOD_INVALID_TYPE: trads_default.t("notification.error.ERROR_TIME_PERIOD_INVALID_TYPE", {
      defaultValue: "Invalid type for provided time period"
    }),
    ERROR_PRICING_DURATION_REQUIRED: trads_default.t("notification.error.ERROR_PRICING_DURATION_REQUIRED", {
      defaultValue: "Pricing duration is required"
    }),
    ERROR_PRICING_DURATION_MUST_BE_GREATER_THAN_ONE: trads_default.t(
      "notification.error.ERROR_PRICING_DURATION_MUST_BE_GREATER_THAN_ONE",
      {
        defaultValue: "Pricing duration must be greater than 1"
      }
    ),
    ERROR_PRICING_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRICING_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided pricing duration"
    }),
    ERROR_PRICING_TIME_PERIOD_REQUIRED: trads_default.t("notification.error.ERROR_PRICING_TIME_PERIOD_REQUIRED", {
      defaultValue: "Pricing time period is required"
    }),
    ERROR_PRICING_TIME_PERIOD_INVALID_TYPE: trads_default.t("notification.error.ERROR_PRICING_TIME_PERIOD_INVALID_TYPE", {
      defaultValue: "Invalid type for provided pricing time period"
    }),
    ERROR_END_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_END_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided end date"
    }),
    ERROR_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner"
    }),
    ERROR_PRICING_RULES_PER_COVERAGE_REQUIRED: trads_default.t("notification.error.ERROR_PRICING_RULES_PER_COVERAGE_REQUIRED", {
      defaultValue: "Pricing rules per coverage is required"
    }),
    ERROR_PRICING_RULES_PER_COVERAGE_EMPTY: trads_default.t("notification.error.ERROR_PRICING_RULES_PER_COVERAGE_EMPTY", {
      defaultValue: "Pricing rules per coverage cannot be empty"
    }),
    ERROR_PRICING_RULES_PER_COVERAGE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided pricing rules per coverage"
      }
    ),
    ERROR_FILE_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FILE_TYPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided file type"
    }),
    ERROR_FILE_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_FILE_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid file extension"
    }),
    ERROR_TEMPLATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TEMPLATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided template"
    }),
    ERROR_EMPTY_BODY_REQUIRED: trads_default.t("notification.error.ERROR_EMPTY_BODY_REQUIRED", {
      defaultValue: "Empty body check is required"
    }),
    ERROR_VALID_END_DATE_REQUIRED: trads_default.t("notification.error.ERROR_VALID_END_DATE_REQUIRED", {
      defaultValue: "A valid end date is required"
    }),
    ERROR_VALID_END_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VALID_END_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided valid end date"
    }),
    ERROR_CONTRACT_REQUIRED: trads_default.t("notification.error.ERROR_CONTRACT_REQUIRED", {
      defaultValue: "No contract provided"
    }),
    ERROR_CONTRACT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CONTRACT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided contract"
    }),
    ERROR_CLAIM_OCCURENCE_PERIOD_START_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_REQUIRED",
      {
        defaultValue: "Claim occurence period start is required"
      }
    ),
    ERROR_CLAIM_OCCURENCE_PERIOD_END_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_REQUIRED", {
      defaultValue: "Claim occurence period end is required"
    }),
    ERROR_PERSONAL_LOCKING_SESSIONS_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PERSONAL_LOCKING_SESSIONS_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided personal locking sessions id"
      }
    ),
    ERROR_PREMIUM_SUPPORT_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided premium support type"
    }),
    ERROR_LOCKING_SESSIONS_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LOCKING_SESSIONS_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided locking sessions id"
    }),
    ERROR_REMAIN_TO_PAY_NOT_RECOVERED_REQUIRED: trads_default.t(
      "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_REQUIRED",
      {
        defaultValue: "Remain to pay not recovered is required"
      }
    ),
    ERROR_REMAIN_TO_PAY_NOT_RECOVERED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_REMAIN_TO_PAY_NOT_RECOVERED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided remain to pay not recovered"
      }
    ),
    ERROR_TO_BE_REIMBURSED_GROUP_NOT_NUMBER: trads_default.t("notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_NUMBER", {
      defaultValue: "Invalid format for provided to be reimbursed group"
    }),
    ERROR_CLAIM_PAID_GROUP_NOT_POSITIVE: trads_default.t("notification.error.ERROR_CLAIM_PAID_GROUP_NOT_POSITIVE", {
      defaultValue: "Claim paid group must be positive"
    }),
    ERROR_CLAIM_PAID_GROUP_NOT_NUMBER: trads_default.t("notification.error.ERROR_CLAIM_PAID_GROUP_NOT_NUMBER", {
      defaultValue: "Invalid format for provided claim paid group"
    }),
    ERROR_SUPPORT_AMOUNT_NOT_POSITIVE: trads_default.t("notification.error.ERROR_SUPPORT_AMOUNT_NOT_POSITIVE", {
      defaultValue: "Support amount must be positive"
    }),
    ERROR_BIKE_CLAIM_AMOUNT_NOT_POSITIVE: trads_default.t("notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_POSITIVE", {
      defaultValue: "Bike claim amount must be positive"
    }),
    ERROR_BIKE_CLAIM_AMOUNT_NOT_NUMBER: trads_default.t("notification.error.ERROR_BIKE_CLAIM_AMOUNT_NOT_NUMBER", {
      defaultValue: "Invalid format for provided bike claim amount"
    }),
    ERROR_GROSS_AMOUNT_NOT_POSITIVE: trads_default.t("notification.error.ERROR_GROSS_AMOUNT_NOT_POSITIVE", {
      defaultValue: "Gross amount must be positive"
    }),
    ERROR_GROSS_AMOUNT_NOT_NUMBER: trads_default.t("notification.error.ERROR_GROSS_AMOUNT_NOT_NUMBER", {
      defaultValue: "Invalid format for provided gross amount"
    }),
    ERROR_TO_BE_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE",
      {
        defaultValue: "To be recovered amount group must be positive"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_GROUP_NOT_NUMBER: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_GROUP_NOT_NUMBER",
      {
        defaultValue: "Invalid format for provided to be recovered amount group"
      }
    ),
    ERROR_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE: trads_default.t(
      "notification.error.ERROR_RECOVERED_AMOUNT__GROUP_NOT_POSITIVE",
      {
        defaultValue: "Recovered amount group must be positive"
      }
    ),
    ERROR_RECOVERED_AMOUNT_GROUP_NOT_NUMBER: trads_default.t("notification.error.ERROR_RECOVERED_AMOUNT_GROUP_NOT_NUMBER", {
      defaultValue: "Invalid format for provided recovered amount group"
    }),
    ERROR_FRANCHISE_AMOUNT_NOT_POSITIVE: trads_default.t("notification.error.ERROR_FRANCHISE_AMOUNT_NOT_POSITIVE", {
      defaultValue: "Franchise amount must be positive"
    }),
    ERROR_FRANCHISE_AMOUNT_NOT_NUMBER: trads_default.t("notification.error.ERROR_FRANCHISE_AMOUNT_NOT_NUMBER", {
      defaultValue: "Invalid format for provided franchise amount"
    }),
    ERROR_FRANCHISE_PERCENTAGE_NOT_POSITIVE: trads_default.t("notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_POSITIVE", {
      defaultValue: "Franchise percentage must be positive"
    }),
    ERROR_FRANCHISE_PERCENTAGE_NOT_NUMBER: trads_default.t("notification.error.ERROR_FRANCHISE_PERCENTAGE_NOT_NUMBER", {
      defaultValue: "Invalid format for provided franchise percentage"
    }),
    ERROR_TO_BE_REIMBURSED_GROUP_NOT_POSITIVE: trads_default.t("notification.error.ERROR_TO_BE_REIMBURSED_GROUP_NOT_POSITIVE", {
      defaultValue: "To be reimbursed group must be positive"
    }),
    ERROR_CLAIM_OCCURENCE_PERIOD_START_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_START_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided claim occurence period start"
      }
    ),
    ERROR_CLAIM_OCCURENCE_PERIOD_END_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_OCCURENCE_PERIOD_END_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided claim occurence period end"
      }
    ),
    ERROR_PACKAGE_NOT_ACTIVE: trads_default.t("notification.error.ERROR_PACKAGE_NOT_ACTIVE", {
      defaultValue: "Package is not active"
    }),
    ERROR_PACKAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PACKAGE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided package"
    }),
    ERROR_CONTRACT_HAS_NO_END_DATE: trads_default.t("notification.error.ERROR_CONTRACT_HAS_NO_END_DATE", {
      defaultValue: "Contract does not have an end date"
    }),
    ERROR_CONTRACT_HAS_NO_START_DATE: trads_default.t("notification.error.ERROR_CONTRACT_HAS_NO_START_DATE", {
      defaultValue: "Contract does not have an start date"
    }),
    ERROR_CONTRACT_IS_NOT_ACTIVE: trads_default.t("notification.error.ERROR_CONTRACT_IS_NOT_ACTIVE", {
      defaultValue: "Contract is inactive"
    }),
    ERROR_MISSING_COVERAGE_PRICING_RULE_DEFINITION: trads_default.t(
      "notification.error.ERROR_MISSING_COVERAGE_PRICING_RULE_DEFINITION",
      {
        defaultValue: "No coverage pricing rule definition provided"
      }
    ),
    // B2B POLICIES
    ERROR_DURATION_INVALID_VALUE: trads_default.t("notification.error.ERROR_DURATION_INVALID_VALUE", {
      defaultValue: "Invalid value for provided duration"
    }),
    ERROR_POLICY_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy object"
    }),
    // B2B POLICIES CANCEL REQUEST
    ERROR_CANCEL_REQUEST_ID_REQUIRED: trads_default.t("notification.error.ERROR_CANCEL_REQUEST_ID_REQUIRED", {
      defaultValue: "No cancel request id provided"
    }),
    ERROR_CANCEL_REQUEST_UNIQUE_ID_REQUIRED: trads_default.t("notification.error.ERROR_CANCEL_REQUEST_UNIQUE_ID_REQUIRED", {
      defaultValue: "No cancel request unique id provided"
    }),
    // B2B QUOTES
    ERROR_CHOOSEN_PACKAGES_REQUIRED: trads_default.t("notification.error.ERROR_CHOOSEN_PACKAGES_REQUIRED", {
      defaultValue: "No choosen package provided"
    }),
    ERROR_AFFECTED_USERS_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_AFFECTED_USERS_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided affected users"
      }
    ),
    ERROR_AFFECTED_USERS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_AFFECTED_USERS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided affected users"
    }),
    ERROR_ACCESSORY_STEP_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ACCESSORY_STEP_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided accessory step"
    }),
    ERROR_OPTIONAL_COVERAGES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided oprtional coverages"
    }),
    ERROR_EFFECTIVE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EFFECTIVE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided effective date"
    }),
    ERROR_DURATION_TOO_LOW: trads_default.t("notification.error.ERROR_DURATION_TOO_LOW", {
      defaultValue: "Provided value for duration is too low"
    }),
    ERROR_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided duration"
    }),
    ERROR_USAGE_REQUIRED: trads_default.t("notification.error.ERROR_DURATION_REQUIRED", {
      defaultValue: "No usage provided"
    }),
    ERROR_USAGE_INVALID_TYPE: trads_default.t("notification.error.ERROR_USAGE_INVALID_TYPE", {
      defaultValue: "Invalid value for provided usage"
    }),
    ERROR_PAYMENT_METHODS_INVALID_TYPE: trads_default.t("notification.error.ERROR_PAYMENT_METHODS_INVALID_TYPE", {
      defaultValue: "Invalid value for provided payment methods"
    }),
    ERROR_SPLITTING_REQUIRED: trads_default.t("notification.error.ERROR_SPLITTING_REQUIRED", {
      defaultValue: "No splitting provided"
    }),
    ERROR_SPLITTING_INVALID_TYPE: trads_default.t("notification.error.ERROR_SPLITTING_INVALID_TYPE", {
      defaultValue: "Invalid value for provided splitting"
    }),
    ERROR_PARTNER_PAY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_PAY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner pay"
    }),
    ERROR_MODEL_BRAND_OR_BIKE_MODEL_REQUIRED: trads_default.t("notification.error.ERROR_MODEL_BRAND_OR_BIKE_MODEL_REQUIRED", {
      defaultValue: "A brand and model or a bike model must be provided"
    }),
    ERROR_ACCESSORIES_VALUE_TOO_LOW: trads_default.t("notification.error.ERROR_ACCESSORIES_VALUE_TOO_LOW", {
      defaultValue: "Provided value for accessories value is too low"
    }),
    ERROR_ACCESSORIES_VALUE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ACCESSORIES_VALUE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided accessories value"
    }),
    ERROR_COUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COUNT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided count"
    }),
    ERROR_FULL_REQUIRED: trads_default.t("notification.error.ERROR_FULL_REQUIRED", {
      defaultValue: "No full provided"
    }),
    ERROR_ANNUAL_REQUIRED: trads_default.t("notification.error.ERROR_ANNUAL_REQUIRED", {
      defaultValue: "No annual provided"
    }),
    ERROR_MONTHLY_REQUIRED: trads_default.t("notification.error.ERROR_MONTHLY_REQUIRED", {
      defaultValue: "No monthly provided"
    }),
    ERROR_OPT_IN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPT_IN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided opt-in"
    }),
    ERROR_AFFECTED_USERS_REQUIRED: trads_default.t("notification.error.ERROR_AFFECTED_USERS_REQUIRED", {
      defaultValue: "No affetced users provided"
    }),
    ERROR_AUTO_RENEWAL_INVALID_TYPE: trads_default.t("notification.error.ERROR_AUTO_RENEWAL_INVALID_TYPE", {
      defaultValue: "Invalid type for provided auto renewal"
    }),
    ERROR_BIRTHDAY_TOO_HIGH: trads_default.t("notification.error.ERROR_BIRTHDAY_TOO_HIGH", {
      defaultValue: "Provided birthday is too high"
    }),
    ERROR_MISSING_INFORMATION: trads_default.t("notification.error.ERROR_MISSING_INFORMATION", {
      defaultValue: "Some informations are missing"
    }),
    WRONG_B2B_USAGE_TYPE: trads_default.t("notification.error.WRONG_B2B_USAGE_TYPE", {
      defaultValue: "Invalid usage type"
    }),
    WRONG_TIME_PERIOD_TYPE: trads_default.t("notification.error.WRONG_TIME_PERIOD_TYPE", {
      defaultValue: "Invalid time period type"
    }),
    // CONTRACTUAL DOCUMENTS
    ERROR_KEY_REQUIRED: trads_default.t("notification.error.ERROR_KEY_REQUIRED", {
      defaultValue: "No key provided"
    }),
    ERROR_CONTRACTUAL_DOCUMENTS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CONTRACTUAL_DOCUMENTS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided contractual documents"
      }
    ),
    // ONBOARDING FROM WEBFLOW
    ERROR_AT_GD_VALUE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AT_GD_VALUE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided at gd value"
    }),
    ERROR_EMPLOYEE_OF_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EMPLOYEE_OF_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided employee of"
    }),
    ERROR_FIRSTNAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FIRSTNAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided firstname"
    }),
    ERROR_GCLID_FIELD_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GCLID_FIELD_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided gclid field"
    }),
    ERROR_LASTNAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LASTNAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided lastname"
    }),
    ERROR_OPT_IN_NL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPT_IN_NL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided opt in nl"
    }),
    ERROR_OPT_IN_NL_MOBILE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPT_IN_NL_MOBILE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided opt in nl mobile"
    }),
    ERROR_PAGE_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PAGE_URL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided page url"
    }),
    ERROR_PARTNERSHIP_SOURCE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNERSHIP_SOURCE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partnership source"
    }),
    ERROR_PARTNER_UTM_CONTENT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_UTM_CONTENT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner utm content"
    }),
    ERROR_PARTNER_UTM_SOURCE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_UTM_SOURCE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner utm source"
    }),
    ERROR_QUOTEFORM_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_QUOTEFORM_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided quoteform id"
    }),
    ERROR_UTM_CAMPAIGN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UTM_CAMPAIGN_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided utm campaign"
    }),
    ERROR_UTM_CONTENT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UTM_CONTENT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided utm content"
    }),
    ERROR_UTM_MEDIUM_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UTM_MEDIUM_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided utm medium"
    }),
    ERROR_UTM_SOURCE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UTM_SOURCE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided utm source"
    }),
    ERROR_UTM_TERM_INVALID_FORMAT: trads_default.t("notification.error.ERROR_UTM_TERM_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided utm term"
    }),
    // COVERAGES
    ERROR_COVERAGE_REQUIRED: trads_default.t("notification.error.ERROR_COVERAGE_REQUIRED", {
      defaultValue: "No coverage provided"
    }),
    ERROR_COVERAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COVERAGE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided coverage"
    }),
    ERROR_OPTIONAL_COVERAGES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_OPTIONAL_COVERAGES_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided coverage"
    }),
    ERROR_CAN_NOT_DISABLE_COVERAGE: trads_default.t("notification.error.ERROR_CAN_NOT_DISABLE_COVERAGE", {
      defaultValue: "Coverage could not be disabled"
    }),
    // FLEETS
    // FRAUD WEIGHTS
    // GROUP COMMISSIONS
    ERROR_PERCENTAGE_REQUIRED: trads_default.t("notification.error.ERROR_PERCENTAGE_REQUIRED", {
      defaultValue: "Percentage is required"
    }),
    ERROR_PERCENTAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PERCENTAGE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided percentage"
    }),
    ERROR_FIXED_AMOUNT_WITH_PERCENTAGE: trads_default.t("notification.error.ERROR_FIXED_AMOUNT_WITH_PERCENTAGE", {
      defaultValue: "Cannot set fixed amount when percentage is set"
    }),
    ERROR_PERCENTAGE_WITH_FIXED_AMOUNT: trads_default.t("notification.error.ERROR_PERCENTAGE_WITH_FIXED_AMOUNT", {
      defaultValue: "Cannot set percentage when fixed amount is set"
    }),
    ERROR_FIXED_AMOUNT_REQUIRED: trads_default.t("notification.error.ERROR_FIXED_AMOUNT_REQUIRED", {
      defaultValue: "Fixed amount is required"
    }),
    ERROR_FIXED_AMOUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FIXED_AMOUNT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided fixed amount"
    }),
    ERROR_AMOUNT_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_AMOUNT_TYPE_REQUIRED", {
      defaultValue: "Amount type is required"
    }),
    ERROR_AMOUNT_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_AMOUNT_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided amount type"
    }),
    ERROR_FIXED_AMOUNT_TYPE_NOT_ALLOWED: trads_default.t("notification.error.ERROR_FIXED_AMOUNT_TYPE_NOT_ALLOWED", {
      defaultValue: "Creating commission rules with fixed amount type is not allowed"
    }),
    ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ONE: trads_default.t(
      "notification.error.ERROR_POLICY_YEAR_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ONE",
      {
        defaultValue: "Policy year must be greater than 1"
      }
    ),
    ERROR_POLICY_YEAR_REQUIRED: trads_default.t("notification.error.ERROR_POLICY_YEAR_REQUIRED", {
      defaultValue: "Policy year is required"
    }),
    ERROR_POLICY_YEAR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_YEAR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy year"
    }),
    ERROR_COMMISSIONS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COMMISSIONS_INVALID_ARRAY", {
      defaultValue: "Commissions must be an array."
    }),
    ERROR_COMMISSIONS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSIONS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided commissions"
    }),
    ERROR_FIXED_AMOUNT_PROHIBITED_FOR_PERCENTAGE_TYPE: trads_default.t(
      "notification.error.ERROR_FIXED_AMOUNT_PROHIBITED_FOR_PERCENTAGE_TYPE",
      {
        defaultValue: "Fixed amounts are not allowed for percentage type"
      }
    ),
    // POLICIES
    ERROR_POLICY_ID_REQUIRED: trads_default.t("notification.error.ERROR_POLICY_ID_REQUIRED", {
      defaultValue: "Policy id is required"
    }),
    ERROR_POLICY_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_ID_INVALID_FORMAT", {
      defaultValue: "Policy id is not in a correct format"
    }),
    ERROR_POLICY_NOT_FOUND: trads_default.t("notification.error.ERROR_POLICY_NOT_FOUND", {
      defaultValue: "Policy not found"
    }),
    ERROR_VEHICLES_ID_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLES_ID_INVALID_ARRAY", {
      defaultValue: "Vehicles ids is not in a correct format"
    }),
    ERROR_VEHICLES_ID_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLES_ID_REQUIRED", {
      defaultValue: "Vehicles id is required"
    }),
    ERROR_COMMENT_LENGTH_1_255: trads_default.t("notification.error.ERROR_COMMENT_LENGTH_1_255", {
      defaultValue: "Comment must be between 1 and 255 characters"
    }),
    ERROR_B2B_POLICY_STATUS: trads_default.t("notification.error.ERROR_B2B_POLICY_STATUS", {
      defaultValue: "Wrong Policy status"
    }),
    ERROR_TOO_OLD_POLICIES_TO_RETRACT: trads_default.t("notification.error.ERROR_TOO_OLD_POLICIES_TO_RETRACT", {
      defaultValue: "Policy is too old to retract"
    }),
    ERROR_WRONG_POLICY_DURATION: trads_default.t("notification.error.ERROR_WRONG_POLICY_DURATION", {
      defaultValue: "Policy duration is wrong"
    }),
    ERROR_B2B_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_B2B_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided b2b policy management parameters"
      }
    ),
    ERROR_B2C_CONTRACT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2C_CONTRACT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2c contract id"
    }),
    ERROR_B2C_CONTRACT_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_B2C_CONTRACT_DOES_NOT_EXIST", {
      defaultValue: "No B2C contract found for this package and partner"
    }),
    ERROR_CANCELLATION_REQUEST_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CANCELLATION_REQUEST_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided cancellation request object"
      }
    ),
    ERROR_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_POLICY_MANAGEMENT_PARAMETERS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided policy management parameters"
      }
    ),
    ERROR_POLICY_STATUS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_STATUS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy status"
    }),
    ERROR_POLICY_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_POLICY_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided policy type"
    }),
    ERROR_PROMO_CODES_REQUIRED: trads_default.t("notification.error.ERROR_PROMO_CODES_REQUIRED", {
      defaultValue: "Invalid format for provided promo codes"
    }),
    ERROR_PROMOTION_CODE_ID_REQUIRED_FOR_INSURANCE_CODE: trads_default.t(
      "notification.error.ERROR_PROMOTION_CODE_ID_REQUIRED_FOR_INSURANCE_CODE",
      {
        defaultValue: "Promotion code ID is required for insurance code products"
      }
    ),
    ERROR_RENEWABLE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RENEWABLE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided renewable"
    }),
    ERROR_RISK_SCORE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RISK_SCORE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided risk score"
    }),
    ERROR_USER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided user"
    }),
    ERROR_TERMINATION_REIMBURSEMENT_MODE_REQUIRED: trads_default.t(
      "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_REQUIRED",
      {
        defaultValue: "Termination reimbursement mode is required"
      }
    ),
    ERROR_TERMINATION_REIMBURSEMENT_MODE_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_TERMINATION_REIMBURSEMENT_MODE_INVALID_TYPE",
      {
        defaultValue: "Invalid type for provided termination reimbursement mode"
      }
    ),
    // B2B CONTRACTS
    ERROR_B2B_CONTRACT_NOT_VALID: trads_default.t("notification.error.ERROR_B2B_CONTRACT_NOT_VALID", {
      defaultValue: "Contract is not valid"
    }),
    CREATE_AMEND_ERROR: trads_default.t("notification.error.CREATE_AMEND_ERROR", {
      defaultValue: "Error creating amendment"
    }),
    ERROR_END_DATE_MUST_BE_AFTER_START_DATE: trads_default.t("notification.error.ERROR_END_DATE_MUST_BE_AFTER_START_DATE", {
      defaultValue: "End date must be after start date"
    }),
    ERROR_CONTRACT_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CONTRACT_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided contract object"
    }),
    // CONTRACTUAL DOCUMENTS
    ERROR_NAME_INVALID_LENGTH: trads_default.t("notification.error.ERROR_NAME_INVALID_LENGTH", {
      defaultValue: "Name must be between 2 and 50 characters"
    }),
    ERROR_CONTRACTUAL_DOCUMENT_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_CONTRACTUAL_DOCUMENT_DOES_NOT_EXIST", {
      defaultValue: "Contractual document does not exist"
    }),
    ERROR_EXPIRED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXPIRED_INVALID_FORMAT", {
      defaultValue: "Expired must be in a correct format"
    }),
    // COVREAGES
    ERROR_COVERAGES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COVERAGES_INVALID_FORMAT", {
      defaultValue: "Coverages must be in a correct format"
    }),
    ERROR_COVERAGES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COVERAGES_INVALID_ARRAY", {
      defaultValue: "Coverages must be an array"
    }),
    INVALID_TRAD_CODE: trads_default.t("notification.error.INVALID_TRAD_CODE", {
      defaultValue: "Invalid trad code"
    }),
    ERROR_INVALID_COVERAGE_CODE: trads_default.t("notification.error.ERROR_INVALID_COVERAGE_CODE", {
      defaultValue: "Invalid coverage code"
    }),
    // FLEETS
    ERROR_MISS_FLEET_NAME: trads_default.t("notification.error.ERROR_MISS_FLEET_NAME", {
      defaultValue: "Fleet name is required"
    }),
    ERROR_MISS_FLEET_ADDRESS: trads_default.t("notification.error.ERROR_MISS_FLEET_ADDRESS", {
      defaultValue: "Fleet address is required"
    }),
    ERROR_MISS_FLEET_ZIPCODE: trads_default.t("notification.error.ERROR_MISS_FLEET_ZIPCODE", {
      defaultValue: "Fleet zip code is required"
    }),
    ERROR_MISS_FLEET_CITY: trads_default.t("notification.error.ERROR_MISS_FLEET_CITY", {
      defaultValue: "Fleet city is required"
    }),
    ERROR_MISS_FLEET_EMAIL: trads_default.t("notification.error.ERROR_MISS_FLEET_EMAIL", {
      defaultValue: "Fleet email is required"
    }),
    ERROR_MISS_FLEET_PHONE: trads_default.t("notification.error.ERROR_MISS_FLEET_PHONE", {
      defaultValue: "Fleet phone number is required"
    }),
    ERROR_FLEET_ID_REQUIRED: trads_default.t("notification.error.ERROR_FLEET_ID_REQUIRED", {
      defaultValue: "Fleet id is required"
    }),
    ERROR_FLEET_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FLEET_ID_INVALID_FORMAT", {
      defaultValue: "Fleet id is not in a correct format"
    }),
    ERROR_FLEET_ID_INVALID: trads_default.t("notification.error.ERROR_FLEET_ID_INVALID", {
      defaultValue: "Fleet id is invalid"
    }),
    ERROR_VEHICLES_IDADDED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLES_IDADDED_INVALID_FORMAT", {
      defaultValue: "Vehicles id added is not in a correct format"
    }),
    ERROR_VEHICLES_IDADDED_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLES_IDADDED_INVALID_ARRAY", {
      defaultValue: "Vehicles id added is not an array"
    }),
    ERROR_VEHICLES_IDDELETED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLES_IDDELETED_INVALID_FORMAT", {
      defaultValue: "Vehicles id deleted is not in a correct format"
    }),
    ERROR_VEHICLES_IDDELETED_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLES_IDDELETED_INVALID_ARRAY", {
      defaultValue: "Vehicles id deleted is not an array"
    }),
    ERROR_VEHICLES_NOT_GROUP: trads_default.t("notification.error.ERROR_VEHICLES_NOT_GROUP", {
      defaultValue: "Vehicles are not in the group"
    }),
    // FRAUD WEIGHTS
    ERROR_LOW_MISSING: trads_default.t("notification.error.ERROR_LOW_MISSING", {
      defaultValue: "Low value not found"
    }),
    ERROR_LOW_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_LOW_LOWER_THAN_ZERO", {
      defaultValue: "Low value has to be between 0 and 1"
    }),
    ERROR_LOW_GREATER_THAN_ONE: trads_default.t("notification.error.ERROR_LOW_GREATER_THAN_ONE", {
      defaultValue: "Low value has to be between 0 and 1"
    }),
    ERROR_LOW_INVALID_NUMBER: trads_default.t("notification.error.ERROR_LOW_INVALID_NUMBER", {
      defaultValue: "Low value has to be a valid number"
    }),
    ERROR_MEDIUM_MISSING: trads_default.t("notification.error.ERROR_MEDIUM_MISSING", {
      defaultValue: "Medium value not found"
    }),
    ERROR_MEDIUM_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_MEDIUM_LOWER_THAN_ZERO", {
      defaultValue: "Medium value has to be between 0 and 1"
    }),
    ERROR_MEDIUM_GREATER_THAN_ONE: trads_default.t("notification.error.ERROR_MEDIUM_GREATER_THAN_ONE", {
      defaultValue: "Medium value has to be between 0 and 1"
    }),
    ERROR_MEDIUM_INVALID_NUMBER: trads_default.t("notification.error.ERROR_MEDIUM_INVALID_NUMBER", {
      defaultValue: "Medium value has to be a valid number"
    }),
    ERROR_MEDIUM_LOWER_THAN_LOW: trads_default.t("notification.error.ERROR_MEDIUM_LOWER_THAN_LOW", {
      defaultValue: "Medium value has to be a greater than low value"
    }),
    ERROR_HIGH_MISSING: trads_default.t("notification.error.ERROR_HIGH_MISSING", {
      defaultValue: "High value not found"
    }),
    ERROR_HIGH_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_HIGH_LOWER_THAN_ZERO", {
      defaultValue: "High value has to be between 0 and 1"
    }),
    ERROR_HIGH_GREATER_THAN_ONE: trads_default.t("notification.error.ERROR_HIGH_GREATER_THAN_ONE", {
      defaultValue: "High value has to be between 0 and 1"
    }),
    ERROR_HIGH_INVALID_NUMBER: trads_default.t("notification.error.ERROR_HIGH_INVALID_NUMBER", {
      defaultValue: "High value has to be a valid number"
    }),
    ERROR_HIGH_LOWER_THAN_MEDIUM: trads_default.t("notification.error.ERROR_HIGH_LOWER_THAN_MEDIUM", {
      defaultValue: "High value has to be a greater than medium value"
    }),
    NO_FRAUD_WEIGHT_FOUND: trads_default.t("notification.error.NO_FRAUD_WEIGHT_FOUND", {
      defaultValue: "Fraud weight not found"
    }),
    // GEOFENCING
    ERROR_LAT_REQUIRED: trads_default.t("notification.error.ERROR_LAT_REQUIRED", {
      defaultValue: "Latitude is required"
    }),
    ERROR_LONG_REQUIRED: trads_default.t("notification.error.ERROR_LONG_REQUIRED", {
      defaultValue: "Longitude is required"
    }),
    ERROR_DANGEROSITY_INVALID_TYPE: trads_default.t("notification.error.ERROR_DANGEROSITY_INVALID_TYPE", {
      defaultValue: "Dangerosity must be in a correct format"
    }),
    ERROR_LAT_DELTA_REQUIRED: trads_default.t("notification.error.ERROR_LAT_DELTA_REQUIRED", {
      defaultValue: "Latitude delta is required"
    }),
    ERROR_LAT_DELTA_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LAT_DELTA_INVALID_FORMAT", {
      defaultValue: "Latitude delta must be in a correct format"
    }),
    ERROR_LONG_DELTA_REQUIRED: trads_default.t("notification.error.ERROR_LONG_DELTA_REQUIRED", {
      defaultValue: "Longitude delta is required"
    }),
    ERROR_LONG_DELTA_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LONG_DELTA_INVALID_FORMAT", {
      defaultValue: "Longitude delta must be in a correct format"
    }),
    ERROR_LAT_DELTA_TOO_HIGH: trads_default.t("notification.error.ERROR_LAT_DELTA_TOO_HIGH", {
      defaultValue: "Latitude delta must be less than 0.2"
    }),
    ERROR_LONG_DELTA_TOO_HIGH: trads_default.t("notification.error.ERROR_LONG_DELTA_TOO_HIGH", {
      defaultValue: "Longitude delta must be less than 0.2"
    }),
    ERROR_ZONES_REQUIRED: trads_default.t("notification.error.ERROR_ZONES_REQUIRED", {
      defaultValue: "Zones are required"
    }),
    ERROR_ZONES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ZONES_INVALID_ARRAY", {
      defaultValue: "Zones must be an array"
    }),
    ERROR_LAT_LONG_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LAT_LONG_INVALID_FORMAT", {
      defaultValue: "Latitude and longitude must be in a correct format"
    }),
    // GROUP COMMISSIONS
    // INSURANCE CLAIMS
    ERROR_TO_BE_RECOVERED_AMOUNT_USER_REQUIRED: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_REQUIRED",
      {
        defaultValue: "To be recovered amount for user is required"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_USER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_INVALID_FORMAT",
      {
        defaultValue: "To be recovered amount for user must be in a correct format"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_USER_TOO_LOW: trads_default.t("notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_USER_TOO_LOW", {
      defaultValue: "To be recovered amount for user must be greater than 0"
    }),
    ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_REQUIRED: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_REQUIRED",
      {
        defaultValue: "To be recovered amount for partner is required"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "To be recovered amount for partner must be in a correct format"
      }
    ),
    ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_TOO_LOW: trads_default.t(
      "notification.error.ERROR_TO_BE_RECOVERED_AMOUNT_PARTNER_TOO_LOW",
      {
        defaultValue: "To be recovered amount for partner must be greater than 0"
      }
    ),
    ERROR_OCCURRENCE_PERIOD_START_REQUIRED: trads_default.t("notification.error.ERROR_OCCURRENCE_PERIOD_START_REQUIRED", {
      defaultValue: "Occurrence period start is required"
    }),
    ERROR_OCCURRENCE_PERIOD_START_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_FORMAT",
      {
        defaultValue: "Occurrence period start must be in a correct format"
      }
    ),
    ERROR_OCCURENCE_PERIOD_END_INVALID_DATE: trads_default.t("notification.error.ERROR_OCCURENCE_PERIOD_END_INVALID_DATE", {
      defaultValue: "Occurrence period end must be in a correct format"
    }),
    ERROR_OPENING_DATE_BEFORE_OCCURRENCE_END: trads_default.t("notification.error.ERROR_OPENING_DATE_BEFORE_OCCURRENCE_END", {
      defaultValue: "Opening date must be after occurrence end"
    }),
    ERROR_OCCURRENCE_PERIOD_START_INVALID_DATE: trads_default.t(
      "notification.error.ERROR_OCCURRENCE_PERIOD_START_INVALID_DATE",
      {
        defaultValue: "Occurrence period start must be in a correct format"
      }
    ),
    ERROR_PERIOD_START_GREATER_THAN_PERIOD_END: trads_default.t(
      "notification.error.ERROR_PERIOD_START_GREATER_THAN_PERIOD_END",
      {
        defaultValue: "Occurrence period start must be before the end"
      }
    ),
    ERROR_OCCURRENCE_PERIOD_END_REQUIRED: trads_default.t("notification.error.ERROR_OCCURRENCE_PERIOD_END_REQUIRED", {
      defaultValue: "Occurrence period end is required"
    }),
    ERROR_OCCURRENCE_PERIOD_END_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_FORMAT",
      {
        defaultValue: "Occurrence period end must be in a correct format"
      }
    ),
    ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_NUMBER: trads_default.t(
      "notification.error.ERROR_PERSONAL_LOCKING_SESSION_ID_INVALID_NUMBER",
      {
        defaultValue: "Personal locking session id must be in a correct format"
      }
    ),
    ERROR_PREMIUM_SUPPORT_INVALID: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_INVALID", {
      defaultValue: "Premium support type is invalid"
    }),
    ERROR_PREMIUM_SUPPORT_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_TYPE_REQUIRED", {
      defaultValue: "Premium support type is required"
    }),
    ERROR_IS_CULPRIT_KNOWN_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_FORMAT", {
      defaultValue: "Is culprit known must be in a correct format"
    }),
    ERROR_PERSONAL_LOCK_ID_INVALID_NUMBER: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_NUMBER", {
      defaultValue: "Personal lock id must be in a correct format"
    }),
    ERROR_AT_HOME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AT_HOME_INVALID_FORMAT", {
      defaultValue: "At home value must be in a correct format"
    }),
    ERROR_IS_BIKE_VAE_REQUIRED: trads_default.t("notification.error.ERROR_IS_BIKE_VAE_REQUIRED", {
      defaultValue: "Is bike vae value is required"
    }),
    ERROR_IS_BIKE_VAE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_BIKE_VAE_INVALID_FORMAT", {
      defaultValue: "Is bike vae value must be in a correct format"
    }),
    ERROR_IS_BATTERY_SAFE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_BATTERY_SAFE_INVALID_FORMAT", {
      defaultValue: "Is battery safe value must be in a correct format"
    }),
    ERROR_TO_BE_REIMBURSED_USER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TO_BE_REIMBURSED_USER_INVALID_FORMAT",
      {
        defaultValue: "To be recovered amount for user must be in a correct format"
      }
    ),
    ERROR_TO_BE_REIMBURSED_USER_TOO_LOW: trads_default.t("notification.error.ERROR_TO_BE_REIMBURSED_USER_TOO_LOW", {
      defaultValue: "To be recovered amount for user must be greater than 0"
    }),
    ERROR_TO_BE_REIMBURSED_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "To be recovered amount for partner must be in a correct format"
      }
    ),
    ERROR_TO_BE_REIMBURSED_PARTNER_TOO_LOW: trads_default.t("notification.error.ERROR_TO_BE_REIMBURSED_PARTNER_TOO_LOW", {
      defaultValue: "To be recovered amount for partner must be greater than 0"
    }),
    ERROR_FRANCHISE_AMOUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FRANCHISE_AMOUNT_INVALID_FORMAT", {
      defaultValue: "Franchise amount must be in a correct format"
    }),
    ERROR_FRANCHISE_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_FRANCHISE_AMOUNT_TOO_LOW", {
      defaultValue: "Franchise amount must be greater than 0"
    }),
    ERROR_CLAIM_PAID_USER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CLAIM_PAID_USER_INVALID_FORMAT", {
      defaultValue: "Claim paid user must be in a correct format"
    }),
    ERROR_CLAIM_PAID_USER_TOO_LOW: trads_default.t("notification.error.ERROR_CLAIM_PAID_USER_TOO_LOW", {
      defaultValue: "Claim paid user must be greater than 0"
    }),
    ERROR_CLAIM_PAID_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CLAIM_PAID_PARTNER_INVALID_FORMAT", {
      defaultValue: "Claim paid partner must be in a correct format"
    }),
    ERROR_CLAIM_PAID_PARTNER_TOO_LOW: trads_default.t("notification.error.ERROR_CLAIM_PAID_PARTNER_TOO_LOW", {
      defaultValue: "Claim paid partner must be greater than 0"
    }),
    ERROR_SUPPORT_CLAIM_AMOUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_INVALID_FORMAT", {
      defaultValue: "Support claim amount must be in a correct format"
    }),
    ERROR_SUPPORT_CLAIM_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_SUPPORT_CLAIM_AMOUNT_TOO_LOW", {
      defaultValue: "Support claim amount must be greater than 0"
    }),
    ERROR_BIKE_CLAIM_AMOUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_CLAIM_AMOUNT_INVALID_FORMAT", {
      defaultValue: "Bike claim amount must be in a correct format"
    }),
    ERROR_BIKE_CLAIM_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_BIKE_CLAIM_AMOUNT_TOO_LOW", {
      defaultValue: "Bike claim amount must be greater than 0"
    }),
    ERROR_FRANCHISE_PERCENTAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FRANCHISE_PERCENTAGE_INVALID_FORMAT", {
      defaultValue: "Franchise percentage must be in a correct format"
    }),
    ERROR_FRANCHISE_PERCENTAGE_TOO_LOW: trads_default.t("notification.error.ERROR_FRANCHISE_PERCENTAGE_TOO_LOW", {
      defaultValue: "Franchise percentage must be greater than 0"
    }),
    ERROR_PRICE_BEFORE_DEDUCTION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PRICE_BEFORE_DEDUCTION_INVALID_FORMAT",
      {
        defaultValue: "Price before deduction must be in a correct format"
      }
    ),
    ERROR_PRICE_BEFORE_DEDUCTION_TOO_LOW: trads_default.t("notification.error.ERROR_PRICE_BEFORE_DEDUCTION_TOO_LOW", {
      defaultValue: "Price before deduction must be greater than 0"
    }),
    ERROR_RECOVERED_AMOUNT_USER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_RECOVERED_AMOUNT_USER_INVALID_FORMAT",
      {
        defaultValue: "Recovered amount for user must be in a correct format"
      }
    ),
    ERROR_RECOVERED_AMOUNT_USER_TOO_LOW: trads_default.t("notification.error.ERROR_RECOVERED_AMOUNT_USER_TOO_LOW", {
      defaultValue: "Recovered amount for user must be greater than 0"
    }),
    ERROR_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "Recovered amount for partner must be in a correct format"
      }
    ),
    ERROR_RECOVERED_AMOUNT_PARTNER_TOO_LOW: trads_default.t("notification.error.ERROR_RECOVERED_AMOUNT_PARTNER_TOO_LOW", {
      defaultValue: "Recovered amount for partner must be greater than 0"
    }),
    ERROR_REAL_VALUE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REAL_VALUE_INVALID_FORMAT", {
      defaultValue: "Real value must be in a correct format"
    }),
    ERROR_REAL_VALUE_NEGATIVE: trads_default.t("notification.error.ERROR_REAL_VALUE_NEGATIVE", {
      defaultValue: "Real value must be at least 0"
    }),
    ERROR_ADDITIONAL_USER_AMOUNT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_INVALID_FORMAT",
      {
        defaultValue: "Additional user amount must be in a correct format for user"
      }
    ),
    ERROR_ADDITIONAL_USER_AMOUNT_NEGATIVE: trads_default.t("notification.error.ERROR_ADDITIONAL_USER_AMOUNT_NEGATIVE", {
      defaultValue: "Additional user amount must be at least 0"
    }),
    ERROR_ADDITIONAL_USER_AMOUNT_REASON_REQUIRED: trads_default.t(
      "notification.error.ERROR_ADDITIONAL_USER_AMOUNT_REASON_REQUIRED",
      {
        defaultValue: "Additional user amount reason is required"
      }
    ),
    ERROR_ADDITIONAL_PARTNER_AMOUNT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_INVALID_FORMAT",
      {
        defaultValue: "Additional partner amount must be in a correct format for partner"
      }
    ),
    ERROR_ADDITIONAL_PARTNER_AMOUNT_NEGATIVE: trads_default.t("notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_NEGATIVE", {
      defaultValue: "Additional partner amount must be at least 0"
    }),
    ERROR_ADDITIONAL_PARTNER_AMOUNT_REASON_REQUIRED: trads_default.t(
      "notification.error.ERROR_ADDITIONAL_PARTNER_AMOUNT_REASON_REQUIRED",
      {
        defaultValue: "Additional partner amount reason is required"
      }
    ),
    GROUP_BUT_B2B_PRODUCT_NOT_IDENTIFIED: trads_default.t("notification.error.GROUP_BUT_B2B_PRODUCT_NOT_IDENTIFIED", {
      defaultValue: "Group but b2b product not identified"
    }),
    ERROR_FIELD_TOUPDATE_REQUIRED: trads_default.t("notification.error.ERROR_FIELD_TOUPDATE_REQUIRED", {
      defaultValue: "Field to update is required"
    }),
    ERROR_FIXED_PARKING_LOCATION_CHECKED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_FIXED_PARKING_LOCATION_CHECKED_INVALID_FORMAT",
      {
        defaultValue: "Fixed parking location checked value must be in a correct format"
      }
    ),
    ERROR_HAS_USER_BEEN_CALLED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_HAS_USER_BEEN_CALLED_INVALID_FORMAT", {
      defaultValue: "Has user been called value must be in a correct format"
    }),
    ERROR_DECLARATION_CONSISTENT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DECLARATION_CONSISTENT_INVALID_FORMAT",
      {
        defaultValue: "Declaration consistent value must be in a correct format"
      }
    ),
    ERROR_HAS_SHOP_BEEN_CALLED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_HAS_SHOP_BEEN_CALLED_INVALID_FORMAT", {
      defaultValue: "Has shop been called value must be in a correct format"
    }),
    ERROR_HAS_PAST_CLAIMS_WITH_BATTERY_CHECKED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_HAS_PAST_CLAIMS_WITH_BATTERY_CHECKED_INVALID_FORMAT",
      {
        defaultValue: "Has past claims with battery checked value must be in a correct format"
      }
    ),
    ERROR_HAS_PLS_BEEN_VALIDATED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_HAS_PLS_BEEN_VALIDATED_INVALID_FORMAT",
      {
        defaultValue: "Has PLS been validated value must be in a correct format"
      }
    ),
    ERROR_IS_PLS_VALIDATED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_PLS_VALIDATED_INVALID_FORMAT", {
      defaultValue: "Is pls validated value must be in a correct format"
    }),
    ERROR_IS_DIRECT_REIMBURSEMENT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is direct reimbursement"
      }
    ),
    ERROR_CLAIM_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_CLAIM_DOES_NOT_EXIST", {
      defaultValue: "Claim does not exist"
    }),
    ERROR_NEED_PLS_BEEN_VALIDATED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided need PLS been validated"
      }
    ),
    ERROR_NEED_PLS_BEEN_VALIDATED_REQUIRED: trads_default.t("notification.error.ERROR_NEED_PLS_BEEN_VALIDATED_REQUIRED", {
      defaultValue: "Need PLS been validated is required"
    }),
    ERROR_UNIQ_ID_REQUIRED: trads_default.t("notification.error.ERROR_UNIQ_ID_REQUIRED", {
      defaultValue: "Uniq id is required"
    }),
    ERROR_UNKNOWN_UNIQ_ID: trads_default.t("notification.error.ERROR_UNKNOWN_UNIQ_ID", {
      defaultValue: "Unknown unique id"
    }),
    ERROR_FRANCHISE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FRANCHISE_INVALID_FORMAT", {
      defaultValue: "Franchise value must be in a correct format"
    }),
    ERROR_CLAIMS_IDS_REQUIRED: trads_default.t("notification.error.ERROR_CLAIMS_IDS_REQUIRED", {
      defaultValue: "Claims ids are required"
    }),
    ERROR_CLAIM_ID_INVALID_TYPE: trads_default.t("notification.error.ERROR_CLAIM_ID_INVALID_TYPE", {
      defaultValue: "Claim id must be in a correct format"
    }),
    ERROR_INVALID_CLAIM: trads_default.t("notification.error.ERROR_INVALID_CLAIM", {
      defaultValue: "Invalid claim"
    }),
    ERROR_PARTNER_CLAIMS_NOT_AN_ARRAY: trads_default.t("notification.error.ERROR_PARTNER_CLAIMS_NOT_AN_ARRAY", {
      defaultValue: "Partner claims ids must be an array"
    }),
    ERROR_AMOUNT_REQUIRED: trads_default.t("notification.error.ERROR_AMOUNT_REQUIRED", {
      defaultValue: "Amount is required"
    }),
    ERROR_AMOUNT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_AMOUNT_INVALID_FORMAT", {
      defaultValue: "Amount must be in a correct format"
    }),
    ERROR_LONG_INVALID_VALUE: trads_default.t("notification.error.ERROR_LONG_INVALID_VALUE", {
      defaultValue: "Long value must be in a correct format"
    }),
    ERROR_LAT_INVALID_VALUE: trads_default.t("notification.error.ERROR_LAT_INVALID_VALUE", {
      defaultValue: "Lat value must be in a correct format"
    }),
    ERROR_ADDRESS_INVALID_STRING: trads_default.t("notification.error.ERROR_ADDRESS_INVALID_STRING", {
      defaultValue: "Address must be in a correct format"
    }),
    ERROR_COVERAGE_CODE_INVALID_VALUE: trads_default.t("notification.error.ERROR_COVERAGE_CODE_INVALID_VALUE", {
      defaultValue: "Coverage code must be in a correct format"
    }),
    ERROR_DESCRIPTION_INVALID_STRING: trads_default.t("notification.error.ERROR_DESCRIPTION_INVALID_STRING", {
      defaultValue: "Description must be in a correct format"
    }),
    ERROR_PARK_LOCATION_INVALID_STRING: trads_default.t("notification.error.ERROR_PARK_LOCATION_INVALID_STRING", {
      defaultValue: "Park location must be in a correct format"
    }),
    ERROR_PREMIUM_SUPPORT_TYPE_INVALID_VALUE: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_TYPE_INVALID_VALUE", {
      defaultValue: "Premium support type must be in a correct format"
    }),
    ERROR_BIKE_ELEMENTS_INVALID_STRING: trads_default.t("notification.error.ERROR_BIKE_ELEMENTS_INVALID_STRING", {
      defaultValue: "Bike elements must be in a correct format"
    }),
    ERROR_IS_CULPRIT_KNOWN_INVALID_BOOLEAN: trads_default.t("notification.error.ERROR_IS_CULPRIT_KNOWN_INVALID_BOOLEAN", {
      defaultValue: "Is culprit known must be a boolean value"
    }),
    ERROR_OCCURED_AT_HOME_INVALID_BOOLEAN: trads_default.t("notification.error.ERROR_OCCURED_AT_HOME_INVALID_BOOLEAN", {
      defaultValue: "Occured at home must be a boolean value"
    }),
    ERROR_IS_BIKE_VAE_INVALID_BOOLEAN: trads_default.t("notification.error.ERROR_IS_BIKE_VAE_INVALID_BOOLEAN", {
      defaultValue: "Is bike vae must be a boolean value"
    }),
    ERROR_IS_BATTERY_SAFE_INVALID_BOOLEAN: trads_default.t("notification.error.ERROR_IS_BATTERY_SAFE_INVALID_BOOLEAN", {
      defaultValue: "Is battery safe must be a boolean value"
    }),
    IS_CULPRIT_KNOWN_NOT_GIVEN: trads_default.t("notification.error.IS_CULPRIT_KNOWN_NOT_GIVEN", {
      defaultValue: "Is culprit known must be provided for vandalism claim"
    }),
    ERROR_PREMIUM_SUPPORT_CLAIM_EXPECTED: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_EXPECTED", {
      defaultValue: "Premium support type must be provided for premium support claim"
    }),
    ERROR_PREMIUM_SUPPORT_CLAIM_UNEXPECTED: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_CLAIM_UNEXPECTED", {
      defaultValue: "Premium support type must not be provided for non premium support claim"
    }),
    ERROR_PHOTO_INVALID_TYPE: trads_default.t("notification.error.ERROR_PHOTO_INVALID_TYPE", {
      defaultValue: "Photo must be in a correct format"
    }),
    ERROR_AMOUNTS_INCONSISTENCIES: trads_default.t("notification.error.ERROR_AMOUNTS_INCONSISTENCIES", {
      defaultValue: "There is inconsistencies amongs amounts"
    }),
    ERROR_CLAIM_NOT_FOUND: trads_default.t("notification.error.ERROR_CLAIM_NOT_FOUND", {
      defaultValue: "Claim could not be found"
    }),
    ERROR_CLAIM_COVERAGE_STATUS_INVALID_TYPE: trads_default.t("notification.error.ERROR_CLAIM_COVERAGE_STATUS_INVALID_TYPE", {
      defaultValue: "Invalid type for claim coverage status"
    }),
    // MANAGEMENT PARAMETERS
    ERROR_CLAIM_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_TYPE_REQUIRED", {
      defaultValue: "Claim type is required"
    }),
    ERROR_CLAIM_TYPE_INVALID: trads_default.t("notification.error.ERROR_CLAIM_TYPE_INVALID", {
      defaultValue: "Invalid claim type"
    }),
    ERROR_REQUIRED_DOCUMENTS_REQUIRED: trads_default.t("notification.error.ERROR_REQUIRED_DOCUMENTS_REQUIRED", {
      defaultValue: "Required documents are required"
    }),
    ERROR_REQUIRED_DOCUMENTS_INVALID: trads_default.t("notification.error.ERROR_REQUIRED_DOCUMENTS_INVALID", {
      defaultValue: "Invalid required documents"
    }),
    ERROR_REQUIRED_AND_OPTIONAL_DOCUMENTS_OVERLAP: trads_default.t(
      "notification.error.ERROR_REQUIRED_AND_OPTIONAL_DOCUMENTS_OVERLAP",
      {
        defaultValue: "Required and optional documents overlap"
      }
    ),
    ERROR_REQUIRED_DOCUMENTS_MUST_BE_ARRAY: trads_default.t("notification.error.ERROR_REQUIRED_DOCUMENTS_MUST_BE_ARRAY", {
      defaultValue: "Required documents must be an array"
    }),
    ERROR_REQUIRED_DOCUMENT_TYPE_INVALID: trads_default.t("notification.error.ERROR_REQUIRED_DOCUMENT_TYPE_INVALID", {
      defaultValue: "Invalid required document type"
    }),
    ERROR_OPTIONAL_DOCUMENTS_REQUIRED: trads_default.t("notification.error.ERROR_OPTIONAL_DOCUMENTS_REQUIRED", {
      defaultValue: "Optional documents are required"
    }),
    ERROR_OPTIONAL_DOCUMENTS_MUST_BE_ARRAY: trads_default.t("notification.error.ERROR_OPTIONAL_DOCUMENTS_MUST_BE_ARRAY", {
      defaultValue: "Optional documents must be an array"
    }),
    ERROR_OPTIONAL_DOCUMENT_TYPE_INVALID: trads_default.t("notification.error.ERROR_OPTIONAL_DOCUMENT_TYPE_INVALID", {
      defaultValue: "Invalid optional document type"
    }),
    ERROR_PARTNER_ID_MUST_BE_A_NUMBER: trads_default.t("notification.error.ERROR_PARTNER_ID_MUST_BE_A_NUMBER", {
      defaultValue: "Invalid format for provided partner id"
    }),
    ERROR_PERSONAL_LOCK_REQUIRED: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_REQUIRED", {
      defaultValue: "Personal lock is required"
    }),
    ERROR_INSURED_VALUE_THRESHOLD_REQUIRED: trads_default.t("notification.error.ERROR_INSURED_VALUE_THRESHOLD_REQUIRED", {
      defaultValue: "Insured value threshold is required"
    }),
    ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_POSITIVE: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_POSITIVE",
      {
        defaultValue: "Insured value threshold must be positive"
      }
    ),
    ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_A_NUMBER: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_THRESHOLD_MUST_BE_A_NUMBER",
      {
        defaultValue: "Insured value threshold must be a number"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_REQUIRED: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_REQUIRED",
      {
        defaultValue: "Gross refundable amount threshold is required"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_POSITIVE: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_POSITIVE",
      {
        defaultValue: "Gross refundable amount threshold must be positive"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_A_NUMBER: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_MUST_BE_A_NUMBER",
      {
        defaultValue: "Gross refundable amount threshold must be a number"
      }
    ),
    ERROR_MANDATORY_OPS_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_MANDATORY_OPS_CHECKS_REQUIRED", {
      defaultValue: "Mandatory ops checks are required"
    }),
    ERROR_MANDATORY_OPS_CHECK_TYPE_INVALID: trads_default.t("notification.error.ERROR_MANDATORY_OPS_CHECK_TYPE_INVALID", {
      defaultValue: "Invalid mandatory ops check type"
    }),
    ERROR_MANDATORY_OPS_CHECKS_MUST_BE_ARRAY: trads_default.t("notification.error.ERROR_MANDATORY_OPS_CHECKS_MUST_BE_ARRAY", {
      defaultValue: "Mandatory ops checks must be an array"
    }),
    ERROR_INSURED_VALUE_OPS_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_REQUIRED", {
      defaultValue: "Insured value ops checks are required"
    }),
    ERROR_INSURED_VALUE_OPS_CHECK_TYPE_INVALID: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_OPS_CHECK_TYPE_INVALID",
      {
        defaultValue: "Invalid insured value ops check type"
      }
    ),
    ERROR_INSURED_VALUE_OPS_CHECKS_MUST_BE_ARRAY: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_MUST_BE_ARRAY",
      {
        defaultValue: "Insured value ops checks must be an array"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_REQUIRED: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_REQUIRED",
      {
        defaultValue: "Gross refundable amount ops checks are required"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECK_TYPE_INVALID: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECK_TYPE_INVALID",
      {
        defaultValue: "Invalid gross refundable amount ops check type"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_MUST_BE_ARRAY: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_MUST_BE_ARRAY",
      {
        defaultValue: "Gross refundable amount ops checks must be an array"
      }
    ),
    ERROR_FRAUD_OPS_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_FRAUD_OPS_CHECKS_REQUIRED", {
      defaultValue: "Fraud ops checks are required"
    }),
    ERROR_FRAUD_OPS_CHECKS_TYPE_INVALID: trads_default.t("notification.error.ERROR_FRAUD_OPS_CHECKS_TYPE_INVALID", {
      defaultValue: "Invalid fraud ops checks type"
    }),
    ERROR_FRAUD_OPS_CHECKS_MUST_BE_ARRAY: trads_default.t("notification.error.ERROR_FRAUD_OPS_CHECKS_MUST_BE_ARRAY", {
      defaultValue: "Fraud ops checks must be an array"
    }),
    ERROR_PLS_DURATION_REQUIRED: trads_default.t("notification.error.ERROR_PLS_DURATION_REQUIRED", {
      defaultValue: "PLS duration is required"
    }),
    ERROR_PLS_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PLS_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid PLS duration format"
    }),
    ERROR_DEPRIVATION_DURATION_REQUIRED: trads_default.t("notification.error.ERROR_DEPRIVATION_DURATION_REQUIRED", {
      defaultValue: "Deprivation duration is required"
    }),
    ERROR_DEPRIVATION_DURATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DEPRIVATION_DURATION_INVALID_FORMAT", {
      defaultValue: "Invalid deprivation duration format"
    }),
    ERROR_CONTRACT_TEMPLATE_REQUIRED: trads_default.t("notification.error.ERROR_CONTRACT_TEMPLATE_REQUIRED", {
      defaultValue: "Contract template is required"
    }),
    ERROR_MAIL_AT_CREATION_ID_REQUIRED: trads_default.t("notification.error.ERROR_MAIL_AT_CREATION_ID_REQUIRED", {
      defaultValue: "Mail at creation ID is required"
    }),
    ERROR_MAIL_AT_CREATION_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAIL_AT_CREATION_ID_INVALID_FORMAT", {
      defaultValue: "Invalid mail at creation ID format"
    }),
    ERROR_MAIL_AT_END_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAIL_AT_END_ID_INVALID_FORMAT", {
      defaultValue: "Invalid mail at end ID format"
    }),
    ERROR_MAIL_AT_END_UNPAID_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_MAIL_AT_END_UNPAID_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid mail at end unpaid ID format"
      }
    ),
    ERROR_DISPLAY_POLICY_INFORMATIONS_REQUIRED: trads_default.t(
      "notification.error.ERROR_DISPLAY_POLICY_INFORMATIONS_REQUIRED",
      {
        defaultValue: "Display policy informations is required"
      }
    ),
    ERROR_PLS_WITH_TOTAL_CLAIM_ALLOWED_REQUIRED: trads_default.t(
      "notification.error.ERROR_PLS_WITH_TOTAL_CLAIM_ALLOWED_REQUIRED",
      {
        defaultValue: "PLS with total claim allowed is required"
      }
    ),
    ERROR_PLS_ALLOWED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PLS_ALLOWED_INVALID_FORMAT", {
      defaultValue: "Invalid PLS allowed format"
    }),
    ERROR_ABANDONED_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ABANDONED_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided"
    }),
    ERROR_CLAIM_MANAGEMENT_PARAMETERS_ALREADY_EXISTS: trads_default.t(
      "notification.error.ERROR_CLAIM_MANAGEMENT_PARAMETERS_ALREADY_EXISTS",
      {
        defaultValue: "Claim management parameters already exist"
      }
    ),
    ERROR_DEPRIVATION_DURATION_IN_DAYS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DEPRIVATION_DURATION_IN_DAYS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided deprivation duration in days"
      }
    ),
    ERROR_IS_OPS_SUSPEND_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_OPS_SUSPEND_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is ops suspend allowed"
      }
    ),
    ERROR_IS_PLS_WITH_TOTAL_CLAIM_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PLS_WITH_TOTAL_CLAIM_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is pls with total claim allowed"
      }
    ),
    ERROR_IS_USER_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_USER_CANCEL_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is user cancel allowed"
      }
    ),
    ERROR_PARTNER_CANCEL_ALLOWED_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_CANCEL_ALLOWED_REQUIRED", {
      defaultValue: "Partner cancel allowed is required"
    }),
    ERROR_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided partner cancel allowed"
      }
    ),
    ERROR_PLS_DURATION_LIMIT_IN_DAYS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PLS_DURATION_LIMIT_IN_DAYS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided pls duration limit in days"
      }
    ),
    ERROR_SHOULD_DISPLAY_BIKE_INFORMATIONS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_DISPLAY_BIKE_INFORMATIONS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should display bike informations"
      }
    ),
    ERROR_SHOULD_DISPLAY_CONTRACT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_DISPLAY_CONTRACT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should display contract"
      }
    ),
    ERROR_SHOULD_DISPLAY_POLICY_INFORMATIONS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_DISPLAY_POLICY_INFORMATIONS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should display policy informations"
      }
    ),
    ERROR_SHOULD_DISPLAY_POLICY_PRICE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_DISPLAY_POLICY_PRICE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should display policy price"
      }
    ),
    ERROR_DISPLAY_BIKE_INFORMATIONS_REQUIRED: trads_default.t("notification.error.ERROR_DISPLAY_BIKE_INFORMATIONS_REQUIRED", {
      defaultValue: "No information about displaying bike informations provided"
    }),
    ERROR_DISPLAY_CONTRACT_REQUIRED: trads_default.t("notification.error.ERROR_DISPLAY_CONTRACT_REQUIRED", {
      defaultValue: "No information about displaying contract provided"
    }),
    ERROR_DISPLAY_POLICY_PRICE_REQUIRED: trads_default.t("notification.error.ERROR_DISPLAY_POLICY_PRICE_REQUIRED", {
      defaultValue: "No information about displaying policy price provided"
    }),
    ERROR_IS_USER_VEHICLE_OWNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_USER_VEHICLE_OWNER_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is user vehicle owner"
      }
    ),
    ERROR_DOCUMENT_PARAMETERS_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_DOCUMENT_PARAMETERS_ALREADY_EXISTS", {
      defaultValue: "Document parameters already exist"
    }),
    ERROR_ONE_TIME_BILLING_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ONE_TIME_BILLING_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided one-time billing"
    }),
    ERROR_ONE_TIME_BILLING_REQUIRED: trads_default.t("notification.error.ERROR_ONE_TIME_BILLING_REQUIRED", {
      defaultValue: "Billing is required"
    }),
    ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided amendment renew allowed days after end"
      }
    ),
    ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_REQUIRED: trads_default.t(
      "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_REQUIRED",
      {
        defaultValue: "Amendment renew allowed days after end is required"
      }
    ),
    ERROR_AMENDMENT_RENEW_NOT_ALLOWED: trads_default.t("notification.error.ERROR_AMENDMENT_RENEW_NOT_ALLOWED", {
      defaultValue: "Amendment or renew is not allowed for this policy"
    }),
    ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_MUST_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_AMENDMENT_RENEW_ALLOWED_DAYS_AFTER_END_MUST_0_AT_LEAST",
      {
        defaultValue: "Amendment renew allowed days after end must be at least 0"
      }
    ),
    ERROR_CLAIM_REIMBURSMENT_PARAMETERS_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_REIMBURSMENT_PARAMETERS_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided reimbursment parameters object"
      }
    ),
    ERROR_IS_APIC_CHECK_REQUIRED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_APIC_CHECK_REQUIRED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is APIC check required"
      }
    ),
    ERROR_IS_MARKING_CODE_CHECK_REQUIRED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_MARKING_CODE_CHECK_REQUIRED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is marking code check required"
      }
    ),
    ERROR_IS_PERSONAL_LOCK_REQUIRED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PERSONAL_LOCK_REQUIRED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is personal lock required"
      }
    ),
    ERROR_OPS_CHECK_PARAMETERS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OPS_CHECK_PARAMETERS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided ops check parameters"
    }),
    // PmpUpdateBodyDto messages
    ERROR_PLS_DURATION_MUST_A_NUMBER: trads_default.t("notification.error.ERROR_PLS_DURATION_MUST_A_NUMBER", {
      defaultValue: "PLS duration must be a number"
    }),
    ERROR_PLS_DURATION_MUST_0_AT_LEAST: trads_default.t("notification.error.ERROR_PLS_DURATION_MUST_0_AT_LEAST", {
      defaultValue: "PLS duration must be at least 0"
    }),
    ERROR_DEPRIVATION_DURATION_MUST_A_NUMBER: trads_default.t("notification.error.ERROR_DEPRIVATION_DURATION_MUST_A_NUMBER", {
      defaultValue: "Deprivation duration must be a number"
    }),
    ERROR_DEPRIVATION_DURATION_MUST_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_DEPRIVATION_DURATION_MUST_0_AT_LEAST",
      {
        defaultValue: "Deprivation duration must be at least 0"
      }
    ),
    ERROR_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid mail ID format"
    }),
    ERROR_EMPTY_BODY: trads_default.t("notification.error.ERROR_EMPTY_BODY", {
      defaultValue: "Empty body"
    }),
    // QmpCreateBodyDto messages
    ERROR_PACKAGE_ID_MUST_A_BE_NUMBER: trads_default.t("notification.error.ERROR_PACKAGE_ID_MUST_A_BE_NUMBER", {
      defaultValue: "Package ID must be a number"
    }),
    ERROR_OPTIONAL_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_OPTIONAL_CHECKS_REQUIRED", {
      defaultValue: "Optional checks are required"
    }),
    ERROR_NOT_OPTIONNAL_CHECK: trads_default.t("notification.error.ERROR_NOT_OPTIONNAL_CHECK", {
      defaultValue: "Not optional check"
    }),
    ERROR_OPTIONAL_CHECKS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_OPTIONAL_CHECKS_INVALID_ARRAY", {
      defaultValue: "Invalid optional checks array"
    }),
    ERROR_VEHICLE_OWNER_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_OWNER_REQUIRED", {
      defaultValue: "Vehicle owner is required"
    }),
    ERROR_VEHICLE_OWNER_NOT_BOOL: trads_default.t("notification.error.ERROR_VEHICLE_OWNER_NOT_BOOL", {
      defaultValue: "Vehicle owner must be a boolean"
    }),
    ERROR_MAIL_ID_MUST_BE_A_NUMBER: trads_default.t("notification.error.ERROR_MAIL_ID_MUST_BE_A_NUMBER", {
      defaultValue: "Mail ID must be a number"
    }),
    // B2bPmpUpdateBodyDto messages
    ERROR_DISPLAY_POLICY_INFORMATION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISPLAY_POLICY_INFORMATION_INVALID_FORMAT",
      {
        defaultValue: "Display policy information must be a boolean"
      }
    ),
    ERROR_DISPLAY_BIKE_INFORMATION_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISPLAY_BIKE_INFORMATION_INVALID_FORMAT",
      {
        defaultValue: "Display bike information must be a boolean"
      }
    ),
    ERROR_DISPLAY_AFFECTED_USER_DETAILS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISPLAY_AFFECTED_USER_DETAILS_INVALID_FORMAT",
      {
        defaultValue: "Display affected user details must be a boolean"
      }
    ),
    ERROR_CLIENT_BIKE_UPDATE_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLIENT_BIKE_UPDATE_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Client bike update allowed must be a boolean"
      }
    ),
    ERROR_CLIENT_ALLOWED_UPDATE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLIENT_ALLOWED_UPDATE_INVALID_FORMAT",
      {
        defaultValue: "Client allowed update must be a boolean"
      }
    ),
    ERROR_PARTNER_TERMINATE_PRIOR_TO_TWELVE_MONTH_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PARTNER_TERMINATE_PRIOR_TO_TWELVE_MONTH_INVALID_FORMAT",
      {
        defaultValue: "Partner terminate prior to twelve month must be a boolean"
      }
    ),
    ERROR_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Client cancel allowed must be a boolean"
      }
    ),
    ERROR_CREATE_CLAIM_CLIENT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CREATE_CLAIM_CLIENT_INVALID_FORMAT", {
      defaultValue: "Create claim client must be a boolean"
    }),
    ERROR_CREATE_CLAIM_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CREATE_CLAIM_PARTNER_INVALID_FORMAT", {
      defaultValue: "Create claim partner must be a boolean"
    }),
    ERROR_B2B_POLICY_UNAUTHORIZED_ACTION: trads_default.t("notification.error.ERROR_B2B_POLICY_UNAUTHORIZED_ACTION", {
      defaultValue: "Unauthorized action for B2B policy"
    }),
    ERROR_B2B_POLICY_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_B2B_POLICY_DOES_NOT_EXIST", {
      defaultValue: "B2B policy does not exist"
    }),
    ERROR_B2B_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST: trads_default.t(
      "notification.error.ERROR_B2B_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST",
      {
        defaultValue: "B2B policy cancel request does not exist"
      }
    ),
    ERROR_B2B_QUOTE_NOT_FOUND: trads_default.t("notification.error.ERROR_B2B_QUOTE_NOT_FOUND", {
      defaultValue: "B2B quote not found"
    }),
    ERROR_B2B_QUOTE_NOT_EDITABLE: trads_default.t("notification.error.ERROR_B2B_QUOTE_NOT_EDITABLE", {
      defaultValue: "B2B quote not editable"
    }),
    ERROR_THRESHOLD_MUST_A_BE_NUMBER: trads_default.t("notification.error.ERROR_THRESHOLD_MUST_A_BE_NUMBER", {
      defaultValue: "Threshold must be a number"
    }),
    ERROR_IDS_INVALID_TYPE: trads_default.t("notification.error.ERROR_IDS_INVALID_TYPE", {
      defaultValue: "Invalid IDs type"
    }),
    // ReimbursementCmpUpdateBodyDto messages
    ERROR_PARTNER_ESTIMATION_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_ESTIMATION_REQUIRED", {
      defaultValue: "Partner estimation is undefined"
    }),
    ERROR_PARTNER_ESTIMATIONS_RULE_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID_ARRAY",
      {
        defaultValue: "Invalid partner estimations rule array"
      }
    ),
    ERROR_PARTNER_ESTIMATION_VALUES_EMPTY: trads_default.t("notification.error.ERROR_PARTNER_ESTIMATION_VALUES_EMPTY", {
      defaultValue: "Partner estimation values are empty"
    }),
    ERROR_PARTNER_ESTIMATION_INVALID_TYPE: trads_default.t("notification.error.ERROR_PARTNER_ESTIMATION_INVALID_TYPE", {
      defaultValue: "Invalid partner estimation type"
    }),
    ERROR_USER_ESTIMATION_REQUIRED: trads_default.t("notification.error.ERROR_USER_ESTIMATION_REQUIRED", {
      defaultValue: "User estimation is undefined"
    }),
    ERROR_USER_ESTIMATIONS_RULE_INVALID_ARRAY: trads_default.t("notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID_ARRAY", {
      defaultValue: "Invalid user estimations rule array"
    }),
    ERROR_USER_ESTIMATION_VALUES_EMPTY: trads_default.t("notification.error.ERROR_USER_ESTIMATION_VALUES_EMPTY", {
      defaultValue: "User estimation values are empty"
    }),
    ERROR_USER_ESTIMATION_INVALID_TYPE: trads_default.t("notification.error.ERROR_USER_ESTIMATION_INVALID_TYPE", {
      defaultValue: "Invalid user estimation type"
    }),
    ERROR_FRANCHISE_RULE_REQUIRED: trads_default.t("notification.error.ERROR_FRANCHISE_RULE_REQUIRED", {
      defaultValue: "Franchise rule is undefined"
    }),
    ERROR_FRANCHISE_RULE_INVALID_ARRAY: trads_default.t("notification.error.ERROR_FRANCHISE_RULE_INVALID_ARRAY", {
      defaultValue: "Invalid franchise rule array"
    }),
    ERROR_FRANCHISE_RULE_VALUES_EMPTY: trads_default.t("notification.error.ERROR_FRANCHISE_RULE_VALUES_EMPTY", {
      defaultValue: "Franchise rule values are empty"
    }),
    ERROR_FRANCHISE_RULE_INVALID_TYPE: trads_default.t("notification.error.ERROR_FRANCHISE_RULE_INVALID_TYPE", {
      defaultValue: "Invalid franchise rule type"
    }),
    ERROR_PARTNER_REIMBURSEMENT_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_REIMBURSEMENT_REQUIRED", {
      defaultValue: "Partner reimbursement is undefined"
    }),
    ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID_ARRAY",
      {
        defaultValue: "Invalid partner reimbursement rule array"
      }
    ),
    ERROR_PARTNER_REIMBURSEMENT_VALUES_EMPTY: trads_default.t("notification.error.ERROR_PARTNER_REIMBURSEMENT_VALUES_EMPTY", {
      defaultValue: "Partner reimbursement values are empty"
    }),
    ERROR_PARTNER_REIMBURSEMENT_INVALID_TYPE: trads_default.t("notification.error.ERROR_PARTNER_REIMBURSEMENT_INVALID_TYPE", {
      defaultValue: "Invalid partner reimbursement type"
    }),
    ERROR_CLIENT_REIMBURSEMENT_REQUIRED: trads_default.t("notification.error.ERROR_CLIENT_REIMBURSEMENT_REQUIRED", {
      defaultValue: "User reimbursement is undefined"
    }),
    ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID_ARRAY",
      {
        defaultValue: "Invalid client reimbursement rule array"
      }
    ),
    ERROR_CLIENT_REIMBURSEMENT_INVALID_TYPE: trads_default.t("notification.error.ERROR_CLIENT_REIMBURSEMENT_INVALID_TYPE", {
      defaultValue: "Invalid user reimbursement type"
    }),
    ERROR_CLAIM_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_CLAIM_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid claim type"
    }),
    ERROR_CLAIM_USER_NOT_FOUND: trads_default.t("notification.error.ERROR_CLAIM_USER_NOT_FOUND", {
      defaultValue: "Could not find given user"
    }),
    // ReimbursementParametersDto messages
    ERROR_WITH_PLS_REQUIRED: trads_default.t("notification.error.ERROR_WITH_PLS_REQUIRED", {
      defaultValue: "With PLS is undefined"
    }),
    ERROR_WITH_PLS_INVALID_TYPE: trads_default.t("notification.error.ERROR_WITH_PLS_INVALID_TYPE", {
      defaultValue: "Invalid with PLS type"
    }),
    ERROR_HAS_BATTERY_REQUIRED: trads_default.t("notification.error.ERROR_HAS_BATTERY_REQUIRED", {
      defaultValue: "Has battery is undefined"
    }),
    ERROR_HAS_BATTERY_INVALID_TYPE: trads_default.t("notification.error.ERROR_HAS_BATTERY_INVALID_TYPE", {
      defaultValue: "Invalid has battery type"
    }),
    ERROR_BIKE_MODEL_MUST_BE_A_NUMBER: trads_default.t("notification.error.ERROR_BIKE_MODEL_MUST_BE_A_NUMBER", {
      defaultValue: "Bike model must be a number"
    }),
    ERROR_PARTNER_ESTIMATIONS_RULE_INVALID: trads_default.t("notification.error.ERROR_PARTNER_ESTIMATIONS_RULE_INVALID", {
      defaultValue: "Invalid partner estimations rule"
    }),
    ERROR_USER_ESTIMATIONS_RULE_INVALID: trads_default.t("notification.error.ERROR_USER_ESTIMATIONS_RULE_INVALID", {
      defaultValue: "Invalid user estimations rule"
    }),
    ERROR_FRANCHISE_RULE_INVALID: trads_default.t("notification.error.ERROR_FRANCHISE_RULE_INVALID", {
      defaultValue: "Invalid franchise rule"
    }),
    ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID: trads_default.t("notification.error.ERROR_PARTNER_REIMBURSEMENT_RULE_INVALID", {
      defaultValue: "Invalid partner reimbursement rule"
    }),
    ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID: trads_default.t("notification.error.ERROR_CLIENT_REIMBURSEMENT_RULE_INVALID", {
      defaultValue: "Invalid client reimbursement rule"
    }),
    ERROR_CLIENT_REIMBURSEMENT_VALUES_EMPTY: trads_default.t("notification.error.ERROR_CLIENT_REIMBURSEMENT_VALUES_EMPTY", {
      defaultValue: "Provided client reimbursement rule is empty"
    }),
    // OpsChecksCmpUpdateBodyDto messages
    ERROR_MANDATORY_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_MANDATORY_CHECKS_REQUIRED", {
      defaultValue: "Mandatory checks are undefined"
    }),
    ERROR_MANDATORY_CHECKS_INVALID_TYPE: trads_default.t("notification.error.ERROR_MANDATORY_CHECKS_INVALID_TYPE", {
      defaultValue: "Invalid mandatory checks type"
    }),
    ERROR_MANDATORY_OPS_CHECKS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_MANDATORY_OPS_CHECKS_INVALID_ARRAY", {
      defaultValue: "Invalid mandatory ops checks array"
    }),
    ERROR_INSURED_VALUE_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_INSURED_VALUE_CHECKS_REQUIRED", {
      defaultValue: "Insured value checks are undefined"
    }),
    ERROR_INSURED_VALUE_CHECKS_INVALID_TYPE: trads_default.t("notification.error.ERROR_INSURED_VALUE_CHECKS_INVALID_TYPE", {
      defaultValue: "Invalid insured value checks type"
    }),
    ERROR_INSURED_VALUE_OPS_CHECKS_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_OPS_CHECKS_INVALID_ARRAY",
      {
        defaultValue: "Invalid insured value ops checks array"
      }
    ),
    ERROR_FRAUD_OPS_CHECKS_INVALID_TYPE: trads_default.t("notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_TYPE", {
      defaultValue: "Invalid fraud ops checks type"
    }),
    ERROR_FRAUD_OPS_CHECKS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_FRAUD_OPS_CHECKS_INVALID_ARRAY", {
      defaultValue: "Invalid fraud ops checks array"
    }),
    ERROR_VALUE_THRESHOLD_REQUIRED: trads_default.t("notification.error.ERROR_VALUE_THRESHOLD_REQUIRED", {
      defaultValue: "Value threshold is undefined"
    }),
    ERROR_VALUE_THRESHOLD_INVALID_TYPE: trads_default.t("notification.error.ERROR_VALUE_THRESHOLD_INVALID_TYPE", {
      defaultValue: "Invalid value threshold type"
    }),
    ERROR_VALUE_THRESHOLD_INVALID: trads_default.t("notification.error.ERROR_VALUE_THRESHOLD_INVALID", {
      defaultValue: "Invalid value threshold"
    }),
    ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID_TYPE",
      {
        defaultValue: "Invalid gross refundable amount threshold type"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_THRESHOLD_INVALID",
      {
        defaultValue: "Invalid gross refundable amount threshold"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_TYPE",
      {
        defaultValue: "Invalid gross refundable amount ops checks type"
      }
    ),
    ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_GROSS_REFUNDABLE_AMOUNT_OPS_CHECKS_INVALID_ARRAY",
      {
        defaultValue: "Invalid gross refundable amount ops checks array"
      }
    ),
    ERROR_REQUIRED_DOCS_REQUIRED: trads_default.t("notification.error.ERROR_REQUIRED_DOCS_REQUIRED", {
      defaultValue: "Required docs are undefined"
    }),
    ERROR_REQUIRED_DOCS_INVALID_TYPE: trads_default.t("notification.error.ERROR_REQUIRED_DOCS_INVALID_TYPE", {
      defaultValue: "Invalid required docs type"
    }),
    ERROR_REQUIRED_DOCS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_REQUIRED_DOCS_INVALID_ARRAY", {
      defaultValue: "Invalid required docs array"
    }),
    ERROR_OPTIONAL_DOCS_REQUIRED: trads_default.t("notification.error.ERROR_OPTIONAL_DOCS_REQUIRED", {
      defaultValue: "Optional docs are undefined"
    }),
    ERROR_OPTIONAL_DOCS_INVALID_TYPE: trads_default.t("notification.error.ERROR_OPTIONAL_DOCS_INVALID_TYPE", {
      defaultValue: "Invalid optional docs type"
    }),
    ERROR_OPTIONAL_DOCS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_OPTIONAL_DOCS_INVALID_ARRAY", {
      defaultValue: "Invalid optional docs array"
    }),
    // CmpUpdateBodyDto messages
    ERROR_LOCK_REQUIRED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LOCK_REQUIRED_INVALID_FORMAT", {
      defaultValue: "Invalid lock required format"
    }),
    ERROR_MARKING_CODE_REQUIRED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_MARKING_CODE_REQUIRED_INVALID_FORMAT",
      {
        defaultValue: "Invalid marking code required format"
      }
    ),
    ERROR_APIC_CHECK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_APIC_CHECK_INVALID_FORMAT", {
      defaultValue: "Invalid APIC check format"
    }),
    ERROR_IS_REPAIR_QUOTE_PARTIAL_CLAIM_REQUIRED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_REPAIR_QUOTE_PARTIAL_CLAIM_REQUIRED_INVALID_FORMAT",
      {
        defaultValue: "Invalid repaid quote format"
      }
    ),
    ERROR_REIMBURSEMENT_LIMIT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REIMBURSEMENT_LIMIT_INVALID_FORMAT", {
      defaultValue: "Invalid reimbursement limit format"
    }),
    ERROR_ALREADY_REIMBURSEMENT_CHECK_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ALREADY_REIMBURSEMENT_CHECK_INVALID_FORMAT",
      {
        defaultValue: "Invalid already reimbursement check format"
      }
    ),
    ERROR_NOTIFY_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NOTIFY_PARTNER_INVALID_FORMAT", {
      defaultValue: "Invalid notify partner format"
    }),
    ERROR_APPLY_FRAUD_TAG_INVALID_FORMAT: trads_default.t("notification.error.ERROR_APPLY_FRAUD_TAG_INVALID_FORMAT", {
      defaultValue: "Invalid apply fraud tag format"
    }),
    ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_INVALID_FORMAT",
      {
        defaultValue: "Invalid total terminate policy format"
      }
    ),
    ERROR_USER_NOTIFY_PARTNER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_NOTIFY_PARTNER_INVALID_FORMAT", {
      defaultValue: "Invalid user notify partner format"
    }),
    ERROR_CAN_USER_CREATE_CLAIM_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CAN_USER_CREATE_CLAIM_INVALID_FORMAT",
      {
        defaultValue: "Invalid can_user_create_claim format"
      }
    ),
    ERROR_CAN_USER_CREATE_CLAIM_REQUIRED: trads_default.t("notification.error.ERROR_CAN_USER_CREATE_CLAIM_REQUIRED", {
      defaultValue: "can_user_create_claim is required"
    }),
    ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_REQUIRED: trads_default.t(
      "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_REQUIRED",
      {
        defaultValue: "should_ask_for_reimbursement_type is required"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_INVALID_FORMAT",
      {
        defaultValue: "Invalid bike obsolescence start date in days format"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_DATE_IN_DAYS_0_AT_LEAST",
      {
        defaultValue: "Bike obsolescence start date in days must be at least 0"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BIKE_OBSO_PERCENTAGE_INVALID_FORMAT",
      {
        defaultValue: "Invalid bike obsolescence percentage per month format"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PER_MONTH_0_AT_LEAST",
      {
        defaultValue: "Bike obsolescence per month must be at least 0"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_INVALID_FORMAT",
      {
        defaultValue: "Invalid bike obsolescence percentage limit format"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_0_AT_LEAST",
      {
        defaultValue: "Bike obsolescence percentage must be at least 0"
      }
    ),
    ERROR_BIKE_OBSO_LIMIT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_OBSO_LIMIT_INVALID_FORMAT", {
      defaultValue: "Invalid bike obsolescence limit format"
    }),
    ERROR_BIKE_OBSOLESCENCE_LIMIT_0_AT_LEAST: trads_default.t("notification.error.ERROR_BIKE_OBSOLESCENCE_LIMIT_0_AT_LEAST", {
      defaultValue: "Bike obsolescence limit must be at least 0"
    }),
    ERROR_ALLOWED_PARTIAL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ALLOWED_PARTIAL_INVALID_FORMAT", {
      defaultValue: "Invalid allowed partial format"
    }),
    ERROR_BIKE_ALLOWED_PARTIAL_MIN_ONE_AT_LEAST: trads_default.t(
      "notification.error.ERROR_BIKE_ALLOWED_PARTIAL_MIN_ONE_AT_LEAST",
      {
        defaultValue: "Bike allowed partial must be at least -1"
      }
    ),
    ERROR_CREATION_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CREATION_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid creation mail ID format"
    }),
    ERROR_REJECTED_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REJECTED_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid rejected mail ID format"
    }),
    ERROR_ABANDON_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ABANDON_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid abandon mail ID format"
    }),
    ERROR_TO_PAY_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TO_PAY_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid to pay mail ID format"
    }),
    ERROR_VALIDATED_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VALIDATED_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid validated mail ID format"
    }),
    ERROR_PAID_MAIL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PAID_MAIL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid paid mail ID format"
    }),
    ERROR_PERSONAL_LOCK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided personal lock"
    }),
    ERROR_MARKING_CODE_CHECK_REQUIRED: trads_default.t("notification.error.ERROR_MARKING_CODE_CHECK_REQUIRED", {
      defaultValue: "Marking code check is required"
    }),
    ERROR_MARKING_CODE_CHECK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MARKING_CODE_CHECK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided marking code check"
    }),
    ERROR_APIC_CHECK_REQUIRED: trads_default.t("notification.error.ERROR_APIC_CHECK_REQUIRED", {
      defaultValue: "Apic check is required"
    }),
    ERROR_REPAIR_QUOTE_REQUIRED: trads_default.t("notification.error.ERROR_REPAIR_QUOTE_REQUIRED", {
      defaultValue: "Repair quote is required"
    }),
    ERROR_ALL_OBSOLESCENCE_SETTINGS_REQUIRED: trads_default.t("notification.error.ERROR_ALL_OBSOLESCENCE_SETTINGS_REQUIRED", {
      defaultValue: "All obsolescence settings are required"
    }),
    ERROR_BIKE_OBSOLESCENCE_START_MUST_BE_POSITIVE: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_MUST_BE_POSITIVE",
      {
        defaultValue: "Bike obsolescence start must be positive"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_START_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided bike obsolescence start"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_POSITIVE: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_POSITIVE",
      {
        defaultValue: "Bike obsolescence percentage per month must be positive"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_OR_EQUAL_TO_100: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_PER_MONTH_MUST_BE_LESS_OR_EQUAL_TO_100",
      {
        defaultValue: "Bike obsolescence percentage per month must be less than 100"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_POSITIVE: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_POSITIVE",
      {
        defaultValue: "Bike obsolescence percentage limit must be positive"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_OR_EQUAL_TO_100: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_MUST_BE_LESS_OR_EQUAL_TO_100",
      {
        defaultValue: "Bike obsolescence percentage limit must be less than 100"
      }
    ),
    ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_REQUIRED: trads_default.t(
      "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_REQUIRED",
      {
        defaultValue: "Partial claim allowed count is required"
      }
    ),
    ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided partial claim allowed count"
      }
    ),
    ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_ASK_FOR_REIMBURSEMENT_TYPE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should ask for reimbursement type"
      }
    ),
    ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_REQUIRED: trads_default.t(
      "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_REQUIRED",
      {
        defaultValue: "Should limit reimbursement to insured value is required"
      }
    ),
    ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_LIMIT_REIMBURSEMENT_TO_INSURED_VALUE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should limit reimbursement to insured value"
      }
    ),
    ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_REQUIRED: trads_default.t(
      "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_REQUIRED",
      {
        defaultValue: "Should check already reimbursed amounts is required"
      }
    ),
    ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_CHECK_ALREADY_REIMBURSED_AMOUNTS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should check already reimbursed amounts"
      }
    ),
    ERROR_SHOULD_NOTIFY_PARTNER_REQUIRED: trads_default.t("notification.error.ERROR_SHOULD_NOTIFY_PARTNER_REQUIRED", {
      defaultValue: "Should notify partner is required"
    }),
    ERROR_SHOULD_NOTIFY_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_NOTIFY_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should notify partner"
      }
    ),
    ERROR_SHOULD_APPLY_FRAUD_TAG_REQUIRED: trads_default.t("notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_REQUIRED", {
      defaultValue: "Should apply fraud tag is required"
    }),
    ERROR_SHOULD_APPLY_FRAUD_TAG_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_APPLY_FRAUD_TAG_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should apply fraud tag"
      }
    ),
    ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_REQUIRED: trads_default.t(
      "notification.error.ERROR_SHOULD_TOTAL_PAID_TERMINATE_POLICY_REQUIRED",
      {
        defaultValue: "Should total paid terminate policy is required"
      }
    ),
    ERROR_SHOULD_USER_NOTIFY_PARTNER_REQUIRED: trads_default.t("notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_REQUIRED", {
      defaultValue: "Should user notify partner is required"
    }),
    ERROR_SHOULD_USER_NOTIFY_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_USER_NOTIFY_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided should user notify partner"
      }
    ),
    ERROR_CLAIM_CREATION_MAIL_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_CREATION_MAIL_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided claim creation mail id"
      }
    ),
    ERROR_VALIDATED_ON_QUOTE_MAIL_ID_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_VALIDATED_ON_QUOTE_MAIL_ID_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided validated on quote mail id"
      }
    ),
    ERROR_DOCUMENT_PARAMETERS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided document parameters"
    }),
    ERROR_DOCUMENT_PARAMETERS_INVALID_OBJECT: trads_default.t("notification.error.ERROR_DOCUMENT_PARAMETERS_INVALID_OBJECT", {
      defaultValue: "Invalid object for provided document parameters"
    }),
    ERROR_OPS_CHECKS_PARAMETERS_INVALID_OBJECT: trads_default.t(
      "notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_OBJECT",
      {
        defaultValue: "Invalid object for provided ops checks parameters"
      }
    ),
    ERROR_REIMBURSEMENT_PARAMETERS_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_ARRAY",
      {
        defaultValue: "Invalid array for provided reimbursement parameters"
      }
    ),
    ERROR_REIMBURSEMENT_PARAMETERS_INVALID_OBJECT: trads_default.t(
      "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_INVALID_OBJECT",
      {
        defaultValue: "Invalid object for provided reimbursement parameters"
      }
    ),
    ERROR_DOCS_ID_REQUIRED: trads_default.t("notification.error.ERROR_DOCS_ID_REQUIRED", {
      defaultValue: "No docs id provided"
    }),
    ERROR_DOCS_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCS_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided docs id"
    }),
    ERROR_CHECKS_ID_REQUIRED: trads_default.t("notification.error.ERROR_CHECKS_ID_REQUIRED", {
      defaultValue: "No checks id provided"
    }),
    ERROR_CHECKS_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CHECKS_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided checks id"
    }),
    ERROR_REIMBURSEMENT_ID_REQUIRED: trads_default.t("notification.error.ERROR_REIMBURSEMENT_ID_REQUIRED", {
      defaultValue: "No reimbursement id provided"
    }),
    ERROR_REIMBURSEMENT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REIMBURSEMENT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided reimbursement id"
    }),
    ERROR_REIMBURSEMENT_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_REIMBURSEMENT_TYPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided reimbursement type"
    }),
    REIMBURSEMENT_TYPE_REQUIRED: trads_default.t("notification.error.REIMBURSEMENT_TYPE_REQUIRED", {
      defaultValue: "Reimbursement type is required"
    }),
    // PACKAGES
    ERROR_PACKAGE_REQUIRED: trads_default.t("notification.error.ERROR_PACKAGE_REQUIRED", {
      defaultValue: "No package provided"
    }),
    ERROR_INSURED_VALUE_THRESHOLD_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID_TYPE",
      {
        defaultValue: "Invalid type for provided insured value threshold"
      }
    ),
    ERROR_INSURED_VALUE_THRESHOLD_INVALID: trads_default.t("notification.error.ERROR_INSURED_VALUE_THRESHOLD_INVALID", {
      defaultValue: "Invalid insured value threshold"
    }),
    ERROR_ACCESSORY_STEPS_REQUIRED: trads_default.t("notification.error.ERROR_ACCESSORY_STEPS_REQUIRED", {
      defaultValue: "No acessory steps provided"
    }),
    ERROR_ACCESSORY_STEPS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_ACCESSORY_STEPS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided accessory steps"
    }),
    ERROR_ACCESSORY_STEPS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ACCESSORY_STEPS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided accessory steps"
    }),
    ERROR_COVERAGES_EMPTY: trads_default.t("notification.error.ERROR_COVERAGES_EMPTY", {
      defaultValue: "Provided coverages array is empty"
    }),
    ERROR_COVERAGES_REQUIRED: trads_default.t("notification.error.ERROR_COVERAGES_REQUIRED", {
      defaultValue: "No coverages provided"
    }),
    ERROR_COVERAGE_PRICING_RULE_DEFINITION_REQUIRED: trads_default.t(
      "notification.error.ERROR_COVERAGE_PRICING_RULE_DEFINITION_REQUIRED",
      {
        defaultValue: "No coverage pricing rule definition provided"
      }
    ),
    ERROR_FAVORITE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FAVORITE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided favorite"
    }),
    ERROR_IS_ACTIVE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_ACTIVE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is_active"
    }),
    // PARTNER INVOICES
    ERROR_PARTNER_INVOICE_ID_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_INVOICE_ID_REQUIRED", {
      defaultValue: "Partner invoice id is required"
    }),
    ERROR_PARTNER_INVOICE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_INVOICE_ID_INVALID_FORMAT", {
      defaultValue: "Partner invoice id has to be a valid number"
    }),
    ERROR_PARTNER_INVOICES_STATUS_REQUIRED: trads_default.t("notification.error.ERROR_PARTNER_INVOICES_STATUS_REQUIRED", {
      defaultValue: "Partner invoice status is required"
    }),
    ERROR_NO_RECEIPTS_CREATED: trads_default.t("notification.error.ERROR_NO_RECEIPTS_CREATED", {
      defaultValue: "No receipts found with status ISSUED or EMITTED"
    }),
    ERROR_PARTNER_INVOICE_RECEIPTS_NOT_ALLOWED: trads_default.t(
      "notification.error.ERROR_PARTNER_INVOICE_RECEIPTS_NOT_ALLOWED",
      {
        defaultValue: "Receipts cannot be added while the partner invoice is paid, sent, cancelled, or void; only draft (created) invoices can be updated."
      }
    ),
    ERROR_INVALID_STATUS: trads_default.t("notification.error.ERROR_INVALID_STATUS", {
      defaultValue: "Invalid partner invoice status"
    }),
    ERROR_PARTNER_INVOICE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PARTNER_INVOICE_DOES_NOT_EXIST", {
      defaultValue: "Partner invoice does not exist"
    }),
    ERROR_INVALID_PARTNER_INVOICE_STATUS: trads_default.t("notification.error.ERROR_INVALID_PARTNER_INVOICE_STATUS", {
      defaultValue: "Partner invoice status does not allow this action"
    }),
    ERROR_PARTNER_INVOICE_DOCUMENT_NOT_FOUND: trads_default.t("notification.error.ERROR_PARTNER_INVOICE_DOCUMENT_NOT_FOUND", {
      defaultValue: "Partner invoice document was not found"
    }),
    ERROR_PARTNER_INVOICE_EXPORT_NOT_FOUND: trads_default.t("notification.error.ERROR_PARTNER_INVOICE_EXPORT_NOT_FOUND", {
      defaultValue: "Partner invoice export was not found"
    }),
    ERROR_B2B2C_PARTNER_INVOICE_STRIPE_MODE_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_B2B2C_PARTNER_INVOICE_STRIPE_MODE_INVALID_TYPE",
      {
        defaultValue: "Invalid B2B2C partner invoice Stripe mode"
      }
    ),
    ERROR_SEND_EMAIL_INVALID_TYPE: trads_default.t("notification.error.ERROR_SEND_EMAIL_INVALID_TYPE", {
      defaultValue: "Invalid format for provided send_email"
    }),
    // PDF
    // PERSONAL LOCKING-SESSIONS
    ERROR_URI_REQUIRED: trads_default.t("notification.error.ERROR_URI_REQUIRED", {
      defaultValue: "No uri provided"
    }),
    ERROR_URI_INVALID_FORMAT: trads_default.t("notification.error.ERROR_URI_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided uri"
    }),
    ERROR_PATH_REQUIRED: trads_default.t("notification.error.ERROR_PATH_REQUIRED", {
      defaultValue: "No path provided"
    }),
    ERROR_PATH_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PATH_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided path"
    }),
    ERROR_BUFFER_REQUIRED: trads_default.t("notification.error.ERROR_BUFFER_REQUIRED", {
      defaultValue: "No buffer provided"
    }),
    ERROR_MIMETYPE_REQUIRED: trads_default.t("notification.error.ERROR_MIMETYPE_REQUIRED", {
      defaultValue: "No mimetype provided"
    }),
    ERROR_MIMETYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIMETYPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided mimetype"
    }),
    ERROR_MIMETYPE_INVALID_EXTENSION: trads_default.t("notification.error.ERROR_MIMETYPE_INVALID_EXTENSION", {
      defaultValue: "Invalid mimetype extension"
    }),
    ERROR_START_PICTURE_REQUIRED: trads_default.t("notification.error.ERROR_START_PICTURE_REQUIRED", {
      defaultValue: "Start picture is required"
    }),
    ERROR_FEEDBACK_REQUIRED: trads_default.t("notification.error.ERROR_FEEDBACK_REQUIRED", {
      defaultValue: "Feedback is required"
    }),
    ERROR_FEEDBACK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FEEDBACK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided feedback"
    }),
    ERROR_FILE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FILE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided file"
    }),
    ERROR_FILE_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_FILE_TYPE_REQUIRED", {
      defaultValue: "No file type provided"
    }),
    ERROR_MISSING_BATTERY_FEEDBACK: trads_default.t("notification.error.ERROR_MISSING_BATTERY_FEEDBACK", {
      defaultValue: "No battery feedback provided"
    }),
    // PERSONAL LOCKS
    ERROR_PERSONAL_LOCK_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_DOES_NOT_EXIST", {
      defaultValue: "Provided personal lock does not exist"
    }),
    // POLICIES
    ERROR_POLICY_REQUIRED: trads_default.t("notification.error.ERROR_POLICY_REQUIRED", {
      defaultValue: "No policy provided"
    }),
    ERROR_POLICY_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_POLICY_DOES_NOT_EXIST", {
      defaultValue: "Provided policy does not exist"
    }),
    CANNOT_CANCEL_ACTIVE_POLICY: trads_default.t("notification.error.CANNOT_CANCEL_ACTIVE_POLICY", {
      defaultValue: "Policy is not cancellable"
    }),
    ERROR_EXTERNAL_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXTERNAL_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided external id"
    }),
    ERROR_EXTERNAL_ID_TOO_LONG: trads_default.t("notification.error.ERROR_EXTERNAL_ID_TOO_LONG", {
      defaultValue: "Provided external id is too long"
    }),
    ERROR_COMMENT_TOO_LONG: trads_default.t("notification.error.ERROR_COMMENT_TOO_LONG", {
      defaultValue: "Provided comment is too long"
    }),
    // POLICIES CANCEL REQUEST
    ERROR_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST: trads_default.t(
      "notification.error.ERROR_POLICY_CANCEL_REQUEST_DOES_NOT_EXIST",
      {
        defaultValue: "Provided policy cancel request does not exist"
      }
    ),
    // PRICING
    ERROR_PRICE_WITHOUT_TAXES_REQUIRED: trads_default.t("notification.error.ERROR_PRICE_WITHOUT_TAXES_REQUIRED", {
      defaultValue: "No price without taxes provided"
    }),
    ERROR_PRICE_WITHOUT_TAXES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRICE_WITHOUT_TAXES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided price without taxes"
    }),
    ERROR_PRICE_WITH_TAXES_REQUIRED: trads_default.t("notification.error.ERROR_PRICE_WITH_TAXES_REQUIRED", {
      defaultValue: "No price with taxes provided"
    }),
    ERROR_PRICE_WITH_TAXES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRICE_WITH_TAXES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided price with taxes"
    }),
    ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_REQUIRED: trads_default.t(
      "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_REQUIRED",
      {
        defaultValue: "No discounted price without taxes provided"
      }
    ),
    ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISCOUNTED_PRICE_WITHOUT_TAXES_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided dicounted price without taxes"
      }
    ),
    ERROR_DISCOUNTED_PRICE_WITH_TAXES_REQUIRED: trads_default.t(
      "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_REQUIRED",
      {
        defaultValue: "No discounted price with taxes provided"
      }
    ),
    ERROR_DISCOUNTED_PRICE_WITH_TAXES_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISCOUNTED_PRICE_WITH_TAXES_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided discounted price with taxes"
      }
    ),
    ERROR_TECHNICAL_PREMIUM_REQUIRED: trads_default.t("notification.error.ERROR_TECHNICAL_PREMIUM_REQUIRED", {
      defaultValue: "No technical premium provided"
    }),
    ERROR_TECHNICAL_PREMIUM_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TECHNICAL_PREMIUM_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided technical premium"
    }),
    ERROR_COMMISSION_REQUIRED: trads_default.t("notification.error.ERROR_COMMISSION_REQUIRED", {
      defaultValue: "No commission provided"
    }),
    ERROR_COMMISSION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided commission"
    }),
    ERROR_SPLITTING_FEES_REQUIRED: trads_default.t("notification.error.ERROR_SPLITTING_FEES_REQUIRED", {
      defaultValue: "No splitting fees provided"
    }),
    ERROR_SPLITTING_FEES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SPLITTING_FEES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided splitting fees"
    }),
    ERROR_MANAGEMENT_FEES_REQUIRED: trads_default.t("notification.error.ERROR_MANAGEMENT_FEES_REQUIRED", {
      defaultValue: "No management fees provided"
    }),
    ERROR_MANAGEMENT_FEES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MANAGEMENT_FEES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided management fees"
    }),
    ERROR_TAXES_REQUIRED: trads_default.t("notification.error.ERROR_TAXES_REQUIRED", {
      defaultValue: "No taxes provided"
    }),
    ERROR_TAXES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TAXES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided taxes"
    }),
    ERROR_BROKER_FEES_REQUIRED: trads_default.t("notification.error.ERROR_BROKER_FEES_REQUIRED", {
      defaultValue: "No broker fees provided"
    }),
    ERROR_BROKER_FEES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BROKER_FEES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided broker fees"
    }),
    ERROR_INSURED_VALUE_REQUIRED: trads_default.t("notification.error.ERROR_INSURED_VALUE_REQUIRED", {
      defaultValue: "No insured value provided"
    }),
    ERROR_INSURED_VALUE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INSURED_VALUE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided insured value"
    }),
    ERROR_INVOICE_ID_MUST_NOT_BE_EMPTY: trads_default.t("notification.error.ERROR_INVOICE_ID_MUST_NOT_BE_EMPTY", {
      defaultValue: "Invoice id must not be empty"
    }),
    ERROR_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_AMOUNT_TOO_LOW", {
      defaultValue: "Amount must be greater than 0"
    }),
    ERROR_AMOUNT_MUST_BE_INTEGER: trads_default.t("notification.error.ERROR_AMOUNT_MUST_BE_INTEGER", {
      defaultValue: "Amount must be an integer"
    }),
    ERROR_IS_CANCEL_REQUIRED: trads_default.t("notification.error.ERROR_IS_CANCEL_REQUIRED", {
      defaultValue: "Is cancel is required"
    }),
    ERROR_INVALID_TERMINATION_DATE: trads_default.t("notification.error.ERROR_INVALID_TERMINATION_DATE", {
      defaultValue: "Termination date must be in a correct format"
    }),
    REASON_NOT_COMPATIBLE_WITH_TERMINATION_DATE: trads_default.t(
      "notification.error.REASON_NOT_COMPATIBLE_WITH_TERMINATION_DATE",
      {
        defaultValue: "Reason is not compatible with termination date"
      }
    ),
    ERROR_USER_BIRTHDAY_REQUIRED: trads_default.t("notification.error.ERROR_USER_BIRTHDAY_REQUIRED", {
      defaultValue: "User birthday is required"
    }),
    ERROR_USER_BIRTHDAYMILLIS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_USER_BIRTHDAYMILLIS_INVALID_FORMAT", {
      defaultValue: "User birthday millis must be in a correct format"
    }),
    ERROR_WRONG_DOCUMENT_TYPE: trads_default.t("notification.error.ERROR_WRONG_DOCUMENT_TYPE", {
      defaultValue: "Wrong document type"
    }),
    ERROR_DOCUMENT_TYPE_NOT_SUPPORTED: trads_default.t("notification.error.ERROR_DOCUMENT_TYPE_NOT_SUPPORTED", {
      defaultValue: "Document type not supported"
    }),
    ERROR_POLICY_EFFECTIVE_START_DATE_REQUIRED: trads_default.t(
      "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_REQUIRED",
      {
        defaultValue: "Policy effective start date is required"
      }
    ),
    ERROR_POLICY_EFFECTIVE_START_DATE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_POLICY_EFFECTIVE_START_DATE_INVALID_FORMAT",
      {
        defaultValue: "Policy effective start date must be in a correct format"
      }
    ),
    ERROR_PAST_EFFECTIVE_START_DATE: trads_default.t("notification.error.ERROR_PAST_EFFECTIVE_START_DATE", {
      defaultValue: "Policy effective start date must be in the future"
    }),
    ERROR_SERIAL_REQUIRED: trads_default.t("notification.error.ERROR_SERIAL_REQUIRED", {
      defaultValue: "Serial is required"
    }),
    ERROR_POLICY_TERMINATION_DATE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_POLICY_TERMINATION_DATE_INVALID_FORMAT",
      {
        defaultValue: "Policy termination date must be in a correct format"
      }
    ),
    ERROR_DATE_IN_THE_PAST: trads_default.t("notification.error.ERROR_DATE_IN_THE_PAST", {
      defaultValue: "Date must be in today or in the future"
    }),
    TERMINATION_DATE_NOT_BETWEEN_POLICY_DATES: trads_default.t("notification.error.TERMINATION_DATE_NOT_BETWEEN_POLICY_DATES", {
      defaultValue: "Termination date must be between policy dates"
    }),
    TERMINATION_DATE_NOT_ALLOWED_FOR_MONTHLY_SPLITTING: trads_default.t(
      "notification.error.TERMINATION_DATE_NOT_ALLOWED_FOR_MONTHLY_SPLITTING",
      {
        defaultValue: "Termination date is not allowed for monthly splitting"
      }
    ),
    ERROR_UNABLE_TO_ABORT_ACTIVE_POLICY: trads_default.t("notification.error.ERROR_UNABLE_TO_ABORT_ACTIVE_POLICY", {
      defaultValue: "Unable to abort active policy"
    }),
    ERROR_CANCEL_POLICY: trads_default.t("notification.error.ERROR_CANCEL_POLICY", {
      defaultValue: "Cannot cancel policy"
    }),
    ERROR_BIKE_PRICE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BIKE_PRICE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bike price"
    }),
    ERROR_BIKE_REQUIRED: trads_default.t("notification.error.ERROR_BIKE_REQUIRED", {
      defaultValue: "No bike provided"
    }),
    // POLICIES CANCEL REQUEST
    // PRICING
    ERROR_B2B_USAGE_TYPE: trads_default.t("notification.error.ERROR_B2B_USAGE_TYPE", {
      defaultValue: "B2b Usage must be in a correct type"
    }),
    ERROR_PROMOTION_CODE_REQUIRED: trads_default.t("notification.error.ERROR_PROMOTION_CODE_REQUIRED", {
      defaultValue: "Promotion code is required"
    }),
    ERROR_BIKE_PRICE_REQUIRED: trads_default.t("notification.error.ERROR_BIKE_PRICE_REQUIRED", {
      defaultValue: "Bike price is required"
    }),
    ERROR_CHOOSEN_PACKAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CHOOSEN_PACKAGE_INVALID_FORMAT", {
      defaultValue: "Choosen package must be in a correct format"
    }),
    NO_PACKAGE_CHOOSEN_YET: trads_default.t("notification.error.NO_PACKAGE_CHOOSEN_YET", {
      defaultValue: "No package choosen yet"
    }),
    // PRICING RULES
    ERROR_COVERAGE_PRICINGS_REQUIRED: trads_default.t("notification.error.ERROR_COVERAGE_PRICINGS_REQUIRED", {
      defaultValue: "No coverage pricing provided"
    }),
    ERROR_COVERAGE_PRICINGS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_INSURED_VALUE_REQUIRED", {
      defaultValue: "Invalid format for provided coverage pricings"
    }),
    ERROR_APPLY_ZONING_REQUIRED: trads_default.t("notification.error.ERROR_APPLY_ZONING_REQUIRED", {
      defaultValue: "No apply zoning provided"
    }),
    ERROR_APPLY_ZONING_INVALID_FORMAT: trads_default.t("notification.error.ERROR_APPLY_ZONING_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided apply zoning"
    }),
    ERROR_MIN_X_REQUIRED: trads_default.t("notification.error.ERROR_MIN_X_REQUIRED", {
      defaultValue: "No min x provided"
    }),
    ERROR_MIN_X_TOO_LOW: trads_default.t("notification.error.ERROR_MIN_X_TOO_LOW", {
      defaultValue: "Min x must be greater than or equal to 0"
    }),
    ERROR_MIN_X_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIN_X_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided min x"
    }),
    ERROR_MAX_X_TOO_LOW: trads_default.t("notification.error.ERROR_MAX_X_TOO_LOW", {
      defaultValue: "Max x must be greater than or equal to 0 and greater than min x"
    }),
    ERROR_MAX_X_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_X_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided max x"
    }),
    ERROR_TECHNICAL_PREMIUM_COEFFS_REQUIRED: trads_default.t("notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_REQUIRED", {
      defaultValue: "No technical premium coefficients provided"
    }),
    ERROR_TECHNICAL_PREMIUM_COEFFS_EMPTY: trads_default.t("notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_EMPTY", {
      defaultValue: "Technical premium coefficients cannot be empty"
    }),
    ERROR_TECHNICAL_PREMIUM_COEFFS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TECHNICAL_PREMIUM_COEFFS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided technical premium coefficients"
      }
    ),
    ERROR_TECHNICAL_PREMIUM_COEFFS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COMMISSION_COEFFS_REQUIRED", {
      defaultValue: "Technical premium coefficients must be an array"
    }),
    ERROR_SPLITTING_FEES_COEFFS_REQUIRED: trads_default.t("notification.error.ERROR_SPLITTING_FEES_COEFFS_REQUIRED", {
      defaultValue: "No splitting fees coefficients provided"
    }),
    ERROR_SPLITTING_FEES_COEFFS_EMPTY: trads_default.t("notification.error.ERROR_SPLITTING_FEES_COEFFS_EMPTY", {
      defaultValue: "Splitting fees coefficients cannot be empty"
    }),
    ERROR_SPLITTING_FEES_COEFFS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided splitting fees coefficients"
      }
    ),
    ERROR_SPLITTING_FEES_COEFFS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_SPLITTING_FEES_COEFFS_INVALID_ARRAY", {
      defaultValue: "Splitting fees coefficients must be an array"
    }),
    ERROR_COMMISSION_COEFFS_REQUIRED: trads_default.t("notification.error.ERROR_COMMISSION_COEFFS_REQUIRED", {
      defaultValue: "No commission coefficients provided"
    }),
    ERROR_COMMISSION_COEFFS_EMPTY: trads_default.t("notification.error.ERROR_COMMISSION_COEFFS_EMPTY", {
      defaultValue: "Commission coefficients cannot be empty"
    }),
    ERROR_COMMISSION_COEFFS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSION_COEFFS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided commission coefficients"
    }),
    ERROR_COMMISSION_COEFFS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COMMISSION_COEFFS_INVALID_ARRAY", {
      defaultValue: "Commission coefficients must be an array"
    }),
    ERROR_MANAGEMENT_FEES_COEFFS_REQUIRED: trads_default.t("notification.error.ERROR_MANAGEMENT_FEES_COEFFS_REQUIRED", {
      defaultValue: "No management fees coefficients provided"
    }),
    ERROR_MANAGEMENT_FEES_COEFFS_EMPTY: trads_default.t("notification.error.ERROR_MANAGEMENT_FEES_COEFFS_EMPTY", {
      defaultValue: "Management fees coefficients cannot be empty"
    }),
    ERROR_MANAGEMENT_FEES_COEFFS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided management fees coefficients"
      }
    ),
    ERROR_MANAGEMENT_FEES_COEFFS_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_MANAGEMENT_FEES_COEFFS_INVALID_ARRAY",
      {
        defaultValue: "Management fees coefficients must be an array"
      }
    ),
    ERROR_TAXE_RATE_REQUIRED: trads_default.t("notification.error.ERROR_TAXE_RATE_REQUIRED", {
      defaultValue: "No taxe rate provided"
    }),
    ERROR_TAXE_RATE_TOO_LOW: trads_default.t("notification.error.ERROR_TAXE_RATE_TOO_LOW", {
      defaultValue: "Taxe rate must be greater than or equal to 0"
    }),
    ERROR_TAXE_RATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TAXE_RATE_INVALID_FORMAT", {
      defaultValue: "Taxe rate must be in a correct format"
    }),
    ERROR_BROKER_FEES_COEFFS_REQUIRED: trads_default.t("notification.error.ERROR_BROKER_FEES_COEFFS_REQUIRED", {
      defaultValue: "No broker fees coefficients provided"
    }),
    ERROR_BROKER_FEES_COEFFS_EMPTY: trads_default.t("notification.error.ERROR_BROKER_FEES_COEFFS_EMPTY", {
      defaultValue: "Broker fees coefficients cannot be empty"
    }),
    ERROR_BROKER_FEES_COEFFS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided broker fees coefficients"
    }),
    ERROR_BROKER_FEES_COEFFS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_BROKER_FEES_COEFFS_INVALID_ARRAY", {
      defaultValue: "Broker fees coefficients must be an array"
    }),
    ERROR_COVERAGE_ID_REQUIRED: trads_default.t("notification.error.ERROR_COVERAGE_ID_REQUIRED", {
      defaultValue: "Coverage id is required"
    }),
    ERROR_COVERAGE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COVERAGE_ID_INVALID_FORMAT", {
      defaultValue: "Coverage id is not in a correct format"
    }),
    ERROR_PRICING_RULES_REQUIRED: trads_default.t("notification.error.ERROR_PRICING_RULES_REQUIRED", {
      defaultValue: "No pricing rules provided"
    }),
    ERROR_PRICING_RULES_EMPTY: trads_default.t("notification.error.ERROR_PRICING_RULES_EMPTY", {
      defaultValue: "Pricing rules cannot be empty"
    }),
    ERROR_PRICING_RULES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_PRICING_RULES_INVALID_ARRAY", {
      defaultValue: "Pricing rules must be an array"
    }),
    ERROR_PRICING_RULES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRICING_RULES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided pricing rules"
    }),
    ERROR_PRICING_RULES_INVALID_LENGTH: trads_default.t("notification.error.ERROR_PRICING_RULES_INVALID_LENGTH", {
      defaultValue: "Invalid length for provided pricing rules"
    }),
    ERROR_PRICE_NOT_DEFINED_FOR_INSURED_VALUE: trads_default.t("notification.error.ERROR_PRICE_NOT_DEFINED_FOR_INSURED_VALUE", {
      defaultValue: "No pricing available for the specified package/insured amount"
    }),
    ERROR_AVERAGE_PRICE_PERCENTAGE_REQUIRED: trads_default.t("notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_REQUIRED", {
      defaultValue: "No average price percentage provided"
    }),
    ERROR_AVERAGE_PRICE_PERCENTAGE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_AVERAGE_PRICE_PERCENTAGE_INVALID_FORMAT",
      {
        defaultValue: "Average price percentage is not in a correct format"
      }
    ),
    ERROR_B2B_CONTRACT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_CONTRACT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2b contract id"
    }),
    ERROR_COVERAGE_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COVERAGE_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided coverage object"
    }),
    ERROR_SPLITTING_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_SPLITTING_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided splitting type"
    }),
    // QUOTES
    ERROR_CLIENT_REQUIRED: trads_default.t("notification.error.ERROR_CLIENT_REQUIRED", {
      defaultValue: "No provided client"
    }),
    ERROR_PREMIUM_SPLITTING_INVALID_TYPE: trads_default.t("notification.error.ERROR_PREMIUM_SPLITTING_INVALID_TYPE", {
      defaultValue: "Invalid type for provided premium splitting"
    }),
    ERROR_DURATION_NOT_VALID: trads_default.t("notification.error.ERROR_DURATION_NOT_VALID", {
      defaultValue: "Provided duration is invalid"
    }),
    ERROR_DURATION_INVALID_FOR_ANNUAL: trads_default.t("notification.error.ERROR_DURATION_INVALID_FOR_ANNUAL", {
      defaultValue: "Invalid duration for annual splitting"
    }),
    ERROR_CALLBACK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CALLBACK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided callback"
    }),
    ERROR_MISSING_FIRSTNAME: trads_default.t("notification.error.ERROR_MISSING_FIRSTNAME", {
      defaultValue: "No firstname provided"
    }),
    ERROR_MISSING_LASTNAME: trads_default.t("notification.error.ERROR_MISSING_LASTNAME", {
      defaultValue: "No lastname provided"
    }),
    ERROR_ATTRIB_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ATTRIB_INVALID_FORMAT", {
      defaultValue: "invalid format for provided attrib"
    }),
    // RECEIPTS
    AMOUNT_GREATER_THAN_RECEIPTS_AMOUNT: trads_default.t("notification.error.AMOUNT_GREATER_THAN_RECEIPTS_AMOUNT", {
      defaultValue: "Refund amount is greater than receipt amount"
    }),
    AMOUNT_GREATER_THAN_TOTAL_RECEIPTS_AMOUNT: trads_default.t("notification.error.AMOUNT_GREATER_THAN_TOTAL_RECEIPTS_AMOUNT", {
      defaultValue: "Refund amount is greater than total receipt amount"
    }),
    NO_REFUNDABLE_AMOUNT_MATCHING_REQUESTED_AMOUNT: trads_default.t(
      "notification.error.NO_REFUNDABLE_AMOUNT_MATCHING_REQUESTED_AMOUNT",
      {
        defaultValue: "No refundable amount close to the requested amount matches the receipts"
      }
    ),
    ERROR_PARTNER_INVOICES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_INVOICES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner invoices"
    }),
    // B2B RECEIPTS
    ERROR_B2B_RECEIPTS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_RECEIPTS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided B2B receipts"
    }),
    ERROR_PAYMENT_STATUS_INVALID_TYPE: trads_default.t("notification.error.ERROR_PAYMENT_STATUS_INVALID_TYPE", {
      defaultValue: "Invalid type for provided payment status"
    }),
    // SCORING THRESHOLDS
    ERROR_LOW_REQUIRED: trads_default.t("notification.error.ERROR_LOW_REQUIRED", {
      defaultValue: "Low threshold is required"
    }),
    ERROR_LOW_GREATER_THAN_MAX: trads_default.t("notification.error.ERROR_LOW_GREATER_THAN_MAX", {
      defaultValue: "Low threshold has to be between 0 and 10000"
    }),
    ERROR_HIGH_REQUIRED: trads_default.t("notification.error.ERROR_HIGH_REQUIRED", {
      defaultValue: "High threshold is required"
    }),
    ERROR_HIGH_GREATER_THAN_MAX: trads_default.t("notification.error.ERROR_HIGH_GREATER_THAN_MAX", {
      defaultValue: "High threshold has to be between 0 and 10000"
    }),
    ERROR_HIGH_LOWER_THAN_LOW: trads_default.t("notification.error.ERROR_HIGH_LOWER_THAN_LOW", {
      defaultValue: "High threshold has to be greater than or equal to low threshold"
    }),
    ERROR_ENUM_SCORED_ENTITY_INVALID_TYPE: trads_default.t("notification.error.ERROR_ENUM_SCORED_ENTITY_INVALID_TYPE", {
      defaultValue: "Invalid format for provided scored entity"
    }),
    // SCORING REPARTITION
    ERROR_GREEN_PCT_MISSING: trads_default.t("notification.error.ERROR_GREEN_PCT_MISSING", {
      defaultValue: "Green percentage is required"
    }),
    ERROR_GREEN_PCT_INVALID_NUMBER: trads_default.t("notification.error.ERROR_GREEN_PCT_INVALID_NUMBER", {
      defaultValue: "Green percentage has to be a valid integer"
    }),
    ERROR_GREEN_PCT_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_GREEN_PCT_LOWER_THAN_ZERO", {
      defaultValue: "Green percentage has to be between 0 and 100"
    }),
    ERROR_GREEN_PCT_GREATER_THAN_HUNDRED: trads_default.t("notification.error.ERROR_GREEN_PCT_GREATER_THAN_HUNDRED", {
      defaultValue: "Green percentage has to be between 0 and 100"
    }),
    ERROR_RED_PCT_MISSING: trads_default.t("notification.error.ERROR_RED_PCT_MISSING", {
      defaultValue: "Red percentage is required"
    }),
    ERROR_RED_PCT_INVALID_NUMBER: trads_default.t("notification.error.ERROR_RED_PCT_INVALID_NUMBER", {
      defaultValue: "Red percentage has to be a valid integer"
    }),
    ERROR_RED_PCT_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_RED_PCT_LOWER_THAN_ZERO", {
      defaultValue: "Red percentage has to be between 0 and 100"
    }),
    ERROR_RED_PCT_GREATER_THAN_HUNDRED: trads_default.t("notification.error.ERROR_RED_PCT_GREATER_THAN_HUNDRED", {
      defaultValue: "Red percentage has to be between 0 and 100"
    }),
    ERROR_GREEN_PLUS_RED_OVER_HUNDRED: trads_default.t("notification.error.ERROR_GREEN_PLUS_RED_OVER_HUNDRED", {
      defaultValue: "Green and red percentages together cannot exceed 100"
    }),
    ERROR_VALUES_REQUIRED: trads_default.t("notification.error.ERROR_VALUES_REQUIRED", {
      defaultValue: "No values provided"
    }),
    ERROR_VALUES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VALUES_INVALID_ARRAY", {
      defaultValue: "Values must be an array"
    }),
    ERROR_VALUES_EMPTY: trads_default.t("notification.error.ERROR_VALUES_EMPTY", {
      defaultValue: "Values cannot be empty"
    }),
    ERROR_VALUES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VALUES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided values"
    }),
    ERROR_PACKAGES_REQUIRED: trads_default.t("notification.error.ERROR_PACKAGES_REQUIRED", {
      defaultValue: "No packages provided"
    }),
    ERROR_PACKAGES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_PACKAGES_INVALID_ARRAY", {
      defaultValue: "Packages must be an array"
    }),
    ERROR_PACKAGES_EMPTY: trads_default.t("notification.error.ERROR_PACKAGES_EMPTY", {
      defaultValue: "Packages cannot be empty"
    }),
    ERROR_PACKAGES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PACKAGES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided packages"
    }),
    ERROR_ACTIVE_REQUIRED: trads_default.t("notification.error.ERROR_ACTIVE_REQUIRED", {
      defaultValue: "No active provided"
    }),
    // SPONSORSHIPS
    ERROR_REFERRAL_MAX_REDEEM_MISSING: trads_default.t("notification.error.ERROR_REFERRAL_MAX_REDEEM_MISSING", {
      defaultValue: "Referral max redeem is required"
    }),
    ERROR_REFERRAL_MAX_REDEEM_INVALID_NUMBER: trads_default.t("notification.error.ERROR_REFERRAL_MAX_REDEEM_INVALID_NUMBER", {
      defaultValue: "Referral max redeem must be a valid number"
    }),
    ERROR_REFERRAL_MAX_REDEEM_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_REFERRAL_MAX_REDEEM_LOWER_THAN_ZERO", {
      defaultValue: "Referral max redeem must be greater than or equal to 0"
    }),
    ERROR_REFERRAL_PERCENTAGE_REDEEM_MISSING: trads_default.t("notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_MISSING", {
      defaultValue: "Referral percentage redeem is required"
    }),
    ERROR_REFERRAL_PERCENTAGE_REDEEM_INVALID_NUMBER: trads_default.t(
      "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_INVALID_NUMBER",
      {
        defaultValue: "Referral percentage redeem must be a valid number"
      }
    ),
    ERROR_REFERRAL_PERCENTAGE_REDEEM_LOWER_THAN_ZERO: trads_default.t(
      "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_LOWER_THAN_ZERO",
      {
        defaultValue: "Referral percentage redeem must be greater than or equal to 0"
      }
    ),
    ERROR_REFERRAL_PERCENTAGE_REDEEM_GREATER_THAN_ONE: trads_default.t(
      "notification.error.ERROR_REFERRAL_PERCENTAGE_REDEEM_GREATER_THAN_ONE",
      {
        defaultValue: "Referral percentage redeem must be less than or equal to 1"
      }
    ),
    ERROR_SPONSOR_MAX_REDEEM_MISSING: trads_default.t("notification.error.ERROR_SPONSOR_MAX_REDEEM_MISSING", {
      defaultValue: "Sponsor max redeem is required"
    }),
    ERROR_SPONSOR_MAX_REDEEM_INVALID_NUMBER: trads_default.t("notification.error.ERROR_SPONSOR_MAX_REDEEM_INVALID_NUMBER", {
      defaultValue: "Sponsor max redeem must be a valid number"
    }),
    ERROR_SPONSOR_MAX_REDEEM_LOWER_THAN_ZERO: trads_default.t("notification.error.ERROR_SPONSOR_MAX_REDEEM_LOWER_THAN_ZERO", {
      defaultValue: "Sponsor max redeem must be greater than or equal to 0"
    }),
    ERROR_AMOUNT_ANNUAL_COUPON_ID_MISSING: trads_default.t("notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_MISSING", {
      defaultValue: "Amount annual coupon id is required"
    }),
    ERROR_AMOUNT_ANNUAL_COUPON_ID_INVALID: trads_default.t("notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_INVALID", {
      defaultValue: "Amount annual coupon id must be a string"
    }),
    ERROR_AMOUNT_ANNUAL_COUPON_ID_TOO_LONG: trads_default.t("notification.error.ERROR_AMOUNT_ANNUAL_COUPON_ID_TOO_LONG", {
      defaultValue: "Amount annual coupon id must be less than 255 characters"
    }),
    ERROR_PERCENTAGE_ANNUAL_COUPON_ID_MISSING: trads_default.t("notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_MISSING", {
      defaultValue: "Percentage annual coupon id is required"
    }),
    ERROR_PERCENTAGE_ANNUAL_COUPON_ID_INVALID: trads_default.t("notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_INVALID", {
      defaultValue: "Percentage annual coupon id must be a string"
    }),
    ERROR_PERCENTAGE_ANNUAL_COUPON_ID_TOO_LONG: trads_default.t(
      "notification.error.ERROR_PERCENTAGE_ANNUAL_COUPON_ID_TOO_LONG",
      {
        defaultValue: "Percentage annual coupon id must be less than 255 characters"
      }
    ),
    ERROR_AMOUNT_MONTHLY_COUPON_ID_MISSING: trads_default.t("notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_MISSING", {
      defaultValue: "Amount monthly coupon id is required"
    }),
    ERROR_AMOUNT_MONTHLY_COUPON_ID_INVALID: trads_default.t("notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_INVALID", {
      defaultValue: "Amount monthly coupon id must be a string"
    }),
    ERROR_AMOUNT_MONTHLY_COUPON_ID_TOO_LONG: trads_default.t("notification.error.ERROR_AMOUNT_MONTHLY_COUPON_ID_TOO_LONG", {
      defaultValue: "Amount monthly coupon id must be less than 255 characters"
    }),
    ERROR_PERCENTAGE_MONTHLY_COUPON_ID_MISSING: trads_default.t(
      "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_MISSING",
      {
        defaultValue: "Percentage monthly coupon id is required"
      }
    ),
    ERROR_PERCENTAGE_MONTHLY_COUPON_ID_INVALID: trads_default.t(
      "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_INVALID",
      {
        defaultValue: "Percentage monthly coupon id must be a string"
      }
    ),
    ERROR_PERCENTAGE_MONTHLY_COUPON_ID_TOO_LONG: trads_default.t(
      "notification.error.ERROR_PERCENTAGE_MONTHLY_COUPON_ID_TOO_LONG",
      {
        defaultValue: "Percentage monthly coupon id must be less than 255 characters"
      }
    ),
    // VEHICLES
    ERROR_VEHICLE_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_VEHICLE_DOES_NOT_EXIST", {
      defaultValue: "Provided vehicle does not exist"
    }),
    ERROR_VEHICLES_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLES_REQUIRED", {
      defaultValue: "No vehicles provided"
    }),
    ERROR_VEHICLES_ID_EMPTY: trads_default.t("notification.error.ERROR_VEHICLES_ID_EMPTY", {
      defaultValue: "Bicycode ids list is empty"
    }),
    ERROR_VEHICLES_MARKING_CODE_DUPLICATE: trads_default.t("notification.error.ERROR_VEHICLES_MARKING_CODE_DUPLICATE", {
      defaultValue: "Vehicle marking codes must be unique"
    }),
    ERROR_VEHICLES_MARKING_CODE_EMPTY: trads_default.t("notification.error.ERROR_VEHICLES_MARKING_CODE_EMPTY", {
      defaultValue: "Vehicle marking codes list is empty"
    }),
    ERROR_VEHICLES_MARKING_CODE_INVALID_ARRAY: trads_default.t("notification.error.ERROR_VEHICLES_MARKING_CODE_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided vehicle marking codes"
    }),
    ERROR_VEHICLES_MARKING_CODE_NOT_ACTIVE: trads_default.t("notification.error.ERROR_VEHICLES_MARKING_CODE_NOT_ACTIVE", {
      defaultValue: "Vehicle marking code is not active on the policy"
    }),
    ERROR_BICYCODE_IDS_REQUIRED: trads_default.t("notification.error.ERROR_BICYCODE_IDS_REQUIRED", {
      defaultValue: "Bicycode ids are required"
    }),
    ERROR_BICYCODE_IDS_EMPTY: trads_default.t("notification.error.ERROR_BICYCODE_IDS_EMPTY", {
      defaultValue: "Bicycode ids must not be empty"
    }),
    ERROR_BICYCODE_IDS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_BICYCODE_IDS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided bicycode ids"
    }),
    ERROR_BICYCODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_BICYCODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided bicycode"
    }),
    ERROR_PURCHASE_PROOF_INVALID_TYPE: trads_default.t("notification.error.ERROR_PURCHASE_PROOF_INVALID_TYPE", {
      defaultValue: "Purchase proof must be in a correct type"
    }),
    ERROR_SERIAL_LENGTH_TOO_LONG: trads_default.t("notification.error.ERROR_SERIAL_LENGTH_TOO_LONG", {
      defaultValue: "Serial length must be less than 30 characters"
    }),
    ERROR_IS_ASSURED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_ASSURED_INVALID_FORMAT", {
      defaultValue: "Is assured must be in a correct format"
    }),
    ERROR_DOCUMENT_OBJECT_REQUIRED: trads_default.t("notification.error.ERROR_DOCUMENT_OBJECT_REQUIRED", {
      defaultValue: "Document object is required"
    }),
    ERROR_DOCUMENT_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENT_OBJECT_INVALID_FORMAT", {
      defaultValue: "Document object must be in a correct format"
    }),
    ERROR_COLOR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COLOR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided color"
    }),
    ERROR_FLEET_NAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FLEET_NAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided fleet name"
    }),
    ERROR_MODEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MODEL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided model name"
    }),
    ERROR_INCLUDE_REQUIRED: trads_default.t("notification.error.ERROR_INCLUDE_REQUIRED", {
      defaultValue: "Include is required"
    }),
    ERROR_B2B_POLICY_OBJECT_REQUIRED: trads_default.t("notification.error.ERROR_B2B_POLICY_OBJECT_REQUIRED", {
      defaultValue: "B2b policy object is required"
    }),
    ERROR_B2B_POLICY_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_POLICY_OBJECT_INVALID_FORMAT", {
      defaultValue: "B2b policy object must be in a correct format"
    }),
    ERROR_INSURANCE_CLAIMS_REQUIRED: trads_default.t("notification.error.ERROR_INSURANCE_CLAIMS_REQUIRED", {
      defaultValue: "Insurance claims is required"
    }),
    ERROR_INSURANCE_CLAIMS_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_INSURANCE_CLAIMS_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Insurance claims object must be in a correct format"
      }
    ),
    ERROR_PERSONAL_LOCK_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_OBJECT_INVALID_FORMAT", {
      defaultValue: "Personal lock object must be in a correct format"
    }),
    ERROR_FLEET_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FLEET_OBJECT_INVALID_FORMAT", {
      defaultValue: "Fleet object must be in a correct format"
    }),
    ERROR_GROUP_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GROUP_OBJECT_INVALID_FORMAT", {
      defaultValue: "Group object must be in a correct format"
    }),
    ERROR_B2B_CLAIMS_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_CLAIMS_OBJECT_INVALID_FORMAT", {
      defaultValue: "B2b claims object must be in a correct format"
    }),
    ERROR_VEHICLE_MUST_HAVE_BICYCODE: trads_default.t("notification.error.ERROR_VEHICLE_MUST_HAVE_BICYCODE", {
      defaultValue: "Vehicle must have a bicycode"
    }),
    ERROR_VEHICLE_REQUIRED: trads_default.t("notification.error.ERROR_VEHICLE_REQUIRED", {
      defaultValue: "No vehicle provided"
    }),
    ERROR_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TYPE_INVALID_FORMAT", {
      defaultValue: "Type must be in a correct format"
    }),
    ERROR_DANGER_LEVEL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DANGER_LEVEL_INVALID_FORMAT", {
      defaultValue: "Danger level must be in a correct format"
    }),
    // FILTERS
    ERROR_INSURANCE_CLAIMS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INSURANCE_CLAIMS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided insurance claims"
    }),
    // INTERCEPTOR
    ERROR_INVALID_RENEW_TOKEN: trads_default.t("notification.error.ERROR_INVALID_RENEW_TOKEN", {
      defaultValue: "Provided renew token is invalid"
    }),
    // WEBHOOKS
    ERROR_B2B_POLICY_NOT_AUTO_RENEWABLE: trads_default.t("notification.error.ERROR_B2B_POLICY_NOT_AUTO_RENEWABLE", {
      defaultValue: "Policy is not renewable"
    }),
    ERROR_IS_ONE_OFF_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_ONE_OFF_INVALID_FORMAT", {
      defaultValue: "Is one off must be in a correct format"
    }),
    // TKT
    ERROR_INSURANCE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_INSURANCE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided insurance date"
    }),
    ERROR_INSURANCE_DATE_REQUIRED: trads_default.t("notification.error.ERROR_INSURANCE_DATE_REQUIRED", {
      defaultValue: "Insurance date is required"
    }),
    ERROR_MISS_CHOOSEN_PACKAGES: trads_default.t("notification.error.ERROR_MISS_CHOOSEN_PACKAGES", {
      defaultValue: "No chosen packages provided"
    }),
    ERROR_MISS_CHOOSEN_PACKAGE_WITH_DURATION: trads_default.t("notification.error.ERROR_MISS_CHOOSEN_PACKAGE_WITH_DURATION", {
      defaultValue: "No chosen package with duration provided"
    }),
    ERROR_MISS_CLIENT_INFO: trads_default.t("notification.error.ERROR_MISS_CLIENT_INFO", {
      defaultValue: "No client info provided"
    }),
    ERROR_MISS_CLIENT_OWNER_INFOS: trads_default.t("notification.error.ERROR_MISS_CLIENT_OWNER_INFOS", {
      defaultValue: "No client owner infos provided"
    }),
    ERROR_MISS_PACKAGES_INFO: trads_default.t("notification.error.ERROR_MISS_PACKAGES_INFO", {
      defaultValue: "No packages info provided"
    }),
    ERROR_MISS_PACKAGE_ID: trads_default.t("notification.error.ERROR_MISS_PACKAGE_ID", {
      defaultValue: "No package id provided"
    }),
    ERROR_MISS_POLICY: trads_default.t("notification.error.ERROR_MISS_POLICY", {
      defaultValue: "No policy provided"
    }),
    ERROR_MISS_POLICY_INFO: trads_default.t("notification.error.ERROR_MISS_POLICY_INFO", {
      defaultValue: "No policy info provided"
    }),
    ERROR_MISS_PRICE_INFO: trads_default.t("notification.error.ERROR_MISS_PRICE_INFO", {
      defaultValue: "No price info provided"
    }),
    ERROR_MISS_PRICING: trads_default.t("notification.error.ERROR_MISS_PRICING", {
      defaultValue: "No pricing provided"
    }),
    ERROR_MISS_VEHICLE: trads_default.t("notification.error.ERROR_MISS_VEHICLE", {
      defaultValue: "No vehicle provided"
    }),
    ERROR_MISS_VEHICLE_INFO: trads_default.t("notification.error.ERROR_MISS_VEHICLE_INFO", {
      defaultValue: "No vehicle info provided"
    }),
    ERROR_NEXT_PACKAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NEXT_PACKAGE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided next package"
    }),
    ERROR_NOTHING_TO_UPDATE: trads_default.t("notification.error.ERROR_NOTHING_TO_UPDATE", {
      defaultValue: "Nothing to update"
    }),
    ERROR_NO_INVOICES: trads_default.t("notification.error.ERROR_NO_INVOICES", {
      defaultValue: "No invoices provided"
    }),
    ERROR_OCCURRENCE_PERIOD_END_INVALID_DATE: trads_default.t("notification.error.ERROR_OCCURRENCE_PERIOD_END_INVALID_DATE", {
      defaultValue: "Invalid date for provided occurrence period end"
    }),
    ERROR_OPEN_CLAIM: trads_default.t("notification.error.ERROR_OPEN_CLAIM", {
      defaultValue: "Open claim"
    }),
    ERROR_OPS_CHECKS_PARAMETERS_ALREADY_EXISTS: trads_default.t(
      "notification.error.ERROR_OPS_CHECKS_PARAMETERS_ALREADY_EXISTS",
      {
        defaultValue: "Ops checks parameters already exists"
      }
    ),
    ERROR_OPS_CHECKS_PARAMETERS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_OPS_CHECKS_PARAMETERS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided ops checks parameters"
    }),
    ERROR_OPTIONAL_COVERAGES_EMPTY: trads_default.t("notification.error.ERROR_OPTIONAL_COVERAGES_EMPTY", {
      defaultValue: "Optional coverages cannot be empty"
    }),
    ERROR_PACKAGE_SOURCE_INVALID_TYPE: trads_default.t("notification.error.ERROR_PACKAGE_SOURCE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided package source"
    }),
    ERROR_PACKAGE_SOURCE_REQUIRED: trads_default.t("notification.error.ERROR_PACKAGE_SOURCE_REQUIRED", {
      defaultValue: "Package source is required"
    }),
    ERROR_PARTNERS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_PARTNERS_INVALID_ARRAY", {
      defaultValue: "Partners must be an array"
    }),
    ERROR_PARTNERS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNERS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partners"
    }),
    ERROR_PAYMENT_METHODS_VALUE: trads_default.t("notification.error.ERROR_PAYMENT_METHODS_VALUE", {
      defaultValue: "Invalid value for provided payment methods"
    }),
    ERROR_PERCENTAGE_PROHIBITED_FOR_FIXED_TYPE: trads_default.t(
      "notification.error.ERROR_PERCENTAGE_PROHIBITED_FOR_FIXED_TYPE",
      {
        defaultValue: "Percentage prohibited for fixed type"
      }
    ),
    ERROR_PERSONAL_LOCK_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PERSONAL_LOCK_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided personal lock id"
    }),
    ERROR_PMP_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_PMP_ALREADY_EXISTS", {
      defaultValue: "Pmp already exists"
    }),
    ERROR_POLICY_ALREADY_EXIST: trads_default.t("notification.error.ERROR_POLICY_ALREADY_EXIST", {
      defaultValue: "Policy already exists"
    }),
    ERROR_POLICY_ALREADY_HAS_AN_ONGOING_CLAIM: trads_default.t("notification.error.ERROR_POLICY_ALREADY_HAS_AN_ONGOING_CLAIM", {
      defaultValue: "Policy already has an ongoing claim"
    }),
    ERROR_POLICY_EXPIRED_OVER_ONE_YEAR: trads_default.t("notification.error.ERROR_POLICY_EXPIRED_OVER_ONE_YEAR", {
      defaultValue: "Policy expired over one year"
    }),
    ERROR_POLICY_INVALID_STATUS: trads_default.t("notification.error.ERROR_POLICY_INVALID_STATUS", {
      defaultValue: "Invalid policy status"
    }),
    ERROR_POLICY_MISSING_INFORMATION: trads_default.t("notification.error.ERROR_POLICY_MISSING_INFORMATION", {
      defaultValue: "Missing information"
    }),
    ERROR_POLICY_NOT_FOUND_OR_INCOMPLETE: trads_default.t("notification.error.ERROR_POLICY_NOT_FOUND_OR_INCOMPLETE", {
      defaultValue: "Policy not found or incomplete"
    }),
    ERROR_PREMIUM_SUPPORT_TYPE_EXPECTED: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_TYPE_EXPECTED", {
      defaultValue: "Premium support type expected"
    }),
    ERROR_PREMIUM_SUPPORT_TYPE_UNEXPECTED: trads_default.t("notification.error.ERROR_PREMIUM_SUPPORT_TYPE_UNEXPECTED", {
      defaultValue: "Premium support type unexpected"
    }),
    ERROR_PRICING_RULES_PER_COVERAGE_INVALID_ARRAY: trads_default.t(
      "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_INVALID_ARRAY",
      {
        defaultValue: "Invalid array for provided pricing rules per coverage"
      }
    ),
    ERROR_PRICING_RULES_PER_COVERAGE_NOT_ALLOWED_FOR_B2B: trads_default.t(
      "notification.error.ERROR_PRICING_RULES_PER_COVERAGE_NOT_ALLOWED_FOR_B2B",
      {
        defaultValue: "Pricing rules per coverage not allowed for B2B"
      }
    ),
    ERROR_PRIORITY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRIORITY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided priority"
    }),
    ERROR_PRIORITY_REQUIRED: trads_default.t("notification.error.ERROR_PRIORITY_REQUIRED", {
      defaultValue: "Priority is required"
    }),
    ERROR_QMP_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_QMP_ALREADY_EXISTS", {
      defaultValue: "Qmp already exists"
    }),
    ERROR_REIMBURSEMENT_PARAMETERS_ALREADY_EXISTS: trads_default.t(
      "notification.error.ERROR_REIMBURSEMENT_PARAMETERS_ALREADY_EXISTS",
      {
        defaultValue: "Reimbursement parameters already exists"
      }
    ),
    ERROR_SPLITTING_VALUE: trads_default.t("notification.error.ERROR_SPLITTING_VALUE", {
      defaultValue: "Invalid value for provided splitting"
    }),
    ERROR_STRIPE_SIGNATURE_INVALID: trads_default.t("notification.error.ERROR_STRIPE_SIGNATURE_INVALID", {
      defaultValue: "Stripe signature is invalid"
    }),
    ERROR_STRIPE_SIGNATURE_REQUIRED: trads_default.t("notification.error.ERROR_STRIPE_SIGNATURE_REQUIRED", {
      defaultValue: "Stripe signature is required"
    }),
    ERROR_SUPPORT_AMOUNT_NOT_NUMBER: trads_default.t("notification.error.ERROR_SUPPORT_AMOUNT_NOT_NUMBER", {
      defaultValue: "Support amount must be a number"
    }),
    ERROR_TIME_PERIOD_TYPE: trads_default.t("notification.error.ERROR_TIME_PERIOD_TYPE", {
      defaultValue: "Invalid time period type"
    }),
    ERROR_TIME_PERIOD_VALUE: trads_default.t("notification.error.ERROR_TIME_PERIOD_VALUE", {
      defaultValue: "Invalid time period value"
    }),
    ERROR_TOO_LATE_TO_CANCEL_CANCELLATION: trads_default.t("notification.error.ERROR_TOO_LATE_TO_CANCEL_CANCELLATION", {
      defaultValue: "Too late to cancel cancellation"
    }),
    ERROR_TOO_MANY_OPENED_REQUESTS: trads_default.t("notification.error.ERROR_TOO_MANY_OPENED_REQUESTS", {
      defaultValue: "Too many opened requests"
    }),
    ERROR_TRAD_CODE_MUST_BE_ONE_OF_THE_VALID_VALUES: trads_default.t(
      "notification.error.ERROR_TRAD_CODE_MUST_BE_ONE_OF_THE_VALID_VALUES",
      {
        defaultValue: "Trad code must be one of the valid values"
      }
    ),
    ERROR_TRAD_CODE_REQUIRED: trads_default.t("notification.error.ERROR_TRAD_CODE_REQUIRED", {
      defaultValue: "Trad code is required"
    }),
    ERROR_USER_CANCEL_ALLOWED_REQUIRED: trads_default.t("notification.error.ERROR_USER_CANCEL_ALLOWED_REQUIRED", {
      defaultValue: "User cancel allowed is required"
    }),
    ERROR_VEHICLE_ID_INVALID_TYPE: trads_default.t("notification.error.ERROR_VEHICLE_ID_INVALID_TYPE", {
      defaultValue: "Invalid type for provided vehicle id"
    }),
    INACTIVE_POLICY_OR_ALREADY_STARTED: trads_default.t("notification.error.INACTIVE_POLICY_OR_ALREADY_STARTED", {
      defaultValue: "Policy is inactive or already started"
    }),
    INCORRECT_AMOUNT: trads_default.t("notification.error.INCORRECT_AMOUNT", {
      defaultValue: "Incorrect amount"
    }),
    INSURANCE_NO_SUBSCRIPTION_GIVEN: trads_default.t("notification.error.INSURANCE_NO_SUBSCRIPTION_GIVEN", {
      defaultValue: "No subscription given"
    }),
    INVALID_CODE: trads_default.t("notification.error.INVALID_CODE", {
      defaultValue: "Invalid code"
    }),
    INVALID_COVERAGE_CODE: trads_default.t("notification.error.INVALID_COVERAGE_CODE", {
      defaultValue: "Invalid coverage code"
    }),
    INVALID_OAUTH_STATE: trads_default.t("notification.error.INVALID_OAUTH_STATE", {
      defaultValue: "Invalid OAuth state"
    }),
    INVALID_PACKAGE_STEP: trads_default.t("notification.error.INVALID_PACKAGE_STEP", {
      defaultValue: "Invalid package step"
    }),
    INVALID_POLICY: trads_default.t("notification.error.INVALID_POLICY", {
      defaultValue: "Invalid policy"
    }),
    INVALID_PREMIUM_SUPPORT_TYPE: trads_default.t("notification.error.INVALID_PREMIUM_SUPPORT_TYPE", {
      defaultValue: "Invalid premium support type"
    }),
    INVALID_PROMOTION_CODE: trads_default.t("notification.error.INVALID_PROMOTION_CODE", {
      defaultValue: "Invalid promotion code"
    }),
    INVALID_QUOTE_GIVEN: trads_default.t("notification.error.INVALID_QUOTE_GIVEN", {
      defaultValue: "Invalid quote given"
    }),
    INVALID_STATUS: trads_default.t("notification.error.INVALID_STATUS", {
      defaultValue: "Invalid status"
    }),
    LAST_CHECK_NOT_ALLOWED: trads_default.t("notification.error.LAST_CHECK_NOT_ALLOWED", {
      defaultValue: "Last check not allowed"
    }),
    MISSING_CLAIM_DATA: trads_default.t("notification.error.MISSING_CLAIM_DATA", {
      defaultValue: "Missing claim data"
    }),
    MISS_POLICY_PACKAGE: trads_default.t("notification.error.MISS_POLICY_PACKAGE", {
      defaultValue: "Missing policy package"
    }),
    MISS_VEHICLES_AFFECTED_USER: trads_default.t("notification.error.MISS_VEHICLES_AFFECTED_USER", {
      defaultValue: "Missing vehicles affected user"
    }),
    NEW_STATUS_NOT_ALLOWED: trads_default.t("notification.error.NEW_STATUS_NOT_ALLOWED", {
      defaultValue: "New status not allowed"
    }),
    ERROR_SEND_MAIL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SEND_MAIL_INVALID_FORMAT", {
      defaultValue: "Send mail must be a boolean"
    }),
    NOT_A_TOTAL_COVERAGE_CODE: trads_default.t("notification.error.NOT_A_TOTAL_COVERAGE_CODE", {
      defaultValue: "Claim is not total"
    }),
    NO_BIKE_FUND: trads_default.t("notification.error.NO_BIKE_FUND", {
      defaultValue: "No bike fund"
    }),
    NO_LINES: trads_default.t("notification.error.NO_LINES", {
      defaultValue: "No lines"
    }),
    NO_PACKAGES: trads_default.t("notification.error.NO_PACKAGES", {
      defaultValue: "No packages"
    }),
    NO_PACKAGES_OR_CONTRACT: trads_default.t("notification.error.NO_PACKAGES_OR_CONTRACT", {
      defaultValue: "No packages or contract"
    }),
    NO_PLAN_GIVEN: trads_default.t("notification.error.NO_PLAN_GIVEN", {
      defaultValue: "No plan given"
    }),
    NO_UPDATE: trads_default.t("notification.error.NO_UPDATE", {
      defaultValue: "No update"
    }),
    NO_VEHICLE_PHOTO: trads_default.t("notification.error.NO_VEHICLE_PHOTO", {
      defaultValue: "No vehicle photo"
    }),
    PAST_EFFECTIVE_START_DATE: trads_default.t("notification.error.PAST_EFFECTIVE_START_DATE", {
      defaultValue: "Effective start date must be in the future"
    }),
    PENDING_POLICY_NOT_FOUND: trads_default.t("notification.error.PENDING_POLICY_NOT_FOUND", {
      defaultValue: "Pending policy not found"
    }),
    PERSONAL_LOCK_REQUIRED: trads_default.t("notification.error.PERSONAL_LOCK_REQUIRED", {
      defaultValue: "Personal lock is required"
    }),
    PLS_VALIDATION_NOT_CONSISTENT: trads_default.t("notification.error.PLS_VALIDATION_NOT_CONSISTENT", {
      defaultValue: "Pls validation not consistent"
    }),
    POLICY_ALREADY_ENDED: trads_default.t("notification.error.POLICY_ALREADY_ENDED", {
      defaultValue: "Policy already ended"
    }),
    POLICY_ALREADY_HAS_AMENDMENT: trads_default.t("notification.error.POLICY_ALREADY_HAS_AMENDMENT", {
      defaultValue: "Policy already has an amendment"
    }),
    POLICY_ALREADY_RENEWED: trads_default.t("notification.error.POLICY_ALREADY_RENEWED", {
      defaultValue: "Policy already renewed"
    }),
    POLICY_IS_NOT_ACTIVE_ANYMORE: trads_default.t("notification.error.POLICY_IS_NOT_ACTIVE_ANYMORE", {
      defaultValue: "Policy is not active anymore"
    }),
    POLICY_NOT_CANCELABLE: trads_default.t("notification.error.POLICY_NOT_CANCELABLE", {
      defaultValue: "Policy not cancelable"
    }),
    POLICY_NOT_FOUND: trads_default.t("notification.error.POLICY_NOT_FOUND", {
      defaultValue: "Policy not found"
    }),
    POLICY_STILL_IN_DEPRIVATION: trads_default.t("notification.error.POLICY_STILL_IN_DEPRIVATION", {
      defaultValue: "Policy still in deprivation"
    }),
    QUOTE_NOT_FOUND_OR_INCOMPLETE: trads_default.t("notification.error.QUOTE_NOT_FOUND_OR_INCOMPLETE", {
      defaultValue: "Quote not found or incomplete"
    }),
    RECEIPT_NOT_FOUND: trads_default.t("notification.error.RECEIPT_NOT_FOUND", {
      defaultValue: "Receipt not found"
    }),
    RECONDUCTED_POLICY: trads_default.t("notification.error.RECONDUCTED_POLICY", {
      defaultValue: "Policy is reconducted"
    }),
    REQUEST_ALREADY_HANDLED: trads_default.t("notification.error.REQUEST_ALREADY_HANDLED", {
      defaultValue: "Request already handled"
    }),
    STRIPE_NOT_EDITABLE: trads_default.t("notification.error.STRIPE_NOT_EDITABLE", {
      defaultValue: "Stripe not editable"
    }),
    TOO_LATE_TO_UPDATE_SCHEDULE: trads_default.t("notification.error.TOO_LATE_TO_UPDATE_SCHEDULE", {
      defaultValue: "Too late to update schedule"
    }),
    UNABLE_TO_DELETE: trads_default.t("notification.error.UNABLE_TO_DELETE", {
      defaultValue: "Unable to delete"
    }),
    UNKNOWN_PRODUCT: trads_default.t("notification.error.UNKNOWN_PRODUCT", {
      defaultValue: "Unknown product"
    }),
    USER_CHECK_COMMENT_REQUIRED: trads_default.t("notification.error.USER_CHECK_COMMENT_REQUIRED", {
      defaultValue: "User check comment is required"
    }),
    USER_ID_REQUIRED: trads_default.t("notification.error.USER_ID_REQUIRED", {
      defaultValue: "User id is required"
    }),
    USER_PERSONAL_LOCK_NOT_FOUND: trads_default.t("notification.error.USER_PERSONAL_LOCK_NOT_FOUND", {
      defaultValue: "User personal lock not found"
    }),
    VEHICLE_NOT_APIC_APPROVED: trads_default.t("notification.error.VEHICLE_NOT_APIC_APPROVED", {
      defaultValue: "Vehicle has not been checked with the APIC"
    }),
    VEHICLE_NOT_EXIST_OR_ERROR_CREATION: trads_default.t("notification.error.VEHICLE_NOT_EXIST_OR_ERROR_CREATION", {
      defaultValue: "Vehicle not exist or error creation"
    }),
    ERROR_CLAIM_REJECT_CANCEL_CONDITION_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_INVALID_TYPE",
      {
        defaultValue: "The cancel condition of the claim reject must be in the correct format"
      }
    ),
    ERROR_CLAIM_REJECT_CANCEL_CONDITION_NOT_ALLOWED: trads_default.t(
      "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_NOT_ALLOWED",
      {
        defaultValue: "The cancel condition of the claim reject is not allowed"
      }
    ),
    ERROR_CLAIM_REJECT_CANCEL_CONDITION_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_REJECT_CANCEL_CONDITION_REQUIRED",
      {
        defaultValue: "The cancel condition of the claim reject is required"
      }
    ),
    ERROR_INVALID_PROMO_CODE: trads_default.t("notification.error.ERROR_INVALID_PROMO_CODE", {
      defaultValue: "The promo code is invalid"
    }),
    ERROR_NO_POLICY_FOR_RENEWAL: trads_default.t("notification.error.ERROR_NO_POLICY_FOR_RENEWAL", {
      defaultValue: "No policy found for renewal"
    }),
    ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT",
      {
        defaultValue: "The total rejected terminate policy must be a boolean"
      }
    ),
    ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_REQUIRED: trads_default.t(
      "notification.error.ERROR_SHOULD_TOTAL_REJECTED_TERMINATE_POLICY_REQUIRED",
      {
        defaultValue: "The total rejected terminate policy is required"
      }
    ),
    ERROR_TERMINATE_POLICY_RETRACTION: trads_default.t("notification.error.ERROR_TERMINATE_POLICY_RETRACTION", {
      defaultValue: "Policy is in retraction, cannot be terminated"
    }),
    ERROR_TERMINATE_POLICY_DUE_DATE_NOT_SIMULABLE: trads_default.t(
      "notification.error.ERROR_TERMINATE_POLICY_DUE_DATE_NOT_SIMULABLE",
      {
        defaultValue: "Termination at due date cannot be simulated"
      }
    ),
    ERROR_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_TOTAL_REJECTED_TERMINATE_POLICY_INVALID_FORMAT",
      {
        defaultValue: "The total rejected terminate policy must be a boolean"
      }
    ),
    VEHICLE_NOT_APIC_APPROVED_OR_INVALID_STATUS: trads_default.t(
      "notification.error.VEHICLE_NOT_APIC_APPROVED_OR_INVALID_STATUS",
      {
        defaultValue: "Vehicle has not been checked with the APIC or has an invalid status"
      }
    ),
    ERROR_EXCLUDE_IDS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_EXCLUDE_IDS_INVALID_ARRAY", {
      defaultValue: "Exclude ids must be an array"
    }),
    ERROR_EXCLUDE_IDS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_EXCLUDE_IDS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided exclude ids"
    }),
    ERROR_MAX_LAT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_LAT_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided max lat"
    }),
    ERROR_MAX_LAT_REQUIRED: trads_default.t("notification.error.ERROR_MAX_LAT_REQUIRED", {
      defaultValue: "No max lat provided"
    }),
    ERROR_MAX_LON_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MAX_LON_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided max lon"
    }),
    ERROR_MAX_LON_REQUIRED: trads_default.t("notification.error.ERROR_MAX_LON_REQUIRED", {
      defaultValue: "No max lon provided"
    }),
    ERROR_MIN_LAT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIN_LAT_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided min lat"
    }),
    ERROR_MIN_LAT_REQUIRED: trads_default.t("notification.error.ERROR_MIN_LAT_REQUIRED", {
      defaultValue: "No min lat provided"
    }),
    ERROR_MIN_LON_INVALID_FORMAT: trads_default.t("notification.error.ERROR_MIN_LON_INVALID_FORMAT", {
      defaultValue: "Invalid value for provided min lon"
    }),
    ERROR_MIN_LON_REQUIRED: trads_default.t("notification.error.ERROR_MIN_LON_REQUIRED", {
      defaultValue: "No min lon provided"
    }),
    ERROR_CANT_DISABLE_PACKAGE_WITH_CONTRACTS: trads_default.t("notification.error.ERROR_CANT_DISABLE_PACKAGE_WITH_CONTRACTS", {
      defaultValue: "Cannot disable package with contracts"
    }),
    ERROR_GROUP_STATS_VIEW_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GROUP_STATS_VIEW_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided group stats view"
    }),
    ERROR_NEXT_CONTRACT_ID_REQUIRED: trads_default.t("notification.error.ERROR_NEXT_CONTRACT_ID_REQUIRED", {
      defaultValue: "nextContractId is required"
    }),
    ERROR_NEXT_CONTRACT_IS_NOT_ACTIVE: trads_default.t("notification.error.ERROR_NEXT_CONTRACT_IS_NOT_ACTIVE", {
      defaultValue: "Next contract is not active"
    }),
    ERROR_NEXT_CONTRACT_HAS_DIFFERENT_USAGE: trads_default.t("notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_USAGE", {
      defaultValue: "Next contract has different usage"
    }),
    ERROR_NEXT_CONTRACT_HAS_DIFFERENT_PACKAGE: trads_default.t("notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_PACKAGE", {
      defaultValue: "Next contract has different package"
    }),
    ERROR_NEXT_CONTRACT_HAS_DIFFERENT_DURATION: trads_default.t(
      "notification.error.ERROR_NEXT_CONTRACT_HAS_DIFFERENT_DURATION",
      {
        defaultValue: "Next contract has different duration"
      }
    ),
    ERROR_NEXT_CONTRACT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NEXT_CONTRACT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided next contract id"
    }),
    ERROR_CLAIM_NOT_LINKED_TO_GROUP: trads_default.t("notification.error.ERROR_CLAIM_NOT_LINKED_TO_GROUP", {
      defaultValue: "Claim is not linked to group"
    }),
    ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_EXCEEDED: trads_default.t(
      "notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_EXCEEDED",
      {
        defaultValue: "Partial claim allowed count exceeded"
      }
    ),
    ERROR_DOCUMENT_PARAMETERS_OBJECTS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DOCUMENT_PARAMETERS_OBJECTS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided document parameters objects"
      }
    ),
    ERROR_REIMBURSMENT_PARAMETERS_OBJECTS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_REIMBURSMENT_PARAMETERS_OBJECTS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided reimbursement parameters objects"
      }
    ),
    ERROR_OPS_CHECK_PARAMETERS_OBJECTS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_OPS_CHECK_PARAMETERS_OBJECTS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided ops check parameters objects"
      }
    ),
    ERROR_BIKE_VALUE_CHECKS_INVALID_TYPE: trads_default.t("notification.error.ERROR_BIKE_VALUE_CHECKS_INVALID_TYPE", {
      defaultValue: "Invalid type for provided bike value checks"
    }),
    ERROR_BIKE_VALUE_CHECKS_REQUIRED: trads_default.t("notification.error.ERROR_BIKE_VALUE_CHECKS_REQUIRED", {
      defaultValue: "No bike value checks provided"
    }),
    ERROR_BIKE_VALUE_OPS_CHECKS_INVALID_ARRAY: trads_default.t("notification.error.ERROR_BIKE_VALUE_OPS_CHECKS_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided bike value ops checks"
    }),
    ERROR_BIKE_VALUE_THRESHOLD_INVALID: trads_default.t("notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID", {
      defaultValue: "Invalid value for provided bike value threshold"
    }),
    ERROR_BIKE_VALUE_THRESHOLD_INVALID_TYPE: trads_default.t("notification.error.ERROR_BIKE_VALUE_THRESHOLD_INVALID_TYPE", {
      defaultValue: "Invalid type for provided bike value threshold"
    }),
    ERROR_BIKE_VALUE_THRESHOLD_REQUIRED: trads_default.t("notification.error.ERROR_BIKE_VALUE_THRESHOLD_REQUIRED", {
      defaultValue: "No bike value threshold provided"
    }),
    ERROR_MIN_FRANCHISE_AMOUNT_INVALID: trads_default.t("notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID", {
      defaultValue: "Invalid value for provided min franchise amount"
    }),
    ERROR_MIN_FRANCHISE_AMOUNT_INVALID_TYPE: trads_default.t("notification.error.ERROR_MIN_FRANCHISE_AMOUNT_INVALID_TYPE", {
      defaultValue: "Invalid type for provided min franchise amount"
    }),
    ERROR_MIN_FRANCHISE_AMOUNT_REQUIRED: trads_default.t("notification.error.ERROR_MIN_FRANCHISE_AMOUNT_REQUIRED", {
      defaultValue: "No min franchise amount provided"
    }),
    ERROR_STATUS_CODE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_STATUS_CODE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided status_code"
    }),
    ERROR_CLAIM_NOT_ALLOWED_TO_UPDATE: trads_default.t("notification.error.ERROR_CLAIM_NOT_ALLOWED_TO_UPDATE", {
      defaultValue: "Claim is not allowed to update"
    }),
    ERROR_ORDER_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_ORDER_DOES_NOT_EXIST", {
      defaultValue: "Order does not exist"
    }),
    ERROR_ORDER_NOT_VALID: trads_default.t("notification.error.ERROR_ORDER_NOT_VALID", {
      defaultValue: "Order is not valid"
    }),
    ORDER_NOT_VALID: trads_default.t("notification.error.ORDER_NOT_VALID", {
      defaultValue: "Order is not valid"
    }),
    ERROR_ORDER_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ORDER_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided order object"
    }),
    ERROR_PRODUCT_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRODUCT_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided product id"
    }),
    ERROR_ORDER_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ORDER_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided order id"
    }),
    ERROR_PRODUCT_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_PRODUCT_DOES_NOT_EXIST", {
      defaultValue: "Product does not exist"
    }),
    ERROR_PRODUCT_OUT_OF_STOCK: trads_default.t("notification.error.ERROR_PRODUCT_OUT_OF_STOCK", {
      defaultValue: "Product is out of stock"
    }),
    ERROR_SPONSOR_NAME_REQUIRED: trads_default.t("notification.error.ERROR_SPONSOR_NAME_REQUIRED", {
      defaultValue: "No sponsor name provided"
    }),
    ERROR_PICTURE_REQUIRED: trads_default.t("notification.error.ERROR_PICTURE_REQUIRED", {
      defaultValue: "No picture provided"
    }),
    ERROR_PRODUCT_COST_REQUIRED: trads_default.t("notification.error.ERROR_PRODUCT_COST_REQUIRED", {
      defaultValue: "No product cost provided"
    }),
    ERROR_PRODUCT_COST_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PRODUCT_COST_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided product cost"
    }),
    ERROR_STOCK_INVALID_FORMAT: trads_default.t("notification.error.ERROR_STOCK_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided stock"
    }),
    ERROR_XSS_DETECTED: trads_default.t("notification.error.ERROR_XSS_DETECTED", {
      defaultValue: "XSS detected"
    }),
    ERROR_PRODUCT_EXPIRED: trads_default.t("notification.error.ERROR_PRODUCT_EXPIRED", {
      defaultValue: "Product has expired"
    }),
    ERROR_MISSING_PRODUCT_INFORMATIONS: trads_default.t("notification.error.ERROR_MISSING_PRODUCT_INFORMATIONS", {
      defaultValue: "Missing product informations"
    }),
    ERROR_GENERATE_ON_ORDER_REQUIRED: trads_default.t("notification.error.ERROR_GENERATE_ON_ORDER_REQUIRED", {
      defaultValue: "No generate on order provided"
    }),
    ERROR_GENERATE_ON_ORDER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_GENERATE_ON_ORDER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided generate on order"
    }),
    ERROR_PROMO_CODES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_PROMO_CODES_INVALID_ARRAY", {
      defaultValue: "Invalid array for provided promotions codes"
    }),
    ERROR_PROMO_CODES_NOT_EMPTY: trads_default.t("notification.error.ERROR_PROMO_CODES_NOT_EMPTY", {
      defaultValue: "No promotions codes provided"
    }),
    ERROR_PROMO_CODES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PROMO_CODES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided promotions codes"
    }),
    ERROR_API_GENERATION_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_API_GENERATION_URL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided api generation url"
    }),
    ERROR_DESCRIPTION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DESCRIPTION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided description"
    }),
    ERROR_PARTNER_WEBSITE_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PARTNER_WEBSITE_URL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided partner website url"
    }),
    ERROR_PICTURE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_PICTURE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided picture"
    }),
    ERROR_SPONSOR_NAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SPONSOR_NAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided sponsor name"
    }),
    ERROR_REWARD_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_REWARD_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided reward type"
    }),
    ERROR_REWARD_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_REWARD_TYPE_REQUIRED", {
      defaultValue: "No reward type provided"
    }),
    ERROR_LINK_URL_REQUIRED: trads_default.t("notification.error.ERROR_LINK_URL_REQUIRED", {
      defaultValue: "No link url provided"
    }),
    ERROR_LINK_URL_INVALID_FORMAT: trads_default.t("notification.error.ERROR_LINK_URL_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided link url"
    }),
    ERROR_INSUFFICIENT_POINTS: trads_default.t("notification.error.ERROR_INSUFFICIENT_POINTS", {
      defaultValue: "Insufficient points"
    }),
    ERROR_POINTS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POINTS_INVALID_FORMAT", {
      defaultValue: "invalid format for points"
    }),
    ERROR_EARNED_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_EARNED_TYPE_INVALID_TYPE", {
      defaultValue: "invalid type for earned-type"
    }),
    ERROR_SPENT_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_SPENT_TYPE_INVALID_TYPE", {
      defaultValue: "invalid type for spent-type"
    }),
    ERROR_PRODUCT_NOT_ACTIVE: trads_default.t("notification.error.ERROR_PRODUCT_NOT_ACTIVE", {
      defaultValue: "Product is not active"
    }),
    ERROR_S3_KEY_REQUIRED: trads_default.t("notification.error.ERROR_S3_KEY_REQUIRED", {
      defaultValue: "No s3 key provided"
    }),
    ERROR_S3_KEY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_S3_KEY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided s3 key"
    }),
    ERROR_CARD_PICTURE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CARD_PICTURE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided card picture"
    }),
    ERROR_CARD_PICTURE_REQUIRED: trads_default.t("notification.error.ERROR_CARD_PICTURE_REQUIRED", {
      defaultValue: "No card picture provided"
    }),
    ERROR_DETAIL_PICTURE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DETAIL_PICTURE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided detail picture"
    }),
    ERROR_DETAIL_PICTURE_REQUIRED: trads_default.t("notification.error.ERROR_DETAIL_PICTURE_REQUIRED", {
      defaultValue: "No detail picture provided"
    }),
    ERROR_DISPLAY_CLAIMS_CLIENT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISPLAY_CLAIMS_CLIENT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided display claims client"
      }
    ),
    ERROR_DISPLAY_CLAIMS_PARTNER_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_DISPLAY_CLAIMS_PARTNER_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided display claims partner"
      }
    ),
    ERROR_IS_CLIENT_EDIT_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_CLIENT_EDIT_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is client edit allowed"
      }
    ),
    ERROR_IS_PARTNER_EDIT_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PARTNER_EDIT_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is partner edit allowed"
      }
    ),
    ERROR_IS_CLIENT_DOC_VIEW_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_CLIENT_DOC_VIEW_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is client doc view allowed"
      }
    ),
    ERROR_IS_PARTNER_DOC_VIEW_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PARTNER_DOC_VIEW_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is partner doc view allowed"
      }
    ),
    ERROR_IS_CLIENT_DOC_UPLOAD_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_CLIENT_DOC_UPLOAD_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is client doc upload allowed"
      }
    ),
    ERROR_IS_PARTNER_DOC_UPLOAD_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PARTNER_DOC_UPLOAD_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is partner doc upload allowed"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided bike obsolescence start in days"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_0_AT_LEAST: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_START_IN_DAYS_0_AT_LEAST",
      {
        defaultValue: "Bike obsolescence start in days must be at least 0"
      }
    ),
    ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_100_AT_MOST: trads_default.t(
      "notification.error.ERROR_BIKE_OBSOLESCENCE_PERCENTAGE_LIMIT_100_AT_MOST",
      {
        defaultValue: "Bike obsolescence percentage limit must be at most 100"
      }
    ),
    ERROR_B2B_CLAIM_MANAGEMENT_PARAMETERS_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_B2B_CLAIM_MANAGEMENT_PARAMETERS_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided b2b claim management parameters"
      }
    ),
    ERROR_IS_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_CLIENT_CANCEL_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is client cancel allowed"
      }
    ),
    ERROR_IS_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PARTNER_CANCEL_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is partner cancel allowed"
      }
    ),
    ERROR_IS_CLIENT_ABANDON_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_CLIENT_ABANDON_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is client abandon allowed"
      }
    ),
    ERROR_IS_PARTNER_ABANDON_ALLOWED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_PARTNER_ABANDON_ALLOWED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is partner abandon allowed"
      }
    ),
    ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_TOO_LOW: trads_default.t("notification.error.ERROR_PARTIAL_CLAIM_ALLOWED_COUNT_TOO_LOW", {
      defaultValue: "Partial claim allowed count must be higher than or equal to -1"
    }),
    ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_NOT_BOOL: trads_default.t(
      "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_NOT_BOOL",
      {
        defaultValue: "Duration greater than contract duration allowed must be a boolean"
      }
    ),
    ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_REQUIRED: trads_default.t(
      "notification.error.ERROR_DURATION_GREATER_THAN_CONTRACT_DURATION_ALLOWED_REQUIRED",
      {
        defaultValue: "Duration greater than contract duration allowed is required"
      }
    ),
    ERROR_AMEND_ALLOWED_NOT_BOOL: trads_default.t("notification.error.ERROR_AMEND_ALLOWED_NOT_BOOL", {
      defaultValue: "Amend allowed must be a boolean"
    }),
    ERROR_AMEND_ALLOWED_REQUIRED: trads_default.t("notification.error.ERROR_AMEND_ALLOWED_REQUIRED", {
      defaultValue: "Amend allowed is required"
    }),
    ERROR_REQUEST_STATUS_INVALID_TYPE: trads_default.t("notification.error.ERROR_REQUEST_STATUS_INVALID_TYPE", {
      defaultValue: "Request status must be an enum"
    }),
    ERROR_REQUEST_REASON_INVALID_TYPE: trads_default.t("notification.error.ERROR_REQUEST_REASON_INVALID_TYPE", {
      defaultValue: "Request reason must be an enum"
    }),
    ERROR_ARTICLE_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ARTICLE_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided article_id"
    }),
    ERROR_RECEIPTS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RECEIPTS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided receipts"
    }),
    ERROR_IS_CONFIRMED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_CONFIRMED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is_confirmed"
    }),
    ERROR_CITY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CITY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided city"
    }),
    ERROR_VEHICLE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_VEHICLE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided vehicle"
    }),
    ERROR_B2B_POLICY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_POLICY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided B2B policy"
    }),
    ERROR_ENUM_SCORING_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_ENUM_SCORING_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid format for provided scoring"
    }),
    ERROR_TRAD_CODE_INVALID_TYPE: trads_default.t("notification.error.ERROR_TRAD_CODE_INVALID_TYPE", {
      defaultValue: "Invalid format for provided trad code"
    }),
    ERROR_NEXT_PACKAGE_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_NEXT_PACKAGE_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided next_package_object"
    }),
    ERROR_PREVIOUS_PACKAGES_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_PREVIOUS_PACKAGES_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided previous_packages_object"
      }
    ),
    ERROR_SOME_REQUIRED: trads_default.t("notification.error.ERROR_SOME_REQUIRED", {
      defaultValue: "Some are required"
    }),
    ERROR_FRAUD_SCORE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_FRAUD_SCORE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided fraud score"
    }),
    ERROR_CLAIM_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CLAIM_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided claim"
    }),
    ERROR_COMMENT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMENT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided comment"
    }),
    ERROR_POLICY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_POLICY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided policy"
    }),
    ERROR_IS_DELETED_INVALID_FORMAT: trads_default.t("notification.error.ERROR_IS_DELETED_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided is_deleted"
    }),
    ERROR_COMMISSIONS_LINES_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMMISSIONS_LINES_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided commissions_lines"
    }),
    ERROR_INSURER_INVALID_TYPE: trads_default.t("notification.error.ERROR_INSURER_INVALID_TYPE", {
      defaultValue: "Invalid format for provided insurer"
    }),
    ERROR_QUOTEID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_QUOTEID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided quoteId"
    }),
    ERROR_SERIAL_NUMBER_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SERIAL_NUMBER_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided serial_number"
    }),
    ERROR_SPLITTING_TYPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SPLITTING_TYPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided splitting_type"
    }),
    ERROR_DOCUMENTS_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_DOCUMENTS_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided documents_object"
    }),
    ERROR_TOTAL_COST_INVALID_FORMAT: trads_default.t("notification.error.ERROR_TOTAL_COST_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided total_cost"
    }),
    ERROR_IS_SPONSORSHIP_CODE_USED_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_IS_SPONSORSHIP_CODE_USED_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is_sponsorship_code_used"
      }
    ),
    ERROR_COMMISSION_INVOICE_FREQUENCY_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_COMMISSION_INVOICE_FREQUENCY_INVALID_TYPE",
      {
        defaultValue: "Invalid type for commission invoice frequency"
      }
    ),
    ERROR_GROUP_TOO_RECENT: trads_default.t("notification.error.ERROR_GROUP_TOO_RECENT", {
      defaultValue: "Group is too recent to generate commissions"
    }),
    ERROR_IS_DIRECT_REIMBURSEMENT_REQUIRED: trads_default.t("notification.error.ERROR_IS_DIRECT_REIMBURSEMENT_REQUIRED", {
      defaultValue: "is_direct_reimbursement is required"
    }),
    ERROR_START_DATE_MORE_THAN_10_MINUTES_AGO: trads_default.t("notification.error.ERROR_START_DATE_MORE_THAN_10_MINUTES_AGO", {
      defaultValue: "Start date must be less than 10 minutes ago"
    }),
    ERROR_END_DATE_BEFORE_START_DATE: trads_default.t("notification.error.ERROR_END_DATE_BEFORE_START_DATE", {
      defaultValue: "End date must be after start date"
    }),
    ERROR_COMMISSION_STATUS_INVALID_TYPE: trads_default.t("notification.error.ERROR_COMMISSION_STATUS_INVALID_TYPE", {
      defaultValue: "Invalid type for provided commission status"
    }),
    ERROR_RJ_UUID_REQUIRED: trads_default.t("notification.error.ERROR_RJ_UUID_REQUIRED", {
      defaultValue: "RJ UUID is required"
    }),
    ERROR_CLAIM_PHOTO_ALREADY_USED: trads_default.t("notification.error.ERROR_CLAIM_PHOTO_ALREADY_USED", {
      defaultValue: "Claim photo already used"
    }),
    ERROR_CLAIM_PHOTO_NOT_FOUND: trads_default.t("notification.error.ERROR_CLAIM_PHOTO_NOT_FOUND", {
      defaultValue: "Claim photo not found"
    }),
    ERROR_CLAIM_PHOTO_NOT_IN_BUCKET: trads_default.t("notification.error.ERROR_CLAIM_PHOTO_NOT_IN_BUCKET", {
      defaultValue: "Claim photo not in bucket"
    }),
    ERROR_TRAJECT_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_TRAJECT_TYPE_REQUIRED", {
      defaultValue: "Trajectory type is required"
    }),
    ERROR_DISTANCE_REQUIRED: trads_default.t("notification.error.ERROR_DISTANCE_REQUIRED", {
      defaultValue: "Distance is required"
    }),
    ERROR_CYCLEWAY_PERCENTAGE_REQUIRED: trads_default.t("notification.error.ERROR_CYCLEWAY_PERCENTAGE_REQUIRED", {
      defaultValue: "Cycleway percentage is required"
    }),
    ERROR_CYCLEWAY_PERCENTAGE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_CYCLEWAY_PERCENTAGE_INVALID_FORMAT", {
      defaultValue: "Cycleway percentage must be in a correct format"
    }),
    ERROR_COORDINATES_REQUIRED: trads_default.t("notification.error.ERROR_COORDINATES_REQUIRED", {
      defaultValue: "Coordinates are required"
    }),
    ERROR_COORDINATES_INVALID_ARRAY: trads_default.t("notification.error.ERROR_COORDINATES_INVALID_ARRAY", {
      defaultValue: "Coordinates must be an array"
    }),
    ERROR_DESTINATION_REQUIRED: trads_default.t("notification.error.ERROR_DESTINATION_REQUIRED", {
      defaultValue: "Destination is required"
    }),
    ERROR_ELEVATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ELEVATION_INVALID_FORMAT", {
      defaultValue: "Elevation must be in a correct format"
    }),
    ERROR_ERROR_DESCRIPTION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ERROR_DESCRIPTION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided error description"
    }),
    ERROR_OAUTH_ERROR_INVALID_FORMAT: trads_default.t("notification.error.ERROR_OAUTH_ERROR_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided oauth error"
    }),
    ERROR_RETURN_TO_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RETURN_TO_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided return to"
    }),
    ERROR_SCOPE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SCOPE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided scope"
    }),
    ERROR_STATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_STATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided state"
    }),
    ERROR_ASSIGNED_OPS_USER_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_ASSIGNED_OPS_USER_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided assigned_ops_user_object"
      }
    ),
    ERROR_ASSIGNED_OPS_USER_ALREADY_ASSIGNED: trads_default.t("notification.error.ERROR_ASSIGNED_OPS_USER_ALREADY_ASSIGNED", {
      defaultValue: "Assigned ops user already assigned"
    }),
    ERROR_ASSIGNED_OPS_USER_ID_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ASSIGNED_OPS_USER_ID_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided assigned_ops_user_id"
    }),
    ERROR_ASSIGNED_OPS_USER_ID_REQUIRED: trads_default.t("notification.error.ERROR_ASSIGNED_OPS_USER_ID_REQUIRED", {
      defaultValue: "Assigned ops user id is required"
    }),
    ERROR_OPS_USER_DOES_NOT_EXIST: trads_default.t("notification.error.ERROR_OPS_USER_DOES_NOT_EXIST", {
      defaultValue: "Ops user does not exist"
    }),
    QONTO_TRANSFER_MISSING: trads_default.t("notification.error.QONTO_TRANSFER_MISSING_ID", {
      defaultValue: "Qonto transfer missing id"
    }),
    // Claim complaints
    ERROR_ACKNOWLEDGE_DATE_BEFORE_RECEIVED_DATE: trads_default.t(
      "notification.error.ERROR_ACKNOWLEDGE_DATE_BEFORE_RECEIVED_DATE",
      {
        defaultValue: "Acknowledge date must be after received date"
      }
    ),
    ERROR_ACKNOWLEDGE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_ACKNOWLEDGE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided acknowledge date"
    }),
    ERROR_B2B_CLAIM_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2B_CLAIM_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2b claim object"
    }),
    ERROR_B2C_CLAIM_OBJECT_INVALID_FORMAT: trads_default.t("notification.error.ERROR_B2C_CLAIM_OBJECT_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided b2c claim object"
    }),
    ERROR_CLAIM_COMPLAINT_ALREADY_EXISTS: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_ALREADY_EXISTS", {
      defaultValue: "Claim complaint already exists"
    }),
    ERROR_CLAIM_COMPLAINT_CLAIM_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_CLAIM_REQUIRED", {
      defaultValue: "No claim provided"
    }),
    ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided level 2 comment"
      }
    ),
    ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_COMMENT_LEVEL_2_REQUIRED",
      {
        defaultValue: "No level 2 comment provided"
      }
    ),
    ERROR_CLAIM_COMPLAINT_FEEDBACK_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_FEEDBACK_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided feedback"
      }
    ),
    ERROR_CLAIM_COMPLAINT_INSURER_NOT_FOUND: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_INSURER_NOT_FOUND", {
      defaultValue: "Could not resolve insurer for claim complaint"
    }),
    ERROR_CLAIM_COMPLAINT_IS_LEVEL_2_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_IS_LEVEL_2_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided is_level_2"
      }
    ),
    ERROR_CLAIM_COMPLAINT_LEVEL_2_FIELDS_REQUIRE_LEVEL_2: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_2_FIELDS_REQUIRE_LEVEL_2",
      {
        defaultValue: "Level 2 fields require complaint level 2 or higher"
      }
    ),
    ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_DECREASE: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_DECREASE",
      {
        defaultValue: "Claim complaint level can only increase"
      }
    ),
    ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_SKIP: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_CANNOT_SKIP", {
      defaultValue: "Claim complaint level can only increase by one"
    }),
    ERROR_CLAIM_COMPLAINT_LEVEL_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided level"
      }
    ),
    ERROR_CLAIM_COMPLAINT_LEVEL_REQUIRES_REJECTED_RESPONSE: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_REQUIRES_REJECTED_RESPONSE",
      {
        defaultValue: "Claim complaint level can only increase after the current level is rejected"
      }
    ),
    ERROR_CLAIM_COMPLAINT_LEVEL_TOO_HIGH: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_HIGH", {
      defaultValue: "Provided level is too high"
    }),
    ERROR_CLAIM_COMPLAINT_LEVEL_TOO_LOW: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_LEVEL_TOO_LOW", {
      defaultValue: "Provided level is too low"
    }),
    ERROR_CLAIM_COMPLAINT_OBJECT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_OBJECT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided claim complaint object"
      }
    ),
    ERROR_CLAIM_COMPLAINT_POLICY_HOLDER_INFO_MISSING: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_POLICY_HOLDER_INFO_MISSING",
      {
        defaultValue: "Policy holder information is missing"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_ALREADY_SET: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_ALREADY_SET",
      {
        defaultValue: "Claim complaint response is already set"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_DATE_LEVEL_2_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DATE_LEVEL_2_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided level 2 response date"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_ALREADY_SET: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_ALREADY_SET",
      {
        defaultValue: "Claim complaint response document is already set"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_MISSING: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_MISSING",
      {
        defaultValue: "Claim complaint response document is missing"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_DOCUMENT_REQUIRED",
      {
        defaultValue: "No claim complaint response document provided"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided response"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_ALREADY_SET: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_ALREADY_SET",
      {
        defaultValue: "Claim complaint level 2 response is already set"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_DOCUMENT_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_DOCUMENT_REQUIRED",
      {
        defaultValue: "No level 2 response document provided"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided level 2 response"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_LEVEL_2_REQUIRED",
      {
        defaultValue: "No level 2 response provided"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_REQUIRED", {
      defaultValue: "No response provided"
    }),
    ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID",
      {
        defaultValue: "Invalid claim complaint response template"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided response template"
      }
    ),
    ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_REQUIRED: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_RESPONSE_TEMPLATE_REQUIRED",
      {
        defaultValue: "No response template provided"
      }
    ),
    ERROR_CLAIM_COMPLAINT_SUBJECT_INVALID_TYPE: trads_default.t(
      "notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_INVALID_TYPE",
      {
        defaultValue: "Invalid type for provided claim complaint subject"
      }
    ),
    ERROR_CLAIM_COMPLAINT_SUBJECT_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_SUBJECT_REQUIRED", {
      defaultValue: "No claim complaint subject provided"
    }),
    ERROR_CLAIM_COMPLAINT_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided claim complaint type"
    }),
    ERROR_CLAIM_COMPLAINT_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_CLAIM_COMPLAINT_TYPE_REQUIRED", {
      defaultValue: "No claim complaint type provided"
    }),
    ERROR_COMPLAINER_ADDRESS_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMPLAINER_ADDRESS_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided complainer address"
    }),
    ERROR_COMPLAINER_ADDRESS_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_ADDRESS_REQUIRED", {
      defaultValue: "No complainer address provided"
    }),
    ERROR_COMPLAINER_CITY_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMPLAINER_CITY_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided complainer city"
    }),
    ERROR_COMPLAINER_CITY_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_CITY_REQUIRED", {
      defaultValue: "No complainer city provided"
    }),
    ERROR_COMPLAINER_FIRSTNAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMPLAINER_FIRSTNAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided complainer firstname"
    }),
    ERROR_COMPLAINER_FIRSTNAME_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_FIRSTNAME_REQUIRED", {
      defaultValue: "No complainer firstname provided"
    }),
    ERROR_COMPLAINER_LASTNAME_INVALID_FORMAT: trads_default.t("notification.error.ERROR_COMPLAINER_LASTNAME_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided complainer lastname"
    }),
    ERROR_COMPLAINER_LASTNAME_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_LASTNAME_REQUIRED", {
      defaultValue: "No complainer lastname provided"
    }),
    ERROR_COMPLAINER_TYPE_INVALID_TYPE: trads_default.t("notification.error.ERROR_COMPLAINER_TYPE_INVALID_TYPE", {
      defaultValue: "Invalid type for provided complainer type"
    }),
    ERROR_COMPLAINER_TYPE_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_TYPE_REQUIRED", {
      defaultValue: "No complainer type provided"
    }),
    ERROR_COMPLAINER_ZIPCODE_REQUIRED: trads_default.t("notification.error.ERROR_COMPLAINER_ZIPCODE_REQUIRED", {
      defaultValue: "No complainer zipcode provided"
    }),
    ERROR_FINANCIAL_DISPUTE_AMOUNT_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided financial dispute amount"
      }
    ),
    ERROR_FINANCIAL_DISPUTE_AMOUNT_TOO_LOW: trads_default.t("notification.error.ERROR_FINANCIAL_DISPUTE_AMOUNT_TOO_LOW", {
      defaultValue: "Provided financial dispute amount is too low"
    }),
    ERROR_INSURER_REQUIRED: trads_default.t("notification.error.ERROR_INSURER_REQUIRED", {
      defaultValue: "No insurer provided"
    }),
    ERROR_RECEIVED_DATE_BEFORE_SENDING_DATE: trads_default.t("notification.error.ERROR_RECEIVED_DATE_BEFORE_SENDING_DATE", {
      defaultValue: "Received date must be after sending date"
    }),
    ERROR_RECEIVED_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RECEIVED_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided received date"
    }),
    ERROR_RECEIVED_DATE_REQUIRED: trads_default.t("notification.error.ERROR_RECEIVED_DATE_REQUIRED", {
      defaultValue: "No received date provided"
    }),
    ERROR_RECEPTION_MEDIUM_EMPTY: trads_default.t("notification.error.ERROR_RECEPTION_MEDIUM_EMPTY", {
      defaultValue: "No reception medium provided"
    }),
    ERROR_RECEPTION_MEDIUM_INVALID_ARRAY: trads_default.t("notification.error.ERROR_RECEPTION_MEDIUM_INVALID_ARRAY", {
      defaultValue: "Provided reception medium not an array"
    }),
    ERROR_RECEPTION_MEDIUM_INVALID_TYPE: trads_default.t("notification.error.ERROR_RECEPTION_MEDIUM_INVALID_TYPE", {
      defaultValue: "Invalid type for provided reception medium"
    }),
    ERROR_RECEPTION_MEDIUM_REQUIRED: trads_default.t("notification.error.ERROR_RECEPTION_MEDIUM_REQUIRED", {
      defaultValue: "No reception medium provided"
    }),
    ERROR_RESPONSE_DATE_BEFORE_ACKNOWLEDGE_DATE: trads_default.t(
      "notification.error.ERROR_RESPONSE_DATE_BEFORE_ACKNOWLEDGE_DATE",
      {
        defaultValue: "Response date must be after acknowledge date"
      }
    ),
    ERROR_RESPONSE_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_RESPONSE_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided response date"
    }),
    ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_ACKNOWLEDGE_DATE: trads_default.t(
      "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_ACKNOWLEDGE_DATE",
      {
        defaultValue: "Level 2 response date must be after acknowledge date"
      }
    ),
    ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_RESPONSE_DATE: trads_default.t(
      "notification.error.ERROR_RESPONSE_DATE_LEVEL_2_BEFORE_RESPONSE_DATE",
      {
        defaultValue: "Level 2 response date must be after response date"
      }
    ),
    ERROR_RESPONSE_DATE_LEVEL_2_REQUIRED: trads_default.t("notification.error.ERROR_RESPONSE_DATE_LEVEL_2_REQUIRED", {
      defaultValue: "No level 2 response date provided"
    }),
    ERROR_RESPONSE_DATE_REQUIRED: trads_default.t("notification.error.ERROR_RESPONSE_DATE_REQUIRED", {
      defaultValue: "No response date provided"
    }),
    ERROR_SENDING_DATE_INVALID_FORMAT: trads_default.t("notification.error.ERROR_SENDING_DATE_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided sending date"
    }),
    ERROR_SENDING_DATE_REQUIRED: trads_default.t("notification.error.ERROR_SENDING_DATE_REQUIRED", {
      defaultValue: "No sending date provided"
    }),
    ERROR_WITH_MEDIATION_INVALID_FORMAT: trads_default.t("notification.error.ERROR_WITH_MEDIATION_INVALID_FORMAT", {
      defaultValue: "Invalid format for provided with mediation"
    }),
    ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_FORMAT: trads_default.t(
      "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_FORMAT",
      {
        defaultValue: "Invalid format for provided customer support ref link"
      }
    ),
    ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_URL: trads_default.t(
      "notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_INVALID_URL",
      {
        defaultValue: "Invalid URL for provided customer support ref link"
      }
    ),
    ERROR_CUSTOMER_SUPPORT_REF_LINK_REQUIRED: trads_default.t("notification.error.ERROR_CUSTOMER_SUPPORT_REF_LINK_REQUIRED", {
      defaultValue: "No customer support ref link provided"
    })
  }[key];
}, "getTranslations");

// src/lib/enums.ts
var PolicyStatus = /* @__PURE__ */ ((PolicyStatus2) => {
  PolicyStatus2["ACTIVE"] = "ACTIVE";
  PolicyStatus2["TERMINATED"] = "TERMINATED";
  PolicyStatus2["ENDED"] = "ENDED";
  PolicyStatus2["WITHOUT_EFFECT"] = "WITHOUT_EFFECT";
  PolicyStatus2["SUSPENDED"] = "SUSPENDED";
  PolicyStatus2["PENDING"] = "PENDING";
  PolicyStatus2["PROGRAMMED"] = "PROGRAMMED";
  PolicyStatus2["PENDING_RECONDUCT"] = "PENDING_RECONDUCT";
  return PolicyStatus2;
})(PolicyStatus || {});
var CriteriaStatus = /* @__PURE__ */ ((CriteriaStatus2) => {
  CriteriaStatus2["VALID"] = "VALID";
  CriteriaStatus2["INVALID"] = "INVALID";
  CriteriaStatus2["VERIFIED"] = "VERIFIED";
  return CriteriaStatus2;
})(CriteriaStatus || {});
var ReceiptsPaymentsStatus = /* @__PURE__ */ ((ReceiptsPaymentsStatus2) => {
  ReceiptsPaymentsStatus2["CREATED"] = "CREATED";
  ReceiptsPaymentsStatus2["CANCEL"] = "CANCEL";
  ReceiptsPaymentsStatus2["EMITTED"] = "EMITTED";
  ReceiptsPaymentsStatus2["INVOICE_CREATED"] = "INVOICE_CREATED";
  ReceiptsPaymentsStatus2["INVOICE_PAID"] = "INVOICE_PAID";
  ReceiptsPaymentsStatus2["ISSUED"] = "ISSUED";
  ReceiptsPaymentsStatus2["PAID_CLAIM"] = "PAID_CLAIM";
  ReceiptsPaymentsStatus2["VOID"] = "VOID";
  return ReceiptsPaymentsStatus2;
})(ReceiptsPaymentsStatus || {});
var B2bUsage = /* @__PURE__ */ ((B2bUsage2) => {
  B2bUsage2["AFFECT_BIKE"] = "AFFECT_BIKE";
  B2bUsage2["SHORT_TERM"] = "SHORT_TERM";
  B2bUsage2["SELF_SERVICE"] = "SELF_SERVICE";
  return B2bUsage2;
})(B2bUsage || {});
var TimePeriod = /* @__PURE__ */ ((TimePeriod2) => {
  TimePeriod2["DAYS"] = "DAYS";
  TimePeriod2["MONTHS"] = "MONTHS";
  TimePeriod2["YEARS"] = "YEARS";
  return TimePeriod2;
})(TimePeriod || {});
var CoverageNeedsEnum = /* @__PURE__ */ ((CoverageNeedsEnum2) => {
  CoverageNeedsEnum2["THEFT"] = "THEFT";
  CoverageNeedsEnum2["DAMAGE"] = "DAMAGE";
  CoverageNeedsEnum2["ASSISTANCE"] = "ASSISTANCE";
  return CoverageNeedsEnum2;
})(CoverageNeedsEnum || {});
var EstimatedVehicleCountEnum = /* @__PURE__ */ ((EstimatedVehicleCountEnum2) => {
  EstimatedVehicleCountEnum2["ONE_TO_TEN"] = "ONE_TO_TEN";
  EstimatedVehicleCountEnum2["ELEVEN_TO_FIFTY"] = "ELEVEN_TO_FIFTY";
  EstimatedVehicleCountEnum2["MORE_THAN_FIFTY"] = "MORE_THAN_FIFTY";
  return EstimatedVehicleCountEnum2;
})(EstimatedVehicleCountEnum || {});
var B2bOnboardingTypeEnum = /* @__PURE__ */ ((B2bOnboardingTypeEnum2) => {
  B2bOnboardingTypeEnum2["INSURE_BIKES"] = "INSURE_BIKES";
  B2bOnboardingTypeEnum2["RESELL_SHARELOCK"] = "RESELL_SHARELOCK";
  B2bOnboardingTypeEnum2["OTHERS"] = "OTHERS";
  return B2bOnboardingTypeEnum2;
})(B2bOnboardingTypeEnum || {});
var EstimatedPolicyCountEnum = /* @__PURE__ */ ((EstimatedPolicyCountEnum2) => {
  EstimatedPolicyCountEnum2["ONE_TO_FIFTY"] = "ONE_TO_FIFTY";
  EstimatedPolicyCountEnum2["FIFTY_ONE_TO_HUNDRED"] = "FIFTY_ONE_TO_HUNDRED";
  EstimatedPolicyCountEnum2["MORE_THAN_HUNDRED"] = "MORE_THAN_HUNDRED";
  return EstimatedPolicyCountEnum2;
})(EstimatedPolicyCountEnum || {});
var ResellTypeEnum = /* @__PURE__ */ ((ResellTypeEnum2) => {
  ResellTypeEnum2["BROKER"] = "BROKER";
  ResellTypeEnum2["OTHERS"] = "OTHERS";
  return ResellTypeEnum2;
})(ResellTypeEnum || {});
var Splitting = /* @__PURE__ */ ((Splitting2) => {
  Splitting2["ANNUAL"] = "ANNUAL";
  Splitting2["MONTHLY"] = "MONTHLY";
  Splitting2["DAILY"] = "DAILY";
  Splitting2["FULL"] = "FULL";
  return Splitting2;
})(Splitting || {});
var ContractStatus = /* @__PURE__ */ ((ContractStatus2) => {
  ContractStatus2["ACTIVE"] = "ACTIVE";
  ContractStatus2["CLOSED"] = "CLOSED";
  ContractStatus2["DEFAULT"] = "DEFAULT";
  return ContractStatus2;
})(ContractStatus || {});
var PaymentMethods = /* @__PURE__ */ ((PaymentMethods2) => {
  PaymentMethods2["CARD"] = "CARD";
  PaymentMethods2["SEPA"] = "SEPA";
  return PaymentMethods2;
})(PaymentMethods || {});
var AuditEventEnum = /* @__PURE__ */ ((AuditEventEnum2) => {
  AuditEventEnum2["USER"] = "USER";
  AuditEventEnum2["PARTNER"] = "PARTNER";
  AuditEventEnum2["LAMBDA"] = "LAMBDA";
  AuditEventEnum2["STRIPE_WEBHOOK"] = "STRIPE_WEBHOOK";
  AuditEventEnum2["BREVO_WEBHOOK"] = "BREVO_WEBHOOK";
  return AuditEventEnum2;
})(AuditEventEnum || {});
var ScoreEnum = /* @__PURE__ */ ((ScoreEnum2) => {
  ScoreEnum2["CLAIM"] = "CLAIM";
  ScoreEnum2["POLICY"] = "POLICY";
  return ScoreEnum2;
})(ScoreEnum || {});
var RolesEnum = /* @__PURE__ */ ((RolesEnum2) => {
  RolesEnum2["Admin"] = "Admin";
  RolesEnum2["TechManager"] = "TechManager";
  RolesEnum2["InsuranceManager"] = "InsuranceManager";
  RolesEnum2["LockManager"] = "LockManager";
  RolesEnum2["CentralManager"] = "CentralManager";
  RolesEnum2["CustomerSupportManager"] = "CustomerSupportManager";
  RolesEnum2["Anonymous"] = "Anonymous";
  RolesEnum2["Partner"] = "Partner";
  RolesEnum2["FraudPartner"] = "FraudPartner";
  RolesEnum2["Authenticated"] = "Authenticated";
  RolesEnum2["Ops"] = "Ops";
  RolesEnum2["Tech"] = "Tech";
  RolesEnum2["Insurance"] = "Insurance";
  RolesEnum2["Lock"] = "Lock";
  RolesEnum2["Central"] = "Central";
  RolesEnum2["CustomerSupport"] = "CustomerSupport";
  RolesEnum2["Finance"] = "Finance";
  return RolesEnum2;
})(RolesEnum || {});
var GroupMemberRolesEnum = /* @__PURE__ */ ((GroupMemberRolesEnum2) => {
  GroupMemberRolesEnum2["Member"] = "Member";
  GroupMemberRolesEnum2["BicycleUser"] = "BicycleUser";
  GroupMemberRolesEnum2["BicycleManagerReadOnly"] = "BicycleManagerReadOnly";
  GroupMemberRolesEnum2["BicycleClaimManagerReadOnly"] = "BicycleClaimManagerReadOnly";
  GroupMemberRolesEnum2["BicycleManager"] = "BicycleManager";
  GroupMemberRolesEnum2["BicycleClaimManager"] = "BicycleClaimManager";
  GroupMemberRolesEnum2["BrokerReadOnly"] = "BrokerReadOnly";
  GroupMemberRolesEnum2["BrokerClaimManagerReadOnly"] = "BrokerClaimManagerReadOnly";
  GroupMemberRolesEnum2["Broker"] = "Broker";
  GroupMemberRolesEnum2["BrokerClaimManager"] = "BrokerClaimManager";
  GroupMemberRolesEnum2["Mycroft"] = "Mycroft";
  GroupMemberRolesEnum2["Tech"] = "Tech";
  GroupMemberRolesEnum2["FinanceReadOnly"] = "FinanceReadOnly";
  GroupMemberRolesEnum2["Finance"] = "Finance";
  GroupMemberRolesEnum2["Admin"] = "Admin";
  GroupMemberRolesEnum2["Owner"] = "Owner";
  return GroupMemberRolesEnum2;
})(GroupMemberRolesEnum || {});
var GroupTypology = /* @__PURE__ */ ((GroupTypology2) => {
  GroupTypology2["BROKER"] = "BROKER";
  GroupTypology2["PHYSICAL_STORE"] = "PHYSICAL_STORE";
  GroupTypology2["ONLINE_STORE"] = "ONLINE_STORE";
  GroupTypology2["BIKE_RENTAL"] = "BIKE_RENTAL";
  GroupTypology2["INTRODUCER"] = "INTRODUCER";
  GroupTypology2["LEASER"] = "LEASER";
  GroupTypology2["LOCAL_AUTHORITY"] = "LOCAL_AUTHORITY";
  GroupTypology2["ENTERPRISE"] = "ENTERPRISE";
  GroupTypology2["SELF_EMPLOYED"] = "SELF_EMPLOYED";
  return GroupTypology2;
})(GroupTypology || {});
var ExpectedPolicyType = /* @__PURE__ */ ((ExpectedPolicyType2) => {
  ExpectedPolicyType2["B2B2C"] = "B2B2C";
  ExpectedPolicyType2["B2B2B"] = "B2B2B";
  return ExpectedPolicyType2;
})(ExpectedPolicyType || {});
var FraudTagType = /* @__PURE__ */ ((FraudTagType2) => {
  FraudTagType2["FRAUD"] = "FRAUD";
  FraudTagType2["MISTAKE"] = "MISTAKE";
  return FraudTagType2;
})(FraudTagType || {});
var DangerosityLevel = /* @__PURE__ */ ((DangerosityLevel2) => {
  DangerosityLevel2["Low"] = "Low";
  DangerosityLevel2["Medium"] = "Medium";
  DangerosityLevel2["High"] = "High";
  DangerosityLevel2["Dangerous"] = "Dangerous";
  return DangerosityLevel2;
})(DangerosityLevel || {});
var CancelInsuranceReason = /* @__PURE__ */ ((CancelInsuranceReason2) => {
  CancelInsuranceReason2["SELL_BIKE"] = "SELL_BIKE";
  CancelInsuranceReason2["LOSS_BIKE"] = "LOSS_BIKE";
  CancelInsuranceReason2["TIME_USE_BIKE"] = "TIME_USE_BIKE";
  CancelInsuranceReason2["RETRACTION"] = "RETRACTION";
  CancelInsuranceReason2["OTHER"] = "OTHER";
  CancelInsuranceReason2["DUE_DATE"] = "DUE_DATE";
  CancelInsuranceReason2["HOUSE_MOVE"] = "HOUSE_MOVE";
  CancelInsuranceReason2["BIKE_FULLY_DAMAGED"] = "BIKE_FULLY_DAMAGED";
  CancelInsuranceReason2["CHANGE_USAGE"] = "CHANGE_USAGE";
  CancelInsuranceReason2["MISS_MONEY"] = "MISS_MONEY";
  CancelInsuranceReason2["BETTER_INSURANCE"] = "BETTER_INSURANCE";
  CancelInsuranceReason2["SITUATION_CHANGE"] = "SITUATION_CHANGE";
  CancelInsuranceReason2["PROFESSIONAL_CHANGE"] = "PROFESSIONAL_CHANGE";
  CancelInsuranceReason2["INSATISFACTION"] = "INSATISFACTION";
  CancelInsuranceReason2["FAILURE_TO_PAY"] = "FAILURE_TO_PAY";
  CancelInsuranceReason2["BIKE_STOLEN"] = "BIKE_STOLEN";
  return CancelInsuranceReason2;
})(CancelInsuranceReason || {});
var InsuranceClaimCoverageCodeType = /* @__PURE__ */ ((InsuranceClaimCoverageCodeType2) => {
  InsuranceClaimCoverageCodeType2["CATNAT"] = "CATNAT";
  InsuranceClaimCoverageCodeType2["DAMAGE_PARTIAL"] = "DAMAGE_PARTIAL";
  InsuranceClaimCoverageCodeType2["DAMAGE"] = "DAMAGE";
  InsuranceClaimCoverageCodeType2["THEFT"] = "THEFT";
  InsuranceClaimCoverageCodeType2["THEFT_PARTIAL"] = "THEFT_PARTIAL";
  InsuranceClaimCoverageCodeType2["PERSONAL_DAMAGE"] = "PERSONAL_DAMAGE";
  InsuranceClaimCoverageCodeType2["VANDALISM"] = "VANDALISM";
  InsuranceClaimCoverageCodeType2["VANDALISM_PARTIAL"] = "VANDALISM_PARTIAL";
  InsuranceClaimCoverageCodeType2["PREMIUM_SUPPORT"] = "PREMIUM_SUPPORT";
  return InsuranceClaimCoverageCodeType2;
})(InsuranceClaimCoverageCodeType || {});
var ClaimStatusEnum = /* @__PURE__ */ ((ClaimStatusEnum2) => {
  ClaimStatusEnum2["OPEN"] = "OPEN";
  ClaimStatusEnum2["REJECTED"] = "REJECTED";
  ClaimStatusEnum2["ABANDONED"] = "ABANDONED";
  ClaimStatusEnum2["BIKE_RETURNED"] = "BIKE_RETURNED";
  ClaimStatusEnum2["FROZEN"] = "FROZEN";
  ClaimStatusEnum2["VALIDATED_ON_QUOTE"] = "VALIDATED_ON_QUOTE";
  ClaimStatusEnum2["TO_PAY"] = "TO_PAY";
  ClaimStatusEnum2["PAID"] = "PAID";
  ClaimStatusEnum2["COMPLETE"] = "COMPLETE";
  ClaimStatusEnum2["LAST_CHECK"] = "LAST_CHECK";
  ClaimStatusEnum2["RISK_CHECK"] = "RISK_CHECK";
  ClaimStatusEnum2["USER_CHECK"] = "USER_CHECK";
  return ClaimStatusEnum2;
})(ClaimStatusEnum || {});
var InsuranceClaimRejectCancelCondition = /* @__PURE__ */ ((InsuranceClaimRejectCancelCondition2) => {
  InsuranceClaimRejectCancelCondition2["TERMINATION_NO_REFUND"] = "TERMINATION_NO_REFUND";
  InsuranceClaimRejectCancelCondition2["TERMINATION_WITH_REFUND"] = "TERMINATION_WITH_REFUND";
  InsuranceClaimRejectCancelCondition2["NO_TERMINATION"] = "NO_TERMINATION";
  return InsuranceClaimRejectCancelCondition2;
})(InsuranceClaimRejectCancelCondition || {});
var ReimbursementType = /* @__PURE__ */ ((ReimbursementType2) => {
  ReimbursementType2["NEW_BIKE_INVOICE"] = "NEW_BIKE_INVOICE";
  ReimbursementType2["VOUCHER"] = "VOUCHER";
  ReimbursementType2["DIRECT_PAYMENT"] = "DIRECT_PAYMENT";
  return ReimbursementType2;
})(ReimbursementType || {});
var PremiumSupportType = /* @__PURE__ */ ((PremiumSupportType2) => {
  PremiumSupportType2["BATTERY_DEFAULT"] = "BATTERY_DEFAULT";
  PremiumSupportType2["TIRE_DEFAULT"] = "TIRE_DEFAULT";
  return PremiumSupportType2;
})(PremiumSupportType || {});
var PackageSource = /* @__PURE__ */ ((PackageSource2) => {
  PackageSource2["B2C"] = "B2C";
  PackageSource2["B2B"] = "B2B";
  PackageSource2["B2B2C"] = "B2B2C";
  return PackageSource2;
})(PackageSource || {});
var TradCode = /* @__PURE__ */ ((TradCode2) => {
  TradCode2["BASIC"] = "BASIC";
  TradCode2["TOTAL_THEFT"] = "TOTAL_THEFT";
  TradCode2["THEFT"] = "THEFT";
  TradCode2["THEFT_PARTIAL"] = "THEFT_PARTIAL";
  TradCode2["DAMAGE"] = "DAMAGE";
  TradCode2["DAMAGE_PARTIAL"] = "DAMAGE_PARTIAL";
  TradCode2["THEFT_AND_DAMAGE"] = "THEFT_AND_DAMAGE";
  TradCode2["THEFT_DAMAGE_AND_ASSISTANCE"] = "THEFT_DAMAGE_AND_ASSISTANCE";
  TradCode2["TOTAL_THEFT_AND_TOTAL_DAMAGE"] = "TOTAL_THEFT_AND_TOTAL_DAMAGE";
  TradCode2["IA"] = "IA";
  TradCode2["SUPPORT"] = "SUPPORT";
  TradCode2["PREMIUM_SUPPORT"] = "PREMIUM_SUPPORT";
  TradCode2["ASSISTANCE"] = "ASSISTANCE";
  TradCode2["ASSISTANCE_PREMIUM"] = "ASSISTANCE_PREMIUM";
  TradCode2["ACCIDENT"] = "ACCIDENT";
  TradCode2["CIVIL_LIABILITY"] = "CIVIL_LIABILITY";
  TradCode2["VLX"] = "VLX";
  TradCode2["DOM"] = "DOM";
  TradCode2["CATNAT"] = "CATNAT";
  TradCode2["PEP"] = "PEP";
  TradCode2["CATECH"] = "CATECH";
  TradCode2["GROUP_ACCIDENT"] = "GROUP_ACCIDENT";
  return TradCode2;
})(TradCode || {});
var CoverageCode = /* @__PURE__ */ ((CoverageCode2) => {
  CoverageCode2["ASSISTANCE"] = "ASSISTANCE";
  CoverageCode2["Accident_HEYME"] = "Accident_HEYME";
  CoverageCode2["Accident_IMA"] = "Accident_IMA";
  return CoverageCode2;
})(CoverageCode || {});
var QuoteStatus = /* @__PURE__ */ ((QuoteStatus2) => {
  QuoteStatus2["OPEN"] = "OPEN";
  QuoteStatus2["SIGNED"] = "SIGNED";
  QuoteStatus2["FINISHED"] = "FINISHED";
  QuoteStatus2["ABANDONED"] = "ABANDONED";
  return QuoteStatus2;
})(QuoteStatus || {});
var QuoteStepEnum = /* @__PURE__ */ ((QuoteStepEnum2) => {
  QuoteStepEnum2["PRICE_ZIP"] = "PRICE_ZIP";
  QuoteStepEnum2["OFFER"] = "OFFER";
  QuoteStepEnum2["OPTIONS"] = "OPTIONS";
  QuoteStepEnum2["MY_BIKE"] = "MY_BIKE";
  QuoteStepEnum2["MY_LOCK"] = "MY_LOCK";
  QuoteStepEnum2["AUTH"] = "AUTH";
  QuoteStepEnum2["CONFIRM_EMAIL"] = "CONFIRM_EMAIL";
  QuoteStepEnum2["SIGN_CONTRACT"] = "SIGN_CONTRACT";
  QuoteStepEnum2["PAYMENT"] = "PAYMENT";
  QuoteStepEnum2["FINISH"] = "FINISH";
  QuoteStepEnum2["MISSING_INFO"] = "MISSING_INFO";
  QuoteStepEnum2["THEFT_VALIDATION"] = "THEFT_VALIDATION";
  return QuoteStepEnum2;
})(QuoteStepEnum || {});
var CustomerStripeStatus = /* @__PURE__ */ ((CustomerStripeStatus2) => {
  CustomerStripeStatus2["INVOICE_UNPAID"] = "INVOICE_UNPAID";
  CustomerStripeStatus2["CARD_NO_DEFAULT"] = "CARD_NO_DEFAULT";
  CustomerStripeStatus2["CARD_EXPIRED"] = "CARD_EXPIRED";
  CustomerStripeStatus2["CARD_SOON_EXPIRED"] = "CARD_SOON_EXPIRED";
  CustomerStripeStatus2["OK"] = "OK";
  return CustomerStripeStatus2;
})(CustomerStripeStatus || {});
var CoverageEnum = /* @__PURE__ */ ((CoverageEnum2) => {
  CoverageEnum2["Theft"] = "Theft";
  CoverageEnum2["Damage"] = "Damage";
  CoverageEnum2["Theft&Damage"] = "Theft&Damage";
  CoverageEnum2["Support"] = "Support";
  CoverageEnum2["PremiumSupport"] = "PremiumSupport";
  CoverageEnum2["THEFT_CHUBB"] = "THEFT_CHUBB";
  CoverageEnum2["DAMAGE_CHUBB"] = "DAMAGE_CHUBB";
  CoverageEnum2["THEFT_AND_DAMAGE_CHUBB"] = "THEFT_AND_DAMAGE_CHUBB";
  CoverageEnum2["SUPPORT_CHUBB"] = "SUPPORT_CHUBB";
  CoverageEnum2["PREMIUMSUPPORT_CHUBB"] = "PREMIUMSUPPORT_CHUBB";
  CoverageEnum2["IA"] = "Ia";
  CoverageEnum2["CARGO_VELIGO_THEFT_AND_DAMAGE"] = "CARGO_VELIGO_THEFT_AND_DAMAGE";
  CoverageEnum2["CARGO_VELIGO_THEFT"] = "CARGO_VELIGO_THEFT";
  CoverageEnum2["VAE_VELIGO_THEFT_AND_DAMAGE"] = "VAE_VELIGO_THEFT_AND_DAMAGE";
  CoverageEnum2["VAE_VELIGO_THEFT"] = "VAE_VELIGO_THEFT";
  CoverageEnum2["Theft&Damages_CARMA"] = "Theft&Damages_CARMA";
  CoverageEnum2["Damages_CARMA"] = "Damages_CARMA";
  return CoverageEnum2;
})(CoverageEnum || {});
var UploadDocumentType = /* @__PURE__ */ ((UploadDocumentType2) => {
  UploadDocumentType2["ACCESSORIE_INVOICE"] = "ACCESSORIE_INVOICE";
  UploadDocumentType2["DAMAGED_BIKE_PHOTO"] = "DAMAGED_BIKE_PHOTO";
  UploadDocumentType2["KBIS"] = "KBIS";
  UploadDocumentType2["LOCK_INVOICE"] = "LOCK_INVOICE";
  UploadDocumentType2["MARKING_CODE_CERTIFICATE"] = "MARKING_CODE_CERTIFICATE";
  UploadDocumentType2["OTHER"] = "OTHER";
  UploadDocumentType2["OTHER_CLAIM"] = "OTHER_CLAIM";
  UploadDocumentType2["OTHER_VEHICLE"] = "OTHER_VEHICLE";
  UploadDocumentType2["OTHER_PERSONAL_LOCK"] = "OTHER_PERSONAL_LOCK";
  UploadDocumentType2["NEW_BIKE_INVOICE"] = "NEW_BIKE_INVOICE";
  UploadDocumentType2["NON_COVERAGE_CERTIFICATE"] = "NON_COVERAGE_CERTIFICATE";
  UploadDocumentType2["PARTNER_KEY_BATTERY_HANDOVER_CERTIFICATE"] = "PARTNER_KEY_BATTERY_HANDOVER_CERTIFICATE";
  UploadDocumentType2["PRE_SINISTER_COMPLAINT"] = "PRE_SINISTER_COMPLAINT";
  UploadDocumentType2["POLICY_RESILIATION_PROOF"] = "POLICY_RESILIATION_PROOF";
  UploadDocumentType2["PREMIUM_SUPPORT_PROOF"] = "PREMIUM_SUPPORT_PROOF";
  UploadDocumentType2["REPAIR_QUOTE"] = "REPAIR_QUOTE";
  UploadDocumentType2["SINISTER_COMPLAINT"] = "SINISTER_COMPLAINT";
  UploadDocumentType2["SINISTER_QUOTE"] = "SINISTER_QUOTE";
  UploadDocumentType2["SINISTER_REIMBURSEMENT_PROOF"] = "SINISTER_REIMBURSEMENT_PROOF";
  UploadDocumentType2["SINISTER_STATEMENT"] = "SINISTER_STATEMENT";
  UploadDocumentType2["SUPPORT_TRANSPORTATION_PROOF"] = "SUPPORT_TRANSPORTATION_PROOF";
  UploadDocumentType2["SUPPORT_BIKE_RENTAL_INVOICE"] = "SUPPORT_BIKE_RENTAL_INVOICE";
  UploadDocumentType2["USER_IBAN"] = "USER_IBAN";
  UploadDocumentType2["USER_ADDRESS"] = "USER_ADDRESS";
  UploadDocumentType2["USER_ID"] = "USER_ID";
  UploadDocumentType2["VEHICLE_INVOICE"] = "VEHICLE_INVOICE";
  UploadDocumentType2["VEHICLE_CERTIFICATE"] = "VEHICLE_CERTIFICATE";
  UploadDocumentType2["VELIGO_INVOICE_TO_INSURER"] = "VELIGO_INVOICE_TO_INSURER";
  UploadDocumentType2["VELIGO_PAID_FRANCHISE_INVOICE"] = "VELIGO_PAID_FRANCHISE_INVOICE";
  UploadDocumentType2["VELIGO_INTERVENTION_REPORT"] = "VELIGO_INTERVENTION_REPORT";
  return UploadDocumentType2;
})(UploadDocumentType || {});
var DocumentStatus = /* @__PURE__ */ ((DocumentStatus2) => {
  DocumentStatus2["RECEIVED"] = "RECEIVED";
  DocumentStatus2["VALIDATED"] = "VALIDATED";
  DocumentStatus2["REJECTED"] = "REJECTED";
  DocumentStatus2["INFORMED"] = "INFORMED";
  return DocumentStatus2;
})(DocumentStatus || {});
var NotificationPriorityEnum = /* @__PURE__ */ ((NotificationPriorityEnum2) => {
  NotificationPriorityEnum2["LOW"] = "LOW";
  NotificationPriorityEnum2["MEDIUM"] = "MEDIUM";
  NotificationPriorityEnum2["HIGH"] = "HIGH";
  return NotificationPriorityEnum2;
})(NotificationPriorityEnum || {});
var NotificationTypeEnum = /* @__PURE__ */ ((NotificationTypeEnum2) => {
  NotificationTypeEnum2["DOC_REJECTED"] = "DOC_REJECTED";
  NotificationTypeEnum2["DOC_INFORMED"] = "DOC_INFORMED";
  NotificationTypeEnum2["CLAIM_CREATED"] = "CLAIM_CREATED";
  NotificationTypeEnum2["CLAIM_CLOSED"] = "CLAIM_CLOSED";
  NotificationTypeEnum2["CLAIM_QUOTE_VALIDATED"] = "CLAIM_QUOTE_VALIDATED";
  NotificationTypeEnum2["CLAIM_VALIDATED"] = "CLAIM_VALIDATED";
  NotificationTypeEnum2["CLAIM_USER_CHECK"] = "CLAIM_USER_CHECK";
  NotificationTypeEnum2["CLAIM_PAID"] = "CLAIM_PAID";
  NotificationTypeEnum2["CARD_EXPIRED"] = "CARD_EXPIRED";
  NotificationTypeEnum2["CARD_SOON_EXPIRED"] = "CARD_SOON_EXPIRED";
  NotificationTypeEnum2["CARD_NO_DEFAULT"] = "CARD_NO_DEFAULT";
  NotificationTypeEnum2["INVOICE_UNPAID"] = "INVOICE_UNPAID";
  NotificationTypeEnum2["POLICY_SUSPENDED"] = "POLICY_SUSPENDED";
  NotificationTypeEnum2["POLICY_TERMINATED"] = "POLICY_TERMINATED";
  NotificationTypeEnum2["POLICY_RENEWED"] = "POLICY_RENEWED";
  NotificationTypeEnum2["POLICY_CANCEL_PERIOD_END"] = "POLICY_CANCEL_PERIOD_END";
  NotificationTypeEnum2["POLICY_CANCEL_MONTH_END"] = "POLICY_CANCEL_MONTH_END";
  NotificationTypeEnum2["PLS_AUTO_TERMINATED"] = "PLS_AUTO_TERMINATED";
  NotificationTypeEnum2["LS_TERMINATED"] = "LS_TERMINATED";
  NotificationTypeEnum2["CUSTOM_PROMO"] = "CUSTOM_PROMO";
  NotificationTypeEnum2["CUSTOM_INFO"] = "CUSTOM_INFO";
  NotificationTypeEnum2["APP_UPDATE"] = "APP_UPDATE";
  NotificationTypeEnum2["BIKE_INVALID_CODE"] = "BIKE_INVALID_CODE";
  NotificationTypeEnum2["BIKE_INVALID_APIC_STATUS"] = "BIKE_INVALID_APIC_STATUS";
  NotificationTypeEnum2["PLS_BATTERY_NOT_REMOVED"] = "PLS_BATTERY_NOT_REMOVED";
  NotificationTypeEnum2["PLS_WHEEL_ONLY"] = "PLS_WHEEL_ONLY";
  NotificationTypeEnum2["PLS_INCORRECTLY_PARKED"] = "PLS_INCORRECTLY_PARKED";
  return NotificationTypeEnum2;
})(NotificationTypeEnum || {});
var BikeStatusEnum = /* @__PURE__ */ ((BikeStatusEnum2) => {
  BikeStatusEnum2["PENDING"] = "PENDING";
  BikeStatusEnum2["ACTIVE"] = "ACTIVE";
  BikeStatusEnum2["STOLEN"] = "STOLEN";
  BikeStatusEnum2["DESTROYED"] = "DESTROYED";
  BikeStatusEnum2["UNKNOWN"] = "UNKNOWN";
  BikeStatusEnum2["NOT_REGISTERED"] = "NOT_REGISTERED";
  BikeStatusEnum2["NON_ATTRIBUTED"] = "NON_ATTRIBUTED";
  BikeStatusEnum2["FOR_SELL"] = "FOR_SELL";
  return BikeStatusEnum2;
})(BikeStatusEnum || {});
var PolicyCancelRequestStatus = /* @__PURE__ */ ((PolicyCancelRequestStatus2) => {
  PolicyCancelRequestStatus2["OPEN"] = "OPEN";
  PolicyCancelRequestStatus2["GRANTED"] = "GRANTED";
  PolicyCancelRequestStatus2["REJECTED"] = "REJECTED";
  PolicyCancelRequestStatus2["CANCEL"] = "CANCEL";
  return PolicyCancelRequestStatus2;
})(PolicyCancelRequestStatus || {});
var ActivityTypeEnum = /* @__PURE__ */ ((ActivityTypeEnum2) => {
  ActivityTypeEnum2["still"] = "still";
  ActivityTypeEnum2["on_foot"] = "on_foot";
  ActivityTypeEnum2["walking"] = "walking";
  ActivityTypeEnum2["running"] = "running";
  ActivityTypeEnum2["in_vehicle"] = "in_vehicle";
  ActivityTypeEnum2["on_bicycle"] = "on_bicycle";
  ActivityTypeEnum2["unknown"] = "unknown";
  return ActivityTypeEnum2;
})(ActivityTypeEnum || {});
var PlsDangerLevel = /* @__PURE__ */ ((PlsDangerLevel2) => {
  PlsDangerLevel2["Low"] = "Low";
  PlsDangerLevel2["Medium"] = "Medium";
  PlsDangerLevel2["High"] = "High";
  PlsDangerLevel2["Dangerous"] = "Dangerous";
  PlsDangerLevel2["DangerousAndWarned"] = "DangerousAndWarned";
  PlsDangerLevel2["NoData"] = "NoData";
  PlsDangerLevel2["Deactivated"] = "Deactivated";
  return PlsDangerLevel2;
})(PlsDangerLevel || {});
var PartnerInvoicesPaymentsStatus = /* @__PURE__ */ ((PartnerInvoicesPaymentsStatus2) => {
  PartnerInvoicesPaymentsStatus2["CREATED"] = "CREATED";
  PartnerInvoicesPaymentsStatus2["CANCEL"] = "CANCEL";
  PartnerInvoicesPaymentsStatus2["INVOICE_PAID"] = "INVOICE_PAID";
  PartnerInvoicesPaymentsStatus2["INVOICE_SENT"] = "INVOICE_SENT";
  PartnerInvoicesPaymentsStatus2["VOID"] = "VOID";
  return PartnerInvoicesPaymentsStatus2;
})(PartnerInvoicesPaymentsStatus || {});
var TernaryChoiceEnum = /* @__PURE__ */ ((TernaryChoiceEnum2) => {
  TernaryChoiceEnum2["YES"] = "YES";
  TernaryChoiceEnum2["NO"] = "NO";
  TernaryChoiceEnum2["OPTIONAL"] = "OPTIONAL";
  return TernaryChoiceEnum2;
})(TernaryChoiceEnum || {});
var OpsChecksEnum = /* @__PURE__ */ ((OpsChecksEnum2) => {
  OpsChecksEnum2["PARKING_LOCATION_CHECK"] = "PARKING_LOCATION_CHECK";
  OpsChecksEnum2["USER_CALL_CHECK"] = "USER_CALL_CHECK";
  OpsChecksEnum2["SHOP_CALL_CHECK"] = "SHOP_CALL_CHECK";
  OpsChecksEnum2["DECLARATION_CONSISTENCY_CHECK"] = "DECLARATION_CONSISTENCY_CHECK";
  OpsChecksEnum2["PAST_CLAIMS_BATTERY_CHECK"] = "PAST_CLAIMS_BATTERY_CHECK";
  OpsChecksEnum2["PLS_CHECK"] = "PLS_CHECK";
  return OpsChecksEnum2;
})(OpsChecksEnum || {});
var OptionalQuoteChecksEnum = /* @__PURE__ */ ((OptionalQuoteChecksEnum2) => {
  OptionalQuoteChecksEnum2["USER_UNDERAGE"] = "USER_UNDERAGE";
  return OptionalQuoteChecksEnum2;
})(OptionalQuoteChecksEnum || {});
var StatisticsRangeEnum = /* @__PURE__ */ ((StatisticsRangeEnum2) => {
  StatisticsRangeEnum2["WEEK"] = "WEEK";
  StatisticsRangeEnum2["MONTH"] = "MONTH";
  StatisticsRangeEnum2["YEAR"] = "YEAR";
  StatisticsRangeEnum2["GLOBAL"] = "GLOBAL";
  return StatisticsRangeEnum2;
})(StatisticsRangeEnum || {});
var CaloriesChartTypeEnum = /* @__PURE__ */ ((CaloriesChartTypeEnum2) => {
  CaloriesChartTypeEnum2["WEEK"] = "WEEK";
  CaloriesChartTypeEnum2["MONTH"] = "MONTH";
  CaloriesChartTypeEnum2["YEAR"] = "YEAR";
  CaloriesChartTypeEnum2["MULTI_YEAR"] = "MULTI_YEAR";
  return CaloriesChartTypeEnum2;
})(CaloriesChartTypeEnum || {});
var BadgesType = /* @__PURE__ */ ((BadgesType2) => {
  BadgesType2["PLS_AT_NIGHT"] = "PLS_AT_NIGHT";
  BadgesType2["MORE_THAN_10_KM"] = "MORE_THAN_10_KM";
  BadgesType2["SPONSORSHIP"] = "SPONSORSHIP";
  BadgesType2["VALENTINE_S_DAY_PLS"] = "VALENTINE_S_DAY_PLS";
  BadgesType2["NB_KM_TRAVELED"] = "NB_KM_TRAVELED";
  BadgesType2["NB_PLS"] = "NB_PLS";
  BadgesType2["ROUTE_DURING_EARTH_DAY"] = "ROUTE_DURING_EARTH_DAY";
  BadgesType2["ROUTE_DURING_BIKE_DAY"] = "ROUTE_DURING_BIKE_DAY";
  BadgesType2["PLS_ON_SAFE_ZONE"] = "PLS_ON_SAFE_ZONE";
  BadgesType2["SAVED_CO2"] = "SAVED_CO2";
  BadgesType2["BIKE_COMMUTING"] = "BIKE_COMMUTING";
  BadgesType2["MAI_A_VELO_2026"] = "MAI_A_VELO_2026";
  return BadgesType2;
})(BadgesType || {});
var UserPointsEarnedType = /* @__PURE__ */ ((UserPointsEarnedType2) => {
  UserPointsEarnedType2["PLS_NO_VIGIMAP_DATA"] = "PLS_NO_VIGIMAP_DATA";
  UserPointsEarnedType2["PLS_GREEN_PLACE"] = "PLS_GREEN_PLACE";
  UserPointsEarnedType2["PLS_YELLOW_PLACE"] = "PLS_YELLOW_PLACE";
  UserPointsEarnedType2["PLS_ORANGE_PLACE"] = "PLS_ORANGE_PLACE";
  UserPointsEarnedType2["PLS_RED_PLACE"] = "PLS_RED_PLACE";
  UserPointsEarnedType2["RIDE"] = "RIDE";
  UserPointsEarnedType2["SUBSCRIPTION"] = "SUBSCRIPTION";
  UserPointsEarnedType2["SPONSORSHIP"] = "SPONSORSHIP";
  UserPointsEarnedType2["BADGE"] = "BADGE";
  return UserPointsEarnedType2;
})(UserPointsEarnedType || {});
var UserPointsSpentType = /* @__PURE__ */ ((UserPointsSpentType2) => {
  UserPointsSpentType2["SHOP_PURCHASE"] = "SHOP_PURCHASE";
  return UserPointsSpentType2;
})(UserPointsSpentType || {});
var ShopCategory = /* @__PURE__ */ ((ShopCategory2) => {
  ShopCategory2["BIKE"] = "BIKE";
  ShopCategory2["EQUIPMENT"] = "EQUIPMENT";
  ShopCategory2["SERVICE"] = "SERVICE";
  ShopCategory2["WELLNESS"] = "WELLNESS";
  ShopCategory2["LIFESTYLE"] = "LIFESTYLE";
  ShopCategory2["OTHER"] = "OTHER";
  ShopCategory2["INSURANCE"] = "INSURANCE";
  return ShopCategory2;
})(ShopCategory || {});
var RewardType = /* @__PURE__ */ ((RewardType2) => {
  RewardType2["PHYSICAL"] = "PHYSICAL";
  RewardType2["UNIQUE_CODE"] = "UNIQUE_CODE";
  RewardType2["SHARED_CODE"] = "SHARED_CODE";
  RewardType2["LINK"] = "LINK";
  RewardType2["INSURANCE_CODE"] = "INSURANCE_CODE";
  return RewardType2;
})(RewardType || {});
var ArticleTypeEnum = /* @__PURE__ */ ((ArticleTypeEnum2) => {
  ArticleTypeEnum2["VEHICLE"] = "VEHICLE";
  ArticleTypeEnum2["LOCK"] = "LOCK";
  ArticleTypeEnum2["REFUNDABLE_ACCESSORY"] = "REFUNDABLE_ACCESSORY";
  ArticleTypeEnum2["NON_REFUNDABLE_ACCESSORY"] = "NON_REFUNDABLE_ACCESSORY";
  return ArticleTypeEnum2;
})(ArticleTypeEnum || {});
var TimelineEventEnum = /* @__PURE__ */ ((TimelineEventEnum2) => {
  TimelineEventEnum2["account"] = "account";
  TimelineEventEnum2["subscription"] = "subscription";
  TimelineEventEnum2["vehicle"] = "vehicle";
  TimelineEventEnum2["payment"] = "payment";
  TimelineEventEnum2["claim"] = "claim";
  TimelineEventEnum2["claim_audit"] = "claim_audit";
  TimelineEventEnum2["comment"] = "comment";
  return TimelineEventEnum2;
})(TimelineEventEnum || {});
var LcbftRiskCategory = /* @__PURE__ */ ((LcbftRiskCategory2) => {
  LcbftRiskCategory2["WEA"] = "WEA";
  LcbftRiskCategory2["MED"] = "MED";
  LcbftRiskCategory2["STR"] = "STR";
  LcbftRiskCategory2["UNKNOWN"] = "UNKNOWN";
  return LcbftRiskCategory2;
})(LcbftRiskCategory || {});
var LcbftVigilanceLevel = /* @__PURE__ */ ((LcbftVigilanceLevel2) => {
  LcbftVigilanceLevel2["N_A"] = "N/A";
  LcbftVigilanceLevel2["NOR"] = "NOR";
  LcbftVigilanceLevel2["HIG"] = "HIG";
  LcbftVigilanceLevel2["UNKNOWN"] = "UNKNOWN";
  return LcbftVigilanceLevel2;
})(LcbftVigilanceLevel || {});
var WebhooksSLEventsEnum = /* @__PURE__ */ ((WebhooksSLEventsEnum2) => {
  WebhooksSLEventsEnum2["MARKING_CODE_CREATED"] = "MARKING_CODE_CREATED";
  WebhooksSLEventsEnum2["MARKING_CODE_CONFLICT_CREATED"] = "MARKING_CODE_CONFLICT_CREATED";
  return WebhooksSLEventsEnum2;
})(WebhooksSLEventsEnum || {});
var ContractualDocTradCodeEnum = /* @__PURE__ */ ((ContractualDocTradCodeEnum2) => {
  ContractualDocTradCodeEnum2["IPID"] = "IPID";
  ContractualDocTradCodeEnum2["CP"] = "CP";
  ContractualDocTradCodeEnum2["NOTICE"] = "NOTICE";
  ContractualDocTradCodeEnum2["FIC"] = "FIC";
  ContractualDocTradCodeEnum2["UNKNOWN"] = "UNKNOWN";
  ContractualDocTradCodeEnum2["DOCS_ASSISTANCE"] = "DOCS_ASSISTANCE";
  ContractualDocTradCodeEnum2["DOCS_ACCIDENT"] = "DOCS_ACCIDENT";
  return ContractualDocTradCodeEnum2;
})(ContractualDocTradCodeEnum || {});
var PackageTradCodeEnum = /* @__PURE__ */ ((PackageTradCodeEnum2) => {
  PackageTradCodeEnum2["BASIC"] = "BASIC";
  PackageTradCodeEnum2["CLASSIC"] = "CLASSIC";
  PackageTradCodeEnum2["CLASSIC_ASSISTANCE"] = "CLASSIC_ASSISTANCE";
  PackageTradCodeEnum2["COMFORT"] = "COMFORT";
  PackageTradCodeEnum2["PREMIUM"] = "PREMIUM";
  PackageTradCodeEnum2["ELEMENTARY"] = "ELEMENTARY";
  PackageTradCodeEnum2["SERENITY"] = "SERENITY";
  PackageTradCodeEnum2["COFIDIS"] = "COFIDIS";
  PackageTradCodeEnum2["GROUP_ACCIDENT_ONLY"] = "GROUP_ACCIDENT_ONLY";
  PackageTradCodeEnum2["THEFT_DAMAGE_AND_GROUP_ACCIDENT"] = "THEFT_DAMAGE_AND_GROUP_ACCIDENT";
  PackageTradCodeEnum2["ZEN"] = "ZEN";
  PackageTradCodeEnum2["ZEN_PLUS"] = "ZEN_PLUS";
  PackageTradCodeEnum2["UNKNOWN"] = "UNKNOWN";
  PackageTradCodeEnum2["THEFT"] = "THEFT";
  return PackageTradCodeEnum2;
})(PackageTradCodeEnum || {});
var GroupCommissionsAmountTypeEnum = /* @__PURE__ */ ((GroupCommissionsAmountTypeEnum2) => {
  GroupCommissionsAmountTypeEnum2["PERCENTAGE_ON_EXCL_TAX"] = "PERCENTAGE_ON_EXCL_TAX";
  GroupCommissionsAmountTypeEnum2["PERCENTAGE_ON_INCL_TAX"] = "PERCENTAGE_ON_INCL_TAX";
  GroupCommissionsAmountTypeEnum2["FIXED"] = "FIXED";
  return GroupCommissionsAmountTypeEnum2;
})(GroupCommissionsAmountTypeEnum || {});
var GroupCommissionsTypeEnum = /* @__PURE__ */ ((GroupCommissionsTypeEnum2) => {
  GroupCommissionsTypeEnum2["PARTNER_B2C"] = "PARTNER_B2C";
  GroupCommissionsTypeEnum2["PARTNER_B2B"] = "PARTNER_B2B";
  GroupCommissionsTypeEnum2["INTRODUCER"] = "INTRODUCER";
  return GroupCommissionsTypeEnum2;
})(GroupCommissionsTypeEnum || {});
var PolicyTerminationReimbursementModeEnum = /* @__PURE__ */ ((PolicyTerminationReimbursementModeEnum2) => {
  PolicyTerminationReimbursementModeEnum2["PRORATE"] = "PRORATE";
  PolicyTerminationReimbursementModeEnum2["BILL_CURRENT_PERIOD"] = "BILL_CURRENT_PERIOD";
  PolicyTerminationReimbursementModeEnum2["BILL_CURRENT_PERIOD_MONTHLY_AND_PRORATE_OTHERWISE"] = "BILL_CURRENT_PERIOD_MONTHLY_AND_PRORATE_OTHERWISE";
  return PolicyTerminationReimbursementModeEnum2;
})(PolicyTerminationReimbursementModeEnum || {});

// src/group-member-role-assignment.ts
var PRIVILEGED_GROUP_MEMBER_ROLES = [
  "Admin" /* Admin */,
  "Owner" /* Owner */
];
function toggleGroupMemberRole(selectedRoles, role, options = {}) {
  const { preventEmptySelection = false } = options;
  if (!selectedRoles.includes(role)) {
    return [...selectedRoles, role].sort((a, b) => a.localeCompare(b));
  }
  const nextRoles = selectedRoles.filter((currentRole) => currentRole !== role);
  if (nextRoles.length === 0) {
    if (preventEmptySelection) {
      return ["Member" /* Member */];
    }
    return selectedRoles;
  }
  return nextRoles.sort((a, b) => a.localeCompare(b));
}
__name(toggleGroupMemberRole, "toggleGroupMemberRole");
function getAssignableGroupMemberRoles(organization, isOwner) {
  return Object.values(GroupMemberRolesEnum).filter((role) => {
    if (role === "Mycroft" /* Mycroft */ && !organization.is_fraud_partner) {
      return false;
    }
    const isBrokerRole = [
      "BrokerReadOnly" /* BrokerReadOnly */,
      "BrokerClaimManagerReadOnly" /* BrokerClaimManagerReadOnly */,
      "Broker" /* Broker */,
      "BrokerClaimManager" /* BrokerClaimManager */
    ].includes(role);
    if (isBrokerRole && !organization.is_partner) {
      return false;
    }
    if (!isOwner && PRIVILEGED_GROUP_MEMBER_ROLES.includes(role)) {
      return false;
    }
    return true;
  });
}
__name(getAssignableGroupMemberRoles, "getAssignableGroupMemberRoles");

// src/group-member-roles.ts
var GroupMemberRole = class {
  static {
    __name(this, "GroupMemberRole");
  }
  static {
    this.roleName = "Member" /* Member */;
  }
  static {
    this.rolesHandled = [];
  }
};
function mix(name, ...Bases) {
  return class extends Bases[0].constructor() {
    static {
      this.roleName = name;
    }
    static {
      this.rolesHandled = [
        name,
        ...Bases.reduce((acc, Base) => Array.from(/* @__PURE__ */ new Set([...acc, ...Base.rolesHandled])), [])
      ];
    }
  };
}
__name(mix, "mix");
var Member = mix("Member" /* Member */, GroupMemberRole);
var BicycleUser = mix("BicycleUser" /* BicycleUser */, Member);
var BicycleManagerReadOnly = mix("BicycleManagerReadOnly" /* BicycleManagerReadOnly */, Member);
var BicycleClaimManagerReadOnly = mix("BicycleClaimManagerReadOnly" /* BicycleClaimManagerReadOnly */, Member);
var BicycleManager = mix("BicycleManager" /* BicycleManager */, BicycleManagerReadOnly);
var BicycleClaimManager = mix("BicycleClaimManager" /* BicycleClaimManager */, BicycleClaimManagerReadOnly);
var BrokerReadOnly = mix("BrokerReadOnly" /* BrokerReadOnly */, Member);
var BrokerClaimManagerReadOnly = mix("BrokerClaimManagerReadOnly" /* BrokerClaimManagerReadOnly */, Member);
var Broker = mix("Broker" /* Broker */, BrokerReadOnly);
var BrokerClaimManager = mix("BrokerClaimManager" /* BrokerClaimManager */, BrokerClaimManagerReadOnly);
var Tech = mix("Tech" /* Tech */, Member);
var FinanceReadOnly = mix("FinanceReadOnly" /* FinanceReadOnly */, Member);
var Finance = mix("Finance" /* Finance */, FinanceReadOnly);
var Mycroft = mix("Mycroft" /* Mycroft */, Member);
var Admin = mix(
  "Admin" /* Admin */,
  BicycleUser,
  BicycleManager,
  BicycleClaimManager,
  Broker,
  BrokerClaimManager,
  Tech,
  Finance,
  Mycroft
);
var Owner = mix("Owner" /* Owner */, Admin);
var roleClassMapper = {
  Member,
  BicycleUser,
  BicycleManagerReadOnly,
  BicycleClaimManagerReadOnly,
  BicycleManager,
  BicycleClaimManager,
  BrokerReadOnly,
  BrokerClaimManagerReadOnly,
  Broker,
  BrokerClaimManager,
  Tech,
  FinanceReadOnly,
  Finance,
  Mycroft,
  Admin,
  Owner
};
function groupRolesClassChecker(attributedRoles, ...neededRoles) {
  if (!attributedRoles) {
    return false;
  }
  const handledRolesSet = new Set(attributedRoles.flatMap((role) => roleClassMapper[role].rolesHandled));
  return neededRoles.some((neededRole) => handledRolesSet.has(neededRole));
}
__name(groupRolesClassChecker, "groupRolesClassChecker");

// src/lib/models/ClaimComplaintType.ts
var ReceptionMediumEnum = /* @__PURE__ */ ((ReceptionMediumEnum2) => {
  ReceptionMediumEnum2["EMAIL"] = "EMAIL";
  ReceptionMediumEnum2["PHONE_CALL"] = "PHONE_CALL";
  ReceptionMediumEnum2["REGISTERED_LETTER"] = "REGISTERED_LETTER";
  return ReceptionMediumEnum2;
})(ReceptionMediumEnum || {});
var ClaimComplaintTypeEnum = /* @__PURE__ */ ((ClaimComplaintTypeEnum2) => {
  ClaimComplaintTypeEnum2["SUBSCRIPTION_OR_ADHESION"] = "SUBSCRIPTION_OR_ADHESION";
  ClaimComplaintTypeEnum2["PRICING"] = "PRICING";
  ClaimComplaintTypeEnum2["CONTRACT_MANAGEMENT"] = "CONTRACT_MANAGEMENT";
  ClaimComplaintTypeEnum2["COMPENSATION_AND_SERVICE"] = "COMPENSATION_AND_SERVICE";
  ClaimComplaintTypeEnum2["TERMINATION_OR_WITHDRAWAL"] = "TERMINATION_OR_WITHDRAWAL";
  ClaimComplaintTypeEnum2["OTHER"] = "OTHER";
  return ClaimComplaintTypeEnum2;
})(ClaimComplaintTypeEnum || {});
var ClaimComplaintSubjectEnum = /* @__PURE__ */ ((ClaimComplaintSubjectEnum2) => {
  ClaimComplaintSubjectEnum2["CLAIM_DECLARATION"] = "CLAIM_DECLARATION";
  ClaimComplaintSubjectEnum2["COMPENSATION_AMOUNT"] = "COMPENSATION_AMOUNT";
  ClaimComplaintSubjectEnum2["CLAIM_DECLARATION_RECEPTION"] = "CLAIM_DECLARATION_RECEPTION";
  ClaimComplaintSubjectEnum2["CLAIM_REJECTION"] = "CLAIM_REJECTION";
  ClaimComplaintSubjectEnum2["COMPENSATION_DELAY"] = "COMPENSATION_DELAY";
  return ClaimComplaintSubjectEnum2;
})(ClaimComplaintSubjectEnum || {});
var ClaimComplaintComplainerTypeEnum = /* @__PURE__ */ ((ClaimComplaintComplainerTypeEnum2) => {
  ClaimComplaintComplainerTypeEnum2["POLICY_HOLDER"] = "POLICY_HOLDER";
  ClaimComplaintComplainerTypeEnum2["POLICY_THIRD_PARTY"] = "POLICY_THIRD_PARTY";
  return ClaimComplaintComplainerTypeEnum2;
})(ClaimComplaintComplainerTypeEnum || {});
var InsurerNameEnum = /* @__PURE__ */ ((InsurerNameEnum2) => {
  InsurerNameEnum2["CHUBB"] = "CHUBB";
  InsurerNameEnum2["SEYNA"] = "SEYNA";
  InsurerNameEnum2["HEYME"] = "HEYME";
  InsurerNameEnum2["CARMA"] = "CARMA";
  InsurerNameEnum2["AXA_ASSISTANCE"] = "AXA_ASSISTANCE";
  InsurerNameEnum2["WAKAM"] = "WAKAM";
  return InsurerNameEnum2;
})(InsurerNameEnum || {});

// src/lib/models/MemberType.ts
var CommunicationTypeEnum = /* @__PURE__ */ ((CommunicationTypeEnum2) => {
  CommunicationTypeEnum2["CLAIM"] = "CLAIM";
  CommunicationTypeEnum2["INVOICE"] = "INVOICE";
  CommunicationTypeEnum2["ALL"] = "ALL";
  CommunicationTypeEnum2["NONE"] = "NONE";
  return CommunicationTypeEnum2;
})(CommunicationTypeEnum || {});

// src/lib/models/PlsPredictionType.ts
var PLS_VERDICTS = ["attached", "not_attached", "unsure"];
var isRecord = /* @__PURE__ */ __name((value) => {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}, "isRecord");
var isPlsPredictionType = /* @__PURE__ */ __name((value) => {
  if (!isRecord(value)) {
    return false;
  }
  if (typeof value.filename !== "string") {
    return false;
  }
  if (!isRecord(value.model) || typeof value.model.model_version !== "string") {
    return false;
  }
  if (value.version === 2) {
    if (typeof value.verdict !== "string" || !PLS_VERDICTS.includes(value.verdict) || !Array.isArray(value.locks) || !isRecord(value.files)) {
      return false;
    }
  } else {
    if (!isRecord(value.data)) {
      return false;
    }
    if (typeof value.data.prediction !== "string" || typeof value.data.state !== "boolean") {
      return false;
    }
  }
  if (value.feedback !== void 0 && typeof value.feedback !== "boolean") {
    return false;
  }
  return true;
}, "isPlsPredictionType");
var parsePlsPrediction = /* @__PURE__ */ __name((value) => {
  let parsed = value;
  if (typeof value === "string") {
    try {
      parsed = JSON.parse(value);
    } catch {
      return void 0;
    }
  }
  if (isPlsPredictionType(parsed)) {
    return parsed;
  }
  return void 0;
}, "parsePlsPrediction");
var isPlsPredictionV2 = /* @__PURE__ */ __name((value) => {
  return value.version === 2;
}, "isPlsPredictionV2");
var isPlsPredictionV3 = /* @__PURE__ */ __name((value) => {
  return isPlsPredictionType(value) && value.model.model_version.includes("V3");
}, "isPlsPredictionV3");
var hasPlsSegmentation = /* @__PURE__ */ __name((value) => {
  return isPlsPredictionType(value) && (value.version === 2 || value.model.model_version.includes("V3"));
}, "hasPlsSegmentation");

// src/lib/models/Predictions.ts
var getIdExpirationDate = /* @__PURE__ */ __name((prediction) => {
  if (prediction.version === 2) {
    return prediction.expiration.value ?? void 0;
  }
  const [value] = prediction.expiration;
  const match = typeof value === "string" ? /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value) : null;
  return match ? `${match[3]}-${match[2]}-${match[1]}` : void 0;
}, "getIdExpirationDate");

// src/lib/models/UserSettingsType.ts
var UserLoginRedirection = /* @__PURE__ */ ((UserLoginRedirection2) => {
  UserLoginRedirection2["B2B"] = "B2B";
  UserLoginRedirection2["B2C"] = "B2C";
  return UserLoginRedirection2;
})(UserLoginRedirection || {});

// src/lib/shared-constants/apic_operator.ts
var apicAssoLink = "https://apic-asso.com/";
var recoBikeLink = "https://www.recobike.com/";
var bicycodeLink = "https://www.bicycode.org/";
var paravolLink = "https://www.paravol.eu/";
var starwayLink = "https://www.starway.fr/";
var mfcLink = "https://mfc.o-code.co";
var decathlonLink = "https://decathlon.o-code.co/";
var icaBikeLink = "https://www.icabike.com/";
var auvrayLink = "https://www.auvray-security.com/";
var moustacheLink = "https://moustachebikes.com/fr/";
var veloPassLink = "https://velopass.com/fr/";
var apicAssoFaqLink = "https://apic-asso.com/faq/";

// src/lib/shared-constants/constants-urls.ts
var B2C_REQUEST_LINK = "https://sharelock.zendesk.com/hc/fr/requests/new";
var B2B_REQUEST_LINK = "https://sharelock-entreprise.zendesk.com/hc/fr/requests/new";
var B2B_FAQ_LINK = "https://sharelock-entreprise.zendesk.com/hc/fr";
var B2C_FAQ_LINK = "https://sharelock.zendesk.com/";
var B2C_CG = "https://www.sharelock.co/fr/cgu";
var B2C_CONTRACTUALS_DOCS = "https://www.sharelock.co/fr/documentation-assurance-velo/documents-contractuels";
var B2C_PC = "https://www.sharelock.co/fr/politique-de-confidentialite";
var LEGAL_PROTECTION_URL = "https://sharelock.zendesk.com/hc/fr/articles/22996497437201-Comment-fonctionne-la-protection-juridique";
var VELIGO_CUSTOMER_SUPPORT_MAIL = "contact@veligo-location.fr";
var IOS_APP_URL = "itms-apps://itunes.apple.com/app/id1540289966";
var ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=co.sharelock.app&hl=fr";
var SHARELOCK_CHUBB_IPID = "https://www.sharelock.co/IPID_CHUBB";
var SHARELOCK_CHUBB_NI = "https://www.sharelock.CO/NI_CHUBB";
var ALL_DOCS_LIST = "https://www.sharelock.co/fr/documentation-assurance-velo/documents-contractuels";
var B2B2C_DOCS_LIST = "https://www.sharelock.co/fr/documentation-assurance-velo/documents-contractuels-b2b2c-defaut";
var ALL_DOCS_LIST_B2B = "https://www.sharelock.co/fr/explication-assurance-b2b";
var B2C_EXPLANATION_URL = "https://www.sharelock.co/fr/explication-assurance";
var PRE_COMPLAINT_LINK = "https://plainte-en-ligne.masecurite.interieur.gouv.fr/";
var ROULEZ_JEUNESSE_LINK = "https://www.roulezjeunesse.com/reparation?cp=REFSL";
var CHUBB_CONFIDENTIALITY_LINK = "https://www.chubb.com/fr-fr/footer/politique-de-confidentialite-en-ligne.html";

// src/lib/shared-constants/partner-shops.ts
var PARTNER_SHOPS_LIST = [
  {
    id: 1,
    type: "BIKE_SHOP",
    name: "ROUES",
    address: "15 Rue Beaurepaire",
    city: "Paris",
    postalCode: "75010",
    phone: "+33153210012",
    website: "https://www.roues.fr",
    logoName: "roues.webp",
    coordinates: {
      latitude: 48.87054624286024,
      longitude: 2.3637283529162496
    }
  },
  {
    id: 2,
    type: "BIKE_SHOP",
    name: "Bloomway",
    address: "33 Av. du Mar\xE9chal Foch",
    city: "Biarritz",
    postalCode: "64200",
    phone: "+33759640572",
    website: "https://bloomway.fr",
    logoName: "bloomway.webp",
    coordinates: {
      latitude: 43.47800316077688,
      longitude: -1.5573042798088574
    }
  },
  {
    id: 3,
    type: "VELIGO",
    name: "Maison du V\xE9lo",
    address: "2 Rue de l'arriv\xE9e",
    city: "Ermont",
    postalCode: "95120",
    website: "https://www.veligo-location.fr/maisons-du-velo/ermont-eaubonne",
    logoName: "veligo.webp",
    coordinates: {
      latitude: 48.980364683366474,
      longitude: 2.2716039467043183
    }
  },
  {
    id: 4,
    type: "VELIGO",
    name: "Maison du V\xE9lo",
    address: "Rue des gaulois",
    city: "Juvisy-sur-Orge",
    postalCode: "91260",
    website: "https://www.veligo-location.fr/en-us/maisons-du-velo/juvisy",
    logoName: "veligo.webp",
    coordinates: {
      latitude: 48.69106958191837,
      longitude: 2.3816740779347167
    }
  },
  {
    id: 5,
    type: "VELIGO",
    name: "Maison du V\xE9lo",
    address: "3 mail Eug\xE8ne Beaudouin",
    city: "Antony",
    postalCode: "92160",
    website: "https://www.veligo-location.fr/en-us/maisons-du-velo/croix-de-berny",
    logoName: "veligo.webp",
    coordinates: {
      latitude: 48.76117710480083,
      longitude: 2.3011473597532537
    }
  },
  {
    id: 6,
    type: "VELIGO",
    name: "Maison du V\xE9lo",
    address: "9 rue du 11 novembre",
    city: "Aulnay-sous-Bois",
    postalCode: "93600",
    website: "https://www.veligo-location.fr/maisons-du-velo/maison-du-velo-daulnay-sous-bois",
    logoName: "veligo.webp",
    coordinates: {
      latitude: 48.93233116163158,
      longitude: 2.494228673152711
    }
  },
  {
    id: 7,
    type: "VELIGO",
    name: "Maison du V\xE9lo",
    address: "1 Place Jean Moulin",
    city: "Maisons-Alfort",
    postalCode: "94700",
    website: "https://www.veligo-location.fr/maisons-du-velo/maisons-alfort",
    logoName: "veligo.webp",
    coordinates: {
      latitude: 48.802551603177086,
      longitude: 2.426739599214342
    }
  }
];

// src/lib/shared-constants/roulezJeunesseAreaList.ts
var ROULEZ_JEUNESSE_AREA_LIST = [
  {
    area: "Paris",
    radius: 12e3,
    coordinates: [
      {
        latitude: 48.86,
        longitude: 2.35
      }
    ]
  },
  {
    area: "Lyon",
    radius: 8e3,
    coordinates: [
      {
        latitude: 45.75,
        longitude: 4.85
      }
    ]
  },
  {
    area: "Strasbourg",
    radius: 9e3,
    coordinates: [
      {
        latitude: 48.59,
        longitude: 7.76
      }
    ]
  },
  {
    area: "Bordeaux",
    radius: 7e3,
    coordinates: [
      {
        latitude: 44.84,
        longitude: -0.56
      }
    ]
  },
  {
    area: "Grenoble",
    radius: 1e3,
    coordinates: [
      {
        latitude: 45.18,
        longitude: 5.73
      }
    ]
  },
  {
    area: "Lille",
    radius: 7e3,
    coordinates: [
      {
        latitude: 50.66,
        longitude: 3.09
      }
    ]
  },
  {
    area: "Nantes",
    radius: 5e3,
    coordinates: [
      {
        latitude: 47.23,
        longitude: -1.54
      }
    ]
  }
];

// src/lib/shared-functions/address-search.ts
var EARTH_RADIUS_METERS = 6371e3;
var degreesToRadians = /* @__PURE__ */ __name((value) => value * Math.PI / 180, "degreesToRadians");
var distanceBetweenCoordinatesMeters = /* @__PURE__ */ __name((latitudeA, longitudeA, latitudeB, longitudeB) => {
  const latitudeDelta = degreesToRadians(latitudeB - latitudeA);
  const longitudeDelta = degreesToRadians(longitudeB - longitudeA);
  const latitudeARadians = degreesToRadians(latitudeA);
  const latitudeBRadians = degreesToRadians(latitudeB);
  const haversineValue = Math.sin(latitudeDelta / 2) ** 2 + Math.cos(latitudeARadians) * Math.cos(latitudeBRadians) * Math.sin(longitudeDelta / 2) ** 2;
  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(haversineValue));
}, "distanceBetweenCoordinatesMeters");
var areCoordinatesInsideAreas = /* @__PURE__ */ __name((areaList, latitude, longitude) => {
  for (const configuredZone of areaList) {
    for (const zoneCenter of configuredZone.coordinates) {
      const distanceMetersFromPointToZoneCenter = distanceBetweenCoordinatesMeters(
        latitude,
        longitude,
        zoneCenter.latitude,
        zoneCenter.longitude
      );
      if (distanceMetersFromPointToZoneCenter <= configuredZone.radius) {
        return true;
      }
    }
  }
  return false;
}, "areCoordinatesInsideAreas");
var searchGouvAddress = /* @__PURE__ */ __name(async (input) => {
  try {
    const res = await fetch(
      `https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(input.trim())}&type=housenumber&autocomplete=1`
    );
    return res?.ok ? await res.json().then((r) => r.features) : false;
  } catch {
    return false;
  }
}, "searchGouvAddress");
var searchGoogleAddress = /* @__PURE__ */ __name(async (input, googleApiKey) => {
  try {
    if (!googleApiKey) {
      throw new Error("Missing Google API Key");
    }
    const res = await fetch("https://places.googleapis.com/v1/places:searchText", {
      method: "POST",
      body: JSON.stringify({
        textQuery: input,
        languageCode: "fr"
      }),
      headers: {
        "Content-Type": "application/json",
        "X-Goog-Api-Key": googleApiKey,
        "X-Goog-FieldMask": "places.formattedAddress,places.addressComponents,places.location,places.name"
      }
    });
    return res?.ok ? await res.json().then((r) => r.places) : [];
  } catch {
    return [];
  }
}, "searchGoogleAddress");
var getFormatedAddressData = /* @__PURE__ */ __name(async (addressArray, allowInternational) => {
  const result = (addressArray || []).reduce((res, current) => {
    if (current && "properties" in current && current.properties.id && current.properties.label && current.properties.name && current.geometry.coordinates.length !== 0) {
      res.push({
        value: JSON.stringify({
          id: current.properties.id,
          name: current.properties.name,
          label: current.properties.label,
          city: current.properties.city,
          postcode: current.properties.postcode,
          long: current.geometry.coordinates[0],
          lat: current.geometry.coordinates[1]
        }),
        label: current.properties.label
      });
    } else if (current && "addressComponents" in current && current.addressComponents.length >= 4) {
      const isInternationalAddress = !current.formattedAddress.includes("France");
      if (isInternationalAddress && !allowInternational) {
        return res;
      }
      const components = current.addressComponents.reduce(
        (acc, component) => {
          if (component.types?.includes("street_number")) {
            acc.houseNumber = component.longText;
          } else if (component.types?.includes("route")) {
            acc.street = component.longText;
          } else if (component.types?.includes("locality")) {
            acc.city = component.longText;
          } else if (component.types?.includes("postal_code")) {
            acc.postcode = component.longText;
          }
          return acc;
        },
        { houseNumber: "", street: "", city: "", postcode: "" }
      );
      const { houseNumber, city, postcode } = components;
      res.push({
        value: JSON.stringify({
          id: current.name,
          name: current.formattedAddress,
          label: current.formattedAddress,
          housenumber: houseNumber,
          city,
          postcode,
          long: current.location.longitude,
          lat: current.location.latitude
        }),
        label: current.formattedAddress
      });
    }
    return res;
  }, []);
  return result;
}, "getFormatedAddressData");
var searchPlace = /* @__PURE__ */ __name(async (search, googleApiKey, allowInternational) => {
  const addressSearchResult = await searchGouvAddress(search);
  if (!addressSearchResult || addressSearchResult.length === 0) {
    const googleresult = await searchGoogleAddress(search, googleApiKey);
    return getFormatedAddressData(googleresult, allowInternational);
  }
  return getFormatedAddressData(addressSearchResult, allowInternational);
}, "searchPlace");

// src/lib/shared-functions/claims.ts
var uniq = /* @__PURE__ */ __name((array) => {
  return Array.from(new Set(array));
}, "uniq");
var hasAllRequiredDocuments = /* @__PURE__ */ __name((documents, documentsList) => {
  if (!documentsList.length) {
    return false;
  }
  const { uploadedDocs } = (documents || []).reduce(
    (acc, doc) => {
      if (doc?.status && doc.type && !doc.expired) {
        if (doc.type === "USER_ID" /* USER_ID */ && doc.uuid.includes("verso")) {
          return acc;
        }
        if (doc.type === "USER_ID" /* USER_ID */ && doc.uuid.includes("recto")) {
          const verso = documents.find((d) => d.uuid.includes("verso"));
          if (!verso) {
            return acc;
          }
          if (!["REJECTED" /* REJECTED */, "INFORMED" /* INFORMED */].includes(doc.status) && !["REJECTED" /* REJECTED */, "INFORMED" /* INFORMED */].includes(verso.status)) {
            acc.uploadedDocs.push("USER_ID" /* USER_ID */);
          }
          return acc;
        }
        if (documentsList.includes(doc.type)) {
          if (!["REJECTED" /* REJECTED */, "INFORMED" /* INFORMED */].includes(doc.status)) {
            acc.uploadedDocs.push(doc.type);
          }
          return acc;
        }
      }
      return acc;
    },
    { uploadedDocs: [] }
  );
  return Number(uniq(uploadedDocs).length / documentsList.length * 100) === 100;
}, "hasAllRequiredDocuments");

// src/notificationsMessages.ts
var resolveNotificationLanguage = /* @__PURE__ */ __name((locale) => {
  const value = (locale ?? trads_default.language).toLowerCase();
  if (value.startsWith("fr")) {
    return "fr";
  }
  return "en";
}, "resolveNotificationLanguage");
var getNotificationMessages = /* @__PURE__ */ __name(({ lng, interpolation = {} } = {}) => {
  return {
    "title.APP": trads_default.t("notification.inapp.title.APP", {
      defaultValue: "New app version !",
      lng
    }),
    "title.DOC": trads_default.t("notification.inapp.title.DOC", {
      defaultValue: "There is news about your documents.",
      lng
    }),
    "title.CLAIM": trads_default.t("notification.inapp.title.CLAIM", {
      defaultValue: "There is news about your claim.",
      lng
    }),
    "title.POLICY": trads_default.t("notification.inapp.title.POLICY", {
      defaultValue: "There is news about your policy.",
      lng
    }),
    "title.PLS": trads_default.t("notification.inapp.title.PLS", {
      defaultValue: 'There is news about your "Park Here" session.',
      lng
    }),
    "title.BIKE": trads_default.t("notification.inapp.title.BIKE", {
      defaultValue: "There is news about your bike.",
      lng
    }),
    "title.INVOICE": trads_default.t("notification.inapp.title.INVOICE", {
      defaultValue: "There is a problem with your payments.",
      lng
    }),
    "title.CARD": trads_default.t("notification.inapp.title.CARD", {
      defaultValue: "There is a problem about your card.",
      lng
    }),
    "title.DEFAULT": trads_default.t("notification.inapp.title.DEFAULT", {
      defaultValue: "There is news",
      lng
    }),
    DOC_REJECTED: trads_default.t("notification.inapp.DOC_REJECTED", {
      defaultValue: 'Your document "{{docType}}" has been rejected.',
      lng,
      ...interpolation
    }),
    DOC_INFORMED: trads_default.t("notification.inapp.DOC_INFORMED", {
      defaultValue: 'We need more information about the document "{{docType}}".',
      lng,
      ...interpolation
    }),
    CLAIM_CLOSED: trads_default.t("notification.inapp.CLAIM_CLOSED", {
      defaultValue: "Your claim {{claimUniqId}} has been closed.",
      lng,
      ...interpolation
    }),
    CLAIM_CREATED: trads_default.t("notification.inapp.CLAIM_CREATED", {
      defaultValue: "Your claim {{claimUniqId}} has been created.",
      lng,
      ...interpolation
    }),
    CLAIM_QUOTE_VALIDATED: trads_default.t("notification.inapp.CLAIM_QUOTE_VALIDATED", {
      defaultValue: "The repair quote for the claim {{claimUniqId}} has been validated.",
      lng,
      ...interpolation
    }),
    CLAIM_VALIDATED: trads_default.t("notification.inapp.CLAIM_VALIDATED", {
      defaultValue: "The claim {{claimUniqId}} has been validated.",
      lng,
      ...interpolation
    }),
    CLAIM_USER_CHECK: trads_default.t("notification.inapp.CLAIM_USER_CHECK", {
      defaultValue: "We need you to call the support about your claim {{claimUniqId}}.",
      lng,
      ...interpolation
    }),
    CLAIM_PAID: trads_default.t("notification.inapp.CLAIM_PAID", {
      defaultValue: "The claim {{claimUniqId}} has been paid.",
      lng,
      ...interpolation
    }),
    CARD_EXPIRED: trads_default.t("notification.inapp.CARD_EXPIRED", {
      defaultValue: "Your credit card has expired.",
      lng
    }),
    CARD_SOON_EXPIRED: trads_default.t("notification.inapp.CARD_SOON_EXPIRED", {
      defaultValue: "Your credit card will expire soon. Click here to update it.",
      lng
    }),
    CARD_NO_DEFAULT: trads_default.t("notification.inapp.CARD_NO_DEFAULT", {
      defaultValue: "You do not have a default card. Click here to set one.",
      lng
    }),
    INVOICE_UNPAID: trads_default.t("notification.inapp.INVOICE_UNPAID", {
      defaultValue: "You have an unpaid invoice. Click here to pay it.",
      lng
    }),
    POLICY_SUSPENDED: trads_default.t("notification.inapp.POLICY_SUSPENDED", {
      defaultValue: "Your policy for your {{bikeBrand}} - {{bikeModel}} has been suspended.",
      lng,
      ...interpolation
    }),
    POLICY_TERMINATED: trads_default.t("notification.inapp.POLICY_TERMINATED", {
      defaultValue: "Your policy for your {{bikeBrand}} - {{bikeModel}} has been terminated.",
      lng,
      ...interpolation
    }),
    POLICY_RENEWED: trads_default.t("notification.inapp.POLICY_RENEWED", {
      defaultValue: "Your policy for your {{bikeBrand}} - {{bikeModel}} has been renewed.",
      lng,
      ...interpolation
    }),
    POLICY_CANCEL_PERIOD_END: trads_default.t("notification.inapp.POLICY_CANCEL_PERIOD_END", {
      defaultValue: "Your policy for your {{bikeBrand}} - {{bikeModel}} is set to be cancelled at the end of the contract period.",
      lng,
      ...interpolation
    }),
    POLICY_CANCEL_MONTH_END: trads_default.t("notification.inapp.POLICY_CANCEL_MONTH_END", {
      defaultValue: "Your policy for your {{bikeBrand}} - {{bikeModel}} is set to be cancelled at the end of the ongoing payment.",
      lng,
      ...interpolation
    }),
    PLS_AUTO_TERMINATED: trads_default.t("notification.inapp.PLS_AUTO_TERMINATED", {
      defaultValue: 'Your "Park Here" session of your {{bikeBrand}} - {{bikeModel}} has been auto-terminated.',
      lng,
      ...interpolation
    }),
    PLS_BATTERY_NOT_REMOVED: trads_default.t("notification.inapp.PLS_BATTERY_NOT_REMOVED", {
      defaultValue: "The battery was not removed from your {{bikeBrand}} - {{bikeModel}}",
      lng,
      ...interpolation
    }),
    PLS_WHEEL_ONLY: trads_default.t("notification.inapp.PLS_WHEEL_ONLY", {
      defaultValue: "It seems your {{bikeBrand}} - {{bikeModel}} was only parked with the wheel. Please check in the app and tell us if it is the case.",
      lng,
      ...interpolation
    }),
    PLS_INCORRECTLY_PARKED: trads_default.t("notification.inapp.PLS_INCORRECTLY_PARKED", {
      defaultValue: "It seems your {{bikeBrand}} - {{bikeModel}} was incorrectly parked. Please check in the app and tell us if it is the case.",
      lng,
      ...interpolation
    }),
    BIKE_INVALID_CODE: trads_default.t("notification.inapp.BIKE_INVALID_CODE", {
      defaultValue: "Your {{bikeBrand}} - {{bikeModel}} has an invalid code.",
      lng,
      ...interpolation
    }),
    BIKE_INVALID_APIC_STATUS: trads_default.t("notification.inapp.BIKE_INVALID_APIC_STATUS", {
      defaultValue: "Your {{bikeBrand}} - {{bikeModel}} has an invalid APIC status. In case of a claim, you must declare the state of the bike to your marking operator.",
      lng,
      ...interpolation
    }),
    APP_UPDATE: trads_default.t("notification.inapp.APP_UPDATE", {
      defaultValue: "Discover the new features of the app.",
      lng
    }),
    DEFAULT: trads_default.t("notification.inapp.DEFAULT", {
      defaultValue: "There is news",
      lng
    })
  };
}, "getNotificationMessages");

// src/lib/shared-functions/notifications.ts
var getTypedNotificationData = /* @__PURE__ */ __name((notification) => {
  switch (notification.type) {
    case "DOC_REJECTED" /* DOC_REJECTED */:
    case "DOC_INFORMED" /* DOC_INFORMED */:
      return { ...notification.data, kind: "NotificationsDocData" };
    case "CLAIM_CREATED" /* CLAIM_CREATED */:
    case "CLAIM_CLOSED" /* CLAIM_CLOSED */:
    case "CLAIM_QUOTE_VALIDATED" /* CLAIM_QUOTE_VALIDATED */:
    case "CLAIM_VALIDATED" /* CLAIM_VALIDATED */:
    case "CLAIM_PAID" /* CLAIM_PAID */:
    case "CLAIM_USER_CHECK" /* CLAIM_USER_CHECK */:
      return { ...notification.data, kind: "NotificationClaimData" };
    case "POLICY_SUSPENDED" /* POLICY_SUSPENDED */:
    case "POLICY_TERMINATED" /* POLICY_TERMINATED */:
    case "POLICY_RENEWED" /* POLICY_RENEWED */:
    case "POLICY_CANCEL_PERIOD_END" /* POLICY_CANCEL_PERIOD_END */:
    case "POLICY_CANCEL_MONTH_END" /* POLICY_CANCEL_MONTH_END */:
      return { ...notification.data, kind: "NotificationsPolicydata" };
    case "PLS_AUTO_TERMINATED" /* PLS_AUTO_TERMINATED */:
    case "PLS_BATTERY_NOT_REMOVED" /* PLS_BATTERY_NOT_REMOVED */:
    case "PLS_WHEEL_ONLY" /* PLS_WHEEL_ONLY */:
    case "PLS_INCORRECTLY_PARKED" /* PLS_INCORRECTLY_PARKED */:
      return { ...notification.data, kind: "NotificationsPlsData" };
    case "BIKE_INVALID_CODE" /* BIKE_INVALID_CODE */:
    case "BIKE_INVALID_APIC_STATUS" /* BIKE_INVALID_APIC_STATUS */:
      return { ...notification.data, kind: "NotificationsBikeData" };
    case "CUSTOM_PROMO" /* CUSTOM_PROMO */:
    case "CUSTOM_INFO" /* CUSTOM_INFO */:
      return { ...notification.data, kind: "NotificationCustomData" };
    case "CARD_NO_DEFAULT" /* CARD_NO_DEFAULT */:
    case "CARD_EXPIRED" /* CARD_EXPIRED */:
    case "CARD_SOON_EXPIRED" /* CARD_SOON_EXPIRED */:
      return { ...notification.data, kind: "NotificationCardData" };
    case "INVOICE_UNPAID" /* INVOICE_UNPAID */:
      return { ...notification.data, kind: "NotificationInvoiceData" };
    case "LS_TERMINATED" /* LS_TERMINATED */:
    default:
      return null;
  }
}, "getTypedNotificationData");
var getNotificationDetails = /* @__PURE__ */ __name((notification, options) => {
  const lng = resolveNotificationLanguage(options?.lng);
  const data = getTypedNotificationData(notification);
  if (data?.kind === "NotificationCustomData") {
    return { title: data.title, text: data.message };
  }
  const interpolation = {};
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      if (key === "kind") {
        return;
      }
      if (typeof value === "string" || typeof value === "number") {
        interpolation[key] = value;
      }
    });
  }
  if (options?.docTypeLabel) {
    interpolation.docType = options.docTypeLabel;
  }
  const category = notification.type.split("_")[0] ?? "";
  const messages = getNotificationMessages({ lng, interpolation });
  return {
    title: messages[`title.${category}`] ?? messages["title.DEFAULT"],
    text: messages[notification.type] ?? messages.DEFAULT
  };
}, "getNotificationDetails");

// src/roles.ts
var Role = class {
  static {
    __name(this, "Role");
  }
  static {
    this.roleName = "Anonymous" /* Anonymous */;
  }
  static {
    this.rolesHandled = [];
  }
};
function mix2(name, ...Bases) {
  return class extends Bases[0].constructor() {
    static {
      this.roleName = name;
    }
    static {
      this.rolesHandled = [
        name,
        // eslint-disable-next-line sonarjs/no-alphabetical-sort
        ...Bases.reduce((acc, Base) => Array.from(/* @__PURE__ */ new Set([...acc, ...Base.rolesHandled])).sort(), [])
      ];
    }
  };
}
__name(mix2, "mix");
var Anonymous = mix2("Anonymous" /* Anonymous */, Role);
var Partner = mix2("Partner" /* Partner */, Role);
var FraudPartner = mix2("FraudPartner" /* FraudPartner */, Role);
var Authenticated = mix2("Authenticated" /* Authenticated */, Role);
var Ops = mix2("Ops" /* Ops */, Authenticated);
var Tech2 = mix2("Tech" /* Tech */, Ops);
var Insurance = mix2("Insurance" /* Insurance */, Ops);
var Lock = mix2("Lock" /* Lock */, Ops);
var Central = mix2("Central" /* Central */, Ops);
var CustomerSupport = mix2("CustomerSupport" /* CustomerSupport */, Ops);
var Finance2 = mix2("Finance" /* Finance */, Ops);
var CustomerSupportManager = mix2("CustomerSupportManager" /* CustomerSupportManager */, CustomerSupport);
var TechManager = mix2("TechManager" /* TechManager */, Tech2);
var InsuranceManager = mix2("InsuranceManager" /* InsuranceManager */, Insurance);
var LockManager = mix2("LockManager" /* LockManager */, Lock);
var CentralManager = mix2("CentralManager" /* CentralManager */, Central, CustomerSupportManager);
var Admin2 = mix2("Admin" /* Admin */, Finance2, TechManager, InsuranceManager, LockManager, CentralManager);
var roleClassMapper2 = {
  Anonymous,
  Partner,
  FraudPartner,
  Authenticated,
  Ops,
  Tech: Tech2,
  Insurance,
  Lock,
  Central,
  CustomerSupport,
  Finance: Finance2,
  CustomerSupportManager,
  TechManager,
  InsuranceManager,
  LockManager,
  CentralManager,
  Admin: Admin2
};
function rolesClassChecker(attributedRoles, ...neededRoles) {
  const handledRolesSet = new Set(attributedRoles.flatMap((role) => roleClassMapper2[role].rolesHandled));
  return neededRoles.some((neededRole) => handledRolesSet.has(neededRole));
}
__name(rolesClassChecker, "rolesClassChecker");
var rolesEnumImplyingOpsHandled = Object.keys(roleClassMapper2).filter(
  (role) => roleClassMapper2[role].rolesHandled.includes("Ops" /* Ops */)
);
function getHandledRoles(roles, handledRoles = []) {
  return roles.reduce((acc, role) => {
    if (!acc.includes(role)) {
      acc.push(role);
      acc = getHandledRoles(
        roleClassMapper2[role].rolesHandled.filter((roleName) => roleName !== role),
        acc
      );
    }
    return acc;
  }, handledRoles);
}
__name(getHandledRoles, "getHandledRoles");

// src/slSdk.ts
import { create } from "axios";

// src/insurance-api/b2b-claims.ts
var B2BClaimsApi = class extends virtual_default {
  static {
    __name(this, "B2BClaimsApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimsCountByStatus(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/count-by-status${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimsCountByStatusForGroup(groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/count-by-status/group/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(id, groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${id}/group/${groupId}${formatQueryParams(filter, "_include=vehicle_object")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOneById(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/ops-id/${id}${formatQueryParams(filter, "_include=vehicle_object")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getRemainToPay(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${id}/get-remain-to-pay`).then((response) => response.data) : Promise.reject(initError);
  }
  create(groupId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claims/${groupId}/create`, data).then((response) => response.data) : Promise.reject(initError);
  }
  uploadPhotos(claimId, groupId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claims/${groupId}/uploadPhoto/${claimId}`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupB2BClaims(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/byGroup/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countGroupB2BClaims(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/byGroup/${groupId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyClaims(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/getMyClaims${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  addNote(id, notes) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${id}/notes`, notes).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2BClaimDates(claimId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/update-b2b-claim-dates`, {
      claimOccurencePeriodStart: data.claimOccurencePeriodStart,
      claimOccurencePeriodEnd: data.claimOccurencePeriodEnd
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaimCoverageCode(claimId, coverageCode) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/updateCoverageCode`, {
      coverageCode
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaimAddress(claimId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/address`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaimAmounts(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${data.claimId}/update-claim-amounts`, {
      to_be_reimbursed_group: data.to_be_reimbursed_group,
      claim_paid_group: data.claim_paid_group,
      to_be_reimbursed_partner: data.to_be_reimbursed_partner,
      claim_paid_partner: data.claim_paid_partner,
      support_claim_amount: data.support_claim_amount,
      bike_claim_amount: data.bike_claim_amount,
      to_be_recovered_amount_group: data.to_be_recovered_amount_group,
      recovered_amount_group: data.recovered_amount_group,
      to_be_recovered_amount_partner: data.to_be_recovered_amount_partner,
      recovered_amount_partner: data.recovered_amount_partner,
      franchise_amount: data.franchise_amount,
      franchise_percentage: data.franchise_percentage,
      gross_refundable_amount: data.gross_refundable_amount
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaimStatus(id, status, comment, isFraud, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${id}/update-status${formatQueryParams(filter)}`, { status, comment, isFraud }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaimDescription(claimId, description) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/updateDescription`, {
      description
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bClaimRelatedDocument(claimId, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${groupId}/getRelatedDocuments/${claimId}`).then((response) => response.data) : Promise.reject(initError);
  }
  changeStatusByUser(claimId, groupId, status, comment) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${groupId}/new-status/${claimId}`, { status, comment }).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bClaimAudits(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${id}/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  reactivateBikeReturnB2bPolicy(claimId, remain_to_pay_not_recovered) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claims/${claimId}/bike-return-reactivate`, { remain_to_pay_not_recovered }).then((response) => response.data) : Promise.reject(initError);
  }
  exportGroupClaimsToCsv(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/group/${groupId}/export-csv${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerClaimsToCsv(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/partner/${partnerId}/export-csv${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientB2BClaims(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/partner/${partnerId}/claims${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientB2BClaimsCount(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/partner/${partnerId}/claims/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  groupUpdateClaim(groupId, claimId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${groupId}/update/${claimId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  hasNoOpsChanges(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${claimId}/has-no-ops-changes`).then((response) => response.data) : Promise.reject(initError);
  }
  refreshCompletionValidationPercentage(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${claimId}/completion-validation-percentage`).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bClaim(claimId, data, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/update${formatQueryParams(filter)}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  payClaim(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/pay-claim`, {}).then((response) => response.data) : Promise.reject(initError);
  }
  getAmountsForRefundComputation(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claims/${claimId}/get-claim-refund-amounts`).then((response) => response.data) : Promise.reject(initError);
  }
  updatePartnerClaimsToPaid(claimsIds, amount, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${partnerId}/update-partner-claim-status-to-paid`, { claimsIds, amount }).then((response) => response.data) : Promise.reject(initError);
  }
  assignOpsUserToB2bClaim(claimId, opsUserId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claims/${claimId}/assign-ops-user${formatQueryParams(filter)}`, {
      assigned_ops_user_id: opsUserId
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_claims_default = new B2BClaimsApi();

// src/insurance-api/b2b-contracts.ts
var B2BContractsApi = class extends virtual_default {
  static {
    __name(this, "B2BContractsApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractsByGroup(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts/byGroup/${groupId}${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractById(contractId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts/byId/${contractId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  create(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/b2b-contracts", data).then((response) => response.data) : Promise.reject(initError);
  }
  duplicate(contractId, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-contracts/${contractId}/duplicate`, { id: groupId }).then((response) => response.data) : Promise.reject(initError);
  }
  update(contractId, status, template, comment) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-contracts/updateContract/${contractId}`, { status, template, comment }).then((response) => response.data) : Promise.reject(initError);
  }
  getUploadSignedUrl(contractId, fileType) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-contracts/upload-template/contract/${contractId}`, { fileType }).then((response) => response.data).catch((e) => console.log("error ===>", e)) : Promise.reject(initError);
  }
  getMyPolicyContract(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts/byMyPolicyId/${policyId}`).then((response) => response.data) : Promise.reject(initError);
  }
  extend(contractId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-contracts/${contractId}/extend`).then((response) => response.data) : Promise.reject(initError);
  }
  setEndDate(contractId, valid_end_date) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-contracts/${contractId}/end-date`, { valid_end_date }).then((response) => response.data) : Promise.reject(initError);
  }
  setNextContract(contractId, nextContractId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-contracts/${contractId}/next-contract`, { nextContractId }).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_contracts_default = new B2BContractsApi();

// src/insurance-api/b2b-management-parameters.ts
var B2bManagementParametersApi = class extends virtual_default {
  static {
    __name(this, "B2bManagementParametersApi");
  }
  updateOneQmp(b2bQmpId, body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-quote-management-parameters/${b2bQmpId}${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateOnePmp(b2bPmpId, body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policy-management-parameters/${b2bPmpId}${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  getB2BQmpById(b2bQmpId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quote-management-parameters/${b2bQmpId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2BPmpById(b2bPmpId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policy-management-parameters/${b2bPmpId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2BPmpDefaults() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-policy-management-parameters/defaults").then((response) => response.data) : Promise.reject(initError);
  }
  getB2BQmpDefaults() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-quote-management-parameters/defaults").then((response) => response.data) : Promise.reject(initError);
  }
  getB2BCmpDefaults() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-claim-management-parameters/defaults").then((response) => response.data) : Promise.reject(initError);
  }
  getB2BCmpById(b2bCmpId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claim-management-parameters/${b2bCmpId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateOneCmp(b2bCmpId, body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claim-management-parameters/${b2bCmpId}${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateOneB2bCmpDoc(b2bCmpId, b2bCmpDocId, claimType, requiredDocs, optionalDocs) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claim-management-parameters/${b2bCmpId}/docsParams/${b2bCmpDocId}`, {
      requiredDocs,
      optionalDocs,
      claimType
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bOpsChecksParameters(b2bCmpId, opsChecksId, claimType, bikeValueThreshold, grossRefundableAmountThreshold, mandatoryOpsChecks, bikeValueOpsChecks, grossRefundableAmountOpsChecks) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claim-management-parameters/${b2bCmpId}/opsChecksParams/${opsChecksId}`, {
      bikeValueThreshold,
      grossRefundableAmountThreshold,
      mandatoryOpsChecks,
      bikeValueOpsChecks,
      grossRefundableAmountOpsChecks,
      claimType
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bReimbursementParameters(b2bCmpId, reimbursementParamsId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-claim-management-parameters/${b2bCmpId}/reimbursementParams/${reimbursementParamsId}`, {
      claimType: data.claimType,
      min_franchise_amount: data.minFranchiseAmount,
      franchise_rule: data.franchiseRule,
      partner_reimbursment_rule: data.partnerReimbursmentRule,
      client_reimbursment_rule: data.clientReimbursmentRule
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createB2bReimbursementParameters(b2bCmpId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claim-management-parameters/${b2bCmpId}/reimbursementParams`, data).then((response) => response.data) : Promise.reject(initError);
  }
  createB2bCmpDocs(b2bCmpId, claimType, requiredDocs, optionalDocs) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claim-management-parameters/${b2bCmpId}/docParams`, {
      claimType,
      requiredDocs,
      optionalDocs
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createB2bCmpOpsChecks(b2bCmpId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-claim-management-parameters/${b2bCmpId}/opsChecksParams`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getB2BCmpByContractId(contractId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-claim-management-parameters/byContract/${contractId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_management_parameters_default = new B2bManagementParametersApi();

// src/insurance-api/b2b-policies.ts
var B2BPoliciesApi = class extends virtual_default {
  static {
    __name(this, "B2BPoliciesApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findAffectedUsers(policyId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byId/${policyId}/affected-users${formatQueryParams(filter, "_sort=lastname:asc")}`).then((response) => response.data) : Promise.reject(initError);
  }
  countAffectedUsers(policyId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byId/${policyId}/affected-users/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findHistoryByQuoteID(quoteId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/history/${quoteId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOneAsOps(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/b2b-policies/byId/${id}${formatQueryParamsWithBase("_include=vehicles_relations.include.vehicle_object", filter)}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  findAllBySerialByGroup(quoteId, groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/b2b-policies/group/${groupId}/bySerial/${quoteId}${formatQueryParams(filter)}&_include=vehicles_relations.include.vehicle_object`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  findAllBySerialByPartner(quoteId, partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/b2b-policies/partner/${partnerId}/bySerial/${quoteId}${formatQueryParams(
        filter
      )}&_include=vehicles_relations.include.vehicle_object`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyVehiclesByQuoteId(quoteId, groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/${groupId}/by-quoteID/${quoteId}/vehicles${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPolicyVehiclesByQuoteId(quoteId, groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/${groupId}/by-quoteID/${quoteId}/vehicles/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupB2BPolicies(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/b2b-policies/byGroup/${groupId}${formatQueryParams(filter, "_include=vehicles_relations.include.vehicle_object")}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  countGroupB2BPolicies(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byGroup/${groupId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllMyGroupsB2BPolicies(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/my-groups-insurances${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getIssuedPDFB2BPolicyLink(id, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/${groupId}/get-issued-pdf-policy-link/${id}`).then((response) => response.data) : Promise.reject(initError);
  }
  findB2BPolicyDocs(groupId, policyId) {
    const url = `/b2b-policies/${groupId}/get-contractual-documents/${policyId}`;
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(url).then((response) => response.data) : Promise.reject(initError);
  }
  findB2BPolicyGGSDocs(groupId) {
    const url = `/b2b-policies/${groupId}/default-terms-of-use-links`;
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(url).then((response) => response.data) : Promise.reject(initError);
  }
  getB2BPoliciesKpi() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-policies/kpis").then((response) => response.data) : Promise.reject(initError);
  }
  getB2BPoliciesHomeKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-policies/home-kpis").then((response) => response.data) : Promise.reject(initError);
  }
  regenerateB2bPolicyPdf(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies/${policyId}/regenerate-pdf`).then((response) => response.data) : Promise.reject(initError);
  }
  update(policyId, groupId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies/${policyId}/update/${groupId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  retract(quoteID, groupId, cancelReasonInfo, vehiclesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies/${groupId}/by-quoteID/${quoteID}/retract`, {
      cancelReason: "RETRACTION",
      cancelReasonInfo,
      vehiclesId
    }).then((response) => response.data) : Promise.reject(initError);
  }
  opsCancelInsurance(quoteID, terminationReason, cancelReasonInfo, vehiclesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies/by-quoteID/${quoteID}/ops-cancel`, {
      cancelReason: terminationReason,
      cancelReasonInfo,
      vehiclesId
    }).then((response) => response.data) : Promise.reject(initError);
  }
  simulateOpsCancelInsurance(quoteID, terminationReason, cancelReasonInfo, vehiclesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-policies/by-quoteID/${quoteID}/simulate-ops-cancel`, {
      cancelReason: terminationReason,
      cancelReasonInfo,
      vehiclesId
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bPolicyAudit(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/${id}/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  exportInsuredVehiclesToCsv(groupId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/group/${groupId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  exportB2bPoliciesToCsv(groupId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/group/${groupId}/export-policies-csv${formatQueryParams(where)}`, {
      responseType: "blob"
    }).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerPoliciesToCsv(partnerId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byPartners/${partnerId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_policies_default = new B2BPoliciesApi();

// src/insurance-api/b2b-policy-cancel-request.ts
var B2bPolicyCancelRequestApi = class extends virtual_default {
  static {
    __name(this, "B2bPolicyCancelRequestApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies-cancel-request${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies-cancel-request/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOneByUniqueId(uniqueId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies-cancel-request/byUniqueId/${uniqueId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies-cancel-request/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findByGroup(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/b2b-policies-cancel-request/byGroup/${groupId}${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getRequestsCountByStatus() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/b2b-policies-cancel-request/count-by-status").then((response) => response.data) : Promise.reject(initError);
  }
  grantOne(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies-cancel-request/${id}/grant`).then((response) => response.data) : Promise.reject(initError);
  }
  rejectOne(id, reject_reason) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies-cancel-request/${id}/reject`, { reject_reason }).then((response) => response.data) : Promise.reject(initError);
  }
  createOne(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/b2b-policies-cancel-request", data).then((response) => response.data) : Promise.reject(initError);
  }
  cancelOne(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-policies-cancel-request/${id}/cancel`).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_policy_cancel_request_default = new B2bPolicyCancelRequestApi();

// src/insurance-api/b2b-quotes.ts
var B2BQuotesApi = class extends virtual_default {
  static {
    __name(this, "B2BQuotesApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  // GROUP => B2B
  findByGroup(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/group/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countByGroup(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/group/${groupId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findB2BQuoteContractualDocs(groupId, serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/group/${groupId}/get-contractual-documents/${serial}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(serial, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/${serial}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bQuoteById(quoteId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/ops-id/${quoteId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bQuoteByPolicyId(policyId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/ops-policy/${policyId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createB2bQuote(groupId, quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/group/${groupId}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  createB2bQuoteFromSimulation(groupId, quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/group/${groupId}/from-simulation`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  createQuoteAmendment(serial, amendData, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/${serial}/amend/${groupId}`, amendData).then((response) => response.data) : Promise.reject(initError);
  }
  updateB2bQuote(groupId, quoteData, quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-quotes/${quoteSerial}/group/${groupId}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  signB2bQuote(quoteSerial, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/${quoteSerial}/group/${groupId}/sign`).then((response) => response.data) : Promise.reject(initError);
  }
  abandonQuote(quoteSerial, groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/b2b-quotes/${quoteSerial}/group/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
  // PARTNER => B2B2B
  findByPartner(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/partners/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countByPartner(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/partners/${partnerId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOneByPartner(serial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/partners/${serial}/partners/${partnerId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2bQuote(quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/${quoteSerial}`).then((response) => response.data) : Promise.reject(initError);
  }
  partnerCreateB2bQuote(partnerId, quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/partners/${partnerId}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  partnerUpdateB2bQuote(partnerId, quoteData, quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2b-quotes/partners/${quoteSerial}/partners/${partnerId}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  partnerSignB2bQuote(quoteSerial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/partners/${quoteSerial}/partners/${partnerId}/sign`).then((response) => response.data) : Promise.reject(initError);
  }
  partnerAbandonQuote(quoteSerial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/b2b-quotes/partners/${quoteSerial}/partners/${partnerId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerB2bQuotePDF(serial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/partners/${serial}/partners/${partnerId}/download`).then((response) => response.data) : Promise.reject(initError);
  }
  // PARTNER => B2B2C
  findOneB2cPartnerQuotes(serial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/partners/${partnerId}/${serial}`).then((response) => response.data) : Promise.reject(initError);
  }
  findAllPartnerQuotes(filter, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/partners/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countAllPartnerQuotes(filter, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/partners/${partnerId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createPartnerB2b2cQuotes(partnerId, quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quotes/partners/${partnerId}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  createPartnerB2cQuotes(partnerId, quotes) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quotes/partners/${partnerId}/bulk`, { quotes }).then((response) => response.data) : Promise.reject(initError);
  }
  updatePartnerB2b2cQuotes(serial, partnerId, quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/quotes/partners/${partnerId}/${serial}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  deletePartnerB2b2cQuotes(serial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/quotes/partners/${partnerId}/${serial}`).then((response) => response.data) : Promise.reject(initError);
  }
  signPartnerB2b2cQuotes(serial, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quotes/partners/${partnerId}/${serial}/sign`).then((response) => response.data) : Promise.reject(initError);
  }
  sendQuoteToClient(serial, partnerId, name, email) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/b2b-quotes/partners/${serial}/partners/${partnerId}/send-quote-to-client`, { name, email }).then((response) => response.data) : Promise.reject(initError);
  }
  simulate(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/b2b-quotes/simulation", data).then((response) => response.data) : Promise.reject(initError);
  }
  exportQuotesByGroupToCsv(groupId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/byGroups/${groupId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  exportQuotesByPartnerGroupToCsv(partnerId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-quotes/byPartners/${partnerId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_quotes_default = new B2BQuotesApi();

// src/insurance-api/b2b-receipts.ts
var B2BReceiptsApi = class extends virtual_default {
  static {
    __name(this, "B2BReceiptsApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-receipts${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-receipts/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getInvoiceReceipts(groupId, invoiceId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-receipts/group/${groupId}/invoice/${invoiceId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getReceiptsByMonthAndGroup(groupId, year, month) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-receipts/group/${groupId}/${year}/${month}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2b_receipts_default = new B2BReceiptsApi();

// src/insurance-api/b2c-contracts.ts
var B2cContractsApi = class extends virtual_default {
  static {
    __name(this, "B2cContractsApi");
  }
  getB2cContracts(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2c-contracts${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2cContractsCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2c-contracts/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2cContract(contractId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2c-contracts/${contractId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createB2cContract(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/b2c-contracts", data).then((response) => response.data) : Promise.reject(initError);
  }
  disableB2cContract(contractId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/b2c-contracts/${contractId}/disable`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2cContractsByPartner(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2c-contracts/byPartner/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var b2c_contracts_default = new B2cContractsApi();

// src/insurance-api/claim-complaints.ts
var ClaimComplaintsApi = class extends virtual_default {
  static {
    __name(this, "ClaimComplaintsApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claim-complaints${formatQueryParams(filter, "_limit=10&_sort=acknowledge_date:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claim-complaints/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claim-complaints/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/claim-complaints/kpis").then((response) => response.data) : Promise.reject(initError);
  }
  create(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/claim-complaints", data).then((response) => response.data) : Promise.reject(initError);
  }
  update(id, data, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claim-complaints/${id}${formatQueryParams(filter)}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  listResponseTemplates(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claim-complaints/${id}/response-templates`).then((response) => response.data) : Promise.reject(initError);
  }
  generateResponseDocument(id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/claim-complaints/${id}/response-document`, data).then((response) => response.data) : Promise.reject(initError);
  }
  previewResponseDocumentVariables(id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/claim-complaints/${id}/response-document/variables`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getResponseDocumentLink(id, isLevel2 = false) {
    const query = isLevel2 ? "?is_level_2=true" : "";
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claim-complaints/${id}/response-document${query}`).then((response) => response.data) : Promise.reject(initError);
  }
  respond(id, data, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claim-complaints/${id}/respond${formatQueryParams(filter)}`, data).then((response) => response.data) : Promise.reject(initError);
  }
};
var claim_complaints_default = new ClaimComplaintsApi();

// src/insurance-api/contractual-documents.ts
var ContractualDocumentsApi = class extends virtual_default {
  static {
    __name(this, "ContractualDocumentsApi");
  }
  getContractualDocuments(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/contractual-documents${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractualDocument(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/contractual-documents/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractualDocumentsCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/contractual-documents/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedForContractualDocument(name) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/contractual-documents/presigned", { name }).then((response) => response.data) : Promise.reject(initError);
  }
  createContractualDocuments(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/contractual-documents", data).then((response) => response.data) : Promise.reject(initError);
  }
  createNewContractualDocumentVersion(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/contractual-documents/${data.id}/version`, { key: data.key }).then((response) => response.data) : Promise.reject(initError);
  }
  updateContractualDocuments(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/contractual-documents/${data.id}/update`, {
      coverages: data.coverages,
      expired: data.expired,
      group: data.group,
      trad_code: data.trad_code
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyContractualDocs(serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${serial}/contractual-documents`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractualDocumentsByPackageAndPartner(packageId, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/contractual-documents/byPackage/${packageId}/partner/${partnerId}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var contractual_documents_default = new ContractualDocumentsApi();

// src/insurance-api/coverages.ts
var CoveragesApi = class extends virtual_default {
  static {
    __name(this, "CoveragesApi");
  }
  getCoverages(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/coverages${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCoveragesCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/coverages/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCoverage(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/coverages/${id}`).then((response) => response.data) : Promise.reject(initError);
  }
  disableCoverage(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/coverages/${id}/disable`).then(({ data }) => data) : Promise.reject(initError);
  }
};
var coverages_default = new CoveragesApi();

// src/insurance-api/fleets.ts
var FleetsApi = class extends virtual_default {
  static {
    __name(this, "FleetsApi");
  }
  getGroupFleets(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/fleets/group/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupFleetsCount(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/fleets/group/${groupId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupFleet(groupId, id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/fleets/${id}/group/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createFleet(groupId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/fleets/group/${groupId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateFleet(fleetId, groupId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/fleets/${fleetId}/group/${groupId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateVehiclesOnFleet(groupId, id, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/fleets/${id}/group/${groupId}/vehicles`, data).then((response) => response.data) : Promise.reject(initError);
  }
  deleteFleet(groupId, id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/fleets/${id}/group/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var fleets_default = new FleetsApi();

// src/insurance-api/fraud-weights.ts
var FraudApi = class extends virtual_default {
  static {
    __name(this, "FraudApi");
  }
  getFraudWeights() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/fraud-weights").then((response) => response.data) : Promise.reject(initError);
  }
  async updateFraudWeights(updatedValues) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put("/fraud-weights", {
      low: updatedValues.low,
      medium: updatedValues.medium,
      high: updatedValues.high
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var fraud_weights_default = new FraudApi();

// src/insurance-api/geofencing.ts
var GeofencingApi = class extends virtual_default {
  static {
    __name(this, "GeofencingApi");
  }
  geofenceByBBox(minLat, maxLat, minLon, maxLon, excludeIds = [], signal) {
    if (!this.axiosInsuranceInstance) {
      return Promise.reject(initError);
    }
    const uniqueExcludeIds = Array.from(new Set(excludeIds)).filter((id) => Number.isFinite(id));
    const payload = {
      minLat,
      maxLat,
      minLon,
      maxLon
    };
    if (uniqueExcludeIds.length > 0) {
      payload.excludeIds = uniqueExcludeIds;
    }
    return this.axiosInsuranceInstance.post("/geofencing/geofenceByBBox", payload, { signal }).then((response) => response.data);
  }
  getReferenceStreet() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/geofencing/referenceStreet").then((response) => response.data) : Promise.reject(initError);
  }
};
var geofencing_default = new GeofencingApi();

// src/insurance-api/insurance-claims.ts
var InsuranceClaimsApi = class extends virtual_default {
  static {
    __name(this, "InsuranceClaimsApi");
  }
  getClaims(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyClaims(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/get-my-claims${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupActiveInsuranceClaims(groupId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/group/${groupId}/get-active-insurance-claims`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaim(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyClaim(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/get-my-claim/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimsCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/count${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimsCountByStatus(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/count-by-status${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimsHomeKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/insurance-claims/home-kpis").then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimStatus(id, status, sendMail, comment, isFraud, terminationOnReject) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}/update-status`, {
      status,
      comment,
      isFraud,
      claim_reject_cancel_condition: terminationOnReject,
      sendMail
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getPaymentAccountBalance() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/insurance-claims/payment-account-balance").then((response) => response.data) : Promise.reject(initError);
  }
  payClaim(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}/pay-claim`, {}).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimStatusToBikeReturned(id, to_be_recovered_amount_user, to_be_recovered_amount_partner, comment, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}/update-status-to-bike-returned${formatQueryParams(filter)}`, {
      to_be_recovered_amount_user,
      to_be_recovered_amount_partner,
      comment
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updatePartnerClaimsToPaid(claimsIds, amount, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${partnerId}/update-partner-claim-status-to-paid`, { claimsIds, amount }).then((response) => response.data) : Promise.reject(initError);
  }
  payPartnerClaimsWithQonto(partnerId, body) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/partner-claim-payments/${partnerId}/pay-with-qonto`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaim(id, data, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}${formatQueryParams(filter)}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  changeStatusByUser(id, status, comment) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}/new-status`, { status, comment }).then((response) => response.data) : Promise.reject(initError);
  }
  addNote(id, notes) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${id}/notes`, notes).then((response) => response.data) : Promise.reject(initError);
  }
  addClaimDocument(claimId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/insurance-claims/${claimId}/documents`, data, { headers: { "Content-Type": "multipart/form-data" } }).then((response) => response.data) : Promise.reject(initError);
  }
  createClaim(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/insurance-claims/create", data).then((response) => response.data) : Promise.reject(initError);
  }
  createClaimByPartner(data, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/insurance-claims/partners/${partnerId}/create`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimAmountsEstimate(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${claimId}/get-estimated-amounts`).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimAmounts(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${data.claimId}/update-claim-amounts`, {
      to_be_reimbursed_user: data.to_be_reimbursed_user,
      support_claim_amount: data.support_claim_amount,
      bike_claim_amount: data.bike_claim_amount,
      claim_paid_user: data.claim_paid_user,
      claim_paid_partner: data.claim_paid_partner,
      franchise_percentage: data.franchise_percentage,
      franchise_amount: data.franchise_amount,
      to_be_reimbursed_partner: data.to_be_reimbursed_partner,
      price_before_deduction: data.price_before_deduction,
      to_be_recovered_amount_user: data.to_be_recovered_amount_user,
      to_be_recovered_amount_partner: data.to_be_recovered_amount_partner,
      recovered_amount_user: data.recovered_amount_user,
      recovered_amount_partner: data.recovered_amount_partner,
      real_value: data.real_value,
      additional_user_amount: data.additional_user_amount,
      additional_partner_amount: data.additional_partner_amount,
      additional_user_amount_reason: data.additional_user_amount_reason,
      additional_partner_amount_reason: data.additional_partner_amount_reason
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimDates(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${data.claimId}/update-claim-dates`, {
      fieldToUpdate: data.fieldToUpdate,
      date: data.date
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimReimbursementType(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${data.claimId}/reimbursement-type`, {
      reimbursement_type: data.reimbursement_type
    }).then((response) => response.data) : Promise.reject(initError);
  }
  refreshFraudScore(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${id}/refresh-fraud-score`).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimRelatedDocument(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${claimId}/getRequiredDocuments`).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimDescription(claimId, description) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${claimId}/updateDescription`, {
      description
    }).then((response) => response.data) : Promise.reject(initError);
  }
  uploadClaimPhotos(claimId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/insurance-claims/${claimId}/uploadPhoto`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  uploadClaimPhotosByPartner(claimId, partnerId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/insurance-claims/partners/${partnerId}/claims/${claimId}/uploadPhoto`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimCoverageCode(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${data.claimId}/updateCoverageCode`, {
      coverageCode: data.coverageCode
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getClaimDocsStats(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${id}/completion-validation-percentage`).then((response) => response.data) : Promise.reject(initError);
  }
  sendPersonalDamageMail(PolicyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${PolicyId}/send-personal-damage-mail`) : Promise.reject(initError);
  }
  getClaimAudits(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${id}/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  reactivateBikeReturnPolicy(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/insurance-claims/${claimId}/bike-return-reactivate`, {}).then((response) => response.data) : Promise.reject(initError);
  }
  checkCoverageVsClaim(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/${claimId}/check-claim-vs-coverage`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientsClaims(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/partners/${partnerId}/claims${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientsClaimsCount(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/partners/${partnerId}/claims/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientClaim(partnerId, claimId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/partners/${partnerId}/claims/${claimId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerClientClaimRelatedDocument(partnerId, claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/partners/${partnerId}/claims/${claimId}/getRequiredDocuments`).then((response) => response.data) : Promise.reject(initError);
  }
  deletePartnerClaimDocument(partnerId, claimId, documentUuid) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/insurance-claims/partners/${partnerId}/claims/${claimId}/documents/${documentUuid}`).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerClaimsToCsv(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/insurance-claims/partners/${partnerId}/claims/export-csv${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  usePictureFromClaimPhoto(claimId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${claimId}/use-picture-from-claim-photo`).then((response) => response.data) : Promise.reject(initError);
  }
  usePictureFromPartnerClaimPhoto(claimId, partnerId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/partners/${partnerId}/claims/${claimId}/use-picture-from-claim-photo`).then((response) => response.data) : Promise.reject(initError);
  }
  assignOpsUserToB2cClaim(claimId, opsUserId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/insurance-claims/${claimId}/assign-ops-user${formatQueryParams(filter)}`, {
      assigned_ops_user_id: opsUserId
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var insurance_claims_default = new InsuranceClaimsApi();

// src/insurance-api/management-parameters.ts
var ManagementParametersApi = class extends virtual_default {
  static {
    __name(this, "ManagementParametersApi");
  }
  getAllQmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quote-management-parameters${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countQmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quote-management-parameters/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateQmp(body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/quote-management-parameters/many${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  createQmp(body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quote-management-parameters${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  getAllPmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies-management-parameters${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies-management-parameters/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createPmp(body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies-management-parameters${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updatePmp(body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies-management-parameters/many${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  getAllCmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claims-management-parameters${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countCmp(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claims-management-parameters/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateCmp(body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claims-management-parameters/many${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  getOneCmp(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/claims-management-parameters/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateOneCmp(id, body, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claims-management-parameters/byId/${id}${formatQueryParams(filter)}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimDocParameters(id, docsParamsId, claimType, requiredDocs, optionalDocs, is_direct_reimbursement) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claims-management-parameters/${id}/docsParams/${docsParamsId}`, {
      requiredDocs,
      optionalDocs,
      claimType,
      is_direct_reimbursement
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateOpsChecksParameters(id, opsChecksId, claimType, insuredValueThreshold, grossRefundableAmountThreshold, mandatoryOpsChecks, insuredValueOpsChecks, grossRefundableAmountOpsChecks, fraudOpsChecks) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claims-management-parameters/${id}/opsChecks/${opsChecksId}`, {
      insuredValueThreshold,
      grossRefundableAmountThreshold,
      mandatoryOpsChecks,
      insuredValueOpsChecks,
      grossRefundableAmountOpsChecks,
      fraudOpsChecks,
      claimType
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateClaimReimbursementParameters(id, reimbursementParamsId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/claims-management-parameters/${id}/reimbursementParams/${reimbursementParamsId}`, {
      partner_estimations_rule: data.partnerEstimationsRule,
      user_estimations_rule: data.userEstimationsRule,
      franchise_rule: data.franchiseRule,
      partner_reimbursment_rule: data.partnerReimbursmentRule,
      client_reimbursment_rule: data.clientReimbursmentRule,
      claimType: data.claimType,
      min_franchise_amount: data.minFranchiseAmount
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createCmp(body) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/claims-management-parameters", body).then((response) => response.data) : Promise.reject(initError);
  }
  createClaimDocParameters(cmpId, claim_type, required_documents, optional_documents, is_direct_reimbursement) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/claims-management-parameters/${cmpId}/document-parameters`, {
      required_documents,
      optional_documents,
      claim_type,
      is_direct_reimbursement
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createCmpOpsChecks(body) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/claims-management-parameters/${body.cmpId}/ops-checks-parameters`, {
      claim_type: body.claim_type,
      insured_value_threshold: body.insured_value_threshold,
      gross_refundable_amount_threshold: body.gross_refundable_amount_threshold,
      insured_value_ops_check: body.insured_value_ops_checks,
      gross_refundable_amount_ops_check: body.gross_refundable_amount_ops_check,
      fraud_ops_check: body.fraud_ops_checks,
      mandatory_ops_check: body.mandatory_ops_checks
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createClaimReimbursementParameters(body) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/claims-management-parameters/${body.cmpId}/reimbursement-parameters`, {
      claim_type: body.claim_type,
      partner_estimations_rule: body.partner_estimations_rule,
      user_estimations_rule: body.user_estimations_rule,
      franchise_rule: body.franchise_rule,
      partner_reimbursment_rule: body.partner_reimbursment_rule,
      client_reimbursment_rule: body.client_reimbursment_rule,
      with_pls: body.with_pls,
      has_battery: body.has_battery,
      bike_model: body.bike_model,
      is_direct_reimbursement: body.is_direct_reimbursement,
      min_franchise_amount: body.min_franchise_amount
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var management_parameters_default = new ManagementParametersApi();

// src/insurance-api/packages.ts
var PackagesApi = class extends virtual_default {
  static {
    __name(this, "PackagesApi");
  }
  getAllPackages(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages/all${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedToUploadPackageTemplate(partnerId, packageId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages/presignedUrl/${partnerId}/${packageId}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPackages(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPackage(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createPackage(pack) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance?.post("/packages", pack).then((response) => response.data) : Promise.reject(initError);
  }
  updatePackage(pack, packId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/packages/${packId}`, pack).then((response) => response.data) : Promise.reject(initError);
  }
  getIncompleteB2cPackages() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/packages/incomplete-b2c-packages`).then((response) => response.data) : Promise.reject(initError);
  }
};
var packages_default = new PackagesApi();

// src/insurance-api/personal-locking-sessions.ts
var InsuranceSessionsApi = class extends virtual_default {
  static {
    __name(this, "InsuranceSessionsApi");
  }
  getUserPersonalLockingSessions(userId, filter = "") {
    return this.getPersonalLockingSessions(
      filter ? `user=${userId}&${filter}` : `user=${userId}&_sort=created_at:DESC`
    );
  }
  getUserPersonalLockingSessionsCount(userId, filter = "") {
    return this.getPersonalLockingSessionsCount(
      filter ? `user=${userId}&${filter}` : `user=${userId}&_sort=created_at:DESC`
    );
  }
  getPersonalLockingSessions(filter, signal) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions${formatQueryParams(filter)}`, { signal }).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockingSessionsCount(filter, signal) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/count${formatQueryParams(filter)}`, { signal }).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockingSession(sessionId, filter) {
    const filterParams = filter ? `?_include=user_object&${filter}` : `?_include=user_object`;
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/${sessionId}${filterParams}`).then((response) => response.data) : Promise.reject(initError);
  }
  createPersonalLockingSession(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/personal-locking-sessions/create", data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getMyPersonalLockingSession() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/personal-locking-sessions/me").then((response) => response.data) : Promise.reject(initError);
  }
  getMyPersonalLockingSessionsCount() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/personal-locking-sessions/count/me").then((response) => response.data) : Promise.reject(initError);
  }
  getAllMyPersonalLockingSession(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/all${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockingSessionSegmentation(sessionId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/${sessionId}/segmentation`).then((response) => response.data) : Promise.reject(initError);
  }
  updateFeedbackSegmentation(sessionId, feedback) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/personal-locking-sessions/${sessionId}/segmentation/feedback`, { feedback }).then((response) => response.data) : Promise.reject(initError);
  }
  updateMissingBatteryFeedback(sessionId, feedback) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/personal-locking-sessions/${sessionId}/missing-battery/feedback`, { feedback }).then((response) => response.data) : Promise.reject(initError);
  }
  terminatePersonalLockingSession(sessionId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/personal-locking-sessions/${sessionId}/terminate`).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockingSessionsKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/kpis`).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockingSessionsHomeKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/home-kpis`).then((response) => response.data) : Promise.reject(initError);
  }
  getNearest(lat, long) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locking-sessions/get-nearest?lat=${lat}&long=${long}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var personal_locking_sessions_default = new InsuranceSessionsApi();

// src/insurance-api/personal-locks.ts
var PersonalLocksApi = class extends virtual_default {
  static {
    __name(this, "PersonalLocksApi");
  }
  getPersonalLock(personalLockId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locks/${personalLockId}${formatQueryParams(filter)}`).then((response) => {
      return response.data;
    }) : Promise.reject(initError);
  }
  getMyPersonalLocks(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locks/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLocks(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locks${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  removePersonalLock(personalLockId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/personal-locks/${personalLockId}/remove`, {}).then((response) => response.data) : Promise.reject(initError);
  }
  deletePersonalLock(personalLockId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/personal-locks/${personalLockId}`).then((response) => response.data) : Promise.reject(initError);
  }
  updatePersonalLock(personalLockId, updateQuery) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/personal-locks/${personalLockId}`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  createPersonalLock(personalLock) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/personal-locks", personalLock).then((response) => response.data) : Promise.reject(initError);
  }
  uploadPersonalLockPhoto(personalLockId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/personal-locks/${personalLockId}/uploadPhoto`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  deletePersonalLockPhoto(personalLockId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/personal-locks/${personalLockId}/picture`).then((response) => response.data) : Promise.reject(initError);
  }
  getPersonalLockDocuments(personalLockId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locks/${personalLockId}/documents`).then((response) => response.data) : Promise.reject(initError);
  }
  /// Partner
  createPartnerForUserPersonalLock(partnerId, personalLock) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/personal-locks/partner/${partnerId}`, personalLock).then((response) => response.data) : Promise.reject(initError);
  }
  getUserPersonalLocks(partnerId, userId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/personal-locks/partner/${partnerId}/byUser/${userId}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var personal_locks_default = new PersonalLocksApi();

// src/insurance-api/policies.ts
var PoliciesApi = class extends virtual_default {
  static {
    __name(this, "PoliciesApi");
  }
  // NEW
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/byId/${id}${formatQueryParams(filter, "_include=vehicle_object")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findByQuoteID(quoteId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/policies/bySerial/${quoteId}${formatQueryParams(filter, "_include=vehicle_object&_include=promotion_code_object")}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getHistoryByQuoteId(quoteId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/history/${quoteId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  abort(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies/${id}/abort`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserPolicies(userId, filter) {
    return this.find(`user=${userId}&${filter || "_sort=created_at:DESC"}`);
  }
  getUserPoliciesCount(userId, filter) {
    return this.count(`user=${userId}&${filter || "_sort=created_at:DESC"}`);
  }
  refreshRiskScore(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies/${id}/refresh-risk-score`).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyInvoices(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${id}/invoices`).then((response) => response.data) : Promise.reject(initError);
  }
  refundPolicyInvoice(id, invoiceId, amount) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies/${id}/refund`, {
      invoiceId,
      amount
    }).then((response) => response.data) : Promise.reject(initError);
  }
  // OLD
  getPoliciesKpis(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/kpis${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPoliciesHomeKpis() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/home-kpis`).then((response) => response.data) : Promise.reject(initError);
  }
  getPastDueInsurancePolicies(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/past-due${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyTotalCommission(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${policyId}/total-commission`).then((response) => response.data) : Promise.reject(initError);
  }
  // It's the same route, but good pratice to have different functions
  // eslint-disable-next-line sonarjs/no-identical-functions
  getMyPolicyInvoices(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${id}/invoices`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyInsurancePolicies(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCountGroupAssignedPolicies(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/group/${groupId}/assigned/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupAssignedPolicies(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/group/${groupId}/assigned${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  cancelMyInsurance({ quoteID, cancelReason, cancelReasonInfo }) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${quoteID}/cancel-insurance`, {
      cancelReason,
      cancelReasonInfo
    }).then((response) => response.data) : Promise.reject(initError);
  }
  cancelMyCancellation(quoteID) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${quoteID}/cancel-cancellation`).then((response) => response.data) : Promise.reject(initError);
  }
  terminatePolicy(policyId, cancelReason, terminationDate, cancelReasonInfo, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/ops-terminate-insurance${formatQueryParams(filter)}`, {
      cancelReason,
      terminationDate,
      cancelReasonInfo
    }).then((response) => response.data) : Promise.reject(initError);
  }
  simulateOpsTerminateInsurance(policyId, cancelReason, terminationDate, cancelReasonInfo) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies/${policyId}/simulate-ops-terminate-insurance`, {
      cancelReason,
      terminationDate,
      cancelReasonInfo
    }).then((response) => response.data) : Promise.reject(initError);
  }
  opsCancelPolicy(policyId, isCancel, cancelReason, cancelReasonInfo) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/ops-cancel-insurance`, { isCancel, cancelReason, cancelReasonInfo }).then((response) => response.data) : Promise.reject(initError);
  }
  cancelPendingPolicy(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/ops-cancel-pending-insurance`).then((response) => response.data) : Promise.reject(initError);
  }
  simulateRetractInsurance(quoteID) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/policies/${quoteID}/simulate-retract-insurance`).then((response) => response.data) : Promise.reject(initError);
  }
  retractInsurance(quoteID, terminationReason, cancelReasonInfo) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${quoteID}/retract-insurance`, {
      cancelReason: terminationReason,
      cancelReasonInfo
    }).then((response) => response.data) : Promise.reject(initError);
  }
  suspendPolicy(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/ops-suspend-insurance`).then((response) => response.data) : Promise.reject(initError);
  }
  getIssuedPDFPolicy(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${policyId}/get-issued-pdf-policy`).then((response) => response.data) : Promise.reject(initError);
  }
  sendIssuedPDFPolicyByEmail(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${policyId}/send-issued-pdf-policy-by-email`).then((response) => response.data) : Promise.reject(initError);
  }
  getIssuedPDFPolicyLink(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${policyId}/get-issued-pdf-policy-link`).then((response) => response.data) : Promise.reject(initError);
  }
  regeneratePolicyPdf(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/regenerate-pdf`).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyRenewInfos(token, userBirthdayMillis) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/renew?userBirthdayMillis=${userBirthdayMillis}`, { headers: { "x-renew-token": token } }).then((response) => response.data) : Promise.reject(initError);
  }
  applyPromoCodeToRenewPolicy(quoteID, promoCode) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${quoteID}/apply-renewal-promotion-code`, { promotion_code: promoCode }).then((response) => response.data) : Promise.reject(initError);
  }
  createCardForRenewPolicy({
    renewToken,
    paymentMethod,
    userSecret
  }) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(
      `/policies/renew?userBirthdayMillis=${userSecret}`,
      {
        paymentMethod
      },
      { headers: { "x-renew-token": renewToken } }
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getPolicyAudit(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/${id}/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  exportGroupAssignedPoliciesToCsv(groupId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/group/${groupId}/assigned/export-csv${formatQueryParams(where)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var policies_default = new PoliciesApi();

// src/insurance-api/policy-cancel-request.ts
var PolicyCancelRequestApi = class extends virtual_default {
  static {
    __name(this, "PolicyCancelRequestApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies-cancel-request${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  findOne(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies-cancel-request/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies-cancel-request/count${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getRequestsCountByStatus() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/policies-cancel-request/count-by-status").then((response) => response.data) : Promise.reject(initError);
  }
  grantOne(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies-cancel-request/${id}/grant`).then((response) => response.data) : Promise.reject(initError);
  }
  rejectOne(id, reject_reason) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies-cancel-request/${id}/reject`, { reject_reason }).then((response) => response.data) : Promise.reject(initError);
  }
  createOne(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/policies-cancel-request", data).then((response) => response.data) : Promise.reject(initError);
  }
};
var policy_cancel_request_default = new PolicyCancelRequestApi();

// src/insurance-api/pricing.ts
var PricingApi = class extends virtual_default {
  static {
    __name(this, "PricingApi");
  }
  getQuotePrices(serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/pricing/${serial}`).then((response) => response.data) : Promise.reject(initError);
  }
  getQuotePriceForChoosenPackage(serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/pricing/${serial}/package`).then((response) => response.data) : Promise.reject(initError);
  }
  applyPurchasedCode(orderId, serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/pricing/apply-purchased-code/${orderId}`, { serial }).then((response) => response.data) : Promise.reject(initError);
  }
};
var pricing_default = new PricingApi();

// src/insurance-api/pricingRules.ts
var PricingRulesApi = class extends virtual_default {
  static {
    __name(this, "PricingRulesApi");
  }
  getPricingRule(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/pricing-rules${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPricingRuleCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/pricing-rules/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var pricingRules_default = new PricingRulesApi();

// src/insurance-api/qonto.ts
var QontoApi = class extends virtual_default {
  static {
    __name(this, "QontoApi");
  }
  getStatus(params) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/settings/qonto/oauth/status", { params }).then((response) => response.data) : Promise.reject(initError);
  }
  getBankAccounts() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/qonto/bank-accounts").then((response) => response.data) : Promise.reject(initError);
  }
  selectBankAccount(bankAccountId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put("/qonto/bank-accounts/select", { bankAccountId }).then(() => void 0) : Promise.reject(initError);
  }
  getTransfers({
    page,
    perPage
  } = {}) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/qonto/transfers", { params: { page, perPage } }).then((response) => response.data) : Promise.reject(initError);
  }
};
var qonto_default = new QontoApi();

// src/insurance-api/quotes.ts
var QuotesApi = class extends virtual_default {
  static {
    __name(this, "QuotesApi");
  }
  find(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCountGroupAssignedQuotes(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/group/${groupId}/assigned/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupAssignedQuotes(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/group/${groupId}/assigned${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteQuote(quoteId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`quotes/${quoteId}`).then((response) => response.data) : Promise.reject(initError);
  }
  createQuote(quoteData) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/quotes", quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  createSimulationQuote(price, accessoriesValue, zipCode, partnership_source, promocode) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/quotes/simulation", { price, accessoriesValue, zipCode, partnership_source, promocode }).then((response) => response.data) : Promise.reject(initError);
  }
  updateSimulationQuote(serial, price, accessoriesValue, zipCode, promocode) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/quotes/${serial}/simulation`, { price, accessoriesValue, zipCode, promocode }).then((response) => response.data) : Promise.reject(initError);
  }
  sendSimulationQuote(email, serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quotes/${serial}/simulation`, { email }).then((response) => response.data) : Promise.reject(initError);
  }
  updateQuote(quoteData, quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/quotes/${quoteSerial}`, quoteData).then((response) => response.data) : Promise.reject(initError);
  }
  getQuote(quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/${quoteSerial}`).then((response) => response.data) : Promise.reject(initError);
  }
  getQuoteById(quoteId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/ops-id/${quoteId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getQuoteByPolicyId(policyId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/ops-policy/${policyId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyQuotes(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  signQuote(quoteSerial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/quotes/${quoteSerial}/sign`).then((response) => response.data) : Promise.reject(initError);
  }
  getFicLink(serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/${serial}/fic`).then((response) => response.data) : Promise.reject(initError);
  }
  getFicLinkById(quoteId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/ops-id/${quoteId}/fic`).then((response) => response.data) : Promise.reject(initError);
  }
  getContractualDocuments(serial) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/${serial}/contractual-documents`).then((response) => response.data) : Promise.reject(initError);
  }
};
var quotes_default = new QuotesApi();

// src/insurance-api/receipts.ts
var ReceiptApi = class extends virtual_default {
  static {
    __name(this, "ReceiptApi");
  }
  getReceipts(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/receipts${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getReceiptsCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/receipts/count${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  generateMassiveExtract(partnerInvoicesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/receipts/generate-massive-export/${partnerInvoicesId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMassiveExportFile(partnerInvoicesId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/receipts/get-massive-export-file/${partnerInvoicesId}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var receipts_default = new ReceiptApi();

// src/insurance-api/scoring-repartition.ts
var ScoringRepartitionApi = class extends virtual_default {
  static {
    __name(this, "ScoringRepartitionApi");
  }
  getScoringRepartitions() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/scoring-repartition").then((response) => response.data) : Promise.reject(initError);
  }
  updateScoringRepartition(id, updatedValues) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/scoring-repartition/${id}`, {
      green_pct: updatedValues.green_pct,
      red_pct: updatedValues.red_pct
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var scoring_repartition_default = new ScoringRepartitionApi();

// src/insurance-api/scoring-threshold.ts
var ScoringThresholdApi = class extends virtual_default {
  static {
    __name(this, "ScoringThresholdApi");
  }
  getScoringThresholds() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/scoring-threshold").then((response) => response.data) : Promise.reject(initError);
  }
  getScoringThreshold(scoringId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/scoring-threshold/${scoringId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getScoringByPackage(packageId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/scoring-threshold/byPackage/${packageId}${formatQueryParams(filter)}`).then((response) => Object.keys(response.data ?? {}).length === 0 ? null : response.data) : Promise.reject(initError);
  }
  updateScoringThreshold(scoringId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/scoring-threshold/${scoringId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
};
var scoring_threshold_default = new ScoringThresholdApi();

// src/insurance-api/sponsorship-configurations.ts
var SponsorshipConfigurationsApi = class extends virtual_default {
  static {
    __name(this, "SponsorshipConfigurationsApi");
  }
  getSponsorshipConfiguration() {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get("/sponsorship-configurations").then((response) => response.data) : Promise.reject(initError);
  }
  updateSponsorshipConfiguration(payload) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put("/sponsorship-configurations", payload).then((response) => response.data) : Promise.reject(initError);
  }
};
var sponsorship_configurations_default = new SponsorshipConfigurationsApi();

// src/insurance-api/sponsorships.ts
var SponsorshipApi = class extends virtual_default {
  static {
    __name(this, "SponsorshipApi");
  }
  getAllSponsorships(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(
      `/sponsorships/get-all-sponsorships${formatQueryParamsWithBase("_include=referral_object&_include=sponsor_object", filter)}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getSponsorshipsCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/sponsorships/get-sponsorships-count?${filter}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserSponsorships(id, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/sponsorships/get-user-sponsorships/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var sponsorships_default = new SponsorshipApi();

// src/insurance-api/vehicles.ts
var VehiclesApi = class extends virtual_default {
  static {
    __name(this, "VehiclesApi");
  }
  getMyVehicles(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  checkVehicleApicStatus(id) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles/${id}/check-apic-status`).then((response) => response.data) : Promise.reject(initError);
  }
  getVehicle(vehicleId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles/${vehicleId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getVehicles(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getVehiclesCount(filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  removeVehicle(vehicleId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/vehicles/${vehicleId}/remove`, {}).then((response) => response.data) : Promise.reject(initError);
  }
  updateVehicle(vehicleId, updateQuery) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/vehicles/${vehicleId}`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  createVehicle(vehicle) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/vehicles", vehicle).then((response) => response.data) : Promise.reject(initError);
  }
  uploadVehiclePhoto(vehicleId, data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/vehicles/${vehicleId}/uploadPhoto`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getVehicleDocuments(vehicleId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/vehicles/${vehicleId}/documents`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteVehiclePhoto(vehicleId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.delete(`/vehicles/${vehicleId}/deletePhoto`).then((response) => response.data) : Promise.reject(initError);
  }
  groupCheckBicycodeExist(groupId, bicycodeIds) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post(`/vehicles/${groupId}/check-bicycode-exist`, {
      bicycodeIds
    }).then((response) => response.data) : Promise.reject(initError);
  }
  resetVehicleBicycode(vehicleId) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/vehicles/${vehicleId}/reset-bicycode`).then((response) => response.data) : Promise.reject(initError);
  }
};
var vehicles_default = new VehiclesApi();

// src/lock-api/alerts.ts
var AlertsApi = class extends virtual_default {
  static {
    __name(this, "AlertsApi");
  }
  getAlerts(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/alerts${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAlertsCount(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/alerts/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLockAlerts(lockSerialNumber, filter = "") {
    return this.getAlerts(`${filter}&lock_serial_number=${lockSerialNumber}`);
  }
  getLockAlertsCount(lockSerialNumber, filter = "") {
    return this.getAlertsCount(`${filter}&lock_serial_number=${lockSerialNumber}`);
  }
  getSessionAlerts(sessionId, filter = "") {
    return this.getAlerts(`${filter}&locking_session_id=${sessionId}`);
  }
  getSessionAlertsCount(sessionId, filter = "") {
    return this.getAlertsCount(`${filter}&locking_session_id=${sessionId}`);
  }
};
var alerts_default = new AlertsApi();

// src/lock-api/locking-sessions.ts
var LockingSessionsApi = class extends virtual_default {
  static {
    __name(this, "LockingSessionsApi");
  }
  getCitySessions(cityId) {
    return this.getLockingSessions(`city=${cityId}&_sort=created_at:DESC`);
  }
  getLockSessions(lockId, filter = "") {
    return this.getLockingSessions(filter ? `lock=${lockId}&${filter}` : `lock=${lockId}&_sort=created_at:DESC`);
  }
  getLockSessionsCount(lockId, filter = "") {
    return this.getLockingSessionsCount(filter ? `lock=${lockId}&${filter}` : `lock=${lockId}&_sort=created_at:DESC`);
  }
  getUserSessions(userId, filter = "") {
    return this.getLockingSessions(filter ? `user=${userId}&${filter}` : `user=${userId}&_sort=created_at:DESC`);
  }
  getUserSessionsCount(userId, filter = "") {
    return this.getLockingSessionsCount(filter ? `user=${userId}&${filter}` : `user=${userId}&_sort=created_at:DESC`);
  }
  getLockingSessions(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLockingSessionsCount(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getSessionsKpis(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions/kpis${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getSession(sessionId, filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions/${sessionId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  setLockingSessionStatusToError(sessionId, updateQuery) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/error`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  getMySession(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllMySession(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locking-sessions/all${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  resumeInitializedSession(sessionId, token) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/resume`, { token }).then((response) => response.data) : Promise.reject(initError);
  }
  createLockingSession(data) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("locking-sessions/create", data).then((response) => response.data) : Promise.reject(initError);
  }
  uploadSessionPhoto(data, id) {
    return this.axiosLockInstance ? this.axiosLockInstance.post(`locking-sessions/${id}/uploadPhoto`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateSensors(sensors, sessionId) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("locking-sessions/updateSensors", {
      sensors,
      id: sessionId
    }).then((response) => response.data) : Promise.reject(initError);
  }
  abortInitializedSession(sessionID) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`locking-sessions/${sessionID}/abort`).then((response) => response.data) : Promise.reject(initError);
  }
  updateStartFeedback(sessionId, updateQuery, filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/start-feedback${formatQueryParams(filter)}`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  updateEndFeedback(sessionId, updateQuery, filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/end-feedback${formatQueryParams(filter)}`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  terminateSession(sessionId, updateQuery) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/terminate`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  setStatusToInProgress(sessionId) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/in_progress`).then((response) => response.data) : Promise.reject(initError);
  }
  setStatusToInTerminated(sessionId) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/opsterminate`).then((response) => response.data) : Promise.reject(initError);
  }
  getNetRevenues(startDate, endDate) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/data/locking-sessions/net-revenues?start_date=${startDate}&end_date=${endDate}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateObservation(sessionId, observation) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/${sessionId}/update-observation`, { observation }).then((response) => response.data) : Promise.reject(initError);
  }
  getItinerary(origin, destination) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/locking-sessions/itineraries", { origin, destination }).then((response) => response.data) : Promise.reject(initError);
  }
};
var locking_sessions_default = new LockingSessionsApi();

// src/lock-api/locks.ts
var LocksApi = class extends virtual_default {
  static {
    __name(this, "LocksApi");
  }
  getLock(lockId) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locks/${lockId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLockBySerial(serial) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/locks?serial_number=${serial}`).then((response) => {
      const locks = response.data;
      if (locks && locks.length > 0) {
        return locks[0];
      }
      return null;
    }) : Promise.reject(initError);
  }
  enableLock(lockId) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locks/${lockId}`, {
      status: "available"
    }).then((response) => response.data) : Promise.reject(initError);
  }
  notAvailableLock(lockId) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locks/${lockId}`, {
      status: "not_available"
    }).then((response) => response.data) : Promise.reject(initError);
  }
  disableLock(lockId) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locks/${lockId}`, {
      status: "disabled"
    }).then((response) => response.data) : Promise.reject(initError);
  }
  openLockAsOPS(data) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/locks/openAsOPS", data).then((response) => response.data) : Promise.reject(initError);
  }
};
var locks_default = new LocksApi();

// src/lock-api/reservations.ts
var ReservationsApi = class extends virtual_default {
  static {
    __name(this, "ReservationsApi");
  }
  createReservation(reservation) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/locking-sessions/reservations", reservation).then((response) => response.data) : Promise.reject(initError);
  }
  deleteReservation(vehicleId) {
    return this.axiosLockInstance ? this.axiosLockInstance.delete(`/locking-sessions/reservations/${vehicleId}`).then((response) => response.data) : Promise.reject(initError);
  }
  async getReservationDuration() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/reservation-duration").then((response) => response.data.default) : Promise.reject(initError);
  }
  async updateReservationDuration(defaultDuration) {
    return this.axiosLockInstance ? this.axiosLockInstance.put("/reservation-duration", { defaultDuration }).then((response) => response.data.default) : Promise.reject(initError);
  }
  updateReservationToLockingSession(sessionId, updateQuery) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/locking-sessions/reservation/${sessionId}/promote`, { token: updateQuery.lock_token }).then((response) => response.data) : Promise.reject(initError);
  }
};
var reservations_default = new ReservationsApi();

// src/lock-api/stations.ts
var StationsApi = class extends virtual_default {
  static {
    __name(this, "StationsApi");
  }
  getStations(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/stations${formatQueryParams(filter, "_limit=1000")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getStation(id, filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/stations/${id}${formatQueryParams(filter, "_limit=1000")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getNearests(lat, long, radius, filter) {
    const queryFilter = filter ? `&${filter}` : "";
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/stations/get-nearests?lat=${lat}&long=${long}&radius=${radius}${queryFilter}`).then((response) => response.data) : Promise.reject(initError);
  }
  createStation(stationData) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/stations", stationData).then((response) => response.data) : Promise.reject(initError);
  }
  updatePosition(id, position) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/stations/${id}`, {
      lat: position.lat,
      long: position.long
    }).then((response) => response.data) : Promise.reject(initError);
  }
  updateCity(id, city, filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.put(`/stations/${id}${formatQueryParams(filter)}`, {
      city
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var stations_default = new StationsApi();

// src/lock-api/transactions.ts
var TransactionsApi = class extends virtual_default {
  static {
    __name(this, "TransactionsApi");
  }
  getTransactions(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/transactions${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getTransactionsCount(filter) {
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/transactions/count${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyTransactions() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/transactions/me?_limit=10000&_sort=created_at:DESC").then((response) => response.data) : Promise.reject(initError);
  }
  getUserTransactions(userId, filter) {
    return this.getTransactions(`user=${userId}&${filter || "_sort=created_at:DESC"}`);
  }
  getUserTransactionsCount(userId, filter) {
    return this.getTransactionsCount(`user=${userId}&${filter || "_sort=created_at:DESC"}`);
  }
  getTransactionsKpi(cityId) {
    const queryParams = cityId ? `?city=${cityId}` : "";
    return this.axiosLockInstance ? this.axiosLockInstance.get(`/transactions/kpis${queryParams}`).then((response) => response.data) : Promise.reject(initError);
  }
  purchaseCredits(amount, promotionCode) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/transactions", { amount, promotionCode }).then((response) => response.data) : Promise.reject(initError);
  }
  async sendFreeTokensToUsers(tokensToSend) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/transactions/give-free-credits", tokensToSend).then((response) => response.data) : Promise.reject(initError);
  }
};
var transactions_default = new TransactionsApi();

// src/main-api/articles.ts
var ArticlesApi = class extends virtual_default {
  static {
    __name(this, "ArticlesApi");
  }
  addArticles(document_id, articles) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/articles`, {
      document_id,
      articles
    }).then((response) => response.data) : Promise.reject(initError);
  }
  removeAllArticles(document_id) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/articles/all/${document_id}`).then((response) => response.data) : Promise.reject(initError);
  }
  getArticles(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/articles${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  removeArticle(article_id) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/articles/${article_id}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateArticles(articles) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/articles`, {
      articles
    }).then((response) => response.data) : Promise.reject(initError);
  }
  getArticlesAudit(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/articles/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var articles_default = new ArticlesApi();

// src/main-api/audits.ts
var AuditsApi = class extends virtual_default {
  static {
    __name(this, "AuditsApi");
  }
  getAuditLogs(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/audits${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAuditLogsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/audits/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var audits_default = new AuditsApi();

// src/main-api/auth.ts
var AuthApi = class extends virtual_default {
  static {
    __name(this, "AuthApi");
  }
  validateSession(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${id}`).then((response) => {
      const res = {
        // SESSION IS OK
        auth: "OK",
        data: response.data
      };
      return res;
    }).catch(() => Promise.resolve({ auth: "NONE" })) : Promise.reject(initError);
  }
  refreshToken(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/auth/refresh-token", data).then((response) => response.data) : Promise.reject(initError);
  }
  login(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/local", data).then((response) => response.data) : Promise.reject(initError);
  }
  verifyDocumentOtp(code) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/tokens/verify-otp", { code }).then((response) => response.data) : Promise.reject(initError);
  }
  resendDocumentOtp() {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/tokens/resend-otp", {}).then((response) => response.data) : Promise.reject(initError);
  }
  getUserQrCode() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/auth/otp-qr-code").then((response) => response.data) : Promise.reject(initError);
  }
  sendMobileAuthLinkByMail() {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/link/mobile-login").then((response) => response.data) : Promise.reject(initError);
  }
  loginWithQr(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/local/qr", data).then((response) => response.data) : Promise.reject(initError);
  }
  logout() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/auth/logout").then((response) => response.data) : Promise.reject(initError);
  }
  register(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/local/register", data).then((response) => response.data) : Promise.reject(initError);
  }
  registerNewOps(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/register-ops", data).then((response) => response.data) : Promise.reject(initError);
  }
  resetPassword(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/reset-password", data).then((response) => response.data) : Promise.reject(initError);
  }
  changePassword(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/change-password", data).then((response) => response.data) : Promise.reject(initError);
  }
  forgotPassword(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/forgot-password", data).then((response) => response.data) : Promise.reject(initError);
  }
  resendEmailConfirmationCode(email) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/resend/email-confirmation-code", { email }).then((response) => response.data) : Promise.reject(initError);
  }
  resendDeviceConfirmationCode(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/resend/device-confirmation-code", data).then((response) => response.data) : Promise.reject(initError);
  }
  getQrForMobileAuth() {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/qr/mobile-login").then((response) => response.data) : Promise.reject(initError);
  }
  requestDeletion() {
    return this.axiosMainInstance ? this.axiosMainInstance.delete("/users/me").then((response) => response.data) : Promise.reject(initError);
  }
  revokeDevice(uniqueId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/devices/${uniqueId}`).then((response) => response.data) : Promise.reject(initError);
  }
  revokeUserDevices(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/devices/users/${userId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserDevices() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/devices/me").then((response) => response.data) : Promise.reject(initError);
  }
};
var auth_default = new AuthApi();

// src/main-api/background-location.ts
var BackgroundLocationApi = class extends virtual_default {
  static {
    __name(this, "BackgroundLocationApi");
  }
  getBackgroundLocations(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBackgroundLocationsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyBackgroundLocations(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation/me${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getOneBackgroundLocation(route_id) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation/${route_id}${formatQueryParams("_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  createBackgroundLocation(data, startDate, endDate) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/background-geolocation", { backgroundLocations: data, startDate, endDate }).then((response) => response.data) : Promise.reject(initError);
  }
  updateBackgroundRoute(routeId, is_on_bicycle) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/background-geolocation/${routeId}`, { is_on_bicycle }).then((response) => response.data) : Promise.reject(initError);
  }
  getMyStats(range, offset) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation/statistics/${range}/${offset}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyCharts(range, offset) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/background-geolocation/statistics/${range}/${offset}/caloriesChart`).then((response) => response.data) : Promise.reject(initError);
  }
};
var background_location_default = new BackgroundLocationApi();

// src/main-api/badges.ts
var BadgesApi = class extends virtual_default {
  static {
    __name(this, "BadgesApi");
  }
  getBadgeDefinitions() {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges-definitions`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllBadgeDefinitions(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges-definitions/all-definitions${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBadgeDefinitionById(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges-definitions/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllBadgeDefinitionsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges-definitions/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateBadgeDefinitionStatus(id, isActive) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/badges-definitions/status/${id}`, { isActive }).then((response) => response.data) : Promise.reject(initError);
  }
  updateBadgeDefinition(id, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/badges-definitions/${id}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  createBadgeDefinition(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/badges-definitions`, data).then((response) => response.data) : Promise.reject(initError);
  }
  assignBadgesToUsers(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/badges/assign`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedForBadgeDefinition(badge_type, level, mimetype) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/badges-definitions/presigned-upload-url`, { badge_type, level, mimetype }).then((response) => response.data) : Promise.reject(initError);
  }
  getUserBadges() {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges/me`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllBadges(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getAllBadgesCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/badges/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var badges_default = new BadgesApi();

// src/main-api/banks.ts
var BanksApi = class extends virtual_default {
  static {
    __name(this, "BanksApi");
  }
  getBanks(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/banks${formatQueryParams(filter, "_sort=name:asc")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBanksCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/banks/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBank(bankId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/banks/${bankId}`).then((response) => response.data) : Promise.reject(initError);
  }
  createBank(bankData) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/banks", bankData).then((response) => response.data) : Promise.reject(initError);
  }
  updateDangerLevel(danger_level, bankId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/banks/${bankId}/danger-level`, { danger_level }).then((response) => response.data) : Promise.reject(initError);
  }
  updateBank(bankId, bankData) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/banks/${bankId}`, bankData).then((response) => response.data) : Promise.reject(initError);
  }
};
var banks_default = new BanksApi();

// src/main-api/bike-models.ts
var BikeModelsApi = class extends virtual_default {
  static {
    __name(this, "BikeModelsApi");
  }
  getBikeModels(filter, approved) {
    const baseQueryParams = approved !== void 0 ? `approved=${approved}` : "";
    return this.axiosMainInstance ? this.axiosMainInstance.get(
      `/bike-models${formatQueryParamsWithBase(baseQueryParams, filter, "_limit=10000&_sort=created_at:DESC")}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getBikeModel(bikeModelId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/byId/${bikeModelId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBikeModelsCount(filter, approved) {
    const baseQueryParams = approved !== void 0 ? `approved=${approved}` : "";
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/count${formatQueryParamsWithBase(baseQueryParams, filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBikeBrands() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/bike-models/brands").then((response) => response.data) : Promise.reject(initError);
  }
  getBikeModelsByBrand(brand) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/modelsByBrand/${brand}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateBikeModel(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/bike-models", data).then((response) => response.data) : Promise.reject(initError);
  }
  getOpsBikeBrands(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/ops-brands${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getOpsBikeModelsByBrand(brand, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/ops-modelsByBrand/${brand}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBikeBrandsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/brands/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateBikeBrand(brand, prevBrand, approved) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/bike-models/brands", { brand, prevBrand, approved }).then((response) => response.data) : Promise.reject(initError);
  }
  deleteBikeModel(bikeModelId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/bike-models/${bikeModelId}`).then((response) => response.data) : Promise.reject(initError);
  }
  createBikeModel(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/bike-models", data).then((response) => response.data) : Promise.reject(initError);
  }
  updateManyBikeModels(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/bike-models/manyByBrands", data).then((response) => response.data) : Promise.reject(initError);
  }
  getBikeBrandSuggestion(brand) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/brand-suggestion/${brand}`).then((response) => response.data) : Promise.reject(initError);
  }
  getSuggestionByBrandAndModel(brand, model) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/suggestionByBrandAndModel/${brand}/${model}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPublicSuggestionByBrandAndModel(brand, model) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/bike-models/publicSuggestionByBrandAndModel/${brand}/${model}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateModelWithSuggestion(suggestionId, bikeId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/bike-models/updateModelWithSuggestion", { suggestionId, bikeId }).then((response) => response.data) : Promise.reject(initError);
  }
};
var bike_models_default = new BikeModelsApi();

// src/main-api/cities.ts
var CitiesApi = class extends virtual_default {
  static {
    __name(this, "CitiesApi");
  }
  getCities(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/cities${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCitiesCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/cities/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getCity(citiId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/cities/${citiId}`).then((response) => response.data) : Promise.reject(initError);
  }
  changeLocCity(cityId, position) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/cities/${cityId}/location`, {
      lat: position.lat,
      long: position.long
    }).then((response) => response.data) : Promise.reject(initError);
  }
  createCity(cityData) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/cities", cityData).then((response) => response.data) : Promise.reject(initError);
  }
  archiveCity(cityId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/cities/${cityId}/archive`, { isArchived: true }).then((response) => response.data) : Promise.reject(initError);
  }
  unarchiveCity(cityId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/cities/${cityId}/archive`, { isArchived: false }).then((response) => response.data) : Promise.reject(initError);
  }
};
var cities_default = new CitiesApi();

// src/main-api/current-user.ts
var UsersApi = class extends virtual_default {
  static {
    __name(this, "UsersApi");
  }
  validateMySession() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/me").then((response) => {
      const res = {
        // SESSION IS OK
        auth: "OK",
        data: response.data
      };
      return res;
    }).catch(() => Promise.resolve({ auth: "NONE" })) : Promise.reject(initError);
  }
  updatePassword(updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/auth/change-password", updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  updateMe(updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/me", updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  // We allow, since this function is a tight bit different from the one above even tho same route, it allow more strong typing
  // eslint-disable-next-line sonarjs/no-identical-functions
  updateFmToken(updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/me", updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  getMe(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyCredits() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/credits/me").then((response) => response.data) : Promise.reject(initError);
  }
  getFavorites() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/me/favorites").then((response) => response.data) : Promise.reject(initError);
  }
  getTagParameter(tag) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/me/parameter?tag=${tag}`).then((response) => response.data) : Promise.reject(initError);
  }
  switchTagParameter(tag) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/me/parameter/switch", { tag }).then((response) => response.data) : Promise.reject(initError);
  }
  addFavorite(updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/me/favorites/add", updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  deleteFavorite(updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/me/favorites/remove", updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  getMyCards() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/me/cards").then((response) => response.data) : Promise.reject(initError);
  }
  getMyInvoices() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/me/invoices").then((response) => response.data) : Promise.reject(initError);
  }
  uploadUserPhoto(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/users/me/upload-photo", data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  revokeDevice(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/devices/${id}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMySponsorships(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/sponsorships/get-my-sponsorships${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  confirmEmail(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/users/confirm-email", data).then((response) => response.data) : Promise.reject(initError);
  }
  checkStripeStatus() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/users/me/check-stripe-status").then((response) => response.data) : Promise.reject(initError);
  }
};
var current_user_default = new UsersApi();

// src/main-api/documents.ts
import axios from "axios";
var DocumentsApi = class extends virtual_default {
  static {
    __name(this, "DocumentsApi");
  }
  getDocuments(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getDocumentsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findPackageTemplateForPartner(partnerId, packageId) {
    const url = `/documents/partner/${partnerId}/package/${packageId}`;
    return this.axiosMainInstance ? this.axiosMainInstance.get(url).then((response) => response.data) : Promise.reject(initError);
  }
  findContractTemplate(contractId) {
    const url = `/documents/contract/template/${contractId}`;
    return this.axiosMainInstance ? this.axiosMainInstance.get(url).then((response) => response.data) : Promise.reject(initError);
  }
  getDocument(uuid, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getDocumentLink(uuid, filename) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/link${formatQueryParams(filename)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateDocInformation(id, notes, sendToUser, rejected, messageToUser) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${id}/notes`, { notes, sendToUser, messageToUser, rejected }).then((response) => response.data) : Promise.reject(initError);
  }
  acceptDocument(uuid, uncoveredElements) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/accept`, { uncoveredElements }).then((response) => response.data) : Promise.reject(initError);
  }
  denyDocument(uuid, rejectReason) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/deny`, { rejectReason }).then((response) => response.data) : Promise.reject(initError);
  }
  resetDocument(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/reset`).then((response) => response.data) : Promise.reject(initError);
  }
  retriggerIbanValidation(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/documents/${uuid}/retrigger-iban-validation`).then(() => void 0) : Promise.reject(initError);
  }
  informUser(uuid, informReason) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/inform`, { informReason }).then((response) => response.data) : Promise.reject(initError);
  }
  updateDocType(uuid, newType, newLink, isB2B) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/updateType`, { newType, newLink, isB2B }).then((response) => response.data) : Promise.reject(initError);
  }
  submitDocumentExpiration(uuid, is_expired, expiration_date) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/submitExpiration`, { is_expired, expiration_date }).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedVehicle(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/vehicle`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedPersonalLock(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/personal-lock`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedPolicies(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/policies`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedB2bPolicies(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/b2b-policies`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedB2bClaim(uuid, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/b2b-claim${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedInsuranceClaim(uuid, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/insurance-claim${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findLinkedUser(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/user`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteDocument(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/documents/${uuid}`).then((response) => response.data) : Promise.reject(initError);
  }
  deletePartnerClientDocument(uuid, partnerId, claimId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/documents/partners/${partnerId}/claim/${claimId}/${uuid}`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteGroupDocument(uuid, groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/documents/${uuid}/group/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
  rotateImage(imageName, rotateFactor) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/documents/rotate-image", { fileName: imageName, rotateFactor }).then((response) => response.data) : Promise.reject(initError);
  }
  getDocumentAnalysis(uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/analysis`).then((response) => response.data) : Promise.reject(initError);
  }
  applyFraudScore(uuid, fraudScoreDetail) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/documents/${uuid}/applyFraudScore`, { fraudScoreDetail }).then((response) => response.data) : Promise.reject(initError);
  }
  getDocumentAudit(uuid, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/documents/${uuid}/audit${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedDocument(type, mimetype, owner, isB2b) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/documents/presigned", { type, mimetype, owner, isB2b }).then((response) => response.data) : Promise.reject(initError);
  }
  getDualPresignedDocument(type, mimetype, versoMimetype) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/documents/dual-presigned", { type, mimetype, versoMimetype }).then((response) => response.data) : Promise.reject(initError);
  }
  async uploadWithPresigned(presignedUrl, f) {
    try {
      const res = await axios.put(presignedUrl, f, {
        headers: {
          "Content-Type": f.type,
          "Content-Length": new Blob([f]).size
        }
      });
      return { status: res.status, url: res.config.url };
    } catch (err) {
      return Promise.reject(err);
    }
  }
  createDocument(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/documents", data).then((response) => response.data) : Promise.reject(initError);
  }
  createDualDocument(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/documents/dual-document", data).then((response) => response.data) : Promise.reject(initError);
  }
  createGroupDocument(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/documents/upload/group/${data.groupId}`, {
      filename: data.filename,
      uuid: data.uuid,
      mimetype: data.mimetype,
      size: data.size,
      object_id: data.object_id,
      type: data.type,
      owner: data.owner
    }).then((response) => response.data) : Promise.reject(initError);
  }
  uploadPartnerClaimDocument(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/documents/partners/${data.partnerId}/claim/${data.claimId}`, {
      filename: data.filename,
      uuid: data.uuid,
      mimetype: data.mimetype,
      size: data.size,
      type: data.type,
      object_id: data.object_id,
      owner: data.owner
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var documents_default = new DocumentsApi();

// src/main-api/groups.ts
var buildInvoiceFilter = /* @__PURE__ */ __name((filter, status) => {
  const filters = [];
  if (filter) {
    filters.push(filter);
  }
  if (status) {
    filters.push(`status=${status}`);
  }
  return filters.length > 0 ? filters.join("&") : void 0;
}, "buildInvoiceFilter");
var GroupsApi = class extends virtual_default {
  static {
    __name(this, "GroupsApi");
  }
  createCompany(newGroup) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/groups/company", newGroup).then((response) => response.data) : Promise.reject(initError);
  }
  getGroups(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyGroups(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getInvoices(groupId, filter, status) {
    const query = buildInvoiceFilter(filter, status);
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices${formatQueryParams(query)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getInvoice(groupId, invoiceId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices/${invoiceId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupInvoicesCount(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices-count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupInvoicesCountByStatus(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices-count-by-status`).then((response) => response.data) : Promise.reject(initError);
  }
  getManagedGroupInvoices(groupId, filter, status) {
    const query = buildInvoiceFilter(filter, status);
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices/managed${formatQueryParams(query)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getManagedGroupInvoicesCount(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices-count/managed${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getManagedGroupInvoicesCountByStatus(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoices-count-by-status/managed${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getInvoiceReceiptsCount(groupId, invoiceId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoice/${invoiceId}/count`).then((response) => response.data) : Promise.reject(initError);
  }
  getPaymentSchedule(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/payment-schedule`).then((response) => response.data) : Promise.reject(initError);
  }
  getNextInvoicePreview(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/next-invoice-preview`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupPolicies(groupId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byGroup/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroup(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  sendMailB2bQuoteClientPayment(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/sendMailClient`).then((response) => response.data) : Promise.reject(initError);
  }
  confirmCompany(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/confirm`).then((response) => response.data) : Promise.reject(initError);
  }
  // Vehicle related
  createMassivelyVehicles(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/vehicles`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupVehicles(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/vehicles${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countGroupVehicles(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/vehicles/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupVehicle(groupId, vehicleId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/vehicles/${vehicleId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerVehicle(partnerId, vehicleId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/partner/${partnerId}/vehicles/${vehicleId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createSetupForCreateCard(groupId, paymentMethod) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/setup-intent`, { paymentMethod }).then((response) => response.data?.client_secret) : Promise.reject(initError);
  }
  getGroupsPaymentMethods(groupId, type) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/paymentMethods/${type}`).then((response) => response.data) : Promise.reject(initError);
  }
  setPaymentMethodAsDefault(groupId, payment_method) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/default-card`, { payment_method }).then((response) => response.data) : Promise.reject(initError);
  }
  deletePaymentMethod(groupId, payment_method) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/groups/${groupId}/payment-method/${payment_method}`).then((response) => response.data) : Promise.reject(initError);
  }
  getSepaMandateUrl(groupId, paymentMethodId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/paymentMethods/${paymentMethodId}/sepa-mandate`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupUsers(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/users${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  uploadGroupPhoto(data, groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/logo`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => response.data) : Promise.reject(initError);
  }
  deleteGroupPhoto(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/groups/${groupId}/logo`).then((response) => response.data) : Promise.reject(initError);
  }
  updatePartnerRole(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/update-partner-role`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateFraudPartnerRole(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/update-fraud-partner-role`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateManagingPartner(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/update-managing-partner`, data).then((response) => response.data) : Promise.reject(initError);
  }
  addUserToGroup(groupId, userId, roles, description) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/user/${userId}`, { roles, description }).then((response) => response.data) : Promise.reject(initError);
  }
  UpdateGroup(groupId, body) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateGroupMainInfos(groupId, body) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/update-main`, body).then((response) => response.data) : Promise.reject(initError);
  }
  AddNoteToGroup(groupId, { date, name, comment }) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/notes`, { date, name, comment }).then((response) => response.data) : Promise.reject(initError);
  }
  DeleteUserFromGroup(groupId, userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/user/${userId}`).then((response) => response.data) : Promise.reject(initError);
  }
  checkStripeStatusGroup(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/check-stripe-status`).then((response) => response.data) : Promise.reject(initError);
  }
  updateGroupAttrib(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/update-attrib`).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupDocuments(groupId, withoutExpired) {
    const queryParams = withoutExpired ? "?withoutExpired=true" : "";
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/documents${queryParams}`).then((response) => response.data) : Promise.reject(initError);
  }
  createInvitation(groupId, email, roles, communication_types) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/invitation`, { email, roles, communication_types }).then((response) => response.data) : Promise.reject(initError);
  }
  getInvitations(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invitations${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  resendInvitation(groupId, email) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/invitation/resend`, { email }).then((response) => response.data) : Promise.reject(initError);
  }
  countInvitations(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invitations/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMembers(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/members${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateMember(groupId, userId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/member/${userId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateInvitation(groupId, invitationId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/invitation/${invitationId}`, data).then((response) => response.data) : Promise.reject(initError);
  }
  getGroupKpi(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/kpi`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerKpiB2b2c(partnerId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${partnerId}/kpi/partner/b2b2c`).then((response) => response.data) : Promise.reject(initError);
  }
  getPartnerKpiB2b2b(partnerId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${partnerId}/kpi/partner/b2b2b`).then((response) => response.data) : Promise.reject(initError);
  }
  countMembers(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/members/count`).then((response) => response.data) : Promise.reject(initError);
  }
  exportInvoiceReceiptsToCsv(groupId, invoiceId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/invoice/${invoiceId}/export-csv`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  createOnboardingNeeds(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/groups/${groupId}/b2b-onboarding`, data).then((response) => response.data) : Promise.reject(initError);
  }
  updateOnboardingNeeds(groupId, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/groups/${groupId}/b2b-onboarding`, data).then((response) => response.data) : Promise.reject(initError);
  }
  checkUserRoleInGroup(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/check-user-roles`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2b2cInvoices(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/b2b2c-invoices${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2b2cInvoicesCount(groupId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/b2b2c-invoices/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2b2cInvoiceDocument(groupId, invoiceId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/b2b2c-invoices/${invoiceId}/document`).then((response) => response.data) : Promise.reject(initError);
  }
  getB2b2cInvoiceReceiptsExport(groupId, invoiceId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/b2b2c-invoices/${invoiceId}/receipts-export`).then((response) => response.data) : Promise.reject(initError);
  }
  simulateGroupDeletion(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/groups/${groupId}/simulate-deletion`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteGroup(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/groups/${groupId}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var groups_default = new GroupsApi();

// src/main-api/itineraries.ts
var ItinerariesApi = class extends virtual_default {
  static {
    __name(this, "ItinerariesApi");
  }
  compute(origin, destination) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/itineraries", { origin, destination }).then((response) => response.data) : Promise.reject(initError);
  }
  getNavigationRoutes(origin, destination) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/itineraries/navigation-routes", { origin, destination }).then((response) => response.data) : Promise.reject(initError);
  }
  getElevations(coordinates) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/itineraries/elevations", { coordinates }).then((response) => response.data) : Promise.reject(initError);
  }
};
var itineraries_default = new ItinerariesApi();

// src/main-api/leads.ts
var LeadsApi = class extends virtual_default {
  static {
    __name(this, "LeadsApi");
  }
  getLeads(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/leads${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLeadByMail(mail) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/lead/email?email=${mail}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLeadsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/leads/count${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLeadsKpi() {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/leads/kpis`).then((response) => response.data) : Promise.reject(initError);
  }
};
var leads_default = new LeadsApi();

// src/main-api/lock-models.ts
var LockModelsApi = class extends virtual_default {
  static {
    __name(this, "LockModelsApi");
  }
  getLockModels(filter, approved) {
    const baseParam = `approved=${approved}`;
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/lock-models${formatQueryParamsWithBase(baseParam, filter, "_limit=10000&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getLockModelsCount(filter, approved) {
    const baseParam = `approved=${approved}`;
    return this.axiosMainInstance ? this.axiosMainInstance.get(
      `/lock-models/count${formatQueryParamsWithBase(baseParam, filter, "_limit=10000&_sort=created_at:DESC")}`
    ).then((response) => response.data) : Promise.reject(initError);
  }
  getLockBrands() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/lock-models/brands").then((response) => response.data) : Promise.reject(initError);
  }
  getLockModelsByBrand(model) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/lock-models/modelsByBrand/${model}`).then((response) => response.data) : Promise.reject(initError);
  }
  updateLockModel(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/lock-models", data).then((response) => response.data) : Promise.reject(initError);
  }
  updateLocksModel({
    locksIds,
    isApproved
  }) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/lock-models/updateAll", { locksIds, isApproved }).then((response) => response.data) : Promise.reject(initError);
  }
  deleteLockModel(lockModelId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/lock-models/${lockModelId}`).then((response) => response.data) : Promise.reject(initError);
  }
  createLockModel(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/lock-models", data).then((response) => response.data) : Promise.reject(initError);
  }
};
var lock_models_default = new LockModelsApi();

// src/main-api/marking-codes.ts
var MarkingCodesApi = class extends virtual_default {
  static {
    __name(this, "MarkingCodesApi");
  }
  getMarkingCodes(fraudPartnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/${fraudPartnerId}${formatQueryParams(filter, "_limit=10000&_sort=import_date:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  countMyMarkingCodes(fraudPartnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/${fraudPartnerId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  totalCountMarkingCodes() {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/totalCount`).then((response) => response.data) : Promise.reject(initError);
  }
  countConflictMarkingCodes() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/marking-codes/count/conflict").then((response) => response.data) : Promise.reject(initError);
  }
  countMyConflictMarkingCodes(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/count/${id}/conflicts${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countYearMarkingCodes(year) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/count/${year}`).then((response) => response.data) : Promise.reject(initError);
  }
  createMarkingCodes(id, datas) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/marking-codes/${id}/codes`, { datas }).then((response) => response.data) : Promise.reject(initError);
  }
  checkCodeApicStatus(codeId, id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/${id}/${codeId}/check-apic-status${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getConflicts(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/${id}/conflicts${formatQueryParams(filter, "_sort=acknowledge:ASC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  putConflict(codeId, id) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/marking-codes/${id}/${codeId}/conflict`).then((response) => response.data) : Promise.reject(initError);
  }
  getConflictsByOps(code, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/conflict-by-code/${code}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getConflictsDetails(codeId, fraudPartnerId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/marking-codes/${fraudPartnerId}/conflicts/${codeId}/details`).then((response) => response.data) : Promise.reject(initError);
  }
};
var marking_codes_default = new MarkingCodesApi();

// src/main-api/notifications.ts
var NotificationsApi = class extends virtual_default {
  static {
    __name(this, "NotificationsApi");
  }
  getMyNotifications(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/notifications/me${formatQueryParams(filter, "_limit=10&_sort=start_date:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  setMyNotificationsRead(ids) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/notifications/me/read", { notifIds: ids }).then((response) => response.data) : Promise.reject(initError);
  }
  notifyUsers(notification) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/notifications/create-notifications", notification).then((response) => response.data) : Promise.reject(initError);
  }
  notifyFirebaseUsers(notification) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/notifications/notify-firebase", notification).then((response) => response.data) : Promise.reject(initError);
  }
  findAllNotifications(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/notifications/all${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countNotifications(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/notifications/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var notifications_default = new NotificationsApi();

// src/main-api/other.ts
import axios2 from "axios";
var OtherApi = class extends virtual_default {
  static {
    __name(this, "OtherApi");
  }
  getNearParavolStations({
    lat,
    long,
    latDelta,
    longDelta
  }) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/paravol-stations/near?lat=${lat}&long=${long}&latitude-delta=${latDelta}&longitude-delta=${longDelta}`).then((response) => response.data) : Promise.reject(initError);
  }
  getBicycleHoop(lat, long, radius) {
    const location = `(around:${radius},${lat},${long})`;
    const body = `[out:json][timeout:25];(node["bicycle_parking"]${location};way
    ["bicycle_parking"]${location};relation["bicycle_parking"]${location};);(._;>;);out body;`;
    return axios2.post("https://overpass-api.de/api/interpreter", `data=${body}`).then((response) => response.data.elements);
  }
  getMailjetTemplatePreview(templateId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/mailjet/template/${templateId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMailjetUserMessages(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/mailjet/user/${userId}/messages`).then((response) => response.data) : Promise.reject(initError);
  }
  getMailjetUserContactLists(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/mailjet/user/${userId}/contact-lists`).then((response) => response.data) : Promise.reject(initError);
  }
  getMailjetGroupMessages(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/mailjet/group/${groupId}/messages`).then((response) => response.data) : Promise.reject(initError);
  }
  getMailjetGroupContactLists(groupId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/mailjet/group/${groupId}/contact-lists`).then((response) => response.data) : Promise.reject(initError);
  }
  getZendeskUserTickets(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/zendesk/user/${userId}/tickets`).then((response) => response.data) : Promise.reject(initError);
  }
  getZendeskTicket(ticketId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/zendesk/tickets/${ticketId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getZendeskTicketComments(ticketId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/zendesk/tickets/${ticketId}/comments`).then((response) => response.data) : Promise.reject(initError);
  }
};
var other_default = new OtherApi();

// src/main-api/partners.ts
var PartnersApi = class extends virtual_default {
  static {
    __name(this, "PartnersApi");
  }
  findPartnersAuthTokens(partnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/auth-tokens${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPartnersAuthTokens(partnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/auth-tokens/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  generatePartnerAuthToken(partnerId) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/partners/${partnerId}/auth-token`).then((response) => response.data) : Promise.reject(initError);
  }
  revokePartnerAuthToken(partnerId, authTokenId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/partners/${partnerId}/auth-token/${authTokenId}`).then((response) => response.data) : Promise.reject(initError);
  }
  findPartnersGroups(partnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/groups${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPartnersGroups(partnerId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/groups/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findPartnersB2bContracts(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-contracts/byPartners/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findPartnersB2bPolicies(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byPartners/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPartnersB2bPolicies(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/b2b-policies/byPartners/${partnerId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  findPartnersB2cPolicies(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/byPartners/${partnerId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  countPartnersB2cPolicies(partnerId, filter) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/byPartners/${partnerId}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  retractPartnersB2cPolicy(partnerId, quoteID, cancelReason, cancelReasonInfo) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/byPartners/${partnerId}/${quoteID}/retract-insurance`, {
      cancelReason,
      cancelReasonInfo
    }).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerQuotesToCsv(partnerId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/quotes/partners/${partnerId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerPoliciesToCsv(partnerId, where) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.get(`/policies/byPartners/${partnerId}/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerGroupsToCsv(partnerId, where) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/groups/export-csv${formatQueryParams(where)}`, { responseType: "blob" }).then((response) => response.data) : Promise.reject(initError);
  }
  exportPartnerInvoicesToCsv(partnerId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/partners/${partnerId}/invoices/export-csv`, {
      responseType: "blob"
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var partners_default = new PartnersApi();

// src/main-api/phone-operators.ts
var PhoneOperatorsApi = class extends virtual_default {
  static {
    __name(this, "PhoneOperatorsApi");
  }
  getPhoneOperators(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/phone-operators${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPhoneOperatorsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/phone-operators/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPhoneOperator(phoneOperatorId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/phone-operators/${phoneOperatorId}`).then((response) => response.data) : Promise.reject(initError);
  }
  createPhoneOperator(phoneOperatorData) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/phone-operators", phoneOperatorData).then((response) => response.data) : Promise.reject(initError);
  }
  updateDangerLevel(dangerLevel, phoneOperatorId) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/phone-operators/${phoneOperatorId}/danger-level`, { danger_level: dangerLevel }).then((response) => response.data) : Promise.reject(initError);
  }
  updatePhoneOperator(phoneOperatorId, phoneOperatorData) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/phone-operators/${phoneOperatorId}`, phoneOperatorData).then((response) => response.data) : Promise.reject(initError);
  }
};
var phone_operators_default = new PhoneOperatorsApi();

// src/main-api/profile-change-requests.ts
var ProfileChangeRequestsApi = class extends virtual_default {
  static {
    __name(this, "ProfileChangeRequestsApi");
  }
  find(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/profile-change-requests${formatQueryParams(filter, "_limit=10&_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  count(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/profile-change-requests/count${formatQueryParams(filter)}`).then((r) => r.data) : Promise.reject(initError);
  }
  findOne(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/profile-change-requests/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  approve(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/profile-change-requests/${id}/approve`).then((response) => response.data) : Promise.reject(initError);
  }
  approveEmailChange(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/profile-change-requests/${id}/approve-email-change`).then((response) => response.data) : Promise.reject(initError);
  }
  reject(id, reject_reason) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/profile-change-requests/${id}/reject`, { reject_reason }).then((response) => response.data) : Promise.reject(initError);
  }
  getMyProfileChangeRequests() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/profile-change-requests/me").then((response) => response.data) : Promise.reject(initError);
  }
  createNameChangeRequest(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/profile-change-requests/name-change-requests", data).then((response) => response.data) : Promise.reject(initError);
  }
  createBirthdayChangeRequest(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/profile-change-requests/birthday-change-requests", data).then((response) => response.data) : Promise.reject(initError);
  }
  createBirthplaceChangeRequest(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/profile-change-requests/birthplace-change-requests", data).then((response) => response.data) : Promise.reject(initError);
  }
  createEmailChangeRequest(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/profile-change-requests/email-change-requests", data).then((response) => response.data) : Promise.reject(initError);
  }
  resendEmailChangeRequest(id, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/profile-change-requests/email-change-requests/${id}/resend`, data).then((response) => response.data) : Promise.reject(initError);
  }
  verifyEmailChangeRequest(id, data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/profile-change-requests/email-change-requests/${id}/verify`, data).then((response) => response.data) : Promise.reject(initError);
  }
  cancelMyProfileChangeRequest(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/profile-change-requests/${id}/cancel`).then((response) => response.data) : Promise.reject(initError);
  }
};
var profile_change_requests_default = new ProfileChangeRequestsApi();

// src/main-api/promotion-codes.ts
var PromotionCodesApi = class extends virtual_default {
  static {
    __name(this, "PromotionCodesApi");
  }
  createPromotionCodes(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/promotion-codes", data).then((response) => response.data) : Promise.reject(initError);
  }
  getPromotionCodes(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes${formatQueryParams(filter, "_sort=created_at:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPromotionCodesCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPromotionCodeUsages(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes/usages${formatQueryParams(filter, "_sort=date_used:DESC")}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPromotionCodeUsagesCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes/usages/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPromotionCode(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes/${id}`).then((response) => response.data) : Promise.reject(initError);
  }
  checkPromotionCodeForSubscription(data) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/transactions/check-promotion-for-subscription", data).then((response) => response.data) : Promise.reject(initError);
  }
  checkPromotionCodeForTransaction(data) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/transactions/check-promotion-for-transaction", data).then((response) => response.data) : Promise.reject(initError);
  }
  getPriceAfterInsuranceVoucher(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/pricing/get-insurance-price-with-policy", data).then((response) => response.data) : Promise.reject(initError);
  }
  // Promotion codes with quotes and pricings
  getPricingQuoteInsuranceVoucher(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/pricing/get-insurance-pricing-from-voucher-with-user-checks", data).then((response) => response.data) : Promise.reject(initError);
  }
  getPricingsQuoteInsuranceVoucher(data) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.post("/pricing/get-insurance-pricings-from-voucher-no-user-check", data).then((response) => response.data) : Promise.reject(initError);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validateStripeCode(code) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/promotion-codes/stripe/${code}`).then((response) => response.data) : Promise.reject(initError);
  }
  updatePromoCode(body) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/promotion-codes/${body.id}`, {
      active: body.active,
      expiration_date: body.expiration_date,
      max_redeem_total: body.max_redeem_total
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var promotion_codes_default = new PromotionCodesApi();

// src/main-api/settings.ts
var SettingsApi = class extends virtual_default {
  static {
    __name(this, "SettingsApi");
  }
  async getVersion() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/version").then((response) => response.data) : Promise.reject(initError);
  }
  async getAndroidVersion() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/version").then((response) => {
      return { version: response.data.android, minVersion: response.data.min_android };
    }) : Promise.reject(initError);
  }
  async updateAndroidVersion(version) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/version", { android: version }).then((response) => {
      return { version: response.data.android, minVersion: response.data.min_android };
    }) : Promise.reject(initError);
  }
  async updateRequiredAndroidVersion(version) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/version/minimum", { min_android: version }).then((response) => {
      return { version: response.data.android, minVersion: response.data.min_android };
    }) : Promise.reject(initError);
  }
  async getIOSVersion() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("/version").then((response) => {
      return { version: response.data.ios, minVersion: response.data.min_ios };
    }) : Promise.reject(initError);
  }
  async updateIOSVersion(version) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/version", { ios: version }).then((response) => {
      return { version: response.data.ios, minVersion: response.data.min_ios };
    }) : Promise.reject(initError);
  }
  async updateRequiredIOSVersion(version) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/version/minimum", { min_ios: version }).then((response) => {
      return { version: response.data.ios, minVersion: response.data.min_ios };
    }) : Promise.reject(initError);
  }
  async getLastFirmwareVersion() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/firmware-versions?_sort=release_date:DESC&_limit=1").then((response) => {
      if (response.data && response.data.length > 0) {
        return response.data[0];
      }
      return void 0;
    }) : Promise.reject(initError);
  }
  async createNewFirmwareVersion(version) {
    return this.axiosLockInstance ? this.axiosLockInstance.post("/firmware-versions", version).then((response) => response.data.ios) : Promise.reject(initError);
  }
  getFirmwareVersions() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/firmware-versions").then((response) => response.data) : Promise.reject(initError);
  }
  async getDefaultFreeTrialDuration() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/free-trial-duration").then((response) => response.data.default) : Promise.reject(initError);
  }
  async updateDefaultFreeTrialDuration(defaultDuration) {
    return this.axiosLockInstance ? this.axiosLockInstance.put("/free-trial-duration", { default: defaultDuration }).then((response) => response.data.default) : Promise.reject(initError);
  }
};
var settings_default = new SettingsApi();

// src/main-api/shop.ts
var ShopApi = class extends virtual_default {
  static {
    __name(this, "ShopApi");
  }
  getOrders(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/orders${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyOrders(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/orders/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getMyOrderCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/orders/me/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getOrderById(orderId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/orders/${orderId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getOrderCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/orders/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getShopProducts(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/products${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getShopProductsCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/products/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getShopProductById(productId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/shop/products/${productId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createShopProduct(body) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/shop/products`, body).then((response) => response.data) : Promise.reject(initError);
  }
  updateShopProduct(productId, body) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/shop/products/${productId}`, body).then((response) => response.data) : Promise.reject(initError);
  }
  buyShopProduct(productId) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/shop/orders/${productId}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedUrlForProductPictureUpload() {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/shop/products/picture/presigned`).then((response) => response.data) : Promise.reject(initError);
  }
  getPresignedUrlForProductPictureRead(key) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/shop/products/picture/presigned-read`, { key }).then((response) => response.data) : Promise.reject(initError);
  }
};
var shop_default = new ShopApi();

// src/main-api/sinisters.ts
var SinistersApi = class extends virtual_default {
  static {
    __name(this, "SinistersApi");
  }
  createSinister(sinister) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/sinisters", sinister).then((response) => response.data) : Promise.reject(initError);
  }
};
var sinisters_default = new SinistersApi();

// src/main-api/subscriptions.ts
var SubscriptionsApi = class extends virtual_default {
  static {
    __name(this, "SubscriptionsApi");
  }
  createSubscription(bodyData) {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/subscriptions", bodyData).then((response) => response.data) : Promise.reject(initError);
  }
  // Create a SetupIntent to save the user Card
  createSetupForCreateCard() {
    return this.axiosMainInstance ? this.axiosMainInstance.post("/subscriptions/setup-intent").then((response) => response.data) : Promise.reject(initError);
  }
  // Set PaymentMethod as default
  setPaymentMethodAsDefault(paymentMethod) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("/subscriptions/payment-method/default", { payment_method: paymentMethod }).then((response) => response.data) : Promise.reject(initError);
  }
  deleteCard(card) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/subscriptions/payment-method/${card.cardId}`).then((response) => response.data) : Promise.reject(initError);
  }
  unsubscribe() {
    return this.axiosMainInstance ? this.axiosMainInstance.delete("/subscriptions").then((response) => response.data) : Promise.reject(initError);
  }
  paymentConfirmation(paymentIntentId, type) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/subscriptions/payment-intent/${paymentIntentId}/confirm`, { type }).then((response) => response.data) : Promise.reject(initError);
  }
  getPaymentSettingsForInsurance(policyId, promotionCode) {
    return this.axiosInsuranceInstance ? this.axiosInsuranceInstance.put(`/policies/${policyId}/payment-settings`, { promotion_code: promotionCode }).then((response) => response.data) : Promise.reject(initError);
  }
};
var subscriptions_default = new SubscriptionsApi();

// src/main-api/user-settings.ts
var UserSettingsApi = class extends virtual_default {
  static {
    __name(this, "UserSettingsApi");
  }
  getMySettings() {
    return this.axiosMainInstance ? this.axiosMainInstance.get("users-settings/me").then((response) => response.data) : Promise.reject(initError);
  }
  updateSettings(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.put("users-settings", {
      vigimap: data.vigimap,
      vigimap_popup: data.vigimap_popup,
      battery_popup: data.battery_popup,
      mail_opt_in: data.mail_opt_in,
      always_geolocation_tracking: data.always_geolocation_tracking,
      redirect_after_login: data.redirect_after_login
    }).then((response) => response.data) : Promise.reject(initError);
  }
};
var user_settings_default = new UserSettingsApi();

// src/main-api/users.ts
var UsersApi2 = class extends virtual_default {
  static {
    __name(this, "UsersApi");
  }
  getUsers(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUsersCount(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getIndebtedUsers(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/indebted${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUser(userId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserZendesk(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/zendesk`).then((response) => response.data.id) : Promise.reject(initError);
  }
  updateUser(userId, updateQuery) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/users/${userId}`, updateQuery).then((response) => response.data) : Promise.reject(initError);
  }
  getUserCredits(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/credits`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserMoneySpent(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/money-spent`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserMonthlyRecurringRevenue(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/monthly-recurring-revenue`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserDevices(userId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/devices?user=${userId}&${filter || "_limit=10&_sort=created_at:DESC"}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserDevicesCount(userId, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/devices/count?user=${userId}&${filter || "_limit=10&_sort=created_at:DESC"}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserDocuments(userId, withoutExpired) {
    const queryParams = withoutExpired ? "?withoutExpired=true" : "";
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/documents${queryParams}`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserGroups(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/groups`).then((response) => response.data) : Promise.reject(initError);
  }
  updateUserRoles(userId, rolesToAdd, rolesToRemove) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/users/${userId}/roles`, { rolesToAdd, rolesToRemove }).then((response) => response.data) : Promise.reject(initError);
  }
  simulateUserDeletion(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${userId}/simulate-deletion`).then((response) => response.data) : Promise.reject(initError);
  }
  deleteUser(userId) {
    return this.axiosMainInstance ? this.axiosMainInstance.delete(`/users/${userId}`).then((response) => response.data) : Promise.reject(initError);
  }
  addNote(id, notes) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/users/${id}/notes`, notes).then((response) => response.data) : Promise.reject(initError);
  }
  getUserLcbft(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/users/${id}/lcbft`).then((response) => response.data) : Promise.reject(initError);
  }
  getUserPoints(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/user-points/me${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPointsByUserId(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/user-points/${id}${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  getPointsCountByUserId(id, filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/user-points/${id}/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  sendRoulezJeunesseBookingUuid(rj_uuid) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/users/me/roulez-jeunesse-booking-form`, { rj_uuid }).then((response) => response.data) : Promise.reject(initError);
  }
  blockBrevo(id) {
    return this.axiosMainInstance ? this.axiosMainInstance.put(`/users/${id}/block-brevo`).then((response) => response.data) : Promise.reject(initError);
  }
};
var users_default = new UsersApi2();

// src/main-api/webhooks-sl.ts
var WebhooksSLApi = class extends virtual_default {
  static {
    __name(this, "WebhooksSLApi");
  }
  findWebhooksSL(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/webhooks-sl${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
  createWebhooksSL(data) {
    return this.axiosMainInstance ? this.axiosMainInstance.post(`/webhooks-sl`, data).then((response) => response.data) : Promise.reject(initError);
  }
  countWebhooksSL(filter) {
    return this.axiosMainInstance ? this.axiosMainInstance.get(`/webhooks-sl/count${formatQueryParams(filter)}`).then((response) => response.data) : Promise.reject(initError);
  }
};
var webhooks_sl_default = new WebhooksSLApi();

// src/slSdk.ts
var generateCustomAxiosError = /* @__PURE__ */ __name((error) => {
  const message = typeof error.response?.data === "object" && error.response.data && "message" in error.response?.data ? error.response?.data.message : null;
  return Object.assign(new Error(), {
    name: error.name || "UKNOWN",
    code: error.response?.status || 418,
    message: typeof message === "string" ? message : JSON.stringify(message),
    data: error.response?.data
  });
}, "generateCustomAxiosError");
var SharelockApi = class {
  constructor() {
    // SubClasses Api
    this.alerts = alerts_default;
    this.audits = audits_default;
    this.auth = auth_default;
    this.b2cContracts = b2c_contracts_default;
    this.bikeModels = bike_models_default;
    this.banks = banks_default;
    this.phoneOperators = phone_operators_default;
    this.profileChangeRequests = profile_change_requests_default;
    this.cities = cities_default;
    this.currentUser = current_user_default;
    this.documents = documents_default;
    this.fraud = fraud_weights_default;
    this.groups = groups_default;
    this.b2bPolicies = b2b_policies_default;
    this.B2bManagementParameters = b2b_management_parameters_default;
    this.b2bClaims = b2b_claims_default;
    this.claimComplaints = claim_complaints_default;
    this.b2bReceipts = b2b_receipts_default;
    this.b2bContracts = b2b_contracts_default;
    this.policies = policies_default;
    this.personalLockingSessions = personal_locking_sessions_default;
    this.leads = leads_default;
    this.lockModels = lock_models_default;
    this.lockSessions = locking_sessions_default;
    this.locks = locks_default;
    this.other = other_default;
    this.personalLocks = personal_locks_default;
    this.pricingRules = pricingRules_default;
    this.promotionCodes = promotion_codes_default;
    this.quotes = quotes_default;
    this.reservations = reservations_default;
    this.settings = settings_default;
    this.shop = shop_default;
    this.sinisters = sinisters_default;
    this.subscriptions = subscriptions_default;
    this.transactions = transactions_default;
    this.users = users_default;
    this.usersSettings = user_settings_default;
    this.vehicles = vehicles_default;
    this.stations = stations_default;
    this.packages = packages_default;
    this.coverages = coverages_default;
    this.receipts = receipts_default;
    this.contractualDocuments = contractual_documents_default;
    this.partners = partners_default;
    this.pricing = pricing_default;
    this.insuranceClaims = insurance_claims_default;
    this.B2BQuotes = b2b_quotes_default;
    this.PolicyCancelRequests = policy_cancel_request_default;
    this.scoringThreshold = scoring_threshold_default;
    this.scoringRepartition = scoring_repartition_default;
    this.notifications = notifications_default;
    this.geofencing = geofencing_default;
    this.backgroundLocation = background_location_default;
    this.partnerInvoices = partner_invoices_default;
    this.qonto = qonto_default;
    this.markingCodes = marking_codes_default;
    this.B2bPolicyCancelRequest = b2b_policy_cancel_request_default;
    this.GroupCommissions = group_commissions_default;
    this.ManagementParameters = management_parameters_default;
    this.Fleets = fleets_default;
    this.SearchGeneric = search_default;
    this.sponsorships = sponsorships_default;
    this.sponsorshipConfigurations = sponsorship_configurations_default;
    this.articles = articles_default;
    this.itineraries = itineraries_default;
    this.webhooksSL = webhooks_sl_default;
    this.badges = badges_default;
    this.initialized = { mainInstance: false, lockInstance: false, insuranceInstance: false };
    this.axiosMainInstance = void 0;
    this.axiosLockInstance = void 0;
    this.axiosInsuranceInstance = void 0;
    this.demoteOps = false;
    this.source = void 0;
    this.handler = void 0;
  }
  static {
    __name(this, "SharelockApi");
  }
  initializeMainInstance(apiURL, getTokenFunc) {
    if (this.initialized.mainInstance) {
      return;
    }
    const source = this.source || "DASHBOARD";
    this.axiosMainInstance = create({
      baseURL: apiURL
    });
    this.axiosMainInstance.defaults.headers.common = {
      "Content-Type": "application/json"
    };
    this.axiosMainInstance.defaults.withCredentials = false;
    this.axiosMainInstance.interceptors.request.use(async (config) => {
      const newConfig = { ...config };
      const token = await getTokenFunc();
      if (newConfig.headers) {
        if (token) {
          newConfig.headers.Authorization = `Bearer ${token}`;
        }
        newConfig.headers["x-source"] = source;
        if (this.demoteOps) {
          newConfig.headers["demote-ops"] = "true";
        }
      }
      return newConfig;
    });
    this.axiosMainInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        throw generateCustomAxiosError(error);
      }
    );
    this.initialized.mainInstance = true;
  }
  initializeLockInstance(apiURL, getTokenFunc) {
    if (this.initialized.lockInstance) {
      return;
    }
    const source = this.source || "DASHBOARD";
    this.axiosLockInstance = create({
      baseURL: apiURL
    });
    this.axiosLockInstance.defaults.headers.common = {
      "Content-Type": "application/json"
    };
    this.axiosLockInstance.defaults.withCredentials = false;
    this.axiosLockInstance.interceptors.request.use(async (config) => {
      const newConfig = { ...config };
      const token = await getTokenFunc();
      if (newConfig.headers) {
        if (token) {
          newConfig.headers.Authorization = `Bearer ${token}`;
        }
        newConfig.headers["x-source"] = source;
        if (this.demoteOps) {
          newConfig.headers["demote-ops"] = "true";
        }
      }
      return newConfig;
    });
    this.axiosLockInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        throw generateCustomAxiosError(error);
      }
    );
    this.initialized.lockInstance = true;
  }
  initializeInsuranceInstance(apiURL, getTokenFunc) {
    if (this.initialized.insuranceInstance) {
      return;
    }
    const source = this.source || "DASHBOARD";
    this.axiosInsuranceInstance = create({
      baseURL: apiURL
    });
    this.axiosInsuranceInstance.defaults.headers.common = {
      "Content-Type": "application/json"
    };
    this.axiosInsuranceInstance.defaults.withCredentials = false;
    this.axiosInsuranceInstance.interceptors.request.use(async (config) => {
      const newConfig = { ...config };
      const token = await getTokenFunc();
      if (newConfig.headers) {
        if (token) {
          newConfig.headers.Authorization = `Bearer ${token}`;
        }
        newConfig.headers["x-source"] = source;
        if (this.demoteOps) {
          newConfig.headers["demote-ops"] = "true";
        }
      }
      return newConfig;
    });
    this.axiosInsuranceInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        throw generateCustomAxiosError(error);
      }
    );
    this.initialized.insuranceInstance = true;
  }
  // FIXME: Initialize must have a callBack for Error ? Or be a promise and throw Something
  async initialize(apiUrls, getTokenFunc, source, demoteOps) {
    this.source = source;
    this.demoteOps = demoteOps;
    this.initializeMainInstance(apiUrls.main, getTokenFunc);
    this.initializeLockInstance(apiUrls.lock, getTokenFunc);
    this.initializeInsuranceInstance(apiUrls.insurance, getTokenFunc);
    const apiInstances = {
      mainInstance: this.axiosMainInstance,
      lockInstance: this.axiosLockInstance,
      insuranceInstance: this.axiosInsuranceInstance
    };
    this.auth.initialize(apiInstances, source);
    this.b2cContracts.initialize(apiInstances, source);
    this.locks.initialize(apiInstances, source);
    this.lockModels.initialize(apiInstances, source);
    this.bikeModels.initialize(apiInstances, source);
    this.lockSessions.initialize(apiInstances, source);
    this.personalLockingSessions.initialize(apiInstances, source);
    this.banks.initialize(apiInstances, source);
    this.phoneOperators.initialize(apiInstances, source);
    this.cities.initialize(apiInstances, source);
    this.fraud.initialize(apiInstances, source);
    this.b2bPolicies.initialize(apiInstances, source);
    this.b2bClaims.initialize(apiInstances, source);
    this.claimComplaints.initialize(apiInstances, source);
    this.b2bContracts.initialize(apiInstances, source);
    this.b2bReceipts.initialize(apiInstances, source);
    this.groups.initialize(apiInstances, source);
    this.vehicles.initialize(apiInstances, source);
    this.alerts.initialize(apiInstances, source);
    this.sinisters.initialize(apiInstances, source);
    this.reservations.initialize(apiInstances, source);
    this.documents.initialize(apiInstances, source);
    this.users.initialize(apiInstances, source);
    this.usersSettings.initialize(apiInstances, source);
    this.pricingRules.initialize(apiInstances, source);
    this.promotionCodes.initialize(apiInstances, source);
    this.settings.initialize(apiInstances, source);
    this.transactions.initialize(apiInstances, source);
    this.leads.initialize(apiInstances, source);
    this.audits.initialize(apiInstances, source);
    this.subscriptions.initialize(apiInstances, source);
    this.personalLocks.initialize(apiInstances, source);
    this.currentUser.initialize(apiInstances, source);
    this.policies.initialize(apiInstances, source);
    this.receipts.initialize(apiInstances, source);
    this.other.initialize(apiInstances, source);
    this.stations.initialize(apiInstances, source);
    this.packages.initialize(apiInstances, source);
    this.coverages.initialize(apiInstances, source);
    this.contractualDocuments.initialize(apiInstances, source);
    this.partners.initialize(apiInstances, source);
    this.quotes.initialize(apiInstances, source);
    this.pricing.initialize(apiInstances, source);
    this.insuranceClaims.initialize(apiInstances, source);
    this.B2BQuotes.initialize(apiInstances, source);
    this.PolicyCancelRequests.initialize(apiInstances, source);
    this.scoringThreshold.initialize(apiInstances, source);
    this.scoringRepartition.initialize(apiInstances, source);
    this.notifications.initialize(apiInstances, source);
    this.geofencing.initialize(apiInstances, source);
    this.backgroundLocation.initialize(apiInstances, source);
    this.partnerInvoices.initialize(apiInstances, this.source);
    this.qonto.initialize(apiInstances, source);
    this.markingCodes.initialize(apiInstances, source);
    this.B2bPolicyCancelRequest.initialize(apiInstances, source);
    this.GroupCommissions.initialize(apiInstances, source);
    this.SearchGeneric.initialize(apiInstances, source);
    this.ManagementParameters.initialize(apiInstances, source);
    this.Fleets.initialize(apiInstances, source);
    this.sponsorships.initialize(apiInstances, source);
    this.articles.initialize(apiInstances, source);
    this.itineraries.initialize(apiInstances, source);
    this.webhooksSL.initialize(apiInstances, source);
    this.B2bManagementParameters.initialize(apiInstances, source);
    this.shop.initialize(apiInstances, source);
    this.profileChangeRequests.initialize(apiInstances, source);
    this.sponsorshipConfigurations.initialize(apiInstances, source);
    this.badges.initialize(apiInstances, source);
  }
  async getBatteriesSwitchParameters() {
    return this.axiosLockInstance ? this.axiosLockInstance.get("/batteries-switch-parameters").then((response) => response.data) : Promise.reject(initError);
  }
  async updateBatteriesSwitchParameters(batteriesSwitchParameters) {
    return this.axiosLockInstance ? this.axiosLockInstance.put("/batteries-switch-parameters", { ...batteriesSwitchParameters }).then((response) => response.data) : Promise.reject(initError);
  }
};
function isAxiosDataError(err) {
  return (err instanceof Object || err instanceof Error) && "statusCode" in err;
}
__name(isAxiosDataError, "isAxiosDataError");
function isCustomAxiosError(err) {
  return (err instanceof Object || err instanceof Error) && "name" in err && "message" in err && "code" in err && "data" in err;
}
__name(isCustomAxiosError, "isCustomAxiosError");
var slSdk_default = new SharelockApi();
export {
  ALL_DOCS_LIST,
  ALL_DOCS_LIST_B2B,
  ANDROID_APP_URL,
  ActivityTypeEnum,
  ArticleTypeEnum,
  AuditEventEnum,
  B2B2C_DOCS_LIST,
  B2B_FAQ_LINK,
  B2B_REQUEST_LINK,
  B2C_CG,
  B2C_CONTRACTUALS_DOCS,
  B2C_EXPLANATION_URL,
  B2C_FAQ_LINK,
  B2C_PC,
  B2C_REQUEST_LINK,
  B2b2cPartnerInvoiceStripeMode,
  B2bOnboardingTypeEnum,
  B2bUsage,
  BadgesType,
  BikeStatusEnum,
  CHUBB_CONFIDENTIALITY_LINK,
  CaloriesChartTypeEnum,
  CancelInsuranceReason,
  ClaimComplaintComplainerTypeEnum,
  ClaimComplaintSubjectEnum,
  ClaimComplaintTypeEnum,
  ClaimStatusEnum,
  CommissionInvoiceFrequency,
  CommissionInvoiceStatus,
  CommissionStatus,
  CommunicationTypeEnum,
  ContractStatus,
  ContractualDocTradCodeEnum,
  CoverageCode,
  CoverageEnum,
  CoverageNeedsEnum,
  CriteriaStatus,
  CustomerStripeStatus,
  DangerosityLevel,
  DocumentStatus,
  EstimatedPolicyCountEnum,
  EstimatedVehicleCountEnum,
  ExpectedPolicyType,
  FraudTagType,
  GroupCommissionsAmountTypeEnum,
  GroupCommissionsTypeEnum,
  GroupMemberRolesEnum,
  GroupTypology,
  IOS_APP_URL,
  InsuranceClaimCoverageCodeType,
  InsuranceClaimRejectCancelCondition,
  InsurerNameEnum,
  LEGAL_PROTECTION_URL,
  LcbftRiskCategory,
  LcbftVigilanceLevel,
  NotificationPriorityEnum,
  NotificationTypeEnum,
  OpsChecksEnum,
  OptionalQuoteChecksEnum,
  PARTNER_SHOPS_LIST,
  PRE_COMPLAINT_LINK,
  PRIVILEGED_GROUP_MEMBER_ROLES,
  PackageSource,
  PackageTradCodeEnum,
  PartnerInvoicesPaymentsStatus,
  PaymentMethods,
  PlsDangerLevel,
  PolicyCancelRequestStatus,
  PolicyStatus,
  PolicyTerminationReimbursementModeEnum,
  PremiumSupportType,
  QuoteStatus,
  QuoteStepEnum,
  ROULEZ_JEUNESSE_AREA_LIST,
  ROULEZ_JEUNESSE_LINK,
  ReceiptsPaymentsStatus,
  ReceptionMediumEnum,
  ReimbursementType,
  ResellTypeEnum,
  RewardType,
  RolesEnum,
  SHARELOCK_CHUBB_IPID,
  SHARELOCK_CHUBB_NI,
  ScoreEnum,
  SearchOptionKindEnum,
  slSdk_default as SharelockApi,
  ShopCategory,
  Splitting,
  StatisticsRangeEnum,
  TernaryChoiceEnum,
  TimePeriod,
  TimelineEventEnum,
  TradCode,
  UploadDocumentType,
  UserLoginRedirection,
  UserPointsEarnedType,
  UserPointsSpentType,
  VELIGO_CUSTOMER_SUPPORT_MAIL,
  WebhooksSLEventsEnum,
  apicAssoFaqLink,
  apicAssoLink,
  areCoordinatesInsideAreas,
  auvrayLink,
  bicycodeLink,
  changeLanguage,
  decathlonLink,
  distanceBetweenCoordinatesMeters,
  getAssignableGroupMemberRoles,
  getFormatedAddressData,
  getHandledRoles,
  getIdExpirationDate,
  getNotificationDetails,
  getTranslations,
  getTypedNotificationData,
  groupRolesClassChecker,
  hasAllRequiredDocuments,
  hasPlsSegmentation,
  icaBikeLink,
  isAxiosDataError,
  isCustomAxiosError,
  isPlsPredictionType,
  isPlsPredictionV2,
  isPlsPredictionV3,
  mfcLink,
  moustacheLink,
  paravolLink,
  parsePlsPrediction,
  recoBikeLink,
  rolesClassChecker,
  rolesEnumImplyingOpsHandled,
  searchPlace,
  starwayLink,
  toggleGroupMemberRole,
  veloPassLink
};
/*! For license information please see index.js.LEGAL.txt */
//# sourceMappingURL=index.js.map
